(function() {
    'use strict';

    angular
        .module('netWordAgroApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset-password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset-password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change-password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {

            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {

            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];

    function HomeController ($scope, Principal, LoginService, $state) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('VersaoDialogController', VersaoDialogController);

    VersaoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Versao'];

    function VersaoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Versao) {
        var vm = this;

        vm.versao = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.versao.id !== null) {
                Versao.update(vm.versao, onSaveSuccess, onSaveError);
            } else {
                Versao.save(vm.versao, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:versaoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dataversao = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('VersaoDetailController', VersaoDetailController);

    VersaoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Versao'];

    function VersaoDetailController($scope, $rootScope, $stateParams, previousState, entity, Versao) {
        var vm = this;

        vm.versao = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:versaoUpdate', function(event, result) {
            vm.versao = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('VersaoDeleteController',VersaoDeleteController);

    VersaoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Versao'];

    function VersaoDeleteController($uibModalInstance, entity, Versao) {
        var vm = this;

        vm.versao = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Versao.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('versao', {
            parent: 'entity',
            url: '/versao',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.versao.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/versao/versaos.html',
                    controller: 'VersaoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('versao');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('versao-detail', {
            parent: 'versao',
            url: '/versao/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.versao.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/versao/versao-detail.html',
                    controller: 'VersaoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('versao');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Versao', function($stateParams, Versao) {
                    return Versao.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'versao',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('versao-detail.edit', {
            parent: 'versao-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/versao/versao-dialog.html',
                    controller: 'VersaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Versao', function(Versao) {
                            return Versao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('versao.new', {
            parent: 'versao',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/versao/versao-dialog.html',
                    controller: 'VersaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dataversao: null,
                                versaoandroid: null,
                                versaoios: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('versao', null, { reload: 'versao' });
                }, function() {
                    $state.go('versao');
                });
            }]
        })
        .state('versao.edit', {
            parent: 'versao',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/versao/versao-dialog.html',
                    controller: 'VersaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Versao', function(Versao) {
                            return Versao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('versao', null, { reload: 'versao' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('versao.delete', {
            parent: 'versao',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/versao/versao-delete-dialog.html',
                    controller: 'VersaoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Versao', function(Versao) {
                            return Versao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('versao', null, { reload: 'versao' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Versao', Versao);

    Versao.$inject = ['$resource', 'DateUtils'];

    function Versao ($resource, DateUtils) {
        var resourceUrl =  'api/versaos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataversao = DateUtils.convertLocalDateFromServer(data.dataversao);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dataversao = DateUtils.convertLocalDateToServer(copy.dataversao);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dataversao = DateUtils.convertLocalDateToServer(copy.dataversao);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('VersaoSearch', VersaoSearch);

    VersaoSearch.$inject = ['$resource'];

    function VersaoSearch($resource) {
        var resourceUrl =  'api/_search/versaos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('VersaoController', VersaoController);

    VersaoController.$inject = ['Versao', 'VersaoSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function VersaoController(Versao, VersaoSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.versaos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                VersaoSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Versao.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.versaos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.versaos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.versaos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.versaos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('UploadnwDialogController', UploadnwDialogController);

    UploadnwDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Uploadnw'];

    function UploadnwDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Uploadnw) {
        var vm = this;

        vm.uploadnw = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.uploadnw.id !== null) {
                Uploadnw.update(vm.uploadnw, onSaveSuccess, onSaveError);
            } else {
                Uploadnw.save(vm.uploadnw, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:uploadnwUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('UploadnwDetailController', UploadnwDetailController);

    UploadnwDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Uploadnw'];

    function UploadnwDetailController($scope, $rootScope, $stateParams, previousState, entity, Uploadnw) {
        var vm = this;

        vm.uploadnw = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:uploadnwUpdate', function(event, result) {
            vm.uploadnw = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('UploadnwDeleteController',UploadnwDeleteController);

    UploadnwDeleteController.$inject = ['$uibModalInstance', 'entity', 'Uploadnw'];

    function UploadnwDeleteController($uibModalInstance, entity, Uploadnw) {
        var vm = this;

        vm.uploadnw = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Uploadnw.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('uploadnw', {
            parent: 'entity',
            url: '/uploadnw',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.uploadnw.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/uploadnw/uploadnws.html',
                    controller: 'UploadnwController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('uploadnw');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('uploadnw-detail', {
            parent: 'uploadnw',
            url: '/uploadnw/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.uploadnw.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/uploadnw/uploadnw-detail.html',
                    controller: 'UploadnwDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('uploadnw');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Uploadnw', function($stateParams, Uploadnw) {
                    return Uploadnw.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'uploadnw',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('uploadnw-detail.edit', {
            parent: 'uploadnw-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/uploadnw/uploadnw-dialog.html',
                    controller: 'UploadnwDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Uploadnw', function(Uploadnw) {
                            return Uploadnw.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('uploadnw.new', {
            parent: 'uploadnw',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/uploadnw/uploadnw-dialog.html',
                    controller: 'UploadnwDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                data: null,
                                inicio: null,
                                fim: null,
                                propriedade: null,
                                usuario: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('uploadnw', null, { reload: 'uploadnw' });
                }, function() {
                    $state.go('uploadnw');
                });
            }]
        })
        .state('uploadnw.edit', {
            parent: 'uploadnw',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/uploadnw/uploadnw-dialog.html',
                    controller: 'UploadnwDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Uploadnw', function(Uploadnw) {
                            return Uploadnw.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('uploadnw', null, { reload: 'uploadnw' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('uploadnw.delete', {
            parent: 'uploadnw',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/uploadnw/uploadnw-delete-dialog.html',
                    controller: 'UploadnwDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Uploadnw', function(Uploadnw) {
                            return Uploadnw.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('uploadnw', null, { reload: 'uploadnw' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Uploadnw', Uploadnw);

    Uploadnw.$inject = ['$resource'];

    function Uploadnw ($resource) {
        var resourceUrl =  'api/uploadnws/:id';

        function formDataObject(data) {
            var fd = new FormData();
            fd.append('file', data);
            return fd;
        }

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'upload': { 
                url: 'api/uploadZip',
                method: 'POST',
                transformRequest: formDataObject,
                headers: { 'Content-Type': undefined, 
                enctype: 'multipart/form-data' } 
            },
            'uploadProc': { 
                url: 'api/uploadFileProc',
                method: 'POST',
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('UploadnwSearch', UploadnwSearch);

    UploadnwSearch.$inject = ['$resource'];

    function UploadnwSearch($resource) {
        var resourceUrl =  'api/_search/uploadnws/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('UploadnwController', UploadnwController);

    UploadnwController.$inject = ['Uploadnw', 'UploadnwSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'Propriedade', 'Safra', 'DataUtils', 'Principal'];

    function UploadnwController(Uploadnw, UploadnwSearch, ParseLinks, AlertService, paginationConstants, Propriedade, Safra, DataUtils, Principal) {

        var vm = this;

        vm.uploadnws = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        vm.selectedfile = null;
        vm.fileData = null;

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        vm.propriedadeSelecionada = undefined;
        vm.safraSelecionada = undefined;

        vm.onSucessoSafra = onSucessoSafra;
        vm.onSucessoUpload = onSucessoUpload;
        vm.onFalhaUpload = onFalhaUpload;

        vm.safras = [];

        vm.converteDataAtual = converteDataAtual;
        vm.inicioUpload = null;
        vm.fimUpload = null;
        vm.currentAccount = null;

        vm.arquivoProcessamento = null;

        // Váriaveis de processamento mapas
        vm.procPlantaDaninha = false;
        vm.procLagarta = false;
        vm.procAmargoso = false;
        vm.procManchaAlvo = false;
        vm.procFerrugem = false;
        vm.procBuva = false;
        vm.procPercevejo = false;
        vm.procFalhaDePlantio = false;
        vm.procMilho = false;
        vm.procFolhaLarga = false;
        vm.procFolhaEstreita = false;

        // Váriaveis de processamento mapas - cana
        vm.procBicudo = false;
        vm.procCigarrinha = false;
        vm.procFolhaLargaCana = false;
        vm.procFolhaEstreitaCana = false;
        vm.procBrocaDaCana = false;
        vm.procPlantaDaninhaCana = false;

        vm.changePropriedade = function () {
            console.log("Change propriedade!");
            vm.safras = [];
            Safra.querySafrasPorPropriedade({
                idPropriedade: vm.propriedadeSelecionada.id
            }, vm.onSucessoSafra);
        }

        function onSucessoSafra(result){
            console.log(result);
            for (var i = 0; i < result.length; i++) {
                vm.safras.push(result[i]);
            }

            console.log(vm.safras);
        }

        vm.setFile = function ($file) {
            vm.fileData = null;
            console.log("Selecionado");
            vm.fileData = $file;
            console.log(vm.fileData);
        };

        vm.enviar = function () {
            vm.inicioUpload = vm.converteDataAtual();
            console.log("Sending...");
            var tipoArquivo = vm.fileData.name.substr(vm.fileData.name.length - 4);
            var blob = vm.fileData.slice(0, vm.fileData.size, vm.fileData.type); 
            var data = new Date();
            var dataString = ( data.getDate() + 1 < 10? '0' + (data.getDate()) : (data.getDate()) ) + ( data.getMonth() + 1 < 10? '0' + (data.getMonth() + 1) : (data.getMonth() +1) ) + data.getFullYear();

            var novonome = vm.safraSelecionada.id + '_' + dataString + tipoArquivo;

            var newFile = new File([blob], novonome, {type: vm.fileData.type});
            Uploadnw.upload(newFile, vm.onSucessoUpload, vm.onFalhaUpload);
        };

        function converteDataAtual(){

            var d = new Date();

            var dia = d.getDate(); dia < 10 ? dia = '0' + dia : dia;
            var mes = d.getMonth() + 1; mes < 10 ? mes = '0' + mes: mes;
            var ano = d.getFullYear();

            var hora = d.getHours();
            var min = d.getMinutes(); min < 10 ? min = '0' + min: min;
            var seg = d.getSeconds(); seg < 10 ? seg = '0' + seg: seg;

            return dia + '/' + mes + '/' + ano + ' ' + hora + ':' + min + ':' + seg;
        }

        function onFalhaUpload(error){
            AlertService.error(error.data.message);
        }

        function onSucessoUpload(data) {
            vm.fimUpload = vm.converteDataAtual();

            Principal.identity().then(function(account) {

                // Preparando log
                vm.currentAccount = account;
                
                var uploadLog = new Uploadnw();
                uploadLog.usuario = vm.currentAccount.login;

                var data = new Date();
                var dataString = ( data.getDate() + 1 < 10? '0' + (data.getDate()) : (data.getDate()) ) + ( data.getMonth() + 1 < 10? '0' + (data.getMonth() + 1) : (data.getMonth() +1) ) +  data.getFullYear();

                uploadLog.data = dataString;

                uploadLog.inicio = vm.inicioUpload;
                uploadLog.fim = vm.fimUpload;

                uploadLog.propriedade = vm.propriedadeSelecionada.nomepropriedade;

                // Preparando arquivo de apoio de processamento
                var nomeArquivoProcessamento = vm.safraSelecionada.id + '_' + dataString + '.txt';
                
                var textoArquivoProcessamento = "";

                textoArquivoProcessamento = textoArquivoProcessamento + vm.safraSelecionada.cultura_nome;

                if(vm.procLagarta){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",lagarta";
                }
                if(vm.procAmargoso){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",amargoso";
                }
                if(vm.procManchaAlvo){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",manchaalvo";
                }
                if(vm.procFerrugem){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",ferrugem";
                }
                if(vm.procBuva){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",buva";
                }
                if(vm.procPercevejo){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",percevejo";
                }
                if(vm.procFalhaDePlantio){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",falhaplantio";
                }
                if(vm.procMilho){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",milho";
                }
                if(vm.procFolhaLarga){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",folhalarga";
                }
                if(vm.procFolhaEstreita){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",folhaestreita";
                }
                if(vm.procPlantaDaninha){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",plantadaninha";
                }
                
                if(vm.procBicudo){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",bicudo";
                }
                if(vm.procCigarrinha){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",cigarrinha";
                }
                if(vm.procFolhaLargaCana){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",folhalargacana";
                }
                if(vm.procFolhaEstreitaCana){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",folhaestreitacana";
                }
                if(vm.procBrocaDaCana){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",brocadacana";
                }
                if(vm.procPlantaDaninhaCana){
                    textoArquivoProcessamento = textoArquivoProcessamento + ",plantadaninhacana";
                }

                
                var fileProc = {
                    fileContent: textoArquivoProcessamento,
                    fileName: nomeArquivoProcessamento
                };

                Uploadnw.uploadProc(fileProc);

                Uploadnw.save(uploadLog, vm.loadAll); // Salvando log
            });

        }

        vm.propriedades = Propriedade.queryNomesPropriedades({
            size: 1000
        });


        loadAll();

        function loadAll () {
            vm.uploadnws = [];

            if (vm.currentSearch) {
                UploadnwSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Uploadnw.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.uploadnws.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.uploadnws = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.uploadnws = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.uploadnws = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('UnidadegestorDialogController', UnidadegestorDialogController);

    UnidadegestorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Unidadegestor', 'Unidade', 'Gestor'];

    function UnidadegestorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Unidadegestor, Unidade, Gestor) {
        var vm = this;

        vm.unidadegestor = entity;
        vm.clear = clear;
        vm.save = save;
        vm.unidades = Unidade.query();
        vm.gestors = Gestor.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.unidadegestor.id !== null) {
                Unidadegestor.update(vm.unidadegestor, onSaveSuccess, onSaveError);
            } else {
                Unidadegestor.save(vm.unidadegestor, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:unidadegestorUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('UnidadegestorDetailController', UnidadegestorDetailController);

    UnidadegestorDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Unidadegestor', 'Unidade', 'Gestor'];

    function UnidadegestorDetailController($scope, $rootScope, $stateParams, previousState, entity, Unidadegestor, Unidade, Gestor) {
        var vm = this;

        vm.unidadegestor = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:unidadegestorUpdate', function(event, result) {
            vm.unidadegestor = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('UnidadegestorDeleteController',UnidadegestorDeleteController);

    UnidadegestorDeleteController.$inject = ['$uibModalInstance', 'entity', 'Unidadegestor'];

    function UnidadegestorDeleteController($uibModalInstance, entity, Unidadegestor) {
        var vm = this;

        vm.unidadegestor = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Unidadegestor.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('unidadegestor', {
            parent: 'entity',
            url: '/unidadegestor',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.unidadegestor.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/unidadegestor/unidadegestors.html',
                    controller: 'UnidadegestorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('unidadegestor');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('unidadegestor-detail', {
            parent: 'unidadegestor',
            url: '/unidadegestor/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.unidadegestor.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/unidadegestor/unidadegestor-detail.html',
                    controller: 'UnidadegestorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('unidadegestor');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Unidadegestor', function($stateParams, Unidadegestor) {
                    return Unidadegestor.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'unidadegestor',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('unidadegestor-detail.edit', {
            parent: 'unidadegestor-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/unidadegestor/unidadegestor-dialog.html',
                    controller: 'UnidadegestorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Unidadegestor', function(Unidadegestor) {
                            return Unidadegestor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('unidadegestor.new', {
            parent: 'unidadegestor',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/unidadegestor/unidadegestor-dialog.html',
                    controller: 'UnidadegestorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('unidadegestor', null, { reload: 'unidadegestor' });
                }, function() {
                    $state.go('unidadegestor');
                });
            }]
        })
        .state('unidadegestor.edit', {
            parent: 'unidadegestor',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/unidadegestor/unidadegestor-dialog.html',
                    controller: 'UnidadegestorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Unidadegestor', function(Unidadegestor) {
                            return Unidadegestor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('unidadegestor', null, { reload: 'unidadegestor' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('unidadegestor.delete', {
            parent: 'unidadegestor',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/unidadegestor/unidadegestor-delete-dialog.html',
                    controller: 'UnidadegestorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Unidadegestor', function(Unidadegestor) {
                            return Unidadegestor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('unidadegestor', null, { reload: 'unidadegestor' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Unidadegestor', Unidadegestor);

    Unidadegestor.$inject = ['$resource'];

    function Unidadegestor ($resource) {
        var resourceUrl =  'api/unidadegestors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'queryUGsAssociadas': { 
                url: '/api/unidadegestor/associadospessoa/:idgestor',
                method: 'GET', 
                isArray: true},
            'acao': { 
                url: '/api/unidadegestor/conjunto/:acao',
                method: 'POST',
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('UnidadegestorSearch', UnidadegestorSearch);

    UnidadegestorSearch.$inject = ['$resource'];

    function UnidadegestorSearch($resource) {
        var resourceUrl =  'api/_search/unidadegestors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('UnidadegestorController', UnidadegestorController);

    UnidadegestorController.$inject = ['Unidadegestor', 'UnidadegestorSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function UnidadegestorController(Unidadegestor, UnidadegestorSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.unidadegestors = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                UnidadegestorSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Unidadegestor.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.unidadegestors.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.unidadegestors = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.unidadegestors = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.unidadegestors = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('UnidadeDialogController', UnidadeDialogController);

    UnidadeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Unidade', 'Pessoa', 'Tecnico', 'Sensor', 'Unidadegestor', 'User', 'Pessoapropriedade'];

    function UnidadeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Unidade, Pessoa, Tecnico, Sensor, Unidadegestor, User, Pessoapropriedade) {
        var vm = this;

        vm.unidade = entity;
        vm.clear = clear;
        vm.save = save;
        vm.pessoas = Pessoa.query();
        vm.tecnicos = Tecnico.query();
        vm.sensors = Sensor.query();
        vm.unidadegestors = Unidadegestor.query();

        vm.onSaveUser = onSaveUser;
        vm.onSavePessoa = onSavePessoa;
        vm.onSaveSuccess = onSaveSuccess;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.unidade.id !== null) {
                Unidade.update(vm.unidade, vm.onSavePessoa, vm.onSaveError);
            } else {
                Unidade.save(vm.unidade, vm.onSaveSuccess, vm.onSaveError);
            }
        }

        function onSaveSuccess(result) {
            vm.unidade.id = result.id;
            $scope.$emit('netWordAgroApp:unidadeUpdate', result);
            vm.novousuario = new User();
            vm.novousuario.login = vm.unidade.login;
            vm.novousuario.firstName = vm.unidade.nome;
            vm.novousuario.lastName = vm.unidade.nome;
            vm.novousuario.email = vm.unidade.email;
            vm.novousuario.authorities = [];
            vm.novousuario.authorities = ['ROLE_GESTOR_PARCEIROS', 'ROLE_USER'];
            User.save(vm.novousuario, onSaveUser);
        }

        function onSaveUser(result) {
            vm.novapessoa = new Pessoa();
            vm.novapessoa.nome = vm.unidade.nome;
            vm.novapessoa.sobrenome = vm.unidade.nome;
            vm.novapessoa.cpf = vm.unidade.cnpj;
            vm.novapessoa.cargo = "gestorparceiro";
            vm.novapessoa.email = vm.unidade.email;
            vm.novapessoa.login = vm.unidade.login;
            vm.novapessoa.unidade = new Unidade();
            vm.novapessoa.unidade.id = vm.unidade.id;
            Pessoa.save(vm.novapessoa, onSavePessoa, onSaveError);
        }

        function onSavePessoa(result){
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('UnidadeDetailController', UnidadeDetailController);

    UnidadeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Unidade', 'Pessoa', 'Tecnico', 'Sensor', 'Unidadegestor'];

    function UnidadeDetailController($scope, $rootScope, $stateParams, previousState, entity, Unidade, Pessoa, Tecnico, Sensor, Unidadegestor) {
        var vm = this;

        vm.unidade = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:unidadeUpdate', function(event, result) {
            vm.unidade = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('UnidadeDeleteController',UnidadeDeleteController);

    UnidadeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Unidade'];

    function UnidadeDeleteController($uibModalInstance, entity, Unidade) {
        var vm = this;

        vm.unidade = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Unidade.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('unidade', {
            parent: 'entity',
            url: '/unidade',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.unidade.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/unidade/unidades.html',
                    controller: 'UnidadeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('unidade');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('unidade-detail', {
            parent: 'unidade',
            url: '/unidade/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.unidade.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/unidade/unidade-detail.html',
                    controller: 'UnidadeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('unidade');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Unidade', function($stateParams, Unidade) {
                    return Unidade.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'unidade',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('unidade-detail.edit', {
            parent: 'unidade-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/unidade/unidade-dialog.html',
                    controller: 'UnidadeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Unidade', function(Unidade) {
                            return Unidade.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('unidade.new', {
            parent: 'unidade',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/unidade/unidade-dialog.html',
                    controller: 'UnidadeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                cnpj: null,
                                email: null,
                                endereco: null,
                                telefone: null,
                                responsavel: null,
                                cpf: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('unidade', null, { reload: 'unidade' });
                }, function() {
                    $state.go('unidade');
                });
            }]
        })
        .state('unidade.edit', {
            parent: 'unidade',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/unidade/unidade-dialog.html',
                    controller: 'UnidadeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Unidade', function(Unidade) {
                            return Unidade.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('unidade', null, { reload: 'unidade' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('unidade.delete', {
            parent: 'unidade',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/unidade/unidade-delete-dialog.html',
                    controller: 'UnidadeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Unidade', function(Unidade) {
                            return Unidade.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('unidade', null, { reload: 'unidade' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Unidade', Unidade);

    Unidade.$inject = ['$resource'];

    function Unidade ($resource) {
        var resourceUrl =  'api/unidades/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'queryUnidadesAssociadas': { 
                url: '/api/unidades/unidadesassociadas/:idgestor',
                method: 'GET', 
                isArray: true},
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('UnidadeSearch', UnidadeSearch);

    UnidadeSearch.$inject = ['$resource'];

    function UnidadeSearch($resource) {
        var resourceUrl =  'api/_search/unidades/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('UnidadeController', UnidadeController);

    UnidadeController.$inject = ['Unidade', 'UnidadeSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function UnidadeController(Unidade, UnidadeSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.unidades = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                UnidadeSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Unidade.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.unidades.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.unidades = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.unidades = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.unidades = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('TecnicoDialogController', TecnicoDialogController);

    TecnicoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Tecnico', 'Unidade', 'User', 'Pessoa'];

    function TecnicoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Tecnico, Unidade, User, Pessoa) {
        var vm = this;

        vm.tecnico = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.unidades = Unidade.query();

        vm.onSaveUser = onSaveUser;
        vm.onSavePessoa = onSavePessoa;
        vm.onSaveSuccess = onSaveSuccess;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.tecnico.id !== null) {
                Tecnico.update(vm.tecnico, onSavePessoa, onSaveError);
            } else {
                Tecnico.save(vm.tecnico, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:unidadeUpdate', result);
            vm.novousuario = new User();
            vm.novousuario.login = vm.tecnico.login;
            vm.novousuario.firstName = vm.tecnico.nome;
            vm.novousuario.lastName = vm.tecnico.sobrenome;
            vm.novousuario.email = vm.tecnico.email;
            vm.novousuario.authorities = [];
            vm.novousuario.authorities = ['ROLE_TECNICO_CAMPO', 'ROLE_USER'];
            User.save(vm.novousuario, onSaveUser);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveUser(result) {
            vm.novapessoa = new Pessoa();
            vm.novapessoa.nome = vm.tecnico.nome;
            vm.novapessoa.sobrenome = vm.tecnico.sobrenome;
            vm.novapessoa.cpf = vm.tecnico.cpf;
            vm.novapessoa.cargo = "tecnicocampo";
            vm.novapessoa.email = vm.tecnico.email;
            vm.novapessoa.login = vm.tecnico.login;
            vm.novapessoa.unidade = new Unidade();
            vm.novapessoa.unidade.id = vm.tecnico.unidade.id;
            Pessoa.save(vm.novapessoa, onSavePessoa, onSaveError);
        }

        function onSavePessoa(result){
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setFoto = function ($file, tecnico) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        tecnico.foto = base64Data;
                        tecnico.fotoContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('TecnicoDetailController', TecnicoDetailController);

    TecnicoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Tecnico', 'Unidade'];

    function TecnicoDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Tecnico, Unidade) {
        var vm = this;

        vm.tecnico = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('netWordAgroApp:tecnicoUpdate', function(event, result) {
            vm.tecnico = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('TecnicoDeleteController',TecnicoDeleteController);

    TecnicoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Tecnico'];

    function TecnicoDeleteController($uibModalInstance, entity, Tecnico) {
        var vm = this;

        vm.tecnico = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Tecnico.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tecnico', {
            parent: 'entity',
            url: '/tecnico',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.tecnico.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tecnico/tecnicos.html',
                    controller: 'TecnicoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tecnico');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tecnico-detail', {
            parent: 'tecnico',
            url: '/tecnico/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.tecnico.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tecnico/tecnico-detail.html',
                    controller: 'TecnicoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tecnico');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Tecnico', function($stateParams, Tecnico) {
                    return Tecnico.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tecnico',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('tecnico-detail.edit', {
            parent: 'tecnico-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tecnico/tecnico-dialog.html',
                    controller: 'TecnicoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Tecnico', function(Tecnico) {
                            return Tecnico.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tecnico.new', {
            parent: 'tecnico',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tecnico/tecnico-dialog.html',
                    controller: 'TecnicoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                sobrenome: null,
                                cpf: null,
                                email: null,
                                foto: null,
                                fotoContentType: null,
                                login: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tecnico', null, { reload: 'tecnico' });
                }, function() {
                    $state.go('tecnico');
                });
            }]
        })
        .state('tecnico.edit', {
            parent: 'tecnico',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tecnico/tecnico-dialog.html',
                    controller: 'TecnicoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Tecnico', function(Tecnico) {
                            return Tecnico.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tecnico', null, { reload: 'tecnico' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tecnico.delete', {
            parent: 'tecnico',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tecnico/tecnico-delete-dialog.html',
                    controller: 'TecnicoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Tecnico', function(Tecnico) {
                            return Tecnico.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tecnico', null, { reload: 'tecnico' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Tecnico', Tecnico);

    Tecnico.$inject = ['$resource'];

    function Tecnico ($resource) {
        var resourceUrl =  'api/tecnicos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('TecnicoSearch', TecnicoSearch);

    TecnicoSearch.$inject = ['$resource'];

    function TecnicoSearch($resource) {
        var resourceUrl =  'api/_search/tecnicos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('TecnicoController', TecnicoController);

    TecnicoController.$inject = ['DataUtils', 'Tecnico', 'TecnicoSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function TecnicoController(DataUtils, Tecnico, TecnicoSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.tecnicos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                TecnicoSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Tecnico.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.tecnicos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.tecnicos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.tecnicos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.tecnicos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('TarefaDialogController', TarefaDialogController);

    TarefaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Tarefa', 'Atividade'];

    function TarefaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Tarefa, Atividade) {
        var vm = this;

        vm.tarefa = entity;
        vm.clear = clear;
        vm.save = save;
        vm.atividades = Atividade.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.tarefa.id !== null) {
                Tarefa.update(vm.tarefa, onSaveSuccess, onSaveError);
            } else {
                Tarefa.save(vm.tarefa, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:tarefaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('TarefaDetailController', TarefaDetailController);

    TarefaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Tarefa', 'Atividade'];

    function TarefaDetailController($scope, $rootScope, $stateParams, previousState, entity, Tarefa, Atividade) {
        var vm = this;

        vm.tarefa = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:tarefaUpdate', function(event, result) {
            vm.tarefa = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('TarefaDeleteController',TarefaDeleteController);

    TarefaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Tarefa'];

    function TarefaDeleteController($uibModalInstance, entity, Tarefa) {
        var vm = this;

        vm.tarefa = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Tarefa.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tarefa', {
            parent: 'entity',
            url: '/tarefa',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.tarefa.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tarefa/tarefas.html',
                    controller: 'TarefaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tarefa');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tarefa-detail', {
            parent: 'tarefa',
            url: '/tarefa/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.tarefa.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tarefa/tarefa-detail.html',
                    controller: 'TarefaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tarefa');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Tarefa', function($stateParams, Tarefa) {
                    return Tarefa.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tarefa',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('tarefa-detail.edit', {
            parent: 'tarefa-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tarefa/tarefa-dialog.html',
                    controller: 'TarefaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Tarefa', function(Tarefa) {
                            return Tarefa.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tarefa.new', {
            parent: 'tarefa',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tarefa/tarefa-dialog.html',
                    controller: 'TarefaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                latitude: null,
                                longitude: null,
                                tipo: null,
                                datahora: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tarefa', null, { reload: 'tarefa' });
                }, function() {
                    $state.go('tarefa');
                });
            }]
        })
        .state('tarefa.edit', {
            parent: 'tarefa',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tarefa/tarefa-dialog.html',
                    controller: 'TarefaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Tarefa', function(Tarefa) {
                            return Tarefa.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tarefa', null, { reload: 'tarefa' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tarefa.delete', {
            parent: 'tarefa',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tarefa/tarefa-delete-dialog.html',
                    controller: 'TarefaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Tarefa', function(Tarefa) {
                            return Tarefa.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tarefa', null, { reload: 'tarefa' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Tarefa', Tarefa);

    Tarefa.$inject = ['$resource'];

    function Tarefa ($resource) {
        var resourceUrl =  'api/tarefas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('TarefaSearch', TarefaSearch);

    TarefaSearch.$inject = ['$resource'];

    function TarefaSearch($resource) {
        var resourceUrl =  'api/_search/tarefas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('TarefaController', TarefaController);

    TarefaController.$inject = ['Tarefa', 'TarefaSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function TarefaController(Tarefa, TarefaSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.tarefas = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                TarefaSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Tarefa.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.tarefas.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.tarefas = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.tarefas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.tarefas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('SoloDialogController', SoloDialogController);

    SoloDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Solo', 'Caracteristicasolo', 'Corratribce', 'Pesquisa'];

    function SoloDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Solo, Caracteristicasolo, Corratribce, Pesquisa) {
        var vm = this;

        vm.solo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.caracteristicasolos = Caracteristicasolo.query();
        vm.corratribces = Corratribce.query();
        vm.pesquisas = Pesquisa.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.solo.id !== null) {
                Solo.update(vm.solo, onSaveSuccess, onSaveError);
            } else {
                Solo.save(vm.solo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:soloUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('SoloDetailController', SoloDetailController);

    SoloDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Solo', 'Caracteristicasolo', 'Corratribce', 'Pesquisa'];

    function SoloDetailController($scope, $rootScope, $stateParams, previousState, entity, Solo, Caracteristicasolo, Corratribce, Pesquisa) {
        var vm = this;

        vm.solo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:soloUpdate', function(event, result) {
            vm.solo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('SoloDeleteController',SoloDeleteController);

    SoloDeleteController.$inject = ['$uibModalInstance', 'entity', 'Solo'];

    function SoloDeleteController($uibModalInstance, entity, Solo) {
        var vm = this;

        vm.solo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Solo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('solo', {
            parent: 'entity',
            url: '/solo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.solo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/solo/solos.html',
                    controller: 'SoloController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('solo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('solo-detail', {
            parent: 'solo',
            url: '/solo/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.solo.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/solo/solo-detail.html',
                    controller: 'SoloDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('solo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Solo', function($stateParams, Solo) {
                    return Solo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'solo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('solo-detail.edit', {
            parent: 'solo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/solo/solo-dialog.html',
                    controller: 'SoloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Solo', function(Solo) {
                            return Solo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('solo.new', {
            parent: 'solo',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/solo/solo-dialog.html',
                    controller: 'SoloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nomesolo: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('solo', null, { reload: 'solo' });
                }, function() {
                    $state.go('solo');
                });
            }]
        })
        .state('solo.edit', {
            parent: 'solo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/solo/solo-dialog.html',
                    controller: 'SoloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Solo', function(Solo) {
                            return Solo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('solo', null, { reload: 'solo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('solo.delete', {
            parent: 'solo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/solo/solo-delete-dialog.html',
                    controller: 'SoloDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Solo', function(Solo) {
                            return Solo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('solo', null, { reload: 'solo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Solo', Solo);

    Solo.$inject = ['$resource'];

    function Solo ($resource) {
        var resourceUrl =  'api/solos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('SoloSearch', SoloSearch);

    SoloSearch.$inject = ['$resource'];

    function SoloSearch($resource) {
        var resourceUrl =  'api/_search/solos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('SoloController', SoloController);

    SoloController.$inject = ['Solo', 'SoloSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function SoloController(Solo, SoloSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.solos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                SoloSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Solo.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.solos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.solos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.solos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.solos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ServicoDialogController', ServicoDialogController);

    ServicoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Servico', 'Alocacaoinsumos', 'Atividade'];

    function ServicoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Servico, Alocacaoinsumos, Atividade) {
        var vm = this;

        vm.servico = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.alocacaoinsumos = Alocacaoinsumos.query();
        vm.atividades = Atividade.query();
        var idatividade = $stateParams.idativ;

        

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
            history.go(-1);
        }

        function save () {
            vm.isSaving = true;
            vm.servico.atividade = new Atividade();
            vm.servico.atividade.id = idatividade;
            if (vm.servico.id !== null) {
                Servico.update(vm.servico, onSaveSuccess, onSaveError);
            } else {
                Servico.save(vm.servico, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:servicoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            history.go(-1);
        }

        function onSaveError () {
            vm.isSaving = false;
            history.go(-1);
        }

        vm.datePickerOpenStatus.datacontratacao = false;
        vm.datePickerOpenStatus.datarealizacao = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ServicoDetailController', ServicoDetailController);

    ServicoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Servico', 'Alocacaoinsumos', 'Atividade'];

    function ServicoDetailController($scope, $rootScope, $stateParams, previousState, entity, Servico, Alocacaoinsumos, Atividade) {
        var vm = this;

        vm.servico = entity;
        vm.previousState = previousState.name;

        vm.alocacaoinsumos=[];

        loadAll();

        var unsubscribe = $rootScope.$on('netWordAgroApp:servicoUpdate', function(event, result) {
            vm.servico = result;
        });


        function loadAll(){
            Alocacaoinsumos.queryByServico({id: vm.servico.id}, function(result){
                vm.alocacaoinsumos = result;
                vm.searchQuery = null;
            });
        }

        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ServicoDeleteController',ServicoDeleteController);

    ServicoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Servico'];

    function ServicoDeleteController($uibModalInstance, entity, Servico) {
        var vm = this;

        vm.servico = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
            history.go(-1);
        }

        function confirmDelete (id) {
            Servico.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    history.go(-1);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('servico', {
            parent: 'entity',
            url: '/servico?{idservico}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.servico.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/servico/servicos.html',
                    controller: 'ServicoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('servico');
                    $translatePartialLoader.addPart('tiposervico');
                    $translatePartialLoader.addPart('tipofluxo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('servico-detail', {
            parent: 'servico',
            url: '/servico/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.servico.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/servico/servico-detail.html',
                    controller: 'ServicoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('servico');
                    $translatePartialLoader.addPart('tiposervico');
                    $translatePartialLoader.addPart('tipofluxo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Servico', function($stateParams, Servico) {
                    return Servico.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'servico',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('servico-detail.edit', {
            parent: 'servico-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/servico/servico-dialog.html',
                    controller: 'ServicoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Servico', function(Servico) {
                            return Servico.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('servico.new', {
            parent: 'servico',
            url: '/new?{idativ}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/servico/servico-dialog.html',
                    controller: 'ServicoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                descricao: null,
                                valor: null,
                                nomeresponsavel: null,
                                tiporesponsavel: null,
                                datacontratacao: null,
                                datarealizacao: null,
                                fluxo: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('servico', null, { reload: 'servico' });
                }, function() {
                    $state.go('servico');
                });
            }]
        })
        .state('servico.edit', {
            parent: 'servico',
            url: '/{id}/edit?{idativ}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/servico/servico-dialog.html',
                    controller: 'ServicoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Servico', function(Servico) {
                            return Servico.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('servico', null, { reload: 'servico' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('servico.delete', {
            parent: 'servico',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/servico/servico-delete-dialog.html',
                    controller: 'ServicoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Servico', function(Servico) {
                            return Servico.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('servico', null, { reload: 'servico' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Servico', Servico);

    Servico.$inject = ['$resource', 'DateUtils'];

    function Servico ($resource, DateUtils) {
        var resourceUrl =  'api/servicos/:id';

        return $resource(resourceUrl, {}, {
            'queryByAtividade':{
                url: '/api/servicos/atividades/:atividadeid',
                method: 'GET',
                isArray: true
            },
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datacontratacao = DateUtils.convertLocalDateFromServer(data.datacontratacao);
                        data.datarealizacao = DateUtils.convertLocalDateFromServer(data.datarealizacao);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datacontratacao = DateUtils.convertLocalDateToServer(copy.datacontratacao);
                    copy.datarealizacao = DateUtils.convertLocalDateToServer(copy.datarealizacao);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datacontratacao = DateUtils.convertLocalDateToServer(copy.datacontratacao);
                    copy.datarealizacao = DateUtils.convertLocalDateToServer(copy.datarealizacao);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('ServicoSearch', ServicoSearch);

    ServicoSearch.$inject = ['$resource'];

    function ServicoSearch($resource) {
        var resourceUrl =  'api/_search/servicos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ServicoController', ServicoController);

    ServicoController.$inject = ['Servico', 'ServicoSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function ServicoController(Servico, ServicoSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.servicos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                ServicoSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Servico.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.servicos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.servicos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.servicos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.servicos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('SensorDialogController', SensorDialogController);

    SensorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Sensor', 'Unidade'];

    function SensorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Sensor, Unidade) {
        var vm = this;

        vm.sensor = entity;
        vm.clear = clear;
        vm.save = save;
        vm.unidades = Unidade.query({
            size: 1000,
            sort: "nome,asc"
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sensor.id !== null) {
                Sensor.update(vm.sensor, onSaveSuccess, onSaveError);
            } else {
                Sensor.save(vm.sensor, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:sensorUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('SensorDetailController', SensorDetailController);

    SensorDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Sensor', 'Unidade'];

    function SensorDetailController($scope, $rootScope, $stateParams, previousState, entity, Sensor, Unidade) {
        var vm = this;

        vm.sensor = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:sensorUpdate', function(event, result) {
            vm.sensor = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('SensorDeleteController',SensorDeleteController);

    SensorDeleteController.$inject = ['$uibModalInstance', 'entity', 'Sensor'];

    function SensorDeleteController($uibModalInstance, entity, Sensor) {
        var vm = this;

        vm.sensor = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Sensor.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sensor', {
            parent: 'entity',
            url: '/sensor',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.sensor.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sensor/sensors.html',
                    controller: 'SensorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sensor');
                    $translatePartialLoader.addPart('tipostatussensor');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('sensor-detail', {
            parent: 'sensor',
            url: '/sensor/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.sensor.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sensor/sensor-detail.html',
                    controller: 'SensorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sensor');
                    $translatePartialLoader.addPart('tipostatussensor');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Sensor', function($stateParams, Sensor) {
                    return Sensor.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'sensor',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('sensor-detail.edit', {
            parent: 'sensor-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sensor/sensor-dialog.html',
                    controller: 'SensorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Sensor', function(Sensor) {
                            return Sensor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sensor.new', {
            parent: 'sensor',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sensor/sensor-dialog.html',
                    controller: 'SensorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                descricao: null,
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('sensor', null, { reload: 'sensor' });
                }, function() {
                    $state.go('sensor');
                });
            }]
        })
        .state('sensor.edit', {
            parent: 'sensor',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sensor/sensor-dialog.html',
                    controller: 'SensorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Sensor', function(Sensor) {
                            return Sensor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sensor', null, { reload: 'sensor' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sensor.delete', {
            parent: 'sensor',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sensor/sensor-delete-dialog.html',
                    controller: 'SensorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Sensor', function(Sensor) {
                            return Sensor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sensor', null, { reload: 'sensor' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Sensor', Sensor);

    Sensor.$inject = ['$resource'];

    function Sensor ($resource) {
        var resourceUrl =  'api/sensors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('SensorSearch', SensorSearch);

    SensorSearch.$inject = ['$resource'];

    function SensorSearch($resource) {
        var resourceUrl =  'api/_search/sensors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('SensorController', SensorController);

    SensorController.$inject = ['Sensor', 'SensorSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function SensorController(Sensor, SensorSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.sensors = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                SensorSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Sensor.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.sensors.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.sensors = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.sensors = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.sensors = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('SafraDialogController', SafraDialogController);

    SafraDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Safra', 'Propriedade', 'Custosnwfertilizantes', 'Custosnwdefensivos', 'Indicadoresnw', 'Custosnwproducao', 'Custoshabituaisproducao', 'Indicadoreshabituais', 'Custoshabituaisdefensivos', 'Custoshabituaisfertilizantes', 'Cultura', 'Etapa', 'Preplantioplan', 'Preplantio', 'Plantioplan', 'Plantio', 'Colheitaplan', 'Colheita', 'Armazenamentosafraplan', 'Armazenamentosafra', 'Manutencaosafraplan', 'Comercializacaoplan', 'Comercializacao', 'Entregasafracomercplan', 'Entregasafracomerc', 'Logentregaarmazplan', 'Logentregaarmaz', 'Logrecinsumoplan', 'Logrecinsumo', 'Manutencaosafra'];

    function SafraDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Safra, Propriedade, Custosnwfertilizantes, Custosnwdefensivos, Indicadoresnw, Custosnwproducao, Custoshabituaisproducao, Indicadoreshabituais, Custoshabituaisdefensivos, Custoshabituaisfertilizantes, Cultura, Etapa, Preplantioplan, Preplantio, Plantioplan, Plantio, Colheitaplan, Colheita, Armazenamentosafraplan, Armazenamentosafra, Manutencaosafraplan, Comercializacaoplan, Comercializacao, Entregasafracomercplan, Entregasafracomerc, Logentregaarmazplan, Logentregaarmaz, Logrecinsumoplan, Logrecinsumo, Manutencaosafra) {
        var vm = this;

        vm.safra = entity;
        vm.clear = clear;
        vm.save = save;
        vm.propriedades = Propriedade.queryNomesPropriedadeParceiros({
            size: 1000,
            sort: "nomepropriedade,asc"
        });
        vm.custosnwfertilizantes = Custosnwfertilizantes.query();
        vm.custosnwdefensivos = Custosnwdefensivos.query();
        vm.indicadoresnws = Indicadoresnw.query();
        vm.custosnwproducaos = Custosnwproducao.query();
        vm.custoshabituaisproducaos = Custoshabituaisproducao.query();
        vm.indicadoreshabituais = Indicadoreshabituais.query();
        vm.custoshabituaisdefensivos = Custoshabituaisdefensivos.query();
        vm.custoshabituaisfertilizantes = Custoshabituaisfertilizantes.query();
        vm.culturas = Cultura.query({
            size: 1000,
            sort: "nomecultura,asc"
        });
        vm.etapas = Etapa.query();
        vm.preplantioplans = Preplantioplan.query();
        vm.preplantios = Preplantio.query();
        vm.plantioplans = Plantioplan.query();
        vm.plantios = Plantio.query();
        vm.colheitaplans = Colheitaplan.query();
        vm.colheitas = Colheita.query();
        vm.armazenamentosafraplans = Armazenamentosafraplan.query();
        vm.armazenamentosafras = Armazenamentosafra.query();
        vm.manutencaosafraplans = Manutencaosafraplan.query();
        vm.comercializacaoplans = Comercializacaoplan.query();
        vm.comercializacaos = Comercializacao.query();
        vm.entregasafracomercplans = Entregasafracomercplan.query();
        vm.entregasafracomercs = Entregasafracomerc.query();
        vm.logentregaarmazplans = Logentregaarmazplan.query();
        vm.logentregaarmazs = Logentregaarmaz.query();
        vm.logrecinsumoplans = Logrecinsumoplan.query();
        vm.logrecinsumos = Logrecinsumo.query();
        vm.manutencaosafras = Manutencaosafra.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.safra.id !== null) {
                Safra.update(vm.safra, onSaveSuccess, onSaveError);
            } else {
                Safra.save(vm.safra, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:safraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('SafraDetailController', SafraDetailController);

    SafraDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Safra', 'Propriedade', 'Custosnwfertilizantes', 'Custosnwdefensivos', 'Indicadoresnw', 'Custosnwproducao', 'Custoshabituaisproducao', 'Indicadoreshabituais', 'Custoshabituaisdefensivos', 'Custoshabituaisfertilizantes', 'Cultura', 'Etapa', 'Preplantioplan', 'Preplantio', 'Plantioplan', 'Plantio', 'Colheitaplan', 'Colheita', 'Armazenamentosafraplan', 'Armazenamentosafra', 'Manutencaosafraplan', 'Comercializacaoplan', 'Comercializacao', 'Entregasafracomercplan', 'Entregasafracomerc', 'Logentregaarmazplan', 'Logentregaarmaz', 'Logrecinsumoplan', 'Logrecinsumo', 'Manutencaosafra'];

    function SafraDetailController($scope, $rootScope, $stateParams, previousState, entity, Safra, Propriedade, Custosnwfertilizantes, Custosnwdefensivos, Indicadoresnw, Custosnwproducao, Custoshabituaisproducao, Indicadoreshabituais, Custoshabituaisdefensivos, Custoshabituaisfertilizantes, Cultura, Etapa, Preplantioplan, Preplantio, Plantioplan, Plantio, Colheitaplan, Colheita, Armazenamentosafraplan, Armazenamentosafra, Manutencaosafraplan, Comercializacaoplan, Comercializacao, Entregasafracomercplan, Entregasafracomerc, Logentregaarmazplan, Logentregaarmaz, Logrecinsumoplan, Logrecinsumo, Manutencaosafra) {
        var vm = this;

        vm.safra = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:safraUpdate', function(event, result) {
            vm.safra = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('SafraDeleteController',SafraDeleteController);

    SafraDeleteController.$inject = ['$uibModalInstance', 'entity', 'Safra'];

    function SafraDeleteController($uibModalInstance, entity, Safra) {
        var vm = this;

        vm.safra = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Safra.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('safra', {
            parent: 'entity',
            url: '/safra',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.safra.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/safra/safras.html',
                    controller: 'SafraController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('safra');
                    $translatePartialLoader.addPart('tiposafra');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('safra-detail', {
            parent: 'safra',
            url: '/safra/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.safra.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/safra/safra-detail.html',
                    controller: 'SafraDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('safra');
                    $translatePartialLoader.addPart('tiposafra');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Safra', function($stateParams, Safra) {
                    return Safra.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'safra',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('safra-detail.edit', {
            parent: 'safra-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/safra/safra-dialog.html',
                    controller: 'SafraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Safra', function(Safra) {
                            return Safra.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('safra.new', {
            parent: 'safra',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/safra/safra-dialog.html',
                    controller: 'SafraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nomesafra: null,
                                safra: null,
                                ano: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('safra', null, { reload: 'safra' });
                }, function() {
                    $state.go('safra');
                });
            }]
        })
        .state('safra.edit', {
            parent: 'safra',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/safra/safra-dialog.html',
                    controller: 'SafraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Safra', function(Safra) {
                            return Safra.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('safra', null, { reload: 'safra' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('safra.delete', {
            parent: 'safra',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/safra/safra-delete-dialog.html',
                    controller: 'SafraDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Safra', function(Safra) {
                            return Safra.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('safra', null, { reload: 'safra' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Safra', Safra);

    Safra.$inject = ['$resource'];

    function Safra ($resource) {
        var resourceUrl =  'api/safras/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'querySafraIdNome': { 
                url: '/api/safras/IdNome/',
                method: 'GET', 
                isArray: true},
            'querySafrasPorPropriedade': { 
                url: '/api/safras/porPropriedade/:idPropriedade',
                method: 'GET', 
                isArray: true},
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('SafraSearch', SafraSearch);

    SafraSearch.$inject = ['$resource'];

    function SafraSearch($resource) {
        var resourceUrl =  'api/_search/safras/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('SafraController', SafraController);

    SafraController.$inject = ['Safra', 'SafraSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function SafraController(Safra, SafraSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.safras = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                SafraSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Safra.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.safras.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.safras = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.safras = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.safras = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('RelatoriocustosnwDialogController', RelatoriocustosnwDialogController);

    RelatoriocustosnwDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Relatoriocustosnw'];

    function RelatoriocustosnwDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Relatoriocustosnw) {
        var vm = this;

        vm.relatoriocustosnw = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.relatoriocustosnw.id !== null) {
                Relatoriocustosnw.update(vm.relatoriocustosnw, onSaveSuccess, onSaveError);
            } else {
                Relatoriocustosnw.save(vm.relatoriocustosnw, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:relatoriocustosnwUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('RelatoriocustosnwDetailController', RelatoriocustosnwDetailController);

    RelatoriocustosnwDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Relatoriocustosnw'];

    function RelatoriocustosnwDetailController($scope, $rootScope, $stateParams, previousState, entity, Relatoriocustosnw) {
        var vm = this;

        vm.relatoriocustosnw = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:relatoriocustosnwUpdate', function(event, result) {
            vm.relatoriocustosnw = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('RelatoriocustosnwDeleteController',RelatoriocustosnwDeleteController);

    RelatoriocustosnwDeleteController.$inject = ['$uibModalInstance', 'entity', 'Relatoriocustosnw'];

    function RelatoriocustosnwDeleteController($uibModalInstance, entity, Relatoriocustosnw) {
        var vm = this;

        vm.relatoriocustosnw = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Relatoriocustosnw.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('relatoriocustosnw', {
            parent: 'entity',
            url: '/relatoriocustosnw',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.relatoriocustosnw.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/relatoriocustosnw/relatoriocustosnws.html',
                    controller: 'RelatoriocustosnwController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('relatoriocustosnw');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('relatoriocustosnw-en', {
            parent: 'entity',
            url: '/relatoriocustosnw-en',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.relatoriocustosnw.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/relatoriocustosnw/relatoriocustosnws-en.html',
                    controller: 'RelatoriocustosnwController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('relatoriocustosnw');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('relatoriocustosnw-es', {
            parent: 'entity',
            url: '/relatoriocustosnw-es',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.relatoriocustosnw.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/relatoriocustosnw/relatoriocustosnws-es.html',
                    controller: 'RelatoriocustosnwController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('relatoriocustosnw');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('relatoriocustosnw-detail', {
            parent: 'relatoriocustosnw',
            url: '/relatoriocustosnw/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.relatoriocustosnw.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/relatoriocustosnw/relatoriocustosnw-detail.html',
                    controller: 'RelatoriocustosnwDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('relatoriocustosnw');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Relatoriocustosnw', function($stateParams, Relatoriocustosnw) {
                    return Relatoriocustosnw.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'relatoriocustosnw',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('relatoriocustosnw-detail.edit', {
            parent: 'relatoriocustosnw-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/relatoriocustosnw/relatoriocustosnw-dialog.html',
                    controller: 'RelatoriocustosnwDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Relatoriocustosnw', function(Relatoriocustosnw) {
                            return Relatoriocustosnw.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('relatoriocustosnw.new', {
            parent: 'relatoriocustosnw',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/relatoriocustosnw/relatoriocustosnw-dialog.html',
                    controller: 'RelatoriocustosnwDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('relatoriocustosnw', null, { reload: 'relatoriocustosnw' });
                }, function() {
                    $state.go('relatoriocustosnw');
                });
            }]
        })
        .state('relatoriocustosnw.edit', {
            parent: 'relatoriocustosnw',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/relatoriocustosnw/relatoriocustosnw-dialog.html',
                    controller: 'RelatoriocustosnwDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Relatoriocustosnw', function(Relatoriocustosnw) {
                            return Relatoriocustosnw.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('relatoriocustosnw', null, { reload: 'relatoriocustosnw' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('relatoriocustosnw.delete', {
            parent: 'relatoriocustosnw',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/relatoriocustosnw/relatoriocustosnw-delete-dialog.html',
                    controller: 'RelatoriocustosnwDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Relatoriocustosnw', function(Relatoriocustosnw) {
                            return Relatoriocustosnw.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('relatoriocustosnw', null, { reload: 'relatoriocustosnw' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Relatoriocustosnw', Relatoriocustosnw);

    Relatoriocustosnw.$inject = ['$resource'];

    function Relatoriocustosnw ($resource) {
        var resourceUrl =  'api/relatoriocustosnws/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('RelatoriocustosnwSearch', RelatoriocustosnwSearch);

    RelatoriocustosnwSearch.$inject = ['$resource'];

    function RelatoriocustosnwSearch($resource) {
        var resourceUrl =  'api/_search/relatoriocustosnws/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('RelatoriocustosnwController', RelatoriocustosnwController);

    RelatoriocustosnwController.$inject = ['Relatoriocustosnw', 'RelatoriocustosnwSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function RelatoriocustosnwController(Relatoriocustosnw, RelatoriocustosnwSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.relatoriocustosnws = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        //loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                RelatoriocustosnwSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Relatoriocustosnw.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.relatoriocustosnws.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.relatoriocustosnws = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.relatoriocustosnws = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.relatoriocustosnws = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('RelatorioDialogController', RelatorioDialogController);

    RelatorioDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Relatorio'];

    function RelatorioDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Relatorio) {
        var vm = this;

        vm.relatorio = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.relatorio.id !== null) {
                Relatorio.update(vm.relatorio, onSaveSuccess, onSaveError);
            } else {
                Relatorio.save(vm.relatorio, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:relatorioUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('RelatorioDetailController', RelatorioDetailController);

    RelatorioDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Relatorio'];

    function RelatorioDetailController($scope, $rootScope, $stateParams, previousState, entity, Relatorio) {
        var vm = this;

        vm.relatorio = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:relatorioUpdate', function(event, result) {
            vm.relatorio = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('RelatorioDeleteController',RelatorioDeleteController);

    RelatorioDeleteController.$inject = ['$uibModalInstance', 'entity', 'Relatorio'];

    function RelatorioDeleteController($uibModalInstance, entity, Relatorio) {
        var vm = this;

        vm.relatorio = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Relatorio.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('relatorio', {
            parent: 'entity',
            url: '/relatorio',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.relatorio.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/relatorio/relatorios.html',
                    controller: 'RelatorioController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('relatorio');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('relatorios-en', {
            parent: 'entity',
            url: '/relatorios-en',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.relatorio.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/relatorio/relatorios-en.html',
                    controller: 'RelatorioController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('relatorio');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('relatorios-es', {
            parent: 'entity',
            url: '/relatorios-es',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.relatorio.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/relatorio/relatorios-es.html',
                    controller: 'RelatorioController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('relatorio');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('relatorio-detail', {
            parent: 'relatorio',
            url: '/relatorio/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.relatorio.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/relatorio/relatorio-detail.html',
                    controller: 'RelatorioDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('relatorio');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Relatorio', function($stateParams, Relatorio) {
                    return Relatorio.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'relatorio',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('relatorio-detail.edit', {
            parent: 'relatorio-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/relatorio/relatorio-dialog.html',
                    controller: 'RelatorioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Relatorio', function(Relatorio) {
                            return Relatorio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('relatorio.new', {
            parent: 'relatorio',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/relatorio/relatorio-dialog.html',
                    controller: 'RelatorioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('relatorio', null, { reload: 'relatorio' });
                }, function() {
                    $state.go('relatorio');
                });
            }]
        })
        .state('relatorio.edit', {
            parent: 'relatorio',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/relatorio/relatorio-dialog.html',
                    controller: 'RelatorioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Relatorio', function(Relatorio) {
                            return Relatorio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('relatorio', null, { reload: 'relatorio' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('relatorio.delete', {
            parent: 'relatorio',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/relatorio/relatorio-delete-dialog.html',
                    controller: 'RelatorioDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Relatorio', function(Relatorio) {
                            return Relatorio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('relatorio', null, { reload: 'relatorio' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Relatorio', Relatorio);

    Relatorio.$inject = ['$resource'];

    function Relatorio ($resource) {
        var resourceUrl =  'api/relatorios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('RelatorioSearch', RelatorioSearch);

    RelatorioSearch.$inject = ['$resource'];

    function RelatorioSearch($resource) {
        var resourceUrl =  'api/_search/relatorios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('RelatorioController', RelatorioController);

    RelatorioController.$inject = ['Relatorio', 'RelatorioSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function RelatorioController(Relatorio, RelatorioSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.relatorios = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        //loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                RelatorioSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Relatorio.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.relatorios.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.relatorios = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.relatorios = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.relatorios = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('RegiaoDialogController', RegiaoDialogController);

    RegiaoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Regiao', 'Estado', 'Pais'];

    function RegiaoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Regiao, Estado, Pais) {
        var vm = this;

        vm.regiao = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.estados = Estado.query();
        vm.pais = Pais.query({
            sort: "nomepais,asc"
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.regiao.id !== null) {
                Regiao.update(vm.regiao, onSaveSuccess, onSaveError);
            } else {
                Regiao.save(vm.regiao, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:regiaoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setImagemregiao = function ($file, regiao) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        regiao.imagemregiao = base64Data;
                        regiao.imagemregiaoContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('RegiaoDetailController', RegiaoDetailController);

    RegiaoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Regiao', 'Estado', 'Pais'];

    function RegiaoDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Regiao, Estado, Pais) {
        var vm = this;

        vm.regiao = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('netWordAgroApp:regiaoUpdate', function(event, result) {
            vm.regiao = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('RegiaoDeleteController',RegiaoDeleteController);

    RegiaoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Regiao'];

    function RegiaoDeleteController($uibModalInstance, entity, Regiao) {
        var vm = this;

        vm.regiao = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Regiao.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('regiao', {
            parent: 'entity',
            url: '/regiao',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.regiao.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/regiao/regiaos.html',
                    controller: 'RegiaoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('regiao');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('regiao-detail', {
            parent: 'regiao',
            url: '/regiao/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.regiao.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/regiao/regiao-detail.html',
                    controller: 'RegiaoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('regiao');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Regiao', function($stateParams, Regiao) {
                    return Regiao.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'regiao',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('regiao-detail.edit', {
            parent: 'regiao-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/regiao/regiao-dialog.html',
                    controller: 'RegiaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Regiao', function(Regiao) {
                            return Regiao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('regiao.new', {
            parent: 'regiao',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/regiao/regiao-dialog.html',
                    controller: 'RegiaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nomeregiao: null,
                                imagemregiao: null,
                                imagemregiaoContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('regiao', null, { reload: 'regiao' });
                }, function() {
                    $state.go('regiao');
                });
            }]
        })
        .state('regiao.edit', {
            parent: 'regiao',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/regiao/regiao-dialog.html',
                    controller: 'RegiaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Regiao', function(Regiao) {
                            return Regiao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('regiao', null, { reload: 'regiao' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('regiao.delete', {
            parent: 'regiao',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/regiao/regiao-delete-dialog.html',
                    controller: 'RegiaoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Regiao', function(Regiao) {
                            return Regiao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('regiao', null, { reload: 'regiao' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Regiao', Regiao);

    Regiao.$inject = ['$resource'];

    function Regiao ($resource) {
        var resourceUrl =  'api/regiaos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('RegiaoSearch', RegiaoSearch);

    RegiaoSearch.$inject = ['$resource'];

    function RegiaoSearch($resource) {
        var resourceUrl =  'api/_search/regiaos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('RegiaoController', RegiaoController);

    RegiaoController.$inject = ['DataUtils', 'Regiao', 'RegiaoSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function RegiaoController(DataUtils, Regiao, RegiaoSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.regiaos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                RegiaoSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Regiao.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.regiaos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.regiaos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.regiaos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.regiaos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ReceituarioDialogController', ReceituarioDialogController);

    ReceituarioDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Receituario', 'Aquisicaosugerida', 'Quadrantesolo', 'Atividade', 'Propostareceituario'];

    function ReceituarioDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Receituario, Aquisicaosugerida, Quadrantesolo, Atividade, Propostareceituario) {
        var vm = this;

        vm.receituario = entity;
        vm.clear = clear;
        vm.save = save;
        vm.aquisicaosugeridas = Aquisicaosugerida.query();
        vm.quadrantesolos = Quadrantesolo.query();
        vm.atividades = Atividade.query();
        vm.propostareceituarios = Propostareceituario.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.receituario.id !== null) {
                Receituario.update(vm.receituario, onSaveSuccess, onSaveError);
            } else {
                Receituario.save(vm.receituario, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:receituarioUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ReceituarioDetailController', ReceituarioDetailController);

    ReceituarioDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Receituario', 'Aquisicaosugerida', 'Quadrantesolo', 'Atividade', 'Propostareceituario'];

    function ReceituarioDetailController($scope, $rootScope, $stateParams, previousState, entity, Receituario, Aquisicaosugerida, Quadrantesolo, Atividade, Propostareceituario) {
        var vm = this;

        vm.receituario = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:receituarioUpdate', function(event, result) {
            vm.receituario = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ReceituarioDeleteController',ReceituarioDeleteController);

    ReceituarioDeleteController.$inject = ['$uibModalInstance', 'entity', 'Receituario'];

    function ReceituarioDeleteController($uibModalInstance, entity, Receituario) {
        var vm = this;

        vm.receituario = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Receituario.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('receituario', {
            parent: 'entity',
            url: '/receituario',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.receituario.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/receituario/receituarios.html',
                    controller: 'ReceituarioController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('receituario');
                    $translatePartialLoader.addPart('tipomedidaquantidade');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('receituario-detail', {
            parent: 'receituario',
            url: '/receituario/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.receituario.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/receituario/receituario-detail.html',
                    controller: 'ReceituarioDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('receituario');
                    $translatePartialLoader.addPart('tipomedidaquantidade');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Receituario', function($stateParams, Receituario) {
                    return Receituario.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'receituario',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('receituario-detail.edit', {
            parent: 'receituario-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/receituario/receituario-dialog.html',
                    controller: 'ReceituarioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Receituario', function(Receituario) {
                            return Receituario.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('receituario.new', {
            parent: 'receituario',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/receituario/receituario-dialog.html',
                    controller: 'ReceituarioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                diagnostico: null,
                                produto: null,
                                quantidade: null,
                                medidaquantidade: null,
                                aplicacao: null,
                                posaplicacao: null,
                                latitudeespecifica: null,
                                longitudeespecifica: null,
                                aplicado: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('receituario', null, { reload: 'receituario' });
                }, function() {
                    $state.go('receituario');
                });
            }]
        })
        .state('receituario.edit', {
            parent: 'receituario',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/receituario/receituario-dialog.html',
                    controller: 'ReceituarioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Receituario', function(Receituario) {
                            return Receituario.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('receituario', null, { reload: 'receituario' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('receituario.delete', {
            parent: 'receituario',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/receituario/receituario-delete-dialog.html',
                    controller: 'ReceituarioDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Receituario', function(Receituario) {
                            return Receituario.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('receituario', null, { reload: 'receituario' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Receituario', Receituario);

    Receituario.$inject = ['$resource'];

    function Receituario ($resource) {
        var resourceUrl =  'api/receituarios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('ReceituarioSearch', ReceituarioSearch);

    ReceituarioSearch.$inject = ['$resource'];

    function ReceituarioSearch($resource) {
        var resourceUrl =  'api/_search/receituarios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ReceituarioController', ReceituarioController);

    ReceituarioController.$inject = ['Receituario', 'ReceituarioSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function ReceituarioController(Receituario, ReceituarioSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.receituarios = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                ReceituarioSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Receituario.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.receituarios.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.receituarios = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.receituarios = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.receituarios = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('QuadrantesoloDialogController', QuadrantesoloDialogController);

    QuadrantesoloDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Quadrantesolo', 'Pontossensoriamentosolo', 'Matrizsensoriamento'];

    function QuadrantesoloDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Quadrantesolo, Pontossensoriamentosolo, Matrizsensoriamento) {
        var vm = this;

        vm.quadrantesolo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.pontossensoriamentosolos = Pontossensoriamentosolo.query();
        vm.matrizsensoriamentos = Matrizsensoriamento.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.quadrantesolo.id !== null) {
                Quadrantesolo.update(vm.quadrantesolo, onSaveSuccess, onSaveError);
            } else {
                Quadrantesolo.save(vm.quadrantesolo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:quadrantesoloUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('QuadrantesoloDetailController', QuadrantesoloDetailController);

    QuadrantesoloDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Quadrantesolo', 'Pontossensoriamentosolo', 'Matrizsensoriamento'];

    function QuadrantesoloDetailController($scope, $rootScope, $stateParams, previousState, entity, Quadrantesolo, Pontossensoriamentosolo, Matrizsensoriamento) {
        var vm = this;

        vm.quadrantesolo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:quadrantesoloUpdate', function(event, result) {
            vm.quadrantesolo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('QuadrantesoloDeleteController',QuadrantesoloDeleteController);

    QuadrantesoloDeleteController.$inject = ['$uibModalInstance', 'entity', 'Quadrantesolo'];

    function QuadrantesoloDeleteController($uibModalInstance, entity, Quadrantesolo) {
        var vm = this;

        vm.quadrantesolo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Quadrantesolo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('quadrantesolo', {
            parent: 'entity',
            url: '/quadrantesolo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.quadrantesolo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/quadrantesolo/quadrantesolos.html',
                    controller: 'QuadrantesoloController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('quadrantesolo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('quadrantesolo-detail', {
            parent: 'quadrantesolo',
            url: '/quadrantesolo/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.quadrantesolo.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/quadrantesolo/quadrantesolo-detail.html',
                    controller: 'QuadrantesoloDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('quadrantesolo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Quadrantesolo', function($stateParams, Quadrantesolo) {
                    return Quadrantesolo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'quadrantesolo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('quadrantesolo-detail.edit', {
            parent: 'quadrantesolo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/quadrantesolo/quadrantesolo-dialog.html',
                    controller: 'QuadrantesoloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Quadrantesolo', function(Quadrantesolo) {
                            return Quadrantesolo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('quadrantesolo.new', {
            parent: 'quadrantesolo',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/quadrantesolo/quadrantesolo-dialog.html',
                    controller: 'QuadrantesoloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nomequadrante: null,
                                valorlatitudep1: null,
                                valorlongitudep1: null,
                                valorlatitudep2: null,
                                valorlongitudep2: null,
                                valorlatitudep3: null,
                                valorlongitudep3: null,
                                valorlatitudep4: null,
                                valorlongitudep4: null,
                                camada: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('quadrantesolo', null, { reload: 'quadrantesolo' });
                }, function() {
                    $state.go('quadrantesolo');
                });
            }]
        })
        .state('quadrantesolo.edit', {
            parent: 'quadrantesolo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/quadrantesolo/quadrantesolo-dialog.html',
                    controller: 'QuadrantesoloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Quadrantesolo', function(Quadrantesolo) {
                            return Quadrantesolo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('quadrantesolo', null, { reload: 'quadrantesolo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('quadrantesolo.delete', {
            parent: 'quadrantesolo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/quadrantesolo/quadrantesolo-delete-dialog.html',
                    controller: 'QuadrantesoloDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Quadrantesolo', function(Quadrantesolo) {
                            return Quadrantesolo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('quadrantesolo', null, { reload: 'quadrantesolo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Quadrantesolo', Quadrantesolo);

    Quadrantesolo.$inject = ['$resource'];

    function Quadrantesolo ($resource) {
        var resourceUrl =  'api/quadrantesolos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('QuadrantesoloSearch', QuadrantesoloSearch);

    QuadrantesoloSearch.$inject = ['$resource'];

    function QuadrantesoloSearch($resource) {
        var resourceUrl =  'api/_search/quadrantesolos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('QuadrantesoloController', QuadrantesoloController);

    QuadrantesoloController.$inject = ['Quadrantesolo', 'QuadrantesoloSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function QuadrantesoloController(Quadrantesolo, QuadrantesoloSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.quadrantesolos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                QuadrantesoloSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Quadrantesolo.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.quadrantesolos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.quadrantesolos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.quadrantesolos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.quadrantesolos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('QuadranteimagemDialogController', QuadranteimagemDialogController);

    QuadranteimagemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Quadranteimagem', 'Medicaoatriblavoura', 'Matrizsensoriamento'];

    function QuadranteimagemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Quadranteimagem, Medicaoatriblavoura, Matrizsensoriamento) {
        var vm = this;

        vm.quadranteimagem = entity;
        vm.clear = clear;
        vm.save = save;
        vm.medicaoatriblavouras = Medicaoatriblavoura.query();
        vm.matrizsensoriamentos = Matrizsensoriamento.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.quadranteimagem.id !== null) {
                Quadranteimagem.update(vm.quadranteimagem, onSaveSuccess, onSaveError);
            } else {
                Quadranteimagem.save(vm.quadranteimagem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:quadranteimagemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('QuadranteimagemDetailController', QuadranteimagemDetailController);

    QuadranteimagemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Quadranteimagem', 'Medicaoatriblavoura', 'Matrizsensoriamento'];

    function QuadranteimagemDetailController($scope, $rootScope, $stateParams, previousState, entity, Quadranteimagem, Medicaoatriblavoura, Matrizsensoriamento) {
        var vm = this;

        vm.quadranteimagem = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:quadranteimagemUpdate', function(event, result) {
            vm.quadranteimagem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('QuadranteimagemDeleteController',QuadranteimagemDeleteController);

    QuadranteimagemDeleteController.$inject = ['$uibModalInstance', 'entity', 'Quadranteimagem'];

    function QuadranteimagemDeleteController($uibModalInstance, entity, Quadranteimagem) {
        var vm = this;

        vm.quadranteimagem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Quadranteimagem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('quadranteimagem', {
            parent: 'entity',
            url: '/quadranteimagem',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.quadranteimagem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/quadranteimagem/quadranteimagems.html',
                    controller: 'QuadranteimagemController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('quadranteimagem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('quadranteimagem-detail', {
            parent: 'quadranteimagem',
            url: '/quadranteimagem/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.quadranteimagem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/quadranteimagem/quadranteimagem-detail.html',
                    controller: 'QuadranteimagemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('quadranteimagem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Quadranteimagem', function($stateParams, Quadranteimagem) {
                    return Quadranteimagem.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'quadranteimagem',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('quadranteimagem-detail.edit', {
            parent: 'quadranteimagem-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/quadranteimagem/quadranteimagem-dialog.html',
                    controller: 'QuadranteimagemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Quadranteimagem', function(Quadranteimagem) {
                            return Quadranteimagem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('quadranteimagem.new', {
            parent: 'quadranteimagem',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/quadranteimagem/quadranteimagem-dialog.html',
                    controller: 'QuadranteimagemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nomequadrante: null,
                                valorlatitudep1: null,
                                valorlongitudep1: null,
                                valorlatitudep2: null,
                                valorlongitudep2: null,
                                valorlatitudep3: null,
                                valorlongitudep3: null,
                                valorlatitudep4: null,
                                valorlongitudep4: null,
                                camada: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('quadranteimagem', null, { reload: 'quadranteimagem' });
                }, function() {
                    $state.go('quadranteimagem');
                });
            }]
        })
        .state('quadranteimagem.edit', {
            parent: 'quadranteimagem',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/quadranteimagem/quadranteimagem-dialog.html',
                    controller: 'QuadranteimagemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Quadranteimagem', function(Quadranteimagem) {
                            return Quadranteimagem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('quadranteimagem', null, { reload: 'quadranteimagem' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('quadranteimagem.delete', {
            parent: 'quadranteimagem',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/quadranteimagem/quadranteimagem-delete-dialog.html',
                    controller: 'QuadranteimagemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Quadranteimagem', function(Quadranteimagem) {
                            return Quadranteimagem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('quadranteimagem', null, { reload: 'quadranteimagem' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Quadranteimagem', Quadranteimagem);

    Quadranteimagem.$inject = ['$resource'];

    function Quadranteimagem ($resource) {
        var resourceUrl =  'api/quadranteimagems/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('QuadranteimagemSearch', QuadranteimagemSearch);

    QuadranteimagemSearch.$inject = ['$resource'];

    function QuadranteimagemSearch($resource) {
        var resourceUrl =  'api/_search/quadranteimagems/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('QuadranteimagemController', QuadranteimagemController);

    QuadranteimagemController.$inject = ['Quadranteimagem', 'QuadranteimagemSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function QuadranteimagemController(Quadranteimagem, QuadranteimagemSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.quadranteimagems = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                QuadranteimagemSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Quadranteimagem.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.quadranteimagems.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.quadranteimagems = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.quadranteimagems = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.quadranteimagems = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PropriedadeDialogController', PropriedadeDialogController);

    PropriedadeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Propriedade', 'Georeferenciamento', 'Concentracaoidealatributo', 'Pesquisa', 'Aquisicao', 'Concentracaoindice', 'Imagemtermica', 'Mapaimagem', 'Propostareceituario', 'Cidade', 'Monitoramentoportatil', 'Controleaplicacao', 'Pessoapropriedade', 'Cooperativa', 'Diariodebordo', 'Automatizacao', 'Fazenda'];

    function PropriedadeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Propriedade, Georeferenciamento, Concentracaoidealatributo, Pesquisa, Aquisicao, Concentracaoindice, Imagemtermica, Mapaimagem, Propostareceituario, Cidade, Monitoramentoportatil, Controleaplicacao, Pessoapropriedade, Cooperativa, Diariodebordo, Automatizacao, Fazenda) {
        var vm = this;

        vm.propriedade = entity; 
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.georeferenciamentos = Georeferenciamento.query();
        vm.concentracaoidealatributos = Concentracaoidealatributo.query();
        vm.pesquisas = Pesquisa.query();
        vm.aquisicaos = Aquisicao.query();
        vm.concentracaoindices = Concentracaoindice.query();
        vm.imagemtermicas = Imagemtermica.query();
        vm.mapaimagems = Mapaimagem.query();
        vm.propostareceituarios = Propostareceituario.query();
        //vm.cidades = Cidade.query();
        vm.monitoramentoportatils = Monitoramentoportatil.query();
        vm.controleaplicacaos = Controleaplicacao.query();
        vm.pessoapropriedades = Pessoapropriedade.query();
        vm.cooperativas = Cooperativa.query();
        vm.diariodebordos = Diariodebordo.query();
        vm.automatizacaos = Automatizacao.query();
        vm.fazendas = Fazenda.query(
            {
                size:1000,
                sort:"nome,asc"
            }
        );

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.propriedade.id !== null) {
                Propriedade.update(vm.propriedade, onSaveSuccess, onSaveError);
            } else {
                Propriedade.save(vm.propriedade, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:propriedadeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setImagempropriedade = function ($file, propriedade) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        propriedade.imagempropriedade = base64Data;
                        propriedade.imagempropriedadeContentType = $file.type;
                    });
                });
            }
        };

        vm.setRegressao = function ($file, propriedade) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        propriedade.regressao = base64Data;
                        propriedade.regressaoContentType = $file.type;
                    });
                });
            }
        };

        vm.setDistribuicao = function ($file, propriedade) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        propriedade.distribuicao = base64Data;
                        propriedade.distribuicaoContentType = $file.type;
                    });
                });
            }
        };

        vm.setBorda = function ($file, propriedade) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        propriedade.borda = base64Data;
                        propriedade.bordaContentType = $file.type;
                    });
                });
            }
        };

        vm.setKML = function ($file, propriedade) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        propriedade.kml = base64Data;
                        propriedade.kmlContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PropriedadeDetailController', PropriedadeDetailController);

    PropriedadeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Propriedade', 'Georeferenciamento', 'Concentracaoidealatributo', 'Pesquisa', 'Aquisicao', 'Concentracaoindice', 'Imagemtermica', 'Mapaimagem', 'Propostareceituario', 'Cidade', 'Monitoramentoportatil', 'Controleaplicacao', 'Pessoapropriedade', 'Cooperativa'];

    function PropriedadeDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Propriedade, Georeferenciamento, Concentracaoidealatributo, Pesquisa, Aquisicao, Concentracaoindice, Imagemtermica, Mapaimagem, Propostareceituario, Cidade, Monitoramentoportatil, Controleaplicacao, Pessoapropriedade, Cooperativa) {
        var vm = this;

        vm.propriedade = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('netWordAgroApp:propriedadeUpdate', function(event, result) {
            vm.propriedade = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PropriedadeDeleteController',PropriedadeDeleteController);

    PropriedadeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Propriedade'];

    function PropriedadeDeleteController($uibModalInstance, entity, Propriedade) {
        var vm = this;

        vm.propriedade = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Propriedade.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('propriedade', {
            parent: 'entity',
            url: '/propriedade',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.propriedade.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/propriedade/propriedades.html',
                    controller: 'PropriedadeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('propriedade');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('propriedade-detail', {
            parent: 'propriedade',
            url: '/propriedade/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.propriedade.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/propriedade/propriedade-detail.html',
                    controller: 'PropriedadeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('propriedade');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Propriedade', function($stateParams, Propriedade) {
                    return Propriedade.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'propriedade',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('propriedade-detail.edit', {
            parent: 'propriedade-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/propriedade/propriedade-dialog.html',
                    controller: 'PropriedadeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Propriedade', function(Propriedade) {
                            return Propriedade.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('propriedade.new', {
            parent: 'propriedade',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/propriedade/propriedade-dialog.html',
                    controller: 'PropriedadeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nomepropriedade: null,
                                tamanhopropriedade: null,
                                responsavelpropriedade: null,
                                emailpropriedade: null,
                                telefonepropriedade: null,
                                cpfproprietario: null,
                                cnpjpropriedade: null,
                                imagempropriedade: null,
                                imagempropriedadeContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('propriedade', null, { reload: 'propriedade' });
                }, function() {
                    $state.go('propriedade');
                });
            }]
        })
        .state('propriedade.edit', {
            parent: 'propriedade',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/propriedade/propriedade-dialog.html',
                    controller: 'PropriedadeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Propriedade', function(Propriedade) {
                            return Propriedade.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('propriedade', null, { reload: 'propriedade' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('propriedade.delete', {
            parent: 'propriedade',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/propriedade/propriedade-delete-dialog.html',
                    controller: 'PropriedadeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Propriedade', function(Propriedade) {
                            return Propriedade.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('propriedade', null, { reload: 'propriedade' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Propriedade', Propriedade);

    Propriedade.$inject = ['$resource'];

    function Propriedade ($resource) {
        var resourceUrl =  'api/propriedades/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'queryNomesPropriedades': { 
                url: '/api/propriedades/nomesPropriedades',
                method: 'GET', 
                isArray: true},
            'queryPropriedadesAssociadas': { 
                url: '/api/propriedades/propassociadas/:idpessoa', 
                method: 'GET', 
                isArray: true},
            'queryPropriedadesCooperativa': { 
                url: '/api/propriedades/cooperativa/:idcooperativa',
                method: 'GET', 
                isArray: true},
            'queryPropriedadesParceiros': { 
                url: '/api/propriedadesParceiros/',
                method: 'GET', 
                isArray: true},
            'queryNomesPropriedadeParceiros': { 
                url: '/api/propriedades/nomesPropriedadesParceiros',
                method: 'GET', 
                isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('PropriedadeSearch', PropriedadeSearch);

    PropriedadeSearch.$inject = ['$resource'];

    function PropriedadeSearch($resource) {
        var resourceUrl =  'api/_search/propriedades/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PropriedadeController', PropriedadeController);

    PropriedadeController.$inject = ['DataUtils', 'Propriedade', 'PropriedadeSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function PropriedadeController(DataUtils, Propriedade, PropriedadeSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.propriedades = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                PropriedadeSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Propriedade.queryPropriedadesParceiros({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.propriedades.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.propriedades = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.propriedades = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.propriedades = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PropostareceituarioVisualizacaoController', PropostareceituarioVisualizacaoController);

    PropostareceituarioVisualizacaoController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'Propostareceituario', 'Propriedade', 'Safra', 'Atributo', 'Concentracaoidealatributo', 'Concentracaoindice', 'Imagemtermica', 'Mapaimagem', 'Receituario', 'ParseLinks', 'AlertService'];

    function PropostareceituarioVisualizacaoController($scope, $rootScope, $stateParams, previousState, Propostareceituario, Propriedade, Safra, Atributo, Concentracaoidealatributo, Concentracaoindice, Imagemtermica, Mapaimagem, Receituario, ParseLinks, AlertService) {
        var vm = this;
        vm.propostas = [];
        vm.idmapa = $stateParams.idmapa;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.itemsPerPage = 10000;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.fileURL;
        vm.carregando=true;
        vm.primeira = true;
        vm.loadMapa = loadMapa;

        loadMapa();
        loadAll();

        function loadMapa(){

           

            Propostareceituario.queryMapa({
                idmapa: parseInt(vm.idmapa)
            }, sucessoMapa, erroMapa);

            function sucessoMapa(data){


                var conteudo = data[0];
                var imagemContentType =conteudo.imagempequenaContentType;
                var imagem = conteudo.imagempequena;
                vm.fileURL = 'data:' + imagemContentType +';base64,' + imagem;
                vm.carregando = false;
                console.log("Imagem lida com sucesso");
                
            }

            function erroMapa(){
                console.log("Erro na leitura do mapa");
            }

        }

        
       


        function loadAll () {    
            

            if (vm.currentSearch) {
                Propostareceituario.queryPropostaByMapa({
                    idmapa: parseInt(vm.idmapa),
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Propostareceituario.queryPropostaByMapa({
                    idmapa:  parseInt(vm.idmapa),
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
        


            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.propostas.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

            
        }

        function reset () {
            vm.page = 0;
            vm.propostas = [];
            loadAll();
        }

        function loadPage(page) {
            console.log("infinite");
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.propostas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.propostas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }


        
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PropostareceituarioDialogController', PropostareceituarioDialogController);

    PropostareceituarioDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Propostareceituario', 'Propriedade', 'Safra', 'Atributo', 'Concentracaoidealatributo', 'Concentracaoindice', 'Imagemtermica', 'Mapaimagem', 'Receituario', 'Principal'];

    function PropostareceituarioDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Propostareceituario, Propriedade, Safra, Atributo, Concentracaoidealatributo, Concentracaoindice, Imagemtermica, Mapaimagem, Receituario, Principal) {
        var vm = this;

        vm.propostareceituario = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.propriedades = Propriedade.query();
        vm.safras = Safra.query();
        vm.atributos = Atributo.query();
        vm.concentracaoidealatributos = Concentracaoidealatributo.query();
        vm.concentracaoindices = Concentracaoindice.query();
        vm.imagemtermicas = Imagemtermica.query();
        vm.mapaimagems = Mapaimagem.query();
        vm.receituarios = Receituario.query();
        vm.propostanova = new Propostareceituario();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.propostareceituario.id !== null) {
                Propostareceituario.update(vm.propostareceituario, onSaveSuccess, onSaveError);
            } else {
                Propostareceituario.save(vm.propostareceituario, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:propostareceituarioUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.data = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PropostareceituarioDetailController', PropostareceituarioDetailController);

    PropostareceituarioDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Propostareceituario', 'Propriedade', 'Safra', 'Atributo', 'Concentracaoidealatributo', 'Concentracaoindice', 'Imagemtermica', 'Mapaimagem', 'Receituario'];

    function PropostareceituarioDetailController($scope, $rootScope, $stateParams, previousState, entity, Propostareceituario, Propriedade, Safra, Atributo, Concentracaoidealatributo, Concentracaoindice, Imagemtermica, Mapaimagem, Receituario) {
        var vm = this;

        vm.propostareceituario = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:propostareceituarioUpdate', function(event, result) {
            vm.propostareceituario = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PropostareceituarioDeleteController',PropostareceituarioDeleteController);

    PropostareceituarioDeleteController.$inject = ['$uibModalInstance', 'entity', 'Propostareceituario'];

    function PropostareceituarioDeleteController($uibModalInstance, entity, Propostareceituario) {
        var vm = this;

        vm.propostareceituario = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Propostareceituario.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PropostareceituarioAprovarDialogController', PropostareceituarioAprovarDialogController);

    PropostareceituarioAprovarDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Propostareceituario', 'Propriedade', 'Safra', 'Atributo', 'Concentracaoidealatributo', 'Concentracaoindice', 'Imagemtermica', 'Mapaimagem', 'Receituario', 'Atividade', 'Quadrantesolo'];

    function PropostareceituarioAprovarDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Propostareceituario, Propriedade, Safra, Atributo, Concentracaoidealatributo, Concentracaoindice, Imagemtermica, Mapaimagem, Receituario, Atividade, Quadrantesolo) {
        var vm = this;
        vm.propostareceituario = entity;
        vm.clear = clear;
        vm.onSaveError = onSaveError;
        vm.onSaveSuccess = onSaveSuccess;
        vm.aprovacao = aprovacao;
        vm.atividades = Atividade.query();
        vm.receituario = new Receituario();
        vm.separar = separar;

        vm.receituario.quantidade = vm.propostareceituario.quantidadesubstancia;
        vm.receituario.medidaquantidade = 'kg';

        function separar(ponto, indice){
            ponto = ponto.slice(1, -1);
            var vetor = ponto.split(',');
            console.log(vetor[indice]);
            return vetor[indice];
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function aprovacao(id){
            vm.novoReceituario = new Receituario();
            vm.novoReceituario.diagnostico = vm.receituario.diagnostico;
            vm.novoReceituario.produto = vm.receituario.produto;
            vm.novoReceituario.quantidade = vm.receituario.quantidade;
            vm.novoReceituario.medidaquantidade = vm.receituario.medidaquantidade;
            vm.novoReceituario.aplicacao = vm.receituario.aplicacao;
            vm.novoReceituario.posaplicacao = vm.receituario.posaplicacao;
            vm.novoReceituario.propostareceituario = new Propostareceituario();
            vm.novoReceituario.propostareceituario = vm.propostareceituario;
            vm.novoReceituario.latitudeespecifica = vm.separar(vm.propostareceituario.ponto1, 0);
            vm.novoReceituario.longitudeespecifica = vm.separar(vm.propostareceituario.ponto1, 1);
            vm.novoReceituario.atividade = new Atividade();
            vm.novoReceituario.atividade = vm.receituario.atividade;

            console.log(vm.novoReceituario);

            Receituario.save(vm.novoReceituario, onSaveSuccess, onSaveError);
        }
        
        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:propostareceituarioUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('propostareceituario', {
            parent: 'entity',
            url: '/propostareceituario',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.propostareceituario.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/propostareceituario/propostareceituarios.html',
                    controller: 'PropostareceituarioController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('propostareceituario');
                    $translatePartialLoader.addPart('mapaimagem');
                    $translatePartialLoader.addPart('tipoproposta');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('propostareceituario-detail', {
            parent: 'propostareceituario',
            url: '/propostareceituario/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.propostareceituario.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/propostareceituario/propostareceituario-detail.html',
                    controller: 'PropostareceituarioDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('propostareceituario');
                    $translatePartialLoader.addPart('tipoproposta');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Propostareceituario', function($stateParams, Propostareceituario) {
                    return Propostareceituario.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'propostareceituario',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('propostareceituario-detail.edit', {
            parent: 'propostareceituario-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/propostareceituario/propostareceituario-dialog.html',
                    controller: 'PropostareceituarioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Propostareceituario', function(Propostareceituario) {
                            return Propostareceituario.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('propostareceituario.new', {
            parent: 'propostareceituario',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/propostareceituario/propostareceituario-dialog.html',
                    controller: 'PropostareceituarioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                data: null,
                                latitude: null,
                                longitude: null,
                                quantidaderecomendada: null,
                                tipoproposta: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('propostareceituario', null, { reload: 'propostareceituario' });
                }, function() {
                    $state.go('propostareceituario');
                });
            }]
        })
        .state('propostareceituario.delete', {
            parent: 'propostareceituario',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/propostareceituario/propostareceituario-delete-dialog.html',
                    controller: 'PropostareceituarioDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Propostareceituario', function(Propostareceituario) {
                            return Propostareceituario.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('propostareceituario', null, { reload: 'propostareceituario' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('propostareceituario-visualizacao', {
            parent: 'propostareceituario',
            url: '/visualizacao/{idmapa}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.propostareceituario.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/propostareceituario/propostareceituario-visualizacao.html',
                    controller: 'PropostareceituarioVisualizacaoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('propostareceituario');
                    $translatePartialLoader.addPart('tipoproposta');
                    return $translate.refresh();
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'propostareceituario',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('propostareceituario.edit', {
            parent: 'propostareceituario-visualizacao',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/propostareceituario/propostareceituario-dialog.html',
                    controller: 'PropostareceituarioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Propostareceituario', function(Propostareceituario) {
                            return Propostareceituario.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('propostareceituario-visualizacao', '',  { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('propostareceituario.aprovar', {
            parent: 'propostareceituario-visualizacao',
            url: '/{id}/aprovar',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/propostareceituario/propostareceituario-aprovar-dialog.html',
                    controller: 'PropostareceituarioAprovarDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Propostareceituario', function(Propostareceituario) {
                            return Propostareceituario.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^');
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Propostareceituario', Propostareceituario);

    Propostareceituario.$inject = ['$resource', 'DateUtils'];

    function Propostareceituario ($resource, DateUtils) {
        var resourceUrl =  'api/propostareceituarios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'querySemImagem': { 
                url: '/api/mapaimagemssemimagem',
                method: 'GET', 
                isArray: true},
            'queryPropostaByMapa': {
                url: '/api/propostareceituarios/pormapa/:idmapa',
                method: 'GET', 
                isArray: true},
            'queryMapa':{
                url: '/api/mapaimagemsimagempequena/:idmapa',
                method: 'GET', 
                isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.data = DateUtils.convertLocalDateFromServer(data.data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.data = DateUtils.convertLocalDateToServer(copy.data);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.data = DateUtils.convertLocalDateToServer(copy.data);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('PropostareceituarioSearch', PropostareceituarioSearch);

    PropostareceituarioSearch.$inject = ['$resource'];

    function PropostareceituarioSearch($resource) {
        var resourceUrl =  'api/_search/propostareceituarios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PropostareceituarioController', PropostareceituarioController);

    PropostareceituarioController.$inject = ['Propostareceituario', 'PropostareceituarioSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'Mapaimagem'];

    function PropostareceituarioController(Propostareceituario, PropostareceituarioSearch, ParseLinks, AlertService, paginationConstants, Mapaimagem) {

        var vm = this;

        vm.mapaimagems = [];
        vm.mapas = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = 10;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = false;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.propostasPorMapa = {};

        /** 
        vm.propostasquery = Propostareceituario.query({
            page: vm.page,
            size: vm.itemsPerPage,
        });

        vm.mapas = Mapaimagem.query({
            page: vm.page,
            size: vm.itemsPerPage,
        });

        vm.propostasquery.$promise.then(function(data){
            for(var i=0; i<data.length; i++){
                var idMapa = data[i].mapaimagem.id;
                if(idMapa in vm.propostasPorMapa){
                    vm.propostasPorMapa[idMapa].push(data[i]);
                }
                else{
                    vm.propostasPorMapa[idMapa] = [];
                    vm.propostasPorMapa[idMapa].push(data[i]);
                }
            }
        });
       **/


       
        vm.mapas = Mapaimagem.query({
            sort: sort()
        });

        loadAll();
        
        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadAll () {    
            if (vm.currentSearch) {
                Propostareceituario.querySemImagem({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Propostareceituario.querySemImagem({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
        


            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.mapaimagems.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.mapaimagems = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.mapaimagems = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.mapaimagems = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PropagandaDialogController', PropagandaDialogController);

    PropagandaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Propaganda', 'Empresaparceira'];

    function PropagandaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Propaganda, Empresaparceira) {
        var vm = this;

        vm.propaganda = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.empresaparceiras = Empresaparceira.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.propaganda.id !== null) {
                Propaganda.update(vm.propaganda, onSaveSuccess, onSaveError);
            } else {
                Propaganda.save(vm.propaganda, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:propagandaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datainicio = false;
        vm.datePickerOpenStatus.datatermino = false;

        vm.setBanner = function ($file, propaganda) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        propaganda.banner = base64Data;
                        propaganda.bannerContentType = $file.type;
                    });
                });
            }
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PropagandaDetailController', PropagandaDetailController);

    PropagandaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Propaganda', 'Empresaparceira'];

    function PropagandaDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Propaganda, Empresaparceira) {
        var vm = this;

        vm.propaganda = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('netWordAgroApp:propagandaUpdate', function(event, result) {
            vm.propaganda = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PropagandaDeleteController',PropagandaDeleteController);

    PropagandaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Propaganda'];

    function PropagandaDeleteController($uibModalInstance, entity, Propaganda) {
        var vm = this;

        vm.propaganda = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Propaganda.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('propaganda', {
            parent: 'entity',
            url: '/propaganda',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.propaganda.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/propaganda/propagandas.html',
                    controller: 'PropagandaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('propaganda');
                    $translatePartialLoader.addPart('tipoanuncio');
                    $translatePartialLoader.addPart('tipodirecionamento');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('propaganda-detail', {
            parent: 'propaganda',
            url: '/propaganda/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.propaganda.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/propaganda/propaganda-detail.html',
                    controller: 'PropagandaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('propaganda');
                    $translatePartialLoader.addPart('tipoanuncio');
                    $translatePartialLoader.addPart('tipodirecionamento');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Propaganda', function($stateParams, Propaganda) {
                    return Propaganda.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'propaganda',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('propaganda-detail.edit', {
            parent: 'propaganda-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/propaganda/propaganda-dialog.html',
                    controller: 'PropagandaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Propaganda', function(Propaganda) {
                            return Propaganda.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('propaganda.new', {
            parent: 'propaganda',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/propaganda/propaganda-dialog.html',
                    controller: 'PropagandaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                datainicio: null,
                                datatermino: null,
                                valoranuncio: null,
                                banner: null,
                                bannerContentType: null,
                                tipoanuncio: null,
                                link: null,
                                direcionamento: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('propaganda', null, { reload: 'propaganda' });
                }, function() {
                    $state.go('propaganda');
                });
            }]
        })
        .state('propaganda.edit', {
            parent: 'propaganda',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/propaganda/propaganda-dialog.html',
                    controller: 'PropagandaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Propaganda', function(Propaganda) {
                            return Propaganda.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('propaganda', null, { reload: 'propaganda' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('propaganda.delete', {
            parent: 'propaganda',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/propaganda/propaganda-delete-dialog.html',
                    controller: 'PropagandaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Propaganda', function(Propaganda) {
                            return Propaganda.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('propaganda', null, { reload: 'propaganda' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Propaganda', Propaganda);

    Propaganda.$inject = ['$resource', 'DateUtils'];

    function Propaganda ($resource, DateUtils) {
        var resourceUrl =  'api/propagandas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datainicio = DateUtils.convertLocalDateFromServer(data.datainicio);
                        data.datatermino = DateUtils.convertLocalDateFromServer(data.datatermino);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('PropagandaSearch', PropagandaSearch);

    PropagandaSearch.$inject = ['$resource'];

    function PropagandaSearch($resource) {
        var resourceUrl =  'api/_search/propagandas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PropagandaController', PropagandaController);

    PropagandaController.$inject = ['DataUtils', 'Propaganda', 'PropagandaSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function PropagandaController(DataUtils, Propaganda, PropagandaSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.propagandas = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                PropagandaSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Propaganda.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.propagandas.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.propagandas = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.propagandas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.propagandas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ProdutoDialogController', ProdutoDialogController);

    ProdutoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Produto', 'PedidoProduto'];

    function ProdutoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Produto, PedidoProduto) {
        var vm = this;

        vm.produto = entity;
        vm.clear = clear;
        vm.save = save;
        vm.pedidoprodutos = PedidoProduto.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.produto.id !== null) {
                Produto.update(vm.produto, onSaveSuccess, onSaveError);
            } else {
                Produto.save(vm.produto, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:produtoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ProdutoDetailController', ProdutoDetailController);

    ProdutoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Produto', 'Pedidoproduto'];

    function ProdutoDetailController($scope, $rootScope, $stateParams, previousState, entity, Produto, Pedidoproduto) {
        var vm = this;

        vm.produto = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:produtoUpdate', function(event, result) {
            vm.produto = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ProdutoDeleteController',ProdutoDeleteController);

    ProdutoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Produto'];

    function ProdutoDeleteController($uibModalInstance, entity, Produto) {
        var vm = this;

        vm.produto = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Produto.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('produto', {
            parent: 'entity',
            url: '/produto',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.produto.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/produto/produtos.html',
                    controller: 'ProdutoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('produto');
                    $translatePartialLoader.addPart('tipoproduto');
                    $translatePartialLoader.addPart('tipoconsistencia');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('produto-detail', {
            parent: 'produto',
            url: '/produto/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.produto.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/produto/produto-detail.html',
                    controller: 'ProdutoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('produto');
                    $translatePartialLoader.addPart('tipoproduto');
                    $translatePartialLoader.addPart('tipoconsistencia');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Produto', function($stateParams, Produto) {
                    return Produto.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'produto',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('produto-detail.edit', {
            parent: 'produto-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/produto/produto-dialog.html',
                    controller: 'ProdutoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Produto', function(Produto) {
                            return Produto.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('produto.new', {
            parent: 'produto',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/produto/produto-dialog.html',
                    controller: 'ProdutoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nomecomercial: null,
                                tipo: null,
                                principioativo: null,
                                doseminima: null,
                                dosemaxima: null,
                                eficaciapuro: null,
                                eficaciamisturado: null,
                                consistencia: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('produto', null, { reload: 'produto' });
                }, function() {
                    $state.go('produto');
                });
            }]
        })
        .state('produto.edit', {
            parent: 'produto',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/produto/produto-dialog.html',
                    controller: 'ProdutoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Produto', function(Produto) {
                            return Produto.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('produto', null, { reload: 'produto' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('produto.delete', {
            parent: 'produto',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/produto/produto-delete-dialog.html',
                    controller: 'ProdutoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Produto', function(Produto) {
                            return Produto.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('produto', null, { reload: 'produto' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Produto', Produto);

    Produto.$inject = ['$resource'];

    function Produto ($resource) {
        var resourceUrl =  'api/produtos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('ProdutoSearch', ProdutoSearch);

    ProdutoSearch.$inject = ['$resource'];

    function ProdutoSearch($resource) {
        var resourceUrl =  'api/_search/produtos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ProdutoController', ProdutoController);

    ProdutoController.$inject = ['Produto', 'ProdutoSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function ProdutoController(Produto, ProdutoSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.produtos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                ProdutoSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Produto.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.produtos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.produtos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.produtos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.produtos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PreplantiotestemDialogController', PreplantiotestemDialogController);

    PreplantiotestemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Preplantiotestem', 'Etapa', 'Safra', '$q'];

    function PreplantiotestemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Preplantiotestem, Etapa, Safra, $q) {
        var vm = this;

        vm.preplantiotestem = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.etapas = Etapa.query();

        vm.safras = Safra.query({filter: 'preplantiotestem-is-null'});
        $q.all([vm.preplantiotestem.$promise, vm.safras.$promise]).then(function() {
            if (!vm.preplantiotestem.safra || !vm.preplantiotestem.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.preplantiotestem.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "preplantiotestem";
            vm.etapa.safra = vm.preplantiotestem.safra;
            
            if (vm.preplantiotestem.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:preplantiotestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.preplantiotestem.etapa = new Etapa();
            vm.preplantiotestem.etapa = result;
            Preplantiotestem.save(vm.preplantiotestem, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:preplantiotestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.preplantiotestem.etapa = new Etapa();
            vm.preplantiotestem.etapa = result;
            Preplantiotestem.update(vm.preplantiotestem, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:preplantiotestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datainicio = false;
        vm.datePickerOpenStatus.datafim = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PreplantiotestemDetailController', PreplantiotestemDetailController);

    PreplantiotestemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Preplantiotestem', 'Etapa', 'Atividade'];

    function PreplantiotestemDetailController($scope, $rootScope, $stateParams, previousState, entity, Preplantiotestem, Etapa, Atividade) {
        var vm = this;

        vm.preplantiotestem = entity;
        vm.previousState = previousState.name;

        vm.atividades = [];

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.preplantiotestem.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        }

        var unsubscribe = $rootScope.$on('netWordAgroApp:preplantiotestemUpdate', function(event, result) {
            vm.preplantiotestem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PreplantiotestemDeleteController',PreplantiotestemDeleteController);

    PreplantiotestemDeleteController.$inject = ['$uibModalInstance', 'entity', 'Preplantiotestem', 'Etapa'];

    function PreplantiotestemDeleteController($uibModalInstance, entity, Preplantiotestem, Etapa) {
        var vm = this;

        vm.preplantiotestem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Preplantiotestem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    Etapa.delete({id: vm.preplantiotestem.etapa.id},
                        function () {
                            $uibModalInstance.close(true);
                        });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('preplantiotestem', {
            parent: 'entity',
            url: '/preplantiotestem',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.preplantiotestem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/preplantiotestem/preplantiotestems.html',
                    controller: 'PreplantiotestemController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('preplantiotestem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('preplantiotestem-detail', {
            parent: 'preplantiotestem',
            url: '/preplantiotestem/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.preplantiotestem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/preplantiotestem/preplantiotestem-detail.html',
                    controller: 'PreplantiotestemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('preplantiotestem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Preplantiotestem', function($stateParams, Preplantiotestem) {
                    return Preplantiotestem.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'preplantiotestem',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('preplantiotestem-detail.edit', {
            parent: 'preplantiotestem-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/preplantiotestem/preplantiotestem-dialog.html',
                    controller: 'PreplantiotestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Preplantiotestem', function(Preplantiotestem) {
                            return Preplantiotestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('preplantiotestem.new', {
            parent: 'preplantiotestem',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/preplantiotestem/preplantiotestem-dialog.html',
                    controller: 'PreplantiotestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                datainicio: null,
                                datafim: null,
                                descricao: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('preplantiotestem', null, { reload: 'preplantiotestem' });
                }, function() {
                    $state.go('preplantiotestem');
                });
            }]
        })
        .state('preplantiotestem.edit', {
            parent: 'preplantiotestem',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/preplantiotestem/preplantiotestem-dialog.html',
                    controller: 'PreplantiotestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Preplantiotestem', function(Preplantiotestem) {
                            return Preplantiotestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('preplantiotestem', null, { reload: 'preplantiotestem' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('preplantiotestem.delete', {
            parent: 'preplantiotestem',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/preplantiotestem/preplantiotestem-delete-dialog.html',
                    controller: 'PreplantiotestemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Preplantiotestem', function(Preplantiotestem) {
                            return Preplantiotestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('preplantiotestem', null, { reload: 'preplantiotestem' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Preplantiotestem', Preplantiotestem);

    Preplantiotestem.$inject = ['$resource', 'DateUtils'];

    function Preplantiotestem ($resource, DateUtils) {
        var resourceUrl =  'api/preplantiotestems/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datainicio = DateUtils.convertLocalDateFromServer(data.datainicio);
                        data.datafim = DateUtils.convertLocalDateFromServer(data.datafim);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datafim = DateUtils.convertLocalDateToServer(copy.datafim);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datafim = DateUtils.convertLocalDateToServer(copy.datafim);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('PreplantiotestemSearch', PreplantiotestemSearch);

    PreplantiotestemSearch.$inject = ['$resource'];

    function PreplantiotestemSearch($resource) {
        var resourceUrl =  'api/_search/preplantiotestems/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PreplantiotestemController', PreplantiotestemController);

    PreplantiotestemController.$inject = ['Preplantiotestem', 'PreplantiotestemSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function PreplantiotestemController(Preplantiotestem, PreplantiotestemSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.preplantiotestems = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                PreplantiotestemSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Preplantiotestem.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.preplantiotestems.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.preplantiotestems = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.preplantiotestems = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.preplantiotestems = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PreplantioplanDialogController', PreplantioplanDialogController);

    PreplantioplanDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Preplantioplan', 'Safra', 'Etapa', 'Principal'];

    function PreplantioplanDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Preplantioplan, Safra, Etapa, Principal) {
        var vm = this;

        vm.preplantioplan = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.safras = Safra.query({filter: 'preplantioplan-is-null'});

        $q.all([vm.preplantioplan.$promise, vm.safras.$promise]).then(function() {
            if (!vm.preplantioplan.safra || !vm.preplantioplan.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.preplantioplan.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });
        vm.etapas = Etapa.query();

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "preplantioplan";
            vm.etapa.safra = vm.preplantioplan.safra;
            
            if (vm.preplantioplan.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
                Principal.identity().then(function (user) {
                    var data = {
                      user: user
                    };
                    vm.preplantioplan.criador = user.login;
                });
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.preplantioplan.etapa = new Etapa();
            vm.preplantioplan.etapa = result;
            Preplantioplan.save(vm.preplantioplan, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.preplantioplan.etapa = new Etapa();
            vm.preplantioplan.etapa = result;
            Preplantioplan.update(vm.preplantioplan, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:preplantioplanUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datainicio = false;
        vm.datePickerOpenStatus.datatermino = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PreplantioplanDetailController', PreplantioplanDetailController);

    PreplantioplanDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Preplantioplan', 'Safra', 'Etapa', 'Atividade'];

    function PreplantioplanDetailController($scope, $rootScope, $stateParams, previousState, entity, Preplantioplan, Safra, Etapa, Atividade) {
        var vm = this;

        vm.preplantioplan = entity;
        vm.previousState = previousState.name;

        vm.atividades = [];

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.preplantioplan.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        }

        var unsubscribe = $rootScope.$on('netWordAgroApp:preplantioplanUpdate', function(event, result) {
            vm.preplantioplan = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PreplantioplanDeleteController',PreplantioplanDeleteController);

    PreplantioplanDeleteController.$inject = ['$uibModalInstance', 'entity', 'Preplantioplan', 'Etapa'];

    function PreplantioplanDeleteController($uibModalInstance, entity, Preplantioplan, Etapa) {
        var vm = this;

        vm.preplantioplan = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Preplantioplan.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    Etapa.delete({id: vm.preplantioplan.etapa.id},
                        function () {
                            $uibModalInstance.close(true);
                        });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('preplantioplan', {
            parent: 'entity',
            url: '/preplantioplan',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.preplantioplan.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/preplantioplan/preplantioplans.html',
                    controller: 'PreplantioplanController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('preplantioplan');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('preplantioplan-detail', {
            parent: 'preplantioplan',
            url: '/preplantioplan/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.preplantioplan.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/preplantioplan/preplantioplan-detail.html',
                    controller: 'PreplantioplanDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('preplantioplan');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Preplantioplan', function($stateParams, Preplantioplan) {
                    return Preplantioplan.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'preplantioplan',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('preplantioplan-detail.edit', {
            parent: 'preplantioplan-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/preplantioplan/preplantioplan-dialog.html',
                    controller: 'PreplantioplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Preplantioplan', function(Preplantioplan) {
                            return Preplantioplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('preplantioplan.new', {
            parent: 'preplantioplan',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/preplantioplan/preplantioplan-dialog.html',
                    controller: 'PreplantioplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                datainicio: null,
                                datatermino: null,
                                descricaopreplantio: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('preplantioplan', null, { reload: 'preplantioplan' });
                }, function() {
                    $state.go('preplantioplan');
                });
            }]
        })
        .state('preplantioplan.edit', {
            parent: 'preplantioplan',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/preplantioplan/preplantioplan-dialog.html',
                    controller: 'PreplantioplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Preplantioplan', function(Preplantioplan) {
                            return Preplantioplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('preplantioplan', null, { reload: 'preplantioplan' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('preplantioplan.delete', {
            parent: 'preplantioplan',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/preplantioplan/preplantioplan-delete-dialog.html',
                    controller: 'PreplantioplanDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Preplantioplan', function(Preplantioplan) {
                            return Preplantioplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('preplantioplan', null, { reload: 'preplantioplan' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Preplantioplan', Preplantioplan);

    Preplantioplan.$inject = ['$resource', 'DateUtils'];

    function Preplantioplan ($resource, DateUtils) {
        var resourceUrl =  'api/preplantioplans/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datainicio = DateUtils.convertLocalDateFromServer(data.datainicio);
                        data.datatermino = DateUtils.convertLocalDateFromServer(data.datatermino);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('PreplantioplanSearch', PreplantioplanSearch);

    PreplantioplanSearch.$inject = ['$resource'];

    function PreplantioplanSearch($resource) {
        var resourceUrl =  'api/_search/preplantioplans/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PreplantioplanController', PreplantioplanController);

    PreplantioplanController.$inject = ['Preplantioplan', 'PreplantioplanSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function PreplantioplanController(Preplantioplan, PreplantioplanSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.preplantioplans = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                PreplantioplanSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Preplantioplan.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.preplantioplans.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.preplantioplans = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.preplantioplans = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.preplantioplans = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AtividadeDialogController', AtividadeDialogController);

    AtividadeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Atividade', 'Etapa', 'Localarmazenamento', 'Servico', 'Aquisicaoplan', 'Aplicacao', 'Receituario', 'Aquisicao'];

    function AtividadeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Atividade, Etapa, Localarmazenamento, Servico, Aquisicaoplan, Aplicacao, Receituario, Aquisicao) {
        var vm = this;

        vm.atividade = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.etapas = Etapa.query();
        vm.localarmazenamentos = Localarmazenamento.query();
        vm.servicos = Servico.query();
        vm.aquisicaoplans = Aquisicaoplan.query();
        vm.aplicacaos = Aplicacao.query();
        vm.receituarios = Receituario.query();
        vm.aquisicaos = Aquisicao.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.atividade.id !== null) {
                Atividade.update(vm.atividade, onSaveSuccess, onSaveError);
            } else {
                Atividade.save(vm.atividade, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:atividadeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datainicio = false;
        vm.datePickerOpenStatus.datatermino = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PreplantioDialogController', PreplantioDialogController);

    PreplantioDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Preplantio', 'Safra', 'Etapa', 'Principal'];

    function PreplantioDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Preplantio, Safra, Etapa, Principal) {
        var vm = this;

        vm.preplantio = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.safras = Safra.query({filter: 'preplantio-is-null'});
        $q.all([vm.preplantio.$promise, vm.safras.$promise]).then(function() {
            if (!vm.preplantio.safra || !vm.preplantio.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.preplantio.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });
        vm.etapas = Etapa.query();

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "preplantio";
            vm.etapa.safra = vm.preplantio.safra;
            
            if (vm.preplantio.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
                Principal.identity().then(function (user) {
                    var data = {
                      user: user
                    };
                    vm.preplantio.criador = user.login;
                });
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.preplantio.etapa = new Etapa();
            vm.preplantio.etapa = result;
            Preplantio.save(vm.preplantio, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.preplantio.etapa = new Etapa();
            vm.preplantio.etapa = result;
            Preplantio.update(vm.preplantio, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:preplantioUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datainicio = false;
        vm.datePickerOpenStatus.datatermino = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PreplantioDetailController', PreplantioDetailController);

    PreplantioDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Preplantio', 'Safra', 'Etapa', 'Atividade'];

    function PreplantioDetailController($scope, $rootScope, $stateParams, previousState, entity, Preplantio, Safra, Etapa, Atividade) {
        var vm = this;

        vm.preplantio = entity;
        vm.previousState = previousState.name;

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.preplantio.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        }

        var unsubscribe = $rootScope.$on('netWordAgroApp:preplantioUpdate', function(event, result) {
            vm.preplantio = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PreplantioDeleteController',PreplantioDeleteController);

    PreplantioDeleteController.$inject = ['$uibModalInstance', 'entity', 'Preplantio', 'Etapa'];

    function PreplantioDeleteController($uibModalInstance, entity, Preplantio, Etapa) {
        var vm = this;

        vm.preplantio = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Preplantio.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    Etapa.delete({id: vm.preplantio.etapa.id},
                        function () {
                            $uibModalInstance.close(true);
                        });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('preplantio', {
            parent: 'entity',
            url: '/preplantio',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.preplantio.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/preplantio/preplantios.html',
                    controller: 'PreplantioController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('preplantio');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('preplantio-detail', {
            parent: 'preplantio',
            url: '/preplantio/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.preplantio.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/preplantio/preplantio-detail.html',
                    controller: 'PreplantioDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('preplantio');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Preplantio', function($stateParams, Preplantio) {
                    return Preplantio.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'preplantio',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('preplantio-detail.edit', {
            parent: 'preplantio-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/preplantio/preplantio-dialog.html',
                    controller: 'PreplantioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Preplantio', function(Preplantio) {
                            return Preplantio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('preplantio.new', {
            parent: 'preplantio',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/preplantio/preplantio-dialog.html',
                    controller: 'PreplantioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                datainicio: null,
                                datatermino: null,
                                descricaopreplantio: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('preplantio', null, { reload: 'preplantio' });
                }, function() {
                    $state.go('preplantio');
                });
            }]
        })
        .state('preplantio.edit', {
            parent: 'preplantio',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/preplantio/preplantio-dialog.html',
                    controller: 'PreplantioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Preplantio', function(Preplantio) {
                            return Preplantio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('preplantio', null, { reload: 'preplantio' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('preplantio.delete', {
            parent: 'preplantio',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/preplantio/preplantio-delete-dialog.html',
                    controller: 'PreplantioDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Preplantio', function(Preplantio) {
                            return Preplantio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('preplantio', null, { reload: 'preplantio' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Preplantio', Preplantio);

    Preplantio.$inject = ['$resource', 'DateUtils'];

    function Preplantio ($resource, DateUtils) {
        var resourceUrl =  'api/preplantios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datainicio = DateUtils.convertLocalDateFromServer(data.datainicio);
                        data.datatermino = DateUtils.convertLocalDateFromServer(data.datatermino);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('PreplantioSearch', PreplantioSearch);

    PreplantioSearch.$inject = ['$resource'];

    function PreplantioSearch($resource) {
        var resourceUrl =  'api/_search/preplantios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PreplantioController', PreplantioController);

    PreplantioController.$inject = ['Preplantio', 'PreplantioSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function PreplantioController(Preplantio, PreplantioSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.preplantios = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                PreplantioSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Preplantio.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.preplantios.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.preplantios = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.preplantios = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.preplantios = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PontossensoriamentosoloDialogController', PontossensoriamentosoloDialogController);

    PontossensoriamentosoloDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Pontossensoriamentosolo', 'Medicaoatribpesq', 'Quadrantesolo'];

    function PontossensoriamentosoloDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Pontossensoriamentosolo, Medicaoatribpesq, Quadrantesolo) {
        var vm = this;

        vm.pontossensoriamentosolo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.medicaoatribpesqs = Medicaoatribpesq.query();
        vm.quadrantesolos = Quadrantesolo.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.pontossensoriamentosolo.id !== null) {
                Pontossensoriamentosolo.update(vm.pontossensoriamentosolo, onSaveSuccess, onSaveError);
            } else {
                Pontossensoriamentosolo.save(vm.pontossensoriamentosolo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:pontossensoriamentosoloUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PontossensoriamentosoloDetailController', PontossensoriamentosoloDetailController);

    PontossensoriamentosoloDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Pontossensoriamentosolo', 'Medicaoatribpesq', 'Quadrantesolo'];

    function PontossensoriamentosoloDetailController($scope, $rootScope, $stateParams, previousState, entity, Pontossensoriamentosolo, Medicaoatribpesq, Quadrantesolo) {
        var vm = this;

        vm.pontossensoriamentosolo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:pontossensoriamentosoloUpdate', function(event, result) {
            vm.pontossensoriamentosolo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PontossensoriamentosoloDeleteController',PontossensoriamentosoloDeleteController);

    PontossensoriamentosoloDeleteController.$inject = ['$uibModalInstance', 'entity', 'Pontossensoriamentosolo'];

    function PontossensoriamentosoloDeleteController($uibModalInstance, entity, Pontossensoriamentosolo) {
        var vm = this;

        vm.pontossensoriamentosolo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Pontossensoriamentosolo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pontossensoriamentosolo', {
            parent: 'entity',
            url: '/pontossensoriamentosolo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.pontossensoriamentosolo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pontossensoriamentosolo/pontossensoriamentosolos.html',
                    controller: 'PontossensoriamentosoloController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pontossensoriamentosolo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('pontossensoriamentosolo-detail', {
            parent: 'pontossensoriamentosolo',
            url: '/pontossensoriamentosolo/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.pontossensoriamentosolo.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pontossensoriamentosolo/pontossensoriamentosolo-detail.html',
                    controller: 'PontossensoriamentosoloDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pontossensoriamentosolo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Pontossensoriamentosolo', function($stateParams, Pontossensoriamentosolo) {
                    return Pontossensoriamentosolo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'pontossensoriamentosolo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('pontossensoriamentosolo-detail.edit', {
            parent: 'pontossensoriamentosolo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pontossensoriamentosolo/pontossensoriamentosolo-dialog.html',
                    controller: 'PontossensoriamentosoloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Pontossensoriamentosolo', function(Pontossensoriamentosolo) {
                            return Pontossensoriamentosolo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pontossensoriamentosolo.new', {
            parent: 'pontossensoriamentosolo',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pontossensoriamentosolo/pontossensoriamentosolo-dialog.html',
                    controller: 'PontossensoriamentosoloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nomeponto: null,
                                vallatitude: null,
                                vallongitude: null,
                                sensorcolocado: false,
                                testeok: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('pontossensoriamentosolo', null, { reload: 'pontossensoriamentosolo' });
                }, function() {
                    $state.go('pontossensoriamentosolo');
                });
            }]
        })
        .state('pontossensoriamentosolo.edit', {
            parent: 'pontossensoriamentosolo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pontossensoriamentosolo/pontossensoriamentosolo-dialog.html',
                    controller: 'PontossensoriamentosoloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Pontossensoriamentosolo', function(Pontossensoriamentosolo) {
                            return Pontossensoriamentosolo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pontossensoriamentosolo', null, { reload: 'pontossensoriamentosolo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pontossensoriamentosolo.delete', {
            parent: 'pontossensoriamentosolo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pontossensoriamentosolo/pontossensoriamentosolo-delete-dialog.html',
                    controller: 'PontossensoriamentosoloDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Pontossensoriamentosolo', function(Pontossensoriamentosolo) {
                            return Pontossensoriamentosolo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pontossensoriamentosolo', null, { reload: 'pontossensoriamentosolo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Pontossensoriamentosolo', Pontossensoriamentosolo);

    Pontossensoriamentosolo.$inject = ['$resource'];

    function Pontossensoriamentosolo ($resource) {
        var resourceUrl =  'api/pontossensoriamentosolos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('PontossensoriamentosoloSearch', PontossensoriamentosoloSearch);

    PontossensoriamentosoloSearch.$inject = ['$resource'];

    function PontossensoriamentosoloSearch($resource) {
        var resourceUrl =  'api/_search/pontossensoriamentosolos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PontossensoriamentosoloController', PontossensoriamentosoloController);

    PontossensoriamentosoloController.$inject = ['Pontossensoriamentosolo', 'PontossensoriamentosoloSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function PontossensoriamentosoloController(Pontossensoriamentosolo, PontossensoriamentosoloSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.pontossensoriamentosolos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                PontossensoriamentosoloSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Pontossensoriamentosolo.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.pontossensoriamentosolos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.pontossensoriamentosolos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.pontossensoriamentosolos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.pontossensoriamentosolos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PlantiotestemDialogController', PlantiotestemDialogController);

    PlantiotestemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Plantiotestem', 'Etapa', 'Safra', '$q'];

    function PlantiotestemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Plantiotestem, Etapa, Safra, $q) {
        var vm = this;

        vm.plantiotestem = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.etapas = Etapa.query();

        vm.safras = Safra.query({filter: 'plantiotestem-is-null'});
        $q.all([vm.plantiotestem.$promise, vm.safras.$promise]).then(function() {
            if (!vm.plantiotestem.safra || !vm.plantiotestem.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.plantiotestem.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "plantiotestem";
            vm.etapa.safra = vm.plantiotestem.safra;
            
            if (vm.plantiotestem.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:plantiotestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.plantiotestem.etapa = new Etapa();
            vm.plantiotestem.etapa = result;
            Plantiotestem.save(vm.plantiotestem, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:plantiotestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.plantiotestem.etapa = new Etapa();
            vm.plantiotestem.etapa = result;
            Plantiotestem.update(vm.plantiotestem, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:plantiotestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datainicio = false;
        vm.datePickerOpenStatus.datafim = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PlantiotestemDetailController', PlantiotestemDetailController);

    PlantiotestemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Plantiotestem', 'Etapa', 'Atividade'];

    function PlantiotestemDetailController($scope, $rootScope, $stateParams, previousState, entity, Plantiotestem, Etapa, Atividade) {
        var vm = this;

        vm.plantiotestem = entity;
        vm.previousState = previousState.name;

        vm.atividades = [];

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.plantiotestem.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        }


        var unsubscribe = $rootScope.$on('netWordAgroApp:plantiotestemUpdate', function(event, result) {
            vm.plantiotestem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PlantiotestemDeleteController',PlantiotestemDeleteController);

    PlantiotestemDeleteController.$inject = ['$uibModalInstance', 'entity', 'Plantiotestem', 'Etapa'];

    function PlantiotestemDeleteController($uibModalInstance, entity, Plantiotestem, Etapa) {
        var vm = this;

        vm.plantiotestem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Plantiotestem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    Etapa.delete({id: vm.plantiotestem.etapa.id},
                        function () {
                            $uibModalInstance.close(true);
                        });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('plantiotestem', {
            parent: 'entity',
            url: '/plantiotestem',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.plantiotestem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/plantiotestem/plantiotestems.html',
                    controller: 'PlantiotestemController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('plantiotestem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('plantiotestem-detail', {
            parent: 'plantiotestem',
            url: '/plantiotestem/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.plantiotestem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/plantiotestem/plantiotestem-detail.html',
                    controller: 'PlantiotestemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('plantiotestem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Plantiotestem', function($stateParams, Plantiotestem) {
                    return Plantiotestem.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'plantiotestem',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('plantiotestem-detail.edit', {
            parent: 'plantiotestem-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/plantiotestem/plantiotestem-dialog.html',
                    controller: 'PlantiotestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Plantiotestem', function(Plantiotestem) {
                            return Plantiotestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('plantiotestem.new', {
            parent: 'plantiotestem',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/plantiotestem/plantiotestem-dialog.html',
                    controller: 'PlantiotestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                datainicio: null,
                                datafim: null,
                                areaplantada: null,
                                descricaoplantio: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('plantiotestem', null, { reload: 'plantiotestem' });
                }, function() {
                    $state.go('plantiotestem');
                });
            }]
        })
        .state('plantiotestem.edit', {
            parent: 'plantiotestem',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/plantiotestem/plantiotestem-dialog.html',
                    controller: 'PlantiotestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Plantiotestem', function(Plantiotestem) {
                            return Plantiotestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('plantiotestem', null, { reload: 'plantiotestem' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('plantiotestem.delete', {
            parent: 'plantiotestem',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/plantiotestem/plantiotestem-delete-dialog.html',
                    controller: 'PlantiotestemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Plantiotestem', function(Plantiotestem) {
                            return Plantiotestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('plantiotestem', null, { reload: 'plantiotestem' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Plantiotestem', Plantiotestem);

    Plantiotestem.$inject = ['$resource', 'DateUtils'];

    function Plantiotestem ($resource, DateUtils) {
        var resourceUrl =  'api/plantiotestems/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datainicio = DateUtils.convertLocalDateFromServer(data.datainicio);
                        data.datafim = DateUtils.convertLocalDateFromServer(data.datafim);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datafim = DateUtils.convertLocalDateToServer(copy.datafim);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datafim = DateUtils.convertLocalDateToServer(copy.datafim);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('PlantiotestemSearch', PlantiotestemSearch);

    PlantiotestemSearch.$inject = ['$resource'];

    function PlantiotestemSearch($resource) {
        var resourceUrl =  'api/_search/plantiotestems/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PlantiotestemController', PlantiotestemController);

    PlantiotestemController.$inject = ['Plantiotestem', 'PlantiotestemSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function PlantiotestemController(Plantiotestem, PlantiotestemSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.plantiotestems = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                PlantiotestemSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Plantiotestem.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.plantiotestems.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.plantiotestems = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.plantiotestems = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.plantiotestems = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PlantioplanDialogController', PlantioplanDialogController);

    PlantioplanDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Plantioplan', 'Safra', 'Etapa', 'Principal'];

    function PlantioplanDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Plantioplan, Safra, Etapa, Principal) {
        var vm = this;

        vm.plantioplan = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.safras = Safra.query({filter: 'plantioplan-is-null'});
        $q.all([vm.plantioplan.$promise, vm.safras.$promise]).then(function() {
            if (!vm.plantioplan.safra || !vm.plantioplan.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.plantioplan.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });
        vm.etapas = Etapa.query();

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "plantioplan";
            vm.etapa.safra = vm.plantioplan.safra;
            
            if (vm.plantioplan.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
                Principal.identity().then(function (user) {
                    var data = {
                      user: user
                    };
                    vm.plantioplan.criador = user.login;
                });
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.plantioplan.etapa = new Etapa();
            vm.plantioplan.etapa = result;
            Plantioplan.save(vm.plantioplan, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.plantioplan.etapa = new Etapa();
            vm.plantioplan.etapa = result;
            Plantioplan.update(vm.plantioplan, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:plantioplanUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datainicio = false;
        vm.datePickerOpenStatus.datatermino = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PlantioplanDetailController', PlantioplanDetailController);

    PlantioplanDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Plantioplan', 'Safra', 'Etapa', 'Atividade'];

    function PlantioplanDetailController($scope, $rootScope, $stateParams, previousState, entity, Plantioplan, Safra, Etapa, Atividade) {
        var vm = this;

        vm.plantioplan = entity;
        vm.previousState = previousState.name;

        vm.atividades = [];

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.plantioplan.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        }

        var unsubscribe = $rootScope.$on('netWordAgroApp:plantioplanUpdate', function(event, result) {
            vm.plantioplan = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PlantioplanDeleteController',PlantioplanDeleteController);

    PlantioplanDeleteController.$inject = ['$uibModalInstance', 'entity', 'Plantioplan', 'Etapa'];

    function PlantioplanDeleteController($uibModalInstance, entity, Plantioplan, Etapa) {
        var vm = this;

        vm.plantioplan = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Plantioplan.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    Etapa.delete({id: vm.plantioplan.etapa.id},
                        function () {
                            $uibModalInstance.close(true);
                        });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('plantioplan', {
            parent: 'entity',
            url: '/plantioplan',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.plantioplan.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/plantioplan/plantioplans.html',
                    controller: 'PlantioplanController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('plantioplan');
                    $translatePartialLoader.addPart('tipomedidaarea');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('plantioplan-detail', {
            parent: 'plantioplan',
            url: '/plantioplan/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.plantioplan.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/plantioplan/plantioplan-detail.html',
                    controller: 'PlantioplanDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('plantioplan');
                    $translatePartialLoader.addPart('tipomedidaarea');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Plantioplan', function($stateParams, Plantioplan) {
                    return Plantioplan.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'plantioplan',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('plantioplan-detail.edit', {
            parent: 'plantioplan-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/plantioplan/plantioplan-dialog.html',
                    controller: 'PlantioplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Plantioplan', function(Plantioplan) {
                            return Plantioplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('plantioplan.new', {
            parent: 'plantioplan',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/plantioplan/plantioplan-dialog.html',
                    controller: 'PlantioplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                datainicio: null,
                                datatermino: null,
                                areaplantada: null,
                                unidadeareaplantada: null,
                                descricaoplantio: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('plantioplan', null, { reload: 'plantioplan' });
                }, function() {
                    $state.go('plantioplan');
                });
            }]
        })
        .state('plantioplan.edit', {
            parent: 'plantioplan',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/plantioplan/plantioplan-dialog.html',
                    controller: 'PlantioplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Plantioplan', function(Plantioplan) {
                            return Plantioplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('plantioplan', null, { reload: 'plantioplan' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('plantioplan.delete', {
            parent: 'plantioplan',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/plantioplan/plantioplan-delete-dialog.html',
                    controller: 'PlantioplanDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Plantioplan', function(Plantioplan) {
                            return Plantioplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('plantioplan', null, { reload: 'plantioplan' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Plantioplan', Plantioplan);

    Plantioplan.$inject = ['$resource', 'DateUtils'];

    function Plantioplan ($resource, DateUtils) {
        var resourceUrl =  'api/plantioplans/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datainicio = DateUtils.convertLocalDateFromServer(data.datainicio);
                        data.datatermino = DateUtils.convertLocalDateFromServer(data.datatermino);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('PlantioplanSearch', PlantioplanSearch);

    PlantioplanSearch.$inject = ['$resource'];

    function PlantioplanSearch($resource) {
        var resourceUrl =  'api/_search/plantioplans/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PlantioplanController', PlantioplanController);

    PlantioplanController.$inject = ['Plantioplan', 'PlantioplanSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function PlantioplanController(Plantioplan, PlantioplanSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.plantioplans = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                PlantioplanSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Plantioplan.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.plantioplans.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.plantioplans = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.plantioplans = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.plantioplans = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PlantioDialogController', PlantioDialogController);

    PlantioDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Plantio', 'Safra', 'Etapa', 'Principal'];

    function PlantioDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Plantio, Safra, Etapa, Principal) {
        var vm = this;

        vm.plantio = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.safras = Safra.query({filter: 'plantio-is-null'});
        $q.all([vm.plantio.$promise, vm.safras.$promise]).then(function() {
            if (!vm.plantio.safra || !vm.plantio.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.plantio.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });
        vm.etapas = Etapa.query();

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "plantio";
            vm.etapa.safra = vm.plantio.safra;
            
            if (vm.plantio.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
                Principal.identity().then(function (user) {
                    var data = {
                      user: user
                    };
                    vm.plantio.criador = user.login;
                });
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.plantio.etapa = new Etapa();
            vm.plantio.etapa = result;
            Plantio.save(vm.plantio, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.plantio.etapa = new Etapa();
            vm.plantio.etapa = result;
            Plantio.update(vm.plantio, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:plantioUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datainicio = false;
        vm.datePickerOpenStatus.datatermino = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PlantioDetailController', PlantioDetailController);

    PlantioDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Plantio', 'Safra', 'Etapa', 'Atividade'];

    function PlantioDetailController($scope, $rootScope, $stateParams, previousState, entity, Plantio, Safra, Etapa, Atividade) {
        var vm = this;

        vm.plantio = entity;
        vm.previousState = previousState.name;

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.plantio.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        }

        var unsubscribe = $rootScope.$on('netWordAgroApp:plantioUpdate', function(event, result) {
            vm.plantio = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PlantioDeleteController',PlantioDeleteController);

    PlantioDeleteController.$inject = ['$uibModalInstance', 'entity', 'Plantio', 'Etapa'];

    function PlantioDeleteController($uibModalInstance, entity, Plantio, Etapa) {
        var vm = this;

        vm.plantio = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Plantio.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    Etapa.delete({id: vm.plantio.etapa.id},
                        function () {
                            $uibModalInstance.close(true);
                        });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('plantio', {
            parent: 'entity',
            url: '/plantio',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.plantio.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/plantio/plantios.html',
                    controller: 'PlantioController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('plantio');
                    $translatePartialLoader.addPart('tipomedidaarea');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('plantio-detail', {
            parent: 'plantio',
            url: '/plantio/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.plantio.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/plantio/plantio-detail.html',
                    controller: 'PlantioDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('plantio');
                    $translatePartialLoader.addPart('tipomedidaarea');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Plantio', function($stateParams, Plantio) {
                    return Plantio.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'plantio',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('plantio-detail.edit', {
            parent: 'plantio-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/plantio/plantio-dialog.html',
                    controller: 'PlantioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Plantio', function(Plantio) {
                            return Plantio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('plantio.new', {
            parent: 'plantio',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/plantio/plantio-dialog.html',
                    controller: 'PlantioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                datainicio: null,
                                datatermino: null,
                                areaplantada: null,
                                unidademedidaareaplantada: null,
                                descricaoplantio: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('plantio', null, { reload: 'plantio' });
                }, function() {
                    $state.go('plantio');
                });
            }]
        })
        .state('plantio.edit', {
            parent: 'plantio',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/plantio/plantio-dialog.html',
                    controller: 'PlantioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Plantio', function(Plantio) {
                            return Plantio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('plantio', null, { reload: 'plantio' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('plantio.delete', {
            parent: 'plantio',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/plantio/plantio-delete-dialog.html',
                    controller: 'PlantioDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Plantio', function(Plantio) {
                            return Plantio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('plantio', null, { reload: 'plantio' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Plantio', Plantio);

    Plantio.$inject = ['$resource', 'DateUtils'];

    function Plantio ($resource, DateUtils) {
        var resourceUrl =  'api/plantios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datainicio = DateUtils.convertLocalDateFromServer(data.datainicio);
                        data.datatermino = DateUtils.convertLocalDateFromServer(data.datatermino);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('PlantioSearch', PlantioSearch);

    PlantioSearch.$inject = ['$resource'];

    function PlantioSearch($resource) {
        var resourceUrl =  'api/_search/plantios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PlantioController', PlantioController);

    PlantioController.$inject = ['Plantio', 'PlantioSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function PlantioController(Plantio, PlantioSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.plantios = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                PlantioSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Plantio.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.plantios.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.plantios = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.plantios = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.plantios = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PlantacaoDialogController', PlantacaoDialogController);

    PlantacaoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Plantacao'];

    function PlantacaoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Plantacao) {
        var vm = this;

        vm.plantacao = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.plantacao.id !== null) {
                Plantacao.update(vm.plantacao, onSaveSuccess, onSaveError);
            } else {
                Plantacao.save(vm.plantacao, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:plantacaoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PlantacaoDetailController', PlantacaoDetailController);

    PlantacaoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Plantacao'];

    function PlantacaoDetailController($scope, $rootScope, $stateParams, previousState, entity, Plantacao) {
        var vm = this;

        vm.plantacao = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:plantacaoUpdate', function(event, result) {
            vm.plantacao = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PlantacaoDeleteController',PlantacaoDeleteController);

    PlantacaoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Plantacao'];

    function PlantacaoDeleteController($uibModalInstance, entity, Plantacao) {
        var vm = this;

        vm.plantacao = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Plantacao.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('plantacao', {
            parent: 'entity',
            url: '/plantacao',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.plantacao.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/plantacao/plantacaos.html',
                    controller: 'PlantacaoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('plantacao');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('plantacao-detail', {
            parent: 'plantacao',
            url: '/plantacao/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.plantacao.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/plantacao/plantacao-detail.html',
                    controller: 'PlantacaoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('plantacao');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Plantacao', function($stateParams, Plantacao) {
                    return Plantacao.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'plantacao',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('plantacao-detail.edit', {
            parent: 'plantacao-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/plantacao/plantacao-dialog.html',
                    controller: 'PlantacaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Plantacao', function(Plantacao) {
                            return Plantacao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('plantacao.new', {
            parent: 'plantacao',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/plantacao/plantacao-dialog.html',
                    controller: 'PlantacaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('plantacao', null, { reload: 'plantacao' });
                }, function() {
                    $state.go('plantacao');
                });
            }]
        })
        .state('plantacao.edit', {
            parent: 'plantacao',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/plantacao/plantacao-dialog.html',
                    controller: 'PlantacaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Plantacao', function(Plantacao) {
                            return Plantacao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('plantacao', null, { reload: 'plantacao' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('plantacao.delete', {
            parent: 'plantacao',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/plantacao/plantacao-delete-dialog.html',
                    controller: 'PlantacaoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Plantacao', function(Plantacao) {
                            return Plantacao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('plantacao', null, { reload: 'plantacao' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Plantacao', Plantacao);

    Plantacao.$inject = ['$resource'];

    function Plantacao ($resource) {
        var resourceUrl =  'api/plantacaos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('PlantacaoSearch', PlantacaoSearch);

    PlantacaoSearch.$inject = ['$resource'];

    function PlantacaoSearch($resource) {
        var resourceUrl =  'api/_search/plantacaos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PlantacaoController', PlantacaoController);

    PlantacaoController.$inject = ['Plantacao', 'PlantacaoSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function PlantacaoController(Plantacao, PlantacaoSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.plantacaos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                PlantacaoSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Plantacao.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.plantacaos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.plantacaos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.plantacaos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.plantacaos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PessoapropriedadeDialogController', PessoapropriedadeDialogController);

    PessoapropriedadeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Pessoapropriedade', 'Pessoa', 'Propriedade'];

    function PessoapropriedadeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Pessoapropriedade, Pessoa, Propriedade) {
        var vm = this;

        vm.pessoapropriedade = entity;
        vm.clear = clear;
        vm.save = save;
        vm.pessoas = Pessoa.query();
        vm.propriedades = Propriedade.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.pessoapropriedade.id !== null) {
                Pessoapropriedade.update(vm.pessoapropriedade, onSaveSuccess, onSaveError);
            } else {
                Pessoapropriedade.save(vm.pessoapropriedade, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:pessoapropriedadeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PessoapropriedadeDetailController', PessoapropriedadeDetailController);

    PessoapropriedadeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Pessoapropriedade', 'Pessoa', 'Propriedade'];

    function PessoapropriedadeDetailController($scope, $rootScope, $stateParams, previousState, entity, Pessoapropriedade, Pessoa, Propriedade) {
        var vm = this;

        vm.pessoapropriedade = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:pessoapropriedadeUpdate', function(event, result) {
            vm.pessoapropriedade = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PessoapropriedadeDeleteController',PessoapropriedadeDeleteController);

    PessoapropriedadeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Pessoapropriedade'];

    function PessoapropriedadeDeleteController($uibModalInstance, entity, Pessoapropriedade) {
        var vm = this;

        vm.pessoapropriedade = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Pessoapropriedade.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pessoapropriedade', {
            parent: 'entity',
            url: '/pessoapropriedade',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.pessoapropriedade.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pessoapropriedade/pessoapropriedades.html',
                    controller: 'PessoapropriedadeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pessoapropriedade');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('pessoapropriedade-detail', {
            parent: 'pessoapropriedade',
            url: '/pessoapropriedade/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.pessoapropriedade.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pessoapropriedade/pessoapropriedade-detail.html',
                    controller: 'PessoapropriedadeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pessoapropriedade');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Pessoapropriedade', function($stateParams, Pessoapropriedade) {
                    return Pessoapropriedade.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'pessoapropriedade',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('pessoapropriedade-detail.edit', {
            parent: 'pessoapropriedade-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pessoapropriedade/pessoapropriedade-dialog.html',
                    controller: 'PessoapropriedadeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Pessoapropriedade', function(Pessoapropriedade) {
                            return Pessoapropriedade.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pessoapropriedade.new', {
            parent: 'pessoapropriedade',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pessoapropriedade/pessoapropriedade-dialog.html',
                    controller: 'PessoapropriedadeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('pessoapropriedade', null, { reload: 'pessoapropriedade' });
                }, function() {
                    $state.go('pessoapropriedade');
                });
            }]
        })
        .state('pessoapropriedade.edit', {
            parent: 'pessoapropriedade',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pessoapropriedade/pessoapropriedade-dialog.html',
                    controller: 'PessoapropriedadeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Pessoapropriedade', function(Pessoapropriedade) {
                            return Pessoapropriedade.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pessoapropriedade', null, { reload: 'pessoapropriedade' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pessoapropriedade.delete', {
            parent: 'pessoapropriedade',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pessoapropriedade/pessoapropriedade-delete-dialog.html',
                    controller: 'PessoapropriedadeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Pessoapropriedade', function(Pessoapropriedade) {
                            return Pessoapropriedade.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pessoapropriedade', null, { reload: 'pessoapropriedade' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Pessoapropriedade', Pessoapropriedade);

    Pessoapropriedade.$inject = ['$resource'];

    function Pessoapropriedade ($resource) {
        var resourceUrl =  'api/pessoapropriedades/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'queryPPsAssociadas': { 
                url: '/api/pessoapropriedades/associadospessoa/:idpessoa',
                method: 'GET', 
                isArray: true},
            'acao': { 
                url: '/api/pessoapropriedades/conjunto/:acao',
                method: 'POST',
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('PessoapropriedadeSearch', PessoapropriedadeSearch);

    PessoapropriedadeSearch.$inject = ['$resource'];

    function PessoapropriedadeSearch($resource) {
        var resourceUrl =  'api/_search/pessoapropriedades/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PessoapropriedadeController', PessoapropriedadeController);

    PessoapropriedadeController.$inject = ['Pessoapropriedade', 'PessoapropriedadeSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function PessoapropriedadeController(Pessoapropriedade, PessoapropriedadeSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.pessoapropriedades = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                PessoapropriedadeSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Pessoapropriedade.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.pessoapropriedades.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.pessoapropriedades = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.pessoapropriedades = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.pessoapropriedades = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PessoaDialogController', PessoaDialogController);

    PessoaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Pessoa', 'Propriedade', 'User', 'Pessoapropriedade', 'Cooperativa', 'Unidade'];

    function PessoaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Pessoa, Propriedade, User, Pessoapropriedade, Cooperativa, Unidade) {
        var vm = this;

        vm.pessoa = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.checkboxes = {};
        //vm.propriedades = Propriedade.query({
        //    size: 50
        //});

        vm.onSucessoNomes = onSucessoNomes;
        vm.listaNomes = Propriedade.queryNomesPropriedadeParceiros({size: 1000, sort:"nomepropriedade,asc"}, onSucessoNomes);
        
        vm.onSucessoPropriedadesAssociadas = onSucessoPropriedadesAssociadas;
        vm.listaPropriedadesAntigas = null;
        
        vm.onSucessoPPs = onSucessoPPs;
        vm.listaPPs = null;

        vm.unidades = Unidade.query(
            {size:1000}
        );
        vm.Preparo = Preparo;

        vm.propriedades = Propriedade.queryNomesPropriedadeParceiros({
            size:1000, sort:"nomepropriedade,asc"
        }, function(data){
            vm.checkboxes = {};
            for (var index = 0; index < data.length; index++) {
                var id = data[index].id;
                vm.checkboxes[id] = false;
            }

            if(vm.pessoa.id != null){
                console.log("Executando first");
                var idPes = parseInt(vm.pessoa.id);
                Propriedade.queryPropriedadesAssociadas({idpessoa:idPes, size:1000}, vm.onSucessoPropriedadesAssociadas); 
                Pessoapropriedade.queryPPsAssociadas({idpessoa: idPes, size:1000}, vm.onSucessoPPs);
            }
            else{
                vm.pessoa.propriedade = [];
            }
        });

        function onSucessoPropriedadesAssociadas(result){
            vm.listaPropriedadesAntigas = result;
            vm.pessoa.propriedade = result;

            for (var index = 0; index < result.length; index++) {
                const id = result[index].id;
                vm.checkboxes[id] = true;
            }

            console.log(vm.listaPropriedadesAntigas);
            console.log(">>");
            console.log(vm.pessoa.propriedade);
        }
        
        function onSucessoPPs(result){
        	vm.listaPPs = result;
        }

        
        
        vm.cooperativas = null;
        vm.cooperativa = null;
        
        /*
        vm.changeCooperativa = function (){
        	console.log("Cooperativa alterada!");
        	if(vm.cooperativa != ""){
        		console.log(vm.cooperativa);
        		vm.pessoa.propriedade = null;
        		Propriedade.queryPropriedadesCooperativa({idcooperativa: vm.cooperativa}, 
        				function(result){
        					vm.pessoa.propriedade = result;
        	        		console.log(vm.pessoa.propriedade);
        				}
        		);
        	}
        	else{
        		console.log("Não selecionada!");
        	}
        };
        */

        vm.changeUnidade = function (){
            console.log("Unidade alterada!");
        };

        vm.changeCheckbox = function(p){
            if(vm.checkboxes[p.id] == true){
                vm.pessoa.propriedade.push(p);
            }
            else {
                vm.pessoa.propriedade = vm.pessoa.propriedade.filter( function(prop) {return prop.id != p.id;} );
            }
        }
        
        /*Cooperativa.query({size:1000}, onSuccessCooperativas);*/
        	
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSucessoNomes(){
        }

       
        function save () {
            vm.isSaving = true;
            if (vm.pessoa.id !== null) {
                var id_unidade = parseInt(vm.pessoa.unidade);
                vm.pessoa.unidade = new Unidade();
                vm.pessoa.unidade.id = id_unidade;
                Pessoa.update(vm.pessoa, vm.Preparo);
            } else {
                vm.novousuario = new User();
                vm.novousuario.login = vm.pessoa.login;
                vm.novousuario.firstName = vm.pessoa.nome;
                vm.novousuario.lastName = vm.pessoa.sobrenome; 
                vm.novousuario.email = vm.pessoa.email;
                vm.novousuario.authorities = [];
                if(vm.pessoa.cargo == 'proprietario'){
                    vm.novousuario.authorities = ['ROLE_PROPRIETARIO', 'ROLE_USER'];
                }
                else if(vm.pessoa.cargo == 'engagronomo'){
                    vm.novousuario.authorities = ['ROLE_ENGENHEIRO_AGRONOMO', 'ROLE_USER'];
                }
                else if(vm.pessoa.cargo == 'funcadmin'){
                    vm.novousuario.authorities = ['ROLE_FUNC_ADMINISTRATIVO', 'ROLE_USER'];
                }
                else if(vm.pessoa.cargo == 'funcoperac'){
                    vm.novousuario.authorities = ['ROLE_FUNC_OPERACIONAL', 'ROLE_USER'];
                }
                else if(vm.pessoa.cargo == 'gestor'){
                    vm.novousuario.authorities = ['ROLE_GESTOR_PROP', 'ROLE_USER'];
                }
                else if(vm.pessoa.cargo == 'tecnicocampo'){
                    vm.novousuario.authorities = ['ROLE_TECNICO_CAMPO', 'ROLE_USER'];
                }
                else if(vm.pessoa.cargo == 'gestorparceiro'){
                    vm.novousuario.authorities = ['ROLE_GESTOR_PARCEIROS', 'ROLE_USER'];
                }


                if(vm.pessoa.cargo!='cooperado'){
                    User.save(vm.novousuario, onSaveUser);
                }
                else {
                    vm.onSaveUser();
                }
            }
        }

        vm.onSaveUser = onSaveUser;
        vm.quantidadePPs = null;
        vm.onSavePP = onSavePP;
        vm.pessoa_id = null;
        vm.PPsDelete = [];
        vm.PPsUpdate = [];
        vm.PPsCreate = [];

        function onSaveUser(){
            var id_unidade = parseInt(vm.pessoa.unidade);
            vm.pessoa.unidade = new Unidade();
            vm.pessoa.unidade.id = id_unidade;
            Pessoa.save(vm.pessoa, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            vm.pessoa_id = result.id;
            vm.quantidadePPs = vm.pessoa.propriedade.length;
            vm.PPatual = 0;

            if(vm.pessoa.propriedade.length > 0){
                var VetorPPs = [];

                for(var i=0; i<vm.pessoa.propriedade.length; i++){
                    var PP = new Pessoapropriedade();
                    PP.pessoa = new Pessoa();
                    PP.propriedade = new Propriedade();

                    PP.pessoa.id = vm.pessoa_id;
                    PP.propriedade.id = vm.pessoa.propriedade[i].id;

                    VetorPPs.push(PP);
                }

                Pessoapropriedade.acao({acao: "create"}, VetorPPs, vm.onSavePP); 

                $scope.$emit('netWordAgroApp:pessoaUpdate', result);
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
            else{
                $scope.$emit('netWordAgroApp:pessoaUpdate', result);
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
        }

        function onSavePP() { 

        }

        function Preparo(){
            var idPes = parseInt(vm.pessoa.id);
            Propriedade.queryPropriedadesAssociadas({idpessoa:idPes, size:1000}, function (data){
                vm.listaPropriedadesAntigas = data;
                onUpdateSuccess();
            });
        }
        
        function onUpdateSuccess(result){
        	console.log("PPs");
        	console.log(vm.listaPPs);
        	console.log("Props Antigas");
            console.log(vm.listaPropriedadesAntigas);
            console.log("Props atuais");
            console.log(vm.pessoa.propriedade);

            vm.PPsDelete = [];
            
			var sumiu = null;
        	
        	for (var i = 0; i < vm.listaPropriedadesAntigas.length; i++) {
        		
        		var idPropriedadeAnterior = vm.listaPropriedadesAntigas[i].id;
        		sumiu = true;
				
				for (var j = 0;  j < vm.pessoa.propriedade.length; j++) {
					var comparativo = vm.pessoa.propriedade[j].id;
					
					if(idPropriedadeAnterior == comparativo){
						sumiu = false;
						break;
					}	
				}
			
				if(sumiu == true){
					for(var j = 0; j < vm.listaPPs.length; j++){
						var idPropriedade = vm.listaPPs[j].propriedade.id ;
						if(idPropriedade == idPropriedadeAnterior){
                            var temp = new Pessoapropriedade();
                            temp.id = vm.listaPPs[j].id;
							vm.PPsDelete.push(temp);
						}
					}
				}
        	}
        	
            var existia = null;
            vm.PPsUpdate = [];
            vm.PPsCreate = [];
        	
        	for (var i = 0; i < vm.pessoa.propriedade.length; i++) {
        		
        		var idComparativo = vm.pessoa.propriedade[i].id;
        		existia = false;
				
				for (var j = 0;  j < vm.listaPropriedadesAntigas.length; j++) {
					var idPropriedadeAntiga = vm.listaPropriedadesAntigas[j].id;
					
					if(idComparativo == idPropriedadeAntiga){
						existia = true;
						break;
					}	
				}
			
				if(existia == false){
					var novo = new Pessoapropriedade();
					novo.propriedade = new Propriedade();
					novo.pessoa = new Pessoa();
					novo.propriedade.id = idComparativo;
					novo.pessoa.id = vm.pessoa.id;
					vm.PPsCreate.push(novo);
				}
            }
            
            console.log(vm.PPsCreate);
            console.log(vm.PPsDelete);

            if(vm.PPsDelete.length > 0 && vm.PPsCreate.length > 0){
                console.log("Caso1");
                Pessoapropriedade.acao({acao: "delete"}, vm.PPsDelete, function(){
                    console.log("Delete");
                    Pessoapropriedade.acao({acao: "create"}, vm.PPsCreate, function(){
                        console.log("Create");
                        $scope.$emit('netWordAgroApp:pessoaUpdate', result);
                        $uibModalInstance.close(result);
                        vm.isSaving = false;    
                    });
                });
            }
            else if(vm.PPsDelete.length > 0){
                console.log("Caso2");

                Pessoapropriedade.acao({acao: "delete"}, vm.PPsDelete, function(){
                    console.log("Delete");
                    $scope.$emit('netWordAgroApp:pessoaUpdate', result);
                    $uibModalInstance.close(result);
                    vm.isSaving = false;    
                });
            }
            else if(vm.PPsCreate.length > 0){
                console.log("Caso3");

                Pessoapropriedade.acao({acao: "create"}, vm.PPsCreate, function(){
                    console.log("Create");
                    $scope.$emit('netWordAgroApp:pessoaUpdate', result);
                    $uibModalInstance.close(result);
                    vm.isSaving = false;    
                });
            }
            else{
                console.log("Caso4");

                console.log("fechando");
                $scope.$emit('netWordAgroApp:pessoaUpdate', result);
                $uibModalInstance.close(result);
                vm.isSaving = false;  
            }

        	
        	
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setFoto = function ($file, pessoa) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        pessoa.foto = base64Data;
                        pessoa.fotoContentType = $file.type;
                    });
                });
            }
        };
        
        function onSuccessCooperativas(result){
        	vm.cooperativas = result;
        }
        
       

    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PessoaDetailController', PessoaDetailController);

    PessoaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Pessoa', 'Propriedade'];

    function PessoaDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Pessoa, Propriedade) {
        var vm = this;

        vm.pessoa = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('netWordAgroApp:pessoaUpdate', function(event, result) {
            vm.pessoa = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PessoaDeleteController',PessoaDeleteController);

    PessoaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Pessoa', 'Propriedade', 'Pessoapropriedade', 'User'];

    function PessoaDeleteController($uibModalInstance, entity, Pessoa, Propriedade, Pessoapropriedade, User) {
        var vm = this;

        vm.pessoa = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        vm.onSuccess = onSuccess;
        vm.numPropriedades = 0;
        vm.deletar = deletar;
        
        
        vm.id = null;
        vm.login = null;
                
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	
        	vm.id = id;
        	vm.login = vm.pessoa.login;
            Pessoapropriedade.queryPPsAssociadas({idpessoa:id}, onSuccess);
        	
           
        }
        
        function onSuccess(result){
            Pessoapropriedade.acao({acao:"delete"}, result, deletar);   
        }

        function deletar(){
            Pessoa.delete({id: vm.id},
                function () {
                    User.delete({login: vm.login});
                    $uibModalInstance.close(true);
                }
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pessoa', {
            parent: 'entity',
            url: '/pessoa',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.pessoa.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pessoa/pessoas.html',
                    controller: 'PessoaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pessoa');
                    $translatePartialLoader.addPart('tipocargo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('pessoa-detail', {
            parent: 'pessoa',
            url: '/pessoa/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.pessoa.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pessoa/pessoa-detail.html',
                    controller: 'PessoaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pessoa');
                    $translatePartialLoader.addPart('tipocargo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Pessoa', function($stateParams, Pessoa) {
                    return Pessoa.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'pessoa',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('pessoa-detail.edit', {
            parent: 'pessoa-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pessoa/pessoa-dialog.html',
                    controller: 'PessoaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Pessoa', function(Pessoa) {
                            return Pessoa.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pessoa.new', {
            parent: 'pessoa',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pessoa/pessoa-dialog.html',
                    controller: 'PessoaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                sobrenome: null,
                                cpf: null,
                                cargo: null,
                                email: null,
                                foto: null,
                                fotoContentType: null,
                                login: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('pessoa', null, { reload: 'pessoa' });
                }, function() {
                    $state.go('pessoa');
                });
            }]
        })
        .state('pessoa.edit', {
            parent: 'pessoa',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pessoa/pessoa-dialog.html',
                    controller: 'PessoaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Pessoa', function(Pessoa) {
                            return Pessoa.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pessoa', null, { reload: 'pessoa' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pessoa.delete', {
            parent: 'pessoa',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pessoa/pessoa-delete-dialog.html',
                    controller: 'PessoaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Pessoa', function(Pessoa) {
                            return Pessoa.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pessoa', null, { reload: 'pessoa' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Pessoa', Pessoa);

    Pessoa.$inject = ['$resource'];

    function Pessoa ($resource) {
        var resourceUrl =  'api/pessoas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('PessoaSearch', PessoaSearch);

    PessoaSearch.$inject = ['$resource'];

    function PessoaSearch($resource) {
        var resourceUrl =  'api/_search/pessoas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PessoaController', PessoaController);

    PessoaController.$inject = ['DataUtils', 'Pessoa', 'PessoaSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function PessoaController(DataUtils, Pessoa, PessoaSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.pessoas = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        vm.filtrocargo = null;

        vm.changeFiltro = function (){
            console.log("Cargo alterado!");
            console.log(vm.filtrocargo);
            vm.page = 0;
            vm.pessoas = [];
            loadAll();
        };

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                PessoaSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Pessoa.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for(var i = 0; i < data.length; i++) {
                    if(vm.filtrocargo === null || vm.filtrocargo === data[i].cargo){
                        console.log("Added");
                        vm.pessoas.push(data[i]);
                    }
                }

                if(vm.pessoas.length == 0 && vm.page < vm.links['last']){
                    console.log("Vazio");
                    vm.page = vm.page + 1;
                    loadPage(vm.page);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.pessoas = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.pessoas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.pessoas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PesquisaDialogController', PesquisaDialogController);

    PesquisaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Pesquisa', 'Propriedade', 'Cultura', 'Solo', 'Atributopesquisa', 'Matrizsensoriamento', 'Medicaoatriblavoura', 'Medicaoatribpesq'];

    function PesquisaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Pesquisa, Propriedade, Cultura, Solo, Atributopesquisa, Matrizsensoriamento, Medicaoatriblavoura, Medicaoatribpesq) {
        var vm = this;

        vm.pesquisa = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.propriedades = Propriedade.query();
        vm.culturas = Cultura.query();
        vm.solos = Solo.query();
        vm.atributopesquisas = Atributopesquisa.query();
        vm.matrizsensoriamentos = Matrizsensoriamento.query();
        vm.medicaoatriblavouras = Medicaoatriblavoura.query();
        vm.medicaoatribpesqs = Medicaoatribpesq.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.pesquisa.id !== null) {
                Pesquisa.update(vm.pesquisa, onSaveSuccess, onSaveError);
            } else {
                Pesquisa.save(vm.pesquisa, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:pesquisaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datapesquisa = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PesquisaDetailController', PesquisaDetailController);

    PesquisaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Pesquisa', 'Propriedade', 'Cultura', 'Solo', 'Atributopesquisa', 'Matrizsensoriamento', 'Medicaoatriblavoura', 'Medicaoatribpesq'];

    function PesquisaDetailController($scope, $rootScope, $stateParams, previousState, entity, Pesquisa, Propriedade, Cultura, Solo, Atributopesquisa, Matrizsensoriamento, Medicaoatriblavoura, Medicaoatribpesq) {
        var vm = this;

        vm.pesquisa = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:pesquisaUpdate', function(event, result) {
            vm.pesquisa = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PesquisaDeleteController',PesquisaDeleteController);

    PesquisaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Pesquisa'];

    function PesquisaDeleteController($uibModalInstance, entity, Pesquisa) {
        var vm = this;

        vm.pesquisa = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Pesquisa.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pesquisa', {
            parent: 'entity',
            url: '/pesquisa',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.pesquisa.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pesquisa/pesquisas.html',
                    controller: 'PesquisaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pesquisa');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('pesquisa-detail', {
            parent: 'pesquisa',
            url: '/pesquisa/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.pesquisa.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pesquisa/pesquisa-detail.html',
                    controller: 'PesquisaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pesquisa');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Pesquisa', function($stateParams, Pesquisa) {
                    return Pesquisa.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'pesquisa',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('pesquisa-detail.edit', {
            parent: 'pesquisa-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pesquisa/pesquisa-dialog.html',
                    controller: 'PesquisaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Pesquisa', function(Pesquisa) {
                            return Pesquisa.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pesquisa.new', {
            parent: 'pesquisa',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pesquisa/pesquisa-dialog.html',
                    controller: 'PesquisaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nomepesquisa: null,
                                datapesquisa: null,
                                obspesquisa: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('pesquisa', null, { reload: 'pesquisa' });
                }, function() {
                    $state.go('pesquisa');
                });
            }]
        })
        .state('pesquisa.edit', {
            parent: 'pesquisa',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pesquisa/pesquisa-dialog.html',
                    controller: 'PesquisaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Pesquisa', function(Pesquisa) {
                            return Pesquisa.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pesquisa', null, { reload: 'pesquisa' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pesquisa.delete', {
            parent: 'pesquisa',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pesquisa/pesquisa-delete-dialog.html',
                    controller: 'PesquisaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Pesquisa', function(Pesquisa) {
                            return Pesquisa.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pesquisa', null, { reload: 'pesquisa' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Pesquisa', Pesquisa);

    Pesquisa.$inject = ['$resource', 'DateUtils'];

    function Pesquisa ($resource, DateUtils) {
        var resourceUrl =  'api/pesquisas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datapesquisa = DateUtils.convertLocalDateFromServer(data.datapesquisa);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datapesquisa = DateUtils.convertLocalDateToServer(copy.datapesquisa);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datapesquisa = DateUtils.convertLocalDateToServer(copy.datapesquisa);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('PesquisaSearch', PesquisaSearch);

    PesquisaSearch.$inject = ['$resource'];

    function PesquisaSearch($resource) {
        var resourceUrl =  'api/_search/pesquisas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PesquisaController', PesquisaController);

    PesquisaController.$inject = ['Pesquisa', 'PesquisaSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function PesquisaController(Pesquisa, PesquisaSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.pesquisas = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                PesquisaSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Pesquisa.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.pesquisas.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.pesquisas = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.pesquisas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.pesquisas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PedidonutricionalDialogController', PedidonutricionalDialogController);

    PedidonutricionalDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Pedidonutricional', 'Propriedade', 'Safra'];

    function PedidonutricionalDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Pedidonutricional, Propriedade, Safra) {
        var vm = this;

        vm.pedidonutricional = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.propriedades = Propriedade.query();
        vm.safras = Safra.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.pedidonutricional.id !== null) {
                Pedidonutricional.update(vm.pedidonutricional, onSaveSuccess, onSaveError);
            } else {
                Pedidonutricional.save(vm.pedidonutricional, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:pedidonutricionalUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setShapefile = function ($file, pedidonutricional) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        pedidonutricional.shapefile = base64Data;
                        pedidonutricional.shapefileContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PedidonutricionalDetailController', PedidonutricionalDetailController);

    PedidonutricionalDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Pedidonutricional', 'Propriedade', 'Safra'];

    function PedidonutricionalDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Pedidonutricional, Propriedade, Safra) {
        var vm = this;

        vm.pedidonutricional = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('netWordAgroApp:pedidonutricionalUpdate', function(event, result) {
            vm.pedidonutricional = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PedidonutricionalDeleteController',PedidonutricionalDeleteController);

    PedidonutricionalDeleteController.$inject = ['$uibModalInstance', 'entity', 'Pedidonutricional'];

    function PedidonutricionalDeleteController($uibModalInstance, entity, Pedidonutricional) {
        var vm = this;

        vm.pedidonutricional = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Pedidonutricional.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pedidonutricional', {
            parent: 'entity',
            url: '/pedidonutricional',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.pedidonutricional.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pedidonutricional/pedidonutricionals.html',
                    controller: 'PedidonutricionalController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pedidonutricional');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('pedidonutricional-detail', {
            parent: 'pedidonutricional',
            url: '/pedidonutricional/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.pedidonutricional.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pedidonutricional/pedidonutricional-detail.html',
                    controller: 'PedidonutricionalDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pedidonutricional');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Pedidonutricional', function($stateParams, Pedidonutricional) {
                    return Pedidonutricional.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'pedidonutricional',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('pedidonutricional-detail.edit', {
            parent: 'pedidonutricional-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pedidonutricional/pedidonutricional-dialog.html',
                    controller: 'PedidonutricionalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Pedidonutricional', function(Pedidonutricional) {
                            return Pedidonutricional.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pedidonutricional.new', {
            parent: 'pedidonutricional',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pedidonutricional/pedidonutricional-dialog.html',
                    controller: 'PedidonutricionalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                idsmapas: null,
                                formuladocomposto: null,
                                nomeformulado: null,
                                nutriente: null,
                                porcentagemformula: null,
                                porcentagemacrescimo: null,
                                areatotal: null,
                                crea: null,
                                datas: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('pedidonutricional', null, { reload: 'pedidonutricional' });
                }, function() {
                    $state.go('pedidonutricional');
                });
            }]
        })
        .state('pedidonutricional.edit', {
            parent: 'pedidonutricional',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pedidonutricional/pedidonutricional-dialog.html',
                    controller: 'PedidonutricionalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Pedidonutricional', function(Pedidonutricional) {
                            return Pedidonutricional.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pedidonutricional', null, { reload: 'pedidonutricional' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pedido-nutricional-fazer', {
            parent: 'entity',
            url: '/pedido-nutricional-fazer',
            data: {
                authorities: [],
                pageTitle: 'netWordAgroApp.pedido.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pedidonutricional/pedido-nutricional-fazer.html',
                    controller: 'PedidoNutricionalFazerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pedidonutricional');
                    $translatePartialLoader.addPart('pedido');
                    $translatePartialLoader.addPart('mapaimagem');
                    $translatePartialLoader.addPart('tipoimagem');
                    $translatePartialLoader.addPart('tipomapa');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('pedidonutricional.delete', {
            parent: 'pedidonutricional',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pedidonutricional/pedidonutricional-delete-dialog.html',
                    controller: 'PedidonutricionalDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Pedidonutricional', function(Pedidonutricional) {
                            return Pedidonutricional.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pedidonutricional', null, { reload: 'pedidonutricional' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Pedidonutricional', Pedidonutricional);

    Pedidonutricional.$inject = ['$resource'];

    function Pedidonutricional ($resource) {
        var resourceUrl =  'api/pedidonutricionals/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'queryShapefile': { 
                url: '/api/pedidonutricionalshapefile/:pedidoid',
                method: 'GET', 
                isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('PedidonutricionalSearch', PedidonutricionalSearch);

    PedidonutricionalSearch.$inject = ['$resource'];

    function PedidonutricionalSearch($resource) {
        var resourceUrl =  'api/_search/pedidonutricionals/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PedidonutricionalController', PedidonutricionalController);

    PedidonutricionalController.$inject = ['DataUtils', 'Pedidonutricional', 'PedidonutricionalSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function PedidonutricionalController(DataUtils, Pedidonutricional, PedidonutricionalSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.pedidonutricionals = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        vm.b64toBlob = b64toBlob;
        vm.sucessoDownloadShape = sucessoDownloadShape;
        vm.downloadShape = downloadShape;

        loadAll();

        function b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;
          
            var byteCharacters = atob(b64Data);
            var byteArrays = [];
          
            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);
            
                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
            
                var byteArray = new Uint8Array(byteNumbers);
            
                byteArrays.push(byteArray);
            }
          
            var blob = new Blob(byteArrays, {type: contentType});
            return blob;
        }

        function sucessoDownloadShape(data){
            var filename = 'shapefile';
            console.log("SUCESSO");
            var ct = data[0].shapefileContentType;
            var dados = data[0].shapefile;
            
            if(ct === null) {
                alert("Nenhum shapefile associado ao mapa");
                return;
            }

            /*
                element.setAttribute('href', 'data:' + ct + ';base64,' + dados);
                element.setAttribute('download', 'download');
            
                element.style.display = 'none';
                
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            */

           var blob = b64toBlob(dados, ct);

           if(window.navigator.msSaveOrOpenBlob) {
               window.navigator.msSaveBlob(blob, filename);
           }
           else{
               var elem = window.document.createElement('a');
               elem.href = window.URL.createObjectURL(blob);
               elem.download = filename;        
               document.body.appendChild(elem);
               elem.click();        
               document.body.removeChild(elem);
           }
        }

        function downloadShape(id){
            Pedidonutricional.queryShapefile({pedidoid: id}, vm.sucessoDownloadShape);
        }
        

        function loadAll () {
            if (vm.currentSearch) {
                PedidonutricionalSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Pedidonutricional.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.pedidonutricionals.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.pedidonutricionals = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.pedidonutricionals = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.pedidonutricionals = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PedidoNutricionalFazerController', PedidoNutricionalFazerController);

        PedidoNutricionalFazerController.$inject = ['Pedidonutricional', 'Pedido', 'PedidoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'Propriedade', 'Safra', 'Mapaimagem', 'Maquinario', '$translate', 'Atributo'];

    function PedidoNutricionalFazerController(Pedidonutricional, Pedido, PedidoSearch, ParseLinks, AlertService, paginationConstants, Propriedade, Safra, Mapaimagem, Maquinario, $translate, Atributo) {

        var vm = this;

        vm.carregando = false;

        // Vetores auxiliares
        vm.ultimoIndice = null;

        vm.clickTeste = clickTeste;
        function clickTeste(){
            console.log(vm.mapasSelecionados);
        }

        // Preenchimento dos dados
        vm.filtroPropriedade = null;

        vm.propriedades = Propriedade.queryNomesPropriedades({
            size: 1000,
            sort: "nomepropriedade,asc"
        });

        vm.atributos = Atributo.query({
            size: 1000,
            sort: "nomeatributo,asc"
        });

        vm.filtroSafra = null;

        vm.changeFiltroPropriedade = function () {
            vm.mapasSelecionados = [];
            vm.dadosMapas=[]

            vm.safras = vm.filtroPropriedade ?  Safra.querySafrasPorPropriedade({
                idPropriedade: vm.filtroPropriedade.id,
                size: 1000,
                sort: "nomesafra,asc"
            }) : [] ;   
            
        };

        vm.filtroTipoMapa = null;

        // Auxiliares
        vm.ajustaData = ajustaData;
        function ajustaData(dataString){
            var d = new Date(dataString);
            d.setDate(d.getDate()+1);
            d.setHours(0);
            return d;        
        }

        vm.somadia = somadia;
        function somadia(d, valor){
            var n = new Date(d);
            n.setDate(n.getDate() + valor);
            n.setHours(0);
            return n;
        }

        //Confirmação de pedido
        vm.confirmarPedido = confirmarPedido;
        function confirmarPedido(){

            if(vm.filtroPropriedade == null || vm.filtroPropriedade=="" || vm.filtroSafra == null || vm.filtroSafra == "" || vm.filtroAtributo == null || vm.filtroAtributo == ""){
                alert("Preencha os dados básicos!");
                return;
            }

            if(vm.formuladocomposto == null || vm.formuladocomposto=="" || vm.nomeformulado == null || vm.nomeformulado == "" || vm.porcentagemcomposto == null || vm.porcentagemcomposto == "" || vm.porcentagemacrescimo == "" || vm.porcentagemacrescimo == null){
                alert("Preencha os dados do formulado!");
                return;
            }

            if(vm.crea == null || vm.crea=="" || vm.areatotal == null || vm.areatotal == ""){
                alert("Preencha os dados adicionais!");
                return;
            }

            var pedido = new Pedidonutricional();

            pedido.propriedade = new Propriedade();
            pedido.propriedade.id = vm.filtroPropriedade.id;

            pedido.safra = new Safra();
            pedido.safra.id = vm.filtroSafra.id;

            pedido.nutriente = vm.filtroAtributo.nomeatributo;

            pedido.formuladocomposto = vm.formuladocomposto;

            pedido.nomeformulado = vm.nomeformulado;

            pedido.porcentagemformula = vm.porcentagemcomposto.toString().replace(",", ".") + '%';

            pedido.porcentagemacrescimo = vm.porcentagemacrescimo.toString().replace(",", ".") + '%';

            pedido.status = "aguardando";
            
            pedido.crea = vm.crea;

            pedido.areatotal = vm.areatotal;
            
            pedido.datas = new Date();

            Pedidonutricional.save(pedido);

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PedidoProdutoDialogController', PedidoProdutoDialogController);

    PedidoProdutoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PedidoProduto', 'Produto', 'Pedido'];

    function PedidoProdutoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PedidoProduto, Produto, Pedido) {
        var vm = this;

        vm.pedidoProduto = entity;
        vm.clear = clear;
        vm.save = save;
        vm.produtos = Produto.query();
        vm.pedidos = Pedido.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.pedidoProduto.id !== null) {
                PedidoProduto.update(vm.pedidoProduto, onSaveSuccess, onSaveError);
            } else {
                PedidoProduto.save(vm.pedidoProduto, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:pedidoProdutoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PedidoProdutoDetailController', PedidoProdutoDetailController);

    PedidoProdutoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PedidoProduto', 'Produto', 'Pedido'];

    function PedidoProdutoDetailController($scope, $rootScope, $stateParams, previousState, entity, PedidoProduto, Produto, Pedido) {
        var vm = this;

        vm.pedidoProduto = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:pedidoProdutoUpdate', function(event, result) {
            vm.pedidoProduto = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PedidoProdutoDeleteController',PedidoProdutoDeleteController);

    PedidoProdutoDeleteController.$inject = ['$uibModalInstance', 'entity', 'PedidoProduto'];

    function PedidoProdutoDeleteController($uibModalInstance, entity, PedidoProduto) {
        var vm = this;

        vm.pedidoProduto = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PedidoProduto.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pedido-produto', {
            parent: 'entity',
            url: '/pedido-produto',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.pedidoProduto.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pedido-produto/pedido-produtos.html',
                    controller: 'PedidoProdutoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pedidoProduto');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('pedido-produto-detail', {
            parent: 'pedido-produto',
            url: '/pedido-produto/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.pedidoProduto.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pedido-produto/pedido-produto-detail.html',
                    controller: 'PedidoProdutoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pedidoProduto');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PedidoProduto', function($stateParams, PedidoProduto) {
                    return PedidoProduto.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'pedido-produto',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('pedido-produto-detail.edit', {
            parent: 'pedido-produto-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pedido-produto/pedido-produto-dialog.html',
                    controller: 'PedidoProdutoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PedidoProduto', function(PedidoProduto) {
                            return PedidoProduto.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pedido-produto.new', {
            parent: 'pedido-produto',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pedido-produto/pedido-produto-dialog.html',
                    controller: 'PedidoProdutoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dose: null,
                                ordem: null,
                                quantidadetotal: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('pedido-produto', null, { reload: 'pedido-produto' });
                }, function() {
                    $state.go('pedido-produto');
                });
            }]
        })
        .state('pedido-produto.edit', {
            parent: 'pedido-produto',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pedido-produto/pedido-produto-dialog.html',
                    controller: 'PedidoProdutoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PedidoProduto', function(PedidoProduto) {
                            return PedidoProduto.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pedido-produto', null, { reload: 'pedido-produto' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pedido-produto.delete', {
            parent: 'pedido-produto',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pedido-produto/pedido-produto-delete-dialog.html',
                    controller: 'PedidoProdutoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PedidoProduto', function(PedidoProduto) {
                            return PedidoProduto.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pedido-produto', null, { reload: 'pedido-produto' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('PedidoProduto', PedidoProduto);

    PedidoProduto.$inject = ['$resource'];

    function PedidoProduto ($resource) {
        var resourceUrl =  'api/pedido-produtos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'acao': { 
                url: '/api/pedidoprodutos/conjunto/:acao',
                method: 'POST',
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('PedidoProdutoSearch', PedidoProdutoSearch);

    PedidoProdutoSearch.$inject = ['$resource'];

    function PedidoProdutoSearch($resource) {
        var resourceUrl =  'api/_search/pedido-produtos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PedidoProdutoController', PedidoProdutoController);

    PedidoProdutoController.$inject = ['PedidoProduto', 'PedidoProdutoSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function PedidoProdutoController(PedidoProduto, PedidoProdutoSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.pedidoProdutos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                PedidoProdutoSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PedidoProduto.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.pedidoProdutos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.pedidoProdutos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.pedidoProdutos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.pedidoProdutos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PedidoFazerController', PedidoFazerController);

        PedidoFazerController.$inject = ['Pedido', 'PedidoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'Propriedade', 'Safra', 'Mapaimagem', 'Maquinario', '$translate', 'Produto', 'PedidoProduto'];

    function PedidoFazerController(Pedido, PedidoSearch, ParseLinks, AlertService, paginationConstants, Propriedade, Safra, Mapaimagem, Maquinario, $translate, Produto, PedidoProduto) {

        var vm = this;

        vm.carregando = false;

        // Vetores auxiliares
        vm.ultimoIndice = null;

        vm.clickTeste = clickTeste;
        function clickTeste(){
            console.log(vm.mapasSelecionados);
        }

        // Preenchimento dos dados
        vm.filtroPropriedade = null;

        vm.propriedades = Propriedade.queryNomesPropriedades({
            size: 1000,
            sort: "nomepropriedade,asc"
        });

        vm.filtroSafra = null;

        vm.changeFiltroPropriedade = function () {
            
            vm.mapasSelecionados = [];
            vm.dadosMapas=[];

            
            vm.safras = vm.filtroPropriedade ?  Safra.querySafrasPorPropriedade({
                idPropriedade: vm.filtroPropriedade.id,
                size: 1000,
                sort: "nomesafra,asc"
            }) : [] ;   
            
        };

        vm.filtroTipoMapa = null;

        vm.maquinarios = Maquinario.query({
            size:1000,
            sort: "marca,asc"
        });

        // Filtros
        vm.atendeFiltros = atendeFiltros;

        function atendeFiltros(mapa){
            var atendeTodos = true;

            if(vm.filtroPropriedade != null) {
                if(vm.filtroPropriedade.id != mapa.propriedade_id){
                    return false;
                }
            }
            if(vm.filtroSafra != null) {
                if(vm.filtroSafra.id != mapa.safra_id){
                    return false;
                }
            }
            if(vm.filtroTipoMapa != null) {
                if(vm.filtroTipoMapa != mapa.tipomapa){
                    return false;
                }
            }

            if(mapa.tipomapa == 'nutricional'){
                return false;
            }

            if(vm.dataInicioIntervalo != null){
                var dataMapa = vm.ajustaData(mapa.data);
                var dataAntes = vm.somadia(vm.dataInicioIntervalo, -1);
                var dataDepois = vm.somadia(vm.dataInicioIntervalo, +1);
                console.log(dataMapa);
                console.log('>' + dataAntes);
                console.log('>>' + dataDepois);
                if(dataMapa < dataAntes || dataMapa > dataDepois){
                    return false;
                }
            }
            return true;
        }

        vm.aplicarFiltros = aplicarFiltros;

        function aplicarFiltros() {

            if(vm.filtroPropriedade == null){
                alert("Selecione uma propriedade!");
                return;
            }

            if(vm.dataInicioIntervalo == null || vm.dataInicioIntervalo == ""){
                alert("Selecione uma data!");
                return;
            }

            if(vm.filtroTipoMapa == ""){
                vm.filtroTipoMapa = null;
            }
            vm.dadosBaixados = Mapaimagem.querySemImagem({
                size: 3000,
                sort: "data,desc"
            }, vm.onCarregarMapasParaFiltros);
        }

        vm.onCarregarMapasParaFiltros = onCarregarMapasParaFiltros;

        function onCarregarMapasParaFiltros(data){
            vm.dadosMapas = [];

            for(var i = 0; i < data.length; i++){
                
                var estaNaLista = false;
                
                if(data[i].wktNull == true){
                    continue;
                }
                
                for(var j=0; j<vm.mapasSelecionados.length; j++){
                    if(vm.mapasSelecionados[j].id == data[i].id){ // Se o mapa já esta lá
                        estaNaLista = true;
                        break;
                    }
                }
                

                if(!estaNaLista && vm.atendeFiltros(data[i])){
                    vm.dadosMapas.push(data[i]);
                }
            }
            //vm.onCarregarDadosMapas(vm.dadosMapas);
        }

        // Controle do intervalo
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        vm.datePickerOpenStatus.dataInicio = false;
        vm.datePickerOpenStatus.dataFim = false;
        vm.dateformat = "dd/MM/yyyy";


        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.dataInicioIntervalo = null;
        vm.dataFimIntervalo = null;

        vm.teste = function(){
            console.log(vm.dataInicioIntervalo);
        };

        // Mapas da Galeria
        vm.onCarregarDadosMapas = onCarregarDadosMapas;
        vm.dadosMapas = [];
        vm.imagensMapas = [];

        /*
        vm.dadosMapas = Mapaimagem.querySemImagem({
            size: 10,
            sort: "data,desc"
        }, vm.onCarregarDadosMapas);*/

        function onCarregarDadosMapas(data){
            //console.log(data);
            for(var i = 0; i < data.length; i++) {
                var element = data[i];
                var id = element.id;
            }
        }

        //Mapas Selecionados
        vm.mapasSelecionados = [];
        vm.removerMapaSelecionado = removerMapaSelecionado;

        function removerMapaSelecionado(mapa){
            var id = mapa.id;
            
            var vetorTemp = [];

            for (var index = 0; index < vm.mapasSelecionados.length; index++) {
                var element = vm.mapasSelecionados[index];
                if(element.id != id){
                    vetorTemp.push(element);
                }
            }

            vm.mapasSelecionados = vetorTemp;
        
            for(var i=0; i<vm.dadosMapas.length; i++){
                if(vm.dadosMapas[i].id == id){ // Se o mapa já esta lá
                    return;
                }
            }

            if(vm.atendeFiltros(mapa)){
                vm.dadosMapas.push(mapa);
            }
        }


        // Transição (click no mapa)
        vm.adicionarMapasSelecionados = adicionarMapasSelecionados;

        function adicionarMapasSelecionados(mapa){
            vm.carregando = true;
            // Trocar mapa de lista
            var id = mapa.id;
            
            for(var i=0; i<vm.mapasSelecionados.length; i++){
                if(vm.mapasSelecionados[i].id == id){ // Se o mapa já esta lá
                    return;
                }
            }

            var vetorTemp = [];

            for (var index = 0; index < vm.dadosMapas.length; index++) {
                var element = vm.dadosMapas[index];
                if(element.id != id){
                    vetorTemp.push(element);
                }
            }

            vm.dadosMapas = vetorTemp;

            vm.mapasSelecionados.push(mapa);

            vm.carregando = false;

        }

        // Auxiliares
        vm.ajustaData = ajustaData;
        function ajustaData(dataString){
            var d = new Date(dataString);
            d.setDate(d.getDate()+1);
            d.setHours(0);
            return d;        
        }

        vm.somadia = somadia;
        function somadia(d, valor){
            var n = new Date(d);
            n.setDate(n.getDate() + valor);
            n.setHours(0);
            return n;
        }

        //Confirmação de pedido
        vm.confirmarPedido = confirmarPedido;
        function confirmarPedido(){

            if(vm.vazao == null || vm.vazao==""){
                alert("Preencha a vazão");
                return;
            }

            if(vm.crea == null || vm.crea==""){
                alert("Preencha a CREA");
                return;
            }

            if(vm.nomeengenheiro == null || vm.nomeengenheiro==""){
                alert("Preencha a nome do Engenheiro");
                return;
            }

            if(vm.maquinario == null || vm.maquinario==""){
                alert("Preencha o maquinário correspondente");
                return;
            }
            for(var i=0; i<vm.produtosPedido.length; i++) {
                var elemento = vm.produtosPedido[i];
                if(elemento.produto == null || elemento.produto == ""){
                    alert("Preencha todos os produtos corretamente!");
                    return;
                }
                if(elemento.dose == null || elemento.dose == ""){
                    alert("Preencha a dose corretamente");
                    return;
                }

            }

            var pedido = new Pedido();

            var stringMapas = "";
            pedido.tipos = "";
            for(var i=0; i<vm.mapasSelecionados.length; i++){
                if(i==0){
                    stringMapas = vm.mapasSelecionados[i].id;
                    $translate('netWordAgroApp.Tipomapa.' + vm.mapasSelecionados[i].tipomapa).then(function(t){
                        pedido.tipos = t;
                    });
                }
                else{
                    stringMapas = stringMapas + ',' + vm.mapasSelecionados[i].id;
                    $translate('netWordAgroApp.Tipomapa.' + vm.mapasSelecionados[i].tipomapa).then(function(t){
                        pedido.tipos = pedido.tipos + ' - ' + t;
                    });
                }
            }

            pedido.idsmapas = stringMapas;
            pedido.vazao = vm.vazao.toString().replace(",", ".");
            pedido.maquinario = new Maquinario;
            pedido.maquinario.id = vm.maquinario.id;
            pedido.nomeengenheiro = vm.nomeengenheiro;
            pedido.propriedade = new Propriedade()
            pedido.propriedade.id = vm.mapasSelecionados[0].propriedade_id;
            pedido.safra = new Safra();
            pedido.safra.id = vm.mapasSelecionados[0].safra_id;
            pedido.status = "aguardando";
            pedido.crea = vm.crea;
            pedido.datas = vm.mapasSelecionados[0].data;            
            Pedido.save(pedido, vm.onPedidoSave);
        }

        vm.onPedidoSave = onPedidoSave;
        function onPedidoSave(result){
            var idPedido = result.id;

            for(var i=0; i<vm.produtosPedido.length; i++) {
                vm.produtosPedido[i].pedido = new Pedido();
                vm.produtosPedido[i].pedido.id = idPedido;
            }

            PedidoProduto.acao({acao: "create"}, vm.produtosPedido, vm.onSave); 
        };

        vm.onSave = onSave;
        function onSave(){
            $scope.$emit('netWordAgroApp:pedidoUpdate', result);
        }

        vm.adicionarProduto = adicionarProduto;
        vm.indiceVetor = 0;
        vm.produtos = [];
        vm.produtos[0] = Produto.query({
            sort: "nomecomercial,asc",
            size: 1000
        });

        vm.removerProduto = removerProduto;
        vm.moverProdutoBaixo = moverProdutoBaixo;
        vm.moverProdutoCima = moverProdutoCima;
        vm.produtosPedido = [];

        function adicionarProduto(){
            var ppNovo = new PedidoProduto();
            ppNovo.ordem = vm.indiceVetor + 1;
            vm.indiceVetor = vm.indiceVetor + 1;           
            vm.produtosPedido.push(ppNovo);
            vm.produtos[ppNovo.ordem] = vm.produtos[0];
            console.log(vm.produtosPedido);
        }

        function removerProduto(produto){
            var listaNova = [];
            var ordemRemocao = produto.ordem;

            for(var i=0; i<vm.produtosPedido.length; i++) {
                var elemento = vm.produtosPedido[i];
                if(elemento.ordem == ordemRemocao){
                    continue;
                }
                else if(elemento.ordem != ordemRemocao){
                    if(elemento.ordem > ordemRemocao){
                        elemento.ordem = elemento.ordem - 1;
                    }
                    listaNova.push(elemento);
                }
            }

            vm.produtosPedido = listaNova;
            vm.indiceVetor = vm.indiceVetor - 1;

        }

        function moverProdutoCima(produto){

            if(produto.ordem == 1){
                return;
            }

            var anterior = vm.produtosPedido[produto.ordem-2];
            var atual = vm.produtosPedido[produto.ordem-1];

            vm.produtosPedido[produto.ordem-2] = new PedidoProduto();
            vm.produtosPedido[produto.ordem-1] = new PedidoProduto();

            vm.produtosPedido[produto.ordem-2] = atual;
            vm.produtosPedido[produto.ordem-1] = anterior;

            atual.ordem = atual.ordem - 1;
            anterior.ordem = anterior.ordem + 1;


        }

        function moverProdutoBaixo(produto){

            if(produto.ordem == vm.produtosPedido.length){
                return;
            }

            var posterior = vm.produtosPedido[produto.ordem];
            var atual = vm.produtosPedido[produto.ordem-1];

            vm.produtosPedido[produto.ordem] = new PedidoProduto();
            vm.produtosPedido[produto.ordem-1] = new PedidoProduto();

            vm.produtosPedido[produto.ordem] = atual;
            vm.produtosPedido[produto.ordem-1] = posterior;

            atual.ordem = atual.ordem + 1;
            posterior.ordem = posterior.ordem - 1;

        }

        vm.changeFiltroTipo = function (tipo, ordem) {
            vm.produtos[ordem] = [];
            Produto.query({
                sort: "nomecomercial,asc",
                size: 1000
            }, function (result){
                for (var i=0; i<result.length;i++) {
                    if (result[i].tipo == tipo) {
                        vm.produtos[ordem].push(result[i]);
                    }
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PedidoDialogController', PedidoDialogController);

    PedidoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Pedido', 'Maquinario', 'Safra', 'Propriedade', 'PedidoProduto'];

    function PedidoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Pedido, Maquinario, Safra, Propriedade, PedidoProduto) {
        var vm = this;

        vm.pedido = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.maquinarios = Maquinario.query();
        vm.safras = Safra.query();
        vm.propriedades = Propriedade.query();
        vm.pedidoprodutos = PedidoProduto.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.pedido.id !== null) {
                Pedido.update(vm.pedido, onSaveSuccess, onSaveError);
            } else {
                Pedido.save(vm.pedido, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:pedidoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setShapefile = function ($file, pedido) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        pedido.shapefile = base64Data;
                        pedido.shapefileContentType = $file.type;
                    });
                });
            }
        };

        vm.setReceituario = function ($file, pedido) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        pedido.receituario = base64Data;
                        pedido.receituarioContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PedidoDetailController', PedidoDetailController);

    PedidoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Pedido', 'Maquinario', 'Safra', 'Propriedade'];

    function PedidoDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Pedido, Maquinario, Safra, Propriedade) {
        var vm = this;

        vm.pedido = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('netWordAgroApp:pedidoUpdate', function(event, result) {
            vm.pedido = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PedidoDeleteController',PedidoDeleteController);

    PedidoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Pedido'];

    function PedidoDeleteController($uibModalInstance, entity, Pedido) {
        var vm = this;

        vm.pedido = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Pedido.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pedido', {
            parent: 'entity',
            url: '/pedido',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.pedido.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pedido/pedidos.html',
                    controller: 'PedidoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pedido');
                    $translatePartialLoader.addPart('tipostatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('pedido-detail', {
            parent: 'pedido',
            url: '/pedido/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.pedido.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pedido/pedido-detail.html',
                    controller: 'PedidoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pedido');
                    $translatePartialLoader.addPart('tipostatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Pedido', function($stateParams, Pedido) {
                    return Pedido.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'pedido',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('pedido-detail.edit', {
            parent: 'pedido-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pedido/pedido-dialog.html',
                    controller: 'PedidoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Pedido', function(Pedido) {
                            return Pedido.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pedido.new', {
            parent: 'pedido',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pedido/pedido-dialog.html',
                    controller: 'PedidoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                idsmapas: null,
                                vazao: null,
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('pedido', null, { reload: 'pedido' });
                }, function() {
                    $state.go('pedido');
                });
            }]
        })
        .state('pedido.edit', {
            parent: 'pedido',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pedido/pedido-dialog.html',
                    controller: 'PedidoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Pedido', function(Pedido) {
                            return Pedido.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pedido', null, { reload: 'pedido' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pedido-fazer', {
            parent: 'entity',
            url: '/pedido-fazer',
            data: {
                authorities: [],
                pageTitle: 'netWordAgroApp.pedido.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pedido/pedido-fazer.html',
                    controller: 'PedidoFazerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pedido');
                    $translatePartialLoader.addPart('mapaimagem');
                    $translatePartialLoader.addPart('tipoimagem');
                    $translatePartialLoader.addPart('tipomapa');
                    $translatePartialLoader.addPart('pedidoProduto');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('produto');
                    $translatePartialLoader.addPart('tipoproduto');
                    return $translate.refresh();
                }]
            }
        })
        .state('pedido.delete', {
            parent: 'pedido',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pedido/pedido-delete-dialog.html',
                    controller: 'PedidoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Pedido', function(Pedido) {
                            return Pedido.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pedido', null, { reload: 'pedido' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Pedido', Pedido);

    Pedido.$inject = ['$resource'];

    function Pedido ($resource) {
        var resourceUrl =  'api/pedidos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryShapefile': { 
                url: '/api/pedidoshapefile/:pedidoid',
                method: 'GET', 
                isArray: true},
            'queryReceituario': { 
                url: '/api/pedidoreceituario/:pedidoid',
                method: 'GET', 
                isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('PedidoSearch', PedidoSearch);

    PedidoSearch.$inject = ['$resource'];

    function PedidoSearch($resource) {
        var resourceUrl =  'api/_search/pedidos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PedidoController', PedidoController);

    PedidoController.$inject = ['DataUtils', 'Pedido', 'PedidoSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function PedidoController(DataUtils, Pedido, PedidoSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.pedidos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        vm.b64toBlob = b64toBlob;
        vm.sucessoDownloadShape = sucessoDownloadShape;
        vm.downloadShape = downloadShape;

        vm.downloadReceituario = downloadReceituario;
        vm.sucessoDownloadReceituario = sucessoDownloadReceituario;

        loadAll();

        function b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;
          
            var byteCharacters = atob(b64Data);
            var byteArrays = [];
          
            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);
            
                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
            
                var byteArray = new Uint8Array(byteNumbers);
            
                byteArrays.push(byteArray);
            }
          
            var blob = new Blob(byteArrays, {type: contentType});
            return blob;
        }

        function sucessoDownloadShape(data){
            var filename = 'shapefile';
            console.log("SUCESSO");
            var ct = data[0].shapefileContentType;
            var dados = data[0].shapefile;
            
            if(ct === null) {
                alert("Nenhum shapefile associado ao mapa");
                return;
            }

            /*
                element.setAttribute('href', 'data:' + ct + ';base64,' + dados);
                element.setAttribute('download', 'download');
            
                element.style.display = 'none';
                
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            */

           var blob = b64toBlob(dados, ct);

           if(window.navigator.msSaveOrOpenBlob) {
               window.navigator.msSaveBlob(blob, filename);
           }
           else{
               var elem = window.document.createElement('a');
               elem.href = window.URL.createObjectURL(blob);
               elem.download = filename;        
               document.body.appendChild(elem);
               elem.click();        
               document.body.removeChild(elem);
           }
        }

        function sucessoDownloadReceituario(data){
            var filename = 'receituario';
            console.log("SUCESSO");
            var ct = data[0].receituarioContentType;
            var dados = data[0].receituario;
            
            if(ct === null) {
                alert("Nenhum receituário associado ao mapa");
                return;
            }

            /*
                element.setAttribute('href', 'data:' + ct + ';base64,' + dados);
                element.setAttribute('download', 'download');
            
                element.style.display = 'none';
                
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            */

           var blob = b64toBlob(dados, ct);

           if(window.navigator.msSaveOrOpenBlob) {
               window.navigator.msSaveBlob(blob, filename);
           }
           else{
               var elem = window.document.createElement('a');
               elem.href = window.URL.createObjectURL(blob);
               elem.download = filename;        
               document.body.appendChild(elem);
               elem.click();        
               document.body.removeChild(elem);
           }
        }

        function downloadShape(id){
            Pedido.queryShapefile({pedidoid: id}, vm.sucessoDownloadShape);
        }

        function downloadReceituario(id){
            Pedido.queryReceituario({pedidoid: id}, vm.sucessoDownloadReceituario);
        }

        function loadAll () {
            if (vm.currentSearch) {
                PedidoSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: "id,desc"
                }, onSuccess, onError);
            } else {
                Pedido.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: "id,desc"
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.pedidos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.pedidos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.pedidos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.pedidos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PaisDialogController', PaisDialogController);

    PaisDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Pais', 'Regiao'];

    function PaisDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Pais, Regiao) {
        var vm = this;

        vm.pais = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.regiaos = Regiao.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.pais.id !== null) {
                Pais.update(vm.pais, onSaveSuccess, onSaveError);
            } else {
                Pais.save(vm.pais, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:paisUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setImagempais = function ($file, pais) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        pais.imagempais = base64Data;
                        pais.imagempaisContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PaisDetailController', PaisDetailController);

    PaisDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Pais', 'Regiao'];

    function PaisDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Pais, Regiao) {
        var vm = this;

        vm.pais = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('netWordAgroApp:paisUpdate', function(event, result) {
            vm.pais = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PaisDeleteController',PaisDeleteController);

    PaisDeleteController.$inject = ['$uibModalInstance', 'entity', 'Pais'];

    function PaisDeleteController($uibModalInstance, entity, Pais) {
        var vm = this;

        vm.pais = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Pais.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pais', {
            parent: 'entity',
            url: '/pais',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.pais.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pais/pais.html',
                    controller: 'PaisController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pais');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('pais-detail', {
            parent: 'pais',
            url: '/pais/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.pais.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pais/pais-detail.html',
                    controller: 'PaisDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pais');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Pais', function($stateParams, Pais) {
                    return Pais.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'pais',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('pais-detail.edit', {
            parent: 'pais-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pais/pais-dialog.html',
                    controller: 'PaisDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Pais', function(Pais) {
                            return Pais.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pais.new', {
            parent: 'pais',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pais/pais-dialog.html',
                    controller: 'PaisDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nomepais: null,
                                siglapais: null,
                                imagempais: null,
                                imagempaisContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('pais', null, { reload: 'pais' });
                }, function() {
                    $state.go('pais');
                });
            }]
        })
        .state('pais.edit', {
            parent: 'pais',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pais/pais-dialog.html',
                    controller: 'PaisDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Pais', function(Pais) {
                            return Pais.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pais', null, { reload: 'pais' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pais.delete', {
            parent: 'pais',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pais/pais-delete-dialog.html',
                    controller: 'PaisDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Pais', function(Pais) {
                            return Pais.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pais', null, { reload: 'pais' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Pais', Pais);

    Pais.$inject = ['$resource'];

    function Pais ($resource) {
        var resourceUrl =  'api/pais/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('PaisSearch', PaisSearch);

    PaisSearch.$inject = ['$resource'];

    function PaisSearch($resource) {
        var resourceUrl =  'api/_search/pais/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PaisController', PaisController);

    PaisController.$inject = ['DataUtils', 'Pais', 'PaisSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function PaisController(DataUtils, Pais, PaisSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.pais = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                PaisSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Pais.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.pais.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.pais = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.pais = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.pais = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

  
function getSafra(){
    var $select = $('#selecsafra');
    var safra = $select.val();

    return safra;
}


function montaGrafDespesasPlan(ling){

    var safra = getSafra();
    var etapasplan = ['preplantioplan', 'plantioplan', 'colheitaplan', 'manutencaosafraplan', 'armazenamentosafraplan', 'comercializacaoplan', 'logrecinsumoplan', 'logentregaarmazplan', 'entregasafracomercplan']

    console.log("Inicio");
    var urlJSON = "/api/servicosetapa/" + safra + "?size=1000";

    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) { 

            mes = json.map(function(item) {
                return item.mes;
            });

            ano = json.map(function(item) {
                return item.ano;
            });

            valor = json.map(function(item) {
                return item.valorservico;
            });

            fluxo = json.map(function(item) {
                return item.fluxo;
            });

            tipoetapa = json.map(function(item) {
                return item.tipoetapa;
            });

            console.log(tipoetapa);
            console.log(fluxo);
            console.log(valor);

            var ctx = document.getElementById('grafdespplan').getContext('2d');

            var mapa = new Map();

            var tamanho = tipoetapa.length;
            for(i=0; i<tamanho; i++){

                if(fluxo[i] === 'receita') continue;
                if(etapasplan.indexOf(tipoetapa[i])==-1) continue;

                var label = mes[i] + '/' + ano[i];
                var val = valor[i];


                if(mapa.has(label)===true){
                    var temp = mapa.get(label) + val;
                    mapa.set(label, temp);
                }
                else{
                    mapa.set(label, val);
                }
            }

            var vlabels = []; var vdatas = [];
            var kv;
            for (kv in mapa.entries()) {
                key = kv[0];
                value = kv[1];
                vlabels.push(key);
                vdatas.push(value);
                console.log(key + " = " + value);
            }

            var labelValor; var labelTexto;
            if(ling === "pt"){
                labelValor = "Valor (R$)";
                labelTexto = "Planejamento de Despesas";
            }
            else if(ling === "es"){
                labelValor = "Valor ($)";
                labelTexto = "Planificación de los Gastos";
            }
            else{
                labelValor = "Value ($)";
                labelTexto = "Output Planning";
            } 

            var myLineChart = new Chart(ctx, {
                type: 'line',
                data: {
                labels: vlabels,
                datasets: [{ 
                    data: vdatas,
                    label: labelValor,
                    borderColor: "#ff0000",
                    fill: true
                    }
                ]
                },
                options: {
                title: {
                    display: true,
                    text: labelTexto
                }
                }
            });
        }
    });
}

function montaGrafReceitasPlan(ling){

    var safra = getSafra();
    var etapasplan = ['preplantioplan', 'plantioplan', 'colheitaplan', 'manutencaosafraplan', 'armazenamentosafraplan', 'comercializacaoplan', 'logrecinsumoplan', 'logentregaarmazplan', 'entregasafracomercplan']

    console.log("Inicio");

    var urlJSON = "/api/servicosetapa/" + safra + "?size=1000"

    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            mes = json.map(function(item) {
                return item.mes;
            });

            ano = json.map(function(item) {
                return item.ano;
            });

            valor = json.map(function(item) {
                return item.valorservico;
            });

            fluxo = json.map(function(item) {
                return item.fluxo;
            });

            tipoetapa = json.map(function(item) {
                return item.tipoetapa;
            });

            console.log(tipoetapa);
            console.log(fluxo);
            console.log(valor);

            var ctx = document.getElementById('grafrecplan').getContext('2d');

            var mapa = new Map();

            var tamanho = tipoetapa.length;
            for(i=0; i<tamanho; i++){

                if(fluxo[i] === 'despesa') continue;
                if(etapasplan.indexOf(tipoetapa[i])==-1) continue;

                var label = mes[i] + '/' + ano[i];
                var val = valor[i];


                if(mapa.has(label)===true){
                    var temp = mapa.get(label) + val;
                    mapa.set(label, temp);
                }
                else{
                    mapa.set(label, val);
                }
            }

            var vlabels = []; var vdatas = [];
            var kv;
            for (kv in mapa.entries()) {
                key = kv[0];
                value = kv[1];
                vlabels.push(key);
                vdatas.push(value);
                console.log(key + " = " + value);
            }

            var labelValor; var labelTexto;
            if(ling === "pt"){
                labelValor = "Valor (R$)";
                labelTexto = "Planejamento da Receita";
            }
            else if(ling === "es"){
                labelValor = "Valor ($)";
                labelTexto = "Planificación del Rendimiento";
            }
            else{
                labelValor = "Value ($)";
                labelTexto = "Income Planning";
            } 

            var myLineChart = new Chart(ctx, {
                type: 'line',
                data: {
                labels: vlabels,
                datasets: [{ 
                    data: vdatas,
                    label: labelValor,
                    borderColor: "#43b534",
                    fill: true
                    }
                ]
                },
                options: {
                title: {
                    display: true,
                    text: labelTexto
                }
                }
            });
        }

    });
   
}

function montaGrafDespesasEtapasPlan(ling){
    
    var safra = getSafra();
    var etapasplan = ['preplantioplan', 'plantioplan', 'colheitaplan', 'manutencaosafraplan', 'armazenamentosafraplan', 'comercializacaoplan', 'logrecinsumoplan', 'logentregaarmazplan', 'entregasafracomercplan']

    console.log("Inicio");

    var urlJSON = "/api/servicosetapa/" + safra + "?size=1000"

    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            valor = json.map(function(item) {
                return item.valorservico;
            });

            fluxo = json.map(function(item) {
                return item.fluxo;
            });

            tipoetapa = json.map(function(item) {
                return item.tipoetapa;
            });


            var mapa = new Map();

            var tamanho = tipoetapa.length;
            var vdatas = [0, 0, 0, 0, 0, 0, 0, 0, 0];

            for(i=0; i<tamanho; i++){

                if(fluxo[i] === 'receita') continue;
                if(etapasplan.indexOf(tipoetapa[i])==-1) continue;

                vdatas[etapasplan.indexOf(tipoetapa[i])] += valor[i];
            }

            var ctx = document.getElementById('grafdespetapaplan').getContext('2d');

            var labelValor; var labelTexto; var vlabels; var labelEtapa;
            if(ling === "pt"){
                labelValor = "Valor (R$)";
                labelTexto = "Planejamento das Despesas Por Etapa";
                vlabels = ['Pré-plantio', 'Plantio', 'Colheita', 'Manutenção', 'Armazenamento', 'Comercialização', 'Recebimento de Insumos', 'Entrega para Armazenamento', 'Entrega Para Comercialização'];
                labelEtapa = "Etapa";
            }
            else if(ling === "es"){
                labelValor = "Valor ($)";
                labelTexto = "Planificación de los gastos por Etapa";
                vlabels = ['Pre-siembra', 'Siembra', 'Vendimia', 'Mantenimiento', 'Almacenamiento', 'Comercialización', 'Recebimiento de Consumiveis', 'Entrega para el Almacenamiento', 'Entrega para la Comercialización'];
                labelEtapa = "Etapa";
            }
            else{
                labelValor = "Value ($)";
                labelTexto = "Output Planning By Stage";
                vlabels = ['Pre-planting', 'Planting', 'Ingathering', 'Maintenance', 'Storage', 'Commercialization', 'Inputs Receiving', 'Delivery for Storage', 'Delivery for Commercialization'];
                labelEtapa = "Stage";
            } 

            var chart = new Chart(ctx, {
                type: 'bar',

                data: {
                    labels: vlabels,
                    datasets: [{
                        label: labelValor,
                        backgroundColor: '#42d4f4', 
                        data: vdatas,
                    }]
                },

                // Configuration options go here
                options: {
                    title: {
                        display: true,
                        text: labelTexto
                    },
                    scales: {
                        yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: labelValor
                        },   
                        ticks: {
                            suggestedMin: 0  // minimum will be 0, unless there is a lower value.
                        }
                        }],

                        xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: labelEtapa
                        }
                        }]
                    }     

                }
            });
        }
    });
}

function montaGrafReceitasEtapasPlan(ling){
    
    var safra = getSafra();
    var etapasplan = ['preplantioplan', 'plantioplan', 'colheitaplan', 'manutencaosafraplan', 'armazenamentosafraplan', 'comercializacaoplan', 'logrecinsumoplan', 'logentregaarmazplan', 'entregasafracomercplan']

    console.log("Inicio");

    var urlJSON = "/api/servicosetapa/" + safra + "?size=1000"

    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            valor = json.map(function(item) {
                return item.valorservico;
            });

            fluxo = json.map(function(item) {
                return item.fluxo;
            });

            tipoetapa = json.map(function(item) {
                return item.tipoetapa;
            });


            var mapa = new Map();

            var tamanho = tipoetapa.length;
            var vdatas = [0, 0, 0, 0, 0, 0, 0, 0, 0];

            for(i=0; i<tamanho; i++){

                if(fluxo[i] === 'despesa') continue;
                if(etapasplan.indexOf(tipoetapa[i])==-1) continue;

                vdatas[etapasplan.indexOf(tipoetapa[i])] += valor[i];
            }

            var ctx = document.getElementById('grafrecetapaplan').getContext('2d');

            var labelValor; var labelTexto; var vlabels; var labelEtapa;
            if(ling === "pt"){
                labelValor = "Valor (R$)";
                labelTexto = "Planejamento da Receita Por Etapa";
                vlabels = ['Pré-plantio', 'Plantio', 'Colheita', 'Manutenção', 'Armazenamento', 'Comercialização', 'Recebimento de Insumos', 'Entrega para Armazenamento', 'Entrega Para Comercialização'];
                labelEtapa = "Etapa";
            }
            else if(ling === "es"){
                labelValor = "Valor ($)";
                labelTexto = "Planificación del rendimiento por Etapa";
                vlabels = ['Pre-siembra', 'Siembra', 'Vendimia', 'Mantenimiento', 'Almacenamiento', 'Comercialización', 'Recebimiento de Consumiveis', 'Entrega para el Almacenamiento', 'Entrega para la Comercialización'];
                labelEtapa = "Etapa";
            }
            else{
                labelValor = "Value ($)";
                labelTexto = "Income Planning By Stage";
                vlabels = ['Pre-planting', 'Planting', 'Ingathering', 'Maintenance', 'Storage', 'Commercialization', 'Inputs Receiving', 'Delivery for Storage', 'Delivery for Commercialization'];
                labelEtapa = "Stage";
            } 

            var chart = new Chart(ctx, {
                type: 'bar',

                data: {
                    labels: vlabels,
                    datasets: [{
                        label:labelValor,
                        backgroundColor: '#7d5bb7', 
                        data: vdatas
                    }]
                },

                // Configuration options go here
                options: {
                    title: {
                        display: true,
                        text: labelTexto
                    },

                    scales: {
                        yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: labelValor
                        },   
                        ticks: {
                            suggestedMin: 0  // minimum will be 0, unless there is a lower value.
                        }
                        }],

                        xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: labelEtapa
                        }
                        }]
                    }     

                }
            });

        }
    });
}

function DistribuicaoTerceirizadoPlan(ling){
    var safra = getSafra();
    var etapasplan = ['preplantioplan', 'plantioplan', 'colheitaplan', 'manutencaosafraplan', 'armazenamentosafraplan', 'comercializacaoplan', 'logrecinsumoplan', 'logentregaarmazplan', 'entregasafracomercplan']

    console.log("Inicio");

    var urlJSON = "/api/servicosetapa/" + safra + "?size=1000"

    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            valor = json.map(function(item) {
                return item.valorservico;
            });

            tipoetapa = json.map(function(item) {
                return item.tipoetapa;
            });

            tiporesponsavel = json.map(function(item) {
                return item.tiporesponsavel;
            });


            var totalterc = 0;
            var totalnaoterc = 0;

            var tamanho = tiporesponsavel.length;
            for(i=0; i<tamanho; i++){
                if(etapasplan.indexOf(tipoetapa[i])==-1) continue;
                if(fluxo[i] === 'receita') continue;

                if(tiporesponsavel[i] === 'terceirizado'){
                    totalterc = totalterc + valor[i];
                }
                else{
                    totalnaoterc = totalnaoterc + valor[i];
                }
            }

            var ctx = document.getElementById('grafdistribtercplan').getContext('2d');

            var labelValor; var labelTexto; var vlabels; var lblEtapa;
            if(ling === "pt"){
                labelValor = "Valor (R$)";
                labelTexto = "Distribuição da Terceirização";
                vlabels = ["terceirizado", "não-terceirizado"];
            }
            else if(ling === "es"){
                labelValor = "Valor ($)";
                labelTexto = "Distribución de la Tercerización";
                vlabels = ["Tercerizado", "No-tercerizado"];
            }
            else{
                labelValor = "Value ($)";
                labelTexto = "Outsourcing Distribution";
                vlabels = ["outsourced", "not outsourced"];
            } 

            var chart = new Chart(ctx, {
                type: 'pie',

                data: {
                    labels: vlabels,
                    datasets: [{
                        label: labelValor,
                        backgroundColor: ['#c45307', '#edba97'],
                        data: [totalterc, totalnaoterc]
                    }]
                },

                // Configuration options go here
                options: {
                    title: {
                        display: true,
                        text: labelTexto
                    }               
                }
            });
        }

    });
}

function linguagemplan(){

    $.ajax({
        url:  '/api/account/',
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            var linguagem = json.langKey;

            if(linguagem==="pt-br"){
            montaRelatorioPlan('pt');
            }
            else if(linguagem==="en"){
                montaRelatorioPlan('en');
            }
            else{
                montaRelatorioPlan('es');
            }
        }
    });
}

function montaRelatorioPlan(ling){

    $.ajax({
        url:  '/api/account/',
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {

            if(ling==="pt"){
                $("#titulodespplan").html("Planejamento de Despesas ao Longo do Tempo")
                $("#titulorecplan").html("Planejamento de Receita ao Longo do Tempo")
                $("#titulodespetapaplan").html("Planejamento de Despesa por Etapa")
                $("#titulorecetapaplan").html("Planejamento de Receita por Etapa")
                $("#titulodistribplan").html("Planejamento da Distribuição dos Gastos Por Terceirizados")
            }
            else if(ling=='es'){
                $("#titulodespplan").html("Planificación de los gastos a lo largo del tiempo")
                $("#titulorecplan").html("Planificación del rendimiento a lo largo del tiempo")
                $("#titulodespetapaplan").html("Planificación de los gastos por etapas")
                $("#titulorecetapaplan").html("Planificación del rendimiento por etapas")
                $("#titulodistribplan").html("Planificación de la distribución por tercerización")
            }
            else if(ling=='en'){
                $("#titulodespplan").html("Output Planning Over Time")
                $("#titulorecplan").html("Income Planning Over Time")
                $("#titulodespetapaplan").html("Output Planning By Stage")
                $("#titulorecetapaplan").html("Income Planning By Stage")
                $("#titulodistribplan").html("Distribution of Expenses By Subcontractors")
            }

            montaGrafDespesasPlan(ling);
            montaGrafReceitasPlan(ling);
            montaGrafDespesasEtapasPlan(ling);
            montaGrafReceitasEtapasPlan(ling);
            DistribuicaoTerceirizadoPlan(ling);
        }
    });
   
}
(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PainelDialogController', PainelDialogController);

    PainelDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Painel'];

    function PainelDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Painel) {
        var vm = this;

        vm.painel = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.painel.id !== null) {
                Painel.update(vm.painel, onSaveSuccess, onSaveError);
            } else {
                Painel.save(vm.painel, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:painelUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PainelDetailController', PainelDetailController);

    PainelDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Painel'];

    function PainelDetailController($scope, $rootScope, $stateParams, previousState, entity, Painel) {
        var vm = this;

        vm.painel = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:painelUpdate', function(event, result) {
            vm.painel = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PainelDeleteController',PainelDeleteController);

    PainelDeleteController.$inject = ['$uibModalInstance', 'entity', 'Painel'];

    function PainelDeleteController($uibModalInstance, entity, Painel) {
        var vm = this;

        vm.painel = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Painel.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('painel', {
            parent: 'entity',
            url: '/painel',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.painel.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/painel/painels.html',
                    controller: 'PainelController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('painel');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('painel-en', {
            parent: 'entity',
            url: '/painel-en',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.painel.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/painel/painels-en.html',
                    controller: 'PainelController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('painel');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('painel-es', {
            parent: 'entity',
            url: '/painel-es',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.painel.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/painel/painels-es.html',
                    controller: 'PainelController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('painel');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('painel-detail', {
            parent: 'painel',
            url: '/painel/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.painel.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/painel/painel-detail.html',
                    controller: 'PainelDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('painel');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Painel', function($stateParams, Painel) {
                    return Painel.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'painel',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('painel-detail.edit', {
            parent: 'painel-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/painel/painel-dialog.html',
                    controller: 'PainelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Painel', function(Painel) {
                            return Painel.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('painel.new', {
            parent: 'painel',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/painel/painel-dialog.html',
                    controller: 'PainelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('painel', null, { reload: 'painel' });
                }, function() {
                    $state.go('painel');
                });
            }]
        })
        .state('painel.edit', {
            parent: 'painel',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/painel/painel-dialog.html',
                    controller: 'PainelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Painel', function(Painel) {
                            return Painel.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('painel', null, { reload: 'painel' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('painel.delete', {
            parent: 'painel',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/painel/painel-delete-dialog.html',
                    controller: 'PainelDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Painel', function(Painel) {
                            return Painel.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('painel', null, { reload: 'painel' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Painel', Painel);

    Painel.$inject = ['$resource'];

    function Painel ($resource) {
        var resourceUrl =  'api/painels/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('PainelSearch', PainelSearch);

    PainelSearch.$inject = ['$resource'];

    function PainelSearch($resource) {
        var resourceUrl =  'api/_search/painels/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PainelController', PainelController);

    PainelController.$inject = ['Painel', 'PainelSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function PainelController(Painel, PainelSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.painels = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        //loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                PainelSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Painel.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.painels.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.painels = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.painels = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.painels = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

function getSafra4(){
    var $select = $('#selecsafra4');
    var safra = $select.val();

    return safra;
}

function gaugeProd(ling){

    var safra = getSafra4();

    var urlJSON = "/api/dadosprodutividade/" + safra + "?size=1000";

    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
        
            area = json.map(function(item) {
                return item.area;
            });

            quantidade = json.map(function(item) {
                return item.quantidade;
            });

            var texto;
            if(ling === 'pt'){
                texto = "Produtividade: ";
            }
            else if(ling === 'es'){
                texto = "Productividad: ";
            }
            else{
                texto = "Productivity: ";
            }

            var opts = {
                angle: 0.15, // The span of the gauge arc
                lineWidth: 0.44, // The line thickness
                radiusScale: 1, // Relative radius
                staticLabels: {
                    font: "15px sans-serif",  // Specifies font
                    labels: [0, 50, 70, 120],  // Print labels at these values
                    color: "#000000",  // Optional: Label text color
                    fractionDigits: 0  // Optional: Numerical precision. 0=round off.
                },   
                pointer: {
                    length: 0.6, // // Relative to gauge radius
                    strokeWidth: 0.035, // The thickness
                    color: '#000000' // Fill color
                },
                staticZones: [
                    {strokeStyle: "#F03E3E", min: 0, max: 50}, // Red from 100 to 130
                    {strokeStyle: "#FFDD00", min: 50, max: 70}, // Yellow
                    {strokeStyle: "#30B32D", min: 70, max: 120}, // Green
                ],
                limitMax: false,     // If false, max value increases automatically if value > maxValue
                limitMin: false,     // If true, the min value of the gauge will be fixed
                colorStart: '#6FADCF',   // Colors
                colorStop: '#8FC0DA',    // just experiment with them
                strokeColor: '#E0E0E0',  // to see which ones work best for you
                generateGradient: true,
                highDpiSupport: true,     // High resolution support
                //percentColors: [[0.0, "#ff0000" ], [0.50, "#f9c802"], [1.0, "#00ff00"]]
            };
            var target = document.getElementById('grafprodexec'); // your canvas element
            var gauge = new Gauge(target).setOptions(opts); // create sexy gauge!
            gauge.maxValue = 120; // set max gauge value
            gauge.setMinValue(0);  // Prefer setter over gauge.minValue = 0
            gauge.animationSpeed = 32; // set animation speed (32 is default value)
            gauge.set(quantidade[0]/area[0]); // set actual value
            $("#prodexecvalor").html(texto + quantidade[0]/area[0]);
        }
    });
}

function gaugeProdPlan(ling){

    var safra = getSafra4();

    var urlJSON = "/api/dadosprodutividadeplan/" + safra + "?size=1000";
    
    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            area = json.map(function(item) {
                return item.area;
            });

            quantidade = json.map(function(item) {
                return item.quantidade;
            });

            var texto;
            if(ling === 'pt'){
                texto = "Produtividade: ";
            }
            else if(ling === 'es'){
                texto = "Productividad: ";
            }
            else{
                texto = "Productivity: ";
            }

            var opts = {
                angle: 0.15, // The span of the gauge arc
                lineWidth: 0.44, // The line thickness
                radiusScale: 1, // Relative radius
                staticLabels: {
                    font: "15px sans-serif",  // Specifies font
                    labels: [0, 50, 70, 120],  // Print labels at these values
                    color: "#000000",  // Optional: Label text color
                    fractionDigits: 0  // Optional: Numerical precision. 0=round off.
                },   
                pointer: {
                    length: 0.6, // // Relative to gauge radius
                    strokeWidth: 0.035, // The thickness
                    color: '#000000' // Fill color
                },
                staticZones: [
                    {strokeStyle: "#F03E3E", min: 0, max: 50}, // Red from 100 to 130
                    {strokeStyle: "#FFDD00", min: 50, max: 70}, // Yellow
                    {strokeStyle: "#30B32D", min: 70, max: 120}, // Green
                ],
                limitMax: false,     // If false, max value increases automatically if value > maxValue
                limitMin: false,     // If true, the min value of the gauge will be fixed
                colorStart: '#6FADCF',   // Colors
                colorStop: '#8FC0DA',    // just experiment with them
                strokeColor: '#E0E0E0',  // to see which ones work best for you
                generateGradient: true,
                highDpiSupport: true,     // High resolution support
                //percentColors: [[0.0, "#ff0000" ], [0.50, "#f9c802"], [1.0, "#00ff00"]]
            };
            var target = document.getElementById('grafprodplan'); // your canvas element
            var gauge = new Gauge(target).setOptions(opts); // create sexy gauge!
            gauge.maxValue = 120; // set max gauge value
            gauge.setMinValue(0);  // Prefer setter over gauge.minValue = 0
            gauge.animationSpeed = 32; // set animation speed (32 is default value)
            gauge.set(quantidade[0]/area[0]); // set actual value
            $("#prodplanvalor").html(texto + quantidade[0]/area[0]);
        }
    });

}

function gaugeRentPlan(ling){

    var safra = getSafra4();
    var etapasplan = ['preplantioplan', 'plantioplan', 'colheitaplan', 'manutencaosafraplan', 'armazenamentosafraplan', 'comercializacaoplan', 'logrecinsumoplan', 'logentregaarmazplan', 'entregasafracomercplan']

    var urlJSON1 = "/api/servicosetapa/" + safra + "?size=1000";
    var urlJSON2 = "/api/aquisicaosplan/valor/" + safra + "?size=1000";

    $.ajax({
        url:  urlJSON1,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {

        $.ajax({
            url:  urlJSON2,
            type: 'GET',
            beforeSend: function(xhr) {
                xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
            },
            success: function(json2) {

                fluxo = json.map(function(item) {
                    return item.fluxo;
                });

                valor = json.map(function(item) {
                    return item.valorservico;
                });

                tipoetapa = json.map(function(item) {
                    return item.tipoetapa;
                });
                
                valoraq  = json2.map(function(item) {
                    return item.total;
                });

                var tamanho = tipoetapa.length;
                var total_desp = valoraq[0]; var total_rec = 0;

                for(i=0; i<tamanho; i++){
                    if(etapasplan.indexOf(tipoetapa[i])==-1) continue;

                    if(fluxo[i]==='despesa') total_desp = total_desp + valor[i];
                    else total_rec = total_rec + valor[i];
                }

                var rent = (100.0*total_rec)/total_desp -100.0;
                console.log('>'+total_rec+'>>'+total_desp+'>>>'+rent);

                var texto;
                if(ling === 'pt'){
                    texto = "Rentabilidade: ";
                }
                else if(ling === 'es'){
                    texto = "Rendimiento: ";
                }
                else{
                    texto = "Profitability: ";
                }

                var opts = {
                    angle: 0.15, // The span of the gauge arc
                    lineWidth: 0.44, // The line thickness
                    radiusScale: 1, // Relative radius
                    staticLabels: {
                        font: "15px sans-serif",  // Specifies font
                        labels: [-100, 0, 20, 100],  // Print labels at these values
                        color: "#000000",  // Optional: Label text color
                        fractionDigits: 0  // Optional: Numerical precision. 0=round off.
                    },   
                    pointer: {
                        length: 0.6, // // Relative to gauge radius
                        strokeWidth: 0.035, // The thickness
                        color: '#000000' // Fill color
                    },
                    staticZones: [
                        {strokeStyle: "#F03E3E", min: -100, max: 0}, // Red from 100 to 130
                        {strokeStyle: "#FFDD00", min: 0, max: 20}, // Yellow
                        {strokeStyle: "#30B32D", min: 20, max: 100}, // Green
                    ],
                    limitMax: false,     // If false, max value increases automatically if value > maxValue
                    limitMin: false,     // If true, the min value of the gauge will be fixed
                    colorStart: '#6FADCF',   // Colors
                    colorStop: '#8FC0DA',    // just experiment with them
                    strokeColor: '#E0E0E0',  // to see which ones work best for you
                    generateGradient: true,
                    highDpiSupport: true,     // High resolution support
                    //percentColors: [[0.0, "#ff0000" ], [0.50, "#f9c802"], [1.0, "#00ff00"]]
                };
                var target = document.getElementById('grafrentplan'); // your canvas element
                var gauge = new Gauge(target).setOptions(opts); // create sexy gauge!
                gauge.maxValue = 100; // set max gauge value
                gauge.setMinValue(-100);  // Prefer setter over gauge.minValue = 0
                gauge.animationSpeed = 32; // set animation speed (32 is default value)
                gauge.set(rent); // set actual value
                $("#rentplanvalor").html(texto + Math.round(rent) + "%");
            }
        });
    }
    });

}


function gaugeRent(ling){

    var safra = getSafra4();
    var etapas = ['preplantio', 'plantio', 'colheita', 'manutencaosafra', 'armazenamentosafra', 'comercializacao', 'logrecinsumo', 'logentregaarmaz', 'entregasafracomerc']


    var urlJSON1 = "/api/servicosetapa/" + safra + "?size=1000";
    var urlJSON2 = "/api/aquisicaosplan/valor/" + safra + "?size=1000";

    $.ajax({
        url:  urlJSON1,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {

        $.ajax({
            url:  urlJSON2,
            type: 'GET',
            beforeSend: function(xhr) {
                xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
            },
            success: function(json2) {

                fluxo = json.map(function(item) {
                    return item.fluxo;
                });

                valor = json.map(function(item) {
                    return item.valorservico;
                });

                tipoetapa = json.map(function(item) {
                    return item.tipoetapa;
                });
                
                valoraq  = json2.map(function(item) {
                    return item.total;
                });

                var tamanho = tipoetapa.length;
                var total_desp = valoraq[0]; var total_rec = 0;

                for(i=0; i<tamanho; i++){
                    if(etapas.indexOf(tipoetapa[i])==-1) continue;

                    if(fluxo[i]==='despesa') total_desp = total_desp + valor[i];
                    else total_rec = total_rec + valor[i];
                }

                var rent = (100.0*total_rec)/total_desp -100.0;
                console.log('>'+total_rec+'>>'+total_desp+'>>>'+rent);

                var texto;
                if(ling === 'pt'){
                    texto = "Rentabilidade: ";
                }
                else if(ling === 'es'){
                    texto = "Rendimiento: ";
                }
                else{
                    texto = "Profitability: ";
                }

                var opts = {
                    angle: 0.15, // The span of the gauge arc
                    lineWidth: 0.44, // The line thickness
                    radiusScale: 1, // Relative radius
                    staticLabels: {
                        font: "15px sans-serif",  // Specifies font
                        labels: [-100, 0, 20, 100],  // Print labels at these values
                        color: "#000000",  // Optional: Label text color
                        fractionDigits: 0  // Optional: Numerical precision. 0=round off.
                    },   
                    pointer: {
                        length: 0.6, // // Relative to gauge radius
                        strokeWidth: 0.035, // The thickness
                        color: '#000000' // Fill color
                    },
                    staticZones: [
                        {strokeStyle: "#F03E3E", min: -100, max: 0}, // Red from 100 to 130
                        {strokeStyle: "#FFDD00", min: 0, max: 20}, // Yellow
                        {strokeStyle: "#30B32D", min: 20, max: 100}, // Green
                    ],
                    limitMax: false,     // If false, max value increases automatically if value > maxValue
                    limitMin: false,     // If true, the min value of the gauge will be fixed
                    colorStart: '#6FADCF',   // Colors
                    colorStop: '#8FC0DA',    // just experiment with them
                    strokeColor: '#E0E0E0',  // to see which ones work best for you
                    generateGradient: true,
                    highDpiSupport: true,     // High resolution support
                    //percentColors: [[0.0, "#ff0000" ], [0.50, "#f9c802"], [1.0, "#00ff00"]]
                };
                var target = document.getElementById('grafrentexec'); // your canvas element
                var gauge = new Gauge(target).setOptions(opts); // create sexy gauge!
                gauge.maxValue = 100; // set max gauge value
                gauge.setMinValue(-100);  // Prefer setter over gauge.minValue = 0
                gauge.animationSpeed = 32; // set animation speed (32 is default value)
                gauge.set(rent); // set actual value
                $("#rentexecvalor").html(texto + Math.round(rent) + "%");
            }
        });
    }
    });
}

function linguagemind(){

    var urlJSON = '/api/account/';

    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            var linguagem = json.langKey;

            if(linguagem==="pt-br"){
                montaRelatorioInd('pt');
            }
            else if(linguagem==="en"){
                montaRelatorioInd('en');
            }
            else{
                montaRelatorioInd('es');
            }
        }
    });
}

function montaRelatorioInd(ling){
    if(ling === 'pt'){
        $('#tituloplanrent').html("Rentabilidade Esperada");
        $('#tituloexecrent').html("Rentabilidade");
        $('#tituloplanprod').html("Produtividade Esperada");
        $('#tituloexecprod').html("Produtividade");
    }
    else if(ling === 'es'){
        $('#tituloplanrent').html("Rentabilidad Esperada");
        $('#tituloexecrent').html("Rentabilidad");
        $('#tituloplanprod').html("Productividad Esperada");
        $('#tituloexecprod').html("Productividad");
    }
    else{
        $('#tituloplanrent').html("Expected profitability");
        $('#tituloexecrent').html("Profitability");
        $('#tituloplanprod').html("Expected productivity ");
        $('#tituloexecprod').html("Productivity");       
    }
        
    gaugeProd(ling);
    gaugeRent(ling);
    gaugeProdPlan(ling);
    gaugeRentPlan(ling);



}
(function(){var t,i,e,s,n,o,a,h,r,l,p,c,u,d=[].slice,g={}.hasOwnProperty,m=function(t,i){function e(){this.constructor=t}for(var s in i)g.call(i,s)&&(t[s]=i[s]);return e.prototype=i.prototype,t.prototype=new e,t.__super__=i.prototype,t};!function(){var t,i,e,s,n,o,a;for(a=["ms","moz","webkit","o"],e=0,n=a.length;e<n&&(o=a[e],!window.requestAnimationFrame);e++)window.requestAnimationFrame=window[o+"RequestAnimationFrame"],window.cancelAnimationFrame=window[o+"CancelAnimationFrame"]||window[o+"CancelRequestAnimationFrame"];t=null,s=0,i={},requestAnimationFrame?window.cancelAnimationFrame||(t=window.requestAnimationFrame,window.requestAnimationFrame=function(e,n){var o;return o=++s,t(function(){if(!i[o])return e()},n),o},window.cancelAnimationFrame=function(t){return i[t]=!0}):(window.requestAnimationFrame=function(t,i){var e,s,n,o;return e=(new Date).getTime(),o=Math.max(0,16-(e-n)),s=window.setTimeout(function(){return t(e+o)},o),n=e+o,s},window.cancelAnimationFrame=function(t){return clearTimeout(t)})}(),u=function(t){var i,e;for(i=Math.floor(t/3600),e=Math.floor((t-3600*i)/60),t-=3600*i+60*e,t+="",e+="";e.length<2;)e="0"+e;for(;t.length<2;)t="0"+t;return(i=i?i+":":"")+e+":"+t},p=function(){var t,i,e;return i=1<=arguments.length?d.call(arguments,0):[],e=i[0],t=i[1],r(e.toFixed(t))},c=function(t,i){var e,s,n;s={};for(e in t)g.call(t,e)&&(n=t[e],s[e]=n);for(e in i)g.call(i,e)&&(n=i[e],s[e]=n);return s},r=function(t){var i,e,s,n;for(t+="",e=t.split("."),s=e[0],n="",e.length>1&&(n="."+e[1]),i=/(\d+)(\d{3})/;i.test(s);)s=s.replace(i,"$1,$2");return s+n},l=function(t){return"#"===t.charAt(0)?t.substring(1,7):t},h=function(){function t(t,i){null==t&&(t=!0),this.clear=null==i||i,t&&AnimationUpdater.add(this)}return t.prototype.animationSpeed=32,t.prototype.update=function(t){var i;return null==t&&(t=!1),!(!t&&this.displayedValue===this.value)&&(this.ctx&&this.clear&&this.ctx.clearRect(0,0,this.canvas.width,this.canvas.height),i=this.value-this.displayedValue,Math.abs(i/this.animationSpeed)<=.001?this.displayedValue=this.value:this.displayedValue=this.displayedValue+i/this.animationSpeed,this.render(),!0)},t}(),e=function(t){function i(){return i.__super__.constructor.apply(this,arguments)}return m(i,t),i.prototype.displayScale=1,i.prototype.forceUpdate=!0,i.prototype.setTextField=function(t,i){return this.textField=t instanceof a?t:new a(t,i)},i.prototype.setMinValue=function(t,i){var e,s,n,o,a;if(this.minValue=t,null==i&&(i=!0),i){for(this.displayedValue=this.minValue,o=this.gp||[],a=[],s=0,n=o.length;s<n;s++)e=o[s],a.push(e.displayedValue=this.minValue);return a}},i.prototype.setOptions=function(t){return null==t&&(t=null),this.options=c(this.options,t),this.textField&&(this.textField.el.style.fontSize=t.fontSize+"px"),this.options.angle>.5&&(this.options.angle=.5),this.configDisplayScale(),this},i.prototype.configDisplayScale=function(){var t,i,e,s,n;return s=this.displayScale,!1===this.options.highDpiSupport?delete this.displayScale:(i=window.devicePixelRatio||1,t=this.ctx.webkitBackingStorePixelRatio||this.ctx.mozBackingStorePixelRatio||this.ctx.msBackingStorePixelRatio||this.ctx.oBackingStorePixelRatio||this.ctx.backingStorePixelRatio||1,this.displayScale=i/t),this.displayScale!==s&&(n=this.canvas.G__width||this.canvas.width,e=this.canvas.G__height||this.canvas.height,this.canvas.width=n*this.displayScale,this.canvas.height=e*this.displayScale,this.canvas.style.width=n+"px",this.canvas.style.height=e+"px",this.canvas.G__width=n,this.canvas.G__height=e),this},i.prototype.parseValue=function(t){return t=parseFloat(t)||Number(t),isFinite(t)?t:0},i}(h),a=function(){function t(t,i){this.el=t,this.fractionDigits=i}return t.prototype.render=function(t){return this.el.innerHTML=p(t.displayedValue,this.fractionDigits)},t}(),t=function(t){function i(t,e){if(this.elem=t,this.text=null!=e&&e,i.__super__.constructor.call(this),void 0===this.elem)throw new Error("The element isn't defined.");this.value=1*this.elem.innerHTML,this.text&&(this.value=0)}return m(i,t),i.prototype.displayedValue=0,i.prototype.value=0,i.prototype.setVal=function(t){return this.value=1*t},i.prototype.render=function(){var t;return t=this.text?u(this.displayedValue.toFixed(0)):r(p(this.displayedValue)),this.elem.innerHTML=t},i}(h),o=function(t){function i(t){if(this.gauge=t,void 0===this.gauge)throw new Error("The element isn't defined.");this.ctx=this.gauge.ctx,this.canvas=this.gauge.canvas,i.__super__.constructor.call(this,!1,!1),this.setOptions()}return m(i,t),i.prototype.displayedValue=0,i.prototype.value=0,i.prototype.options={strokeWidth:.035,length:.1,color:"#000000",iconPath:null,iconScale:1,iconAngle:0},i.prototype.img=null,i.prototype.setOptions=function(t){if(null==t&&(t=null),this.options=c(this.options,t),this.length=2*this.gauge.radius*this.gauge.options.radiusScale*this.options.length,this.strokeWidth=this.canvas.height*this.options.strokeWidth,this.maxValue=this.gauge.maxValue,this.minValue=this.gauge.minValue,this.animationSpeed=this.gauge.animationSpeed,this.options.angle=this.gauge.options.angle,this.options.iconPath)return this.img=new Image,this.img.src=this.options.iconPath},i.prototype.render=function(){var t,i,e,s,n,o,a,h,r;if(t=this.gauge.getAngle.call(this,this.displayedValue),h=Math.round(this.length*Math.cos(t)),r=Math.round(this.length*Math.sin(t)),o=Math.round(this.strokeWidth*Math.cos(t-Math.PI/2)),a=Math.round(this.strokeWidth*Math.sin(t-Math.PI/2)),i=Math.round(this.strokeWidth*Math.cos(t+Math.PI/2)),e=Math.round(this.strokeWidth*Math.sin(t+Math.PI/2)),this.ctx.beginPath(),this.ctx.fillStyle=this.options.color,this.ctx.arc(0,0,this.strokeWidth,0,2*Math.PI,!1),this.ctx.fill(),this.ctx.beginPath(),this.ctx.moveTo(o,a),this.ctx.lineTo(h,r),this.ctx.lineTo(i,e),this.ctx.fill(),this.img)return s=Math.round(this.img.width*this.options.iconScale),n=Math.round(this.img.height*this.options.iconScale),this.ctx.save(),this.ctx.translate(h,r),this.ctx.rotate(t+Math.PI/180*(90+this.options.iconAngle)),this.ctx.drawImage(this.img,-s/2,-n/2,s,n),this.ctx.restore()},i}(h),function(){function t(t){this.elem=t}t.prototype.updateValues=function(t){return this.value=t[0],this.maxValue=t[1],this.avgValue=t[2],this.render()},t.prototype.render=function(){var t,i;return this.textField&&this.textField.text(p(this.value)),0===this.maxValue&&(this.maxValue=2*this.avgValue),i=this.value/this.maxValue*100,t=this.avgValue/this.maxValue*100,$(".bar-value",this.elem).css({width:i+"%"}),$(".typical-value",this.elem).css({width:t+"%"})}}(),n=function(t){function i(t){var e,s;this.canvas=t,i.__super__.constructor.call(this),this.percentColors=null,"undefined"!=typeof G_vmlCanvasManager&&(this.canvas=window.G_vmlCanvasManager.initElement(this.canvas)),this.ctx=this.canvas.getContext("2d"),e=this.canvas.clientHeight,s=this.canvas.clientWidth,this.canvas.height=e,this.canvas.width=s,this.gp=[new o(this)],this.setOptions()}return m(i,t),i.prototype.elem=null,i.prototype.value=[20],i.prototype.maxValue=80,i.prototype.minValue=0,i.prototype.displayedAngle=0,i.prototype.displayedValue=0,i.prototype.lineWidth=40,i.prototype.paddingTop=.1,i.prototype.paddingBottom=.1,i.prototype.percentColors=null,i.prototype.options={colorStart:"#6fadcf",colorStop:void 0,gradientType:0,strokeColor:"#e0e0e0",pointer:{length:.8,strokeWidth:.035,iconScale:1},angle:.15,lineWidth:.44,radiusScale:1,fontSize:40,limitMax:!1,limitMin:!1},i.prototype.setOptions=function(t){var e,s,n,o,a;for(null==t&&(t=null),i.__super__.setOptions.call(this,t),this.configPercentColors(),this.extraPadding=0,this.options.angle<0&&(o=Math.PI*(1+this.options.angle),this.extraPadding=Math.sin(o)),this.availableHeight=this.canvas.height*(1-this.paddingTop-this.paddingBottom),this.lineWidth=this.availableHeight*this.options.lineWidth,this.radius=(this.availableHeight-this.lineWidth/2)/(1+this.extraPadding),this.ctx.clearRect(0,0,this.canvas.width,this.canvas.height),a=this.gp,s=0,n=a.length;s<n;s++)e=a[s],e.setOptions(this.options.pointer),e.render();return this.render(),this},i.prototype.configPercentColors=function(){var t,i,e,s,n,o,a;if(this.percentColors=null,void 0!==this.options.percentColors){for(this.percentColors=new Array,o=[],e=s=0,n=this.options.percentColors.length-1;0<=n?s<=n:s>=n;e=0<=n?++s:--s)a=parseInt(l(this.options.percentColors[e][1]).substring(0,2),16),i=parseInt(l(this.options.percentColors[e][1]).substring(2,4),16),t=parseInt(l(this.options.percentColors[e][1]).substring(4,6),16),o.push(this.percentColors[e]={pct:this.options.percentColors[e][0],color:{r:a,g:i,b:t}});return o}},i.prototype.set=function(t){var i,e,s,n,a,h,r,l,p;for(t instanceof Array||(t=[t]),e=s=0,r=t.length-1;0<=r?s<=r:s>=r;e=0<=r?++s:--s)t[e]=this.parseValue(t[e]);if(t.length>this.gp.length)for(e=n=0,l=t.length-this.gp.length;0<=l?n<l:n>l;e=0<=l?++n:--n)i=new o(this),i.setOptions(this.options.pointer),this.gp.push(i);else t.length<this.gp.length&&(this.gp=this.gp.slice(this.gp.length-t.length));for(e=0,a=0,h=t.length;a<h;a++)p=t[a],p>this.maxValue?this.options.limitMax?p=this.maxValue:this.maxValue=p+1:p<this.minValue&&(this.options.limitMin?p=this.minValue:this.minValue=p-1),this.gp[e].value=p,this.gp[e++].setOptions({minValue:this.minValue,maxValue:this.maxValue,angle:this.options.angle});return this.value=Math.max(Math.min(t[t.length-1],this.maxValue),this.minValue),AnimationUpdater.run(this.forceUpdate),this.forceUpdate=!1},i.prototype.getAngle=function(t){return(1+this.options.angle)*Math.PI+(t-this.minValue)/(this.maxValue-this.minValue)*(1-2*this.options.angle)*Math.PI},i.prototype.getColorForPercentage=function(t,i){var e,s,n,o,a,h,r;if(0===t)e=this.percentColors[0].color;else for(e=this.percentColors[this.percentColors.length-1].color,n=o=0,h=this.percentColors.length-1;0<=h?o<=h:o>=h;n=0<=h?++o:--o)if(t<=this.percentColors[n].pct){!0===i?(r=this.percentColors[n-1]||this.percentColors[0],s=this.percentColors[n],a=(t-r.pct)/(s.pct-r.pct),e={r:Math.floor(r.color.r*(1-a)+s.color.r*a),g:Math.floor(r.color.g*(1-a)+s.color.g*a),b:Math.floor(r.color.b*(1-a)+s.color.b*a)}):e=this.percentColors[n].color;break}return"rgb("+[e.r,e.g,e.b].join(",")+")"},i.prototype.getColorForValue=function(t,i){var e;return e=(t-this.minValue)/(this.maxValue-this.minValue),this.getColorForPercentage(e,i)},i.prototype.renderStaticLabels=function(t,i,e,s){var n,o,a,h,r,l,c,u,d,g;for(this.ctx.save(),this.ctx.translate(i,e),n=t.font||"10px Times",l=/\d+\.?\d?/,r=n.match(l)[0],u=n.slice(r.length),o=parseFloat(r)*this.displayScale,this.ctx.font=o+u,this.ctx.fillStyle=t.color||"#000000",this.ctx.textBaseline="bottom",this.ctx.textAlign="center",c=t.labels,a=0,h=c.length;a<h;a++)g=c[a],void 0!==g.label?(!this.options.limitMin||g>=this.minValue)&&(!this.options.limitMax||g<=this.maxValue)&&(n=g.font||t.font,r=n.match(l)[0],u=n.slice(r.length),o=parseFloat(r)*this.displayScale,this.ctx.font=o+u,d=this.getAngle(g.label)-3*Math.PI/2,this.ctx.rotate(d),this.ctx.fillText(p(g.label,t.fractionDigits),0,-s-this.lineWidth/2),this.ctx.rotate(-d)):(!this.options.limitMin||g>=this.minValue)&&(!this.options.limitMax||g<=this.maxValue)&&(d=this.getAngle(g)-3*Math.PI/2,this.ctx.rotate(d),this.ctx.fillText(p(g,t.fractionDigits),0,-s-this.lineWidth/2),this.ctx.rotate(-d));return this.ctx.restore()},i.prototype.renderTicks=function(t,i,e,s){var n,o,a,h,r,l,p,c,u,d,g,m,x,f,v,y,V,w,S,M,C;if(t!=={}){for(l=t.divisions||0,S=t.subDivisions||0,a=t.divColor||"#fff",v=t.subColor||"#fff",h=t.divLength||.7,V=t.subLength||.2,u=parseFloat(this.maxValue)-parseFloat(this.minValue),d=parseFloat(u)/parseFloat(t.divisions),y=parseFloat(d)/parseFloat(t.subDivisions),n=parseFloat(this.minValue),o=0+y,c=u/400,r=c*(t.divWidth||1),w=c*(t.subWidth||1),m=[],M=p=0,g=l+1;p<g;M=p+=1)this.ctx.lineWidth=this.lineWidth*h,x=this.lineWidth/2*(1-h),C=this.radius*this.options.radiusScale+x,this.ctx.strokeStyle=a,this.ctx.beginPath(),this.ctx.arc(0,0,C,this.getAngle(n-r),this.getAngle(n+r),!1),this.ctx.stroke(),o=n+y,n+=d,M!==t.divisions&&S>0?m.push(function(){var t,i,e;for(e=[],f=t=0,i=S-1;t<i;f=t+=1)this.ctx.lineWidth=this.lineWidth*V,x=this.lineWidth/2*(1-V),C=this.radius*this.options.radiusScale+x,this.ctx.strokeStyle=v,this.ctx.beginPath(),this.ctx.arc(0,0,C,this.getAngle(o-w),this.getAngle(o+w),!1),this.ctx.stroke(),e.push(o+=y);return e}.call(this)):m.push(void 0);return m}},i.prototype.render=function(){var t,i,e,s,n,o,a,h,r,l,p,c,u,d,g,m,x;if(m=this.canvas.width/2,s=this.canvas.height*this.paddingTop+this.availableHeight-(this.radius+this.lineWidth/2)*this.extraPadding,t=this.getAngle(this.displayedValue),this.textField&&this.textField.render(this),this.ctx.lineCap="butt",p=this.radius*this.options.radiusScale,this.options.staticLabels&&this.renderStaticLabels(this.options.staticLabels,m,s,p),this.options.staticZones)for(this.ctx.save(),this.ctx.translate(m,s),this.ctx.lineWidth=this.lineWidth,c=this.options.staticZones,n=0,a=c.length;n<a;n++)x=c[n],l=x.min,this.options.limitMin&&l<this.minValue&&(l=this.minValue),r=x.max,this.options.limitMax&&r>this.maxValue&&(r=this.maxValue),g=this.radius*this.options.radiusScale,x.height&&(this.ctx.lineWidth=this.lineWidth*x.height,d=this.lineWidth/2*(x.offset||1-x.height),g=this.radius*this.options.radiusScale+d),this.ctx.strokeStyle=x.strokeStyle,this.ctx.beginPath(),this.ctx.arc(0,0,g,this.getAngle(l),this.getAngle(r),!1),this.ctx.stroke();else void 0!==this.options.customFillStyle?i=this.options.customFillStyle(this):null!==this.percentColors?i=this.getColorForValue(this.displayedValue,this.options.generateGradient):void 0!==this.options.colorStop?(i=0===this.options.gradientType?this.ctx.createRadialGradient(m,s,9,m,s,70):this.ctx.createLinearGradient(0,0,m,0),i.addColorStop(0,this.options.colorStart),i.addColorStop(1,this.options.colorStop)):i=this.options.colorStart,this.ctx.strokeStyle=i,this.ctx.beginPath(),this.ctx.arc(m,s,p,(1+this.options.angle)*Math.PI,t,!1),this.ctx.lineWidth=this.lineWidth,this.ctx.stroke(),this.ctx.strokeStyle=this.options.strokeColor,this.ctx.beginPath(),this.ctx.arc(m,s,p,t,(2-this.options.angle)*Math.PI,!1),this.ctx.stroke(),this.ctx.save(),this.ctx.translate(m,s);for(this.options.renderTicks&&this.renderTicks(this.options.renderTicks,m,s,p),this.ctx.restore(),this.ctx.translate(m,s),u=this.gp,o=0,h=u.length;o<h;o++)e=u[o],e.update(!0);return this.ctx.translate(-m,-s)},i}(e),i=function(t){function i(t){this.canvas=t,i.__super__.constructor.call(this),"undefined"!=typeof G_vmlCanvasManager&&(this.canvas=window.G_vmlCanvasManager.initElement(this.canvas)),this.ctx=this.canvas.getContext("2d"),this.setOptions(),this.render()}return m(i,t),i.prototype.lineWidth=15,i.prototype.displayedValue=0,i.prototype.value=33,i.prototype.maxValue=80,i.prototype.minValue=0,i.prototype.options={lineWidth:.1,colorStart:"#6f6ea0",colorStop:"#c0c0db",strokeColor:"#eeeeee",shadowColor:"#d5d5d5",angle:.35,radiusScale:1},i.prototype.getAngle=function(t){return(1-this.options.angle)*Math.PI+(t-this.minValue)/(this.maxValue-this.minValue)*(2+this.options.angle-(1-this.options.angle))*Math.PI},i.prototype.setOptions=function(t){return null==t&&(t=null),i.__super__.setOptions.call(this,t),this.lineWidth=this.canvas.height*this.options.lineWidth,this.radius=this.options.radiusScale*(this.canvas.height/2-this.lineWidth/2),this},i.prototype.set=function(t){return this.value=this.parseValue(t),this.value>this.maxValue?this.options.limitMax?this.value=this.maxValue:this.maxValue=this.value:this.value<this.minValue&&(this.options.limitMin?this.value=this.minValue:this.minValue=this.value),AnimationUpdater.run(this.forceUpdate),this.forceUpdate=!1},i.prototype.render=function(){var t,i,e,s;return t=this.getAngle(this.displayedValue),s=this.canvas.width/2,e=this.canvas.height/2,this.textField&&this.textField.render(this),i=this.ctx.createRadialGradient(s,e,39,s,e,70),i.addColorStop(0,this.options.colorStart),i.addColorStop(1,this.options.colorStop),this.radius-this.lineWidth/2,this.radius+this.lineWidth/2,this.ctx.strokeStyle=this.options.strokeColor,this.ctx.beginPath(),this.ctx.arc(s,e,this.radius,(1-this.options.angle)*Math.PI,(2+this.options.angle)*Math.PI,!1),this.ctx.lineWidth=this.lineWidth,this.ctx.lineCap="round",this.ctx.stroke(),this.ctx.strokeStyle=i,this.ctx.beginPath(),this.ctx.arc(s,e,this.radius,(1-this.options.angle)*Math.PI,t,!1),this.ctx.stroke()},i}(e),s=function(t){function i(){return i.__super__.constructor.apply(this,arguments)}return m(i,t),i.prototype.strokeGradient=function(t,i,e,s){var n;return n=this.ctx.createRadialGradient(t,i,e,t,i,s),n.addColorStop(0,this.options.shadowColor),n.addColorStop(.12,this.options._orgStrokeColor),n.addColorStop(.88,this.options._orgStrokeColor),n.addColorStop(1,this.options.shadowColor),n},i.prototype.setOptions=function(t){var e,s,n,o;return null==t&&(t=null),i.__super__.setOptions.call(this,t),o=this.canvas.width/2,e=this.canvas.height/2,s=this.radius-this.lineWidth/2,n=this.radius+this.lineWidth/2,this.options._orgStrokeColor=this.options.strokeColor,this.options.strokeColor=this.strokeGradient(o,e,s,n),this},i}(i),window.AnimationUpdater={elements:[],animId:null,addAll:function(t){var i,e,s,n;for(n=[],e=0,s=t.length;e<s;e++)i=t[e],n.push(AnimationUpdater.elements.push(i));return n},add:function(t){return AnimationUpdater.elements.push(t)},run:function(t){var i,e,s,n,o;if(null==t&&(t=!1),isFinite(parseFloat(t))||!0===t){for(e=!0,o=AnimationUpdater.elements,s=0,n=o.length;s<n;s++)i=o[s],i.update(!0===t)&&(e=!1);return AnimationUpdater.animId=e?null:requestAnimationFrame(AnimationUpdater.run)}if(!1===t)return!0===AnimationUpdater.animId&&cancelAnimationFrame(AnimationUpdater.animId),AnimationUpdater.animId=requestAnimationFrame(AnimationUpdater.run)}},"function"==typeof window.define&&null!=window.define.amd?define(function(){return{Gauge:n,Donut:s,BaseDonut:i,TextRenderer:a}}):"undefined"!=typeof module&&null!=module.exports?module.exports={Gauge:n,Donut:s,BaseDonut:i,TextRenderer:a}:(window.Gauge=n,window.Donut=s,window.BaseDonut=i,window.TextRenderer=a)}).call(this);

  
function getSafra2(){
    var $select = $('#selecsafra2');
    var safra = $select.val();

    return safra;
}


function montaGrafDespesasExec(ling){

    var safra = getSafra2();
    var etapas = ['preplantio', 'plantio', 'colheita', 'manutencaosafra', 'armazenamentosafra', 'comercializacao', 'logrecinsumo', 'logentregaarmaz', 'entregasafracomerc']

    console.log("Inicio");

    var urlJSON = "/api/servicosetapa/" + safra + "?size=1000";
    
    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
       
            mes = json.map(function(item) {
                return item.mes;
            });

            ano = json.map(function(item) {
                return item.ano;
            });

            valor = json.map(function(item) {
                return item.valorservico;
            });

            fluxo = json.map(function(item) {
                return item.fluxo;
            });

            tipoetapa = json.map(function(item) {
                return item.tipoetapa;
            });

            console.log(tipoetapa);
            console.log(fluxo);
            console.log(valor);

            var ctx = document.getElementById('grafdesp').getContext('2d');

            var mapa = new Map();

            var tamanho = tipoetapa.length;
            for(i=0; i<tamanho; i++){

                if(fluxo[i] === 'receita') continue;
                if(etapas.indexOf(tipoetapa[i])==-1) continue;

                var label = mes[i] + '/' + ano[i];
                var val = valor[i];


                if(mapa.has(label)===true){
                    var temp = mapa.get(label) + val;
                    mapa.set(label, temp);
                }
                else{
                    mapa.set(label, val);
                }
            }

            var vlabels = []; var vdatas = [];
            var kv;
            for ( kv in mapa.entries()) {
                key = kv[0];
                value = kv[1];
                vlabels.push(key);
                vdatas.push(value);
                console.log(key + " = " + value);
            }

            var labelValor; var labelTexto;
            if(ling === "pt"){
                labelValor = "Valor (R$)";
                labelTexto = "Despesas";
            }
            else if(ling === "es"){
                labelValor = "Valor ($)";
                labelTexto = "Gastos";
            }
            else{
                labelValor = "Value ($)";
                labelTexto = "Output";
            } 


            var myLineChart = new Chart(ctx, {
                type: 'line',
                data: {
                labels: vlabels,
                datasets: [{ 
                    data: vdatas,
                    label: labelValor,
                    borderColor: "#ff0000",
                    fill: true
                    }
                ]
                },
                options: {
                title: {
                    display: true,
                    text: labelTexto
                }
                }
            });
        }
    });
   
}

function montaGrafReceitasExec(ling){

    var safra = getSafra2();
    var etapas = ['preplantio', 'plantio', 'colheita', 'manutencaosafra', 'armazenamentosafra', 'comercializacao', 'logrecinsumo', 'logentregaarmaz', 'entregasafracomerc']

    console.log("Inicio");
    var urlJSON = "/api/servicosetapa/" + safra + "?size=1000";
    
    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {

            mes = json.map(function(item) {
                return item.mes;
            });

            ano = json.map(function(item) {
                return item.ano;
            });

            valor = json.map(function(item) {
                return item.valorservico;
            });

            fluxo = json.map(function(item) {
                return item.fluxo;
            });

            tipoetapa = json.map(function(item) {
                return item.tipoetapa;
            });

            console.log(tipoetapa);
            console.log(fluxo);
            console.log(valor);

            var ctx = document.getElementById('grafrec').getContext('2d');

            var mapa = new Map();

            var tamanho = tipoetapa.length;
            for(i=0; i<tamanho; i++){

                if(fluxo[i] === 'despesa') continue;
                if(etapas.indexOf(tipoetapa[i])==-1) continue;

                var label = mes[i] + '/' + ano[i];
                var val = valor[i];


                if(mapa.has(label)===true){
                    var temp = mapa.get(label) + val;
                    mapa.set(label, temp);
                }
                else{
                    mapa.set(label, val);
                }
            }

            var vlabels = []; var vdatas = [];
            var kv;
            for (var kv in mapa.entries()) {
                key = kv[0];
                value = kv[1];
                
                vlabels.push(key);
                vdatas.push(value);
                console.log(key + " = " + value);
            }

            var labelValor; var labelTexto;
            if(ling === "pt"){
                labelValor = "Valor (R$)";
                labelTexto = "Receita";
            }
            else if(ling === "es"){
                labelValor = "Valor ($)";
                labelTexto = "Rendimiento";
            }
            else{
                labelValor = "Value ($)";
                labelTexto = "Income";
            } 

            var myLineChart = new Chart(ctx, {
                type: 'line',
                data: {
                labels: vlabels,
                datasets: [{ 
                    data: vdatas,
                    label: labelValor,
                    borderColor: "#43b534",
                    fill: true
                    }
                ]
                },
                options: {
                title: {
                    display: true,
                    text: labelTexto
                }
                }
            });
        }
    });
   
}

function montaGrafDespesasEtapasExec(ling){
    
    var safra = getSafra2();
    var etapas = ['preplantio', 'plantio', 'colheita', 'manutencaosafra', 'armazenamentosafra', 'comercializacao', 'logrecinsumo', 'logentregaarmaz', 'entregasafracomerc']

    console.log("Inicio");

    var urlJSON = "/api/servicosetapa/" + safra + "?size=1000";
    
    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            valor = json.map(function(item) {
                return item.valorservico;
            });

            fluxo = json.map(function(item) {
                return item.fluxo;
            });

            tipoetapa = json.map(function(item) {
                return item.tipoetapa;
            });


            var mapa = new Map();

            var tamanho = tipoetapa.length;
            var vdatas = [0, 0, 0, 0, 0, 0, 0, 0, 0];

            for(i=0; i<tamanho; i++){

                if(fluxo[i] === 'receita') continue;
                if(etapas.indexOf(tipoetapa[i])==-1) continue;

                vdatas[etapas.indexOf(tipoetapa[i])] += valor[i];
            }

            var ctx = document.getElementById('grafdespetapa').getContext('2d');

            var labelValor; var labelTexto; var vlabels; var labelEtapa;
            if(ling === "pt"){
                labelValor = "Valor (R$)";
                labelTexto = "Despesas Por Etapa";
                vlabels = ['Pré-plantio', 'Plantio', 'Colheita', 'Manutenção', 'Armazenamento', 'Comercialização', 'Recebimento de Insumos', 'Entrega para Armazenamento', 'Entrega Para Comercialização'];
                labelEtapa = "Etapa";
            }
            else if(ling === "es"){
                labelValor = "Valor ($)";
                labelTexto = "Gastos por Etapa";
                vlabels = ['Pre-siembra', 'Siembra', 'Vendimia', 'Mantenimiento', 'Almacenamiento', 'Comercialización', 'Recebimiento de Consumiveis', 'Entrega para el Almacenamiento', 'Entrega para la Comercialización'];
                labelEtapa = "Etapa";
            }
            else{
                labelValor = "Value ($)";
                labelTexto = "Output By Stage";
                vlabels = ['Pre-planting', 'Planting', 'Ingathering', 'Maintenance', 'Storage', 'Commercialization', 'Inputs Receiving', 'Delivery for Storage', 'Delivery for Commercialization'];
                labelEtapa = "Stage";
            } 


            var chart = new Chart(ctx, {
                type: 'bar',

                data: {
                    labels: vlabels,
                    datasets: [{
                        label: labelValor,
                        backgroundColor: '#42d4f4', 
                        data: vdatas,
                    }]
                },

                // Configuration options go here
                options: {
                    title: {
                        display: true,
                        text: labelTexto
                    },
                    scales: {
                        yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: labelValor
                        },   
                        ticks: {
                            suggestedMin: 0  // minimum will be 0, unless there is a lower value.
                        }
                        }],

                        xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: labelEtapa
                        }
                        }]
                    }     

                }
            });

        }
    });
}

function montaGrafReceitasEtapasExec(ling){
    
    var safra = getSafra2();
    var etapas = ['preplantio', 'plantio', 'colheita', 'manutencaosafra', 'armazenamentosafra', 'comercializacao', 'logrecinsumo', 'logentregaarmaz', 'entregasafracomerc']

    console.log("Inicio");

    var urlJSON = "/api/servicosetapa/" + safra + "?size=1000";
    
    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            
            valor = json.map(function(item) {
                return item.valorservico;
            });

            fluxo = json.map(function(item) {
                return item.fluxo;
            });

            tipoetapa = json.map(function(item) {
                return item.tipoetapa;
            });


            var mapa = new Map();

            var tamanho = tipoetapa.length;
            var vdatas = [0, 0, 0, 0, 0, 0, 0, 0, 0];

            for(i=0; i<tamanho; i++){

                if(fluxo[i] === 'despesa') continue;
                if(etapas.indexOf(tipoetapa[i])==-1) continue;

                vdatas[etapas.indexOf(tipoetapa[i])] += valor[i];
            }

            var ctx = document.getElementById('grafrecetapa').getContext('2d');

            var labelValor; var labelTexto; var vlabels; var labelEtapa;
            if(ling === "pt"){
                labelValor = "Valor (R$)";
                labelTexto = "Receita Por Etapa";
                vlabels = ['Pré-plantio', 'Plantio', 'Colheita', 'Manutenção', 'Armazenamento', 'Comercialização', 'Recebimento de Insumos', 'Entrega para Armazenamento', 'Entrega Para Comercialização'];
                labelEtapa = "Etapa";
            }
            else if(ling === "es"){
                labelValor = "Valor ($)";
                labelTexto = "Rendimiento por Etapa";
                vlabels = ['Pre-siembra', 'Siembra', 'Vendimia', 'Mantenimiento', 'Almacenamiento', 'Comercialización', 'Recebimiento de Consumiveis', 'Entrega para el Almacenamiento', 'Entrega para la Comercialización'];
                labelEtapa = "Etapa";
            }
            else{
                labelValor = "Value ($)";
                labelTexto = "Income By Stage";
                vlabels = ['Pre-planting', 'Planting', 'Ingathering', 'Maintenance', 'Storage', 'Commercialization', 'Inputs Receiving', 'Delivery for Storage', 'Delivery for Commercialization'];
                labelEtapa = "Stage";
            } 

            var chart = new Chart(ctx, {
                type: 'bar',

                data: {
                    labels: vlabels,
                    datasets: [{
                        label: labelValor,
                        backgroundColor: '#7d5bb7', 
                        data: vdatas,
                    }]
                },

                // Configuration options go here
                options: {
                    title: {
                        display: true,
                        text: labelTexto
                    },

                    scales: {
                        yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: labelValor
                        },   
                        ticks: {
                            suggestedMin: 0  // minimum will be 0, unless there is a lower value.
                        }
                        }],

                        xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: labelEtapa
                        }
                        }]
                    }     

                }
            });
        }
    });
}

function DistribuicaoTerceirizadoExec(ling){
    var safra = getSafra2();
    var etapas = ['preplantio', 'plantio', 'colheita', 'manutencaosafra', 'armazenamentosafra', 'comercializacao', 'logrecinsumo', 'logentregaarmaz', 'entregasafracomerc']

    console.log("Inicio");

    var urlJSON = "/api/servicosetapa/" + safra + "?size=1000";
    
    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
 
            valor = json.map(function(item) {
                return item.valorservico;
            });

            tipoetapa = json.map(function(item) {
                return item.tipoetapa;
            });

            tiporesponsavel = json.map(function(item) {
                return item.tiporesponsavel;
            });


            var totalterc = 0;
            var totalnaoterc = 0;

            var tamanho = tiporesponsavel.length;
            for(i=0; i<tamanho; i++){
                if(etapas.indexOf(tipoetapa[i])==-1) continue;
                if(fluxo[i] === 'receita') continue;

                if(tiporesponsavel[i] === 'terceirizado'){
                    totalterc = totalterc + valor[i];
                }
                else{
                    totalnaoterc = totalnaoterc + valor[i];
                }
            }

            var ctx = document.getElementById('grafdistribterc').getContext('2d');

            var labelValor; var labelTexto; var vlabels; var lblEtapa;
            if(ling === "pt"){
                labelValor = "Valor (R$)";
                labelTexto = "Distribuição da Terceirização";
                vlabels = ["terceirizado", "não-terceirizado"];
            }
            else if(ling === "es"){
                labelValor = "Valor ($)";
                labelTexto = "Distribución de la Tercerización";
                vlabels = ["Tercerizado", "No-tercerizado"];
            }
            else{
                labelValor = "Value ($)";
                labelTexto = "Outsourcing Distribution";
                vlabels = ["outsourced", "not outsourced"];
            } 
            
            var chart = new Chart(ctx, {
                type: 'pie',

                data: {
                    labels: vlabels,
                    datasets: [{
                        label: labelValor,
                        backgroundColor: ['#c45307', '#edba97'],
                        data: [totalterc, totalnaoterc]
                    }]
                },

                // Configuration options go here
                options: {
                    title: {
                        display: true,
                        text: labelTexto
                    }               
                }
            });
        }   
    });
}

function linguagemexec(){

    var urlJSON = '/api/account/';
    
    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {      
            var linguagem = json.langKey;

            if(linguagem==="pt-br"){
                montaRelatorioExec('pt');
            }
            else if(linguagem==="en"){
                montaRelatorioExec('en');
            }
            else{
                montaRelatorioExec('es');
            }
        }
    });
}

function montaRelatorioExec(ling){
    var urlJSON = '/api/account/';
    
    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            if(ling==="pt"){
                $('#titulodespexec').html("Despesas ao Longo do Tempo");
                $('#titulorecexec').html("Receita ao Longo do Tempo");
                $('#titulodespexecetapa').html("Despesas por Etapa");
                $('#titulorecexecetapa').html("Receita por Etapa");
                $('#titulodistribexec').html("Distribuição dos Gastos Por Terceirizados");
            }
            else if(ling === 'en'){
                $('#titulodespexec').html("Output Over Time");
                $('#titulorecexec').html("Income Over Time");
                $('#titulodespexecetapa').html("Output By Stage");
                $('#titulorecexecetapa').html("Income By Stage");
                $('#titulodistribexec').html("Distribution By Outsourcing");
            }
            else if(ling==="es"){
                $('#titulodespexec').html("Costes a lo largo del tiempo");
                $('#titulorecexec').html("Rendimiento a lo largo del tiempo");
                $('#titulodespexecetapa').html("Costes por Etapas");
                $('#titulorecexecetapa').html("Rendimiento por Etapas");
                $('#titulodistribexec').html("Distribución por Tercerización");
            
            }
            montaGrafDespesasExec(ling);
            montaGrafReceitasExec(ling);
            montaGrafDespesasEtapasExec(ling);
            montaGrafReceitasEtapasExec(ling);
            DistribuicaoTerceirizadoExec(ling);
        }
    });
}
  
function getSafra3(){
    var $select = $('#selecsafra3');
    var safra = $select.val();

    return safra;
}

function montaGrafDespesasComp(ling){

    var safra = getSafra3();
    var etapasplan = ['preplantioplan', 'plantioplan', 'colheitaplan', 'manutencaosafraplan', 'armazenamentosafraplan', 'comercializacaoplan', 'logrecinsumoplan', 'logentregaarmazplan', 'entregasafracomercplan']
    var etapas = ['preplantio', 'plantio', 'colheita', 'manutencaosafra', 'armazenamentosafra', 'comercializacao', 'logrecinsumo', 'logentregaarmaz', 'entregasafracomerc']


    console.log("Inicio");

    var urlJSON = "/api/servicosetapa/" + safra + "?size=1000";
    
    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            mes = json.map(function(item) {
                return item.mes;
            });

            ano = json.map(function(item) {
                return item.ano;
            });

            valor = json.map(function(item) {
                return item.valorservico;
            });

            fluxo = json.map(function(item) {
                return item.fluxo;
            });

            tipoetapa = json.map(function(item) {
                return item.tipoetapa;
            });

            console.log(tipoetapa);
            console.log(fluxo);
            console.log(valor);

            var ctx = document.getElementById('grafdespcomp').getContext('2d');

            var mapaplan = new Map();
            var mapaexec = new Map();

            var tamanho = tipoetapa.length;

            for(i=0; i<tamanho; i++){
                if(fluxo[i] === 'receita') continue;

                var label = mes[i] + '/' + ano[i];
                var val = valor[i];


                if(etapasplan.indexOf(tipoetapa[i])>-1){
                    if(mapaplan.has(label)===true){
                        var temp = mapaplan.get(label) + val;
                        mapaplan.set(label, temp);
                    }
                    else{
                        mapaplan.set(label, val);
                    }
                }
                else{
                    if(mapaexec.has(label)===true){
                        var temp = mapaexec.get(label) + val;
                        mapaexec.set(label, temp);
                    }
                    else{
                        mapaexec.set(label, val);
                    }
                }
            }

            var mapeamentogeral = new Map();
            
            var kv;
            for (  kv in mapaplan.entries()) {
                key = kv[0];
                value = kv[1];

                if(mapaexec.has(key)){
                    mapeamentogeral.set(key, [value, mapaexec.get(key)]);
                }
                else{
                    mapeamentogeral.set(key, [value, 0]);
                }
            }

            var kv;
            for ( kv in mapaexec.entries()) {
                key = kv[0];
                value = kv[1];

                if(mapeamentogeral.has(key) == false){
                    mapeamentogeral.set(key, [0, value]);
                }
            }


            var vlabels=[]; var vdataplan =[]; var vdataexec=[];
            for ( kv in mapeamentogeral.entries()) {
                key = kv[0];
                value = kv[1];
                
                vlabels.push(key);
                vdataplan.push(value[0]);
                vdataexec.push(value[1]);
                console.log(key + " = " + value);
            }

            var labelValorPlan; var labelValorExec; var labelTexto;
            if(ling === "pt"){
                labelValorPlan = "Valor planejado";
                labelValorExec = "Valor executado";
                labelTexto = "Comparativo de Despesas";
            }
            else if(ling === "es"){
                labelValorPlan = "Planificado";
                labelValorExec = "Ejecutado";
                labelTexto = "Comparativo de Gastos";
            }
            else{
                labelValorPlan = "Planned value";
                labelValorExec = "Executed value";
                labelTexto = "Output Comparative";
            } 

            var myLineChart = new Chart(ctx, {
                type: 'line',
                data: {
                labels: vlabels,
                datasets: [{ 
                    data: vdataplan,
                    label: labelValorPlan,
                    borderColor: "#ff0000",
                    fill: true
                    }
                    ,
                    { 
                        data: vdataexec,
                        label: labelValorExec,
                        borderColor: "#00ff00",
                        fill: true
                }
                ]
                },
                options: {
                title: {
                    display: true,
                    text: labelTexto
                }
                }
            });
        }
    });
   
}

function montaGrafReceitasComp(ling){

   
    var safra = getSafra3();
    var etapasplan = ['preplantioplan', 'plantioplan', 'colheitaplan', 'manutencaosafraplan', 'armazenamentosafraplan', 'comercializacaoplan', 'logrecinsumoplan', 'logentregaarmazplan', 'entregasafracomercplan']
    var etapas = ['preplantio', 'plantio', 'colheita', 'manutencaosafra', 'armazenamentosafra', 'comercializacao', 'logrecinsumo', 'logentregaarmaz', 'entregasafracomerc']


    console.log("Inicio");
    
    var urlJSON = "/api/servicosetapa/" + safra + "?size=1000";
    
    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            mes = json.map(function(item) {
                return item.mes;
            });

            ano = json.map(function(item) {
                return item.ano;
            });

            valor = json.map(function(item) {
                return item.valorservico;
            });

            fluxo = json.map(function(item) {
                return item.fluxo;
            });

            tipoetapa = json.map(function(item) {
                return item.tipoetapa;
            });

            console.log(tipoetapa);
            console.log(fluxo);
            console.log(valor);

            var ctx = document.getElementById('grafreccomp').getContext('2d');

            var mapaplan = new Map();
            var mapaexec = new Map();

            var tamanho = tipoetapa.length;

            for(i=0; i<tamanho; i++){
                if(fluxo[i] === 'despesa') continue;

                var label = mes[i] + '/' + ano[i];
                var val = valor[i];


                if(etapasplan.indexOf(tipoetapa[i])>-1){
                    if(mapaplan.has(label)===true){
                        var temp = mapaplan.get(label) + val;
                        mapaplan.set(label, temp);
                    }
                    else{
                        mapaplan.set(label, val);
                    }
                }
                else{
                    if(mapaexec.has(label)===true){
                        var temp = mapaexec.get(label) + val;
                        mapaexec.set(label, temp);
                    }
                    else{
                        mapaexec.set(label, val);
                    }
                }
            }

            var mapeamentogeral = new Map();
            for ( kv in mapaplan.entries()) {
                key = kv[0];
                value = kv[1];

                if(mapaexec.has(key)){
                    mapeamentogeral.set(key, [value, mapaexec.get(key)]);
                }
                else{
                    mapeamentogeral.set(key, [value, 0]);
                }
            }

            for ( kv in mapaexec.entries()) {
                key = kv[0];
                value = kv[1];

                if(mapeamentogeral.has(key) == false){
                    mapeamentogeral.set(key, [0, value]);
                }
            }


            var vlabels=[]; var vdataplan =[]; var vdataexec=[];
            for ( kv in mapeamentogeral.entries()) {
                key = kv[0];
                value = kv[1];

                vlabels.push(key);
                vdataplan.push(value[0]);
                vdataexec.push(value[1]);
                console.log(key + " = " + value);
            }

            var labelValorPlan; var labelValorExec; var labelTexto;
            if(ling === "pt"){
                labelValorPlan = "Valor planejado";
                labelValorExec = "Valor executado";
                labelTexto = "Comparativo de Receita";
            }
            else if(ling === "es"){
                labelValorPlan = "Planificado";
                labelValorExec = "Ejecutado";
                labelTexto = "Comparativo de Rendimiento";
            }
            else{
                labelValorPlan = "Planned value";
                labelValorExec = "Executed value";
                labelTexto = "Income Comparative";
            } 

            var myLineChart = new Chart(ctx, {
                type: 'line',
                data: {
                labels: vlabels,
                datasets: [{ 
                    data: vdataplan,
                    label: labelValorPlan,
                    borderColor: "#ff0000",
                    fill: true
                    }
                    ,
                    { 
                        data: vdataexec,
                        label: labelValorExec,
                        borderColor: "#00ff00",
                        fill: true
                }
                ]
                },
                options: {
                title: {
                    display: true,
                    text: labelTexto
                }
                }
            });
            
        }
    });
}

function montaGrafDespesasEtapasComp(ling){
    var safra = getSafra3();
    var etapasplan = ['preplantioplan', 'plantioplan', 'colheitaplan', 'manutencaosafraplan', 'armazenamentosafraplan', 'comercializacaoplan', 'logrecinsumoplan', 'logentregaarmazplan', 'entregasafracomercplan']
    var etapas = ['preplantio', 'plantio', 'colheita', 'manutencaosafra', 'armazenamentosafra', 'comercializacao', 'logrecinsumo', 'logentregaarmaz', 'entregasafracomerc']


    console.log("Inicio");

    var urlJSON = "/api/servicosetapa/" + safra + "?size=1000";
    
    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            tipoetapa = json.map(function(item) {
                return item.tipoetapa;
            });

            valor = json.map(function(item) {
                return item.valorservico;
            });

            fluxo = json.map(function(item) {
                return item.fluxo;
            });

            var vdatasplan = [0, 0, 0, 0, 0, 0, 0, 0, 0];
            var vdatasexec = [0, 0, 0, 0, 0, 0, 0, 0, 0];

            var tamanho = tipoetapa.length;

            for(i=0; i<tamanho; i++){

                if(fluxo[i] === 'receita') continue;
                if(etapasplan.indexOf(tipoetapa[i])==-1) continue;

                vdatasplan[etapasplan.indexOf(tipoetapa[i])] += valor[i];
            }


            for(i=0; i<tamanho; i++){

                if(fluxo[i] === 'receita') continue;
                if(etapas.indexOf(tipoetapa[i])==-1) continue;

                vdatasexec[etapas.indexOf(tipoetapa[i])] += valor[i];
            }

            var ctx = document.getElementById('grafdespetapacomp').getContext('2d');        

            var vlabels; var labelValorPlan; var labelValorExec; var labelTexto; var labelEtapa; var labelValor;
            if(ling === "pt"){
                labelValorPlan = "Valor planejado";
                labelValorExec = "Valor executado";
                labelTexto = "Comparativo de Despesas Por Etapa";
                vlabels = ['Pré-plantio', 'Plantio', 'Colheita', 'Manutenção', 'Armazenamento', 'Comercialização', 'Recebimento de Insumos', 'Entrega para Armazenamento', 'Entrega Para Comercialização'];
                labelEtapa = "Etapa";
                labelValor = "Valor";
            }
            else if(ling === "es"){
                labelValorPlan = "Planificado";
                labelValorExec = "Ejecutado";
                labelTexto = "Comparativo de Gastos Por Etapa";
                vlabels = ['Pre-siembra', 'Siembra', 'Vendimia', 'Mantenimiento', 'Almacenamiento', 'Comercialización', 'Recebimiento de Consumiveis', 'Entrega para el Almacenamiento', 'Entrega para la Comercialización'];
                labelEtapa = "Etapa";
                labelValor = "Valor";
            }
            else{
                labelValorPlan = "Planned value";
                labelValorExec = "Executed value";
                labelTexto = "Output Comparative By Stage";
                vlabels = ['Pre-planting', 'Planting', 'Ingathering', 'Maintenance', 'Storage', 'Commercialization', 'Inputs Receiving', 'Delivery for Storage', 'Delivery for Commercialization'];
                labelEtapa = "Stage";
                labelValor = "Value";
            } 

            var chart = new Chart(ctx, {
                type: 'bar',

                data: {
                    labels: vlabels,
                    datasets: [
                        {
                            label: labelValorPlan,
                            backgroundColor: 'rgb(255, 102, 102)', 
                            //borderColor: 'rgb(255, 99, 132)',
                            data: vdatasplan,
                        },
                        {
                            label: labelValorExec,
                            backgroundColor: 'rgb(255, 51, 51)', 
                            //borderColor: 'rgb(255, 99, 132)',
                            data: vdatasexec,
                        }
                    ]
                },

                // Configuration options go here
                options: {
                    scales: {
                        title: {
                            display: true,
                            text: labelTexto
                            },
                        yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: labelValor
                        },   
                        ticks: {
                            suggestedMin: 0  // minimum will be 0, unless there is a lower value.
                        }
                        }],

                        xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: labelEtapa
                        }
                        }]
                    }     

                }
            });
        }

    });
}

function montaGrafReceitasEtapasComp(ling){
    var safra = getSafra3();
    var etapasplan = ['preplantioplan', 'plantioplan', 'colheitaplan', 'manutencaosafraplan', 'armazenamentosafraplan', 'comercializacaoplan', 'logrecinsumoplan', 'logentregaarmazplan', 'entregasafracomercplan']
    var etapas = ['preplantio', 'plantio', 'colheita', 'manutencaosafra', 'armazenamentosafra', 'comercializacao', 'logrecinsumo', 'logentregaarmaz', 'entregasafracomerc']


    console.log("Inicio");
    var urlJSON = "/api/servicosetapa/" + safra + "?size=1000";
    
    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            tipoetapa = json.map(function(item) {
                return item.tipoetapa;
            });

            valor = json.map(function(item) {
                return item.valorservico;
            });

            fluxo = json.map(function(item) {
                return item.fluxo;
            });

            var vlabels = ['Pre-planting', 'Planting', 'Ingathering', 'Maintenance', 'Storage', 'Commercialization', 'Inputs Receiving', 'Delivery for Storage', 'Delivery for Commercialization'];
            var vdatasplan = [0, 0, 0, 0, 0, 0, 0, 0, 0];
            var vdatasexec = [0, 0, 0, 0, 0, 0, 0, 0, 0];

            var tamanho = tipoetapa.length;

            for(i=0; i<tamanho; i++){

                if(fluxo[i] === 'despesa') continue;
                if(etapasplan.indexOf(tipoetapa[i])==-1) continue;

                vdatasplan[etapasplan.indexOf(tipoetapa[i])] += valor[i];
            }


            for(i=0; i<tamanho; i++){

                if(fluxo[i] === 'despesa') continue;
                if(etapas.indexOf(tipoetapa[i])==-1) continue;

                vdatasexec[etapas.indexOf(tipoetapa[i])] += valor[i];
            }

            var ctx = document.getElementById('grafrecetapacomp').getContext('2d');        


            var vlabels; var labelValorPlan; var labelValorExec; var labelTexto; var labelEtapa; var labelValor;
            if(ling === "pt"){
                labelValorPlan = "Valor planejado";
                labelValorExec = "Valor executado";
                labelTexto = "Comparativo de Receita Por Etapa";
                vlabels = ['Pré-plantio', 'Plantio', 'Colheita', 'Manutenção', 'Armazenamento', 'Comercialização', 'Recebimento de Insumos', 'Entrega para Armazenamento', 'Entrega Para Comercialização'];
                labelEtapa = "Etapa";
                labelValor = "Valor";
            }
            else if(ling === "es"){
                labelValorPlan = "Planificado";
                labelValorExec = "Ejecutado";
                labelTexto = "Comparativo del Rendimiento Por Etapa";
                vlabels = ['Pre-siembra', 'Siembra', 'Vendimia', 'Mantenimiento', 'Almacenamiento', 'Comercialización', 'Recebimiento de Consumiveis', 'Entrega para el Almacenamiento', 'Entrega para la Comercialización'];
                labelEtapa = "Etapa";
                labelValor = "Valor";
            }
            else{
                labelValorPlan = "Planned value";
                labelValorExec = "Executed value";
                labelTexto = "Income Comparative By Stage";
                vlabels = ['Pre-planting', 'Planting', 'Ingathering', 'Maintenance', 'Storage', 'Commercialization', 'Inputs Receiving', 'Delivery for Storage', 'Delivery for Commercialization'];
                labelEtapa = "Stage";
                labelValor = "Value";
            }

            var chart = new Chart(ctx, {
                type: 'bar',

                data: {
                    labels: vlabels,
                    datasets: [
                        {
                            label: labelValorPlan,
                            backgroundColor: '#97edbf', 
                            //borderColor: 'rgb(255, 99, 132)',
                            data: vdatasplan,
                        },
                        {
                            label: labelValorExec,
                            backgroundColor: '#61c690', 
                            //borderColor: 'rgb(255, 99, 132)',
                            data: vdatasexec,
                        }
                    ]
                },

                // Configuration options go here
                options: {
                    scales: {
                        title: {
                            display: true,
                            text: labelTexto
                            },
                        yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: labelValor
                        },   
                        ticks: {
                            suggestedMin: 0  // minimum will be 0, unless there is a lower value.
                        }
                        }],

                        xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: labelEtapa
                        }
                        }]
                    }     

                }
            });
        }
    });
}

function linguagemcomp(){
    var urlJSON = '/api/account/';
    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            
            var linguagem = json.langKey;

            if(linguagem==="pt-br"){
            montaRelatorioComp('pt');
            }
            else if(linguagem==="en"){
                montaRelatorioComp('en');
            }
            else{
                montaRelatorioComp('es');
            }
        }
    });
}

function montaRelatorioComp(ling){
    if(ling==='pt'){
        $("#titulodespcomp").html("Comparativo de Despesas ao Longo do tempo");
        $("#tituloreccomp").html("Comparativo de Receita ao Longo do tempo");
        $("#titulodespcompetapa").html("Comparativo de Despesas por Etapas");
        $("#tituloreccompetapa").html("Comparativo de Receita por Etapas");
    }
    else if(ling==='es'){
        $("#titulodespcomp").html("Comparativo de los Gastos a lo largo del tiempo");
        $("#tituloreccomp").html("Comparativo del Rendimiento a lo largo del tiempo");
        $("#titulodespcompetapa").html("Comparativo de los Gastos por Etapas");
        $("#tituloreccompetapa").html("Comparativo del Rendimiento por Etapas");
    }
    else{
        $("#titulodespcomp").html("Output Comparative Over Time");
        $("#tituloreccomp").html("Income Comparative Over Time");
        $("#titulodespcompetapa").html("Output Comparative By Stages");
        $("#tituloreccompetapa").html("Income Comparative By Stages");
    }
    montaGrafDespesasComp(ling);
    montaGrafReceitasComp(ling);
    montaGrafDespesasEtapasComp(ling);
    montaGrafReceitasEtapasComp(ling);
}
function preencheSelector(id){
    $('#gerapdf').attr('disabled', true);
    var $select = $(id);

    $.ajax({
        url:  '/api/nomesafras/',
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            $select.html('');
            var listaOpcoes = json.map(function(item) {
                return item.nome;
            });

            for (var i = 0; i < listaOpcoes.length; i++) {
                $select.append('<option id="' + listaOpcoes[i] + '">' + listaOpcoes[i] + '</option>');
            }
        }
    });
}



preencheSelector('#selecsafra');
preencheSelector('#selecsafra2');
preencheSelector('#selecsafra3');
preencheSelector('#selecsafra4');

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MonitoramentoportatilDialogController', MonitoramentoportatilDialogController);

    MonitoramentoportatilDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Monitoramentoportatil', 'Propriedade', 'Safra'];

    function MonitoramentoportatilDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Monitoramentoportatil, Propriedade, Safra) {
        var vm = this;

        vm.monitoramentoportatil = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.propriedades = Propriedade.query();
        vm.safras = Safra.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.monitoramentoportatil.id !== null) {
                Monitoramentoportatil.update(vm.monitoramentoportatil, onSaveSuccess, onSaveError);
            } else {
                Monitoramentoportatil.save(vm.monitoramentoportatil, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:monitoramentoportatilUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.data = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MonitoramentoportatilDetailController', MonitoramentoportatilDetailController);

    MonitoramentoportatilDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Monitoramentoportatil', 'Propriedade', 'Safra'];

    function MonitoramentoportatilDetailController($scope, $rootScope, $stateParams, previousState, entity, Monitoramentoportatil, Propriedade, Safra) {
        var vm = this;

        vm.monitoramentoportatil = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:monitoramentoportatilUpdate', function(event, result) {
            vm.monitoramentoportatil = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MonitoramentoportatilDeleteController',MonitoramentoportatilDeleteController);

    MonitoramentoportatilDeleteController.$inject = ['$uibModalInstance', 'entity', 'Monitoramentoportatil'];

    function MonitoramentoportatilDeleteController($uibModalInstance, entity, Monitoramentoportatil) {
        var vm = this;

        vm.monitoramentoportatil = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Monitoramentoportatil.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('monitoramentoportatil', {
            parent: 'entity',
            url: '/monitoramentoportatil',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.monitoramentoportatil.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/monitoramentoportatil/monitoramentoportatils.html',
                    controller: 'MonitoramentoportatilController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('monitoramentoportatil');
                    $translatePartialLoader.addPart('tipomonitoramento');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('monitoramentoportatil-detail', {
            parent: 'monitoramentoportatil',
            url: '/monitoramentoportatil/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.monitoramentoportatil.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/monitoramentoportatil/monitoramentoportatil-detail.html',
                    controller: 'MonitoramentoportatilDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('monitoramentoportatil');
                    $translatePartialLoader.addPart('tipomonitoramento');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Monitoramentoportatil', function($stateParams, Monitoramentoportatil) {
                    return Monitoramentoportatil.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'monitoramentoportatil',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('monitoramentoportatil-detail.edit', {
            parent: 'monitoramentoportatil-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/monitoramentoportatil/monitoramentoportatil-dialog.html',
                    controller: 'MonitoramentoportatilDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Monitoramentoportatil', function(Monitoramentoportatil) {
                            return Monitoramentoportatil.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('monitoramentoportatil.new', {
            parent: 'monitoramentoportatil',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/monitoramentoportatil/monitoramentoportatil-dialog.html',
                    controller: 'MonitoramentoportatilDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                data: null,
                                latitude: null,
                                longitude: null,
                                tipomonitoramento: null,
                                tipopraga: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('monitoramentoportatil', null, { reload: 'monitoramentoportatil' });
                }, function() {
                    $state.go('monitoramentoportatil');
                });
            }]
        })
        .state('monitoramentoportatil.edit', {
            parent: 'monitoramentoportatil',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/monitoramentoportatil/monitoramentoportatil-dialog.html',
                    controller: 'MonitoramentoportatilDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Monitoramentoportatil', function(Monitoramentoportatil) {
                            return Monitoramentoportatil.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('monitoramentoportatil', null, { reload: 'monitoramentoportatil' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('monitoramentoportatil.delete', {
            parent: 'monitoramentoportatil',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/monitoramentoportatil/monitoramentoportatil-delete-dialog.html',
                    controller: 'MonitoramentoportatilDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Monitoramentoportatil', function(Monitoramentoportatil) {
                            return Monitoramentoportatil.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('monitoramentoportatil', null, { reload: 'monitoramentoportatil' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Monitoramentoportatil', Monitoramentoportatil);

    Monitoramentoportatil.$inject = ['$resource', 'DateUtils'];

    function Monitoramentoportatil ($resource, DateUtils) {
        var resourceUrl =  'api/monitoramentoportatils/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.data = DateUtils.convertLocalDateFromServer(data.data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.data = DateUtils.convertLocalDateToServer(copy.data);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.data = DateUtils.convertLocalDateToServer(copy.data);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('MonitoramentoportatilSearch', MonitoramentoportatilSearch);

    MonitoramentoportatilSearch.$inject = ['$resource'];

    function MonitoramentoportatilSearch($resource) {
        var resourceUrl =  'api/_search/monitoramentoportatils/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MonitoramentoportatilController', MonitoramentoportatilController);

    MonitoramentoportatilController.$inject = ['Monitoramentoportatil', 'MonitoramentoportatilSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function MonitoramentoportatilController(Monitoramentoportatil, MonitoramentoportatilSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.monitoramentoportatils = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                MonitoramentoportatilSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Monitoramentoportatil.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.monitoramentoportatils.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.monitoramentoportatils = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.monitoramentoportatils = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.monitoramentoportatils = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MicroregiaoDialogController', MicroregiaoDialogController);

    MicroregiaoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Microregiao', 'Cidade', 'Estado'];

    function MicroregiaoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Microregiao, Cidade, Estado) {
        var vm = this;

        vm.microregiao = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.cidades = Cidade.query();
        vm.estados = Estado.query({
            size:1000,
            sort: "nomeestado,asc"
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.microregiao.id !== null) {
                Microregiao.update(vm.microregiao, onSaveSuccess, onSaveError);
            } else {
                Microregiao.save(vm.microregiao, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:microregiaoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setImagemmicroregiao = function ($file, microregiao) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        microregiao.imagemmicroregiao = base64Data;
                        microregiao.imagemmicroregiaoContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MicroregiaoDetailController', MicroregiaoDetailController);

    MicroregiaoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Microregiao', 'Cidade', 'Estado'];

    function MicroregiaoDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Microregiao, Cidade, Estado) {
        var vm = this;

        vm.microregiao = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('netWordAgroApp:microregiaoUpdate', function(event, result) {
            vm.microregiao = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MicroregiaoDeleteController',MicroregiaoDeleteController);

    MicroregiaoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Microregiao'];

    function MicroregiaoDeleteController($uibModalInstance, entity, Microregiao) {
        var vm = this;

        vm.microregiao = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Microregiao.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('microregiao', {
            parent: 'entity',
            url: '/microregiao?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.microregiao.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/microregiao/microregiaos.html',
                    controller: 'MicroregiaoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('microregiao');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('microregiao-detail', {
            parent: 'microregiao',
            url: '/microregiao/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.microregiao.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/microregiao/microregiao-detail.html',
                    controller: 'MicroregiaoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('microregiao');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Microregiao', function($stateParams, Microregiao) {
                    return Microregiao.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'microregiao',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('microregiao-detail.edit', {
            parent: 'microregiao-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/microregiao/microregiao-dialog.html',
                    controller: 'MicroregiaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Microregiao', function(Microregiao) {
                            return Microregiao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('microregiao.new', {
            parent: 'microregiao',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/microregiao/microregiao-dialog.html',
                    controller: 'MicroregiaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nomemicroregiao: null,
                                imagemmicroregiao: null,
                                imagemmicroregiaoContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('microregiao', null, { reload: 'microregiao' });
                }, function() {
                    $state.go('microregiao');
                });
            }]
        })
        .state('microregiao.edit', {
            parent: 'microregiao',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/microregiao/microregiao-dialog.html',
                    controller: 'MicroregiaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Microregiao', function(Microregiao) {
                            return Microregiao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('microregiao', null, { reload: 'microregiao' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('microregiao.delete', {
            parent: 'microregiao',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/microregiao/microregiao-delete-dialog.html',
                    controller: 'MicroregiaoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Microregiao', function(Microregiao) {
                            return Microregiao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('microregiao', null, { reload: 'microregiao' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Microregiao', Microregiao);

    Microregiao.$inject = ['$resource'];

    function Microregiao ($resource) {
        var resourceUrl =  'api/microregiaos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('MicroregiaoSearch', MicroregiaoSearch);

    MicroregiaoSearch.$inject = ['$resource'];

    function MicroregiaoSearch($resource) {
        var resourceUrl =  'api/_search/microregiaos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MicroregiaoController', MicroregiaoController);

    MicroregiaoController.$inject = ['$state', 'DataUtils', 'Microregiao', 'MicroregiaoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function MicroregiaoController($state, DataUtils, Microregiao, MicroregiaoSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                MicroregiaoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Microregiao.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.microregiaos = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MedicaoatribpesqDialogController', MedicaoatribpesqDialogController);

    MedicaoatribpesqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Medicaoatribpesq', 'Atributopesquisa', 'Pesquisa', 'Pontossensoriamentosolo'];

    function MedicaoatribpesqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Medicaoatribpesq, Atributopesquisa, Pesquisa, Pontossensoriamentosolo) {
        var vm = this;

        vm.medicaoatribpesq = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.atributopesquisas = Atributopesquisa.query();
        vm.pesquisas = Pesquisa.query();
        vm.pontossensoriamentosolos = Pontossensoriamentosolo.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.medicaoatribpesq.id !== null) {
                Medicaoatribpesq.update(vm.medicaoatribpesq, onSaveSuccess, onSaveError);
            } else {
                Medicaoatribpesq.save(vm.medicaoatribpesq, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:medicaoatribpesqUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datahoramedicao = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MedicaoatribpesqDetailController', MedicaoatribpesqDetailController);

    MedicaoatribpesqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Medicaoatribpesq', 'Atributopesquisa', 'Pesquisa', 'Pontossensoriamentosolo'];

    function MedicaoatribpesqDetailController($scope, $rootScope, $stateParams, previousState, entity, Medicaoatribpesq, Atributopesquisa, Pesquisa, Pontossensoriamentosolo) {
        var vm = this;

        vm.medicaoatribpesq = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:medicaoatribpesqUpdate', function(event, result) {
            vm.medicaoatribpesq = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MedicaoatribpesqDeleteController',MedicaoatribpesqDeleteController);

    MedicaoatribpesqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Medicaoatribpesq'];

    function MedicaoatribpesqDeleteController($uibModalInstance, entity, Medicaoatribpesq) {
        var vm = this;

        vm.medicaoatribpesq = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Medicaoatribpesq.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('medicaoatribpesq', {
            parent: 'entity',
            url: '/medicaoatribpesq',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.medicaoatribpesq.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/medicaoatribpesq/medicaoatribpesqs.html',
                    controller: 'MedicaoatribpesqController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('medicaoatribpesq');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('medicaoatribpesq-detail', {
            parent: 'medicaoatribpesq',
            url: '/medicaoatribpesq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.medicaoatribpesq.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/medicaoatribpesq/medicaoatribpesq-detail.html',
                    controller: 'MedicaoatribpesqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('medicaoatribpesq');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Medicaoatribpesq', function($stateParams, Medicaoatribpesq) {
                    return Medicaoatribpesq.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'medicaoatribpesq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('medicaoatribpesq-detail.edit', {
            parent: 'medicaoatribpesq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/medicaoatribpesq/medicaoatribpesq-dialog.html',
                    controller: 'MedicaoatribpesqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Medicaoatribpesq', function(Medicaoatribpesq) {
                            return Medicaoatribpesq.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('medicaoatribpesq.new', {
            parent: 'medicaoatribpesq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/medicaoatribpesq/medicaoatribpesq-dialog.html',
                    controller: 'MedicaoatribpesqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                datahoramedicao: null,
                                freqmedicao: null,
                                conduteletricamedicao: null,
                                umidmedicao: null,
                                tempmedicao: null,
                                valorconcentracao: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('medicaoatribpesq', null, { reload: 'medicaoatribpesq' });
                }, function() {
                    $state.go('medicaoatribpesq');
                });
            }]
        })
        .state('medicaoatribpesq.edit', {
            parent: 'medicaoatribpesq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/medicaoatribpesq/medicaoatribpesq-dialog.html',
                    controller: 'MedicaoatribpesqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Medicaoatribpesq', function(Medicaoatribpesq) {
                            return Medicaoatribpesq.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('medicaoatribpesq', null, { reload: 'medicaoatribpesq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('medicaoatribpesq.delete', {
            parent: 'medicaoatribpesq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/medicaoatribpesq/medicaoatribpesq-delete-dialog.html',
                    controller: 'MedicaoatribpesqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Medicaoatribpesq', function(Medicaoatribpesq) {
                            return Medicaoatribpesq.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('medicaoatribpesq', null, { reload: 'medicaoatribpesq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Medicaoatribpesq', Medicaoatribpesq);

    Medicaoatribpesq.$inject = ['$resource', 'DateUtils'];

    function Medicaoatribpesq ($resource, DateUtils) {
        var resourceUrl =  'api/medicaoatribpesqs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datahoramedicao = DateUtils.convertLocalDateFromServer(data.datahoramedicao);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datahoramedicao = DateUtils.convertLocalDateToServer(copy.datahoramedicao);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datahoramedicao = DateUtils.convertLocalDateToServer(copy.datahoramedicao);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('MedicaoatribpesqSearch', MedicaoatribpesqSearch);

    MedicaoatribpesqSearch.$inject = ['$resource'];

    function MedicaoatribpesqSearch($resource) {
        var resourceUrl =  'api/_search/medicaoatribpesqs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MedicaoatribpesqController', MedicaoatribpesqController);

    MedicaoatribpesqController.$inject = ['Medicaoatribpesq', 'MedicaoatribpesqSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function MedicaoatribpesqController(Medicaoatribpesq, MedicaoatribpesqSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.medicaoatribpesqs = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                MedicaoatribpesqSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Medicaoatribpesq.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.medicaoatribpesqs.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.medicaoatribpesqs = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.medicaoatribpesqs = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.medicaoatribpesqs = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MedicaoatriblavouraDialogController', MedicaoatriblavouraDialogController);

    MedicaoatriblavouraDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Medicaoatriblavoura', 'Pesquisa', 'Atributopesquisa', 'Quadranteimagem'];

    function MedicaoatriblavouraDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Medicaoatriblavoura, Pesquisa, Atributopesquisa, Quadranteimagem) {
        var vm = this;

        vm.medicaoatriblavoura = entity;
        vm.clear = clear;
        vm.save = save;
        vm.pesquisas = Pesquisa.query();
        vm.atributopesquisas = Atributopesquisa.query();
        vm.quadranteimagems = Quadranteimagem.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.medicaoatriblavoura.id !== null) {
                Medicaoatriblavoura.update(vm.medicaoatriblavoura, onSaveSuccess, onSaveError);
            } else {
                Medicaoatriblavoura.save(vm.medicaoatriblavoura, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:medicaoatriblavouraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MedicaoatriblavouraDetailController', MedicaoatriblavouraDetailController);

    MedicaoatriblavouraDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Medicaoatriblavoura', 'Pesquisa', 'Atributopesquisa', 'Quadranteimagem'];

    function MedicaoatriblavouraDetailController($scope, $rootScope, $stateParams, previousState, entity, Medicaoatriblavoura, Pesquisa, Atributopesquisa, Quadranteimagem) {
        var vm = this;

        vm.medicaoatriblavoura = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:medicaoatriblavouraUpdate', function(event, result) {
            vm.medicaoatriblavoura = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MedicaoatriblavouraDeleteController',MedicaoatriblavouraDeleteController);

    MedicaoatriblavouraDeleteController.$inject = ['$uibModalInstance', 'entity', 'Medicaoatriblavoura'];

    function MedicaoatriblavouraDeleteController($uibModalInstance, entity, Medicaoatriblavoura) {
        var vm = this;

        vm.medicaoatriblavoura = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Medicaoatriblavoura.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('medicaoatriblavoura', {
            parent: 'entity',
            url: '/medicaoatriblavoura',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.medicaoatriblavoura.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/medicaoatriblavoura/medicaoatriblavouras.html',
                    controller: 'MedicaoatriblavouraController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('medicaoatriblavoura');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('medicaoatriblavoura-detail', {
            parent: 'medicaoatriblavoura',
            url: '/medicaoatriblavoura/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.medicaoatriblavoura.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/medicaoatriblavoura/medicaoatriblavoura-detail.html',
                    controller: 'MedicaoatriblavouraDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('medicaoatriblavoura');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Medicaoatriblavoura', function($stateParams, Medicaoatriblavoura) {
                    return Medicaoatriblavoura.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'medicaoatriblavoura',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('medicaoatriblavoura-detail.edit', {
            parent: 'medicaoatriblavoura-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/medicaoatriblavoura/medicaoatriblavoura-dialog.html',
                    controller: 'MedicaoatriblavouraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Medicaoatriblavoura', function(Medicaoatriblavoura) {
                            return Medicaoatriblavoura.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('medicaoatriblavoura.new', {
            parent: 'medicaoatriblavoura',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/medicaoatriblavoura/medicaoatriblavoura-dialog.html',
                    controller: 'MedicaoatriblavouraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nomemonitoramento: null,
                                corassociada: null,
                                tipomonitoramento: null,
                                valoraquisitado: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('medicaoatriblavoura', null, { reload: 'medicaoatriblavoura' });
                }, function() {
                    $state.go('medicaoatriblavoura');
                });
            }]
        })
        .state('medicaoatriblavoura.edit', {
            parent: 'medicaoatriblavoura',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/medicaoatriblavoura/medicaoatriblavoura-dialog.html',
                    controller: 'MedicaoatriblavouraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Medicaoatriblavoura', function(Medicaoatriblavoura) {
                            return Medicaoatriblavoura.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('medicaoatriblavoura', null, { reload: 'medicaoatriblavoura' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('medicaoatriblavoura.delete', {
            parent: 'medicaoatriblavoura',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/medicaoatriblavoura/medicaoatriblavoura-delete-dialog.html',
                    controller: 'MedicaoatriblavouraDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Medicaoatriblavoura', function(Medicaoatriblavoura) {
                            return Medicaoatriblavoura.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('medicaoatriblavoura', null, { reload: 'medicaoatriblavoura' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Medicaoatriblavoura', Medicaoatriblavoura);

    Medicaoatriblavoura.$inject = ['$resource'];

    function Medicaoatriblavoura ($resource) {
        var resourceUrl =  'api/medicaoatriblavouras/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('MedicaoatriblavouraSearch', MedicaoatriblavouraSearch);

    MedicaoatriblavouraSearch.$inject = ['$resource'];

    function MedicaoatriblavouraSearch($resource) {
        var resourceUrl =  'api/_search/medicaoatriblavouras/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MedicaoatriblavouraController', MedicaoatriblavouraController);

    MedicaoatriblavouraController.$inject = ['Medicaoatriblavoura', 'MedicaoatriblavouraSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function MedicaoatriblavouraController(Medicaoatriblavoura, MedicaoatriblavouraSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.medicaoatriblavouras = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                MedicaoatriblavouraSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Medicaoatriblavoura.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.medicaoatriblavouras.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.medicaoatriblavouras = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.medicaoatriblavouras = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.medicaoatriblavouras = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MatrizsensoriamentoDialogController', MatrizsensoriamentoDialogController);

    MatrizsensoriamentoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Matrizsensoriamento', 'Quadranteimagem', 'Quadrantesolo', 'Pesquisa'];

    function MatrizsensoriamentoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Matrizsensoriamento, Quadranteimagem, Quadrantesolo, Pesquisa) {
        var vm = this;

        vm.matrizsensoriamento = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.quadranteimagems = Quadranteimagem.query();
        vm.quadrantesolos = Quadrantesolo.query();
        vm.pesquisas = Pesquisa.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.matrizsensoriamento.id !== null) {
                Matrizsensoriamento.update(vm.matrizsensoriamento, onSaveSuccess, onSaveError);
            } else {
                Matrizsensoriamento.save(vm.matrizsensoriamento, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:matrizsensoriamentoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setImagemmatriz = function ($file, matrizsensoriamento) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        matrizsensoriamento.imagemmatriz = base64Data;
                        matrizsensoriamento.imagemmatrizContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MatrizsensoriamentoDetailController', MatrizsensoriamentoDetailController);

    MatrizsensoriamentoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Matrizsensoriamento', 'Quadranteimagem', 'Quadrantesolo', 'Pesquisa'];

    function MatrizsensoriamentoDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Matrizsensoriamento, Quadranteimagem, Quadrantesolo, Pesquisa) {
        var vm = this;

        vm.matrizsensoriamento = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('netWordAgroApp:matrizsensoriamentoUpdate', function(event, result) {
            vm.matrizsensoriamento = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MatrizsensoriamentoDeleteController',MatrizsensoriamentoDeleteController);

    MatrizsensoriamentoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Matrizsensoriamento'];

    function MatrizsensoriamentoDeleteController($uibModalInstance, entity, Matrizsensoriamento) {
        var vm = this;

        vm.matrizsensoriamento = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Matrizsensoriamento.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('matrizsensoriamento', {
            parent: 'entity',
            url: '/matrizsensoriamento',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.matrizsensoriamento.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/matrizsensoriamento/matrizsensoriamentos.html',
                    controller: 'MatrizsensoriamentoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('matrizsensoriamento');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('matrizsensoriamento-detail', {
            parent: 'matrizsensoriamento',
            url: '/matrizsensoriamento/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.matrizsensoriamento.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/matrizsensoriamento/matrizsensoriamento-detail.html',
                    controller: 'MatrizsensoriamentoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('matrizsensoriamento');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Matrizsensoriamento', function($stateParams, Matrizsensoriamento) {
                    return Matrizsensoriamento.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'matrizsensoriamento',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('matrizsensoriamento-detail.edit', {
            parent: 'matrizsensoriamento-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/matrizsensoriamento/matrizsensoriamento-dialog.html',
                    controller: 'MatrizsensoriamentoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Matrizsensoriamento', function(Matrizsensoriamento) {
                            return Matrizsensoriamento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('matrizsensoriamento.new', {
            parent: 'matrizsensoriamento',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/matrizsensoriamento/matrizsensoriamento-dialog.html',
                    controller: 'MatrizsensoriamentoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nomematriz: null,
                                imagemmatriz: null,
                                imagemmatrizContentType: null,
                                valorlatitudep1: null,
                                valorlongitudep1: null,
                                valorlatitudep2: null,
                                valorlongitudep2: null,
                                valorlatitudep3: null,
                                valorlongitudep3: null,
                                valorlatitudep4: null,
                                valorlongitudep4: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('matrizsensoriamento', null, { reload: 'matrizsensoriamento' });
                }, function() {
                    $state.go('matrizsensoriamento');
                });
            }]
        })
        .state('matrizsensoriamento.edit', {
            parent: 'matrizsensoriamento',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/matrizsensoriamento/matrizsensoriamento-dialog.html',
                    controller: 'MatrizsensoriamentoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Matrizsensoriamento', function(Matrizsensoriamento) {
                            return Matrizsensoriamento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('matrizsensoriamento', null, { reload: 'matrizsensoriamento' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('matrizsensoriamento.delete', {
            parent: 'matrizsensoriamento',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/matrizsensoriamento/matrizsensoriamento-delete-dialog.html',
                    controller: 'MatrizsensoriamentoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Matrizsensoriamento', function(Matrizsensoriamento) {
                            return Matrizsensoriamento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('matrizsensoriamento', null, { reload: 'matrizsensoriamento' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Matrizsensoriamento', Matrizsensoriamento);

    Matrizsensoriamento.$inject = ['$resource'];

    function Matrizsensoriamento ($resource) {
        var resourceUrl =  'api/matrizsensoriamentos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('MatrizsensoriamentoSearch', MatrizsensoriamentoSearch);

    MatrizsensoriamentoSearch.$inject = ['$resource'];

    function MatrizsensoriamentoSearch($resource) {
        var resourceUrl =  'api/_search/matrizsensoriamentos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MatrizsensoriamentoController', MatrizsensoriamentoController);

    MatrizsensoriamentoController.$inject = ['DataUtils', 'Matrizsensoriamento', 'MatrizsensoriamentoSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function MatrizsensoriamentoController(DataUtils, Matrizsensoriamento, MatrizsensoriamentoSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.matrizsensoriamentos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                MatrizsensoriamentoSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Matrizsensoriamento.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.matrizsensoriamentos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.matrizsensoriamentos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.matrizsensoriamentos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.matrizsensoriamentos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MaquinarioDialogController', MaquinarioDialogController);

    MaquinarioDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Maquinario', 'Pedido'];

    function MaquinarioDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Maquinario, Pedido) {
        var vm = this;

        vm.maquinario = entity;
        vm.clear = clear;
        vm.save = save;
        vm.pedidos = Pedido.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.maquinario.id !== null) {
                Maquinario.update(vm.maquinario, onSaveSuccess, onSaveError);
            } else {
                Maquinario.save(vm.maquinario, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:maquinarioUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MaquinarioDetailController', MaquinarioDetailController);

    MaquinarioDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Maquinario', 'Pedido'];

    function MaquinarioDetailController($scope, $rootScope, $stateParams, previousState, entity, Maquinario, Pedido) {
        var vm = this;

        vm.maquinario = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:maquinarioUpdate', function(event, result) {
            vm.maquinario = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MaquinarioDeleteController',MaquinarioDeleteController);

    MaquinarioDeleteController.$inject = ['$uibModalInstance', 'entity', 'Maquinario'];

    function MaquinarioDeleteController($uibModalInstance, entity, Maquinario) {
        var vm = this;

        vm.maquinario = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Maquinario.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('maquinario', {
            parent: 'entity',
            url: '/maquinario',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.maquinario.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/maquinario/maquinarios.html',
                    controller: 'MaquinarioController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('maquinario');
                    $translatePartialLoader.addPart('tipogps');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('maquinario-detail', {
            parent: 'maquinario',
            url: '/maquinario/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.maquinario.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/maquinario/maquinario-detail.html',
                    controller: 'MaquinarioDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('maquinario');
                    $translatePartialLoader.addPart('tipogps');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Maquinario', function($stateParams, Maquinario) {
                    return Maquinario.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'maquinario',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('maquinario-detail.edit', {
            parent: 'maquinario-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/maquinario/maquinario-dialog.html',
                    controller: 'MaquinarioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Maquinario', function(Maquinario) {
                            return Maquinario.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('maquinario.new', {
            parent: 'maquinario',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/maquinario/maquinario-dialog.html',
                    controller: 'MaquinarioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                marca: null,
                                modelo: null,
                                monitor: null,
                                tamanho: null,
                                estruturapastas: null,
                                modogps: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('maquinario', null, { reload: 'maquinario' });
                }, function() {
                    $state.go('maquinario');
                });
            }]
        })
        .state('maquinario.edit', {
            parent: 'maquinario',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/maquinario/maquinario-dialog.html',
                    controller: 'MaquinarioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Maquinario', function(Maquinario) {
                            return Maquinario.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('maquinario', null, { reload: 'maquinario' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('maquinario.delete', {
            parent: 'maquinario',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/maquinario/maquinario-delete-dialog.html',
                    controller: 'MaquinarioDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Maquinario', function(Maquinario) {
                            return Maquinario.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('maquinario', null, { reload: 'maquinario' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Maquinario', Maquinario);

    Maquinario.$inject = ['$resource'];

    function Maquinario ($resource) {
        var resourceUrl =  'api/maquinarios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('MaquinarioSearch', MaquinarioSearch);

    MaquinarioSearch.$inject = ['$resource'];

    function MaquinarioSearch($resource) {
        var resourceUrl =  'api/_search/maquinarios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MaquinarioController', MaquinarioController);

    MaquinarioController.$inject = ['Maquinario', 'MaquinarioSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function MaquinarioController(Maquinario, MaquinarioSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.maquinarios = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                MaquinarioSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Maquinario.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.maquinarios.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.maquinarios = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.maquinarios = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.maquinarios = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MapaimagemVisualizarController', MapaimagemVisualizarController);

    MapaimagemVisualizarController.$inject = ['DataUtils', 'Mapaimagem', 'ParseLinks', 'AlertService', 'paginationConstants', '$stateParams'];

    function MapaimagemVisualizarController(DataUtils, Mapaimagem, ParseLinks, AlertService, paginationConstants, $stateParams) {
        var vm = this;
        vm.carregando = true;
        vm.sucesso = sucesso;
        vm.nomemapa = null;

        vm.idmapa = $stateParams.id;


        function sucesso(data){
            vm.nomemapa = data[0].nomemapa;
            vm.fileURL = 'data:' + data[0].imagempequenaContentType +';base64,' + data[0].imagempequena;
            vm.carregando = false;
        }

        Mapaimagem.queryImagemPequena({mapaid: vm.idmapa}, vm.sucesso);

    
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MapaimagemDialogController', MapaimagemDialogController);

    MapaimagemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Mapaimagem', 'Concentracaoindice', 'Imagemtermica', 'Propostareceituario', 'Safra', 'Propriedade', 'Atributo'];

    function MapaimagemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Mapaimagem, Concentracaoindice, Imagemtermica, Propostareceituario, Safra, Propriedade, Atributo) {
        var vm = this;

        vm.mapaimagem = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.concentracaoindices = Concentracaoindice.query();
        vm.imagemtermicas = Imagemtermica.query();
        vm.propostareceituarios = Propostareceituario.query();
        vm.safras = Safra.querySafraIdNome(
            {size: 1000, sort:"nomesafra,asc"}
        );
        vm.propriedades = Propriedade.queryNomesPropriedades(
            {size: 1000, sort:"nomepropriedade,asc"}
        );
        vm.atributos = Atributo.query(
            {size: 1000, sort: "nomeatributo,asc"}
        );

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.mapaimagem.id !== null) {
                Mapaimagem.update(vm.mapaimagem, onSaveSuccess, onSaveError);
            } else {
                Mapaimagem.save(vm.mapaimagem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:mapaimagemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setImagem = function ($file, mapaimagem) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        mapaimagem.imagem = base64Data;
                        mapaimagem.imagemContentType = $file.type;
                    });
                });
            }
        };

        vm.setImagempequena = function ($file, mapaimagem) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        mapaimagem.imagempequena = base64Data;
                        mapaimagem.imagempequenaContentType = $file.type;
                    });
                });
            }
        };
        vm.datePickerOpenStatus.data = false;

        vm.setShapefile = function ($file, mapaimagem) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        mapaimagem.shapefile = base64Data;
                        mapaimagem.shapefileContentType = $file.type;
                    });
                });
            }
        };
        
        vm.setWKT = function ($file, mapaimagem) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        mapaimagem.wkt = base64Data;
                        mapaimagem.wktContentType = $file.type;
                    });
                });
            }
        };
        
        vm.setCSV = function ($file, mapaimagem) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        mapaimagem.csv = base64Data;
                        mapaimagem.csvContentType = $file.type;
                    });
                });
            }
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MapaimagemDetailController', MapaimagemDetailController);

    MapaimagemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Mapaimagem', 'Safra', 'Propriedade', 'Atributo', 'Propostareceituario', 'Imagemtermica', 'Concentracaoindice'];

    function MapaimagemDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Mapaimagem, Safra, Propriedade, Atributo, Propostareceituario, Imagemtermica, Concentracaoindice) {
        var vm = this;

        vm.mapaimagem = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('netWordAgroApp:mapaimagemUpdate', function(event, result) {
            vm.mapaimagem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MapaimagemDeleteController',MapaimagemDeleteController);

    MapaimagemDeleteController.$inject = ['$uibModalInstance', 'entity', 'Mapaimagem'];

    function MapaimagemDeleteController($uibModalInstance, entity, Mapaimagem) {
        var vm = this;

        vm.mapaimagem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Mapaimagem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('mapaimagem', {
            parent: 'entity',
            url: '/mapaimagem',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.mapaimagem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/mapaimagem/mapaimagems.html',
                    controller: 'MapaimagemController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('mapaimagem');
                    $translatePartialLoader.addPart('tipoimagem');
                    $translatePartialLoader.addPart('tipomapa');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('mapaimagem-detail', {
            parent: 'mapaimagem',
            url: '/mapaimagem/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.mapaimagem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/mapaimagem/mapaimagem-detail.html',
                    controller: 'MapaimagemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('mapaimagem');
                    $translatePartialLoader.addPart('tipoimagem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Mapaimagem', function($stateParams, Mapaimagem) {
                    return Mapaimagem.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'mapaimagem',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('mapaimagem-visualizarimagem', {
            parent: 'mapaimagem',
            url: '/visualizarimagem/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.mapaimagem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/mapaimagem/mapaimagem-visualizar.html',
                    controller: 'MapaimagemVisualizarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('mapaimagem');
                    $translatePartialLoader.addPart('tipoimagem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', function($stateParams, Mapaimagem) {
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'mapaimagem',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('mapaimagem-detail.edit', {
            parent: 'mapaimagem-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/mapaimagem/mapaimagem-dialog.html',
                    controller: 'MapaimagemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Mapaimagem', function(Mapaimagem) {
                            return Mapaimagem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('mapaimagem.new', {
            parent: 'mapaimagem',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/mapaimagem/mapaimagem-dialog.html',
                    controller: 'MapaimagemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nomemapa: null,
                                imagem: null,
                                imagemContentType: null,
                                latitudecentro: null,
                                longitudecentro: null,
                                tipoimagem: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('mapaimagem', null, { reload: 'mapaimagem' });
                }, function() {
                    $state.go('mapaimagem');
                });
            }]
        })
        .state('mapaimagem.edit', {
            parent: 'mapaimagem',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/mapaimagem/mapaimagem-dialog.html',
                    controller: 'MapaimagemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Mapaimagem', function(Mapaimagem) {
                            return Mapaimagem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('mapaimagem', null, { reload: 'mapaimagem' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('mapaimagem.delete', {
            parent: 'mapaimagem',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/mapaimagem/mapaimagem-delete-dialog.html',
                    controller: 'MapaimagemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Mapaimagem', function(Mapaimagem) {
                            return Mapaimagem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('mapaimagem', null, { reload: 'mapaimagem' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('mapacomparativo', {
            parent: 'entity',
            url: '/mapacomparativo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.mapaimagem.home.titleComparativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/mapaimagem/comparativo-mapas.html',
                    controller: 'MapacomparativoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('mapaimagem');
                    $translatePartialLoader.addPart('tipoimagem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('mapa-calor', {
            parent: 'entity',
            url: '/mapa-calor',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.mapaimagem.mapasdecalortitle'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/mapaimagem/mapa-calor.html',
                    controller: 'MapaCalorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('mapaimagem');
                    $translatePartialLoader.addPart('tipoimagem');
                    $translatePartialLoader.addPart('tipomapa');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('mapa-interativo', {
            parent: 'entity',
            url: '/mapa-interativo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.mapaimagem.mapasinterativostitle'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/mapaimagem/mapa-interativo.html',
                    controller: 'MapaInterativoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('mapaimagem');
                    $translatePartialLoader.addPart('tipoimagem');
                    $translatePartialLoader.addPart('tipomapa');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('mapa-calor-mobile', {
            parent: 'entity',
            url: '/mapa-calor-mobile/{idtoken}',
            data: {
                authorities: [],
                pageTitle: 'netWordAgroApp.mapaimagem.mapasdecalortitle'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/mapaimagem/mapa-calor-mobile.html',
                    controller: 'MapaCalorMobileController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('mapaimagem');
                    $translatePartialLoader.addPart('tipoimagem');
                    $translatePartialLoader.addPart('tipomapa');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('mapa-interativo-mobile', {
            parent: 'entity',
            url: '/mapa-interativo-mobile/{idtoken}',
            data: {
                authorities: [],
                pageTitle: 'netWordAgroApp.mapaimagem.mapasinterativostitle'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/mapaimagem/mapa-interativo-mobile.html',
                    controller: 'MapaInterativoMobileController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('mapaimagem');
                    $translatePartialLoader.addPart('tipoimagem');
                    $translatePartialLoader.addPart('tipomapa');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Mapaimagem', Mapaimagem);

    Mapaimagem.$inject = ['$resource'];

    function Mapaimagem ($resource) {
        var resourceUrl =  'api/mapaimagems/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'querySemImagem': { 
                url: '/api/mapaimagemssemimagem',
                method: 'GET', 
                isArray: true},
            'queryImagem': { 
                url: '/api/mapaimagemsimagem/:mapaid',
                method: 'GET', 
                isArray: true},
            'queryImagemPequena': { 
                url: '/api/mapaimagemsimagempequena/:mapaid',
                method: 'GET', 
                isArray: true},
            'queryComparativoPragaSaude': { 
                url: '/api/mapaimagems/:safraid/:busca',
                method: 'GET', 
                isArray: true},
            'queryComparativoNutricional': { 
                url: '/api/mapanutricionalimagems/:safraid/:busca',
                method: 'GET', 
                isArray: true},
            'queryShapefile': { 
                url: '/api/mapaimagemsshapefile/:mapaid',
                method: 'GET', 
                isArray: true},
            'queryCSV': { 
                url: '/api/mapaimagemscsv/:mapaid',
                method: 'GET', 
                isArray: true},
            'queryWKT': { 
                url: '/api/mapaimagemswkt/:mapaid',
                method: 'GET', 
                isArray: true},
            'queryGaleria': {
                url: 'api/mapaimagems/galeria/:propid',  
                method: 'GET', 
                isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('MapaimagemSearch', MapaimagemSearch);

    MapaimagemSearch.$inject = ['$resource'];

    function MapaimagemSearch($resource) {
        var resourceUrl =  'api/_search/mapaimagems/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MapaimagemController', MapaimagemController);

    MapaimagemController.$inject = ['DataUtils', 'Mapaimagem', 'MapaimagemSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'Propriedade'];

    function MapaimagemController(DataUtils, Mapaimagem, MapaimagemSearch, ParseLinks, AlertService, paginationConstants, Propriedade) {

        var vm = this;

        vm.mapaimagems = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = 20;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = false;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.abrirImagem = abrirImagem;
        vm.sucesso = sucesso;

        vm.download = download;
        vm.sucessoDownload = sucessoDownload;

        vm.downloadShape = downloadShape;
        vm.sucessoDownloadShape = sucessoDownloadShape;
        
        vm.downloadWKT = downloadWKT;
        vm.sucessoDownloadWKT = sucessoDownloadWKT;
        
        vm.downloadCSV = downloadCSV;
        vm.sucessoDownloadCSV = sucessoDownloadCSV;

        vm.filtropropriedade = null;
        
        loadAll();

        vm.filtropropriedades = Propriedade.queryNomesPropriedades({
            size: 1000,
            sort: "nomepropriedade,asc"
        });

        vm.changeFiltro = function (){
            console.log("Propriedade alterada!");
            console.log(vm.filtropropriedade); 
            vm.page = 0;
            vm.mapaimagems = [];
            loadAll();
        };

        function loadAll () {
            if (vm.currentSearch) {
                MapaimagemSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Mapaimagem.querySemImagem({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for(var i = 0; i < data.length; i++) {
                    if(vm.filtropropriedade === null || parseInt(vm.filtropropriedade.id) === data[i].propriedade_id){
                        console.log("Added");
                        vm.mapaimagems.push(data[i]);
                    }
                }

                if(vm.mapaimagems.length == 0 && vm.page < vm.links['last']){
                    console.log("Vazio");
                    vm.page = vm.page + 1;
                    loadPage(vm.page);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

        }

        function reset () {
            vm.page = 0;
            vm.mapaimagems = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.mapaimagems = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.mapaimagems = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }

        function sucesso(data){
            vm.openFile(data[0].imagempequenaContentType, data[0].imagempequena);
        }

        function abrirImagem(id){
            
            Mapaimagem.queryImagemPequena({mapaid: id}, vm.sucesso);
            
        }


        function b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;
          
            var byteCharacters = atob(b64Data);
            var byteArrays = [];
          
            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);
            
                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
            
                var byteArray = new Uint8Array(byteNumbers);
            
                byteArrays.push(byteArray);
            }
          
            var blob = new Blob(byteArrays, {type: contentType});
            return blob;
        }

        function sucessoDownload(data){
            var filename = 'mapa';
            console.log("SUCESSO");
            var ct = data[0].imagemContentType;
            var dados = data[0].imagem;
            
            /*
                element.setAttribute('href', 'data:' + ct + ';base64,' + dados);
                element.setAttribute('download', 'download');
            
                element.style.display = 'none';
                
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            */

           var blob = b64toBlob(dados, ct);

           if(window.navigator.msSaveOrOpenBlob) {
               window.navigator.msSaveBlob(blob, filename);
           }
           else{
               var elem = window.document.createElement('a');
               elem.href = window.URL.createObjectURL(blob);
               elem.download = filename;
               document.body.appendChild(elem);
               elem.click();
               document.body.removeChild(elem);
           }
        }
        
        function sucessoDownloadShape(data){
            var filename = 'shapefile';
            console.log("SUCESSO");
            var ct = data[0].shapefileContentType;
            var dados = data[0].shapefile;
            
            if(ct === null) {
                alert("Nenhum shapefile associado ao mapa");
                return;
            }

            /*
                element.setAttribute('href', 'data:' + ct + ';base64,' + dados);
                element.setAttribute('download', 'download');
            
                element.style.display = 'none';
                
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            */

           var blob = b64toBlob(dados, ct);

           if(window.navigator.msSaveOrOpenBlob) {
               window.navigator.msSaveBlob(blob, filename);
           }
           else{
               var elem = window.document.createElement('a');
               elem.href = window.URL.createObjectURL(blob);
               elem.download = filename;        
               document.body.appendChild(elem);
               elem.click();        
               document.body.removeChild(elem);
           }
        }
        
        function sucessoDownloadCSV(data){
            var filename = 'proposta.csv';
            console.log("SUCESSO");
            var ct = data[0].csvContentType;
            var dados = data[0].csv;
            
            if(ct === null) {
                alert("Nenhuma proposta associada ao mapa");
                return;
            }

            /*
                element.setAttribute('href', 'data:' + ct + ';base64,' + dados);
                element.setAttribute('download', 'download');
            
                element.style.display = 'none';
                
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            */

           var blob = b64toBlob(dados, ct);

           if(window.navigator.msSaveOrOpenBlob) {
               window.navigator.msSaveBlob(blob, filename);
           }
           else{
               var elem = window.document.createElement('a');
               elem.href = window.URL.createObjectURL(blob);
               elem.download = filename;        
               document.body.appendChild(elem);
               elem.click();        
               document.body.removeChild(elem);
           }
        }
        
        function sucessoDownloadWKT(data){
            var filename = 'wkt.wkt';
            console.log("SUCESSO");
            var ct = data[0].wktContentType;
            var dados = data[0].wkt;
            
            if(ct === null) {
                alert("Nenhum wkt associado ao mapa");
                return;
            }

            /*
                element.setAttribute('href', 'data:' + ct + ';base64,' + dados);
                element.setAttribute('download', 'download');
            
                element.style.display = 'none';
                
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            */

           var blob = b64toBlob(dados, ct);

           if(window.navigator.msSaveOrOpenBlob) {
               window.navigator.msSaveBlob(blob, filename);
           }
           else{
               var elem = window.document.createElement('a');
               elem.href = window.URL.createObjectURL(blob);
               elem.download = filename;        
               document.body.appendChild(elem);
               elem.click();        
               document.body.removeChild(elem);
           }
        }


        function download(id){
            
            Mapaimagem.queryImagem({mapaid: id}, vm.sucessoDownload);
            
        }

        function downloadShape(id){
            Mapaimagem.queryShapefile({mapaid: id}, vm.sucessoDownloadShape);
        }

        function downloadCSV(id){
            Mapaimagem.queryCSV({mapaid: id}, vm.sucessoDownloadCSV);
        }
        
        function downloadWKT(id){
            Mapaimagem.queryWKT({mapaid: id}, vm.sucessoDownloadWKT);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MapaInterativoMobileController', MapaInterativoMobileController);

        MapaInterativoMobileController.$inject = ['$timeout', '$scope', '$stateParams', 'Propriedade', 'Safra', 'Mapaimagem', 'AuthServerProvider'];

    function MapaInterativoMobileController ($timeout, $scope, $stateParams, Propriedade, Safra, Mapaimagem, AuthServerProvider) {
        var vm = this;

        var idtoken = $stateParams.idtoken;
        AuthServerProvider.loginWithToken(idtoken, true);

        vm.carregando = false;

        // Vetores auxiliares
        vm.colors = ["#FF0000", "#FF7700", "#FFF700", "#4DFF00", "#60FFEE", "#0D006E", "#3A0054", "#FF00FB", "#FFFFFF", "#000000", "#C561FF"]
        vm.ultimoIndice = null;

        vm.clickTeste = clickTeste;
        function clickTeste(){
            console.log(vm.mapasSelecionados);
        }

        // Preenchimento dos dados
        vm.filtroPropriedade = null;

        vm.propriedades = Propriedade.queryNomesPropriedades({
            size: 1000,
            sort: "nomepropriedade,asc"
        });

        vm.filtroSafra = null;

        vm.changeFiltroPropriedade = function () {
            vm.safras = vm.filtroPropriedade ?  Safra.querySafrasPorPropriedade({
                idPropriedade: vm.filtroPropriedade.id,
                size: 1000,
                sort: "nomesafra,asc"
            }) : [] ;    
        }

        vm.filtroTipoMapa = null;

        // Filtros
        vm.atendeFiltros = atendeFiltros;

        function atendeFiltros(mapa){
            var atendeTodos = true;

            if(vm.filtroPropriedade != null) {
                if(vm.filtroPropriedade.id != mapa.propriedade_id){
                    return false;
                }
            }
            if(vm.filtroSafra != null) {
                if(vm.filtroSafra.id != mapa.safra_id){
                    return false;
                }
            }
            if(vm.filtroTipoMapa != null) {
                if(vm.filtroTipoMapa != mapa.tipomapa){
                    return false;
                }
            }

            if(mapa.tipomapa == 'nutricional'){
                return false;
            }

            if(vm.dataInicioIntervalo != null || vm.dataFimIntervalo != null){
                if(vm.dataInicioIntervalo == null) {
                    var dataMapa = vm.ajustaData(mapa.data);
                    
                    console.log(dataMapa);
                    console.log(vm.dataInicioIntervalo);
                    console.log(vm.dataFimIntervalo);
                    if(dataMapa > vm.dataFimIntervalo){
                        return false;
                    }
                }
                else if(vm.dataFimIntervalo == null) {
                    var dataMapa = vm.ajustaData(mapa.data);
                    
                    console.log(dataMapa);
                    console.log(vm.dataInicioIntervalo);
                    console.log(vm.dataFimIntervalo);
                    if(dataMapa < vm.dataInicioIntervalo){
                        return false;
                    }
                }
                else {
                    var dataMapa = vm.ajustaData(mapa.data);
                    
                    console.log(dataMapa);
                    console.log(vm.dataInicioIntervalo);
                    console.log(vm.dataFimIntervalo);
                    if(dataMapa < vm.dataInicioIntervalo || dataMapa > vm.dataFimIntervalo){
                        return false;
                    }
                }

            }
            return true;
        }

        vm.aplicarFiltros = aplicarFiltros;

        function aplicarFiltros() {
            if(vm.filtroTipoMapa == ""){
                vm.filtroTipoMapa = null;
            }

            if(vm.filtroPropriedade == "" || vm.filtroPropriedade == null){
                alert("Selecione uma propriedade!");
                return;
            }

            vm.dadosBaixados = Mapaimagem.queryGaleria({
                propid: vm.filtroPropriedade.id,
                size: 3000,
                sort: "data,desc"
            }, vm.onCarregarMapasParaFiltros);
        }

        vm.onCarregarMapasParaFiltros = onCarregarMapasParaFiltros;

        function onCarregarMapasParaFiltros(data){
            vm.dadosMapas = [];

            for(var i = 0; i < data.length; i++){
                
                var estaNaLista = false;
                
                if(data[i].wktNull == true){
                    continue;
                }
                
                for(var j=0; j<vm.mapasSelecionados.length; j++){
                    if(vm.mapasSelecionados[j].id == data[i].id){ // Se o mapa já esta lá
                        estaNaLista = true;
                        break;
                    }
                }
                

                if(!estaNaLista && vm.atendeFiltros(data[i])){
                    vm.dadosMapas.push(data[i]);
                }
            }
            //vm.onCarregarDadosMapas(vm.dadosMapas);
        }

        // Controle do intervalo
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        vm.datePickerOpenStatus.dataInicio = false;
        vm.datePickerOpenStatus.dataFim = false;
        vm.dateformat = "dd/MM/yyyy";


        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.dataInicioIntervalo = null;
        vm.dataFimIntervalo = null;

        vm.teste = function(){
            console.log(vm.dataInicioIntervalo);
        }

        // Mapas da Galeria
        vm.onCarregarDadosMapas = onCarregarDadosMapas;
        vm.onCarregarImagensMapas = onCarregarImagensMapas;
        vm.dadosMapas = [];
        vm.imagensMapas = [];

        /*
        vm.dadosMapas = Mapaimagem.querySemImagem({
            size: 10,
            sort: "data,desc"
        }, vm.onCarregarDadosMapas);*/

        function onCarregarDadosMapas(data){
            //console.log(data);
            for(var i = 0; i < data.length; i++) {
                var element = data[i];
                var id = element.id;
                
                vm.dadosMapas[i].img = Mapaimagem.queryImagemPequena({
                    mapaid: id
                }, onCarregarImagensMapas);
            }
        }

        function onCarregarImagensMapas(data){
            //console.log(vm.dadosMapas);
        }

        //Mapas Selecionados
        vm.mapasSelecionados = [];
        vm.removerMapaSelecionado = removerMapaSelecionado;

        function removerMapaSelecionado(mapa){
            const id = mapa.id;

            // Removendo do Google Maps
            for(var i = 0; i < vm.poligonosNoMapa[id].length; i++){
                var element = vm.poligonosNoMapa[id][i];
                element.setMap(null);
            }

            delete vm.poligonosNoMapa[id];
            
            var vetorTemp = [];

            for (var index = 0; index < vm.mapasSelecionados.length; index++) {
                const element = vm.mapasSelecionados[index];
                if(element.id != id){
                    vetorTemp.push(element);
                }
            }

            vm.mapasSelecionados = vetorTemp;
        
            for(var i=0; i<vm.dadosMapas.length; i++){
                if(vm.dadosMapas[i].id == id){ // Se o mapa já esta lá
                    return
                }
            }

            if(vm.atendeFiltros(mapa)){
                vm.dadosMapas.push(mapa);
            }
        }


        // Transição (click no mapa)
        vm.adicionarMapasSelecionados = adicionarMapasSelecionados;
        vm.onCarregarWKT = onCarregarWKT;

        function adicionarMapasSelecionados(mapa){
            vm.carregando = true;
            // Trocar mapa de lista
            const id = mapa.id;
            
            if(vm.mapasSelecionados.length > 0){
                vm.removerMapaSelecionado(vm.mapasSelecionados[0]);
            }

            for(var i=0; i<vm.mapasSelecionados.length; i++){
                if(vm.mapasSelecionados[i].id == id){ // Se o mapa já esta lá
                    return
                }
            }

            var vetorTemp = [];

            for (var index = 0; index < vm.dadosMapas.length; index++) {
                const element = vm.dadosMapas[index];
                if(element.id != id){
                    vetorTemp.push(element);
                }
            }

            vm.dadosMapas = vetorTemp;
            
            // Pegar dados do WKT
            mapa.wktData = Mapaimagem.queryWKT({
                mapaid: id
            }, vm.onCarregarWKT);

            vm.mapasSelecionados.push(mapa);
        }

        function onCarregarWKT(data){
            // Dados Carregados em Base64
            data = data[0];

            var fileData = data.wkt;
            data.wkt = [];

            // Dados Carregados como Blob (conversão)
            var fileBlob = vm.converteBase64ToWKT(fileData, "");

            // FileReader
            var readerWKT = new FileReader();

            if(vm.ultimoIndice == null){
                vm.ultimoIndice = vm.retornaAleatorio(0,10);
            }
            else{
                vm.ultimoIndice = (vm.ultimoIndice + 1)%11;
            }
            
            var cor = vm.colors[vm.ultimoIndice];
            data.cor = cor;

            vm.poligonosNoMapa[data.id] = [];

            readerWKT.onload = function () {
                var dadosWKT = readerWKT.result;
                var linhas = dadosWKT.split('\n');
                
                var valores = [];

                for (var index = 1; index < linhas.length; index++) {
                    const element = linhas[index];

                    if(element == "") continue;

                    var sequenciaPontos = vm.converteStringPontos(element);
                    //console.log(sequenciaPontos);

                    //data.wkt.push(sequenciaPontos);

                    var poligono = new google.maps.Polygon({
                        paths: sequenciaPontos,
                        strokeColor: cor,
                        strokeOpacity: 0.8,
                        strokeWeight: 3,
                        fillColor: cor,
                        fillOpacity: 0.35
                    });

                    poligono.setMap(vm.map);
                    vm.poligonosNoMapa[data.id].push(poligono);
                    
                    if(index==1){
                        vm.map.setCenter(sequenciaPontos[0]);
                    }
                }


            }
            readerWKT.readAsText(fileBlob);

            //console.log(fileData);
            vm.carregando = false;
        }


        // Google Maps
        vm.map = null;
        vm.initMap = initMap;
        
        vm.poligonosNoMapa = {};

        function initMap() {
            vm.map = new google.maps.Map(document.getElementById('map'), {
                center: {lat: -24.283362, lng: -53.839970},
                zoom: 15,
                mapTypeId: 'satellite',
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: true
            });
        }

        initMap();
        
        // Auxiliares
        vm.converteBase64ToWKT = converteBase64ToWKT;
        function converteBase64ToWKT(b64Data, contentType) {
    
            var sliceSize = 512
            var byteCharacters = atob(b64Data);
            var byteArrays = [];
          
            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);
            
                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
            
                var byteArray = new Uint8Array(byteNumbers);
            
                byteArrays.push(byteArray);
            }
          
            var blob = new Blob(byteArrays, {type: contentType});
            return blob;
        }

        vm.converteStringPontos = converteStringPontos;
        function converteStringPontos(linha){
            var poligono = linha.split('|');
            poligono = poligono[1];
            poligono = poligono.slice(9, poligono.length-3);

            var coordenadas = poligono.split(',');
            
            var pontosPoligono = [];

            for(var i = 0; i < coordenadas.length; i++){
                const element = coordenadas[i];
                var temp = element.split(' ');
                var lat = temp[1]; var lng = temp[0];
                //console.log(lat);
                //console.log(lng)
                
                pontosPoligono.push( new google.maps.LatLng(lat, lng) );
            }

            return pontosPoligono;
        }

        vm.retornaAleatorio = retornaAleatorio;
        function retornaAleatorio(min, max){
            return Math.floor(Math.random() * (max - min)) + min;
        }

        vm.ajustaData = ajustaData;
        function ajustaData(dataString){
            var d = new Date(dataString);
            d.setDate(d.getDate()+1);
            d.setHours(0);
            return d;        
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MapaInterativoController', MapaInterativoController);

        MapaInterativoController.$inject = ['$timeout', '$scope', '$stateParams', 'Propriedade', 'Safra', 'Mapaimagem'];

    function MapaInterativoController ($timeout, $scope, $stateParams, Propriedade, Safra, Mapaimagem) {
        var vm = this;

        vm.carregando = false;

        // Vetores auxiliares
        vm.colors = ["#FF0000", "#FF7700", "#FFF700", "#4DFF00", "#60FFEE", "#0D006E", "#3A0054", "#FF00FB", "#FFFFFF", "#000000", "#C561FF"]
        vm.ultimoIndice = null;

        vm.clickTeste = clickTeste;
        function clickTeste(){
            console.log(vm.mapasSelecionados);
        }

        // Preenchimento dos dados
        vm.filtroPropriedade = null;

        vm.propriedades = Propriedade.queryNomesPropriedades({
            size: 1000,
            sort: "nomepropriedade,asc"
        });

        vm.filtroSafra = null;

        vm.changeFiltroPropriedade = function () {
            vm.safras = vm.filtroPropriedade ?  Safra.querySafrasPorPropriedade({
                idPropriedade: vm.filtroPropriedade.id,
                size: 1000,
                sort: "nomesafra,asc"
            }) : [] ;    
        }

        vm.filtroTipoMapa = null;

        // Filtros
        vm.atendeFiltros = atendeFiltros;

        function atendeFiltros(mapa){
            var atendeTodos = true;

            if(vm.filtroPropriedade != null) {
                if(vm.filtroPropriedade.id != mapa.propriedade_id){
                    return false;
                }
            }
            if(vm.filtroSafra != null) {
                if(vm.filtroSafra.id != mapa.safra_id){
                    return false;
                }
            }
            if(vm.filtroTipoMapa != null) {
                if(vm.filtroTipoMapa != mapa.tipomapa){
                    return false;
                }
            }

            if(mapa.tipomapa == 'nutricional'){
                return false;
            }

            if(vm.dataInicioIntervalo != null || vm.dataFimIntervalo != null){
                if(vm.dataInicioIntervalo == null) {
                    var dataMapa = vm.ajustaData(mapa.data);
                    
                    console.log(dataMapa);
                    console.log(vm.dataInicioIntervalo);
                    console.log(vm.dataFimIntervalo);
                    if(dataMapa > vm.dataFimIntervalo){
                        return false;
                    }
                }
                else if(vm.dataFimIntervalo == null) {
                    var dataMapa = vm.ajustaData(mapa.data);
                    
                    console.log(dataMapa);
                    console.log(vm.dataInicioIntervalo);
                    console.log(vm.dataFimIntervalo);
                    if(dataMapa < vm.dataInicioIntervalo){
                        return false;
                    }
                }
                else {
                    var dataMapa = vm.ajustaData(mapa.data);
                    
                    console.log(dataMapa);
                    console.log(vm.dataInicioIntervalo);
                    console.log(vm.dataFimIntervalo);
                    if(dataMapa < vm.dataInicioIntervalo || dataMapa > vm.dataFimIntervalo){
                        return false;
                    }
                }

            }
            return true;
        }

        vm.aplicarFiltros = aplicarFiltros;

        function aplicarFiltros() {
            if(vm.filtroTipoMapa == ""){
                vm.filtroTipoMapa = null;
            }

            if(vm.filtroPropriedade == "" || vm.filtroPropriedade == null){
                alert("Selecione uma propriedade!");
                return;
            }

            vm.dadosBaixados = Mapaimagem.queryGaleria({
                propid: vm.filtroPropriedade.id,
                size: 3000,
                sort: "data,desc"
            }, vm.onCarregarMapasParaFiltros);
        }

        vm.onCarregarMapasParaFiltros = onCarregarMapasParaFiltros;

        function onCarregarMapasParaFiltros(data){
            vm.dadosMapas = [];

            for(var i = 0; i < data.length; i++){
                
                var estaNaLista = false;
                
                if(data[i].wktNull == true){
                    continue;
                }
                
                for(var j=0; j<vm.mapasSelecionados.length; j++){
                    if(vm.mapasSelecionados[j].id == data[i].id){ // Se o mapa já esta lá
                        estaNaLista = true;
                        break;
                    }
                }
                

                if(!estaNaLista && vm.atendeFiltros(data[i])){
                    vm.dadosMapas.push(data[i]);
                }
            }
            //vm.onCarregarDadosMapas(vm.dadosMapas);
        }

        // Controle do intervalo
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        vm.datePickerOpenStatus.dataInicio = false;
        vm.datePickerOpenStatus.dataFim = false;
        vm.dateformat = "dd/MM/yyyy";


        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.dataInicioIntervalo = null;
        vm.dataFimIntervalo = null;

        vm.teste = function(){
            console.log(vm.dataInicioIntervalo);
        }

        // Mapas da Galeria
        vm.onCarregarDadosMapas = onCarregarDadosMapas;
        vm.onCarregarImagensMapas = onCarregarImagensMapas;
        vm.dadosMapas = [];
        vm.imagensMapas = [];

        /*
        vm.dadosMapas = Mapaimagem.querySemImagem({
            size: 10,
            sort: "data,desc"
        }, vm.onCarregarDadosMapas);*/

        function onCarregarDadosMapas(data){
            //console.log(data);
            for(var i = 0; i < data.length; i++) {
                var element = data[i];
                var id = element.id;
                
                vm.dadosMapas[i].img = Mapaimagem.queryImagemPequena({
                    mapaid: id
                }, onCarregarImagensMapas);
            }
        }

        function onCarregarImagensMapas(data){
            //console.log(vm.dadosMapas);
        }

        //Mapas Selecionados
        vm.mapasSelecionados = [];
        vm.removerMapaSelecionado = removerMapaSelecionado;

        function removerMapaSelecionado(mapa){
            const id = mapa.id;

            // Removendo do Google Maps
            for(var i = 0; i < vm.poligonosNoMapa[id].length; i++){
                var element = vm.poligonosNoMapa[id][i];
                element.setMap(null);
            }

            delete vm.poligonosNoMapa[id];
            
            var vetorTemp = [];

            for (var index = 0; index < vm.mapasSelecionados.length; index++) {
                const element = vm.mapasSelecionados[index];
                if(element.id != id){
                    vetorTemp.push(element);
                }
            }

            vm.mapasSelecionados = vetorTemp;
        
            for(var i=0; i<vm.dadosMapas.length; i++){
                if(vm.dadosMapas[i].id == id){ // Se o mapa já esta lá
                    return
                }
            }

            if(vm.atendeFiltros(mapa)){
                vm.dadosMapas.push(mapa);
            }
        }


        // Transição (click no mapa)
        vm.adicionarMapasSelecionados = adicionarMapasSelecionados;
        vm.onCarregarWKT = onCarregarWKT;

        function adicionarMapasSelecionados(mapa){
            vm.carregando = true;
            // Trocar mapa de lista
            const id = mapa.id;
            
            for(var i=0; i<vm.mapasSelecionados.length; i++){
                if(vm.mapasSelecionados[i].id == id){ // Se o mapa já esta lá
                    return
                }
            }

            var vetorTemp = [];

            for (var index = 0; index < vm.dadosMapas.length; index++) {
                const element = vm.dadosMapas[index];
                if(element.id != id){
                    vetorTemp.push(element);
                }
            }

            vm.dadosMapas = vetorTemp;
            
            // Pegar dados do WKT
            mapa.wktData = Mapaimagem.queryWKT({
                mapaid: id
            }, vm.onCarregarWKT);

            vm.mapasSelecionados.push(mapa);
        }

        function onCarregarWKT(data){
            // Dados Carregados em Base64
            data = data[0];

            var fileData = data.wkt;
            data.wkt = [];

            // Dados Carregados como Blob (conversão)
            var fileBlob = vm.converteBase64ToWKT(fileData, "");

            // FileReader
            var readerWKT = new FileReader();

            if(vm.ultimoIndice == null){
                vm.ultimoIndice = vm.retornaAleatorio(0,10);
            }
            else{
                vm.ultimoIndice = (vm.ultimoIndice + 1)%11;
            }
            
            var cor = vm.colors[vm.ultimoIndice];
            data.cor = cor;

            vm.poligonosNoMapa[data.id] = [];

            readerWKT.onload = function () {
                var dadosWKT = readerWKT.result;
                var linhas = dadosWKT.split('\n');
                
                var valores = [];

                for (var index = 1; index < linhas.length; index++) {
                    const element = linhas[index];

                    if(element == "") continue;

                    var sequenciaPontos = vm.converteStringPontos(element);
                    //console.log(sequenciaPontos);

                    //data.wkt.push(sequenciaPontos);

                    var poligono = new google.maps.Polygon({
                        paths: sequenciaPontos,
                        strokeColor: cor,
                        strokeOpacity: 0.8,
                        strokeWeight: 3,
                        fillColor: cor,
                        fillOpacity: 0.35
                    });

                    poligono.setMap(vm.map);
                    vm.poligonosNoMapa[data.id].push(poligono);
                    
                    if(index==1){
                        vm.map.setCenter(sequenciaPontos[0]);
                    }
                }


            }
            readerWKT.readAsText(fileBlob);

            //console.log(fileData);
            vm.carregando = false;
        }


        // Google Maps
        vm.map = null;
        vm.initMap = initMap;
        
        vm.poligonosNoMapa = {};

        function initMap() {
            vm.map = new google.maps.Map(document.getElementById('map'), {
                center: {lat: -24.283362, lng: -53.839970},
                zoom: 15,
                mapTypeId: 'satellite'
            });
        }

        initMap();
        
        // Auxiliares
        vm.converteBase64ToWKT = converteBase64ToWKT;
        function converteBase64ToWKT(b64Data, contentType) {
    
            var sliceSize = 512
            var byteCharacters = atob(b64Data);
            var byteArrays = [];
          
            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);
            
                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
            
                var byteArray = new Uint8Array(byteNumbers);
            
                byteArrays.push(byteArray);
            }
          
            var blob = new Blob(byteArrays, {type: contentType});
            return blob;
        }

        vm.converteStringPontos = converteStringPontos;
        function converteStringPontos(linha){
            var poligono = linha.split('|');
            poligono = poligono[1];
            poligono = poligono.slice(9, poligono.length-3);

            var coordenadas = poligono.split(',');
            
            var pontosPoligono = [];

            for(var i = 0; i < coordenadas.length; i++){
                const element = coordenadas[i];
                var temp = element.split(' ');
                var lat = temp[1]; var lng = temp[0];
                //console.log(lat);
                //console.log(lng)
                
                pontosPoligono.push( new google.maps.LatLng(lat, lng) );
            }

            return pontosPoligono;
        }

        vm.retornaAleatorio = retornaAleatorio;
        function retornaAleatorio(min, max){
            return Math.floor(Math.random() * (max - min)) + min;
        }

        vm.ajustaData = ajustaData;
        function ajustaData(dataString){
            var d = new Date(dataString);
            d.setDate(d.getDate()+1);
            d.setHours(0);
            return d;        
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MapaCalorMobileController', MapaCalorMobileController);

        MapaCalorMobileController.$inject = ['$timeout', '$scope', '$stateParams', 'Propriedade', 'Safra', 'Mapaimagem', 'Configuracaomapacalor', 'AuthServerProvider'];

    function MapaCalorMobileController($timeout, $scope, $stateParams, Propriedade, Safra, Mapaimagem, Configuracaomapacalor, AuthServerProvider) {
        var vm = this;

        var idtoken = $stateParams.idtoken;
        AuthServerProvider.loginWithToken(idtoken, true);
        
        // Vetores auxiliares
        vm.colors = ["#FF0000", "#FFFF00", "#00FF00"];
        vm.valoresPreferencias = [];
        vm.ultimoIndice = null;

        vm.carregando = false;

        vm.clickTeste = clickTeste;
        function clickTeste(){
            console.log(vm.mapasSelecionados);
        }

        // Preenchimento dos dados
        vm.filtroPropriedade = null;

        vm.propriedades = Propriedade.queryNomesPropriedades({
            size: 1000,
            sort: "nomepropriedade,asc"
        });

        vm.filtroSafra = null;

        vm.changeFiltroPropriedade = function () {
            vm.safras = vm.filtroPropriedade ?  Safra.querySafrasPorPropriedade({
                idPropriedade: vm.filtroPropriedade.id,
                size: 1000,
                sort: "nomesafra,asc"
            }) : [] ;    
        }

        Configuracaomapacalor.query({
            size:1000
        }, onCarregarValoresPreferencia);

        vm.valoresPreferencias = null;

        vm.onCarregarValoresPreferencia = onCarregarValoresPreferencia;
        function onCarregarValoresPreferencia(data){
            var dicionario = {};
            for (var i=0; i<data.length; i++){
                var tipo = data[i].tipomapa;
                var cultura = data[i].cultura.nomecultura;

                var chave = tipo + cultura;

                dicionario[chave] = {
                    pouco: data[i].pouco,
                    muito: data[i].muito
                }
            }
            vm.valoresPreferencias = dicionario; 
            console.log(vm.valoresPreferencias)
        }

        vm.filtroTipoMapa = null;

        // Filtros
        vm.atendeFiltros = atendeFiltros;

        function atendeFiltros(mapa){
            var atendeTodos = true;

            if(vm.filtroPropriedade != null) {
                if(vm.filtroPropriedade.id != mapa.propriedade_id){
                    return false;
                }
            }
            if(vm.filtroSafra != null) {
                if(vm.filtroSafra.id != mapa.safra_id){
                    return false;
                }
            }
            if(vm.filtroTipoMapa != null) {
                if(vm.filtroTipoMapa != mapa.tipomapa){
                    return false;
                }
            }

            if(mapa.tipomapa == 'nutricional'){
                return false;
            }

            if(vm.dataInicioIntervalo != null || vm.dataFimIntervalo != null){
                if(vm.dataInicioIntervalo == null) {
                    var dataMapa = vm.ajustaData(mapa.data);
                    
                    //console.log(dataMapa);
                    //console.log(vm.dataInicioIntervalo);
                    //console.log(vm.dataFimIntervalo);
                    if(dataMapa > vm.dataFimIntervalo){
                        return false;
                    }
                }
                else if(vm.dataFimIntervalo == null) {
                    var dataMapa = vm.ajustaData(mapa.data);
                    
                    //console.log(dataMapa);
                    //console.log(vm.dataInicioIntervalo);
                    //onsole.log(vm.dataFimIntervalo);
                    if(dataMapa < vm.dataInicioIntervalo){
                        return false;
                    }
                }
                else {
                    var dataMapa = vm.ajustaData(mapa.data);
                    
                    //console.log(dataMapa);
                    //console.log(vm.dataInicioIntervalo);
                    //console.log(vm.dataFimIntervalo);
                    if(dataMapa < vm.dataInicioIntervalo || dataMapa > vm.dataFimIntervalo){
                        return false;
                    }
                }

            }
            return true;
        }

        vm.aplicarFiltros = aplicarFiltros;

        function aplicarFiltros() {

            if(vm.filtroTipoMapa == ""){
                vm.filtroTipoMapa = null;
            }
            
            if(vm.filtroPropriedade == "" || vm.filtroPropriedade == null){
                alert("Selecione uma propriedade!");
                return;
            }

            vm.dadosBaixados = Mapaimagem.queryGaleria({
                propid: vm.filtroPropriedade.id,
                size: 1000,
                sort: "data,desc"
            }, vm.onCarregarMapasParaFiltros);
        }

        vm.onCarregarMapasParaFiltros = onCarregarMapasParaFiltros;

        function onCarregarMapasParaFiltros(data){
            vm.dadosMapas = [];

            for(var i = 0; i < data.length; i++){
                
                var estaNaLista = false;
            
                if(data[i].csvNull == true){
                    continue;
                }
                
                for(var j=0; j<vm.mapasSelecionados.length; j++){
                    if(vm.mapasSelecionados[j].id == data[i].id){ // Se o mapa já esta lá
                        estaNaLista = true;
                        break;
                    }
                }
                
                if(!estaNaLista && vm.atendeFiltros(data[i])){
                    vm.dadosMapas.push(data[i]);
                    //console.log(data[i].data);
                }
            }
            vm.onCarregarDadosMapas(vm.dadosMapas);
        }

        // Controle do intervalo
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        vm.datePickerOpenStatus.dataInicio = false;
        vm.datePickerOpenStatus.dataFim = false;
        vm.dateformat = "dd/MM/yyyy";


        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.dataInicioIntervalo = null;
        vm.dataFimIntervalo = null;

        vm.teste = function(){
            //console.log(vm.dataInicioIntervalo);
        }

        // Mapas da Galeria
        vm.onCarregarDadosMapas = onCarregarDadosMapas;
        vm.onCarregarImagensMapas = onCarregarImagensMapas;
        vm.dadosMapas = [];
        vm.imagensMapas = [];

        /*vm.dadosMapas = Mapaimagem.querySemImagem({
            size: 10,
            sort: "data,desc"
        }, vm.onCarregarDadosMapas);*/

        function onCarregarDadosMapas(data){
            //console.log(data);
            for(var i = 0; i < data.length; i++) {
                var element = data[i];
                var id = element.id;
                
                vm.dadosMapas[i].img = Mapaimagem.queryImagemPequena({
                    mapaid: id
                }, onCarregarImagensMapas);
            }
        }

        function onCarregarImagensMapas(data){
            //console.log(vm.dadosMapas);
        }

        //Mapas Selecionados
        vm.mapasSelecionados = [];
        vm.removerMapaSelecionado = removerMapaSelecionado;

        function removerMapaSelecionado(mapa){
            const id = mapa.id;

            // Removendo do Google Maps
            for(var i = 0; i < vm.pontosNoMapa[id].length; i++){
                var element = vm.pontosNoMapa[id][i];
                element.setMap(null);
            }

            delete vm.pontosNoMapa[id];
            
            var vetorTemp = [];

            for (var index = 0; index < vm.mapasSelecionados.length; index++) {
                const element = vm.mapasSelecionados[index];
                if(element.id != id){
                    vetorTemp.push(element);
                }
            }

            vm.mapasSelecionados = vetorTemp;
        
            for(var i=0; i<vm.dadosMapas.length; i++){
                if(vm.dadosMapas[i].id == id){ // Se o mapa já esta lá
                    return
                }
            }

            if(vm.atendeFiltros(mapa)){
                vm.dadosMapas.push(mapa);
            }
        }


        // Transição (click no mapa)
        vm.adicionarMapasSelecionados = adicionarMapasSelecionados;
        vm.onCarregarCSV = onCarregarCSV;
        vm.controleTipoCultura = null;

        function adicionarMapasSelecionados(mapa){
            // Trocar mapa de lista

            vm.carregando = true;
            const id = mapa.id;

            if(vm.mapasSelecionados.length > 0){
                vm.removerMapaSelecionado(vm.mapasSelecionados[0]);
            }
            
            vm.controleTipoCultura = mapa.tipomapa + mapa.cultura_nomecultura;
            console.log(vm.controleTipoCultura);

            for(var i=0; i<vm.mapasSelecionados.length; i++){
                if(vm.mapasSelecionados[i].id == id){ // Se o mapa já esta lá
                    return
                }
            }

            var vetorTemp = [];

            for (var index = 0; index < vm.dadosMapas.length; index++) {
                const element = vm.dadosMapas[index];
                if(element.id != id){
                    vetorTemp.push(element);
                }
            }

            vm.dadosMapas = vetorTemp;
            
            // Pegar dados do CSV
            Mapaimagem.queryCSV({
                mapaid: id
            }, vm.onCarregarCSV);

            vm.mapasSelecionados.push(mapa);
        }

        function onCarregarCSV(data){

            // Dados Carregados em Base64
            data = data[0];

            var fileData = data.csv;
            data.csv = [];

            // Dados Carregados como Blob (conversão)
            var fileBlob = vm.converteBase64ToCSV(fileData, "application/vnd.ms-excel");

            // FileReader
            var readerCSV = new FileReader();

            vm.pontosNoMapa[data.id] = [];

            readerCSV.onload = function () {
                var dadosCSV = readerCSV.result;
                var linhas = dadosCSV.split('\n');
                
                var valores = [];

                for (var index = 0; index < linhas.length; index++) {
                    const element = linhas[index];

                    if(element == "") continue;

                    var sequenciaPontos = vm.converteStringPontos(element);
                    //console.log(sequenciaPontos);

                    data.csv.push(sequenciaPontos);
                    var lat = sequenciaPontos[0];
                    var lng = sequenciaPontos[1];

                    var qtd = sequenciaPontos[2];

                    var preferencia = vm.valoresPreferencias[vm.controleTipoCultura]

                    var pouco = preferencia.pouco;
                    var muito = preferencia.muito;

                    var PTemp1 = google.maps.geometry.spherical.computeOffset(new google.maps.LatLng(lat, lng), 4, 0);
                    var PTemp2 = google.maps.geometry.spherical.computeOffset(new google.maps.LatLng(lat, lng), 4, 90);
                    var PTemp3 = google.maps.geometry.spherical.computeOffset(new google.maps.LatLng(lat, lng), 4, 180);
                    var PTemp4 = google.maps.geometry.spherical.computeOffset(new google.maps.LatLng(lat, lng), 4, -90);

                    var P1 = new google.maps.LatLng(PTemp1.lat(), PTemp4.lng());
                    var P2 = new google.maps.LatLng(PTemp1.lat(), PTemp2.lng());
                    var P3 = new google.maps.LatLng(PTemp3.lat(), PTemp2.lng());
                    var P4 = new google.maps.LatLng(PTemp3.lat(), PTemp4.lng());

                    //console.log(P1.lat());

                    var sequenciaPontos = [P1, P2, P3, P4, P1];

                    var point = null;

                    if(qtd <= pouco){
                        point =  new google.maps.Polygon({
                            paths: sequenciaPontos,
                            strokeColor: "#00FF00",
                            strokeOpacity: 0.8,
                            strokeWeight: 3,
                            fillColor: "#00FF00",
                            fillOpacity: 0.35,
                            map: vm.map
                        });
                    }
                    else if(qtd > pouco && qtd <muito){
                        point =  new google.maps.Polygon({
                            paths: sequenciaPontos,
                            strokeColor: "#FFFF00",
                            strokeOpacity: 0.8,
                            strokeWeight: 3,
                            fillColor: "#FFFF00",
                            fillOpacity: 0.35,
                            map: vm.map
                        });
                    }
                    else if(qtd >= muito){
                        point =  new google.maps.Polygon({
                            paths: sequenciaPontos,
                            strokeColor: "#FF0000",
                            strokeOpacity: 0.8,
                            strokeWeight: 3,
                            fillColor: "#FF0000",
                            fillOpacity: 0.35,
                            map: vm.map
                        });
                    }
                
                    vm.pontosNoMapa[data.id].push(point);
                    
                    if(index==0){
                        vm.map.setCenter(new google.maps.LatLng(lat, lng));
                    }

                }

                vm.carregando = false;

            }
            readerCSV.readAsText(fileBlob);

            //console.log(fileData);
        }


        // Google Maps
        vm.map = null;
        vm.initMap = initMap;
        
        vm.pontosNoMapa = {};

        function initMap() {
            vm.map = new google.maps.Map(document.getElementById('map'), {
                center: {lat: -24.283362, lng: -53.839970},
                zoom: 15,
                mapTypeId: 'satellite',
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: true
            });
        }

        initMap();

        vm.converteBase64ToCSV = converteBase64ToCSV;
        function converteBase64ToCSV(b64Data, contentType) {
    
            var sliceSize = 512
            var byteCharacters = atob(b64Data);
            var byteArrays = [];
          
            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);
            
                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
            
                var byteArray = new Uint8Array(byteNumbers);
            
                byteArrays.push(byteArray);
            }
          
            var blob = new Blob(byteArrays, {type: contentType});
            return blob;
        }

        vm.converteStringPontos = converteStringPontos;
        function converteStringPontos(linha){
            linha = linha.split(';');

            var geo = linha[0];
            geo = geo.slice(1, geo.length-1);
            geo = geo.replace(' ', '');
            geo = geo.split(',');

            var lat = geo[0];
            var lng = geo[1];

            var qtd = linha[1];

            var vetor = new Array();
            vetor.push(lat); vetor.push(lng); vetor.push(qtd);

            return vetor;
        }

        vm.retornaAleatorio = retornaAleatorio;
        function retornaAleatorio(min, max){
            return Math.floor(Math.random() * (max - min)) + min;
        }

        vm.ajustaData = ajustaData;
        function ajustaData(dataString){
            var d = new Date(dataString);
            d.setDate(d.getDate()+1);
            d.setHours(0);
            return d;        
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MapaCalorController', MapaCalorController);

        MapaCalorController.$inject = ['$timeout', '$scope', '$stateParams', 'Propriedade', 'Safra', 'Mapaimagem', 'Configuracaomapacalor'];

    function MapaCalorController($timeout, $scope, $stateParams, Propriedade, Safra, Mapaimagem, Configuracaomapacalor) {
        var vm = this;
        
        // Vetores auxiliares
        vm.colors = ["#FF0000", "#FFFF00", "#00FF00"];
        vm.valoresPreferencias = [];
        vm.ultimoIndice = null;

        vm.carregando = false;

        vm.clickTeste = clickTeste;
        function clickTeste(){
            console.log(vm.mapasSelecionados);
        }

        // Preenchimento dos dados
        vm.filtroPropriedade = null;

        vm.propriedades = Propriedade.queryNomesPropriedades({
            size: 1000,
            sort: "nomepropriedade,asc"
        });

        vm.filtroSafra = null;

        vm.changeFiltroPropriedade = function () {
            vm.safras = vm.filtroPropriedade ?  Safra.querySafrasPorPropriedade({
                idPropriedade: vm.filtroPropriedade.id,
                size: 1000,
                sort: "nomesafra,asc"
            }) : [] ;    
        }

        Configuracaomapacalor.query({
            size:1000
        }, onCarregarValoresPreferencia);

        vm.valoresPreferencias = null;

        vm.onCarregarValoresPreferencia = onCarregarValoresPreferencia;
        function onCarregarValoresPreferencia(data){
            var dicionario = {};
            for (var i=0; i<data.length; i++){
                var tipo = data[i].tipomapa;
                var cultura = data[i].cultura.nomecultura;

                var chave = tipo + cultura;

                dicionario[chave] = {
                    pouco: data[i].pouco,
                    muito: data[i].muito
                }
            }
            vm.valoresPreferencias = dicionario; 
            console.log(vm.valoresPreferencias)
        }

        vm.filtroTipoMapa = null;

        // Filtros
        vm.atendeFiltros = atendeFiltros;

        function atendeFiltros(mapa){
            var atendeTodos = true;

            if(vm.filtroPropriedade != null) {
                if(vm.filtroPropriedade.id != mapa.propriedade_id){
                    return false;
                }
            }
            if(vm.filtroSafra != null) {
                if(vm.filtroSafra.id != mapa.safra_id){
                    return false;
                }
            }
            if(vm.filtroTipoMapa != null) {
                if(vm.filtroTipoMapa != mapa.tipomapa){
                    return false;
                }
            }

            if(mapa.tipomapa == 'nutricional'){
                return false;
            }

            if(vm.dataInicioIntervalo != null || vm.dataFimIntervalo != null){
                if(vm.dataInicioIntervalo == null) {
                    var dataMapa = vm.ajustaData(mapa.data);
                    
                    //console.log(dataMapa);
                    //console.log(vm.dataInicioIntervalo);
                    //console.log(vm.dataFimIntervalo);
                    if(dataMapa > vm.dataFimIntervalo){
                        return false;
                    }
                }
                else if(vm.dataFimIntervalo == null) {
                    var dataMapa = vm.ajustaData(mapa.data);
                    
                    //console.log(dataMapa);
                    //console.log(vm.dataInicioIntervalo);
                    //onsole.log(vm.dataFimIntervalo);
                    if(dataMapa < vm.dataInicioIntervalo){
                        return false;
                    }
                }
                else {
                    var dataMapa = vm.ajustaData(mapa.data);
                    
                    //console.log(dataMapa);
                    //console.log(vm.dataInicioIntervalo);
                    //console.log(vm.dataFimIntervalo);
                    if(dataMapa < vm.dataInicioIntervalo || dataMapa > vm.dataFimIntervalo){
                        return false;
                    }
                }

            }
            return true;
        }

        vm.aplicarFiltros = aplicarFiltros;

        function aplicarFiltros() {

            if(vm.filtroTipoMapa == ""){
                vm.filtroTipoMapa = null;
            }
            
            if(vm.filtroPropriedade == "" || vm.filtroPropriedade == null){
                alert("Selecione uma propriedade!");
                return;
            }

            vm.dadosBaixados = Mapaimagem.queryGaleria({
                propid: vm.filtroPropriedade.id,
                size: 1000,
                sort: "data,desc"
            }, vm.onCarregarMapasParaFiltros);
        }

        vm.onCarregarMapasParaFiltros = onCarregarMapasParaFiltros;

        function onCarregarMapasParaFiltros(data){
            vm.dadosMapas = [];

            for(var i = 0; i < data.length; i++){
                
                var estaNaLista = false;
            
                if(data[i].csvNull == true){
                    continue;
                }
                
                for(var j=0; j<vm.mapasSelecionados.length; j++){
                    if(vm.mapasSelecionados[j].id == data[i].id){ // Se o mapa já esta lá
                        estaNaLista = true;
                        break;
                    }
                }
                
                if(!estaNaLista && vm.atendeFiltros(data[i])){
                    vm.dadosMapas.push(data[i]);
                    //console.log(data[i].data);
                }
            }
            vm.onCarregarDadosMapas(vm.dadosMapas);
        }

        // Controle do intervalo
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        vm.datePickerOpenStatus.dataInicio = false;
        vm.datePickerOpenStatus.dataFim = false;
        vm.dateformat = "dd/MM/yyyy";


        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.dataInicioIntervalo = null;
        vm.dataFimIntervalo = null;

        vm.teste = function(){
            //console.log(vm.dataInicioIntervalo);
        }

        // Mapas da Galeria
        vm.onCarregarDadosMapas = onCarregarDadosMapas;
        vm.onCarregarImagensMapas = onCarregarImagensMapas;
        vm.dadosMapas = [];
        vm.imagensMapas = [];

        /*vm.dadosMapas = Mapaimagem.querySemImagem({
            size: 10,
            sort: "data,desc"
        }, vm.onCarregarDadosMapas);*/

        function onCarregarDadosMapas(data){
            //console.log(data);
            for(var i = 0; i < data.length; i++) {
                var element = data[i];
                var id = element.id;
                
                vm.dadosMapas[i].img = Mapaimagem.queryImagemPequena({
                    mapaid: id
                }, onCarregarImagensMapas);
            }
        }

        function onCarregarImagensMapas(data){
            //console.log(vm.dadosMapas);
        }

        //Mapas Selecionados
        vm.mapasSelecionados = [];
        vm.removerMapaSelecionado = removerMapaSelecionado;

        function removerMapaSelecionado(mapa){
            const id = mapa.id;

            // Removendo do Google Maps
            for(var i = 0; i < vm.pontosNoMapa[id].length; i++){
                var element = vm.pontosNoMapa[id][i];
                element.setMap(null);
            }

            delete vm.pontosNoMapa[id];
            
            var vetorTemp = [];

            for (var index = 0; index < vm.mapasSelecionados.length; index++) {
                const element = vm.mapasSelecionados[index];
                if(element.id != id){
                    vetorTemp.push(element);
                }
            }

            vm.mapasSelecionados = vetorTemp;
        
            for(var i=0; i<vm.dadosMapas.length; i++){
                if(vm.dadosMapas[i].id == id){ // Se o mapa já esta lá
                    return
                }
            }

            if(vm.atendeFiltros(mapa)){
                vm.dadosMapas.push(mapa);
            }
        }


        // Transição (click no mapa)
        vm.adicionarMapasSelecionados = adicionarMapasSelecionados;
        vm.onCarregarCSV = onCarregarCSV;
        vm.controleTipoCultura = null;

        function adicionarMapasSelecionados(mapa){
            // Trocar mapa de lista

            vm.carregando = true;
            const id = mapa.id;

            if(vm.mapasSelecionados.length > 0){
                vm.removerMapaSelecionado(vm.mapasSelecionados[0]);
            }
            
            vm.controleTipoCultura = mapa.tipomapa + mapa.cultura_nomecultura;
            console.log(vm.controleTipoCultura);

            for(var i=0; i<vm.mapasSelecionados.length; i++){
                if(vm.mapasSelecionados[i].id == id){ // Se o mapa já esta lá
                    return
                }
            }

            var vetorTemp = [];

            for (var index = 0; index < vm.dadosMapas.length; index++) {
                const element = vm.dadosMapas[index];
                if(element.id != id){
                    vetorTemp.push(element);
                }
            }

            vm.dadosMapas = vetorTemp;
            
            // Pegar dados do CSV
            Mapaimagem.queryCSV({
                mapaid: id
            }, vm.onCarregarCSV);

            vm.mapasSelecionados.push(mapa);
        }

        function onCarregarCSV(data){

            // Dados Carregados em Base64
            data = data[0];

            var fileData = data.csv;
            data.csv = [];

            // Dados Carregados como Blob (conversão)
            var fileBlob = vm.converteBase64ToCSV(fileData, "application/vnd.ms-excel");

            // FileReader
            var readerCSV = new FileReader();

            vm.pontosNoMapa[data.id] = [];

            readerCSV.onload = function () {
                var dadosCSV = readerCSV.result;
                var linhas = dadosCSV.split('\n');
                
                var valores = [];

                for (var index = 0; index < linhas.length; index++) {
                    const element = linhas[index];

                    if(element == "") continue;

                    var sequenciaPontos = vm.converteStringPontos(element);
                    //console.log(sequenciaPontos);

                    data.csv.push(sequenciaPontos);
                    var lat = sequenciaPontos[0];
                    var lng = sequenciaPontos[1];

                    var qtd = sequenciaPontos[2];

                    var preferencia = vm.valoresPreferencias[vm.controleTipoCultura]

                    var pouco = preferencia.pouco;
                    var muito = preferencia.muito;

                    var PTemp1 = google.maps.geometry.spherical.computeOffset(new google.maps.LatLng(lat, lng), 4, 0);
                    var PTemp2 = google.maps.geometry.spherical.computeOffset(new google.maps.LatLng(lat, lng), 4, 90);
                    var PTemp3 = google.maps.geometry.spherical.computeOffset(new google.maps.LatLng(lat, lng), 4, 180);
                    var PTemp4 = google.maps.geometry.spherical.computeOffset(new google.maps.LatLng(lat, lng), 4, -90);

                    var P1 = new google.maps.LatLng(PTemp1.lat(), PTemp4.lng());
                    var P2 = new google.maps.LatLng(PTemp1.lat(), PTemp2.lng());
                    var P3 = new google.maps.LatLng(PTemp3.lat(), PTemp2.lng());
                    var P4 = new google.maps.LatLng(PTemp3.lat(), PTemp4.lng());

                    //console.log(P1.lat());

                    var sequenciaPontos = [P1, P2, P3, P4, P1];

                    var point = null;

                    if(qtd <= pouco){
                        point =  new google.maps.Polygon({
                            paths: sequenciaPontos,
                            strokeColor: "#00FF00",
                            strokeOpacity: 0.8,
                            strokeWeight: 3,
                            fillColor: "#00FF00",
                            fillOpacity: 0.35,
                            map: vm.map
                        });
                    }
                    else if(qtd > pouco && qtd <muito){
                        point =  new google.maps.Polygon({
                            paths: sequenciaPontos,
                            strokeColor: "#FFFF00",
                            strokeOpacity: 0.8,
                            strokeWeight: 3,
                            fillColor: "#FFFF00",
                            fillOpacity: 0.35,
                            map: vm.map
                        });
                    }
                    else if(qtd >= muito){
                        point =  new google.maps.Polygon({
                            paths: sequenciaPontos,
                            strokeColor: "#FF0000",
                            strokeOpacity: 0.8,
                            strokeWeight: 3,
                            fillColor: "#FF0000",
                            fillOpacity: 0.35,
                            map: vm.map
                        });
                    }
                
                    vm.pontosNoMapa[data.id].push(point);
                    
                    if(index==0){
                        vm.map.setCenter(new google.maps.LatLng(lat, lng));
                    }

                }

                vm.carregando = false;

            }
            readerCSV.readAsText(fileBlob);

            //console.log(fileData);
        }


        // Google Maps
        vm.map = null;
        vm.initMap = initMap;
        
        vm.pontosNoMapa = {};

        function initMap() {
            vm.map = new google.maps.Map(document.getElementById('map'), {
                center: {lat: -24.283362, lng: -53.839970},
                zoom: 15,
                mapTypeId: 'satellite'
            });
        }

        initMap();

        vm.converteBase64ToCSV = converteBase64ToCSV;
        function converteBase64ToCSV(b64Data, contentType) {
    
            var sliceSize = 512
            var byteCharacters = atob(b64Data);
            var byteArrays = [];
          
            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);
            
                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
            
                var byteArray = new Uint8Array(byteNumbers);
            
                byteArrays.push(byteArray);
            }
          
            var blob = new Blob(byteArrays, {type: contentType});
            return blob;
        }

        vm.converteStringPontos = converteStringPontos;
        function converteStringPontos(linha){
            linha = linha.split(';');

            var geo = linha[0];
            geo = geo.slice(1, geo.length-1);
            geo = geo.replace(' ', '');
            geo = geo.split(',');

            var lat = geo[0];
            var lng = geo[1];

            var qtd = linha[1];

            var vetor = new Array();
            vetor.push(lat); vetor.push(lng); vetor.push(qtd);

            return vetor;
        }

        vm.retornaAleatorio = retornaAleatorio;
        function retornaAleatorio(min, max){
            return Math.floor(Math.random() * (max - min)) + min;
        }

        vm.ajustaData = ajustaData;
        function ajustaData(dataString){
            var d = new Date(dataString);
            d.setDate(d.getDate()+1);
            d.setHours(0);
            return d;        
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('MapacomparativoController', MapacomparativoController);

    MapacomparativoController.$inject = ['Safra','DataUtils', 'Mapaimagem', 'MapaimagemSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'Propriedade'];

    function MapacomparativoController(Safra, DataUtils, Mapaimagem, MapaimagemSearch, ParseLinks, AlertService, paginationConstants, Propriedade) {

        var vm = this;
        vm.mapaimagems = [];
        vm.typeMap = typeMap;
        vm.showMaps = showMaps;
        vm.clear = clear;
        vm.download = download;
        vm.sucessoDownload = sucessoDownload;
        vm.pressButtonMaps = pressButtonMaps;
        vm.tipoMapa = "";
        vm.textMaps = "";
        vm.safra = new Safra();
        vm.propriedade = null;
        vm.tipoNutricional = "Nitrogênio";
        vm.typeMap('Percevejo');
        vm.propriedades = Propriedade.queryNomesPropriedades({
            size: 100  
        });
        vm.loadPage = loadPage;
        vm.itemsPerPage = 20;
        vm.page = 0;
        vm.links = {
            last: 0
        };

        vm.safras = [];
        vm.onSucessoSafra = onSucessoSafra;


        vm.changePropriedade = function () {
            console.log("Change propriedade!");
            vm.safras = [];
            Safra.querySafraIdNome({size:1000}, vm.onSucessoSafra);
        }

        function onSucessoSafra(result){
            console.log(result);
            for (var i = 0; i < result.length; i++) {
                if(result[i].propriedade_id === parseInt(vm.propriedade.id)){
                    console.log("Added safra!");
                    vm.safras.push(result[i]);
                }
            }
        }

        function typeMap(tipoMapa) {
            console.log("typeMap " + tipoMapa);
            vm.tipoMapa = tipoMapa;
            console.log(vm.tipoNutricional);
            console.log("safra " + vm.safra.nomesafra);
            vm.clear();
        }

        function pressButtonMaps(){
            console.log("press " + vm.safra.nomesafra);
            vm.clear();
            vm.showMaps();
        }

        function showMaps() {
            console.log("showmap");
            if (vm.tipoMapa == "Nutricional") {
                console.log("nut");
                Mapaimagem.queryComparativoNutricional({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    safraid: vm.safra.id,
                    busca: vm.tipoNutricional
                },onSuccess,onError)
            }
            else {
                console.log("outros " + vm.tipoMapa);
                Mapaimagem.queryComparativoPragaSaude({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    safraid: vm.safra.id,
                    busca: vm.tipoMapa
                },onSuccess,onError)
            }
               
            function onSuccess(data, headers) {
                if (data.length == 0){
                    vm.textMaps = "Não existem mapas para serem exibidos";
                }
                console.log(data);
                console.log("sucesso");
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    if(vm.propriedade === null){
                        console.log("Added!");
                        data[i].imagempequenaContentType = 'data:' + data[i].imagempequenaContentType +';base64,' + data[i].imagempequena;
                        vm.mapaimagems.push(data[i]);
                    }
                    else{
                        if(data[i].propriedade_id === parseInt(vm.propriedade.id)){
                            console.log("Added!");
                            data[i].imagempequenaContentType = 'data:' + data[i].imagempequenaContentType +';base64,' + data[i].imagempequena;
                            vm.mapaimagems.push(data[i]);
                        }
                    }
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
        function loadPage(page) {
            vm.page = page;
            showMaps();
        }

        function clear () {
            vm.textMaps = "";
            vm.mapaimagems = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
        }
        function download(id){
            
            Mapaimagem.queryImagem({mapaid: id}, vm.sucessoDownload);
            
        }
        function b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;
          
            var byteCharacters = atob(b64Data);
            var byteArrays = [];
          
            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);
            
                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
            
                var byteArray = new Uint8Array(byteNumbers);
            
                byteArrays.push(byteArray);
            }
          
            var blob = new Blob(byteArrays, {type: contentType});
            return blob;
        }
        function sucessoDownload(data){
            var filename = 'mapa';
            console.log("SUCESSO");
            var ct = data[0].imagemContentType;
            var dados = data[0].imagem;
            
            /*
                element.setAttribute('href', 'data:' + ct + ';base64,' + dados);
                element.setAttribute('download', 'download');
            
                element.style.display = 'none';
                
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            */

           var blob = b64toBlob(dados, ct);

           if(window.navigator.msSaveOrOpenBlob) {
               window.navigator.msSaveBlob(blob, filename);
           }
           else{
               var elem = window.document.createElement('a');
               elem.href = window.URL.createObjectURL(blob);
               elem.download = filename;        
               document.body.appendChild(elem);
               elem.click();        
               document.body.removeChild(elem);
           }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ManutencaosafratestemDialogController', ManutencaosafratestemDialogController);

    ManutencaosafratestemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Manutencaosafratestem', 'Etapa', 'Safra', '$q'];

    function ManutencaosafratestemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Manutencaosafratestem, Etapa, Safra, $q) {
        var vm = this;

        vm.manutencaosafratestem = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.etapas = Etapa.query();

        vm.safras = Safra.query({filter: 'manutencaosafratestem-is-null'});
        $q.all([vm.manutencaosafratestem.$promise, vm.safras.$promise]).then(function() {
            if (!vm.manutencaosafratestem.safra || !vm.manutencaosafratestem.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.manutencaosafratestem.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "manutencaosafratestem";
            vm.etapa.safra = vm.manutencaosafratestem.safra;
            
            if (vm.manutencaosafratestem.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:manutencaosafratestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.manutencaosafratestem.etapa = new Etapa();
            vm.manutencaosafratestem.etapa = result;
            Manutencaosafratestem.save(vm.manutencaosafratestem, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:manutencaosafratestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.manutencaosafratestem.etapa = new Etapa();
            vm.manutencaosafratestem.etapa = result;
            Manutencaosafratestem.update(vm.manutencaosafratestem, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:manutencaosafratestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datainicio = false;
        vm.datePickerOpenStatus.datafim = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ManutencaosafratestemDetailController', ManutencaosafratestemDetailController);

    ManutencaosafratestemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Manutencaosafratestem', 'Etapa', 'Atividade'];

    function ManutencaosafratestemDetailController($scope, $rootScope, $stateParams, previousState, entity, Manutencaosafratestem, Etapa, Atividade) {
        var vm = this;

        vm.manutencaosafratestem = entity;
        vm.previousState = previousState.name;

        vm.atividades = [];

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.manutencaosafratestem.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        }


        var unsubscribe = $rootScope.$on('netWordAgroApp:manutencaosafratestemUpdate', function(event, result) {
            vm.manutencaosafratestem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ManutencaosafratestemDeleteController',ManutencaosafratestemDeleteController);

    ManutencaosafratestemDeleteController.$inject = ['$uibModalInstance', 'entity', 'Manutencaosafratestem', 'Etapa'];

    function ManutencaosafratestemDeleteController($uibModalInstance, entity, Manutencaosafratestem, Etapa) {
        var vm = this;

        vm.manutencaosafratestem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Manutencaosafratestem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    Etapa.delete({id: vm.manutencaosafratestem.etapa.id},
                        function () {
                            $uibModalInstance.close(true);
                        });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('manutencaosafratestem', {
            parent: 'entity',
            url: '/manutencaosafratestem',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.manutencaosafratestem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/manutencaosafratestem/manutencaosafratestems.html',
                    controller: 'ManutencaosafratestemController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('manutencaosafratestem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('manutencaosafratestem-detail', {
            parent: 'manutencaosafratestem',
            url: '/manutencaosafratestem/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.manutencaosafratestem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/manutencaosafratestem/manutencaosafratestem-detail.html',
                    controller: 'ManutencaosafratestemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('manutencaosafratestem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Manutencaosafratestem', function($stateParams, Manutencaosafratestem) {
                    return Manutencaosafratestem.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'manutencaosafratestem',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('manutencaosafratestem-detail.edit', {
            parent: 'manutencaosafratestem-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manutencaosafratestem/manutencaosafratestem-dialog.html',
                    controller: 'ManutencaosafratestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Manutencaosafratestem', function(Manutencaosafratestem) {
                            return Manutencaosafratestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('manutencaosafratestem.new', {
            parent: 'manutencaosafratestem',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manutencaosafratestem/manutencaosafratestem-dialog.html',
                    controller: 'ManutencaosafratestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                datainicio: null,
                                datafim: null,
                                descricaodamanutencao: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('manutencaosafratestem', null, { reload: 'manutencaosafratestem' });
                }, function() {
                    $state.go('manutencaosafratestem');
                });
            }]
        })
        .state('manutencaosafratestem.edit', {
            parent: 'manutencaosafratestem',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manutencaosafratestem/manutencaosafratestem-dialog.html',
                    controller: 'ManutencaosafratestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Manutencaosafratestem', function(Manutencaosafratestem) {
                            return Manutencaosafratestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('manutencaosafratestem', null, { reload: 'manutencaosafratestem' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('manutencaosafratestem.delete', {
            parent: 'manutencaosafratestem',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manutencaosafratestem/manutencaosafratestem-delete-dialog.html',
                    controller: 'ManutencaosafratestemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Manutencaosafratestem', function(Manutencaosafratestem) {
                            return Manutencaosafratestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('manutencaosafratestem', null, { reload: 'manutencaosafratestem' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Manutencaosafratestem', Manutencaosafratestem);

    Manutencaosafratestem.$inject = ['$resource', 'DateUtils'];

    function Manutencaosafratestem ($resource, DateUtils) {
        var resourceUrl =  'api/manutencaosafratestems/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datainicio = DateUtils.convertLocalDateFromServer(data.datainicio);
                        data.datafim = DateUtils.convertLocalDateFromServer(data.datafim);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datafim = DateUtils.convertLocalDateToServer(copy.datafim);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datafim = DateUtils.convertLocalDateToServer(copy.datafim);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('ManutencaosafratestemSearch', ManutencaosafratestemSearch);

    ManutencaosafratestemSearch.$inject = ['$resource'];

    function ManutencaosafratestemSearch($resource) {
        var resourceUrl =  'api/_search/manutencaosafratestems/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ManutencaosafratestemController', ManutencaosafratestemController);

    ManutencaosafratestemController.$inject = ['Manutencaosafratestem', 'ManutencaosafratestemSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function ManutencaosafratestemController(Manutencaosafratestem, ManutencaosafratestemSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.manutencaosafratestems = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                ManutencaosafratestemSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Manutencaosafratestem.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.manutencaosafratestems.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.manutencaosafratestems = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.manutencaosafratestems = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.manutencaosafratestems = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ManutencaosafraplanDialogController', ManutencaosafraplanDialogController);

    ManutencaosafraplanDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Manutencaosafraplan', 'Safra', 'Etapa', 'Principal'];

    function ManutencaosafraplanDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Manutencaosafraplan, Safra, Etapa, Principal) {
        var vm = this;

        vm.manutencaosafraplan = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.safras = Safra.query({filter: 'manutencaosafraplan-is-null'});
        $q.all([vm.manutencaosafraplan.$promise, vm.safras.$promise]).then(function() {
            if (!vm.manutencaosafraplan.safra || !vm.manutencaosafraplan.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.manutencaosafraplan.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });
        vm.etapas = Etapa.query();

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "manutencaosafraplan";
            vm.etapa.safra = vm.manutencaosafraplan.safra;
            
            if (vm.manutencaosafraplan.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
                Principal.identity().then(function (user) {
                    var data = {
                      user: user
                    };
                    vm.manutencaosafraplan.criador = user.login;
                });
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.manutencaosafraplan.etapa = new Etapa();
            vm.manutencaosafraplan.etapa = result;
            Manutencaosafraplan.save(vm.manutencaosafraplan, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.manutencaosafraplan.etapa = new Etapa();
            vm.manutencaosafraplan.etapa = result;
            Manutencaosafraplan.update(vm.manutencaosafraplan, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }
        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:manutencaosafraplanUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datainicio = false;
        vm.datePickerOpenStatus.datatermino = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ManutencaosafraplanDetailController', ManutencaosafraplanDetailController);

    ManutencaosafraplanDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Manutencaosafraplan', 'Safra', 'Etapa', 'Atividade'];

    function ManutencaosafraplanDetailController($scope, $rootScope, $stateParams, previousState, entity, Manutencaosafraplan, Safra, Etapa, Atividade) {
        var vm = this;

        vm.manutencaosafraplan = entity;
        vm.previousState = previousState.name;

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.manutencaosafraplan.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        }

        var unsubscribe = $rootScope.$on('netWordAgroApp:manutencaosafraplanUpdate', function(event, result) {
            vm.manutencaosafraplan = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ManutencaosafraplanDeleteController',ManutencaosafraplanDeleteController);

    ManutencaosafraplanDeleteController.$inject = ['$uibModalInstance', 'entity', 'Manutencaosafraplan', 'Etapa'];

    function ManutencaosafraplanDeleteController($uibModalInstance, entity, Manutencaosafraplan, Etapa) {
        var vm = this;

        vm.manutencaosafraplan = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Manutencaosafraplan.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    Etapa.delete({id: vm.manutencaosafraplan.etapa.id},
                        function () {
                            $uibModalInstance.close(true);
                        });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('manutencaosafraplan', {
            parent: 'entity',
            url: '/manutencaosafraplan',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.manutencaosafraplan.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/manutencaosafraplan/manutencaosafraplans.html',
                    controller: 'ManutencaosafraplanController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('manutencaosafraplan');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('manutencaosafraplan-detail', {
            parent: 'manutencaosafraplan',
            url: '/manutencaosafraplan/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.manutencaosafraplan.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/manutencaosafraplan/manutencaosafraplan-detail.html',
                    controller: 'ManutencaosafraplanDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('manutencaosafraplan');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Manutencaosafraplan', function($stateParams, Manutencaosafraplan) {
                    return Manutencaosafraplan.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'manutencaosafraplan',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('manutencaosafraplan-detail.edit', {
            parent: 'manutencaosafraplan-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manutencaosafraplan/manutencaosafraplan-dialog.html',
                    controller: 'ManutencaosafraplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Manutencaosafraplan', function(Manutencaosafraplan) {
                            return Manutencaosafraplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('manutencaosafraplan.new', {
            parent: 'manutencaosafraplan',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manutencaosafraplan/manutencaosafraplan-dialog.html',
                    controller: 'ManutencaosafraplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                datainicio: null,
                                datatermino: null,
                                descricaomanutencao: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('manutencaosafraplan', null, { reload: 'manutencaosafraplan' });
                }, function() {
                    $state.go('manutencaosafraplan');
                });
            }]
        })
        .state('manutencaosafraplan.edit', {
            parent: 'manutencaosafraplan',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manutencaosafraplan/manutencaosafraplan-dialog.html',
                    controller: 'ManutencaosafraplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Manutencaosafraplan', function(Manutencaosafraplan) {
                            return Manutencaosafraplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('manutencaosafraplan', null, { reload: 'manutencaosafraplan' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('manutencaosafraplan.delete', {
            parent: 'manutencaosafraplan',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manutencaosafraplan/manutencaosafraplan-delete-dialog.html',
                    controller: 'ManutencaosafraplanDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Manutencaosafraplan', function(Manutencaosafraplan) {
                            return Manutencaosafraplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('manutencaosafraplan', null, { reload: 'manutencaosafraplan' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Manutencaosafraplan', Manutencaosafraplan);

    Manutencaosafraplan.$inject = ['$resource', 'DateUtils'];

    function Manutencaosafraplan ($resource, DateUtils) {
        var resourceUrl =  'api/manutencaosafraplans/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datainicio = DateUtils.convertLocalDateFromServer(data.datainicio);
                        data.datatermino = DateUtils.convertLocalDateFromServer(data.datatermino);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('ManutencaosafraplanSearch', ManutencaosafraplanSearch);

    ManutencaosafraplanSearch.$inject = ['$resource'];

    function ManutencaosafraplanSearch($resource) {
        var resourceUrl =  'api/_search/manutencaosafraplans/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ManutencaosafraplanController', ManutencaosafraplanController);

    ManutencaosafraplanController.$inject = ['Manutencaosafraplan', 'ManutencaosafraplanSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function ManutencaosafraplanController(Manutencaosafraplan, ManutencaosafraplanSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.manutencaosafraplans = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                ManutencaosafraplanSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Manutencaosafraplan.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.manutencaosafraplans.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.manutencaosafraplans = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.manutencaosafraplans = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.manutencaosafraplans = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ManutencaosafraDialogController', ManutencaosafraDialogController);

    ManutencaosafraDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Manutencaosafra', 'Safra', 'Etapa', 'Principal'];

    function ManutencaosafraDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Manutencaosafra, Safra, Etapa, Principal) {
        var vm = this;

        vm.manutencaosafra = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.safras = Safra.query({filter: 'manutencaosafra-is-null'});
        $q.all([vm.manutencaosafra.$promise, vm.safras.$promise]).then(function() {
            if (!vm.manutencaosafra.safra || !vm.manutencaosafra.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.manutencaosafra.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });
        vm.etapas = Etapa.query();

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "manutencaosafra";
            vm.etapa.safra = vm.manutencaosafra.safra;
            
            if (vm.manutencaosafra.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
                Principal.identity().then(function (user) {
                    var data = {
                      user: user
                    };
                    vm.manutencaosafra.criador = user.login;
                });
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.manutencaosafra.etapa = new Etapa();
            vm.manutencaosafra.etapa = result;
            Manutencaosafra.save(vm.manutencaosafra, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.manutencaosafra.etapa = new Etapa();
            vm.manutencaosafra.etapa = result;
            Manutencaosafra.update(vm.manutencaosafra, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }
        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:manutencaosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datainicio = false;
        vm.datePickerOpenStatus.datatermino = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ManutencaosafraDetailController', ManutencaosafraDetailController);

    ManutencaosafraDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Manutencaosafra', 'Safra', 'Etapa', 'Atividade'];

    function ManutencaosafraDetailController($scope, $rootScope, $stateParams, previousState, entity, Manutencaosafra, Safra, Etapa, Atividade) {
        var vm = this;

        vm.manutencaosafra = entity;
        vm.previousState = previousState.name;

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.manutencaosafra.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        }

        var unsubscribe = $rootScope.$on('netWordAgroApp:manutencaosafraUpdate', function(event, result) {
            vm.manutencaosafra = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ManutencaosafraDeleteController',ManutencaosafraDeleteController);

    ManutencaosafraDeleteController.$inject = ['$uibModalInstance', 'entity', 'Manutencaosafra', 'Etapa'];

    function ManutencaosafraDeleteController($uibModalInstance, entity, Manutencaosafra, Etapa) {
        var vm = this;

        vm.manutencaosafra = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Manutencaosafra.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    Etapa.delete({id: vm.manutencaosafra.etapa.id},
                        function () {
                            $uibModalInstance.close(true);
                        });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('manutencaosafra', {
            parent: 'entity',
            url: '/manutencaosafra',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.manutencaosafra.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/manutencaosafra/manutencaosafras.html',
                    controller: 'ManutencaosafraController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('manutencaosafra');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('manutencaosafra-detail', {
            parent: 'manutencaosafra',
            url: '/manutencaosafra/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.manutencaosafra.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/manutencaosafra/manutencaosafra-detail.html',
                    controller: 'ManutencaosafraDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('manutencaosafra');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Manutencaosafra', function($stateParams, Manutencaosafra) {
                    return Manutencaosafra.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'manutencaosafra',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('manutencaosafra-detail.edit', {
            parent: 'manutencaosafra-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manutencaosafra/manutencaosafra-dialog.html',
                    controller: 'ManutencaosafraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Manutencaosafra', function(Manutencaosafra) {
                            return Manutencaosafra.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('manutencaosafra.new', {
            parent: 'manutencaosafra',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manutencaosafra/manutencaosafra-dialog.html',
                    controller: 'ManutencaosafraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                datainicio: null,
                                datatermino: null,
                                descricaomanutencao: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('manutencaosafra', null, { reload: 'manutencaosafra' });
                }, function() {
                    $state.go('manutencaosafra');
                });
            }]
        })
        .state('manutencaosafra.edit', {
            parent: 'manutencaosafra',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manutencaosafra/manutencaosafra-dialog.html',
                    controller: 'ManutencaosafraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Manutencaosafra', function(Manutencaosafra) {
                            return Manutencaosafra.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('manutencaosafra', null, { reload: 'manutencaosafra' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('manutencaosafra.delete', {
            parent: 'manutencaosafra',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manutencaosafra/manutencaosafra-delete-dialog.html',
                    controller: 'ManutencaosafraDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Manutencaosafra', function(Manutencaosafra) {
                            return Manutencaosafra.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('manutencaosafra', null, { reload: 'manutencaosafra' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Manutencaosafra', Manutencaosafra);

    Manutencaosafra.$inject = ['$resource', 'DateUtils'];

    function Manutencaosafra ($resource, DateUtils) {
        var resourceUrl =  'api/manutencaosafras/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datainicio = DateUtils.convertLocalDateFromServer(data.datainicio);
                        data.datatermino = DateUtils.convertLocalDateFromServer(data.datatermino);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('ManutencaosafraSearch', ManutencaosafraSearch);

    ManutencaosafraSearch.$inject = ['$resource'];

    function ManutencaosafraSearch($resource) {
        var resourceUrl =  'api/_search/manutencaosafras/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ManutencaosafraController', ManutencaosafraController);

    ManutencaosafraController.$inject = ['Manutencaosafra', 'ManutencaosafraSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function ManutencaosafraController(Manutencaosafra, ManutencaosafraSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.manutencaosafras = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                ManutencaosafraSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Manutencaosafra.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.manutencaosafras.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.manutencaosafras = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.manutencaosafras = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.manutencaosafras = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LogrecinsumotestemDialogController', LogrecinsumotestemDialogController);

    LogrecinsumotestemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Logrecinsumotestem', 'Etapa', 'Aquisicao', 'Safra', '$q'];

    function LogrecinsumotestemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Logrecinsumotestem, Etapa, Aquisicao, Safra, $q) {
        var vm = this;

        vm.logrecinsumotestem = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.etapas = Etapa.query();
        vm.aquisicaos = Aquisicao.query();

        vm.safras = Safra.query({filter: 'logrecinsumotestem-is-null'});
        $q.all([vm.logrecinsumotestem.$promise, vm.safras.$promise]).then(function() {
            if (!vm.logrecinsumotestem.safra || !vm.logrecinsumotestem.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.logrecinsumotestem.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "logrecinsumotestem";
            vm.etapa.safra = vm.logrecinsumotestem.safra;
            
            if (vm.logrecinsumotestem.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:logrecinsumotestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.logrecinsumotestem.etapa = new Etapa();
            vm.logrecinsumotestem.etapa = result;
            Logrecinsumotestem.save(vm.logrecinsumotestem, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:logrecinsumotestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.logrecinsumotestem.etapa = new Etapa();
            vm.logrecinsumotestem.etapa = result;
            Logrecinsumotestem.update(vm.logrecinsumotestem, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:logrecinsumotestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datainicio = false;
        vm.datePickerOpenStatus.datatermino = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LogrecinsumotestemDetailController', LogrecinsumotestemDetailController);

    LogrecinsumotestemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Logrecinsumotestem', 'Etapa', 'Aquisicao', 'Atividade'];

    function LogrecinsumotestemDetailController($scope, $rootScope, $stateParams, previousState, entity, Logrecinsumotestem, Etapa, Aquisicao, Atividade) {
        var vm = this;

        vm.logrecinsumotestem = entity;
        vm.previousState = previousState.name;

        vm.atividades = [];

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.logrecinsumotestem.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        }


        var unsubscribe = $rootScope.$on('netWordAgroApp:logrecinsumotestemUpdate', function(event, result) {
            vm.logrecinsumotestem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LogrecinsumotestemDeleteController',LogrecinsumotestemDeleteController);

    LogrecinsumotestemDeleteController.$inject = ['$uibModalInstance', 'entity', 'Logrecinsumotestem', 'Etapa'];

    function LogrecinsumotestemDeleteController($uibModalInstance, entity, Logrecinsumotestem, Etapa) {
        var vm = this;

        vm.logrecinsumotestem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Logrecinsumotestem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    Etapa.delete({id: vm.logrecinsumotestem.etapa.id},
                        function () {
                            $uibModalInstance.close(true);
                        });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('logrecinsumotestem', {
            parent: 'entity',
            url: '/logrecinsumotestem',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.logrecinsumotestem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/logrecinsumotestem/logrecinsumotestems.html',
                    controller: 'LogrecinsumotestemController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logrecinsumotestem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('logrecinsumotestem-detail', {
            parent: 'logrecinsumotestem',
            url: '/logrecinsumotestem/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.logrecinsumotestem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/logrecinsumotestem/logrecinsumotestem-detail.html',
                    controller: 'LogrecinsumotestemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logrecinsumotestem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Logrecinsumotestem', function($stateParams, Logrecinsumotestem) {
                    return Logrecinsumotestem.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'logrecinsumotestem',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('logrecinsumotestem-detail.edit', {
            parent: 'logrecinsumotestem-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/logrecinsumotestem/logrecinsumotestem-dialog.html',
                    controller: 'LogrecinsumotestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Logrecinsumotestem', function(Logrecinsumotestem) {
                            return Logrecinsumotestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('logrecinsumotestem.new', {
            parent: 'logrecinsumotestem',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/logrecinsumotestem/logrecinsumotestem-dialog.html',
                    controller: 'LogrecinsumotestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                datainicio: null,
                                datatermino: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('logrecinsumotestem', null, { reload: 'logrecinsumotestem' });
                }, function() {
                    $state.go('logrecinsumotestem');
                });
            }]
        })
        .state('logrecinsumotestem.edit', {
            parent: 'logrecinsumotestem',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/logrecinsumotestem/logrecinsumotestem-dialog.html',
                    controller: 'LogrecinsumotestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Logrecinsumotestem', function(Logrecinsumotestem) {
                            return Logrecinsumotestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('logrecinsumotestem', null, { reload: 'logrecinsumotestem' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('logrecinsumotestem.delete', {
            parent: 'logrecinsumotestem',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/logrecinsumotestem/logrecinsumotestem-delete-dialog.html',
                    controller: 'LogrecinsumotestemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Logrecinsumotestem', function(Logrecinsumotestem) {
                            return Logrecinsumotestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('logrecinsumotestem', null, { reload: 'logrecinsumotestem' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Logrecinsumotestem', Logrecinsumotestem);

    Logrecinsumotestem.$inject = ['$resource', 'DateUtils'];

    function Logrecinsumotestem ($resource, DateUtils) {
        var resourceUrl =  'api/logrecinsumotestems/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datainicio = DateUtils.convertLocalDateFromServer(data.datainicio);
                        data.datatermino = DateUtils.convertLocalDateFromServer(data.datatermino);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('LogrecinsumotestemSearch', LogrecinsumotestemSearch);

    LogrecinsumotestemSearch.$inject = ['$resource'];

    function LogrecinsumotestemSearch($resource) {
        var resourceUrl =  'api/_search/logrecinsumotestems/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LogrecinsumotestemController', LogrecinsumotestemController);

    LogrecinsumotestemController.$inject = ['Logrecinsumotestem', 'LogrecinsumotestemSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function LogrecinsumotestemController(Logrecinsumotestem, LogrecinsumotestemSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.logrecinsumotestems = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                LogrecinsumotestemSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Logrecinsumotestem.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.logrecinsumotestems.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.logrecinsumotestems = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.logrecinsumotestems = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.logrecinsumotestems = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LogrecinsumoplanDialogController', LogrecinsumoplanDialogController);

    LogrecinsumoplanDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Logrecinsumoplan', 'Aquisicaoplan', 'Safra', 'Etapa', 'Principal'];

    function LogrecinsumoplanDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Logrecinsumoplan, Aquisicaoplan, Safra, Etapa, Principal) {
        var vm = this;

        vm.logrecinsumoplan = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.aquisicaoplans = Aquisicaoplan.query();
        vm.safras = Safra.query({filter: 'logrecinsumoplan-is-null'});
        $q.all([vm.logrecinsumoplan.$promise, vm.safras.$promise]).then(function() {
            if (!vm.logrecinsumoplan.safra || !vm.logrecinsumoplan.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.logrecinsumoplan.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });
        vm.etapas = Etapa.query();

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "logrecinsumoplan";
            vm.etapa.safra = vm.logrecinsumoplan.safra;
            
            if (vm.logrecinsumoplan.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
                Principal.identity().then(function (user) {
                    var data = {
                      user: user
                    };
                    vm.logrecinsumoplan.criador = user.login;
                });
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.logrecinsumoplan.etapa = new Etapa();
            vm.logrecinsumoplan.etapa = result;
            Logrecinsumoplan.save(vm.logrecinsumoplan, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.logrecinsumoplan.etapa = new Etapa();
            vm.logrecinsumoplan.etapa = result;
            Logrecinsumoplan.update(vm.logrecinsumoplan, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:logrecinsumoplanUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datainicio = false;
        vm.datePickerOpenStatus.datatermino = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LogrecinsumoplanDetailController', LogrecinsumoplanDetailController);

    LogrecinsumoplanDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Logrecinsumoplan', 'Aquisicaoplan', 'Safra', 'Etapa', 'Atividade'];

    function LogrecinsumoplanDetailController($scope, $rootScope, $stateParams, previousState, entity, Logrecinsumoplan, Aquisicaoplan, Safra, Etapa, Atividade) {
        var vm = this;

        vm.logrecinsumoplan = entity;
        vm.previousState = previousState.name;

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.logrecinsumoplan.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        }


        var unsubscribe = $rootScope.$on('netWordAgroApp:logrecinsumoplanUpdate', function(event, result) {
            vm.logrecinsumoplan = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LogrecinsumoplanDeleteController',LogrecinsumoplanDeleteController);

    LogrecinsumoplanDeleteController.$inject = ['$uibModalInstance', 'entity', 'Logrecinsumoplan', 'Etapa'];

    function LogrecinsumoplanDeleteController($uibModalInstance, entity, Logrecinsumoplan, Etapa) {
        var vm = this;

        vm.logrecinsumoplan = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Logrecinsumoplan.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    Etapa.delete({id: vm.logrecinsumoplan.etapa.id},
                        function () {
                            $uibModalInstance.close(true);
                        });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('logrecinsumoplan', {
            parent: 'entity',
            url: '/logrecinsumoplan',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.logrecinsumoplan.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/logrecinsumoplan/logrecinsumoplans.html',
                    controller: 'LogrecinsumoplanController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logrecinsumoplan');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('logrecinsumoplan-detail', {
            parent: 'logrecinsumoplan',
            url: '/logrecinsumoplan/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.logrecinsumoplan.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/logrecinsumoplan/logrecinsumoplan-detail.html',
                    controller: 'LogrecinsumoplanDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logrecinsumoplan');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Logrecinsumoplan', function($stateParams, Logrecinsumoplan) {
                    return Logrecinsumoplan.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'logrecinsumoplan',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('logrecinsumoplan-detail.edit', {
            parent: 'logrecinsumoplan-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/logrecinsumoplan/logrecinsumoplan-dialog.html',
                    controller: 'LogrecinsumoplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Logrecinsumoplan', function(Logrecinsumoplan) {
                            return Logrecinsumoplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('logrecinsumoplan.new', {
            parent: 'logrecinsumoplan',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/logrecinsumoplan/logrecinsumoplan-dialog.html',
                    controller: 'LogrecinsumoplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                datainicio: null,
                                datatermino: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('logrecinsumoplan', null, { reload: 'logrecinsumoplan' });
                }, function() {
                    $state.go('logrecinsumoplan');
                });
            }]
        })
        .state('logrecinsumoplan.edit', {
            parent: 'logrecinsumoplan',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/logrecinsumoplan/logrecinsumoplan-dialog.html',
                    controller: 'LogrecinsumoplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Logrecinsumoplan', function(Logrecinsumoplan) {
                            return Logrecinsumoplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('logrecinsumoplan', null, { reload: 'logrecinsumoplan' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('logrecinsumoplan.delete', {
            parent: 'logrecinsumoplan',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/logrecinsumoplan/logrecinsumoplan-delete-dialog.html',
                    controller: 'LogrecinsumoplanDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Logrecinsumoplan', function(Logrecinsumoplan) {
                            return Logrecinsumoplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('logrecinsumoplan', null, { reload: 'logrecinsumoplan' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Logrecinsumoplan', Logrecinsumoplan);

    Logrecinsumoplan.$inject = ['$resource', 'DateUtils'];

    function Logrecinsumoplan ($resource, DateUtils) {
        var resourceUrl =  'api/logrecinsumoplans/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datainicio = DateUtils.convertLocalDateFromServer(data.datainicio);
                        data.datatermino = DateUtils.convertLocalDateFromServer(data.datatermino);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('LogrecinsumoplanSearch', LogrecinsumoplanSearch);

    LogrecinsumoplanSearch.$inject = ['$resource'];

    function LogrecinsumoplanSearch($resource) {
        var resourceUrl =  'api/_search/logrecinsumoplans/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LogrecinsumoplanController', LogrecinsumoplanController);

    LogrecinsumoplanController.$inject = ['Logrecinsumoplan', 'LogrecinsumoplanSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function LogrecinsumoplanController(Logrecinsumoplan, LogrecinsumoplanSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.logrecinsumoplans = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                LogrecinsumoplanSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Logrecinsumoplan.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.logrecinsumoplans.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.logrecinsumoplans = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.logrecinsumoplans = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.logrecinsumoplans = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LogrecinsumoDialogController', LogrecinsumoDialogController);

    LogrecinsumoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Logrecinsumo', 'Aquisicao', 'Safra', 'Etapa', 'Principal'];

    function LogrecinsumoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Logrecinsumo, Aquisicao, Safra, Etapa, Principal) {
        var vm = this;

        vm.logrecinsumo = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.aquisicaos = Aquisicao.query();
        vm.safras = Safra.query({filter: 'logrecinsumo-is-null'});
        $q.all([vm.logrecinsumo.$promise, vm.safras.$promise]).then(function() {
            if (!vm.logrecinsumo.safra || !vm.logrecinsumo.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.logrecinsumo.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });
        vm.etapas = Etapa.query();

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "logrecinsumo";
            vm.etapa.safra = vm.logrecinsumo.safra;
            
            if (vm.logrecinsumo.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
                Principal.identity().then(function (user) {
                    var data = {
                      user: user
                    };
                    vm.logrecinsumo.criador = user.login;
                });
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.logrecinsumo.etapa = new Etapa();
            vm.logrecinsumo.etapa = result;
            Logrecinsumo.save(vm.logrecinsumo, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.logrecinsumo.etapa = new Etapa();
            vm.logrecinsumo.etapa = result;
            Logrecinsumo.update(vm.logrecinsumo, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }
        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:logrecinsumoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datainicio = false;
        vm.datePickerOpenStatus.datatermino = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LogrecinsumoDetailController', LogrecinsumoDetailController);

    LogrecinsumoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Logrecinsumo', 'Aquisicao', 'Safra', 'Etapa', 'Atividade'];

    function LogrecinsumoDetailController($scope, $rootScope, $stateParams, previousState, entity, Logrecinsumo, Aquisicao, Safra, Etapa, Atividade) {
        var vm = this;

        vm.logrecinsumo = entity;
        vm.previousState = previousState.name;

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.logrecinsumo.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        }

        var unsubscribe = $rootScope.$on('netWordAgroApp:logrecinsumoUpdate', function(event, result) {
            vm.logrecinsumo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LogrecinsumoDeleteController',LogrecinsumoDeleteController);

    LogrecinsumoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Logrecinsumo', 'Etapa'];

    function LogrecinsumoDeleteController($uibModalInstance, entity, Logrecinsumo, Etapa) {
        var vm = this;

        vm.logrecinsumo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Logrecinsumo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    Etapa.delete({id: vm.logrecinsumo.etapa.id},
                        function () {
                            $uibModalInstance.close(true);
                        });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('logrecinsumo', {
            parent: 'entity',
            url: '/logrecinsumo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.logrecinsumo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/logrecinsumo/logrecinsumos.html',
                    controller: 'LogrecinsumoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logrecinsumo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('logrecinsumo-detail', {
            parent: 'logrecinsumo',
            url: '/logrecinsumo/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.logrecinsumo.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/logrecinsumo/logrecinsumo-detail.html',
                    controller: 'LogrecinsumoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logrecinsumo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Logrecinsumo', function($stateParams, Logrecinsumo) {
                    return Logrecinsumo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'logrecinsumo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('logrecinsumo-detail.edit', {
            parent: 'logrecinsumo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/logrecinsumo/logrecinsumo-dialog.html',
                    controller: 'LogrecinsumoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Logrecinsumo', function(Logrecinsumo) {
                            return Logrecinsumo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('logrecinsumo.new', {
            parent: 'logrecinsumo',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/logrecinsumo/logrecinsumo-dialog.html',
                    controller: 'LogrecinsumoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                datainicio: null,
                                datatermino: null,
                                criador: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('logrecinsumo', null, { reload: 'logrecinsumo' });
                }, function() {
                    $state.go('logrecinsumo');
                });
            }]
        })
        .state('logrecinsumo.edit', {
            parent: 'logrecinsumo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/logrecinsumo/logrecinsumo-dialog.html',
                    controller: 'LogrecinsumoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Logrecinsumo', function(Logrecinsumo) {
                            return Logrecinsumo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('logrecinsumo', null, { reload: 'logrecinsumo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('logrecinsumo.delete', {
            parent: 'logrecinsumo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/logrecinsumo/logrecinsumo-delete-dialog.html',
                    controller: 'LogrecinsumoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Logrecinsumo', function(Logrecinsumo) {
                            return Logrecinsumo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('logrecinsumo', null, { reload: 'logrecinsumo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Logrecinsumo', Logrecinsumo);

    Logrecinsumo.$inject = ['$resource', 'DateUtils'];

    function Logrecinsumo ($resource, DateUtils) {
        var resourceUrl =  'api/logrecinsumos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datainicio = DateUtils.convertLocalDateFromServer(data.datainicio);
                        data.datatermino = DateUtils.convertLocalDateFromServer(data.datatermino);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('LogrecinsumoSearch', LogrecinsumoSearch);

    LogrecinsumoSearch.$inject = ['$resource'];

    function LogrecinsumoSearch($resource) {
        var resourceUrl =  'api/_search/logrecinsumos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LogrecinsumoController', LogrecinsumoController);

    LogrecinsumoController.$inject = ['Logrecinsumo', 'LogrecinsumoSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function LogrecinsumoController(Logrecinsumo, LogrecinsumoSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.logrecinsumos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                LogrecinsumoSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Logrecinsumo.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.logrecinsumos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.logrecinsumos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.logrecinsumos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.logrecinsumos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LogentregaarmaztestemDialogController', LogentregaarmaztestemDialogController);

    LogentregaarmaztestemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Logentregaarmaztestem', 'Etapa', 'Safra', '$q'];

    function LogentregaarmaztestemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Logentregaarmaztestem, Etapa, Safra, $q) {
        var vm = this;

        vm.logentregaarmaztestem = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.etapas = Etapa.query();

        vm.safras = Safra.query({filter: 'logentregaarmaztestem-is-null'});
        $q.all([vm.logentregaarmaztestem.$promise, vm.safras.$promise]).then(function() {
            if (!vm.logentregaarmaztestem.safra || !vm.logentregaarmaztestem.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.logentregaarmaztestem.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "logentregaarmaztestem";
            vm.etapa.safra = vm.logentregaarmaztestem.safra;
            
            if (vm.logentregaarmaztestem.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:logentregaarmaztestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.logentregaarmaztestem.etapa = new Etapa();
            vm.logentregaarmaztestem.etapa = result;
            Logentregaarmaztestem.save(vm.logentregaarmaztestem, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:logentregaarmaztestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.logentregaarmaztestem.etapa = new Etapa();
            vm.logentregaarmaztestem.etapa = result;
            Logentregaarmaztestem.update(vm.logentregaarmaztestem, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:logentregaarmaztestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datainicio = false;
        vm.datePickerOpenStatus.datatermino = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LogentregaarmaztestemDetailController', LogentregaarmaztestemDetailController);

    LogentregaarmaztestemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Logentregaarmaztestem', 'Etapa', 'Atividade'];

    function LogentregaarmaztestemDetailController($scope, $rootScope, $stateParams, previousState, entity, Logentregaarmaztestem, Etapa, Atividade) {
        var vm = this;

        vm.logentregaarmaztestem = entity;
        vm.previousState = previousState.name;

        vm.atividades = [];

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.logentregaarmaztestem.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        }

        var unsubscribe = $rootScope.$on('netWordAgroApp:logentregaarmaztestemUpdate', function(event, result) {
            vm.logentregaarmaztestem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LogentregaarmaztestemDeleteController',LogentregaarmaztestemDeleteController);

    LogentregaarmaztestemDeleteController.$inject = ['$uibModalInstance', 'entity', 'Logentregaarmaztestem', 'Etapa'];

    function LogentregaarmaztestemDeleteController($uibModalInstance, entity, Logentregaarmaztestem, Etapa) {
        var vm = this;

        vm.logentregaarmaztestem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Logentregaarmaztestem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    Etapa.delete({id: vm.logentregaarmaztestem.etapa.id},
                        function () {
                            $uibModalInstance.close(true);
                        });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('logentregaarmaztestem', {
            parent: 'entity',
            url: '/logentregaarmaztestem',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.logentregaarmaztestem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/logentregaarmaztestem/logentregaarmaztestems.html',
                    controller: 'LogentregaarmaztestemController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logentregaarmaztestem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('logentregaarmaztestem-detail', {
            parent: 'logentregaarmaztestem',
            url: '/logentregaarmaztestem/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.logentregaarmaztestem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/logentregaarmaztestem/logentregaarmaztestem-detail.html',
                    controller: 'LogentregaarmaztestemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logentregaarmaztestem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Logentregaarmaztestem', function($stateParams, Logentregaarmaztestem) {
                    return Logentregaarmaztestem.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'logentregaarmaztestem',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('logentregaarmaztestem-detail.edit', {
            parent: 'logentregaarmaztestem-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/logentregaarmaztestem/logentregaarmaztestem-dialog.html',
                    controller: 'LogentregaarmaztestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Logentregaarmaztestem', function(Logentregaarmaztestem) {
                            return Logentregaarmaztestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('logentregaarmaztestem.new', {
            parent: 'logentregaarmaztestem',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/logentregaarmaztestem/logentregaarmaztestem-dialog.html',
                    controller: 'LogentregaarmaztestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                datainicio: null,
                                datatermino: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('logentregaarmaztestem', null, { reload: 'logentregaarmaztestem' });
                }, function() {
                    $state.go('logentregaarmaztestem');
                });
            }]
        })
        .state('logentregaarmaztestem.edit', {
            parent: 'logentregaarmaztestem',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/logentregaarmaztestem/logentregaarmaztestem-dialog.html',
                    controller: 'LogentregaarmaztestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Logentregaarmaztestem', function(Logentregaarmaztestem) {
                            return Logentregaarmaztestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('logentregaarmaztestem', null, { reload: 'logentregaarmaztestem' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('logentregaarmaztestem.delete', {
            parent: 'logentregaarmaztestem',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/logentregaarmaztestem/logentregaarmaztestem-delete-dialog.html',
                    controller: 'LogentregaarmaztestemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Logentregaarmaztestem', function(Logentregaarmaztestem) {
                            return Logentregaarmaztestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('logentregaarmaztestem', null, { reload: 'logentregaarmaztestem' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Logentregaarmaztestem', Logentregaarmaztestem);

    Logentregaarmaztestem.$inject = ['$resource', 'DateUtils'];

    function Logentregaarmaztestem ($resource, DateUtils) {
        var resourceUrl =  'api/logentregaarmaztestems/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datainicio = DateUtils.convertLocalDateFromServer(data.datainicio);
                        data.datatermino = DateUtils.convertLocalDateFromServer(data.datatermino);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('LogentregaarmaztestemSearch', LogentregaarmaztestemSearch);

    LogentregaarmaztestemSearch.$inject = ['$resource'];

    function LogentregaarmaztestemSearch($resource) {
        var resourceUrl =  'api/_search/logentregaarmaztestems/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LogentregaarmaztestemController', LogentregaarmaztestemController);

    LogentregaarmaztestemController.$inject = ['Logentregaarmaztestem', 'LogentregaarmaztestemSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function LogentregaarmaztestemController(Logentregaarmaztestem, LogentregaarmaztestemSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.logentregaarmaztestems = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                LogentregaarmaztestemSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Logentregaarmaztestem.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.logentregaarmaztestems.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.logentregaarmaztestems = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.logentregaarmaztestems = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.logentregaarmaztestems = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LogentregaarmazplanDialogController', LogentregaarmazplanDialogController);

    LogentregaarmazplanDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Logentregaarmazplan', 'Safra', 'Etapa', 'Principal'];

    function LogentregaarmazplanDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Logentregaarmazplan, Safra, Etapa, Principal) {
        var vm = this;

        vm.logentregaarmazplan = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.safras = Safra.query({filter: 'logentregaarmazplan-is-null'});
        $q.all([vm.logentregaarmazplan.$promise, vm.safras.$promise]).then(function() {
            if (!vm.logentregaarmazplan.safra || !vm.logentregaarmazplan.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.logentregaarmazplan.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });
        vm.etapas = Etapa.query();

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "logentregaarmazplan";
            vm.etapa.safra = vm.logentregaarmazplan.safra;
            
            if (vm.logentregaarmazplan.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
                Principal.identity().then(function (user) {
                    var data = {
                      user: user
                    };
                    vm.logentregaarmazplan.criador = user.login;
                });
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.logentregaarmazplan.etapa = new Etapa();
            vm.logentregaarmazplan.etapa = result;
            Logentregaarmazplan.save(vm.logentregaarmazplan, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.logentregaarmazplan.etapa = new Etapa();
            vm.logentregaarmazplan.etapa = result;
            Logentregaarmazplan.update(vm.logentregaarmazplan, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:logentregaarmazplanUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datainicio = false;
        vm.datePickerOpenStatus.datatermino = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LogentregaarmazplanDetailController', LogentregaarmazplanDetailController);

    LogentregaarmazplanDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Logentregaarmazplan', 'Safra', 'Etapa', 'Atividade'];

    function LogentregaarmazplanDetailController($scope, $rootScope, $stateParams, previousState, entity, Logentregaarmazplan, Safra, Etapa, Atividade) {
        var vm = this;

        vm.logentregaarmazplan = entity;
        vm.previousState = previousState.name;


        vm.atividades = [];

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.logentregaarmazplan.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        } 

        var unsubscribe = $rootScope.$on('netWordAgroApp:logentregaarmazplanUpdate', function(event, result) {
            vm.logentregaarmazplan = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LogentregaarmazplanDeleteController',LogentregaarmazplanDeleteController);

    LogentregaarmazplanDeleteController.$inject = ['$uibModalInstance', 'entity', 'Logentregaarmazplan', 'Etapa'];

    function LogentregaarmazplanDeleteController($uibModalInstance, entity, Logentregaarmazplan, Etapa) {
        var vm = this;

        vm.logentregaarmazplan = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Logentregaarmazplan.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    Etapa.delete({id: vm.logentregaarmazplan.etapa.id},
                        function () {
                            $uibModalInstance.close(true);
                        });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('logentregaarmazplan', {
            parent: 'entity',
            url: '/logentregaarmazplan',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.logentregaarmazplan.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/logentregaarmazplan/logentregaarmazplans.html',
                    controller: 'LogentregaarmazplanController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logentregaarmazplan');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('logentregaarmazplan-detail', {
            parent: 'logentregaarmazplan',
            url: '/logentregaarmazplan/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.logentregaarmazplan.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/logentregaarmazplan/logentregaarmazplan-detail.html',
                    controller: 'LogentregaarmazplanDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logentregaarmazplan');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Logentregaarmazplan', function($stateParams, Logentregaarmazplan) {
                    return Logentregaarmazplan.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'logentregaarmazplan',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('logentregaarmazplan-detail.edit', {
            parent: 'logentregaarmazplan-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/logentregaarmazplan/logentregaarmazplan-dialog.html',
                    controller: 'LogentregaarmazplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Logentregaarmazplan', function(Logentregaarmazplan) {
                            return Logentregaarmazplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('logentregaarmazplan.new', {
            parent: 'logentregaarmazplan',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/logentregaarmazplan/logentregaarmazplan-dialog.html',
                    controller: 'LogentregaarmazplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                datainicio: null,
                                datatermino: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('logentregaarmazplan', null, { reload: 'logentregaarmazplan' });
                }, function() {
                    $state.go('logentregaarmazplan');
                });
            }]
        })
        .state('logentregaarmazplan.edit', {
            parent: 'logentregaarmazplan',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/logentregaarmazplan/logentregaarmazplan-dialog.html',
                    controller: 'LogentregaarmazplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Logentregaarmazplan', function(Logentregaarmazplan) {
                            return Logentregaarmazplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('logentregaarmazplan', null, { reload: 'logentregaarmazplan' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('logentregaarmazplan.delete', {
            parent: 'logentregaarmazplan',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/logentregaarmazplan/logentregaarmazplan-delete-dialog.html',
                    controller: 'LogentregaarmazplanDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Logentregaarmazplan', function(Logentregaarmazplan) {
                            return Logentregaarmazplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('logentregaarmazplan', null, { reload: 'logentregaarmazplan' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Logentregaarmazplan', Logentregaarmazplan);

    Logentregaarmazplan.$inject = ['$resource', 'DateUtils'];

    function Logentregaarmazplan ($resource, DateUtils) {
        var resourceUrl =  'api/logentregaarmazplans/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datainicio = DateUtils.convertLocalDateFromServer(data.datainicio);
                        data.datatermino = DateUtils.convertLocalDateFromServer(data.datatermino);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('LogentregaarmazplanSearch', LogentregaarmazplanSearch);

    LogentregaarmazplanSearch.$inject = ['$resource'];

    function LogentregaarmazplanSearch($resource) {
        var resourceUrl =  'api/_search/logentregaarmazplans/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LogentregaarmazplanController', LogentregaarmazplanController);

    LogentregaarmazplanController.$inject = ['Logentregaarmazplan', 'LogentregaarmazplanSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function LogentregaarmazplanController(Logentregaarmazplan, LogentregaarmazplanSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.logentregaarmazplans = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                LogentregaarmazplanSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Logentregaarmazplan.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.logentregaarmazplans.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.logentregaarmazplans = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.logentregaarmazplans = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.logentregaarmazplans = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LogentregaarmazDialogController', LogentregaarmazDialogController);

    LogentregaarmazDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Logentregaarmaz', 'Safra', 'Etapa', 'Principal'];

    function LogentregaarmazDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Logentregaarmaz, Safra, Etapa, Principal) {
        var vm = this;

        vm.logentregaarmaz = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.safras = Safra.query({filter: 'logentregaarmaz-is-null'});
        $q.all([vm.logentregaarmaz.$promise, vm.safras.$promise]).then(function() {
            if (!vm.logentregaarmaz.safra || !vm.logentregaarmaz.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.logentregaarmaz.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });
        vm.etapas = Etapa.query();

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "logentregaarmaz";
            vm.etapa.safra = vm.logentregaarmaz.safra;
            
            if (vm.logentregaarmaz.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
                Principal.identity().then(function (user) {
                    var data = {
                      user: user
                    };
                    vm.logentregaarmaz.criador = user.login;
                });
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.logentregaarmaz.etapa = new Etapa();
            vm.logentregaarmaz.etapa = result;
            Logentregaarmaz.save(vm.logentregaarmaz, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.logentregaarmaz.etapa = new Etapa();
            vm.logentregaarmaz.etapa = result;
            Logentregaarmaz.update(vm.logentregaarmaz, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:logentregaarmazUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datainicio = false;
        vm.datePickerOpenStatus.datatermino = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LogentregaarmazDetailController', LogentregaarmazDetailController);

    LogentregaarmazDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Logentregaarmaz', 'Safra', 'Etapa', 'Atividade'];

    function LogentregaarmazDetailController($scope, $rootScope, $stateParams, previousState, entity, Logentregaarmaz, Safra, Etapa, Atividade) {
        var vm = this;

        vm.logentregaarmaz = entity;
        vm.previousState = previousState.name;


        vm.atividades = [];

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.logentregaarmaz.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        }

        var unsubscribe = $rootScope.$on('netWordAgroApp:logentregaarmazUpdate', function(event, result) {
            vm.logentregaarmaz = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LogentregaarmazDeleteController',LogentregaarmazDeleteController);

    LogentregaarmazDeleteController.$inject = ['$uibModalInstance', 'entity', 'Logentregaarmaz', 'Etapa'];

    function LogentregaarmazDeleteController($uibModalInstance, entity, Logentregaarmaz, Etapa) {
        var vm = this;

        vm.logentregaarmaz = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Logentregaarmaz.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    Etapa.delete({id: vm.logentregaarmaz.etapa.id},
                        function () {
                            $uibModalInstance.close(true);
                        });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('logentregaarmaz', {
            parent: 'entity',
            url: '/logentregaarmaz',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.logentregaarmaz.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/logentregaarmaz/logentregaarmazs.html',
                    controller: 'LogentregaarmazController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logentregaarmaz');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('logentregaarmaz-detail', {
            parent: 'logentregaarmaz',
            url: '/logentregaarmaz/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.logentregaarmaz.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/logentregaarmaz/logentregaarmaz-detail.html',
                    controller: 'LogentregaarmazDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logentregaarmaz');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Logentregaarmaz', function($stateParams, Logentregaarmaz) {
                    return Logentregaarmaz.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'logentregaarmaz',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('logentregaarmaz-detail.edit', {
            parent: 'logentregaarmaz-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/logentregaarmaz/logentregaarmaz-dialog.html',
                    controller: 'LogentregaarmazDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Logentregaarmaz', function(Logentregaarmaz) {
                            return Logentregaarmaz.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('logentregaarmaz.new', {
            parent: 'logentregaarmaz',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/logentregaarmaz/logentregaarmaz-dialog.html',
                    controller: 'LogentregaarmazDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                datainicio: null,
                                datatermino: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('logentregaarmaz', null, { reload: 'logentregaarmaz' });
                }, function() {
                    $state.go('logentregaarmaz');
                });
            }]
        })
        .state('logentregaarmaz.edit', {
            parent: 'logentregaarmaz',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/logentregaarmaz/logentregaarmaz-dialog.html',
                    controller: 'LogentregaarmazDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Logentregaarmaz', function(Logentregaarmaz) {
                            return Logentregaarmaz.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('logentregaarmaz', null, { reload: 'logentregaarmaz' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('logentregaarmaz.delete', {
            parent: 'logentregaarmaz',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/logentregaarmaz/logentregaarmaz-delete-dialog.html',
                    controller: 'LogentregaarmazDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Logentregaarmaz', function(Logentregaarmaz) {
                            return Logentregaarmaz.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('logentregaarmaz', null, { reload: 'logentregaarmaz' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Logentregaarmaz', Logentregaarmaz);

    Logentregaarmaz.$inject = ['$resource', 'DateUtils'];

    function Logentregaarmaz ($resource, DateUtils) {
        var resourceUrl =  'api/logentregaarmazs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datainicio = DateUtils.convertLocalDateFromServer(data.datainicio);
                        data.datatermino = DateUtils.convertLocalDateFromServer(data.datatermino);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('LogentregaarmazSearch', LogentregaarmazSearch);

    LogentregaarmazSearch.$inject = ['$resource'];

    function LogentregaarmazSearch($resource) {
        var resourceUrl =  'api/_search/logentregaarmazs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LogentregaarmazController', LogentregaarmazController);

    LogentregaarmazController.$inject = ['Logentregaarmaz', 'LogentregaarmazSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function LogentregaarmazController(Logentregaarmaz, LogentregaarmazSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.logentregaarmazs = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                LogentregaarmazSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Logentregaarmaz.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.logentregaarmazs.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.logentregaarmazs = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.logentregaarmazs = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.logentregaarmazs = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LocalarmazenamentoDialogController', LocalarmazenamentoDialogController);

    LocalarmazenamentoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Localarmazenamento', 'Atividade', 'Aquisicaoplan', 'Insumo'];

    function LocalarmazenamentoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Localarmazenamento, Atividade, Aquisicaoplan, Insumo) {
        var vm = this;

        vm.localarmazenamento = entity;
        vm.clear = clear;
        vm.save = save;
        vm.atividades = Atividade.query();
        vm.aquisicaoplans = Aquisicaoplan.query();
        vm.insumos = Insumo.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.localarmazenamento.id !== null) {
                Localarmazenamento.update(vm.localarmazenamento, onSaveSuccess, onSaveError);
            } else {
                Localarmazenamento.save(vm.localarmazenamento, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:localarmazenamentoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LocalarmazenamentoDetailController', LocalarmazenamentoDetailController);

    LocalarmazenamentoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Localarmazenamento', 'Atividade', 'Aquisicaoplan', 'Insumo'];

    function LocalarmazenamentoDetailController($scope, $rootScope, $stateParams, previousState, entity, Localarmazenamento, Atividade, Aquisicaoplan, Insumo) {
        var vm = this;

        vm.localarmazenamento = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:localarmazenamentoUpdate', function(event, result) {
            vm.localarmazenamento = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LocalarmazenamentoDeleteController',LocalarmazenamentoDeleteController);

    LocalarmazenamentoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Localarmazenamento'];

    function LocalarmazenamentoDeleteController($uibModalInstance, entity, Localarmazenamento) {
        var vm = this;

        vm.localarmazenamento = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Localarmazenamento.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('localarmazenamento', {
            parent: 'entity',
            url: '/localarmazenamento',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.localarmazenamento.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/localarmazenamento/localarmazenamentos.html',
                    controller: 'LocalarmazenamentoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('localarmazenamento');
                    $translatePartialLoader.addPart('tipolocalarmazenamento');
                    $translatePartialLoader.addPart('tipomedidacapacidade');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('localarmazenamento-detail', {
            parent: 'localarmazenamento',
            url: '/localarmazenamento/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.localarmazenamento.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/localarmazenamento/localarmazenamento-detail.html',
                    controller: 'LocalarmazenamentoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('localarmazenamento');
                    $translatePartialLoader.addPart('tipolocalarmazenamento');
                    $translatePartialLoader.addPart('tipomedidacapacidade');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Localarmazenamento', function($stateParams, Localarmazenamento) {
                    return Localarmazenamento.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'localarmazenamento',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('localarmazenamento-detail.edit', {
            parent: 'localarmazenamento-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/localarmazenamento/localarmazenamento-dialog.html',
                    controller: 'LocalarmazenamentoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Localarmazenamento', function(Localarmazenamento) {
                            return Localarmazenamento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('localarmazenamento.new', {
            parent: 'localarmazenamento',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/localarmazenamento/localarmazenamento-dialog.html',
                    controller: 'LocalarmazenamentoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nomelocal: null,
                                tipolocalarmaz: null,
                                capacidade: null,
                                medidacapacidade: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('localarmazenamento', null, { reload: 'localarmazenamento' });
                }, function() {
                    $state.go('localarmazenamento');
                });
            }]
        })
        .state('localarmazenamento.edit', {
            parent: 'localarmazenamento',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/localarmazenamento/localarmazenamento-dialog.html',
                    controller: 'LocalarmazenamentoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Localarmazenamento', function(Localarmazenamento) {
                            return Localarmazenamento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('localarmazenamento', null, { reload: 'localarmazenamento' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('localarmazenamento.delete', {
            parent: 'localarmazenamento',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/localarmazenamento/localarmazenamento-delete-dialog.html',
                    controller: 'LocalarmazenamentoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Localarmazenamento', function(Localarmazenamento) {
                            return Localarmazenamento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('localarmazenamento', null, { reload: 'localarmazenamento' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Localarmazenamento', Localarmazenamento);

    Localarmazenamento.$inject = ['$resource'];

    function Localarmazenamento ($resource) {
        var resourceUrl =  'api/localarmazenamentos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('LocalarmazenamentoSearch', LocalarmazenamentoSearch);

    LocalarmazenamentoSearch.$inject = ['$resource'];

    function LocalarmazenamentoSearch($resource) {
        var resourceUrl =  'api/_search/localarmazenamentos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LocalarmazenamentoController', LocalarmazenamentoController);

    LocalarmazenamentoController.$inject = ['Localarmazenamento', 'LocalarmazenamentoSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function LocalarmazenamentoController(Localarmazenamento, LocalarmazenamentoSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.localarmazenamentos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                LocalarmazenamentoSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Localarmazenamento.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.localarmazenamentos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.localarmazenamentos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.localarmazenamentos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.localarmazenamentos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('InsumoDialogController', InsumoDialogController);

    InsumoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Insumo', 'Localarmazenamento', 'Alocacaoinsumos', 'Aquisicao'];

    function InsumoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Insumo, Localarmazenamento, Alocacaoinsumos, Aquisicao) {
        var vm = this;

        vm.insumo = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.localarmazenamentos = Localarmazenamento.query();
        vm.alocacaoinsumos = Alocacaoinsumos.query();
        vm.aquisicaos = Aquisicao.query();
        vm.restante = vm.insumo.quantidadearmazenada;
        vm.mudaMax = mudaMax;

        vm.insumo.aquisicao = new Aquisicao();

        Aquisicao.get({id: vm.insumo.aquisicao.id}).$promise.then(function(data){
            vm.restante = data.quantidade;
            Insumo.query().$promise.then(function(data2){
                var i = 0;
                for(i=0; i<data2.length; i++){
                    if(data2[i].id !== vm.insumo.id){
                        if(data2[i].aquisicao.id === vm.insumo.aquisicao.id){
                            vm.restante = vm.restante - data2[i].quantidadearmazenada;
                        }
                    }
                }
            });
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.insumo.id !== null) {
                Insumo.update(vm.insumo, onSaveSuccess, onSaveError);
            } else {
                Insumo.save(vm.insumo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:insumoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dataentrada = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function mudaMax(){
            vm.maxarmazenado = vm.insumo.quantidadearmazenada;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('InsumoDetailController', InsumoDetailController);

    InsumoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Insumo', 'Localarmazenamento', 'Alocacaoinsumos', 'Aquisicao'];

    function InsumoDetailController($scope, $rootScope, $stateParams, previousState, entity, Insumo, Localarmazenamento, Alocacaoinsumos, Aquisicao) {
        var vm = this;

        vm.insumo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:insumoUpdate', function(event, result) {
            vm.insumo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('InsumoDeleteController',InsumoDeleteController);

    InsumoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Insumo'];

    function InsumoDeleteController($uibModalInstance, entity, Insumo) {
        var vm = this;

        vm.insumo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Insumo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('insumo', {
            parent: 'entity',
            url: '/insumo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.insumo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/insumo/insumos.html',
                    controller: 'InsumoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('insumo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('insumo-detail', {
            parent: 'insumo',
            url: '/insumo/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.insumo.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/insumo/insumo-detail.html',
                    controller: 'InsumoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('insumo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Insumo', function($stateParams, Insumo) {
                    return Insumo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'insumo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('insumo-detail.edit', {
            parent: 'insumo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insumo/insumo-dialog.html',
                    controller: 'InsumoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Insumo', function(Insumo) {
                            return Insumo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('insumo.new', {
            parent: 'insumo',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insumo/insumo-dialog.html',
                    controller: 'InsumoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                dataentrada: null,
                                quantidadearmazenada: null,
                                quantidadedisponivel: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('insumo', null, { reload: 'insumo' });
                }, function() {
                    $state.go('insumo');
                });
            }]
        })
        .state('insumo.edit', {
            parent: 'insumo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insumo/insumo-dialog.html',
                    controller: 'InsumoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Insumo', function(Insumo) {
                            return Insumo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('insumo', null, { reload: 'insumo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('insumo.delete', {
            parent: 'insumo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insumo/insumo-delete-dialog.html',
                    controller: 'InsumoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Insumo', function(Insumo) {
                            return Insumo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('insumo', null, { reload: 'insumo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Insumo', Insumo);

    Insumo.$inject = ['$resource', 'DateUtils'];

    function Insumo ($resource, DateUtils) {
        var resourceUrl =  'api/insumos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataentrada = DateUtils.convertLocalDateFromServer(data.dataentrada);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dataentrada = DateUtils.convertLocalDateToServer(copy.dataentrada);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dataentrada = DateUtils.convertLocalDateToServer(copy.dataentrada);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('InsumoSearch', InsumoSearch);

    InsumoSearch.$inject = ['$resource'];

    function InsumoSearch($resource) {
        var resourceUrl =  'api/_search/insumos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('InsumoController', InsumoController);

    InsumoController.$inject = ['Insumo', 'InsumoSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function InsumoController(Insumo, InsumoSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.insumos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                InsumoSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Insumo.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.insumos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.insumos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.insumos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.insumos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('IndicadoresnwDialogController', IndicadoresnwDialogController);

    IndicadoresnwDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Indicadoresnw', 'Safra'];

    function IndicadoresnwDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Indicadoresnw, Safra) {
        var vm = this;

        vm.indicadoresnw = entity;
        vm.clear = clear;
        vm.save = save;
        vm.safras = Safra.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.indicadoresnw.id !== null) {
                Indicadoresnw.update(vm.indicadoresnw, onSaveSuccess, onSaveError);
            } else {
                Indicadoresnw.save(vm.indicadoresnw, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:indicadoresnwUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('IndicadoresnwDetailController', IndicadoresnwDetailController);

    IndicadoresnwDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Indicadoresnw', 'Safra'];

    function IndicadoresnwDetailController($scope, $rootScope, $stateParams, previousState, entity, Indicadoresnw, Safra) {
        var vm = this;

        vm.indicadoresnw = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:indicadoresnwUpdate', function(event, result) {
            vm.indicadoresnw = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('IndicadoresnwDeleteController',IndicadoresnwDeleteController);

    IndicadoresnwDeleteController.$inject = ['$uibModalInstance', 'entity', 'Indicadoresnw'];

    function IndicadoresnwDeleteController($uibModalInstance, entity, Indicadoresnw) {
        var vm = this;

        vm.indicadoresnw = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Indicadoresnw.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('indicadoresnw', {
            parent: 'entity',
            url: '/indicadoresnw',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.indicadoresnw.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/indicadoresnw/indicadoresnws.html',
                    controller: 'IndicadoresnwController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('indicadoresnw');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('indicadoresnw-detail', {
            parent: 'indicadoresnw',
            url: '/indicadoresnw/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.indicadoresnw.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/indicadoresnw/indicadoresnw-detail.html',
                    controller: 'IndicadoresnwDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('indicadoresnw');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Indicadoresnw', function($stateParams, Indicadoresnw) {
                    return Indicadoresnw.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'indicadoresnw',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('indicadoresnw-detail.edit', {
            parent: 'indicadoresnw-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/indicadoresnw/indicadoresnw-dialog.html',
                    controller: 'IndicadoresnwDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Indicadoresnw', function(Indicadoresnw) {
                            return Indicadoresnw.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('indicadoresnw.new', {
            parent: 'indicadoresnw',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/indicadoresnw/indicadoresnw-dialog.html',
                    controller: 'IndicadoresnwDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                produtividadehectare: null,
                                rentabilidadehectare: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('indicadoresnw', null, { reload: 'indicadoresnw' });
                }, function() {
                    $state.go('indicadoresnw');
                });
            }]
        })
        .state('indicadoresnw.edit', {
            parent: 'indicadoresnw',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/indicadoresnw/indicadoresnw-dialog.html',
                    controller: 'IndicadoresnwDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Indicadoresnw', function(Indicadoresnw) {
                            return Indicadoresnw.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('indicadoresnw', null, { reload: 'indicadoresnw' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('indicadoresnw.delete', {
            parent: 'indicadoresnw',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/indicadoresnw/indicadoresnw-delete-dialog.html',
                    controller: 'IndicadoresnwDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Indicadoresnw', function(Indicadoresnw) {
                            return Indicadoresnw.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('indicadoresnw', null, { reload: 'indicadoresnw' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Indicadoresnw', Indicadoresnw);

    Indicadoresnw.$inject = ['$resource'];

    function Indicadoresnw ($resource) {
        var resourceUrl =  'api/indicadoresnws/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('IndicadoresnwSearch', IndicadoresnwSearch);

    IndicadoresnwSearch.$inject = ['$resource'];

    function IndicadoresnwSearch($resource) {
        var resourceUrl =  'api/_search/indicadoresnws/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('IndicadoresnwController', IndicadoresnwController);

    IndicadoresnwController.$inject = ['Indicadoresnw', 'IndicadoresnwSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function IndicadoresnwController(Indicadoresnw, IndicadoresnwSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.indicadoresnws = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                IndicadoresnwSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Indicadoresnw.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.indicadoresnws.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.indicadoresnws = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.indicadoresnws = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.indicadoresnws = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('IndicadoreshabituaisDialogController', IndicadoreshabituaisDialogController);

    IndicadoreshabituaisDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Indicadoreshabituais', 'Safra'];

    function IndicadoreshabituaisDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Indicadoreshabituais, Safra) {
        var vm = this;

        vm.indicadoreshabituais = entity;
        vm.clear = clear;
        vm.save = save;
        vm.safras = Safra.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.indicadoreshabituais.id !== null) {
                Indicadoreshabituais.update(vm.indicadoreshabituais, onSaveSuccess, onSaveError);
            } else {
                Indicadoreshabituais.save(vm.indicadoreshabituais, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:indicadoreshabituaisUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('IndicadoreshabituaisDetailController', IndicadoreshabituaisDetailController);

    IndicadoreshabituaisDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Indicadoreshabituais', 'Safra'];

    function IndicadoreshabituaisDetailController($scope, $rootScope, $stateParams, previousState, entity, Indicadoreshabituais, Safra) {
        var vm = this;

        vm.indicadoreshabituais = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:indicadoreshabituaisUpdate', function(event, result) {
            vm.indicadoreshabituais = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('IndicadoreshabituaisDeleteController',IndicadoreshabituaisDeleteController);

    IndicadoreshabituaisDeleteController.$inject = ['$uibModalInstance', 'entity', 'Indicadoreshabituais'];

    function IndicadoreshabituaisDeleteController($uibModalInstance, entity, Indicadoreshabituais) {
        var vm = this;

        vm.indicadoreshabituais = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Indicadoreshabituais.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('indicadoreshabituais', {
            parent: 'entity',
            url: '/indicadoreshabituais',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.indicadoreshabituais.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/indicadoreshabituais/indicadoreshabituais.html',
                    controller: 'IndicadoreshabituaisController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('indicadoreshabituais');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('indicadoreshabituais-detail', {
            parent: 'indicadoreshabituais',
            url: '/indicadoreshabituais/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.indicadoreshabituais.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/indicadoreshabituais/indicadoreshabituais-detail.html',
                    controller: 'IndicadoreshabituaisDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('indicadoreshabituais');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Indicadoreshabituais', function($stateParams, Indicadoreshabituais) {
                    return Indicadoreshabituais.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'indicadoreshabituais',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('indicadoreshabituais-detail.edit', {
            parent: 'indicadoreshabituais-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/indicadoreshabituais/indicadoreshabituais-dialog.html',
                    controller: 'IndicadoreshabituaisDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Indicadoreshabituais', function(Indicadoreshabituais) {
                            return Indicadoreshabituais.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('indicadoreshabituais.new', {
            parent: 'indicadoreshabituais',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/indicadoreshabituais/indicadoreshabituais-dialog.html',
                    controller: 'IndicadoreshabituaisDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                produtividadehectare: null,
                                rentabilidadehectare: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('indicadoreshabituais', null, { reload: 'indicadoreshabituais' });
                }, function() {
                    $state.go('indicadoreshabituais');
                });
            }]
        })
        .state('indicadoreshabituais.edit', {
            parent: 'indicadoreshabituais',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/indicadoreshabituais/indicadoreshabituais-dialog.html',
                    controller: 'IndicadoreshabituaisDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Indicadoreshabituais', function(Indicadoreshabituais) {
                            return Indicadoreshabituais.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('indicadoreshabituais', null, { reload: 'indicadoreshabituais' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('indicadoreshabituais.delete', {
            parent: 'indicadoreshabituais',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/indicadoreshabituais/indicadoreshabituais-delete-dialog.html',
                    controller: 'IndicadoreshabituaisDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Indicadoreshabituais', function(Indicadoreshabituais) {
                            return Indicadoreshabituais.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('indicadoreshabituais', null, { reload: 'indicadoreshabituais' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Indicadoreshabituais', Indicadoreshabituais);

    Indicadoreshabituais.$inject = ['$resource'];

    function Indicadoreshabituais ($resource) {
        var resourceUrl =  'api/indicadoreshabituais/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('IndicadoreshabituaisSearch', IndicadoreshabituaisSearch);

    IndicadoreshabituaisSearch.$inject = ['$resource'];

    function IndicadoreshabituaisSearch($resource) {
        var resourceUrl =  'api/_search/indicadoreshabituais/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('IndicadoreshabituaisController', IndicadoreshabituaisController);

    IndicadoreshabituaisController.$inject = ['Indicadoreshabituais', 'IndicadoreshabituaisSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function IndicadoreshabituaisController(Indicadoreshabituais, IndicadoreshabituaisSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.indicadoreshabituais = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                IndicadoreshabituaisSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Indicadoreshabituais.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.indicadoreshabituais.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.indicadoreshabituais = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.indicadoreshabituais = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.indicadoreshabituais = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ImagemtermicaDialogController', ImagemtermicaDialogController);

    ImagemtermicaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Imagemtermica', 'Safra', 'Propriedade', 'Mapaimagem', 'Propostareceituario'];

    function ImagemtermicaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Imagemtermica, Safra, Propriedade, Mapaimagem, Propostareceituario) {
        var vm = this;

        vm.imagemtermica = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.safras = Safra.query();
        vm.propriedades = Propriedade.query();
        vm.mapaimagems = Mapaimagem.query();
        vm.propostareceituarios = Propostareceituario.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.imagemtermica.id !== null) {
                Imagemtermica.update(vm.imagemtermica, onSaveSuccess, onSaveError);
            } else {
                Imagemtermica.save(vm.imagemtermica, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:imagemtermicaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.data = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ImagemtermicaDetailController', ImagemtermicaDetailController);

    ImagemtermicaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Imagemtermica', 'Safra', 'Propriedade', 'Mapaimagem', 'Propostareceituario'];

    function ImagemtermicaDetailController($scope, $rootScope, $stateParams, previousState, entity, Imagemtermica, Safra, Propriedade, Mapaimagem, Propostareceituario) {
        var vm = this;

        vm.imagemtermica = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:imagemtermicaUpdate', function(event, result) {
            vm.imagemtermica = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ImagemtermicaDeleteController',ImagemtermicaDeleteController);

    ImagemtermicaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Imagemtermica'];

    function ImagemtermicaDeleteController($uibModalInstance, entity, Imagemtermica) {
        var vm = this;

        vm.imagemtermica = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Imagemtermica.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('imagemtermica', {
            parent: 'entity',
            url: '/imagemtermica',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.imagemtermica.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/imagemtermica/imagemtermicas.html',
                    controller: 'ImagemtermicaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('imagemtermica');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('imagemtermica-detail', {
            parent: 'imagemtermica',
            url: '/imagemtermica/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.imagemtermica.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/imagemtermica/imagemtermica-detail.html',
                    controller: 'ImagemtermicaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('imagemtermica');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Imagemtermica', function($stateParams, Imagemtermica) {
                    return Imagemtermica.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'imagemtermica',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('imagemtermica-detail.edit', {
            parent: 'imagemtermica-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/imagemtermica/imagemtermica-dialog.html',
                    controller: 'ImagemtermicaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Imagemtermica', function(Imagemtermica) {
                            return Imagemtermica.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('imagemtermica.new', {
            parent: 'imagemtermica',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/imagemtermica/imagemtermica-dialog.html',
                    controller: 'ImagemtermicaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                data: null,
                                latitude: null,
                                longitude: null,
                                tipopraga: null,
                                valortermico: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('imagemtermica', null, { reload: 'imagemtermica' });
                }, function() {
                    $state.go('imagemtermica');
                });
            }]
        })
        .state('imagemtermica.edit', {
            parent: 'imagemtermica',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/imagemtermica/imagemtermica-dialog.html',
                    controller: 'ImagemtermicaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Imagemtermica', function(Imagemtermica) {
                            return Imagemtermica.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('imagemtermica', null, { reload: 'imagemtermica' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('imagemtermica.delete', {
            parent: 'imagemtermica',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/imagemtermica/imagemtermica-delete-dialog.html',
                    controller: 'ImagemtermicaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Imagemtermica', function(Imagemtermica) {
                            return Imagemtermica.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('imagemtermica', null, { reload: 'imagemtermica' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Imagemtermica', Imagemtermica);

    Imagemtermica.$inject = ['$resource', 'DateUtils'];

    function Imagemtermica ($resource, DateUtils) {
        var resourceUrl =  'api/imagemtermicas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.data = DateUtils.convertLocalDateFromServer(data.data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.data = DateUtils.convertLocalDateToServer(copy.data);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.data = DateUtils.convertLocalDateToServer(copy.data);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('ImagemtermicaSearch', ImagemtermicaSearch);

    ImagemtermicaSearch.$inject = ['$resource'];

    function ImagemtermicaSearch($resource) {
        var resourceUrl =  'api/_search/imagemtermicas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ImagemtermicaController', ImagemtermicaController);

    ImagemtermicaController.$inject = ['Imagemtermica', 'ImagemtermicaSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function ImagemtermicaController(Imagemtermica, ImagemtermicaSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.imagemtermicas = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                ImagemtermicaSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Imagemtermica.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.imagemtermicas.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.imagemtermicas = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.imagemtermicas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.imagemtermicas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('GestorDialogController', GestorDialogController);

GestorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Gestor', 'Unidadegestor', 'Pessoa', 'Propriedade', 'Unidade', 'User'];

    function GestorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Gestor, Unidadegestor, Pessoa, Propriedade, Unidade, User) {
        var vm = this;

        vm.gestor = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.unidadegestors = Unidadegestor.query();
        vm.unidades = Unidade.query({
            size:1000
        });
        
        vm.onSaveUser = onSaveUser;
        vm.onSavePessoa = onSavePessoa;
        vm.onSaveSuccess = onSaveSuccess;
        vm.onUpdateSuccess = onUpdateSuccess;

        vm.listaUnidadesAntigas = [];

        vm.onSucessoUnidadesAssociadas = onSucessoUnidadesAssociadas;
        vm.onSucessoUGs = onSucessoUGs;

        vm.gestor_id = null;

        if(vm.gestor.id != null){
        	var idGestor = parseInt(vm.gestor.id);
        	Unidade.queryUnidadesAssociadas({idgestor: idGestor, size:1000}, onSucessoUnidadesAssociadas);
        	Unidadegestor.queryUGsAssociadas({idgestor: idGestor, size:1000}, onSucessoUGs);
        }
        
        function onSucessoUnidadesAssociadas(result){
        	vm.gestor.unidade = result;
        	vm.listaUnidadesAntigas = result;
        }
        
        function onSucessoUGs(result){
        	vm.listaUGs = result;
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.gestor.id !== null) {
                Gestor.update(vm.gestor, onUpdateSuccess, onSaveError);
            } else {
                vm.gestor_id = null;
                Gestor.save(vm.gestor, onSaveSuccess, onSaveError);
            }
        }

        // Criação do usuário
        function onSaveSuccess (result) {
            vm.gestor_id = result.id;
            vm.novousuario = new User();
            vm.novousuario.login = vm.gestor.login;
            vm.novousuario.firstName = vm.gestor.nome;
            vm.novousuario.lastName = vm.gestor.sobrenome; 
            vm.novousuario.email = vm.gestor.email;
            vm.novousuario.authorities = [];
            vm.novousuario.authorities = ['ROLE_GESTOR_PARCEIROS', 'ROLE_USER'];
            User.save(vm.novousuario, onSaveUser, onSaveError);
        }

        // Criação da Pessoa
        function onSaveUser(result) {
            vm.novapessoa = new Pessoa();
            vm.novapessoa.nome = vm.gestor.nome;
            vm.novapessoa.sobrenome = vm.gestor.sobrenome;
            vm.novapessoa.cpf = vm.gestor.cpf;
            vm.novapessoa.cargo = "gestorparceiro";
            vm.novapessoa.email = vm.gestor.email;
            vm.novapessoa.login = vm.gestor.login;
            Pessoa.save(vm.novapessoa, onSavePessoa, onSaveError);
        }
        
        vm.PPsDelete = [];
        vm.PPsUpdate = [];
        vm.PPsCreate = [];
        vm.pessoa_id = null;

        // Criaçao de UnidadeGestor
        function onSavePessoa(result){
            vm.pessoa_id = result.id;

            if(vm.gestor.unidade.length > 0){
                var VetorUGs = [];

                for(var i=0; i<vm.gestor.unidade.length; i++){
                    var UG = new Unidadegestor();
                    UG.gestor = new Gestor();
                    UG.unidade = new Unidade();

                    UG.gestor.id = vm.gestor_id;
                    UG.unidade.id = vm.gestor.unidade[i].id;

                    VetorUGs.push(UG);
                }

                Unidadegestor.acao({acao: "create"}, VetorUGs, vm.onSaveUGs);
            }
            else{
                $scope.$emit('netWordAgroApp:pessoaUpdate', result);
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
        }

        vm.PPsCreate = [];

        vm.onSaveUGs = function onSaveUGs() { 
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }
        
        function onUpdateSuccess(result){
        	console.log(vm.listaUGs);
        	console.log(vm.listaUnidadesAntigas);
            vm.UGsDelete = [];
            
			var sumiu = null;
        	
        	for (var i = 0; i < vm.listaUnidadesAntigas.length; i++) {
        		
        		var idUnidadeAnterior = vm.listaUnidadesAntigas[i].id;
        		sumiu = true;
				
				for (var j = 0;  j < vm.gestor.unidade.length; j++) {
					var comparativo = vm.gestor.unidade[j].id;
					
					if(idUnidadeAnterior == comparativo){
						sumiu = false;
						break;
					}	
				}
			
				if(sumiu == true){
					for(var j = 0; j < vm.listaUGs.length; j++){
						var idUnidade = vm.listaUGs[j].unidade.id ;
						if(idUnidade == idUnidadeAnterior){
                            var temp = new Unidadegestor();
                            temp.id = vm.listaUGs[j].id;
							vm.UGsDelete.push(temp);
						}
					}
				}
        	}
        	
            var existia = null;
            vm.UGsUpdate = [];
            vm.UGsCreate = [];
        	
        	for (var i = 0; i < vm.gestor.unidade.length; i++) {
        		
        		var idComparativo = vm.gestor.unidade[i].id;
        		existia = false;
				
				for (var j = 0;  j < vm.listaUnidadesAntigas.length; j++) {
					var idUnidadeAntiga = vm.listaUnidadesAntigas[j].id;
					
					if(idComparativo == idUnidadeAntiga){
						existia = true;
						break;
					}	
				}
			
				if(existia == false){
					var novo = new Unidadegestor();
					novo.unidade = new Unidade();
					novo.gestor = new Gestor();
					novo.unidade.id = idComparativo;
					novo.gestor.id = vm.gestor.id;
					vm.UGsCreate.push(novo);
				}
            }
            
            Unidadegestor.acao({acao: "delete"}, vm.UGsDelete, function(){
                console.log("Delete");
                Unidadegestor.acao({acao: "create"}, vm.UGsCreate, function(){
                    console.log("Create");
                    //$scope.$emit('netWordAgroApp:pessoaUpdate', result);
                    //$uibModalInstance.close(result);
                    vm.isSaving = false;    
                });
            });
        	
        	
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function onSaveUGs(result) {

        }

        vm.setFoto = function ($file, gestor) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        gestor.foto = base64Data;
                        gestor.fotoContentType = $file.type;
                    });
                });
            }
        };

    }
})();

// FINALIZAÇÃO
//$scope.$emit('netWordAgroApp:pessoaUpdate', result);
//$uibModalInstance.close(result);

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('GestorDetailController', GestorDetailController);

    GestorDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Gestor', 'Unidadegestor'];

    function GestorDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Gestor, Unidadegestor) {
        var vm = this;

        vm.gestor = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('netWordAgroApp:gestorUpdate', function(event, result) {
            vm.gestor = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('GestorDeleteController',GestorDeleteController);

    GestorDeleteController.$inject = ['$uibModalInstance', 'entity', 'Gestor', 'Unidadegestor'];

    function GestorDeleteController($uibModalInstance, entity, Gestor, Unidadegestor) {
        var vm = this;

        vm.gestor = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        vm.id = null;
        vm.login = null;
        vm.onSuccessUnidades = onSuccessUnidades;
        vm.finalizar = finalizar;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {

            Unidade.queryUGsAssociadas({idGestor: id}, onSuccessUnidades);

            /*Gestor.delete({id: id},
                
                function () {
                    $uibModalInstance.close(true);
                });
                */
        }

        function onSuccessUnidades(result){
            Unidadegestor.acao({acao: "delete"}, result, finalizar);
        }

        function finalizar(){
            Gestor.delete({id: vm.id},
                // TO-DO
                function () {
                    User.delete({login: vm.login});
                    $uibModalInstance.close(true);
                }
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('gestor', {
            parent: 'entity',
            url: '/gestor',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.gestor.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/gestor/gestors.html',
                    controller: 'GestorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gestor');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('gestor-detail', {
            parent: 'gestor',
            url: '/gestor/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.gestor.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/gestor/gestor-detail.html',
                    controller: 'GestorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gestor');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Gestor', function($stateParams, Gestor) {
                    return Gestor.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'gestor',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('gestor-detail.edit', {
            parent: 'gestor-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gestor/gestor-dialog.html',
                    controller: 'GestorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Gestor', function(Gestor) {
                            return Gestor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('gestor.new', {
            parent: 'gestor',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gestor/gestor-dialog.html',
                    controller: 'GestorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                sobrenome: null,
                                email: null,
                                foto: null,
                                fotoContentType: null,
                                login: null,
                                cpf: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('gestor', null, { reload: 'gestor' });
                }, function() {
                    $state.go('gestor');
                });
            }]
        })
        .state('gestor.edit', {
            parent: 'gestor',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gestor/gestor-dialog.html',
                    controller: 'GestorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Gestor', function(Gestor) {
                            return Gestor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('gestor', null, { reload: 'gestor' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('gestor.delete', {
            parent: 'gestor',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gestor/gestor-delete-dialog.html',
                    controller: 'GestorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Gestor', function(Gestor) {
                            return Gestor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('gestor', null, { reload: 'gestor' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Gestor', Gestor);

    Gestor.$inject = ['$resource'];

    function Gestor ($resource) {
        var resourceUrl =  'api/gestors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('GestorSearch', GestorSearch);

    GestorSearch.$inject = ['$resource'];

    function GestorSearch($resource) {
        var resourceUrl =  'api/_search/gestors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('GestorController', GestorController);

    GestorController.$inject = ['DataUtils', 'Gestor', 'GestorSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function GestorController(DataUtils, Gestor, GestorSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.gestors = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                GestorSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Gestor.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.gestors.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.gestors = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.gestors = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.gestors = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('GeoreferenciamentoDialogController', GeoreferenciamentoDialogController);

    GeoreferenciamentoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Georeferenciamento', 'Propriedade'];

    function GeoreferenciamentoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Georeferenciamento, Propriedade) {
        var vm = this;

        vm.georeferenciamento = entity;
        vm.clear = clear;
        vm.save = save;
        vm.propriedades = Propriedade.query({
            size:1000,
            sort:"nomepropriedade,asc"
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.georeferenciamento.id !== null) {
                Georeferenciamento.update(vm.georeferenciamento, onSaveSuccess, onSaveError);
            } else {
                Georeferenciamento.save(vm.georeferenciamento, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:georeferenciamentoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('GeoreferenciamentoDetailController', GeoreferenciamentoDetailController);

    GeoreferenciamentoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Georeferenciamento', 'Propriedade'];

    function GeoreferenciamentoDetailController($scope, $rootScope, $stateParams, previousState, entity, Georeferenciamento, Propriedade) {
        var vm = this;

        vm.georeferenciamento = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:georeferenciamentoUpdate', function(event, result) {
            vm.georeferenciamento = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('GeoreferenciamentoDeleteController',GeoreferenciamentoDeleteController);

    GeoreferenciamentoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Georeferenciamento'];

    function GeoreferenciamentoDeleteController($uibModalInstance, entity, Georeferenciamento) {
        var vm = this;

        vm.georeferenciamento = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Georeferenciamento.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('georeferenciamento', {
            parent: 'entity',
            url: '/georeferenciamento?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.georeferenciamento.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/georeferenciamento/georeferenciamentos.html',
                    controller: 'GeoreferenciamentoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('georeferenciamento');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('georeferenciamento-detail', {
            parent: 'georeferenciamento',
            url: '/georeferenciamento/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.georeferenciamento.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/georeferenciamento/georeferenciamento-detail.html',
                    controller: 'GeoreferenciamentoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('georeferenciamento');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Georeferenciamento', function($stateParams, Georeferenciamento) {
                    return Georeferenciamento.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'georeferenciamento',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('georeferenciamento-detail.edit', {
            parent: 'georeferenciamento-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/georeferenciamento/georeferenciamento-dialog.html',
                    controller: 'GeoreferenciamentoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Georeferenciamento', function(Georeferenciamento) {
                            return Georeferenciamento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('georeferenciamento.new', {
            parent: 'georeferenciamento',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/georeferenciamento/georeferenciamento-dialog.html',
                    controller: 'GeoreferenciamentoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                desposicao: null,
                                vallatitude: null,
                                vallongitude: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('georeferenciamento', null, { reload: 'georeferenciamento' });
                }, function() {
                    $state.go('georeferenciamento');
                });
            }]
        })
        .state('georeferenciamento.edit', {
            parent: 'georeferenciamento',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/georeferenciamento/georeferenciamento-dialog.html',
                    controller: 'GeoreferenciamentoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Georeferenciamento', function(Georeferenciamento) {
                            return Georeferenciamento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('georeferenciamento', null, { reload: 'georeferenciamento' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('georeferenciamento.delete', {
            parent: 'georeferenciamento',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/georeferenciamento/georeferenciamento-delete-dialog.html',
                    controller: 'GeoreferenciamentoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Georeferenciamento', function(Georeferenciamento) {
                            return Georeferenciamento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('georeferenciamento', null, { reload: 'georeferenciamento' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Georeferenciamento', Georeferenciamento);

    Georeferenciamento.$inject = ['$resource'];

    function Georeferenciamento ($resource) {
        var resourceUrl =  'api/georeferenciamentos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('GeoreferenciamentoSearch', GeoreferenciamentoSearch);

    GeoreferenciamentoSearch.$inject = ['$resource'];

    function GeoreferenciamentoSearch($resource) {
        var resourceUrl =  'api/_search/georeferenciamentos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('GeoreferenciamentoController', GeoreferenciamentoController);

    GeoreferenciamentoController.$inject = ['$state', 'Georeferenciamento', 'GeoreferenciamentoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function GeoreferenciamentoController($state, Georeferenciamento, GeoreferenciamentoSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                GeoreferenciamentoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Georeferenciamento.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.georeferenciamentos = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('FazendaDialogController', FazendaDialogController);

    FazendaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Fazenda', 'Cidade'];

    function FazendaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Fazenda, Cidade) {
        var vm = this;

        vm.fazenda = entity;
        vm.clear = clear;
        vm.save = save;
        vm.cidades = Cidade.query({
            size: 1000,
            sort:"nomecidade,asc"
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.fazenda.id !== null) {
                Fazenda.update(vm.fazenda, onSaveSuccess, onSaveError);
            } else {
                Fazenda.save(vm.fazenda, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:fazendaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('FazendaDetailController', FazendaDetailController);

    FazendaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Fazenda', 'Cidade'];

    function FazendaDetailController($scope, $rootScope, $stateParams, previousState, entity, Fazenda, Cidade) {
        var vm = this;

        vm.fazenda = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:fazendaUpdate', function(event, result) {
            vm.fazenda = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('FazendaDeleteController',FazendaDeleteController);

    FazendaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Fazenda'];

    function FazendaDeleteController($uibModalInstance, entity, Fazenda) {
        var vm = this;

        vm.fazenda = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Fazenda.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('fazenda', {
            parent: 'entity',
            url: '/fazenda',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.fazenda.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/fazenda/fazendas.html',
                    controller: 'FazendaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fazenda');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('fazenda-detail', {
            parent: 'fazenda',
            url: '/fazenda/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.fazenda.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/fazenda/fazenda-detail.html',
                    controller: 'FazendaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fazenda');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Fazenda', function($stateParams, Fazenda) {
                    return Fazenda.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'fazenda',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('fazenda-detail.edit', {
            parent: 'fazenda-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fazenda/fazenda-dialog.html',
                    controller: 'FazendaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Fazenda', function(Fazenda) {
                            return Fazenda.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('fazenda.new', {
            parent: 'fazenda',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fazenda/fazenda-dialog.html',
                    controller: 'FazendaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('fazenda', null, { reload: 'fazenda' });
                }, function() {
                    $state.go('fazenda');
                });
            }]
        })
        .state('fazenda.edit', {
            parent: 'fazenda',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fazenda/fazenda-dialog.html',
                    controller: 'FazendaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Fazenda', function(Fazenda) {
                            return Fazenda.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('fazenda', null, { reload: 'fazenda' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('fazenda.delete', {
            parent: 'fazenda',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fazenda/fazenda-delete-dialog.html',
                    controller: 'FazendaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Fazenda', function(Fazenda) {
                            return Fazenda.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('fazenda', null, { reload: 'fazenda' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Fazenda', Fazenda);

    Fazenda.$inject = ['$resource'];

    function Fazenda ($resource) {
        var resourceUrl =  'api/fazendas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('FazendaSearch', FazendaSearch);

    FazendaSearch.$inject = ['$resource'];

    function FazendaSearch($resource) {
        var resourceUrl =  'api/_search/fazendas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('FazendaController', FazendaController);

    FazendaController.$inject = ['Fazenda', 'FazendaSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function FazendaController(Fazenda, FazendaSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.fazendas = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                FazendaSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Fazenda.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.fazendas.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.fazendas = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.fazendas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.fazendas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('EtapaDialogController', EtapaDialogController);

    EtapaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Etapa', 'Safra', 'Logrecinsumo', 'Logrecinsumoplan', 'Logentregaarmaz', 'Logentregaarmazplan', 'Entregasafracomerc', 'Entregasafracomercplan', 'Comercializacao', 'Comercializacaoplan', 'Manutencaosafraplan', 'Armazenamentosafra', 'Armazenamentosafraplan', 'Colheita', 'Colheitaplan', 'Plantio', 'Plantioplan', 'Preplantio', 'Preplantioplan', 'Atividade', 'Manutencaosafra'];

    function EtapaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Etapa, Safra, Logrecinsumo, Logrecinsumoplan, Logentregaarmaz, Logentregaarmazplan, Entregasafracomerc, Entregasafracomercplan, Comercializacao, Comercializacaoplan, Manutencaosafraplan, Armazenamentosafra, Armazenamentosafraplan, Colheita, Colheitaplan, Plantio, Plantioplan, Preplantio, Preplantioplan, Atividade, Manutencaosafra) {
        var vm = this;

        vm.etapa = entity;
        vm.clear = clear;
        vm.save = save;
        vm.safras = Safra.query();
        vm.logrecinsumos = Logrecinsumo.query();
        vm.logrecinsumoplans = Logrecinsumoplan.query();
        vm.logentregaarmazs = Logentregaarmaz.query();
        vm.logentregaarmazplans = Logentregaarmazplan.query();
        vm.entregasafracomercs = Entregasafracomerc.query();
        vm.entregasafracomercplans = Entregasafracomercplan.query();
        vm.comercializacaos = Comercializacao.query();
        vm.comercializacaoplans = Comercializacaoplan.query();
        vm.manutencaosafraplans = Manutencaosafraplan.query();
        vm.armazenamentosafras = Armazenamentosafra.query();
        vm.armazenamentosafraplans = Armazenamentosafraplan.query();
        vm.colheitas = Colheita.query();
        vm.colheitaplans = Colheitaplan.query();
        vm.plantios = Plantio.query();
        vm.plantioplans = Plantioplan.query();
        vm.preplantios = Preplantio.query();
        vm.preplantioplans = Preplantioplan.query();
        vm.atividades = Atividade.query();
        vm.manutencaosafras = Manutencaosafra.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.etapa.id !== null) {
                Etapa.update(vm.etapa, onSaveSuccess, onSaveError);
            } else {
                Etapa.save(vm.etapa, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:etapaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            return vm.etapa.id;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('EtapaDetailController', EtapaDetailController);

    EtapaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Etapa', 'Safra', 'Logrecinsumo', 'Logrecinsumoplan', 'Logentregaarmaz', 'Logentregaarmazplan', 'Entregasafracomerc', 'Entregasafracomercplan', 'Comercializacao', 'Comercializacaoplan', 'Manutencaosafraplan', 'Armazenamentosafra', 'Armazenamentosafraplan', 'Colheita', 'Colheitaplan', 'Plantio', 'Plantioplan', 'Preplantio', 'Preplantioplan', 'Atividade', 'Manutencaosafra'];

    function EtapaDetailController($scope, $rootScope, $stateParams, previousState, entity, Etapa, Safra, Logrecinsumo, Logrecinsumoplan, Logentregaarmaz, Logentregaarmazplan, Entregasafracomerc, Entregasafracomercplan, Comercializacao, Comercializacaoplan, Manutencaosafraplan, Armazenamentosafra, Armazenamentosafraplan, Colheita, Colheitaplan, Plantio, Plantioplan, Preplantio, Preplantioplan, Atividade, Manutencaosafra) {
        var vm = this;

        vm.etapa = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:etapaUpdate', function(event, result) {
            vm.etapa = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('EtapaDeleteController',EtapaDeleteController);

    EtapaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Etapa'];

    function EtapaDeleteController($uibModalInstance, entity, Etapa) {
        var vm = this;

        vm.etapa = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Etapa.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('etapa', {
            parent: 'entity',
            url: '/etapa',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.etapa.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/etapa/etapas.html',
                    controller: 'EtapaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('etapa');
                    $translatePartialLoader.addPart('tipoetapa');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('etapa-detail', {
            parent: 'etapa',
            url: '/etapa/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.etapa.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/etapa/etapa-detail.html',
                    controller: 'EtapaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('etapa');
                    $translatePartialLoader.addPart('tipoetapa');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Etapa', function($stateParams, Etapa) {
                    return Etapa.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'etapa',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('etapa-detail.edit', {
            parent: 'etapa-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/etapa/etapa-dialog.html',
                    controller: 'EtapaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Etapa', function(Etapa) {
                            return Etapa.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('etapa.new', {
            parent: 'etapa',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/etapa/etapa-dialog.html',
                    controller: 'EtapaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                tipoetapa: null,
                                nomeetapa: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('etapa', null, { reload: 'etapa' });
                }, function() {
                    $state.go('etapa');
                });
            }]
        })
        .state('etapa.edit', {
            parent: 'etapa',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/etapa/etapa-dialog.html',
                    controller: 'EtapaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Etapa', function(Etapa) {
                            return Etapa.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('etapa', null, { reload: 'etapa' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('etapa.delete', {
            parent: 'etapa',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/etapa/etapa-delete-dialog.html',
                    controller: 'EtapaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Etapa', function(Etapa) {
                            return Etapa.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('etapa', null, { reload: 'etapa' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Etapa', Etapa);

    Etapa.$inject = ['$resource'];

    function Etapa ($resource) {
        var resourceUrl =  'api/etapas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('EtapaSearch', EtapaSearch);

    EtapaSearch.$inject = ['$resource'];

    function EtapaSearch($resource) {
        var resourceUrl =  'api/_search/etapas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('EtapaController', EtapaController);

    EtapaController.$inject = ['Etapa', 'EtapaSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function EtapaController(Etapa, EtapaSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.etapas = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                EtapaSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Etapa.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.etapas.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.etapas = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.etapas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.etapas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('EstadoDialogController', EstadoDialogController);

    EstadoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Estado', 'Microregiao', 'Regiao'];

    function EstadoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Estado, Microregiao, Regiao) {
        var vm = this;

        vm.estado = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.microregiaos = Microregiao.query({
            size: 1000,
            sort: "nomemicroregiao,asc"
        });
        vm.regiaos = Regiao.query({
            size:1000,
            sort:"nomeregiao,asc"
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.estado.id !== null) {
                Estado.update(vm.estado, onSaveSuccess, onSaveError);
            } else {
                Estado.save(vm.estado, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:estadoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setImagemestado = function ($file, estado) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        estado.imagemestado = base64Data;
                        estado.imagemestadoContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('EstadoDetailController', EstadoDetailController);

    EstadoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Estado', 'Microregiao', 'Regiao'];

    function EstadoDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Estado, Microregiao, Regiao) {
        var vm = this;

        vm.estado = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('netWordAgroApp:estadoUpdate', function(event, result) {
            vm.estado = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('EstadoDeleteController',EstadoDeleteController);

    EstadoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Estado'];

    function EstadoDeleteController($uibModalInstance, entity, Estado) {
        var vm = this;

        vm.estado = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Estado.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('estado', {
            parent: 'entity',
            url: '/estado',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.estado.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/estado/estados.html',
                    controller: 'EstadoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('estado');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('estado-detail', {
            parent: 'estado',
            url: '/estado/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.estado.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/estado/estado-detail.html',
                    controller: 'EstadoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('estado');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Estado', function($stateParams, Estado) {
                    return Estado.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'estado',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('estado-detail.edit', {
            parent: 'estado-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/estado/estado-dialog.html',
                    controller: 'EstadoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Estado', function(Estado) {
                            return Estado.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('estado.new', {
            parent: 'estado',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/estado/estado-dialog.html',
                    controller: 'EstadoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nomeestado: null,
                                siglaestado: null,
                                imagemestado: null,
                                imagemestadoContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('estado', null, { reload: 'estado' });
                }, function() {
                    $state.go('estado');
                });
            }]
        })
        .state('estado.edit', {
            parent: 'estado',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/estado/estado-dialog.html',
                    controller: 'EstadoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Estado', function(Estado) {
                            return Estado.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('estado', null, { reload: 'estado' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('estado.delete', {
            parent: 'estado',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/estado/estado-delete-dialog.html',
                    controller: 'EstadoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Estado', function(Estado) {
                            return Estado.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('estado', null, { reload: 'estado' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Estado', Estado);

    Estado.$inject = ['$resource'];

    function Estado ($resource) {
        var resourceUrl =  'api/estados/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('EstadoSearch', EstadoSearch);

    EstadoSearch.$inject = ['$resource'];

    function EstadoSearch($resource) {
        var resourceUrl =  'api/_search/estados/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('EstadoController', EstadoController);

    EstadoController.$inject = ['DataUtils', 'Estado', 'EstadoSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function EstadoController(DataUtils, Estado, EstadoSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.estados = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                EstadoSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Estado.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.estados.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.estados = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.estados = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.estados = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('EntregasafracomerctestemDialogController', EntregasafracomerctestemDialogController);

    EntregasafracomerctestemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Entregasafracomerctestem', 'Etapa', 'Safra', '$q'];

    function EntregasafracomerctestemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Entregasafracomerctestem, Etapa, Safra, $q) {
        var vm = this;

        vm.entregasafracomerctestem = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.etapas = Etapa.query();

        vm.safras = Safra.query({filter: 'entregasafracomerctestem-is-null'});
        $q.all([vm.entregasafracomerctestem.$promise, vm.safras.$promise]).then(function() {
            if (!vm.entregasafracomerctestem.safra || !vm.entregasafracomerctestem.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.entregasafracomerctestem.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "entregasafracomerctestem";
            vm.etapa.safra = vm.entregasafracomerctestem.safra;
            
            if (vm.entregasafracomerctestem.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:entregasafracomerctestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.entregasafracomerctestem.etapa = new Etapa();
            vm.entregasafracomerctestem.etapa = result;
            Entregasafracomerctestem.save(vm.entregasafracomerctestem, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:entregasafracomerctestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.entregasafracomerctestem.etapa = new Etapa();
            vm.entregasafracomerctestem.etapa = result;
            Entregasafracomerctestem.update(vm.entregasafracomerctestem, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:entregasafracomerctestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.data = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('EntregasafracomerctestemDetailController', EntregasafracomerctestemDetailController);

    EntregasafracomerctestemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Entregasafracomerctestem', 'Etapa', 'Atividade'];

    function EntregasafracomerctestemDetailController($scope, $rootScope, $stateParams, previousState, entity, Entregasafracomerctestem, Etapa, Atividade) {
        var vm = this;

        vm.entregasafracomerctestem = entity;
        vm.previousState = previousState.name;

        vm.atividades = [];

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.entregasafracomerctestem.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        }


        var unsubscribe = $rootScope.$on('netWordAgroApp:entregasafracomerctestemUpdate', function(event, result) {
            vm.entregasafracomerctestem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('EntregasafracomerctestemDeleteController',EntregasafracomerctestemDeleteController);

    EntregasafracomerctestemDeleteController.$inject = ['$uibModalInstance', 'entity', 'Entregasafracomerctestem', 'Etapa'];

    function EntregasafracomerctestemDeleteController($uibModalInstance, entity, Entregasafracomerctestem, Etapa) {
        var vm = this;

        vm.entregasafracomerctestem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Entregasafracomerctestem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    Etapa.delete({id: vm.entregasafracomerctestem.etapa.id},
                        function () {
                            $uibModalInstance.close(true);
                        });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('entregasafracomerctestem', {
            parent: 'entity',
            url: '/entregasafracomerctestem',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.entregasafracomerctestem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/entregasafracomerctestem/entregasafracomerctestems.html',
                    controller: 'EntregasafracomerctestemController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('entregasafracomerctestem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('entregasafracomerctestem-detail', {
            parent: 'entregasafracomerctestem',
            url: '/entregasafracomerctestem/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.entregasafracomerctestem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/entregasafracomerctestem/entregasafracomerctestem-detail.html',
                    controller: 'EntregasafracomerctestemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('entregasafracomerctestem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Entregasafracomerctestem', function($stateParams, Entregasafracomerctestem) {
                    return Entregasafracomerctestem.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'entregasafracomerctestem',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('entregasafracomerctestem-detail.edit', {
            parent: 'entregasafracomerctestem-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/entregasafracomerctestem/entregasafracomerctestem-dialog.html',
                    controller: 'EntregasafracomerctestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Entregasafracomerctestem', function(Entregasafracomerctestem) {
                            return Entregasafracomerctestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('entregasafracomerctestem.new', {
            parent: 'entregasafracomerctestem',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/entregasafracomerctestem/entregasafracomerctestem-dialog.html',
                    controller: 'EntregasafracomerctestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                data: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('entregasafracomerctestem', null, { reload: 'entregasafracomerctestem' });
                }, function() {
                    $state.go('entregasafracomerctestem');
                });
            }]
        })
        .state('entregasafracomerctestem.edit', {
            parent: 'entregasafracomerctestem',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/entregasafracomerctestem/entregasafracomerctestem-dialog.html',
                    controller: 'EntregasafracomerctestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Entregasafracomerctestem', function(Entregasafracomerctestem) {
                            return Entregasafracomerctestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('entregasafracomerctestem', null, { reload: 'entregasafracomerctestem' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('entregasafracomerctestem.delete', {
            parent: 'entregasafracomerctestem',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/entregasafracomerctestem/entregasafracomerctestem-delete-dialog.html',
                    controller: 'EntregasafracomerctestemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Entregasafracomerctestem', function(Entregasafracomerctestem) {
                            return Entregasafracomerctestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('entregasafracomerctestem', null, { reload: 'entregasafracomerctestem' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Entregasafracomerctestem', Entregasafracomerctestem);

    Entregasafracomerctestem.$inject = ['$resource', 'DateUtils'];

    function Entregasafracomerctestem ($resource, DateUtils) {
        var resourceUrl =  'api/entregasafracomerctestems/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.data = DateUtils.convertLocalDateFromServer(data.data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.data = DateUtils.convertLocalDateToServer(copy.data);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.data = DateUtils.convertLocalDateToServer(copy.data);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('EntregasafracomerctestemSearch', EntregasafracomerctestemSearch);

    EntregasafracomerctestemSearch.$inject = ['$resource'];

    function EntregasafracomerctestemSearch($resource) {
        var resourceUrl =  'api/_search/entregasafracomerctestems/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('EntregasafracomerctestemController', EntregasafracomerctestemController);

    EntregasafracomerctestemController.$inject = ['Entregasafracomerctestem', 'EntregasafracomerctestemSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function EntregasafracomerctestemController(Entregasafracomerctestem, EntregasafracomerctestemSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.entregasafracomerctestems = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                EntregasafracomerctestemSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Entregasafracomerctestem.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.entregasafracomerctestems.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.entregasafracomerctestems = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.entregasafracomerctestems = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.entregasafracomerctestems = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('EntregasafracomercplanDialogController', EntregasafracomercplanDialogController);

    EntregasafracomercplanDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Entregasafracomercplan', 'Safra', 'Etapa', 'Principal'];

    function EntregasafracomercplanDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Entregasafracomercplan, Safra, Etapa, Principal) {
        var vm = this;

        vm.entregasafracomercplan = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.safras = Safra.query({filter: 'entregasafracomercplan-is-null'});
        $q.all([vm.entregasafracomercplan.$promise, vm.safras.$promise]).then(function() {
            if (!vm.entregasafracomercplan.safra || !vm.entregasafracomercplan.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.entregasafracomercplan.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });
        vm.etapas = Etapa.query();

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "entregasafracomercplan";
            vm.etapa.safra = vm.entregasafracomercplan.safra;
            
            if (vm.entregasafracomercplan.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
                Principal.identity().then(function (user) {
                    var data = {
                      user: user
                    };
                    vm.entregasafracomercplan.criador = user.login;
                });
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.entregasafracomercplan.etapa = new Etapa();
            vm.entregasafracomercplan.etapa = result;
            Entregasafracomercplan.save(vm.entregasafracomercplan, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.entregasafracomercplan.etapa = new Etapa();
            vm.entregasafracomercplan.etapa = result;
            Entregasafracomercplan.update(vm.entregasafracomercplan, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:entregasafracomercplanUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datainicio = false;
        vm.datePickerOpenStatus.datatermino = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('EntregasafracomercplanDetailController', EntregasafracomercplanDetailController);

    EntregasafracomercplanDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Entregasafracomercplan', 'Safra', 'Etapa', 'Atividade'];

    function EntregasafracomercplanDetailController($scope, $rootScope, $stateParams, previousState, entity, Entregasafracomercplan, Safra, Etapa, Atividade) {
        var vm = this;

        vm.entregasafracomercplan = entity;
        vm.previousState = previousState.name;

        vm.atividades = [];

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.entregasafracomercplan.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        }

        var unsubscribe = $rootScope.$on('netWordAgroApp:entregasafracomercplanUpdate', function(event, result) {
            vm.entregasafracomercplan = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('EntregasafracomercplanDeleteController',EntregasafracomercplanDeleteController);

    EntregasafracomercplanDeleteController.$inject = ['$uibModalInstance', 'entity', 'Entregasafracomercplan', 'Etapa'];

    function EntregasafracomercplanDeleteController($uibModalInstance, entity, Entregasafracomercplan, Etapa) {
        var vm = this;

        vm.entregasafracomercplan = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Entregasafracomercplan.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    Etapa.delete({id: vm.entregasafracomercplan.etapa.id},
                        function () {
                            $uibModalInstance.close(true);
                        });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('entregasafracomercplan', {
            parent: 'entity',
            url: '/entregasafracomercplan',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.entregasafracomercplan.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/entregasafracomercplan/entregasafracomercplans.html',
                    controller: 'EntregasafracomercplanController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('entregasafracomercplan');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('entregasafracomercplan-detail', {
            parent: 'entregasafracomercplan',
            url: '/entregasafracomercplan/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.entregasafracomercplan.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/entregasafracomercplan/entregasafracomercplan-detail.html',
                    controller: 'EntregasafracomercplanDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('entregasafracomercplan');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Entregasafracomercplan', function($stateParams, Entregasafracomercplan) {
                    return Entregasafracomercplan.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'entregasafracomercplan',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('entregasafracomercplan-detail.edit', {
            parent: 'entregasafracomercplan-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/entregasafracomercplan/entregasafracomercplan-dialog.html',
                    controller: 'EntregasafracomercplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Entregasafracomercplan', function(Entregasafracomercplan) {
                            return Entregasafracomercplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('entregasafracomercplan.new', {
            parent: 'entregasafracomercplan',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/entregasafracomercplan/entregasafracomercplan-dialog.html',
                    controller: 'EntregasafracomercplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                datainicio: null,
                                datatermino: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('entregasafracomercplan', null, { reload: 'entregasafracomercplan' });
                }, function() {
                    $state.go('entregasafracomercplan');
                });
            }]
        })
        .state('entregasafracomercplan.edit', {
            parent: 'entregasafracomercplan',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/entregasafracomercplan/entregasafracomercplan-dialog.html',
                    controller: 'EntregasafracomercplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Entregasafracomercplan', function(Entregasafracomercplan) {
                            return Entregasafracomercplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('entregasafracomercplan', null, { reload: 'entregasafracomercplan' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('entregasafracomercplan.delete', {
            parent: 'entregasafracomercplan',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/entregasafracomercplan/entregasafracomercplan-delete-dialog.html',
                    controller: 'EntregasafracomercplanDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Entregasafracomercplan', function(Entregasafracomercplan) {
                            return Entregasafracomercplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('entregasafracomercplan', null, { reload: 'entregasafracomercplan' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Entregasafracomercplan', Entregasafracomercplan);

    Entregasafracomercplan.$inject = ['$resource', 'DateUtils'];

    function Entregasafracomercplan ($resource, DateUtils) {
        var resourceUrl =  'api/entregasafracomercplans/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datainicio = DateUtils.convertLocalDateFromServer(data.datainicio);
                        data.datatermino = DateUtils.convertLocalDateFromServer(data.datatermino);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('EntregasafracomercplanSearch', EntregasafracomercplanSearch);

    EntregasafracomercplanSearch.$inject = ['$resource'];

    function EntregasafracomercplanSearch($resource) {
        var resourceUrl =  'api/_search/entregasafracomercplans/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('EntregasafracomercplanController', EntregasafracomercplanController);

    EntregasafracomercplanController.$inject = ['Entregasafracomercplan', 'EntregasafracomercplanSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function EntregasafracomercplanController(Entregasafracomercplan, EntregasafracomercplanSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.entregasafracomercplans = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                EntregasafracomercplanSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Entregasafracomercplan.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.entregasafracomercplans.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.entregasafracomercplans = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.entregasafracomercplans = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.entregasafracomercplans = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('EntregasafracomercDialogController', EntregasafracomercDialogController);

    EntregasafracomercDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Entregasafracomerc', 'Safra', 'Etapa', 'Principal'];

    function EntregasafracomercDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Entregasafracomerc, Safra, Etapa, Principal) {
        var vm = this;

        vm.entregasafracomerc = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.safras = Safra.query({filter: 'entregasafracomerc-is-null'});
        $q.all([vm.entregasafracomerc.$promise, vm.safras.$promise]).then(function() {
            if (!vm.entregasafracomerc.safra || !vm.entregasafracomerc.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.entregasafracomerc.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });
        vm.etapas = Etapa.query();

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "entregasafracomerc";
            vm.etapa.safra = vm.entregasafracomerc.safra;
            
            if (vm.entregasafracomerc.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
                Principal.identity().then(function (user) {
                    var data = {
                      user: user
                    };
                    vm.entregasafracomerc.criador = user.login;
                });
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.entregasafracomerc.etapa = new Etapa();
            vm.entregasafracomerc.etapa = result;
            Entregasafracomerc.save(vm.entregasafracomerc, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.entregasafracomerc.etapa = new Etapa();
            vm.entregasafracomerc.etapa = result;
            Entregasafracomerc.update(vm.entregasafracomerc, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:entregasafracomercUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datainicio = false;
        vm.datePickerOpenStatus.datafim = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('EntregasafracomercDetailController', EntregasafracomercDetailController);

    EntregasafracomercDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Entregasafracomerc', 'Safra', 'Etapa', 'Atividade'];

    function EntregasafracomercDetailController($scope, $rootScope, $stateParams, previousState, entity, Entregasafracomerc, Safra, Etapa, Atividade) {
        var vm = this;

        vm.entregasafracomerc = entity;
        vm.previousState = previousState.name;

        vm.atividades = [];

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.entregasafracomerc.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        }

        var unsubscribe = $rootScope.$on('netWordAgroApp:entregasafracomercUpdate', function(event, result) {
            vm.entregasafracomerc = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('EntregasafracomercDeleteController',EntregasafracomercDeleteController);

    EntregasafracomercDeleteController.$inject = ['$uibModalInstance', 'entity', 'Entregasafracomerc', 'Etapa'];

    function EntregasafracomercDeleteController($uibModalInstance, entity, Entregasafracomerc, Etapa) {
        var vm = this;

        vm.entregasafracomerc = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Entregasafracomerc.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    Etapa.delete({id: vm.entregasafracomerc.etapa.id},
                        function () {
                            $uibModalInstance.close(true);
                        });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('entregasafracomerc', {
            parent: 'entity',
            url: '/entregasafracomerc',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.entregasafracomerc.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/entregasafracomerc/entregasafracomercs.html',
                    controller: 'EntregasafracomercController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('entregasafracomerc');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('entregasafracomerc-detail', {
            parent: 'entregasafracomerc',
            url: '/entregasafracomerc/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.entregasafracomerc.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/entregasafracomerc/entregasafracomerc-detail.html',
                    controller: 'EntregasafracomercDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('entregasafracomerc');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Entregasafracomerc', function($stateParams, Entregasafracomerc) {
                    return Entregasafracomerc.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'entregasafracomerc',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('entregasafracomerc-detail.edit', {
            parent: 'entregasafracomerc-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/entregasafracomerc/entregasafracomerc-dialog.html',
                    controller: 'EntregasafracomercDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Entregasafracomerc', function(Entregasafracomerc) {
                            return Entregasafracomerc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('entregasafracomerc.new', {
            parent: 'entregasafracomerc',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/entregasafracomerc/entregasafracomerc-dialog.html',
                    controller: 'EntregasafracomercDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                datainicio: null,
                                datafim: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('entregasafracomerc', null, { reload: 'entregasafracomerc' });
                }, function() {
                    $state.go('entregasafracomerc');
                });
            }]
        })
        .state('entregasafracomerc.edit', {
            parent: 'entregasafracomerc',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/entregasafracomerc/entregasafracomerc-dialog.html',
                    controller: 'EntregasafracomercDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Entregasafracomerc', function(Entregasafracomerc) {
                            return Entregasafracomerc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('entregasafracomerc', null, { reload: 'entregasafracomerc' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('entregasafracomerc.delete', {
            parent: 'entregasafracomerc',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/entregasafracomerc/entregasafracomerc-delete-dialog.html',
                    controller: 'EntregasafracomercDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Entregasafracomerc', function(Entregasafracomerc) {
                            return Entregasafracomerc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('entregasafracomerc', null, { reload: 'entregasafracomerc' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Entregasafracomerc', Entregasafracomerc);

    Entregasafracomerc.$inject = ['$resource', 'DateUtils'];

    function Entregasafracomerc ($resource, DateUtils) {
        var resourceUrl =  'api/entregasafracomercs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datainicio = DateUtils.convertLocalDateFromServer(data.datainicio);
                        data.datafim = DateUtils.convertLocalDateFromServer(data.datafim);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datafim = DateUtils.convertLocalDateToServer(copy.datafim);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datafim = DateUtils.convertLocalDateToServer(copy.datafim);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('EntregasafracomercSearch', EntregasafracomercSearch);

    EntregasafracomercSearch.$inject = ['$resource'];

    function EntregasafracomercSearch($resource) {
        var resourceUrl =  'api/_search/entregasafracomercs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('EntregasafracomercController', EntregasafracomercController);

    EntregasafracomercController.$inject = ['Entregasafracomerc', 'EntregasafracomercSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function EntregasafracomercController(Entregasafracomerc, EntregasafracomercSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.entregasafracomercs = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                EntregasafracomercSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Entregasafracomerc.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.entregasafracomercs.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.entregasafracomercs = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.entregasafracomercs = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.entregasafracomercs = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('EmpresaparceiraDialogController', EmpresaparceiraDialogController);

    EmpresaparceiraDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Empresaparceira', 'Propaganda'];

    function EmpresaparceiraDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Empresaparceira, Propaganda) {
        var vm = this;

        vm.empresaparceira = entity;
        vm.clear = clear;
        vm.save = save;
        vm.propagandas = Propaganda.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.empresaparceira.id !== null) {
                Empresaparceira.update(vm.empresaparceira, onSaveSuccess, onSaveError);
            } else {
                Empresaparceira.save(vm.empresaparceira, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:empresaparceiraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('EmpresaparceiraDetailController', EmpresaparceiraDetailController);

    EmpresaparceiraDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Empresaparceira', 'Propaganda'];

    function EmpresaparceiraDetailController($scope, $rootScope, $stateParams, previousState, entity, Empresaparceira, Propaganda) {
        var vm = this;

        vm.empresaparceira = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:empresaparceiraUpdate', function(event, result) {
            vm.empresaparceira = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('EmpresaparceiraDeleteController',EmpresaparceiraDeleteController);

    EmpresaparceiraDeleteController.$inject = ['$uibModalInstance', 'entity', 'Empresaparceira'];

    function EmpresaparceiraDeleteController($uibModalInstance, entity, Empresaparceira) {
        var vm = this;

        vm.empresaparceira = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Empresaparceira.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('empresaparceira', {
            parent: 'entity',
            url: '/empresaparceira',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.empresaparceira.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/empresaparceira/empresaparceiras.html',
                    controller: 'EmpresaparceiraController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('empresaparceira');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('empresaparceira-detail', {
            parent: 'empresaparceira',
            url: '/empresaparceira/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.empresaparceira.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/empresaparceira/empresaparceira-detail.html',
                    controller: 'EmpresaparceiraDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('empresaparceira');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Empresaparceira', function($stateParams, Empresaparceira) {
                    return Empresaparceira.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'empresaparceira',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('empresaparceira-detail.edit', {
            parent: 'empresaparceira-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/empresaparceira/empresaparceira-dialog.html',
                    controller: 'EmpresaparceiraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Empresaparceira', function(Empresaparceira) {
                            return Empresaparceira.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('empresaparceira.new', {
            parent: 'empresaparceira',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/empresaparceira/empresaparceira-dialog.html',
                    controller: 'EmpresaparceiraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                tiporegistro: null,
                                cnpjregistro: null,
                                email: null,
                                telefone: null,
                                enderecofisico: null,
                                siteempresa: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('empresaparceira', null, { reload: 'empresaparceira' });
                }, function() {
                    $state.go('empresaparceira');
                });
            }]
        })
        .state('empresaparceira.edit', {
            parent: 'empresaparceira',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/empresaparceira/empresaparceira-dialog.html',
                    controller: 'EmpresaparceiraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Empresaparceira', function(Empresaparceira) {
                            return Empresaparceira.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('empresaparceira', null, { reload: 'empresaparceira' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('empresaparceira.delete', {
            parent: 'empresaparceira',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/empresaparceira/empresaparceira-delete-dialog.html',
                    controller: 'EmpresaparceiraDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Empresaparceira', function(Empresaparceira) {
                            return Empresaparceira.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('empresaparceira', null, { reload: 'empresaparceira' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Empresaparceira', Empresaparceira);

    Empresaparceira.$inject = ['$resource'];

    function Empresaparceira ($resource) {
        var resourceUrl =  'api/empresaparceiras/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('EmpresaparceiraSearch', EmpresaparceiraSearch);

    EmpresaparceiraSearch.$inject = ['$resource'];

    function EmpresaparceiraSearch($resource) {
        var resourceUrl =  'api/_search/empresaparceiras/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('EmpresaparceiraController', EmpresaparceiraController);

    EmpresaparceiraController.$inject = ['Empresaparceira', 'EmpresaparceiraSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function EmpresaparceiraController(Empresaparceira, EmpresaparceiraSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.empresaparceiras = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                EmpresaparceiraSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Empresaparceira.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.empresaparceiras.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.empresaparceiras = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.empresaparceiras = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.empresaparceiras = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('DiariodebordoDialogController', DiariodebordoDialogController);

    DiariodebordoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Diariodebordo', 'Propriedade', 'Safra'];

    function DiariodebordoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Diariodebordo, Propriedade, Safra) {
        var vm = this;

        vm.diariodebordo = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.propriedades = Propriedade.queryNomesPropriedades({
            size: 1000,
            sort: "nomepropriedade,asc"
        });

        vm.safras = Safra.querySafraIdNome({
            size: 1000,
            sort: "nomesafra,asc"
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.diariodebordo.id !== null) {
                Diariodebordo.update(vm.diariodebordo, onSaveSuccess, onSaveError);
            } else {
                Diariodebordo.save(vm.diariodebordo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:diariodebordoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setArquivodiario = function ($file, diariodebordo) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        diariodebordo.arquivodiario = base64Data;
                        diariodebordo.arquivodiarioContentType = $file.type;
                    });
                });
            }
        };

        vm.setArquivoobservacoes = function ($file, diariodebordo) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        diariodebordo.arquivoobservacoes = base64Data;
                        diariodebordo.arquivoobservacoesContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('DiariodebordoDetailController', DiariodebordoDetailController);

    DiariodebordoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Diariodebordo', 'Propriedade', 'Safra'];

    function DiariodebordoDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Diariodebordo, Propriedade, Safra) {
        var vm = this;

        vm.diariodebordo = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('netWordAgroApp:diariodebordoUpdate', function(event, result) {
            vm.diariodebordo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('DiariodebordoDeleteController',DiariodebordoDeleteController);

    DiariodebordoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Diariodebordo'];

    function DiariodebordoDeleteController($uibModalInstance, entity, Diariodebordo) {
        var vm = this;

        vm.diariodebordo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Diariodebordo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('diariodebordo', {
            parent: 'entity',
            url: '/diariodebordo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.diariodebordo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/diariodebordo/diariodebordos.html',
                    controller: 'DiariodebordoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('diariodebordo');
                    $translatePartialLoader.addPart('mapaimagem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('diariodebordo-detail', {
            parent: 'diariodebordo',
            url: '/diariodebordo/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.diariodebordo.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/diariodebordo/diariodebordo-detail.html',
                    controller: 'DiariodebordoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('diariodebordo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Diariodebordo', function($stateParams, Diariodebordo) {
                    return Diariodebordo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'diariodebordo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('diariodebordo-detail.edit', {
            parent: 'diariodebordo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/diariodebordo/diariodebordo-dialog.html',
                    controller: 'DiariodebordoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Diariodebordo', function(Diariodebordo) {
                            return Diariodebordo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('diariodebordo.new', {
            parent: 'diariodebordo',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/diariodebordo/diariodebordo-dialog.html',
                    controller: 'DiariodebordoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dataavaliacao: null,
                                arquivodiario: null,
                                arquivodiarioContentType: null,
                                arquivoobservacoes: null,
                                arquivoobservacoesContentType: null,
                                tipoincidencia: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('diariodebordo', null, { reload: 'diariodebordo' });
                }, function() {
                    $state.go('diariodebordo');
                });
            }]
        })
        .state('diariodebordo.edit', {
            parent: 'diariodebordo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/diariodebordo/diariodebordo-dialog.html',
                    controller: 'DiariodebordoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Diariodebordo', function(Diariodebordo) {
                            return Diariodebordo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('diariodebordo', null, { reload: 'diariodebordo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('diariodebordo.delete', {
            parent: 'diariodebordo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/diariodebordo/diariodebordo-delete-dialog.html',
                    controller: 'DiariodebordoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Diariodebordo', function(Diariodebordo) {
                            return Diariodebordo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('diariodebordo', null, { reload: 'diariodebordo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Diariodebordo', Diariodebordo);

    Diariodebordo.$inject = ['$resource'];

    function Diariodebordo ($resource) {
        var resourceUrl =  'api/diariodebordos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'queryDiario': {  
                url: '/api/diarioarquivo/:diarioid',
                method: 'GET', 
                isArray: true},
            'queryObservacoes': { 
                url: '/api/diarioobservacoes/:diarioid',
                method: 'GET', 
                isArray: true},
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('DiariodebordoSearch', DiariodebordoSearch);

    DiariodebordoSearch.$inject = ['$resource'];

    function DiariodebordoSearch($resource) {
        var resourceUrl =  'api/_search/diariodebordos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('DiariodebordoController', DiariodebordoController);

    DiariodebordoController.$inject = ['DataUtils', 'Diariodebordo', 'DiariodebordoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'Propriedade'];

    function DiariodebordoController(DataUtils, Diariodebordo, DiariodebordoSearch, ParseLinks, AlertService, paginationConstants, Propriedade) {

        var vm = this;

        vm.diariodebordos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = false;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        vm.filtropropriedade = null;

        vm.downloadDiario = downloadDiario;
        vm.sucessoDownloadDiario = sucessoDownloadDiario;
        
        vm.downloadObservacoes = downloadObservacoes;
        vm.sucessoDownloadObservacoes = sucessoDownloadObservacoes;

        vm.filtropropriedades = Propriedade.queryNomesPropriedades({
            size: 1000,
            sort: "nomepropriedade,asc"
        });

        vm.organizar = organizar;


        vm.changeFiltro = function (){
            console.log("Propriedade alterada!");
            console.log(vm.filtropropriedade);
            vm.page = 0;
            vm.diariodebordos = [];
            loadAll();
        };

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                DiariodebordoSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 2000,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Diariodebordo.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for(var i = 0; i < data.length; i++) {
                    if(vm.filtropropriedade === null || parseInt(vm.filtropropriedade.id) === data[i].propriedade_id){
                        console.log("Added");
                        vm.diariodebordos.push(data[i]);
                    }
                }

                if(vm.diariodebordos.length == 0 && vm.page < vm.links['last']){
                    console.log("Vazio");
                    vm.page = vm.page + 1;
                    loadPage(vm.page);
                }

                //vm.organizar();
            }

           

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function organizar() {
            vm.diariodebordos.sort(
                function (a,b){
                    var dataA = a.dataavaliacao;
                    var dataB = b.dataavaliacao;

                    dataA = dataA.split('/'); dataB = dataB.split('/');

                    var diaA = parseInt(dataA[0]); var diaB = parseInt(dataB[0]);
                    var mesA = parseInt(dataA[1]); var mesB = parseInt(dataB[1]);
                    var anoA = parseInt(dataA[2]); var anoB = parseInt(dataB[2]);

                    //console.log(dataA);
                    //console.log(dataB);
                    if(anoA < anoB){
                        return 1;
                    }
                    else if(anoA > anoB){
                        return -1;
                    } else {
                        if(mesA < mesB){
                            return 1;
                        }
                        else if(mesA > mesB){
                            return -1
                        }
                        else{
                            if(diaA < diaB){
                                return 1;
                            }
                            else if(diaA > diaB){
                                return -1;
                            }
                            else{
                                return 0;
                            }
                        }
                    }
                }
            );
        }

        function reset () {
            vm.page = 0;
            vm.diariodebordos = []; 
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.diariodebordos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.diariodebordos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }

        function b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;
          
            var byteCharacters = atob(b64Data);
            var byteArrays = [];
          
            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);
            
                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
            
                var byteArray = new Uint8Array(byteNumbers);
            
                byteArrays.push(byteArray);
            }
          
            var blob = new Blob(byteArrays, {type: contentType});
            return blob;
        }
    
        function downloadDiario(id){
            Diariodebordo.queryDiario({diarioid: id}, vm.sucessoDownloadDiario);
        }
    
        function sucessoDownloadDiario(data){
            var filename = 'diario.wkt';
    
            var ct = data[0].arquivodiarioContentType;
            var dados = data[0].arquivodiario;
            
            /*
                element.setAttribute('href', 'data:' + ct + ';base64,' + dados);
                element.setAttribute('download', 'download');
            
                element.style.display = 'none';
                
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            */
    
           var blob = b64toBlob(dados, ct);
    
           if(window.navigator.msSaveOrOpenBlob) {
               window.navigator.msSaveBlob(blob, filename);
           }
           else{
               var elem = window.document.createElement('a');
               elem.href = window.URL.createObjectURL(blob);
               elem.download = filename;
               document.body.appendChild(elem);
               elem.click();
               document.body.removeChild(elem);
           }
        }
    
        function downloadObservacoes(id){
            Diariodebordo.queryObservacoes({diarioid: id}, vm.sucessoDownloadObservacoes);
        }
    
        function sucessoDownloadObservacoes(data){
            var filename = 'observacoes.txt';
    
            var ct = data[0].arquivoobservacoesContentType;
            var dados = data[0].arquivoobservacoes;
            
            /*
                element.setAttribute('href', 'data:' + ct + ';base64,' + dados);
                element.setAttribute('download', 'download');
            
                element.style.display = 'none';
                
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            */
    
           var blob = b64toBlob(dados, ct);
    
           if(window.navigator.msSaveOrOpenBlob) {
               window.navigator.msSaveBlob(blob, filename);
           }
           else{
               var elem = window.document.createElement('a');
               elem.href = window.URL.createObjectURL(blob);
               elem.download = filename;
               document.body.appendChild(elem);
               elem.click();
               document.body.removeChild(elem);
           }
        }
    }

    

})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CustosnwproducaoDialogController', CustosnwproducaoDialogController);

    CustosnwproducaoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Custosnwproducao', 'Safra'];

    function CustosnwproducaoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Custosnwproducao, Safra) {
        var vm = this;

        vm.custosnwproducao = entity;
        vm.clear = clear;
        vm.save = save;
        vm.safras = Safra.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.custosnwproducao.id !== null) {
                Custosnwproducao.update(vm.custosnwproducao, onSaveSuccess, onSaveError);
            } else {
                Custosnwproducao.save(vm.custosnwproducao, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:custosnwproducaoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CustosnwproducaoDetailController', CustosnwproducaoDetailController);

    CustosnwproducaoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Custosnwproducao', 'Safra'];

    function CustosnwproducaoDetailController($scope, $rootScope, $stateParams, previousState, entity, Custosnwproducao, Safra) {
        var vm = this;

        vm.custosnwproducao = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:custosnwproducaoUpdate', function(event, result) {
            vm.custosnwproducao = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CustosnwproducaoDeleteController',CustosnwproducaoDeleteController);

    CustosnwproducaoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Custosnwproducao'];

    function CustosnwproducaoDeleteController($uibModalInstance, entity, Custosnwproducao) {
        var vm = this;

        vm.custosnwproducao = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Custosnwproducao.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custosnwproducao', {
            parent: 'entity',
            url: '/custosnwproducao',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.custosnwproducao.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custosnwproducao/custosnwproducaos.html',
                    controller: 'CustosnwproducaoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('custosnwproducao');
                    $translatePartialLoader.addPart('tipoproducao');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custosnwproducao-detail', {
            parent: 'custosnwproducao',
            url: '/custosnwproducao/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.custosnwproducao.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custosnwproducao/custosnwproducao-detail.html',
                    controller: 'CustosnwproducaoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('custosnwproducao');
                    $translatePartialLoader.addPart('tipoproducao');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Custosnwproducao', function($stateParams, Custosnwproducao) {
                    return Custosnwproducao.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custosnwproducao',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custosnwproducao-detail.edit', {
            parent: 'custosnwproducao-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custosnwproducao/custosnwproducao-dialog.html',
                    controller: 'CustosnwproducaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Custosnwproducao', function(Custosnwproducao) {
                            return Custosnwproducao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custosnwproducao.new', {
            parent: 'custosnwproducao',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custosnwproducao/custosnwproducao-dialog.html',
                    controller: 'CustosnwproducaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                quantidademaquinas: null,
                                tipogasto: null,
                                horamaquina: null,
                                valor: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custosnwproducao', null, { reload: 'custosnwproducao' });
                }, function() {
                    $state.go('custosnwproducao');
                });
            }]
        })
        .state('custosnwproducao.edit', {
            parent: 'custosnwproducao',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custosnwproducao/custosnwproducao-dialog.html',
                    controller: 'CustosnwproducaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Custosnwproducao', function(Custosnwproducao) {
                            return Custosnwproducao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custosnwproducao', null, { reload: 'custosnwproducao' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custosnwproducao.delete', {
            parent: 'custosnwproducao',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custosnwproducao/custosnwproducao-delete-dialog.html',
                    controller: 'CustosnwproducaoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Custosnwproducao', function(Custosnwproducao) {
                            return Custosnwproducao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custosnwproducao', null, { reload: 'custosnwproducao' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Custosnwproducao', Custosnwproducao);

    Custosnwproducao.$inject = ['$resource'];

    function Custosnwproducao ($resource) {
        var resourceUrl =  'api/custosnwproducaos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('CustosnwproducaoSearch', CustosnwproducaoSearch);

    CustosnwproducaoSearch.$inject = ['$resource'];

    function CustosnwproducaoSearch($resource) {
        var resourceUrl =  'api/_search/custosnwproducaos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CustosnwproducaoController', CustosnwproducaoController);

    CustosnwproducaoController.$inject = ['Custosnwproducao', 'CustosnwproducaoSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function CustosnwproducaoController(Custosnwproducao, CustosnwproducaoSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.custosnwproducaos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                CustosnwproducaoSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Custosnwproducao.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.custosnwproducaos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.custosnwproducaos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.custosnwproducaos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.custosnwproducaos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CustosnwfertilizantesDialogController', CustosnwfertilizantesDialogController);

    CustosnwfertilizantesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Custosnwfertilizantes', 'Safra'];

    function CustosnwfertilizantesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Custosnwfertilizantes, Safra) {
        var vm = this;

        vm.custosnwfertilizantes = entity;
        vm.clear = clear;
        vm.save = save;
        vm.safras = Safra.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.custosnwfertilizantes.id !== null) {
                Custosnwfertilizantes.update(vm.custosnwfertilizantes, onSaveSuccess, onSaveError);
            } else {
                Custosnwfertilizantes.save(vm.custosnwfertilizantes, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:custosnwfertilizantesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CustosnwfertilizantesDetailController', CustosnwfertilizantesDetailController);

    CustosnwfertilizantesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Custosnwfertilizantes', 'Safra'];

    function CustosnwfertilizantesDetailController($scope, $rootScope, $stateParams, previousState, entity, Custosnwfertilizantes, Safra) {
        var vm = this;

        vm.custosnwfertilizantes = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:custosnwfertilizantesUpdate', function(event, result) {
            vm.custosnwfertilizantes = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CustosnwfertilizantesDeleteController',CustosnwfertilizantesDeleteController);

    CustosnwfertilizantesDeleteController.$inject = ['$uibModalInstance', 'entity', 'Custosnwfertilizantes'];

    function CustosnwfertilizantesDeleteController($uibModalInstance, entity, Custosnwfertilizantes) {
        var vm = this;

        vm.custosnwfertilizantes = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Custosnwfertilizantes.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custosnwfertilizantes', {
            parent: 'entity',
            url: '/custosnwfertilizantes',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.custosnwfertilizantes.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custosnwfertilizantes/custosnwfertilizantes.html',
                    controller: 'CustosnwfertilizantesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('custosnwfertilizantes');
                    $translatePartialLoader.addPart('tipofertilizante');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custosnwfertilizantes-detail', {
            parent: 'custosnwfertilizantes',
            url: '/custosnwfertilizantes/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.custosnwfertilizantes.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custosnwfertilizantes/custosnwfertilizantes-detail.html',
                    controller: 'CustosnwfertilizantesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('custosnwfertilizantes');
                    $translatePartialLoader.addPart('tipofertilizante');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Custosnwfertilizantes', function($stateParams, Custosnwfertilizantes) {
                    return Custosnwfertilizantes.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custosnwfertilizantes',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custosnwfertilizantes-detail.edit', {
            parent: 'custosnwfertilizantes-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custosnwfertilizantes/custosnwfertilizantes-dialog.html',
                    controller: 'CustosnwfertilizantesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Custosnwfertilizantes', function(Custosnwfertilizantes) {
                            return Custosnwfertilizantes.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custosnwfertilizantes.new', {
            parent: 'custosnwfertilizantes',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custosnwfertilizantes/custosnwfertilizantes-dialog.html',
                    controller: 'CustosnwfertilizantesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                descricaogastos: null,
                                tipogasto: null,
                                valor: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custosnwfertilizantes', null, { reload: 'custosnwfertilizantes' });
                }, function() {
                    $state.go('custosnwfertilizantes');
                });
            }]
        })
        .state('custosnwfertilizantes.edit', {
            parent: 'custosnwfertilizantes',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custosnwfertilizantes/custosnwfertilizantes-dialog.html',
                    controller: 'CustosnwfertilizantesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Custosnwfertilizantes', function(Custosnwfertilizantes) {
                            return Custosnwfertilizantes.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custosnwfertilizantes', null, { reload: 'custosnwfertilizantes' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custosnwfertilizantes.delete', {
            parent: 'custosnwfertilizantes',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custosnwfertilizantes/custosnwfertilizantes-delete-dialog.html',
                    controller: 'CustosnwfertilizantesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Custosnwfertilizantes', function(Custosnwfertilizantes) {
                            return Custosnwfertilizantes.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custosnwfertilizantes', null, { reload: 'custosnwfertilizantes' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Custosnwfertilizantes', Custosnwfertilizantes);

    Custosnwfertilizantes.$inject = ['$resource'];

    function Custosnwfertilizantes ($resource) {
        var resourceUrl =  'api/custosnwfertilizantes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('CustosnwfertilizantesSearch', CustosnwfertilizantesSearch);

    CustosnwfertilizantesSearch.$inject = ['$resource'];

    function CustosnwfertilizantesSearch($resource) {
        var resourceUrl =  'api/_search/custosnwfertilizantes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CustosnwfertilizantesController', CustosnwfertilizantesController);

    CustosnwfertilizantesController.$inject = ['Custosnwfertilizantes', 'CustosnwfertilizantesSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function CustosnwfertilizantesController(Custosnwfertilizantes, CustosnwfertilizantesSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.custosnwfertilizantes = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                CustosnwfertilizantesSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Custosnwfertilizantes.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.custosnwfertilizantes.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.custosnwfertilizantes = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.custosnwfertilizantes = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.custosnwfertilizantes = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CustosnwdefensivosDialogController', CustosnwdefensivosDialogController);

    CustosnwdefensivosDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Custosnwdefensivos', 'Safra'];

    function CustosnwdefensivosDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Custosnwdefensivos, Safra) {
        var vm = this;

        vm.custosnwdefensivos = entity;
        vm.clear = clear;
        vm.save = save;
        vm.safras = Safra.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.custosnwdefensivos.id !== null) {
                Custosnwdefensivos.update(vm.custosnwdefensivos, onSaveSuccess, onSaveError);
            } else {
                Custosnwdefensivos.save(vm.custosnwdefensivos, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:custosnwdefensivosUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CustosnwdefensivosDetailController', CustosnwdefensivosDetailController);

    CustosnwdefensivosDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Custosnwdefensivos', 'Safra'];

    function CustosnwdefensivosDetailController($scope, $rootScope, $stateParams, previousState, entity, Custosnwdefensivos, Safra) {
        var vm = this;

        vm.custosnwdefensivos = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:custosnwdefensivosUpdate', function(event, result) {
            vm.custosnwdefensivos = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CustosnwdefensivosDeleteController',CustosnwdefensivosDeleteController);

    CustosnwdefensivosDeleteController.$inject = ['$uibModalInstance', 'entity', 'Custosnwdefensivos'];

    function CustosnwdefensivosDeleteController($uibModalInstance, entity, Custosnwdefensivos) {
        var vm = this;

        vm.custosnwdefensivos = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Custosnwdefensivos.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custosnwdefensivos', {
            parent: 'entity',
            url: '/custosnwdefensivos',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.custosnwdefensivos.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custosnwdefensivos/custosnwdefensivos.html',
                    controller: 'CustosnwdefensivosController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('custosnwdefensivos');
                    $translatePartialLoader.addPart('tipodefensivo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custosnwdefensivos-detail', {
            parent: 'custosnwdefensivos',
            url: '/custosnwdefensivos/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.custosnwdefensivos.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custosnwdefensivos/custosnwdefensivos-detail.html',
                    controller: 'CustosnwdefensivosDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('custosnwdefensivos');
                    $translatePartialLoader.addPart('tipodefensivo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Custosnwdefensivos', function($stateParams, Custosnwdefensivos) {
                    return Custosnwdefensivos.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custosnwdefensivos',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custosnwdefensivos-detail.edit', {
            parent: 'custosnwdefensivos-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custosnwdefensivos/custosnwdefensivos-dialog.html',
                    controller: 'CustosnwdefensivosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Custosnwdefensivos', function(Custosnwdefensivos) {
                            return Custosnwdefensivos.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custosnwdefensivos.new', {
            parent: 'custosnwdefensivos',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custosnwdefensivos/custosnwdefensivos-dialog.html',
                    controller: 'CustosnwdefensivosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                descricaogastos: null,
                                tipogasto: null,
                                valor: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custosnwdefensivos', null, { reload: 'custosnwdefensivos' });
                }, function() {
                    $state.go('custosnwdefensivos');
                });
            }]
        })
        .state('custosnwdefensivos.edit', {
            parent: 'custosnwdefensivos',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custosnwdefensivos/custosnwdefensivos-dialog.html',
                    controller: 'CustosnwdefensivosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Custosnwdefensivos', function(Custosnwdefensivos) {
                            return Custosnwdefensivos.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custosnwdefensivos', null, { reload: 'custosnwdefensivos' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custosnwdefensivos.delete', {
            parent: 'custosnwdefensivos',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custosnwdefensivos/custosnwdefensivos-delete-dialog.html',
                    controller: 'CustosnwdefensivosDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Custosnwdefensivos', function(Custosnwdefensivos) {
                            return Custosnwdefensivos.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custosnwdefensivos', null, { reload: 'custosnwdefensivos' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Custosnwdefensivos', Custosnwdefensivos);

    Custosnwdefensivos.$inject = ['$resource'];

    function Custosnwdefensivos ($resource) {
        var resourceUrl =  'api/custosnwdefensivos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('CustosnwdefensivosSearch', CustosnwdefensivosSearch);

    CustosnwdefensivosSearch.$inject = ['$resource'];

    function CustosnwdefensivosSearch($resource) {
        var resourceUrl =  'api/_search/custosnwdefensivos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CustosnwdefensivosController', CustosnwdefensivosController);

    CustosnwdefensivosController.$inject = ['Custosnwdefensivos', 'CustosnwdefensivosSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function CustosnwdefensivosController(Custosnwdefensivos, CustosnwdefensivosSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.custosnwdefensivos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                CustosnwdefensivosSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Custosnwdefensivos.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.custosnwdefensivos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.custosnwdefensivos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.custosnwdefensivos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.custosnwdefensivos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CustoshabituaisproducaoDialogController', CustoshabituaisproducaoDialogController);

    CustoshabituaisproducaoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Custoshabituaisproducao', 'Safra'];

    function CustoshabituaisproducaoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Custoshabituaisproducao, Safra) {
        var vm = this;

        vm.custoshabituaisproducao = entity;
        vm.clear = clear;
        vm.save = save;
        vm.safras = Safra.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.custoshabituaisproducao.id !== null) {
                Custoshabituaisproducao.update(vm.custoshabituaisproducao, onSaveSuccess, onSaveError);
            } else {
                Custoshabituaisproducao.save(vm.custoshabituaisproducao, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:custoshabituaisproducaoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CustoshabituaisproducaoDetailController', CustoshabituaisproducaoDetailController);

    CustoshabituaisproducaoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Custoshabituaisproducao', 'Safra'];

    function CustoshabituaisproducaoDetailController($scope, $rootScope, $stateParams, previousState, entity, Custoshabituaisproducao, Safra) {
        var vm = this;

        vm.custoshabituaisproducao = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:custoshabituaisproducaoUpdate', function(event, result) {
            vm.custoshabituaisproducao = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CustoshabituaisproducaoDeleteController',CustoshabituaisproducaoDeleteController);

    CustoshabituaisproducaoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Custoshabituaisproducao'];

    function CustoshabituaisproducaoDeleteController($uibModalInstance, entity, Custoshabituaisproducao) {
        var vm = this;

        vm.custoshabituaisproducao = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Custoshabituaisproducao.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custoshabituaisproducao', {
            parent: 'entity',
            url: '/custoshabituaisproducao',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.custoshabituaisproducao.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custoshabituaisproducao/custoshabituaisproducaos.html',
                    controller: 'CustoshabituaisproducaoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('custoshabituaisproducao');
                    $translatePartialLoader.addPart('tipoproducao');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custoshabituaisproducao-detail', {
            parent: 'custoshabituaisproducao',
            url: '/custoshabituaisproducao/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.custoshabituaisproducao.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custoshabituaisproducao/custoshabituaisproducao-detail.html',
                    controller: 'CustoshabituaisproducaoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('custoshabituaisproducao');
                    $translatePartialLoader.addPart('tipoproducao');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Custoshabituaisproducao', function($stateParams, Custoshabituaisproducao) {
                    return Custoshabituaisproducao.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custoshabituaisproducao',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custoshabituaisproducao-detail.edit', {
            parent: 'custoshabituaisproducao-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custoshabituaisproducao/custoshabituaisproducao-dialog.html',
                    controller: 'CustoshabituaisproducaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Custoshabituaisproducao', function(Custoshabituaisproducao) {
                            return Custoshabituaisproducao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custoshabituaisproducao.new', {
            parent: 'custoshabituaisproducao',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custoshabituaisproducao/custoshabituaisproducao-dialog.html',
                    controller: 'CustoshabituaisproducaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                quantidademaquinas: null,
                                tipogasto: null,
                                horamaquina: null,
                                valor: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custoshabituaisproducao', null, { reload: 'custoshabituaisproducao' });
                }, function() {
                    $state.go('custoshabituaisproducao');
                });
            }]
        })
        .state('custoshabituaisproducao.edit', {
            parent: 'custoshabituaisproducao',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custoshabituaisproducao/custoshabituaisproducao-dialog.html',
                    controller: 'CustoshabituaisproducaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Custoshabituaisproducao', function(Custoshabituaisproducao) {
                            return Custoshabituaisproducao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custoshabituaisproducao', null, { reload: 'custoshabituaisproducao' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custoshabituaisproducao.delete', {
            parent: 'custoshabituaisproducao',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custoshabituaisproducao/custoshabituaisproducao-delete-dialog.html',
                    controller: 'CustoshabituaisproducaoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Custoshabituaisproducao', function(Custoshabituaisproducao) {
                            return Custoshabituaisproducao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custoshabituaisproducao', null, { reload: 'custoshabituaisproducao' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Custoshabituaisproducao', Custoshabituaisproducao);

    Custoshabituaisproducao.$inject = ['$resource'];

    function Custoshabituaisproducao ($resource) {
        var resourceUrl =  'api/custoshabituaisproducaos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('CustoshabituaisproducaoSearch', CustoshabituaisproducaoSearch);

    CustoshabituaisproducaoSearch.$inject = ['$resource'];

    function CustoshabituaisproducaoSearch($resource) {
        var resourceUrl =  'api/_search/custoshabituaisproducaos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CustoshabituaisproducaoController', CustoshabituaisproducaoController);

    CustoshabituaisproducaoController.$inject = ['Custoshabituaisproducao', 'CustoshabituaisproducaoSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function CustoshabituaisproducaoController(Custoshabituaisproducao, CustoshabituaisproducaoSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.custoshabituaisproducaos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                CustoshabituaisproducaoSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Custoshabituaisproducao.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.custoshabituaisproducaos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.custoshabituaisproducaos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.custoshabituaisproducaos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.custoshabituaisproducaos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CustoshabituaisfertilizantesDialogController', CustoshabituaisfertilizantesDialogController);

    CustoshabituaisfertilizantesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Custoshabituaisfertilizantes', 'Safra'];

    function CustoshabituaisfertilizantesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Custoshabituaisfertilizantes, Safra) {
        var vm = this;

        vm.custoshabituaisfertilizantes = entity;
        vm.clear = clear;
        vm.save = save;
        vm.safras = Safra.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.custoshabituaisfertilizantes.id !== null) {
                Custoshabituaisfertilizantes.update(vm.custoshabituaisfertilizantes, onSaveSuccess, onSaveError);
            } else {
                Custoshabituaisfertilizantes.save(vm.custoshabituaisfertilizantes, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:custoshabituaisfertilizantesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CustoshabituaisfertilizantesDetailController', CustoshabituaisfertilizantesDetailController);

    CustoshabituaisfertilizantesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Custoshabituaisfertilizantes', 'Safra'];

    function CustoshabituaisfertilizantesDetailController($scope, $rootScope, $stateParams, previousState, entity, Custoshabituaisfertilizantes, Safra) {
        var vm = this;

        vm.custoshabituaisfertilizantes = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:custoshabituaisfertilizantesUpdate', function(event, result) {
            vm.custoshabituaisfertilizantes = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CustoshabituaisfertilizantesDeleteController',CustoshabituaisfertilizantesDeleteController);

    CustoshabituaisfertilizantesDeleteController.$inject = ['$uibModalInstance', 'entity', 'Custoshabituaisfertilizantes'];

    function CustoshabituaisfertilizantesDeleteController($uibModalInstance, entity, Custoshabituaisfertilizantes) {
        var vm = this;

        vm.custoshabituaisfertilizantes = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Custoshabituaisfertilizantes.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custoshabituaisfertilizantes', {
            parent: 'entity',
            url: '/custoshabituaisfertilizantes',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.custoshabituaisfertilizantes.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custoshabituaisfertilizantes/custoshabituaisfertilizantes.html',
                    controller: 'CustoshabituaisfertilizantesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('custoshabituaisfertilizantes');
                    $translatePartialLoader.addPart('tipofertilizante');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custoshabituaisfertilizantes-detail', {
            parent: 'custoshabituaisfertilizantes',
            url: '/custoshabituaisfertilizantes/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.custoshabituaisfertilizantes.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custoshabituaisfertilizantes/custoshabituaisfertilizantes-detail.html',
                    controller: 'CustoshabituaisfertilizantesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('custoshabituaisfertilizantes');
                    $translatePartialLoader.addPart('tipofertilizante');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Custoshabituaisfertilizantes', function($stateParams, Custoshabituaisfertilizantes) {
                    return Custoshabituaisfertilizantes.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custoshabituaisfertilizantes',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custoshabituaisfertilizantes-detail.edit', {
            parent: 'custoshabituaisfertilizantes-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custoshabituaisfertilizantes/custoshabituaisfertilizantes-dialog.html',
                    controller: 'CustoshabituaisfertilizantesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Custoshabituaisfertilizantes', function(Custoshabituaisfertilizantes) {
                            return Custoshabituaisfertilizantes.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custoshabituaisfertilizantes.new', {
            parent: 'custoshabituaisfertilizantes',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custoshabituaisfertilizantes/custoshabituaisfertilizantes-dialog.html',
                    controller: 'CustoshabituaisfertilizantesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                descricaogastos: null,
                                tipogasto: null,
                                valor: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custoshabituaisfertilizantes', null, { reload: 'custoshabituaisfertilizantes' });
                }, function() {
                    $state.go('custoshabituaisfertilizantes');
                });
            }]
        })
        .state('custoshabituaisfertilizantes.edit', {
            parent: 'custoshabituaisfertilizantes',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custoshabituaisfertilizantes/custoshabituaisfertilizantes-dialog.html',
                    controller: 'CustoshabituaisfertilizantesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Custoshabituaisfertilizantes', function(Custoshabituaisfertilizantes) {
                            return Custoshabituaisfertilizantes.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custoshabituaisfertilizantes', null, { reload: 'custoshabituaisfertilizantes' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custoshabituaisfertilizantes.delete', {
            parent: 'custoshabituaisfertilizantes',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custoshabituaisfertilizantes/custoshabituaisfertilizantes-delete-dialog.html',
                    controller: 'CustoshabituaisfertilizantesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Custoshabituaisfertilizantes', function(Custoshabituaisfertilizantes) {
                            return Custoshabituaisfertilizantes.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custoshabituaisfertilizantes', null, { reload: 'custoshabituaisfertilizantes' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Custoshabituaisfertilizantes', Custoshabituaisfertilizantes);

    Custoshabituaisfertilizantes.$inject = ['$resource'];

    function Custoshabituaisfertilizantes ($resource) {
        var resourceUrl =  'api/custoshabituaisfertilizantes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('CustoshabituaisfertilizantesSearch', CustoshabituaisfertilizantesSearch);

    CustoshabituaisfertilizantesSearch.$inject = ['$resource'];

    function CustoshabituaisfertilizantesSearch($resource) {
        var resourceUrl =  'api/_search/custoshabituaisfertilizantes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CustoshabituaisfertilizantesController', CustoshabituaisfertilizantesController);

    CustoshabituaisfertilizantesController.$inject = ['Custoshabituaisfertilizantes', 'CustoshabituaisfertilizantesSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function CustoshabituaisfertilizantesController(Custoshabituaisfertilizantes, CustoshabituaisfertilizantesSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.custoshabituaisfertilizantes = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                CustoshabituaisfertilizantesSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Custoshabituaisfertilizantes.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.custoshabituaisfertilizantes.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.custoshabituaisfertilizantes = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.custoshabituaisfertilizantes = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.custoshabituaisfertilizantes = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CustoshabituaisdefensivosDialogController', CustoshabituaisdefensivosDialogController);

    CustoshabituaisdefensivosDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Custoshabituaisdefensivos', 'Safra'];

    function CustoshabituaisdefensivosDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Custoshabituaisdefensivos, Safra) {
        var vm = this;

        vm.custoshabituaisdefensivos = entity;
        vm.clear = clear;
        vm.save = save;
        vm.safras = Safra.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.custoshabituaisdefensivos.id !== null) {
                Custoshabituaisdefensivos.update(vm.custoshabituaisdefensivos, onSaveSuccess, onSaveError);
            } else {
                Custoshabituaisdefensivos.save(vm.custoshabituaisdefensivos, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:custoshabituaisdefensivosUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CustoshabituaisdefensivosDetailController', CustoshabituaisdefensivosDetailController);

    CustoshabituaisdefensivosDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Custoshabituaisdefensivos', 'Safra'];

    function CustoshabituaisdefensivosDetailController($scope, $rootScope, $stateParams, previousState, entity, Custoshabituaisdefensivos, Safra) {
        var vm = this;

        vm.custoshabituaisdefensivos = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:custoshabituaisdefensivosUpdate', function(event, result) {
            vm.custoshabituaisdefensivos = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CustoshabituaisdefensivosDeleteController',CustoshabituaisdefensivosDeleteController);

    CustoshabituaisdefensivosDeleteController.$inject = ['$uibModalInstance', 'entity', 'Custoshabituaisdefensivos'];

    function CustoshabituaisdefensivosDeleteController($uibModalInstance, entity, Custoshabituaisdefensivos) {
        var vm = this;

        vm.custoshabituaisdefensivos = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Custoshabituaisdefensivos.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('custoshabituaisdefensivos', {
            parent: 'entity',
            url: '/custoshabituaisdefensivos',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.custoshabituaisdefensivos.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custoshabituaisdefensivos/custoshabituaisdefensivos.html',
                    controller: 'CustoshabituaisdefensivosController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('custoshabituaisdefensivos');
                    $translatePartialLoader.addPart('tipodefensivo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('custoshabituaisdefensivos-detail', {
            parent: 'custoshabituaisdefensivos',
            url: '/custoshabituaisdefensivos/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.custoshabituaisdefensivos.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/custoshabituaisdefensivos/custoshabituaisdefensivos-detail.html',
                    controller: 'CustoshabituaisdefensivosDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('custoshabituaisdefensivos');
                    $translatePartialLoader.addPart('tipodefensivo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Custoshabituaisdefensivos', function($stateParams, Custoshabituaisdefensivos) {
                    return Custoshabituaisdefensivos.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'custoshabituaisdefensivos',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('custoshabituaisdefensivos-detail.edit', {
            parent: 'custoshabituaisdefensivos-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custoshabituaisdefensivos/custoshabituaisdefensivos-dialog.html',
                    controller: 'CustoshabituaisdefensivosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Custoshabituaisdefensivos', function(Custoshabituaisdefensivos) {
                            return Custoshabituaisdefensivos.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custoshabituaisdefensivos.new', {
            parent: 'custoshabituaisdefensivos',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custoshabituaisdefensivos/custoshabituaisdefensivos-dialog.html',
                    controller: 'CustoshabituaisdefensivosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                descricaogastos: null,
                                tipogasto: null,
                                valor: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('custoshabituaisdefensivos', null, { reload: 'custoshabituaisdefensivos' });
                }, function() {
                    $state.go('custoshabituaisdefensivos');
                });
            }]
        })
        .state('custoshabituaisdefensivos.edit', {
            parent: 'custoshabituaisdefensivos',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custoshabituaisdefensivos/custoshabituaisdefensivos-dialog.html',
                    controller: 'CustoshabituaisdefensivosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Custoshabituaisdefensivos', function(Custoshabituaisdefensivos) {
                            return Custoshabituaisdefensivos.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custoshabituaisdefensivos', null, { reload: 'custoshabituaisdefensivos' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('custoshabituaisdefensivos.delete', {
            parent: 'custoshabituaisdefensivos',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/custoshabituaisdefensivos/custoshabituaisdefensivos-delete-dialog.html',
                    controller: 'CustoshabituaisdefensivosDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Custoshabituaisdefensivos', function(Custoshabituaisdefensivos) {
                            return Custoshabituaisdefensivos.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('custoshabituaisdefensivos', null, { reload: 'custoshabituaisdefensivos' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Custoshabituaisdefensivos', Custoshabituaisdefensivos);

    Custoshabituaisdefensivos.$inject = ['$resource'];

    function Custoshabituaisdefensivos ($resource) {
        var resourceUrl =  'api/custoshabituaisdefensivos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('CustoshabituaisdefensivosSearch', CustoshabituaisdefensivosSearch);

    CustoshabituaisdefensivosSearch.$inject = ['$resource'];

    function CustoshabituaisdefensivosSearch($resource) {
        var resourceUrl =  'api/_search/custoshabituaisdefensivos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CustoshabituaisdefensivosController', CustoshabituaisdefensivosController);

    CustoshabituaisdefensivosController.$inject = ['Custoshabituaisdefensivos', 'CustoshabituaisdefensivosSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function CustoshabituaisdefensivosController(Custoshabituaisdefensivos, CustoshabituaisdefensivosSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.custoshabituaisdefensivos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                CustoshabituaisdefensivosSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Custoshabituaisdefensivos.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.custoshabituaisdefensivos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.custoshabituaisdefensivos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.custoshabituaisdefensivos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.custoshabituaisdefensivos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CulturaDialogController', CulturaDialogController);

    CulturaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Cultura', 'Pesquisa', 'Corratribce', 'Concentracaoidealatributo', 'Caracteristicacultura', 'Safra'];

    function CulturaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Cultura, Pesquisa, Corratribce, Concentracaoidealatributo, Caracteristicacultura, Safra) {
        var vm = this;

        vm.cultura = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.pesquisas = Pesquisa.query();
        vm.corratribces = Corratribce.query();
        vm.concentracaoidealatributos = Concentracaoidealatributo.query();
        vm.caracteristicaculturas = Caracteristicacultura.query();
        vm.safras = Safra.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.cultura.id !== null) {
                Cultura.update(vm.cultura, onSaveSuccess, onSaveError);
            } else {
                Cultura.save(vm.cultura, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:culturaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setImagemcultura = function ($file, cultura) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        cultura.imagemcultura = base64Data;
                        cultura.imagemculturaContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CulturaDetailController', CulturaDetailController);

    CulturaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Cultura', 'Pesquisa', 'Corratribce', 'Concentracaoidealatributo', 'Caracteristicacultura', 'Safra'];

    function CulturaDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Cultura, Pesquisa, Corratribce, Concentracaoidealatributo, Caracteristicacultura, Safra) {
        var vm = this;

        vm.cultura = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('netWordAgroApp:culturaUpdate', function(event, result) {
            vm.cultura = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CulturaDeleteController',CulturaDeleteController);

    CulturaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Cultura'];

    function CulturaDeleteController($uibModalInstance, entity, Cultura) {
        var vm = this;

        vm.cultura = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Cultura.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('cultura', {
            parent: 'entity',
            url: '/cultura',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.cultura.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cultura/culturas.html',
                    controller: 'CulturaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cultura');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('cultura-detail', {
            parent: 'cultura',
            url: '/cultura/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.cultura.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cultura/cultura-detail.html',
                    controller: 'CulturaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cultura');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Cultura', function($stateParams, Cultura) {
                    return Cultura.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'cultura',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('cultura-detail.edit', {
            parent: 'cultura-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cultura/cultura-dialog.html',
                    controller: 'CulturaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Cultura', function(Cultura) {
                            return Cultura.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cultura.new', {
            parent: 'cultura',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cultura/cultura-dialog.html',
                    controller: 'CulturaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nomecultura: null,
                                imagemcultura: null,
                                imagemculturaContentType: null,
                                produtividademinima: null,
                                produtividademedia: null,
                                produtividademaxima: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('cultura', null, { reload: 'cultura' });
                }, function() {
                    $state.go('cultura');
                });
            }]
        })
        .state('cultura.edit', {
            parent: 'cultura',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cultura/cultura-dialog.html',
                    controller: 'CulturaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Cultura', function(Cultura) {
                            return Cultura.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cultura', null, { reload: 'cultura' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cultura.delete', {
            parent: 'cultura',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cultura/cultura-delete-dialog.html',
                    controller: 'CulturaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Cultura', function(Cultura) {
                            return Cultura.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cultura', null, { reload: 'cultura' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Cultura', Cultura);

    Cultura.$inject = ['$resource'];

    function Cultura ($resource) {
        var resourceUrl =  'api/culturas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('CulturaSearch', CulturaSearch);

    CulturaSearch.$inject = ['$resource'];

    function CulturaSearch($resource) {
        var resourceUrl =  'api/_search/culturas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CulturaController', CulturaController);

    CulturaController.$inject = ['DataUtils', 'Cultura', 'CulturaSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function CulturaController(DataUtils, Cultura, CulturaSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.culturas = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                CulturaSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Cultura.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.culturas.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.culturas = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.culturas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.culturas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CorratribceDialogController', CorratribceDialogController);

    CorratribceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Corratribce', 'Atributo', 'Cultura', 'Solo'];

    function CorratribceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Corratribce, Atributo, Cultura, Solo) {
        var vm = this;

        vm.corratribce = entity;
        vm.clear = clear;
        vm.save = save;
        vm.atributos = Atributo.query();
        vm.culturas = Cultura.query();
        vm.solos = Solo.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.corratribce.id !== null) {
                Corratribce.update(vm.corratribce, onSaveSuccess, onSaveError);
            } else {
                Corratribce.save(vm.corratribce, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:corratribceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CorratribceDetailController', CorratribceDetailController);

    CorratribceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Corratribce', 'Atributo', 'Cultura', 'Solo'];

    function CorratribceDetailController($scope, $rootScope, $stateParams, previousState, entity, Corratribce, Atributo, Cultura, Solo) {
        var vm = this;

        vm.corratribce = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:corratribceUpdate', function(event, result) {
            vm.corratribce = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CorratribceDeleteController',CorratribceDeleteController);

    CorratribceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Corratribce'];

    function CorratribceDeleteController($uibModalInstance, entity, Corratribce) {
        var vm = this;

        vm.corratribce = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Corratribce.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('corratribce', {
            parent: 'entity',
            url: '/corratribce',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.corratribce.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/corratribce/corratribces.html',
                    controller: 'CorratribceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('corratribce');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('corratribce-detail', {
            parent: 'corratribce',
            url: '/corratribce/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.corratribce.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/corratribce/corratribce-detail.html',
                    controller: 'CorratribceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('corratribce');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Corratribce', function($stateParams, Corratribce) {
                    return Corratribce.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'corratribce',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('corratribce-detail.edit', {
            parent: 'corratribce-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/corratribce/corratribce-dialog.html',
                    controller: 'CorratribceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Corratribce', function(Corratribce) {
                            return Corratribce.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('corratribce.new', {
            parent: 'corratribce',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/corratribce/corratribce-dialog.html',
                    controller: 'CorratribceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                freqcorr: null,
                                condcorr: null,
                                tempCorr: null,
                                umidcorr: null,
                                vlrconcentracao: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('corratribce', null, { reload: 'corratribce' });
                }, function() {
                    $state.go('corratribce');
                });
            }]
        })
        .state('corratribce.edit', {
            parent: 'corratribce',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/corratribce/corratribce-dialog.html',
                    controller: 'CorratribceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Corratribce', function(Corratribce) {
                            return Corratribce.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('corratribce', null, { reload: 'corratribce' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('corratribce.delete', {
            parent: 'corratribce',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/corratribce/corratribce-delete-dialog.html',
                    controller: 'CorratribceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Corratribce', function(Corratribce) {
                            return Corratribce.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('corratribce', null, { reload: 'corratribce' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Corratribce', Corratribce);

    Corratribce.$inject = ['$resource'];

    function Corratribce ($resource) {
        var resourceUrl =  'api/corratribces/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('CorratribceSearch', CorratribceSearch);

    CorratribceSearch.$inject = ['$resource'];

    function CorratribceSearch($resource) {
        var resourceUrl =  'api/_search/corratribces/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CorratribceController', CorratribceController);

    CorratribceController.$inject = ['Corratribce', 'CorratribceSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function CorratribceController(Corratribce, CorratribceSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.corratribces = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                CorratribceSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Corratribce.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.corratribces.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.corratribces = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.corratribces = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.corratribces = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CooperativaDialogController', CooperativaDialogController);

    CooperativaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Cooperativa', 'Propriedade'];

    function CooperativaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Cooperativa, Propriedade) {
        var vm = this;

        vm.cooperativa = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.propriedades = Propriedade.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.cooperativa.id !== null) {
                Cooperativa.update(vm.cooperativa, onSaveSuccess, onSaveError);
            } else {
                Cooperativa.save(vm.cooperativa, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:cooperativaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setLogotipo = function ($file, cooperativa) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        cooperativa.logotipo = base64Data;
                        cooperativa.logotipoContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CooperativaDetailController', CooperativaDetailController);

    CooperativaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Cooperativa', 'Propriedade'];

    function CooperativaDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Cooperativa, Propriedade) {
        var vm = this;

        vm.cooperativa = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('netWordAgroApp:cooperativaUpdate', function(event, result) {
            vm.cooperativa = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CooperativaDeleteController',CooperativaDeleteController);

    CooperativaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Cooperativa'];

    function CooperativaDeleteController($uibModalInstance, entity, Cooperativa) {
        var vm = this;

        vm.cooperativa = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Cooperativa.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('cooperativa', {
            parent: 'entity',
            url: '/cooperativa',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.cooperativa.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cooperativa/cooperativas.html',
                    controller: 'CooperativaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cooperativa');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('cooperativa-detail', {
            parent: 'cooperativa',
            url: '/cooperativa/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.cooperativa.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cooperativa/cooperativa-detail.html',
                    controller: 'CooperativaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cooperativa');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Cooperativa', function($stateParams, Cooperativa) {
                    return Cooperativa.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'cooperativa',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('cooperativa-detail.edit', {
            parent: 'cooperativa-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cooperativa/cooperativa-dialog.html',
                    controller: 'CooperativaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Cooperativa', function(Cooperativa) {
                            return Cooperativa.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cooperativa.new', {
            parent: 'cooperativa',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cooperativa/cooperativa-dialog.html',
                    controller: 'CooperativaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                cnpj: null,
                                nomeresponsavel: null,
                                telefoneresponsavel: null,
                                emailresponsavel: null,
                                logotipo: null,
                                logotipoContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('cooperativa', null, { reload: 'cooperativa' });
                }, function() {
                    $state.go('cooperativa');
                });
            }]
        })
        .state('cooperativa.edit', {
            parent: 'cooperativa',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cooperativa/cooperativa-dialog.html',
                    controller: 'CooperativaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Cooperativa', function(Cooperativa) {
                            return Cooperativa.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cooperativa', null, { reload: 'cooperativa' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cooperativa.delete', {
            parent: 'cooperativa',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cooperativa/cooperativa-delete-dialog.html',
                    controller: 'CooperativaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Cooperativa', function(Cooperativa) {
                            return Cooperativa.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cooperativa', null, { reload: 'cooperativa' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Cooperativa', Cooperativa);

    Cooperativa.$inject = ['$resource'];

    function Cooperativa ($resource) {
        var resourceUrl =  'api/cooperativas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('CooperativaSearch', CooperativaSearch);

    CooperativaSearch.$inject = ['$resource'];

    function CooperativaSearch($resource) {
        var resourceUrl =  'api/_search/cooperativas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CooperativaController', CooperativaController);

    CooperativaController.$inject = ['DataUtils', 'Cooperativa', 'CooperativaSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function CooperativaController(DataUtils, Cooperativa, CooperativaSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.cooperativas = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                CooperativaSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Cooperativa.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.cooperativas.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.cooperativas = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.cooperativas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.cooperativas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ControlepropagandasDialogController', ControlepropagandasDialogController);

    ControlepropagandasDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Controlepropagandas'];

    function ControlepropagandasDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Controlepropagandas) {
        var vm = this;

        vm.controlepropagandas = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.controlepropagandas.id !== null) {
                Controlepropagandas.update(vm.controlepropagandas, onSaveSuccess, onSaveError);
            } else {
                Controlepropagandas.save(vm.controlepropagandas, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:controlepropagandasUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.horario = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ControlepropagandasDetailController', ControlepropagandasDetailController);

    ControlepropagandasDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Controlepropagandas'];

    function ControlepropagandasDetailController($scope, $rootScope, $stateParams, previousState, entity, Controlepropagandas) {
        var vm = this;

        vm.controlepropagandas = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:controlepropagandasUpdate', function(event, result) {
            vm.controlepropagandas = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ControlepropagandasDeleteController',ControlepropagandasDeleteController);

    ControlepropagandasDeleteController.$inject = ['$uibModalInstance', 'entity', 'Controlepropagandas'];

    function ControlepropagandasDeleteController($uibModalInstance, entity, Controlepropagandas) {
        var vm = this;

        vm.controlepropagandas = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Controlepropagandas.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('controlepropagandas', {
            parent: 'entity',
            url: '/controlepropagandas',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.controlepropagandas.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/controlepropagandas/controlepropagandas.html',
                    controller: 'ControlepropagandasController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('controlepropagandas');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('controlepropagandas-detail', {
            parent: 'controlepropagandas',
            url: '/controlepropagandas/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.controlepropagandas.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/controlepropagandas/controlepropagandas-detail.html',
                    controller: 'ControlepropagandasDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('controlepropagandas');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Controlepropagandas', function($stateParams, Controlepropagandas) {
                    return Controlepropagandas.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'controlepropagandas',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('controlepropagandas-detail.edit', {
            parent: 'controlepropagandas-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/controlepropagandas/controlepropagandas-dialog.html',
                    controller: 'ControlepropagandasDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Controlepropagandas', function(Controlepropagandas) {
                            return Controlepropagandas.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('controlepropagandas.new', {
            parent: 'controlepropagandas',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/controlepropagandas/controlepropagandas-dialog.html',
                    controller: 'ControlepropagandasDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                idbanner: null,
                                linkacessado: null,
                                horario: null,
                                usuario: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('controlepropagandas', null, { reload: 'controlepropagandas' });
                }, function() {
                    $state.go('controlepropagandas');
                });
            }]
        })
        .state('controlepropagandas.edit', {
            parent: 'controlepropagandas',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/controlepropagandas/controlepropagandas-dialog.html',
                    controller: 'ControlepropagandasDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Controlepropagandas', function(Controlepropagandas) {
                            return Controlepropagandas.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('controlepropagandas', null, { reload: 'controlepropagandas' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('controlepropagandas.delete', {
            parent: 'controlepropagandas',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/controlepropagandas/controlepropagandas-delete-dialog.html',
                    controller: 'ControlepropagandasDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Controlepropagandas', function(Controlepropagandas) {
                            return Controlepropagandas.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('controlepropagandas', null, { reload: 'controlepropagandas' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Controlepropagandas', Controlepropagandas);

    Controlepropagandas.$inject = ['$resource', 'DateUtils'];

    function Controlepropagandas ($resource, DateUtils) {
        var resourceUrl =  'api/controlepropagandas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.horario = DateUtils.convertDateTimeFromServer(data.horario);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('ControlepropagandasSearch', ControlepropagandasSearch);

    ControlepropagandasSearch.$inject = ['$resource'];

    function ControlepropagandasSearch($resource) {
        var resourceUrl =  'api/_search/controlepropagandas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ControlepropagandasController', ControlepropagandasController);

    ControlepropagandasController.$inject = ['Controlepropagandas', 'ControlepropagandasSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function ControlepropagandasController(Controlepropagandas, ControlepropagandasSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.controlepropagandas = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                ControlepropagandasSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Controlepropagandas.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.controlepropagandas.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.controlepropagandas = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.controlepropagandas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.controlepropagandas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ControleaplicacaoDialogController', ControleaplicacaoDialogController);

    ControleaplicacaoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Controleaplicacao', 'Safra', 'Propriedade'];

    function ControleaplicacaoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Controleaplicacao, Safra, Propriedade) {
        var vm = this;

        vm.controleaplicacao = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.safras = Safra.query();
        vm.propriedades = Propriedade.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.controleaplicacao.id !== null) {
                Controleaplicacao.update(vm.controleaplicacao, onSaveSuccess, onSaveError);
            } else {
                Controleaplicacao.save(vm.controleaplicacao, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:controleaplicacaoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.data = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ControleaplicacaoDetailController', ControleaplicacaoDetailController);

    ControleaplicacaoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Controleaplicacao', 'Safra', 'Propriedade'];

    function ControleaplicacaoDetailController($scope, $rootScope, $stateParams, previousState, entity, Controleaplicacao, Safra, Propriedade) {
        var vm = this;

        vm.controleaplicacao = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:controleaplicacaoUpdate', function(event, result) {
            vm.controleaplicacao = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ControleaplicacaoDeleteController',ControleaplicacaoDeleteController);

    ControleaplicacaoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Controleaplicacao'];

    function ControleaplicacaoDeleteController($uibModalInstance, entity, Controleaplicacao) {
        var vm = this;

        vm.controleaplicacao = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Controleaplicacao.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('controleaplicacao', {
            parent: 'entity',
            url: '/controleaplicacao',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.controleaplicacao.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/controleaplicacao/controleaplicacaos.html',
                    controller: 'ControleaplicacaoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('controleaplicacao');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('controleaplicacao-detail', {
            parent: 'controleaplicacao',
            url: '/controleaplicacao/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.controleaplicacao.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/controleaplicacao/controleaplicacao-detail.html',
                    controller: 'ControleaplicacaoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('controleaplicacao');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Controleaplicacao', function($stateParams, Controleaplicacao) {
                    return Controleaplicacao.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'controleaplicacao',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('controleaplicacao-detail.edit', {
            parent: 'controleaplicacao-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/controleaplicacao/controleaplicacao-dialog.html',
                    controller: 'ControleaplicacaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Controleaplicacao', function(Controleaplicacao) {
                            return Controleaplicacao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('controleaplicacao.new', {
            parent: 'controleaplicacao',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/controleaplicacao/controleaplicacao-dialog.html',
                    controller: 'ControleaplicacaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                data: null,
                                tipoaplicacao: null,
                                produto: null,
                                quantidadeproduto: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('controleaplicacao', null, { reload: 'controleaplicacao' });
                }, function() {
                    $state.go('controleaplicacao');
                });
            }]
        })
        .state('controleaplicacao.edit', {
            parent: 'controleaplicacao',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/controleaplicacao/controleaplicacao-dialog.html',
                    controller: 'ControleaplicacaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Controleaplicacao', function(Controleaplicacao) {
                            return Controleaplicacao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('controleaplicacao', null, { reload: 'controleaplicacao' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('controleaplicacao.delete', {
            parent: 'controleaplicacao',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/controleaplicacao/controleaplicacao-delete-dialog.html',
                    controller: 'ControleaplicacaoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Controleaplicacao', function(Controleaplicacao) {
                            return Controleaplicacao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('controleaplicacao', null, { reload: 'controleaplicacao' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Controleaplicacao', Controleaplicacao);

    Controleaplicacao.$inject = ['$resource', 'DateUtils'];

    function Controleaplicacao ($resource, DateUtils) {
        var resourceUrl =  'api/controleaplicacaos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.data = DateUtils.convertLocalDateFromServer(data.data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.data = DateUtils.convertLocalDateToServer(copy.data);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.data = DateUtils.convertLocalDateToServer(copy.data);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('ControleaplicacaoSearch', ControleaplicacaoSearch);

    ControleaplicacaoSearch.$inject = ['$resource'];

    function ControleaplicacaoSearch($resource) {
        var resourceUrl =  'api/_search/controleaplicacaos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ControleaplicacaoController', ControleaplicacaoController);

    ControleaplicacaoController.$inject = ['Controleaplicacao', 'ControleaplicacaoSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function ControleaplicacaoController(Controleaplicacao, ControleaplicacaoSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.controleaplicacaos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                ControleaplicacaoSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Controleaplicacao.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.controleaplicacaos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.controleaplicacaos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.controleaplicacaos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.controleaplicacaos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ConfiguracaomapacalorDialogController', ConfiguracaomapacalorDialogController);

    ConfiguracaomapacalorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Configuracaomapacalor', 'Cultura'];

    function ConfiguracaomapacalorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Configuracaomapacalor, Cultura) {
        var vm = this;

        vm.configuracaomapacalor = entity;
        vm.clear = clear;
        vm.save = save;
        vm.culturas = Cultura.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.configuracaomapacalor.id !== null) {
                Configuracaomapacalor.update(vm.configuracaomapacalor, onSaveSuccess, onSaveError);
            } else {
                Configuracaomapacalor.save(vm.configuracaomapacalor, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:configuracaomapacalorUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ConfiguracaomapacalorDetailController', ConfiguracaomapacalorDetailController);

    ConfiguracaomapacalorDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Configuracaomapacalor', 'Cultura'];

    function ConfiguracaomapacalorDetailController($scope, $rootScope, $stateParams, previousState, entity, Configuracaomapacalor, Cultura) {
        var vm = this;

        vm.configuracaomapacalor = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:configuracaomapacalorUpdate', function(event, result) {
            vm.configuracaomapacalor = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ConfiguracaomapacalorDeleteController',ConfiguracaomapacalorDeleteController);

    ConfiguracaomapacalorDeleteController.$inject = ['$uibModalInstance', 'entity', 'Configuracaomapacalor'];

    function ConfiguracaomapacalorDeleteController($uibModalInstance, entity, Configuracaomapacalor) {
        var vm = this;

        vm.configuracaomapacalor = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Configuracaomapacalor.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('configuracaomapacalor', {
            parent: 'entity',
            url: '/configuracaomapacalor',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.configuracaomapacalor.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/configuracaomapacalor/configuracaomapacalors.html',
                    controller: 'ConfiguracaomapacalorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuracaomapacalor');
                    $translatePartialLoader.addPart('tipomapa');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('configuracaomapacalor-detail', {
            parent: 'configuracaomapacalor',
            url: '/configuracaomapacalor/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.configuracaomapacalor.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/configuracaomapacalor/configuracaomapacalor-detail.html',
                    controller: 'ConfiguracaomapacalorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuracaomapacalor');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Configuracaomapacalor', function($stateParams, Configuracaomapacalor) {
                    return Configuracaomapacalor.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'configuracaomapacalor',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('configuracaomapacalor-detail.edit', {
            parent: 'configuracaomapacalor-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/configuracaomapacalor/configuracaomapacalor-dialog.html',
                    controller: 'ConfiguracaomapacalorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Configuracaomapacalor', function(Configuracaomapacalor) {
                            return Configuracaomapacalor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('configuracaomapacalor.new', {
            parent: 'configuracaomapacalor',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/configuracaomapacalor/configuracaomapacalor-dialog.html',
                    controller: 'ConfiguracaomapacalorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                pouco: null,
                                muito: null,
                                tipomapa: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('configuracaomapacalor', null, { reload: 'configuracaomapacalor' });
                }, function() {
                    $state.go('configuracaomapacalor');
                });
            }]
        })
        .state('configuracaomapacalor.edit', {
            parent: 'configuracaomapacalor',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/configuracaomapacalor/configuracaomapacalor-dialog.html',
                    controller: 'ConfiguracaomapacalorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Configuracaomapacalor', function(Configuracaomapacalor) {
                            return Configuracaomapacalor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('configuracaomapacalor', null, { reload: 'configuracaomapacalor' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('configuracaomapacalor.delete', {
            parent: 'configuracaomapacalor',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/configuracaomapacalor/configuracaomapacalor-delete-dialog.html',
                    controller: 'ConfiguracaomapacalorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Configuracaomapacalor', function(Configuracaomapacalor) {
                            return Configuracaomapacalor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('configuracaomapacalor', null, { reload: 'configuracaomapacalor' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Configuracaomapacalor', Configuracaomapacalor);

    Configuracaomapacalor.$inject = ['$resource'];

    function Configuracaomapacalor ($resource) {
        var resourceUrl =  'api/configuracaomapacalors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('ConfiguracaomapacalorSearch', ConfiguracaomapacalorSearch);

    ConfiguracaomapacalorSearch.$inject = ['$resource'];

    function ConfiguracaomapacalorSearch($resource) {
        var resourceUrl =  'api/_search/configuracaomapacalors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ConfiguracaomapacalorController', ConfiguracaomapacalorController);

    ConfiguracaomapacalorController.$inject = ['Configuracaomapacalor', 'ConfiguracaomapacalorSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function ConfiguracaomapacalorController(Configuracaomapacalor, ConfiguracaomapacalorSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.configuracaomapacalors = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                ConfiguracaomapacalorSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Configuracaomapacalor.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.configuracaomapacalors.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.configuracaomapacalors = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.configuracaomapacalors = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.configuracaomapacalors = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ConcentracaoindiceDialogController', ConcentracaoindiceDialogController);

    ConcentracaoindiceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Concentracaoindice', 'Atributo', 'Corratribce', 'Safra', 'Propriedade', 'Mapaimagem', 'Propostareceituario'];

    function ConcentracaoindiceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Concentracaoindice, Atributo, Corratribce, Safra, Propriedade, Mapaimagem, Propostareceituario) {
        var vm = this;

        vm.concentracaoindice = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.atributos = Atributo.query();
        vm.corratribces = Corratribce.query();
        vm.safras = Safra.query();
        vm.propriedades = Propriedade.query();
        vm.mapaimagems = Mapaimagem.query();
        vm.propostareceituarios = Propostareceituario.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.concentracaoindice.id !== null) {
                Concentracaoindice.update(vm.concentracaoindice, onSaveSuccess, onSaveError);
            } else {
                Concentracaoindice.save(vm.concentracaoindice, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:concentracaoindiceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.data = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ConcentracaoindiceDetailController', ConcentracaoindiceDetailController);

    ConcentracaoindiceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Concentracaoindice', 'Atributo', 'Corratribce', 'Safra', 'Propriedade', 'Mapaimagem', 'Propostareceituario'];

    function ConcentracaoindiceDetailController($scope, $rootScope, $stateParams, previousState, entity, Concentracaoindice, Atributo, Corratribce, Safra, Propriedade, Mapaimagem, Propostareceituario) {
        var vm = this;

        vm.concentracaoindice = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:concentracaoindiceUpdate', function(event, result) {
            vm.concentracaoindice = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ConcentracaoindiceDeleteController',ConcentracaoindiceDeleteController);

    ConcentracaoindiceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Concentracaoindice'];

    function ConcentracaoindiceDeleteController($uibModalInstance, entity, Concentracaoindice) {
        var vm = this;

        vm.concentracaoindice = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Concentracaoindice.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('concentracaoindice', {
            parent: 'entity',
            url: '/concentracaoindice',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.concentracaoindice.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/concentracaoindice/concentracaoindices.html',
                    controller: 'ConcentracaoindiceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('concentracaoindice');
                    $translatePartialLoader.addPart('tipoindice');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('concentracaoindice-detail', {
            parent: 'concentracaoindice',
            url: '/concentracaoindice/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.concentracaoindice.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/concentracaoindice/concentracaoindice-detail.html',
                    controller: 'ConcentracaoindiceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('concentracaoindice');
                    $translatePartialLoader.addPart('tipoindice');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Concentracaoindice', function($stateParams, Concentracaoindice) {
                    return Concentracaoindice.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'concentracaoindice',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('concentracaoindice-detail.edit', {
            parent: 'concentracaoindice-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/concentracaoindice/concentracaoindice-dialog.html',
                    controller: 'ConcentracaoindiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Concentracaoindice', function(Concentracaoindice) {
                            return Concentracaoindice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('concentracaoindice.new', {
            parent: 'concentracaoindice',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/concentracaoindice/concentracaoindice-dialog.html',
                    controller: 'ConcentracaoindiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                data: null,
                                latitude: null,
                                longitude: null,
                                indice: null,
                                valorindice: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('concentracaoindice', null, { reload: 'concentracaoindice' });
                }, function() {
                    $state.go('concentracaoindice');
                });
            }]
        })
        .state('concentracaoindice.edit', {
            parent: 'concentracaoindice',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/concentracaoindice/concentracaoindice-dialog.html',
                    controller: 'ConcentracaoindiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Concentracaoindice', function(Concentracaoindice) {
                            return Concentracaoindice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('concentracaoindice', null, { reload: 'concentracaoindice' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('concentracaoindice.delete', {
            parent: 'concentracaoindice',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/concentracaoindice/concentracaoindice-delete-dialog.html',
                    controller: 'ConcentracaoindiceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Concentracaoindice', function(Concentracaoindice) {
                            return Concentracaoindice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('concentracaoindice', null, { reload: 'concentracaoindice' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Concentracaoindice', Concentracaoindice);

    Concentracaoindice.$inject = ['$resource', 'DateUtils'];

    function Concentracaoindice ($resource, DateUtils) {
        var resourceUrl =  'api/concentracaoindices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.data = DateUtils.convertLocalDateFromServer(data.data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.data = DateUtils.convertLocalDateToServer(copy.data);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.data = DateUtils.convertLocalDateToServer(copy.data);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('ConcentracaoindiceSearch', ConcentracaoindiceSearch);

    ConcentracaoindiceSearch.$inject = ['$resource'];

    function ConcentracaoindiceSearch($resource) {
        var resourceUrl =  'api/_search/concentracaoindices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ConcentracaoindiceController', ConcentracaoindiceController);

    ConcentracaoindiceController.$inject = ['Concentracaoindice', 'ConcentracaoindiceSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function ConcentracaoindiceController(Concentracaoindice, ConcentracaoindiceSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.concentracaoindices = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                ConcentracaoindiceSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Concentracaoindice.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.concentracaoindices.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.concentracaoindices = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.concentracaoindices = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.concentracaoindices = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ConcentracaoidealatributoDialogController', ConcentracaoidealatributoDialogController);

    ConcentracaoidealatributoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Concentracaoidealatributo', 'Cultura', 'Atributo', 'Propostareceituario', 'Cidade', 'Propriedade'];

    function ConcentracaoidealatributoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Concentracaoidealatributo, Cultura, Atributo, Propostareceituario, Cidade, Propriedade) {
        var vm = this;

        vm.concentracaoidealatributo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.culturas = Cultura.query();
        vm.atributos = Atributo.query();
        vm.propostareceituarios = Propostareceituario.query();
        vm.cidades = Cidade.query();
        vm.propriedades = Propriedade.query();
        vm.selecaoreferencia = selecaoreferencia;

        $scope.exibecidade = false;
        $scope.exibeprop = false;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function selecaoreferencia(){
            console.log("Hi");
            if(vm.concentracaoidealatributo.referencia === "cidade"){
                $scope.exibecidade = true;
                $scope.exibeprop = false;
            }
            else{
                $scope.exibecidade = false;
                $scope.exibeprop = true;
            }
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.concentracaoidealatributo.id !== null) {
                Concentracaoidealatributo.update(vm.concentracaoidealatributo, onSaveSuccess, onSaveError);
            } else {
                Concentracaoidealatributo.save(vm.concentracaoidealatributo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:concentracaoidealatributoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ConcentracaoidealatributoDetailController', ConcentracaoidealatributoDetailController);

    ConcentracaoidealatributoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Concentracaoidealatributo', 'Cultura', 'Atributo', 'Propostareceituario', 'Cidade', 'Propriedade'];

    function ConcentracaoidealatributoDetailController($scope, $rootScope, $stateParams, previousState, entity, Concentracaoidealatributo, Cultura, Atributo, Propostareceituario, Cidade, Propriedade) {
        var vm = this;

        vm.concentracaoidealatributo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:concentracaoidealatributoUpdate', function(event, result) {
            vm.concentracaoidealatributo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ConcentracaoidealatributoDeleteController',ConcentracaoidealatributoDeleteController);

    ConcentracaoidealatributoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Concentracaoidealatributo'];

    function ConcentracaoidealatributoDeleteController($uibModalInstance, entity, Concentracaoidealatributo) {
        var vm = this;

        vm.concentracaoidealatributo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Concentracaoidealatributo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('concentracaoidealatributo', {
            parent: 'entity',
            url: '/concentracaoidealatributo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.concentracaoidealatributo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/concentracaoidealatributo/concentracaoidealatributos.html',
                    controller: 'ConcentracaoidealatributoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('concentracaoidealatributo');
                    $translatePartialLoader.addPart('tiporeferenciaatributo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('concentracaoidealatributo-detail', {
            parent: 'concentracaoidealatributo',
            url: '/concentracaoidealatributo/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.concentracaoidealatributo.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/concentracaoidealatributo/concentracaoidealatributo-detail.html',
                    controller: 'ConcentracaoidealatributoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('concentracaoidealatributo');
                    $translatePartialLoader.addPart('tiporeferenciaatributo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Concentracaoidealatributo', function($stateParams, Concentracaoidealatributo) {
                    return Concentracaoidealatributo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'concentracaoidealatributo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('concentracaoidealatributo-detail.edit', {
            parent: 'concentracaoidealatributo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/concentracaoidealatributo/concentracaoidealatributo-dialog.html',
                    controller: 'ConcentracaoidealatributoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Concentracaoidealatributo', function(Concentracaoidealatributo) {
                            return Concentracaoidealatributo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('concentracaoidealatributo.new', {
            parent: 'concentracaoidealatributo',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/concentracaoidealatributo/concentracaoidealatributo-dialog.html',
                    controller: 'ConcentracaoidealatributoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                valorconcentracaoatributo: null,
                                referencia: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('concentracaoidealatributo', null, { reload: 'concentracaoidealatributo' });
                }, function() {
                    $state.go('concentracaoidealatributo');
                });
            }]
        })
        .state('concentracaoidealatributo.edit', {
            parent: 'concentracaoidealatributo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/concentracaoidealatributo/concentracaoidealatributo-dialog.html',
                    controller: 'ConcentracaoidealatributoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Concentracaoidealatributo', function(Concentracaoidealatributo) {
                            return Concentracaoidealatributo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('concentracaoidealatributo', null, { reload: 'concentracaoidealatributo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('concentracaoidealatributo.delete', {
            parent: 'concentracaoidealatributo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/concentracaoidealatributo/concentracaoidealatributo-delete-dialog.html',
                    controller: 'ConcentracaoidealatributoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Concentracaoidealatributo', function(Concentracaoidealatributo) {
                            return Concentracaoidealatributo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('concentracaoidealatributo', null, { reload: 'concentracaoidealatributo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Concentracaoidealatributo', Concentracaoidealatributo);

    Concentracaoidealatributo.$inject = ['$resource'];

    function Concentracaoidealatributo ($resource) {
        var resourceUrl =  'api/concentracaoidealatributos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('ConcentracaoidealatributoSearch', ConcentracaoidealatributoSearch);

    ConcentracaoidealatributoSearch.$inject = ['$resource'];

    function ConcentracaoidealatributoSearch($resource) {
        var resourceUrl =  'api/_search/concentracaoidealatributos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ConcentracaoidealatributoController', ConcentracaoidealatributoController);

    ConcentracaoidealatributoController.$inject = ['Concentracaoidealatributo', 'ConcentracaoidealatributoSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function ConcentracaoidealatributoController(Concentracaoidealatributo, ConcentracaoidealatributoSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.concentracaoidealatributos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                ConcentracaoidealatributoSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Concentracaoidealatributo.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.concentracaoidealatributos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.concentracaoidealatributos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.concentracaoidealatributos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.concentracaoidealatributos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ComparativoDialogController', ComparativoDialogController);

    ComparativoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Comparativo'];

    function ComparativoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Comparativo) {
        var vm = this;

        vm.comparativo = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.comparativo.id !== null) {
                Comparativo.update(vm.comparativo, onSaveSuccess, onSaveError);
            } else {
                Comparativo.save(vm.comparativo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:comparativoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ComparativoDetailController', ComparativoDetailController);

    ComparativoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Comparativo'];

    function ComparativoDetailController($scope, $rootScope, $stateParams, previousState, entity, Comparativo) {
        var vm = this;

        vm.comparativo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:comparativoUpdate', function(event, result) {
            vm.comparativo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ComparativoDeleteController',ComparativoDeleteController);

    ComparativoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Comparativo'];

    function ComparativoDeleteController($uibModalInstance, entity, Comparativo) {
        var vm = this;

        vm.comparativo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Comparativo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('comparativo', {
            parent: 'entity',
            url: '/comparativo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.comparativo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/comparativo/comparativos.html',
                    controller: 'ComparativoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('comparativo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('comparativo-en', {
            parent: 'entity',
            url: '/comparativo-en',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.comparativo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/comparativo/comparativos-en.html',
                    controller: 'ComparativoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('comparativo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('comparativo-es', {
            parent: 'entity',
            url: '/comparativo-es',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.comparativo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/comparativo/comparativos-es.html',
                    controller: 'ComparativoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('comparativo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('comparativo-detail', {
            parent: 'comparativo',
            url: '/comparativo/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.comparativo.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/comparativo/comparativo-detail.html',
                    controller: 'ComparativoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('comparativo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Comparativo', function($stateParams, Comparativo) {
                    return Comparativo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'comparativo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('comparativo-detail.edit', {
            parent: 'comparativo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comparativo/comparativo-dialog.html',
                    controller: 'ComparativoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Comparativo', function(Comparativo) {
                            return Comparativo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('comparativo.new', {
            parent: 'comparativo',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comparativo/comparativo-dialog.html',
                    controller: 'ComparativoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('comparativo', null, { reload: 'comparativo' });
                }, function() {
                    $state.go('comparativo');
                });
            }]
        })
        .state('comparativo.edit', {
            parent: 'comparativo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comparativo/comparativo-dialog.html',
                    controller: 'ComparativoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Comparativo', function(Comparativo) {
                            return Comparativo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('comparativo', null, { reload: 'comparativo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('comparativo.delete', {
            parent: 'comparativo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comparativo/comparativo-delete-dialog.html',
                    controller: 'ComparativoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Comparativo', function(Comparativo) {
                            return Comparativo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('comparativo', null, { reload: 'comparativo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Comparativo', Comparativo);

    Comparativo.$inject = ['$resource'];

    function Comparativo ($resource) {
        var resourceUrl =  'api/comparativos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('ComparativoSearch', ComparativoSearch);

    ComparativoSearch.$inject = ['$resource'];

    function ComparativoSearch($resource) {
        var resourceUrl =  'api/_search/comparativos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ComparativoController', ComparativoController);

    ComparativoController.$inject = ['Comparativo', 'ComparativoSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function ComparativoController(Comparativo, ComparativoSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.comparativos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        //loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                ComparativoSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Comparativo.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.comparativos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.comparativos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.comparativos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.comparativos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ComercializacaotestemDialogController', ComercializacaotestemDialogController);

    ComercializacaotestemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Comercializacaotestem', 'Etapa', 'Safra', '$q'];

    function ComercializacaotestemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Comercializacaotestem, Etapa, Safra, $q) {
        var vm = this;

        vm.comercializacaotestem = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.etapas = Etapa.query();

        vm.safras = Safra.query({filter: 'comercializacaotestem-is-null'});
        $q.all([vm.comercializacaotestem.$promise, vm.safras.$promise]).then(function() {
            if (!vm.comercializacaotestem.safra || !vm.comercializacaotestem.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.comercializacaotestem.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "comercializacaotestem";
            vm.etapa.safra = vm.comercializacaotestem.safra;
            
            if (vm.comercializacaotestem.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
              
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:comercializacaotestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.comercializacaotestem.etapa = new Etapa();
            vm.comercializacaotestem.etapa = result;
            Comercializacaotestem.save(vm.comercializacaotestem, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:comercializacaotestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.comercializacaotestem.etapa = new Etapa();
            vm.comercializacaotestem.etapa = result;
            Comercializacaotestem.update(vm.comercializacaotestem, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:comercializacaotestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.data = false;
        vm.datePickerOpenStatus.datafim = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ComercializacaotestemDetailController', ComercializacaotestemDetailController);

    ComercializacaotestemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Comercializacaotestem', 'Etapa', 'Atividade'];

    function ComercializacaotestemDetailController($scope, $rootScope, $stateParams, previousState, entity, Comercializacaotestem, Etapa, Atividade) {
        var vm = this;

        vm.comercializacaotestem = entity;
        vm.previousState = previousState.name;

        vm.atividades = [];

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.comercializacaotestem.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        }


        var unsubscribe = $rootScope.$on('netWordAgroApp:comercializacaotestemUpdate', function(event, result) {
            vm.comercializacaotestem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ComercializacaotestemDeleteController',ComercializacaotestemDeleteController);

    ComercializacaotestemDeleteController.$inject = ['$uibModalInstance', 'entity', 'Comercializacaotestem', 'Etapa'];

    function ComercializacaotestemDeleteController($uibModalInstance, entity, Comercializacaotestem, Etapa) {
        var vm = this;

        vm.comercializacaotestem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Comercializacaotestem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    Etapa.delete({id: vm.comercializacaotestem.etapa.id},
                        function () {
                            $uibModalInstance.close(true);
                        });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('comercializacaotestem', {
            parent: 'entity',
            url: '/comercializacaotestem',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.comercializacaotestem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/comercializacaotestem/comercializacaotestems.html',
                    controller: 'ComercializacaotestemController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('comercializacaotestem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('comercializacaotestem-detail', {
            parent: 'comercializacaotestem',
            url: '/comercializacaotestem/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.comercializacaotestem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/comercializacaotestem/comercializacaotestem-detail.html',
                    controller: 'ComercializacaotestemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('comercializacaotestem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Comercializacaotestem', function($stateParams, Comercializacaotestem) {
                    return Comercializacaotestem.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'comercializacaotestem',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('comercializacaotestem-detail.edit', {
            parent: 'comercializacaotestem-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comercializacaotestem/comercializacaotestem-dialog.html',
                    controller: 'ComercializacaotestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Comercializacaotestem', function(Comercializacaotestem) {
                            return Comercializacaotestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('comercializacaotestem.new', {
            parent: 'comercializacaotestem',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comercializacaotestem/comercializacaotestem-dialog.html',
                    controller: 'ComercializacaotestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                data: null,
                                datafim: null,
                                quantidadevendida: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('comercializacaotestem', null, { reload: 'comercializacaotestem' });
                }, function() {
                    $state.go('comercializacaotestem');
                });
            }]
        })
        .state('comercializacaotestem.edit', {
            parent: 'comercializacaotestem',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comercializacaotestem/comercializacaotestem-dialog.html',
                    controller: 'ComercializacaotestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Comercializacaotestem', function(Comercializacaotestem) {
                            return Comercializacaotestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('comercializacaotestem', null, { reload: 'comercializacaotestem' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('comercializacaotestem.delete', {
            parent: 'comercializacaotestem',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comercializacaotestem/comercializacaotestem-delete-dialog.html',
                    controller: 'ComercializacaotestemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Comercializacaotestem', function(Comercializacaotestem) {
                            return Comercializacaotestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('comercializacaotestem', null, { reload: 'comercializacaotestem' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Comercializacaotestem', Comercializacaotestem);

    Comercializacaotestem.$inject = ['$resource', 'DateUtils'];

    function Comercializacaotestem ($resource, DateUtils) {
        var resourceUrl =  'api/comercializacaotestems/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.data = DateUtils.convertLocalDateFromServer(data.data);
                        data.datafim = DateUtils.convertLocalDateFromServer(data.datafim);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.data = DateUtils.convertLocalDateToServer(copy.data);
                    copy.datafim = DateUtils.convertLocalDateToServer(copy.datafim);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.data = DateUtils.convertLocalDateToServer(copy.data);
                    copy.datafim = DateUtils.convertLocalDateToServer(copy.datafim);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('ComercializacaotestemSearch', ComercializacaotestemSearch);

    ComercializacaotestemSearch.$inject = ['$resource'];

    function ComercializacaotestemSearch($resource) {
        var resourceUrl =  'api/_search/comercializacaotestems/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ComercializacaotestemController', ComercializacaotestemController);

    ComercializacaotestemController.$inject = ['Comercializacaotestem', 'ComercializacaotestemSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function ComercializacaotestemController(Comercializacaotestem, ComercializacaotestemSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.comercializacaotestems = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                ComercializacaotestemSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Comercializacaotestem.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.comercializacaotestems.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.comercializacaotestems = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.comercializacaotestems = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.comercializacaotestems = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ComercializacaoplanDialogController', ComercializacaoplanDialogController);

    ComercializacaoplanDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Comercializacaoplan', 'Safra', 'Etapa', 'Principal'];

    function ComercializacaoplanDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Comercializacaoplan, Safra, Etapa, Principal) {
        var vm = this;

        vm.comercializacaoplan = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.safras = Safra.query({filter: 'comercializacaoplan-is-null'});
        $q.all([vm.comercializacaoplan.$promise, vm.safras.$promise]).then(function() {
            if (!vm.comercializacaoplan.safra || !vm.comercializacaoplan.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.comercializacaoplan.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });
        vm.etapas = Etapa.query();

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "comercializacaoplan";
            vm.etapa.safra = vm.comercializacaoplan.safra;
            
            if (vm.comercializacaoplan.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
                Principal.identity().then(function (user) {
                    var data = {
                      user: user
                    };
                    vm.comercializacaoplan.criador = user.login;
                });
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.comercializacaoplan.etapa = new Etapa();
            vm.comercializacaoplan.etapa = result;
            Comercializacaoplan.save(vm.comercializacaoplan, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.comercializacaoplan.etapa = new Etapa();
            vm.comercializacaoplan.etapa = result;
            Comercializacaoplan.update(vm.comercializacaoplan, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:comercializacaoplanUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datainicio = false;
        vm.datePickerOpenStatus.datatermino = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ComercializacaoplanDetailController', ComercializacaoplanDetailController);

    ComercializacaoplanDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Comercializacaoplan', 'Safra', 'Etapa', 'Atividade'];

    function ComercializacaoplanDetailController($scope, $rootScope, $stateParams, previousState, entity, Comercializacaoplan, Safra, Etapa, Atividade) {
        var vm = this;

        vm.comercializacaoplan = entity;
        vm.previousState = previousState.name;

        vm.atividades = [];

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.comercializacaoplan.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        }

        var unsubscribe = $rootScope.$on('netWordAgroApp:comercializacaoplanUpdate', function(event, result) {
            vm.comercializacaoplan = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ComercializacaoplanDeleteController',ComercializacaoplanDeleteController);

    ComercializacaoplanDeleteController.$inject = ['$uibModalInstance', 'entity', 'Comercializacaoplan', 'Etapa'];

    function ComercializacaoplanDeleteController($uibModalInstance, entity, Comercializacaoplan, Etapa) {
        var vm = this;

        vm.comercializacaoplan = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Comercializacaoplan.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    Etapa.delete({id: vm.comercializacaoplan.etapa.id},
                        function () {
                            $uibModalInstance.close(true);
                        });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('comercializacaoplan', {
            parent: 'entity',
            url: '/comercializacaoplan',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.comercializacaoplan.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/comercializacaoplan/comercializacaoplans.html',
                    controller: 'ComercializacaoplanController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('comercializacaoplan');
                    $translatePartialLoader.addPart('tipomedidacomercio');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('comercializacaoplan-detail', {
            parent: 'comercializacaoplan',
            url: '/comercializacaoplan/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.comercializacaoplan.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/comercializacaoplan/comercializacaoplan-detail.html',
                    controller: 'ComercializacaoplanDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('comercializacaoplan');
                    $translatePartialLoader.addPart('tipomedidacomercio');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Comercializacaoplan', function($stateParams, Comercializacaoplan) {
                    return Comercializacaoplan.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'comercializacaoplan',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('comercializacaoplan-detail.edit', {
            parent: 'comercializacaoplan-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comercializacaoplan/comercializacaoplan-dialog.html',
                    controller: 'ComercializacaoplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Comercializacaoplan', function(Comercializacaoplan) {
                            return Comercializacaoplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('comercializacaoplan.new', {
            parent: 'comercializacaoplan',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comercializacaoplan/comercializacaoplan-dialog.html',
                    controller: 'ComercializacaoplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                datainicio: null,
                                datatermino: null,
                                quantidadevendida: null,
                                unidademedida: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('comercializacaoplan', null, { reload: 'comercializacaoplan' });
                }, function() {
                    $state.go('comercializacaoplan');
                });
            }]
        })
        .state('comercializacaoplan.edit', {
            parent: 'comercializacaoplan',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comercializacaoplan/comercializacaoplan-dialog.html',
                    controller: 'ComercializacaoplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Comercializacaoplan', function(Comercializacaoplan) {
                            return Comercializacaoplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('comercializacaoplan', null, { reload: 'comercializacaoplan' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('comercializacaoplan.delete', {
            parent: 'comercializacaoplan',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comercializacaoplan/comercializacaoplan-delete-dialog.html',
                    controller: 'ComercializacaoplanDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Comercializacaoplan', function(Comercializacaoplan) {
                            return Comercializacaoplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('comercializacaoplan', null, { reload: 'comercializacaoplan' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Comercializacaoplan', Comercializacaoplan);

    Comercializacaoplan.$inject = ['$resource', 'DateUtils'];

    function Comercializacaoplan ($resource, DateUtils) {
        var resourceUrl =  'api/comercializacaoplans/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datainicio = DateUtils.convertLocalDateFromServer(data.datainicio);
                        data.datatermino = DateUtils.convertLocalDateFromServer(data.datatermino);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('ComercializacaoplanSearch', ComercializacaoplanSearch);

    ComercializacaoplanSearch.$inject = ['$resource'];

    function ComercializacaoplanSearch($resource) {
        var resourceUrl =  'api/_search/comercializacaoplans/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ComercializacaoplanController', ComercializacaoplanController);

    ComercializacaoplanController.$inject = ['Comercializacaoplan', 'ComercializacaoplanSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function ComercializacaoplanController(Comercializacaoplan, ComercializacaoplanSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.comercializacaoplans = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                ComercializacaoplanSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Comercializacaoplan.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.comercializacaoplans.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.comercializacaoplans = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.comercializacaoplans = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.comercializacaoplans = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ComercializacaoDialogController', ComercializacaoDialogController);

    ComercializacaoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Comercializacao', 'Safra', 'Etapa', 'Atividade', 'Principal'];

    function ComercializacaoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Comercializacao, Safra, Etapa, Atividade, Principal) {
        var vm = this;

        vm.comercializacao = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.safras = Safra.query({filter: 'comercializacao-is-null'});
        $q.all([vm.comercializacao.$promise, vm.safras.$promise]).then(function() {
            if (!vm.comercializacao.safra || !vm.comercializacao.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.comercializacao.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });
        vm.etapas = Etapa.query();

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "comercializacao";
            vm.etapa.safra = vm.comercializacao.safra;
            
            if (vm.comercializacao.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
                Principal.identity().then(function (user) {
                    var data = {
                      user: user
                    };
                    vm.comercializacao.criador = user.login;
                });
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.comercializacao.etapa = new Etapa();
            vm.comercializacao.etapa = result;
            Comercializacao.save(vm.comercializacao, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.comercializacao.etapa = new Etapa();
            vm.comercializacao.etapa = result;
            Comercializacao.update(vm.comercializacao, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:comercializacaoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datainicio = false;
        vm.datePickerOpenStatus.datatermino = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ComercializacaoDetailController', ComercializacaoDetailController);

    ComercializacaoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Comercializacao', 'Safra', 'Etapa', 'Atividade'];

    function ComercializacaoDetailController($scope, $rootScope, $stateParams, previousState, entity, Comercializacao, Safra, Etapa, Atividade) {
        var vm = this;

        vm.comercializacao = entity;
        vm.previousState = previousState.name;

        vm.atividades = [];

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.comercializacao.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        }

        var unsubscribe = $rootScope.$on('netWordAgroApp:comercializacaoUpdate', function(event, result) {
            vm.comercializacao = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ComercializacaoDeleteController',ComercializacaoDeleteController);

    ComercializacaoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Comercializacao', 'Etapa'];

    function ComercializacaoDeleteController($uibModalInstance, entity, Comercializacao, Etapa) {
        var vm = this;

        vm.comercializacao = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Comercializacao.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    Etapa.delete({id: vm.comercializacao.etapa.id},
                        function () {
                            $uibModalInstance.close(true);
                        });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('comercializacao', {
            parent: 'entity',
            url: '/comercializacao',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.comercializacao.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/comercializacao/comercializacaos.html',
                    controller: 'ComercializacaoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('comercializacao');
                    $translatePartialLoader.addPart('tipomedidacomercio');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('comercializacao-detail', {
            parent: 'comercializacao',
            url: '/comercializacao/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.comercializacao.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/comercializacao/comercializacao-detail.html',
                    controller: 'ComercializacaoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('comercializacao');
                    $translatePartialLoader.addPart('tipomedidacomercio');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Comercializacao', function($stateParams, Comercializacao) {
                    return Comercializacao.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'comercializacao',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('comercializacao-detail.edit', {
            parent: 'comercializacao-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comercializacao/comercializacao-dialog.html',
                    controller: 'ComercializacaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Comercializacao', function(Comercializacao) {
                            return Comercializacao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('comercializacao.new', {
            parent: 'comercializacao',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comercializacao/comercializacao-dialog.html',
                    controller: 'ComercializacaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                datainicio: null,
                                datatermino: null,
                                quantidadevendida: null,
                                unidadedemedida: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('comercializacao', null, { reload: 'comercializacao' });
                }, function() {
                    $state.go('comercializacao');
                });
            }]
        })
        .state('comercializacao.edit', {
            parent: 'comercializacao',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comercializacao/comercializacao-dialog.html',
                    controller: 'ComercializacaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Comercializacao', function(Comercializacao) {
                            return Comercializacao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('comercializacao', null, { reload: 'comercializacao' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('comercializacao.delete', {
            parent: 'comercializacao',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comercializacao/comercializacao-delete-dialog.html',
                    controller: 'ComercializacaoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Comercializacao', function(Comercializacao) {
                            return Comercializacao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('comercializacao', null, { reload: 'comercializacao' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Comercializacao', Comercializacao);

    Comercializacao.$inject = ['$resource', 'DateUtils'];

    function Comercializacao ($resource, DateUtils) {
        var resourceUrl =  'api/comercializacaos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datainicio = DateUtils.convertLocalDateFromServer(data.datainicio);
                        data.datatermino = DateUtils.convertLocalDateFromServer(data.datatermino);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('ComercializacaoSearch', ComercializacaoSearch);

    ComercializacaoSearch.$inject = ['$resource'];

    function ComercializacaoSearch($resource) {
        var resourceUrl =  'api/_search/comercializacaos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ComercializacaoController', ComercializacaoController);

    ComercializacaoController.$inject = ['Comercializacao', 'ComercializacaoSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function ComercializacaoController(Comercializacao, ComercializacaoSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.comercializacaos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                ComercializacaoSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Comercializacao.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.comercializacaos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.comercializacaos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.comercializacaos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.comercializacaos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ColheitatestemDialogController', ColheitatestemDialogController);

    ColheitatestemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Colheitatestem', 'Etapa', 'Safra', '$q'];

    function ColheitatestemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Colheitatestem, Etapa, Safra, $q) {
        var vm = this;


        vm.colheitatestem = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.etapas = Etapa.query();

        vm.safras = Safra.query({filter: 'colheitatestem-is-null'});
        $q.all([vm.colheitatestem.$promise, vm.safras.$promise]).then(function() {
            if (!vm.colheitatestem.safra || !vm.colheitatestem.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.colheitatestem.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "colheitatestem";
            vm.etapa.safra = vm.colheitatestem.safra;
            
            if (vm.colheitatestem.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);
            } else {
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:colheitatestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.colheitatestem.etapa = new Etapa();
            vm.colheitatestem.etapa = result;
            Colheitatestem.save(vm.colheitatestem, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:colheitatestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.colheitatestem.etapa = new Etapa();
            vm.colheitatestem.etapa = result;
            Colheitatestem.update(vm.colheitatestem, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:colheitatestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datainicio = false;
        vm.datePickerOpenStatus.datafim = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ColheitatestemDetailController', ColheitatestemDetailController);

    ColheitatestemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Colheitatestem', 'Etapa'];

    function ColheitatestemDetailController($scope, $rootScope, $stateParams, previousState, entity, Colheitatestem, Etapa) {
        var vm = this;

        vm.colheitatestem = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:colheitatestemUpdate', function(event, result) {
            vm.colheitatestem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ColheitatestemDeleteController',ColheitatestemDeleteController);

    ColheitatestemDeleteController.$inject = ['$uibModalInstance', 'entity', 'Colheitatestem', 'Etapa'];

    function ColheitatestemDeleteController($uibModalInstance, entity, Colheitatestem, Etapa) {
        var vm = this;

        vm.colheitatestem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Colheitatestem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    Etapa.delete({id: vm.colheitatestem.etapa.id},
                        function () {
                            $uibModalInstance.close(true);
                        });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('colheitatestem', {
            parent: 'entity',
            url: '/colheitatestem',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.colheitatestem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/colheitatestem/colheitatestems.html',
                    controller: 'ColheitatestemController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('colheitatestem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('colheitatestem-detail', {
            parent: 'colheitatestem',
            url: '/colheitatestem/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.colheitatestem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/colheitatestem/colheitatestem-detail.html',
                    controller: 'ColheitatestemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('colheitatestem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Colheitatestem', function($stateParams, Colheitatestem) {
                    return Colheitatestem.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'colheitatestem',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('colheitatestem-detail.edit', {
            parent: 'colheitatestem-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/colheitatestem/colheitatestem-dialog.html',
                    controller: 'ColheitatestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Colheitatestem', function(Colheitatestem) {
                            return Colheitatestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('colheitatestem.new', {
            parent: 'colheitatestem',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/colheitatestem/colheitatestem-dialog.html',
                    controller: 'ColheitatestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                datainicio: null,
                                datafim: null,
                                areacolhida: null,
                                quantidadecolhida: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('colheitatestem', null, { reload: 'colheitatestem' });
                }, function() {
                    $state.go('colheitatestem');
                });
            }]
        })
        .state('colheitatestem.edit', {
            parent: 'colheitatestem',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/colheitatestem/colheitatestem-dialog.html',
                    controller: 'ColheitatestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Colheitatestem', function(Colheitatestem) {
                            return Colheitatestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('colheitatestem', null, { reload: 'colheitatestem' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('colheitatestem.delete', {
            parent: 'colheitatestem',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/colheitatestem/colheitatestem-delete-dialog.html',
                    controller: 'ColheitatestemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Colheitatestem', function(Colheitatestem) {
                            return Colheitatestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('colheitatestem', null, { reload: 'colheitatestem' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Colheitatestem', Colheitatestem);

    Colheitatestem.$inject = ['$resource', 'DateUtils'];

    function Colheitatestem ($resource, DateUtils) {
        var resourceUrl =  'api/colheitatestems/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datainicio = DateUtils.convertLocalDateFromServer(data.datainicio);
                        data.datafim = DateUtils.convertLocalDateFromServer(data.datafim);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datafim = DateUtils.convertLocalDateToServer(copy.datafim);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datafim = DateUtils.convertLocalDateToServer(copy.datafim);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('ColheitatestemSearch', ColheitatestemSearch);

    ColheitatestemSearch.$inject = ['$resource'];

    function ColheitatestemSearch($resource) {
        var resourceUrl =  'api/_search/colheitatestems/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ColheitatestemController', ColheitatestemController);

    ColheitatestemController.$inject = ['Colheitatestem', 'ColheitatestemSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function ColheitatestemController(Colheitatestem, ColheitatestemSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.colheitatestems = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                ColheitatestemSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Colheitatestem.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.colheitatestems.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.colheitatestems = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.colheitatestems = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.colheitatestems = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ColheitaplanDialogController', ColheitaplanDialogController);

    ColheitaplanDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Colheitaplan', 'Safra', 'Etapa', 'Principal'];

    function ColheitaplanDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Colheitaplan, Safra, Etapa, Principal) {
        var vm = this;

        vm.colheitaplan = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.safras = Safra.query({filter: 'colheitaplan-is-null'});
        $q.all([vm.colheitaplan.$promise, vm.safras.$promise]).then(function() {
            if (!vm.colheitaplan.safra || !vm.colheitaplan.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.colheitaplan.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });
        vm.etapas = Etapa.query();

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "colheitaplan";
            vm.etapa.safra = vm.colheitaplan.safra;
            
            if (vm.colheitaplan.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
                Principal.identity().then(function (user) {
                    var data = {
                      user: user
                    };
                    vm.colheitaplan.criador = user.login;
                });
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.colheitaplan.etapa = new Etapa();
            vm.colheitaplan.etapa = result;
            Colheitaplan.save(vm.colheitaplan, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.colheitaplan.etapa = new Etapa();
            vm.colheitaplan.etapa = result;
            Colheitaplan.update(vm.colheitaplan, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }
        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:colheitaplanUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datainicio = false;
        vm.datePickerOpenStatus.datatermino = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ColheitaplanDetailController', ColheitaplanDetailController);

    ColheitaplanDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Colheitaplan', 'Safra', 'Etapa', 'Atividade'];

    function ColheitaplanDetailController($scope, $rootScope, $stateParams, previousState, entity, Colheitaplan, Safra, Etapa, Atividade) {
        var vm = this;

        vm.colheitaplan = entity;
        vm.previousState = previousState.name;

        vm.atividades = [];

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.colheitaplan.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        }

        var unsubscribe = $rootScope.$on('netWordAgroApp:colheitaplanUpdate', function(event, result) {
            vm.colheitaplan = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ColheitaplanDeleteController',ColheitaplanDeleteController);

    ColheitaplanDeleteController.$inject = ['$uibModalInstance', 'entity', 'Colheitaplan', 'Etapa'];

    function ColheitaplanDeleteController($uibModalInstance, entity, Colheitaplan, Etapa) {
        var vm = this;

        vm.colheitaplan = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Colheitaplan.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    Etapa.delete({id: vm.colheitaplan.etapa.id},
                        function () {
                            $uibModalInstance.close(true);
                        });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('colheitaplan', {
            parent: 'entity',
            url: '/colheitaplan',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.colheitaplan.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/colheitaplan/colheitaplans.html',
                    controller: 'ColheitaplanController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('colheitaplan');
                    $translatePartialLoader.addPart('tipomedidaarea');
                    $translatePartialLoader.addPart('tipomedidacolheita');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('colheitaplan-detail', {
            parent: 'colheitaplan',
            url: '/colheitaplan/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.colheitaplan.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/colheitaplan/colheitaplan-detail.html',
                    controller: 'ColheitaplanDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('colheitaplan');
                    $translatePartialLoader.addPart('tipomedidaarea');
                    $translatePartialLoader.addPart('tipomedidacolheita');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Colheitaplan', function($stateParams, Colheitaplan) {
                    return Colheitaplan.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'colheitaplan',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('colheitaplan-detail.edit', {
            parent: 'colheitaplan-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/colheitaplan/colheitaplan-dialog.html',
                    controller: 'ColheitaplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Colheitaplan', function(Colheitaplan) {
                            return Colheitaplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('colheitaplan.new', {
            parent: 'colheitaplan',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/colheitaplan/colheitaplan-dialog.html',
                    controller: 'ColheitaplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                datainicio: null,
                                datatermino: null,
                                areacolhida: null,
                                unidademedidaarea: null,
                                quantidadecolhida: null,
                                unidademedidacolheita: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('colheitaplan', null, { reload: 'colheitaplan' });
                }, function() {
                    $state.go('colheitaplan');
                });
            }]
        })
        .state('colheitaplan.edit', {
            parent: 'colheitaplan',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/colheitaplan/colheitaplan-dialog.html',
                    controller: 'ColheitaplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Colheitaplan', function(Colheitaplan) {
                            return Colheitaplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('colheitaplan', null, { reload: 'colheitaplan' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('colheitaplan.delete', {
            parent: 'colheitaplan',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/colheitaplan/colheitaplan-delete-dialog.html',
                    controller: 'ColheitaplanDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Colheitaplan', function(Colheitaplan) {
                            return Colheitaplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('colheitaplan', null, { reload: 'colheitaplan' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Colheitaplan', Colheitaplan);

    Colheitaplan.$inject = ['$resource', 'DateUtils'];

    function Colheitaplan ($resource, DateUtils) {
        var resourceUrl =  'api/colheitaplans/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datainicio = DateUtils.convertLocalDateFromServer(data.datainicio);
                        data.datatermino = DateUtils.convertLocalDateFromServer(data.datatermino);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('ColheitaplanSearch', ColheitaplanSearch);

    ColheitaplanSearch.$inject = ['$resource'];

    function ColheitaplanSearch($resource) {
        var resourceUrl =  'api/_search/colheitaplans/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ColheitaplanController', ColheitaplanController);

    ColheitaplanController.$inject = ['Colheitaplan', 'ColheitaplanSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function ColheitaplanController(Colheitaplan, ColheitaplanSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.colheitaplans = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                ColheitaplanSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Colheitaplan.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.colheitaplans.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.colheitaplans = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.colheitaplans = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.colheitaplans = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ColheitaDialogController', ColheitaDialogController);

    ColheitaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Colheita', 'Safra', 'Etapa', 'Principal'];

    function ColheitaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Colheita, Safra, Etapa, Principal) {
        var vm = this;

        vm.colheita = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.safras = Safra.query({filter: 'colheita-is-null'});
        $q.all([vm.colheita.$promise, vm.safras.$promise]).then(function() {
            if (!vm.colheita.safra || !vm.colheita.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.colheita.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });
        vm.etapas = Etapa.query();

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "colheita";
            vm.etapa.safra = vm.colheita.safra;
            
            if (vm.colheita.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
                Principal.identity().then(function (user) {
                    var data = {
                      user: user
                    };
                    vm.colheita.criador = user.login;
                });
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.colheita.etapa = new Etapa();
            vm.colheita.etapa = result;
            Colheita.save(vm.colheita, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.colheita.etapa = new Etapa();
            vm.colheita.etapa = result;
            Colheita.update(vm.colheita, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:colheitaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datainicio = false;
        vm.datePickerOpenStatus.datatermino = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ColheitaDetailController', ColheitaDetailController);

    ColheitaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Colheita', 'Safra', 'Etapa', 'Atividade'];

    function ColheitaDetailController($scope, $rootScope, $stateParams, previousState, entity, Colheita, Safra, Etapa, Atividade) {
        var vm = this;

        vm.colheita = entity;
        vm.previousState = previousState.name;

        vm.atividades = [];

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.colheita.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        }

        var unsubscribe = $rootScope.$on('netWordAgroApp:colheitaUpdate', function(event, result) {
            vm.colheita = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ColheitaDeleteController',ColheitaDeleteController);

    ColheitaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Colheita'];

    function ColheitaDeleteController($uibModalInstance, entity, Colheita) {
        var vm = this;

        vm.colheita = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Colheita.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('colheita', {
            parent: 'entity',
            url: '/colheita',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.colheita.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/colheita/colheitas.html',
                    controller: 'ColheitaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('colheita');
                    $translatePartialLoader.addPart('tipomedidaarea');
                    $translatePartialLoader.addPart('tipomedidacolheita');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('colheita-detail', {
            parent: 'colheita',
            url: '/colheita/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.colheita.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/colheita/colheita-detail.html',
                    controller: 'ColheitaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('colheita');
                    $translatePartialLoader.addPart('tipomedidaarea');
                    $translatePartialLoader.addPart('tipomedidacolheita');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Colheita', function($stateParams, Colheita) {
                    return Colheita.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'colheita',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('colheita-detail.edit', {
            parent: 'colheita-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/colheita/colheita-dialog.html',
                    controller: 'ColheitaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Colheita', function(Colheita) {
                            return Colheita.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('colheita.new', {
            parent: 'colheita',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/colheita/colheita-dialog.html',
                    controller: 'ColheitaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                datainicio: null,
                                datatermino: null,
                                areacolhida: null,
                                unidademedidaarea: null,
                                quantidadecolhida: null,
                                unidademedidacolheita: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('colheita', null, { reload: 'colheita' });
                }, function() {
                    $state.go('colheita');
                });
            }]
        })
        .state('colheita.edit', {
            parent: 'colheita',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/colheita/colheita-dialog.html',
                    controller: 'ColheitaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Colheita', function(Colheita) {
                            return Colheita.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('colheita', null, { reload: 'colheita' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('colheita.delete', {
            parent: 'colheita',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/colheita/colheita-delete-dialog.html',
                    controller: 'ColheitaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Colheita', function(Colheita) {
                            return Colheita.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('colheita', null, { reload: 'colheita' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Colheita', Colheita);

    Colheita.$inject = ['$resource', 'DateUtils'];

    function Colheita ($resource, DateUtils) {
        var resourceUrl =  'api/colheitas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datainicio = DateUtils.convertLocalDateFromServer(data.datainicio);
                        data.datatermino = DateUtils.convertLocalDateFromServer(data.datatermino);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('ColheitaSearch', ColheitaSearch);

    ColheitaSearch.$inject = ['$resource'];

    function ColheitaSearch($resource) {
        var resourceUrl =  'api/_search/colheitas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ColheitaController', ColheitaController);

    ColheitaController.$inject = ['Colheita', 'ColheitaSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function ColheitaController(Colheita, ColheitaSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.colheitas = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                ColheitaSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Colheita.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.colheitas.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.colheitas = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.colheitas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.colheitas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CidadeDialogController', CidadeDialogController);

    CidadeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Cidade', 'Propriedade', 'Microregiao', 'Concentracaoidealatributo'];

    function CidadeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Cidade, Propriedade, Microregiao, Concentracaoidealatributo) {
        var vm = this;

        vm.cidade = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.propriedades = Propriedade.query();
        vm.microregiaos = Microregiao.query({
            size: 1000,
            sort: "nomemicroregiao,asc"
        });
        vm.concentracaoidealatributos = Concentracaoidealatributo.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.cidade.id !== null) {
                Cidade.update(vm.cidade, onSaveSuccess, onSaveError);
            } else {
                Cidade.save(vm.cidade, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:cidadeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setImagemcidade = function ($file, cidade) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        cidade.imagemcidade = base64Data;
                        cidade.imagemcidadeContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CidadeDetailController', CidadeDetailController);

    CidadeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Cidade', 'Propriedade', 'Microregiao', 'Concentracaoidealatributo'];

    function CidadeDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Cidade, Propriedade, Microregiao, Concentracaoidealatributo) {
        var vm = this;

        vm.cidade = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('netWordAgroApp:cidadeUpdate', function(event, result) {
            vm.cidade = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CidadeDeleteController',CidadeDeleteController);

    CidadeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Cidade'];

    function CidadeDeleteController($uibModalInstance, entity, Cidade) {
        var vm = this;

        vm.cidade = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Cidade.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('cidade', {
            parent: 'entity',
            url: '/cidade',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.cidade.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cidade/cidades.html',
                    controller: 'CidadeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cidade');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('cidade-detail', {
            parent: 'cidade',
            url: '/cidade/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.cidade.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cidade/cidade-detail.html',
                    controller: 'CidadeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cidade');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Cidade', function($stateParams, Cidade) {
                    return Cidade.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'cidade',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('cidade-detail.edit', {
            parent: 'cidade-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cidade/cidade-dialog.html',
                    controller: 'CidadeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Cidade', function(Cidade) {
                            return Cidade.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cidade.new', {
            parent: 'cidade',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cidade/cidade-dialog.html',
                    controller: 'CidadeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nomecidade: null,
                                imagemcidade: null,
                                imagemcidadeContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('cidade', null, { reload: 'cidade' });
                }, function() {
                    $state.go('cidade');
                });
            }]
        })
        .state('cidade.edit', {
            parent: 'cidade',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cidade/cidade-dialog.html',
                    controller: 'CidadeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Cidade', function(Cidade) {
                            return Cidade.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cidade', null, { reload: 'cidade' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cidade.delete', {
            parent: 'cidade',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cidade/cidade-delete-dialog.html',
                    controller: 'CidadeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Cidade', function(Cidade) {
                            return Cidade.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cidade', null, { reload: 'cidade' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Cidade', Cidade);

    Cidade.$inject = ['$resource'];

    function Cidade ($resource) {
        var resourceUrl =  'api/cidades/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('CidadeSearch', CidadeSearch);

    CidadeSearch.$inject = ['$resource'];

    function CidadeSearch($resource) {
        var resourceUrl =  'api/_search/cidades/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CidadeController', CidadeController);

    CidadeController.$inject = ['DataUtils', 'Cidade', 'CidadeSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function CidadeController(DataUtils, Cidade, CidadeSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.cidades = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                CidadeSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Cidade.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.cidades.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.cidades = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.cidades = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.cidades = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CaracteristicasoloDialogController', CaracteristicasoloDialogController);

    CaracteristicasoloDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Caracteristicasolo', 'Solo'];

    function CaracteristicasoloDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Caracteristicasolo, Solo) {
        var vm = this;

        vm.caracteristicasolo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.solos = Solo.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.caracteristicasolo.id !== null) {
                Caracteristicasolo.update(vm.caracteristicasolo, onSaveSuccess, onSaveError);
            } else {
                Caracteristicasolo.save(vm.caracteristicasolo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:caracteristicasoloUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CaracteristicasoloDetailController', CaracteristicasoloDetailController);

    CaracteristicasoloDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Caracteristicasolo', 'Solo'];

    function CaracteristicasoloDetailController($scope, $rootScope, $stateParams, previousState, entity, Caracteristicasolo, Solo) {
        var vm = this;

        vm.caracteristicasolo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:caracteristicasoloUpdate', function(event, result) {
            vm.caracteristicasolo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CaracteristicasoloDeleteController',CaracteristicasoloDeleteController);

    CaracteristicasoloDeleteController.$inject = ['$uibModalInstance', 'entity', 'Caracteristicasolo'];

    function CaracteristicasoloDeleteController($uibModalInstance, entity, Caracteristicasolo) {
        var vm = this;

        vm.caracteristicasolo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Caracteristicasolo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('caracteristicasolo', {
            parent: 'entity',
            url: '/caracteristicasolo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.caracteristicasolo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/caracteristicasolo/caracteristicasolos.html',
                    controller: 'CaracteristicasoloController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('caracteristicasolo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('caracteristicasolo-detail', {
            parent: 'caracteristicasolo',
            url: '/caracteristicasolo/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.caracteristicasolo.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/caracteristicasolo/caracteristicasolo-detail.html',
                    controller: 'CaracteristicasoloDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('caracteristicasolo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Caracteristicasolo', function($stateParams, Caracteristicasolo) {
                    return Caracteristicasolo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'caracteristicasolo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('caracteristicasolo-detail.edit', {
            parent: 'caracteristicasolo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/caracteristicasolo/caracteristicasolo-dialog.html',
                    controller: 'CaracteristicasoloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Caracteristicasolo', function(Caracteristicasolo) {
                            return Caracteristicasolo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('caracteristicasolo.new', {
            parent: 'caracteristicasolo',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/caracteristicasolo/caracteristicasolo-dialog.html',
                    controller: 'CaracteristicasoloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                descaracteristica: null,
                                destipcaracteristica: null,
                                valorcaracteristica: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('caracteristicasolo', null, { reload: 'caracteristicasolo' });
                }, function() {
                    $state.go('caracteristicasolo');
                });
            }]
        })
        .state('caracteristicasolo.edit', {
            parent: 'caracteristicasolo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/caracteristicasolo/caracteristicasolo-dialog.html',
                    controller: 'CaracteristicasoloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Caracteristicasolo', function(Caracteristicasolo) {
                            return Caracteristicasolo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('caracteristicasolo', null, { reload: 'caracteristicasolo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('caracteristicasolo.delete', {
            parent: 'caracteristicasolo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/caracteristicasolo/caracteristicasolo-delete-dialog.html',
                    controller: 'CaracteristicasoloDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Caracteristicasolo', function(Caracteristicasolo) {
                            return Caracteristicasolo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('caracteristicasolo', null, { reload: 'caracteristicasolo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Caracteristicasolo', Caracteristicasolo);

    Caracteristicasolo.$inject = ['$resource'];

    function Caracteristicasolo ($resource) {
        var resourceUrl =  'api/caracteristicasolos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('CaracteristicasoloSearch', CaracteristicasoloSearch);

    CaracteristicasoloSearch.$inject = ['$resource'];

    function CaracteristicasoloSearch($resource) {
        var resourceUrl =  'api/_search/caracteristicasolos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CaracteristicasoloController', CaracteristicasoloController);

    CaracteristicasoloController.$inject = ['Caracteristicasolo', 'CaracteristicasoloSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function CaracteristicasoloController(Caracteristicasolo, CaracteristicasoloSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.caracteristicasolos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                CaracteristicasoloSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Caracteristicasolo.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.caracteristicasolos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.caracteristicasolos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.caracteristicasolos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.caracteristicasolos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CaracteristicaculturaDialogController', CaracteristicaculturaDialogController);

    CaracteristicaculturaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Caracteristicacultura', 'Cultura'];

    function CaracteristicaculturaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Caracteristicacultura, Cultura) {
        var vm = this;

        vm.caracteristicacultura = entity;
        vm.clear = clear;
        vm.save = save;
        vm.culturas = Cultura.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.caracteristicacultura.id !== null) {
                Caracteristicacultura.update(vm.caracteristicacultura, onSaveSuccess, onSaveError);
            } else {
                Caracteristicacultura.save(vm.caracteristicacultura, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:caracteristicaculturaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CaracteristicaculturaDetailController', CaracteristicaculturaDetailController);

    CaracteristicaculturaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Caracteristicacultura', 'Cultura'];

    function CaracteristicaculturaDetailController($scope, $rootScope, $stateParams, previousState, entity, Caracteristicacultura, Cultura) {
        var vm = this;

        vm.caracteristicacultura = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:caracteristicaculturaUpdate', function(event, result) {
            vm.caracteristicacultura = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CaracteristicaculturaDeleteController',CaracteristicaculturaDeleteController);

    CaracteristicaculturaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Caracteristicacultura'];

    function CaracteristicaculturaDeleteController($uibModalInstance, entity, Caracteristicacultura) {
        var vm = this;

        vm.caracteristicacultura = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Caracteristicacultura.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('caracteristicacultura', {
            parent: 'entity',
            url: '/caracteristicacultura',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.caracteristicacultura.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/caracteristicacultura/caracteristicaculturas.html',
                    controller: 'CaracteristicaculturaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('caracteristicacultura');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('caracteristicacultura-detail', {
            parent: 'caracteristicacultura',
            url: '/caracteristicacultura/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.caracteristicacultura.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/caracteristicacultura/caracteristicacultura-detail.html',
                    controller: 'CaracteristicaculturaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('caracteristicacultura');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Caracteristicacultura', function($stateParams, Caracteristicacultura) {
                    return Caracteristicacultura.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'caracteristicacultura',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('caracteristicacultura-detail.edit', {
            parent: 'caracteristicacultura-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/caracteristicacultura/caracteristicacultura-dialog.html',
                    controller: 'CaracteristicaculturaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Caracteristicacultura', function(Caracteristicacultura) {
                            return Caracteristicacultura.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('caracteristicacultura.new', {
            parent: 'caracteristicacultura',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/caracteristicacultura/caracteristicacultura-dialog.html',
                    controller: 'CaracteristicaculturaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                descaracteristica: null,
                                destipcaracteristica: null,
                                valorcaracteristica: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('caracteristicacultura', null, { reload: 'caracteristicacultura' });
                }, function() {
                    $state.go('caracteristicacultura');
                });
            }]
        })
        .state('caracteristicacultura.edit', {
            parent: 'caracteristicacultura',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/caracteristicacultura/caracteristicacultura-dialog.html',
                    controller: 'CaracteristicaculturaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Caracteristicacultura', function(Caracteristicacultura) {
                            return Caracteristicacultura.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('caracteristicacultura', null, { reload: 'caracteristicacultura' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('caracteristicacultura.delete', {
            parent: 'caracteristicacultura',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/caracteristicacultura/caracteristicacultura-delete-dialog.html',
                    controller: 'CaracteristicaculturaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Caracteristicacultura', function(Caracteristicacultura) {
                            return Caracteristicacultura.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('caracteristicacultura', null, { reload: 'caracteristicacultura' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Caracteristicacultura', Caracteristicacultura);

    Caracteristicacultura.$inject = ['$resource'];

    function Caracteristicacultura ($resource) {
        var resourceUrl =  'api/caracteristicaculturas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('CaracteristicaculturaSearch', CaracteristicaculturaSearch);

    CaracteristicaculturaSearch.$inject = ['$resource'];

    function CaracteristicaculturaSearch($resource) {
        var resourceUrl =  'api/_search/caracteristicaculturas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('CaracteristicaculturaController', CaracteristicaculturaController);

    CaracteristicaculturaController.$inject = ['Caracteristicacultura', 'CaracteristicaculturaSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function CaracteristicaculturaController(Caracteristicacultura, CaracteristicaculturaSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.caracteristicaculturas = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                CaracteristicaculturaSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Caracteristicacultura.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.caracteristicaculturas.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.caracteristicaculturas = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.caracteristicaculturas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.caracteristicaculturas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AvaliacaosoloDialogController', AvaliacaosoloDialogController);

    AvaliacaosoloDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Avaliacaosolo', 'Propriedade', 'Safra'];

    function AvaliacaosoloDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Avaliacaosolo, Propriedade, Safra) {
        var vm = this;

        vm.avaliacaosolo = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.propriedades = Propriedade.query();
        vm.safras = Safra.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.avaliacaosolo.id !== null) {
                Avaliacaosolo.update(vm.avaliacaosolo, onSaveSuccess, onSaveError);
            } else {
                Avaliacaosolo.save(vm.avaliacaosolo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:avaliacaosoloUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setMedicoes = function ($file, avaliacaosolo) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        avaliacaosolo.medicoes = base64Data;
                        avaliacaosolo.medicoesContentType = $file.type;
                    });
                });
            }
        };

        vm.setMedicoesinfo = function ($file, avaliacaosolo) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        avaliacaosolo.medicoesinfo = base64Data;
                        avaliacaosolo.medicoesinfoContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AvaliacaosoloDetailController', AvaliacaosoloDetailController);

    AvaliacaosoloDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Avaliacaosolo', 'Propriedade', 'Safra'];

    function AvaliacaosoloDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Avaliacaosolo, Propriedade, Safra) {
        var vm = this;

        vm.avaliacaosolo = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('netWordAgroApp:avaliacaosoloUpdate', function(event, result) {
            vm.avaliacaosolo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AvaliacaosoloDeleteController',AvaliacaosoloDeleteController);

    AvaliacaosoloDeleteController.$inject = ['$uibModalInstance', 'entity', 'Avaliacaosolo'];

    function AvaliacaosoloDeleteController($uibModalInstance, entity, Avaliacaosolo) {
        var vm = this;

        vm.avaliacaosolo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Avaliacaosolo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('avaliacaosolo', {
            parent: 'entity',
            url: '/avaliacaosolo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.avaliacaosolo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/avaliacaosolo/avaliacaosolos.html',
                    controller: 'AvaliacaosoloController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('avaliacaosolo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('avaliacaosolo-detail', {
            parent: 'avaliacaosolo',
            url: '/avaliacaosolo/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.avaliacaosolo.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/avaliacaosolo/avaliacaosolo-detail.html',
                    controller: 'AvaliacaosoloDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('avaliacaosolo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Avaliacaosolo', function($stateParams, Avaliacaosolo) {
                    return Avaliacaosolo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'avaliacaosolo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('avaliacaosolo-detail.edit', {
            parent: 'avaliacaosolo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/avaliacaosolo/avaliacaosolo-dialog.html',
                    controller: 'AvaliacaosoloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Avaliacaosolo', function(Avaliacaosolo) {
                            return Avaliacaosolo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('avaliacaosolo.new', {
            parent: 'avaliacaosolo',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/avaliacaosolo/avaliacaosolo-dialog.html',
                    controller: 'AvaliacaosoloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                usuario: null,
                                medicoes: null,
                                medicoesContentType: null,
                                medicoesinfo: null,
                                medicoesinfoContentType: null,
                                dataavaliacao: null,
                                sensores: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('avaliacaosolo', null, { reload: 'avaliacaosolo' });
                }, function() {
                    $state.go('avaliacaosolo');
                });
            }]
        })
        .state('avaliacaosolo.edit', {
            parent: 'avaliacaosolo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/avaliacaosolo/avaliacaosolo-dialog.html',
                    controller: 'AvaliacaosoloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Avaliacaosolo', function(Avaliacaosolo) {
                            return Avaliacaosolo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('avaliacaosolo', null, { reload: 'avaliacaosolo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('avaliacaosolo.delete', {
            parent: 'avaliacaosolo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/avaliacaosolo/avaliacaosolo-delete-dialog.html',
                    controller: 'AvaliacaosoloDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Avaliacaosolo', function(Avaliacaosolo) {
                            return Avaliacaosolo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('avaliacaosolo', null, { reload: 'avaliacaosolo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Avaliacaosolo', Avaliacaosolo);

    Avaliacaosolo.$inject = ['$resource'];

    function Avaliacaosolo ($resource) {
        var resourceUrl =  'api/avaliacaosolos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'queryMedicoes': { 
                url: '/api/avaliacoessolo/medicoes/:id',
                method: 'GET', 
                isArray: true},
            'queryInfo': { 
                url: '/api/avaliacoessolo/medicoesinfo/:id',
                method: 'GET', 
                isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('AvaliacaosoloSearch', AvaliacaosoloSearch);

    AvaliacaosoloSearch.$inject = ['$resource'];

    function AvaliacaosoloSearch($resource) {
        var resourceUrl =  'api/_search/avaliacaosolos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AvaliacaosoloController', AvaliacaosoloController);

    AvaliacaosoloController.$inject = ['DataUtils', 'Avaliacaosolo', 'AvaliacaosoloSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function AvaliacaosoloController(DataUtils, Avaliacaosolo, AvaliacaosoloSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.avaliacaosolos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                AvaliacaosoloSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Avaliacaosolo.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.avaliacaosolos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.avaliacaosolos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.avaliacaosolos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.avaliacaosolos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }

            
        vm.b64toBlob = b64toBlob;
        vm.sucessoDownloadMedicoes = sucessoDownloadMedicoes;
        vm.sucessoDownloadMedicoesInfo = sucessoDownloadMedicoesInfo;
        vm.downloadMedicoes = downloadMedicoes;
        vm.downloadMedicoesInfo = downloadMedicoesInfo;

        function b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;
        
            var byteCharacters = atob(b64Data);
            var byteArrays = [];
        
            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);
            
                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
            
                var byteArray = new Uint8Array(byteNumbers);
            
                byteArrays.push(byteArray);
            }
        
            var blob = new Blob(byteArrays, {type: contentType});
            return blob;
        }

        function sucessoDownloadMedicoes(data){
            var filename = 'medicoes.txt';
            console.log("SUCESSO");
            var ct = data[0].medicoesContentType;
            var dados = data[0].medicoes;
            
            if(ct === null) {
                alert("Nenhuma medição associada");
                return;
            }

            /*
                element.setAttribute('href', 'data:' + ct + ';base64,' + dados);
                element.setAttribute('download', 'download');
            
                element.style.display = 'none';
                
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            */

        var blob = b64toBlob(dados, ct);

        if(window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(blob, filename);
        }
        else{
            var elem = window.document.createElement('a');
            elem.href = window.URL.createObjectURL(blob);
            elem.download = filename;        
            document.body.appendChild(elem);
            elem.click();        
            document.body.removeChild(elem);
        }
        }
        
        function sucessoDownloadMedicoesInfo(data){
            var filename = 'medicoesInfo.txt';
            console.log("SUCESSO");
            var ct = data[0].medicoesinfoContentType;
            var dados = data[0].medicoesinfo;
            
            if(ct === null) {
                alert("Nenhuma informação associada");
                return;
            }

            /*
                element.setAttribute('href', 'data:' + ct + ';base64,' + dados);
                element.setAttribute('download', 'download');
            
                element.style.display = 'none';
                
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            */

        var blob = b64toBlob(dados, ct);

        if(window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(blob, filename);
        }
        else{
            var elem = window.document.createElement('a');
            elem.href = window.URL.createObjectURL(blob);
            elem.download = filename;        
            document.body.appendChild(elem);
            elem.click();        
            document.body.removeChild(elem);
        }
        }

        function downloadMedicoes(id){
            Avaliacaosolo.queryMedicoes({id: id}, vm.sucessoDownloadMedicoes);
        }

        function downloadMedicoesInfo(id){
            Avaliacaosolo.queryInfo({id: id}, vm.sucessoDownloadMedicoesInfo);
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AutomatizacaoDialogController', AutomatizacaoDialogController);

    AutomatizacaoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Automatizacao', 'Safra', 'Propriedade'];

    function AutomatizacaoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Automatizacao, Safra, Propriedade) {
        var vm = this;

        vm.automatizacao = entity;
        vm.clear = clear;
        vm.save = save;
        vm.safras = Safra.query();
        vm.propriedades = Propriedade.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.automatizacao.id !== null) {
                Automatizacao.update(vm.automatizacao, onSaveSuccess, onSaveError);
            } else {
                Automatizacao.save(vm.automatizacao, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:automatizacaoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AutomatizacaoDetailController', AutomatizacaoDetailController);

    AutomatizacaoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Automatizacao', 'Safra', 'Propriedade'];

    function AutomatizacaoDetailController($scope, $rootScope, $stateParams, previousState, entity, Automatizacao, Safra, Propriedade) {
        var vm = this;

        vm.automatizacao = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:automatizacaoUpdate', function(event, result) {
            vm.automatizacao = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AutomatizacaoDeleteController',AutomatizacaoDeleteController);

    AutomatizacaoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Automatizacao'];

    function AutomatizacaoDeleteController($uibModalInstance, entity, Automatizacao) {
        var vm = this;

        vm.automatizacao = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Automatizacao.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('automatizacao', {
            parent: 'entity',
            url: '/automatizacao',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.automatizacao.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/automatizacao/automatizacaos.html',
                    controller: 'AutomatizacaoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('automatizacao');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('mapaimagem');
                    return $translate.refresh();
                }]
            }
        })
        .state('automatizacao-detail', {
            parent: 'automatizacao',
            url: '/automatizacao/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.automatizacao.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/automatizacao/automatizacao-detail.html',
                    controller: 'AutomatizacaoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('automatizacao');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Automatizacao', function($stateParams, Automatizacao) {
                    return Automatizacao.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'automatizacao',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('automatizacao-detail.edit', {
            parent: 'automatizacao-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/automatizacao/automatizacao-dialog.html',
                    controller: 'AutomatizacaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Automatizacao', function(Automatizacao) {
                            return Automatizacao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('automatizacao.new', {
            parent: 'automatizacao',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/automatizacao/automatizacao-dialog.html',
                    controller: 'AutomatizacaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                inicioprocessamento: null,
                                fimprocessamento: null,
                                status: null,
                                maquinaresponsavel: null,
                                log: null,
                                descricao: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('automatizacao', null, { reload: 'automatizacao' });
                }, function() {
                    $state.go('automatizacao');
                });
            }]
        })
        .state('automatizacao.edit', {
            parent: 'automatizacao',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/automatizacao/automatizacao-dialog.html',
                    controller: 'AutomatizacaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Automatizacao', function(Automatizacao) {
                            return Automatizacao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('automatizacao', null, { reload: 'automatizacao' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('automatizacao.delete', {
            parent: 'automatizacao',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/automatizacao/automatizacao-delete-dialog.html',
                    controller: 'AutomatizacaoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Automatizacao', function(Automatizacao) {
                            return Automatizacao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('automatizacao', null, { reload: 'automatizacao' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Automatizacao', Automatizacao);

    Automatizacao.$inject = ['$resource'];

    function Automatizacao ($resource) {
        var resourceUrl =  'api/automatizacaos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('AutomatizacaoSearch', AutomatizacaoSearch);

    AutomatizacaoSearch.$inject = ['$resource'];

    function AutomatizacaoSearch($resource) {
        var resourceUrl =  'api/_search/automatizacaos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AutomatizacaoController', AutomatizacaoController);

    AutomatizacaoController.$inject = ['Automatizacao', 'AutomatizacaoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'Propriedade'];

    function AutomatizacaoController(Automatizacao, AutomatizacaoSearch, ParseLinks, AlertService, paginationConstants, Propriedade) {

        var vm = this;

        vm.automatizacaos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        vm.filtropropriedade = null;

        loadAll();

        vm.filtropropriedades = Propriedade.queryNomesPropriedades({
            size: 1000,
            sort: "nomepropriedade,asc"
        });

        vm.changeFiltro = function (){
            console.log("Propriedade alterada!");
            console.log(vm.filtropropriedade);
            vm.page = 0;
            vm.automatizacaos = [];
            loadAll();
        };

        function loadAll () {
            if (vm.currentSearch) {
                AutomatizacaoSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Automatizacao.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for(var i = 0; i < data.length; i++) {
                    if(vm.filtropropriedade === null || parseInt(vm.filtropropriedade.id) === data[i].propriedade.id){
                        console.log("Added");
                        vm.automatizacaos.push(data[i]);
                    }
                }

                if(vm.automatizacaos.length == 0 && vm.page < vm.links['last']){
                    console.log("Vazio");
                    vm.page = vm.page + 1;
                    loadPage(vm.page);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.automatizacaos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.automatizacaos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.automatizacaos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AtributopesquisaDialogController', AtributopesquisaDialogController);

    AtributopesquisaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Atributopesquisa', 'Pesquisa', 'Atributo', 'Medicaoatribpesq', 'Medicaoatriblavoura'];

    function AtributopesquisaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Atributopesquisa, Pesquisa, Atributo, Medicaoatribpesq, Medicaoatriblavoura) {
        var vm = this;

        vm.atributopesquisa = entity;
        vm.clear = clear;
        vm.save = save;
        vm.pesquisas = Pesquisa.query();
        vm.atributos = Atributo.query();
        vm.medicaoatribpesqs = Medicaoatribpesq.query();
        vm.medicaoatriblavouras = Medicaoatriblavoura.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.atributopesquisa.id !== null) {
                Atributopesquisa.update(vm.atributopesquisa, onSaveSuccess, onSaveError);
            } else {
                Atributopesquisa.save(vm.atributopesquisa, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:atributopesquisaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AtributopesquisaDetailController', AtributopesquisaDetailController);

    AtributopesquisaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Atributopesquisa', 'Pesquisa', 'Atributo', 'Medicaoatribpesq', 'Medicaoatriblavoura'];

    function AtributopesquisaDetailController($scope, $rootScope, $stateParams, previousState, entity, Atributopesquisa, Pesquisa, Atributo, Medicaoatribpesq, Medicaoatriblavoura) {
        var vm = this;

        vm.atributopesquisa = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:atributopesquisaUpdate', function(event, result) {
            vm.atributopesquisa = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AtributopesquisaDeleteController',AtributopesquisaDeleteController);

    AtributopesquisaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Atributopesquisa'];

    function AtributopesquisaDeleteController($uibModalInstance, entity, Atributopesquisa) {
        var vm = this;

        vm.atributopesquisa = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Atributopesquisa.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('atributopesquisa', {
            parent: 'entity',
            url: '/atributopesquisa',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.atributopesquisa.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/atributopesquisa/atributopesquisas.html',
                    controller: 'AtributopesquisaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('atributopesquisa');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('atributopesquisa-detail', {
            parent: 'atributopesquisa',
            url: '/atributopesquisa/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.atributopesquisa.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/atributopesquisa/atributopesquisa-detail.html',
                    controller: 'AtributopesquisaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('atributopesquisa');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Atributopesquisa', function($stateParams, Atributopesquisa) {
                    return Atributopesquisa.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'atributopesquisa',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('atributopesquisa-detail.edit', {
            parent: 'atributopesquisa-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/atributopesquisa/atributopesquisa-dialog.html',
                    controller: 'AtributopesquisaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Atributopesquisa', function(Atributopesquisa) {
                            return Atributopesquisa.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('atributopesquisa.new', {
            parent: 'atributopesquisa',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/atributopesquisa/atributopesquisa-dialog.html',
                    controller: 'AtributopesquisaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('atributopesquisa', null, { reload: 'atributopesquisa' });
                }, function() {
                    $state.go('atributopesquisa');
                });
            }]
        })
        .state('atributopesquisa.edit', {
            parent: 'atributopesquisa',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/atributopesquisa/atributopesquisa-dialog.html',
                    controller: 'AtributopesquisaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Atributopesquisa', function(Atributopesquisa) {
                            return Atributopesquisa.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('atributopesquisa', null, { reload: 'atributopesquisa' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('atributopesquisa.delete', {
            parent: 'atributopesquisa',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/atributopesquisa/atributopesquisa-delete-dialog.html',
                    controller: 'AtributopesquisaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Atributopesquisa', function(Atributopesquisa) {
                            return Atributopesquisa.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('atributopesquisa', null, { reload: 'atributopesquisa' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Atributopesquisa', Atributopesquisa);

    Atributopesquisa.$inject = ['$resource'];

    function Atributopesquisa ($resource) {
        var resourceUrl =  'api/atributopesquisas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('AtributopesquisaSearch', AtributopesquisaSearch);

    AtributopesquisaSearch.$inject = ['$resource'];

    function AtributopesquisaSearch($resource) {
        var resourceUrl =  'api/_search/atributopesquisas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AtributopesquisaController', AtributopesquisaController);

    AtributopesquisaController.$inject = ['Atributopesquisa', 'AtributopesquisaSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function AtributopesquisaController(Atributopesquisa, AtributopesquisaSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.atributopesquisas = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                AtributopesquisaSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Atributopesquisa.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.atributopesquisas.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.atributopesquisas = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.atributopesquisas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.atributopesquisas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AtributoDialogController', AtributoDialogController);

    AtributoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Atributo', 'Concentracaoidealatributo', 'Atributopesquisa', 'Corratribce'];

    function AtributoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Atributo, Concentracaoidealatributo, Atributopesquisa, Corratribce) {
        var vm = this;

        vm.atributo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.concentracaoidealatributos = Concentracaoidealatributo.query();
        vm.atributopesquisas = Atributopesquisa.query();
        vm.corratribces = Corratribce.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.atributo.id !== null) {
                Atributo.update(vm.atributo, onSaveSuccess, onSaveError);
            } else {
                Atributo.save(vm.atributo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:atributoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AtributoDetailController', AtributoDetailController);

    AtributoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Atributo', 'Concentracaoidealatributo', 'Atributopesquisa', 'Corratribce'];

    function AtributoDetailController($scope, $rootScope, $stateParams, previousState, entity, Atributo, Concentracaoidealatributo, Atributopesquisa, Corratribce) {
        var vm = this;

        vm.atributo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:atributoUpdate', function(event, result) {
            vm.atributo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AtributoDeleteController',AtributoDeleteController);

    AtributoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Atributo'];

    function AtributoDeleteController($uibModalInstance, entity, Atributo) {
        var vm = this;

        vm.atributo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Atributo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('atributo', {
            parent: 'entity',
            url: '/atributo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.atributo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/atributo/atributos.html',
                    controller: 'AtributoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('atributo');
                    $translatePartialLoader.addPart('tipoatributo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('atributo-detail', {
            parent: 'atributo',
            url: '/atributo/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.atributo.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/atributo/atributo-detail.html',
                    controller: 'AtributoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('atributo');
                    $translatePartialLoader.addPart('tipoatributo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Atributo', function($stateParams, Atributo) {
                    return Atributo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'atributo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('atributo-detail.edit', {
            parent: 'atributo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/atributo/atributo-dialog.html',
                    controller: 'AtributoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Atributo', function(Atributo) {
                            return Atributo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('atributo.new', {
            parent: 'atributo',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/atributo/atributo-dialog.html',
                    controller: 'AtributoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nomeatributo: null,
                                funcaoatributo: null,
                                caracatributo: null,
                                tipoatributo: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('atributo', null, { reload: 'atributo' });
                }, function() {
                    $state.go('atributo');
                });
            }]
        })
        .state('atributo.edit', {
            parent: 'atributo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/atributo/atributo-dialog.html',
                    controller: 'AtributoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Atributo', function(Atributo) {
                            return Atributo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('atributo', null, { reload: 'atributo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('atributo.delete', {
            parent: 'atributo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/atributo/atributo-delete-dialog.html',
                    controller: 'AtributoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Atributo', function(Atributo) {
                            return Atributo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('atributo', null, { reload: 'atributo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Atributo', Atributo);

    Atributo.$inject = ['$resource'];

    function Atributo ($resource) {
        var resourceUrl =  'api/atributos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('AtributoSearch', AtributoSearch);

    AtributoSearch.$inject = ['$resource'];

    function AtributoSearch($resource) {
        var resourceUrl =  'api/_search/atributos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AtributoController', AtributoController);

    AtributoController.$inject = ['Atributo', 'AtributoSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function AtributoController(Atributo, AtributoSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.atributos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                AtributoSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Atributo.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.atributos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.atributos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.atributos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.atributos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AtividadeDialogController', AtividadeDialogController);

    AtividadeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Atividade', 'Etapa', 'Localarmazenamento', 'Servico', 'Aquisicaoplan', 'Aplicacao', 'Receituario', 'Aquisicao'];

    function AtividadeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Atividade, Etapa, Localarmazenamento, Servico, Aquisicaoplan, Aplicacao, Receituario, Aquisicao) {
        var vm = this;

        vm.atividade = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.etapas = Etapa.query();
        vm.localarmazenamentos = Localarmazenamento.query();
        vm.servicos = Servico.query();
        vm.aquisicaoplans = Aquisicaoplan.query();
        vm.aplicacaos = Aplicacao.query();
        vm.receituarios = Receituario.query();
        vm.aquisicaos = Aquisicao.query();
        var idetapa = $stateParams.idetapa;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
            history.go(-1);
        }

        function save () {
            vm.isSaving = true;
            vm.atividade.etapa = new Etapa();
            if (vm.atividade.id !== null) {
                console.log(idetapa);
                vm.atividade.etapa.id = idetapa;
                Atividade.update(vm.atividade, onSaveSuccess, onSaveError);
            } else {
                vm.atividade.etapa.id = idetapa;
                Atividade.save(vm.atividade, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:atividadeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            history.go(-1);
        }

        function onSaveError () {
            vm.isSaving = false;
            history.go(-1);
        }

        vm.datePickerOpenStatus.datainicio = false;
        vm.datePickerOpenStatus.datatermino = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AtividadeDetailController', AtividadeDetailController);

    AtividadeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Atividade', 'Etapa', 'Localarmazenamento', 'Servico', 'Aquisicaoplan', 'Aplicacao', 'Receituario', 'Aquisicao'];

    function AtividadeDetailController($scope, $rootScope, $stateParams, previousState, entity, Atividade, Etapa, Localarmazenamento, Servico, Aquisicaoplan, Aplicacao, Receituario, Aquisicao) {
        var vm = this;

        vm.atividade = entity;
        vm.previousState = previousState.name;

        vm.servicos=[];

        loadAll();

        function loadAll(){
            Servico.queryByAtividade({atividadeid: vm.atividade.id}, function(result) {
                vm.servicos = result;
                vm.searchQuery = null;
            });
        } 

        var unsubscribe = $rootScope.$on('netWordAgroApp:atividadeUpdate', function(event, result) {
            vm.atividade = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AtividadeDeleteController',AtividadeDeleteController);

    AtividadeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Atividade'];

    function AtividadeDeleteController($uibModalInstance, entity, Atividade) {
        var vm = this;

        vm.atividade = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
            history.go(-1);
        }

        function confirmDelete (id) {
            Atividade.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    history.go(-1);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('atividade', {
            parent: 'entity',
            url: '/atividade',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.atividade.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/atividade/atividades.html',
                    controller: 'AtividadeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('atividade');
                    $translatePartialLoader.addPart('tipolocal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('atividade-detail', {
            parent: 'atividade',
            url: '/atividade/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.atividade.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/atividade/atividade-detail.html',
                    controller: 'AtividadeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('atividade');
                    $translatePartialLoader.addPart('tipolocal');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Atividade', function($stateParams, Atividade) {
                    return Atividade.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'atividade',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('atividade-detail.edit', {
            parent: 'atividade-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/atividade/atividade-dialog.html',
                    controller: 'AtividadeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Atividade', function(Atividade) {
                            return Atividade.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('atividade.new', {
            parent: 'atividade',
            url: '/new?{idetapa}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/atividade/atividade-dialog.html',
                    controller: 'AtividadeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                descricao: null,
                                datainicio: null,
                                datatermino: null,
                                tipolocal: null,
                                id: null,
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('atividade', null, { reload: 'atividade' });
                }, function() {
                    $state.go('atividade');
                });
            }]
        })
        .state('atividade.edit', {
            parent: 'atividade',
            url: '/{id}/edit?{idetapa}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/atividade/atividade-dialog.html',
                    controller: 'AtividadeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Atividade', function(Atividade) {
                            return Atividade.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('atividade', null, { reload: 'atividade' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('atividade.delete', {
            parent: 'atividade',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/atividade/atividade-delete-dialog.html',
                    controller: 'AtividadeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Atividade', function(Atividade) {
                            return Atividade.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('atividade', null, { reload: 'atividade' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Atividade', Atividade);

    Atividade.$inject = ['$resource', 'DateUtils'];

    function Atividade ($resource, DateUtils) {
        var resourceUrl =  'api/atividades/:id';

        return $resource(resourceUrl, {}, {

            'queryByEtapa': {
                url: '/api/atividades/etapas/:etapaid',
                method: 'GET',
                isArray: true
            },
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datainicio = DateUtils.convertLocalDateFromServer(data.datainicio);
                        data.datatermino = DateUtils.convertLocalDateFromServer(data.datatermino);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datainicio = DateUtils.convertLocalDateToServer(copy.datainicio);
                    copy.datatermino = DateUtils.convertLocalDateToServer(copy.datatermino);
                    return angular.toJson(copy);
                }
            }
            
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('AtividadeSearch', AtividadeSearch);

    AtividadeSearch.$inject = ['$resource'];

    function AtividadeSearch($resource) {
        var resourceUrl =  'api/_search/atividades/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AtividadeController', AtividadeController);

    AtividadeController.$inject = ['Atividade', 'AtividadeSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function AtividadeController(Atividade, AtividadeSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.atividades = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                AtividadeSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Atividade.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.atividades.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.atividades = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.atividades = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.atividades = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ArmazenamentosafratestemDialogController', ArmazenamentosafratestemDialogController);

    ArmazenamentosafratestemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Armazenamentosafratestem', 'Etapa', 'Safra' ,'$q'];

    function ArmazenamentosafratestemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Armazenamentosafratestem, Etapa, Safra, $q) {
        var vm = this;

        vm.armazenamentosafratestem = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.etapas = Etapa.query();

        vm.safras = Safra.query({filter: 'armazenamentosafratestem-is-null'});
        $q.all([vm.armazenamentosafratestem.$promise, vm.safras.$promise]).then(function() {
            if (!vm.armazenamentosafratestem.safra || !vm.armazenamentosafratestem.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.armazenamentosafratestem.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "armazenamentosafratestem";
            vm.etapa.safra = vm.armazenamentosafratestem.safra;
            
            if (vm.armazenamentosafratestem.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafratestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.armazenamentosafratestem.etapa = new Etapa();
            vm.armazenamentosafratestem.etapa = result;
            Armazenamentosafratestem.save(vm.armazenamentosafratestem, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafratestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.armazenamentosafratestem.etapa = new Etapa();
            vm.armazenamentosafratestem.etapa = result;
            Armazenamentosafratestem.update(vm.armazenamentosafratestem, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafratestemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dataarmazenamento = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ArmazenamentosafratestemDetailController', ArmazenamentosafratestemDetailController);

    ArmazenamentosafratestemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Armazenamentosafratestem', 'Etapa', 'Atividade'];

    function ArmazenamentosafratestemDetailController($scope, $rootScope, $stateParams, previousState, entity, Armazenamentosafratestem, Etapa, Atividade) {
        var vm = this;

        vm.armazenamentosafratestem = entity;
        vm.previousState = previousState.name;

        vm.atividades = [];

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.armazenamentosafratestem.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        }

        var unsubscribe = $rootScope.$on('netWordAgroApp:armazenamentosafratestemUpdate', function(event, result) {
            vm.armazenamentosafratestem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ArmazenamentosafratestemDeleteController',ArmazenamentosafratestemDeleteController);

    ArmazenamentosafratestemDeleteController.$inject = ['$uibModalInstance', 'entity', 'Armazenamentosafratestem', 'Etapa'];

    function ArmazenamentosafratestemDeleteController($uibModalInstance, entity, Armazenamentosafratestem, Etapa) {
        var vm = this;

        vm.armazenamentosafratestem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Armazenamentosafratestem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    Etapa.delete({id: vm.armazenamentosafratestem.etapa.id},
                        function () {
                            $uibModalInstance.close(true);
                        });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('armazenamentosafratestem', {
            parent: 'entity',
            url: '/armazenamentosafratestem',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.armazenamentosafratestem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/armazenamentosafratestem/armazenamentosafratestems.html',
                    controller: 'ArmazenamentosafratestemController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('armazenamentosafratestem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('armazenamentosafratestem-detail', {
            parent: 'armazenamentosafratestem',
            url: '/armazenamentosafratestem/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.armazenamentosafratestem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/armazenamentosafratestem/armazenamentosafratestem-detail.html',
                    controller: 'ArmazenamentosafratestemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('armazenamentosafratestem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Armazenamentosafratestem', function($stateParams, Armazenamentosafratestem) {
                    return Armazenamentosafratestem.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'armazenamentosafratestem',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('armazenamentosafratestem-detail.edit', {
            parent: 'armazenamentosafratestem-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/armazenamentosafratestem/armazenamentosafratestem-dialog.html',
                    controller: 'ArmazenamentosafratestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Armazenamentosafratestem', function(Armazenamentosafratestem) {
                            return Armazenamentosafratestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('armazenamentosafratestem.new', {
            parent: 'armazenamentosafratestem',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/armazenamentosafratestem/armazenamentosafratestem-dialog.html',
                    controller: 'ArmazenamentosafratestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dataarmazenamento: null,
                                quantidadearmazenada: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('armazenamentosafratestem', null, { reload: 'armazenamentosafratestem' });
                }, function() {
                    $state.go('armazenamentosafratestem');
                });
            }]
        })
        .state('armazenamentosafratestem.edit', {
            parent: 'armazenamentosafratestem',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/armazenamentosafratestem/armazenamentosafratestem-dialog.html',
                    controller: 'ArmazenamentosafratestemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Armazenamentosafratestem', function(Armazenamentosafratestem) {
                            return Armazenamentosafratestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('armazenamentosafratestem', null, { reload: 'armazenamentosafratestem' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('armazenamentosafratestem.delete', {
            parent: 'armazenamentosafratestem',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/armazenamentosafratestem/armazenamentosafratestem-delete-dialog.html',
                    controller: 'ArmazenamentosafratestemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Armazenamentosafratestem', function(Armazenamentosafratestem) {
                            return Armazenamentosafratestem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('armazenamentosafratestem', null, { reload: 'armazenamentosafratestem' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Armazenamentosafratestem', Armazenamentosafratestem);

    Armazenamentosafratestem.$inject = ['$resource', 'DateUtils'];

    function Armazenamentosafratestem ($resource, DateUtils) {
        var resourceUrl =  'api/armazenamentosafratestems/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataarmazenamento = DateUtils.convertLocalDateFromServer(data.dataarmazenamento);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dataarmazenamento = DateUtils.convertLocalDateToServer(copy.dataarmazenamento);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dataarmazenamento = DateUtils.convertLocalDateToServer(copy.dataarmazenamento);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('ArmazenamentosafratestemSearch', ArmazenamentosafratestemSearch);

    ArmazenamentosafratestemSearch.$inject = ['$resource'];

    function ArmazenamentosafratestemSearch($resource) {
        var resourceUrl =  'api/_search/armazenamentosafratestems/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ArmazenamentosafratestemController', ArmazenamentosafratestemController);

    ArmazenamentosafratestemController.$inject = ['Armazenamentosafratestem', 'ArmazenamentosafratestemSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function ArmazenamentosafratestemController(Armazenamentosafratestem, ArmazenamentosafratestemSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.armazenamentosafratestems = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                ArmazenamentosafratestemSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Armazenamentosafratestem.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.armazenamentosafratestems.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.armazenamentosafratestems = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.armazenamentosafratestems = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.armazenamentosafratestems = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ArmazenamentosafraplanDialogController', ArmazenamentosafraplanDialogController);

    ArmazenamentosafraplanDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Armazenamentosafraplan', 'Safra', 'Etapa', 'Principal'];

    function ArmazenamentosafraplanDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Armazenamentosafraplan, Safra, Etapa, Principal) {
        var vm = this;

        vm.armazenamentosafraplan = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.safras = Safra.query({filter: 'armazenamentosafraplan-is-null'});
        $q.all([vm.armazenamentosafraplan.$promise, vm.safras.$promise]).then(function() {
            if (!vm.armazenamentosafraplan.safra || !vm.armazenamentosafraplan.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.armazenamentosafraplan.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });
        vm.etapas = Etapa.query();

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "armazenamentosafraplan";
            vm.etapa.safra = vm.armazenamentosafraplan.safra;
            
            if (vm.armazenamentosafraplan.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
                Principal.identity().then(function (user) {
                    var data = {
                      user: user
                    };
                    vm.armazenamentosafraplan.criador = user.login;
                });
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.armazenamentosafraplan.etapa = new Etapa();
            vm.armazenamentosafraplan.etapa = result;
            Armazenamentosafraplan.save(vm.armazenamentosafraplan, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.armazenamentosafraplan.etapa = new Etapa();
            vm.armazenamentosafraplan.etapa = result;
            Armazenamentosafraplan.update(vm.armazenamentosafraplan, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraplanUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dataarmazenamento = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ArmazenamentosafraplanDetailController', ArmazenamentosafraplanDetailController);

    ArmazenamentosafraplanDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Armazenamentosafraplan', 'Safra', 'Etapa', 'Atividade'];

    function ArmazenamentosafraplanDetailController($scope, $rootScope, $stateParams, previousState, entity, Armazenamentosafraplan, Safra, Etapa, Atividade) {
        var vm = this;

        vm.armazenamentosafraplan = entity;
        vm.previousState = previousState.name;

        vm.atividades = [];

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.armazenamentosafraplan.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        }

        var unsubscribe = $rootScope.$on('netWordAgroApp:armazenamentosafraplanUpdate', function(event, result) {
            vm.armazenamentosafraplan = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ArmazenamentosafraplanDeleteController',ArmazenamentosafraplanDeleteController);

    ArmazenamentosafraplanDeleteController.$inject = ['$uibModalInstance', 'entity', 'Armazenamentosafraplan', 'Etapa'];

    function ArmazenamentosafraplanDeleteController($uibModalInstance, entity, Armazenamentosafraplan, Etapa) {
        var vm = this;

        vm.armazenamentosafraplan = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Armazenamentosafraplan.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    Etapa.delete({id: vm.armazenamentosafraplan.etapa.id},
                        function () {
                            $uibModalInstance.close(true);
                        });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('armazenamentosafraplan', {
            parent: 'entity',
            url: '/armazenamentosafraplan',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.armazenamentosafraplan.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/armazenamentosafraplan/armazenamentosafraplans.html',
                    controller: 'ArmazenamentosafraplanController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('armazenamentosafraplan');
                    $translatePartialLoader.addPart('tipomedidaarmaz');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('armazenamentosafraplan-detail', {
            parent: 'armazenamentosafraplan',
            url: '/armazenamentosafraplan/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.armazenamentosafraplan.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/armazenamentosafraplan/armazenamentosafraplan-detail.html',
                    controller: 'ArmazenamentosafraplanDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('armazenamentosafraplan');
                    $translatePartialLoader.addPart('tipomedidaarmaz');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Armazenamentosafraplan', function($stateParams, Armazenamentosafraplan) {
                    return Armazenamentosafraplan.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'armazenamentosafraplan',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('armazenamentosafraplan-detail.edit', {
            parent: 'armazenamentosafraplan-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/armazenamentosafraplan/armazenamentosafraplan-dialog.html',
                    controller: 'ArmazenamentosafraplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Armazenamentosafraplan', function(Armazenamentosafraplan) {
                            return Armazenamentosafraplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('armazenamentosafraplan.new', {
            parent: 'armazenamentosafraplan',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/armazenamentosafraplan/armazenamentosafraplan-dialog.html',
                    controller: 'ArmazenamentosafraplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dataarmazenamento: null,
                                quantidadearmazenada: null,
                                unidademedida: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('armazenamentosafraplan', null, { reload: 'armazenamentosafraplan' });
                }, function() {
                    $state.go('armazenamentosafraplan');
                });
            }]
        })
        .state('armazenamentosafraplan.edit', {
            parent: 'armazenamentosafraplan',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/armazenamentosafraplan/armazenamentosafraplan-dialog.html',
                    controller: 'ArmazenamentosafraplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Armazenamentosafraplan', function(Armazenamentosafraplan) {
                            return Armazenamentosafraplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('armazenamentosafraplan', null, { reload: 'armazenamentosafraplan' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('armazenamentosafraplan.delete', {
            parent: 'armazenamentosafraplan',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/armazenamentosafraplan/armazenamentosafraplan-delete-dialog.html',
                    controller: 'ArmazenamentosafraplanDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Armazenamentosafraplan', function(Armazenamentosafraplan) {
                            return Armazenamentosafraplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('armazenamentosafraplan', null, { reload: 'armazenamentosafraplan' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Armazenamentosafraplan', Armazenamentosafraplan);

    Armazenamentosafraplan.$inject = ['$resource', 'DateUtils'];

    function Armazenamentosafraplan ($resource, DateUtils) {
        var resourceUrl =  'api/armazenamentosafraplans/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataarmazenamento = DateUtils.convertLocalDateFromServer(data.dataarmazenamento);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dataarmazenamento = DateUtils.convertLocalDateToServer(copy.dataarmazenamento);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dataarmazenamento = DateUtils.convertLocalDateToServer(copy.dataarmazenamento);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('ArmazenamentosafraplanSearch', ArmazenamentosafraplanSearch);

    ArmazenamentosafraplanSearch.$inject = ['$resource'];

    function ArmazenamentosafraplanSearch($resource) {
        var resourceUrl =  'api/_search/armazenamentosafraplans/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ArmazenamentosafraplanController', ArmazenamentosafraplanController);

    ArmazenamentosafraplanController.$inject = ['Armazenamentosafraplan', 'ArmazenamentosafraplanSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function ArmazenamentosafraplanController(Armazenamentosafraplan, ArmazenamentosafraplanSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.armazenamentosafraplans = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                ArmazenamentosafraplanSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Armazenamentosafraplan.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.armazenamentosafraplans.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.armazenamentosafraplans = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.armazenamentosafraplans = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.armazenamentosafraplans = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ArmazenamentosafraDialogController', ArmazenamentosafraDialogController);

    ArmazenamentosafraDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Armazenamentosafra', 'Safra', 'Etapa', 'Principal'];

    function ArmazenamentosafraDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Armazenamentosafra, Safra, Etapa, Principal, Tipoetapa) {
        var vm = this;

        vm.armazenamentosafra = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.safras = Safra.query({filter: 'armazenamentosafra-is-null'});
        $q.all([vm.armazenamentosafra.$promise, vm.safras.$promise]).then(function() {
            if (!vm.armazenamentosafra.safra || !vm.armazenamentosafra.safra.id) {
                return $q.reject();
            }
            return Safra.get({id : vm.armazenamentosafra.safra.id}).$promise;
        }).then(function(safra) {
            vm.safras.push(safra);
        });
        vm.etapas = Etapa.query();

        vm.onSaveErrorEtapa = onSaveErrorEtapa;
        vm.onSaveSuccessEtapa = onSaveSuccessEtapa;
        vm.onUpdateSuccessEtapa = onUpdateSuccessEtapa;
        vm.onUpdateErrorEtapa = onUpdateErrorEtapa;
        vm.etapa = new Etapa();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.etapa.tipoetapa = "armazenamentosafra";
            vm.etapa.safra = vm.armazenamentosafra.safra;
            
            if (vm.armazenamentosafra.id !== null) {
                Etapa.update(vm.etapa, onUpdateSuccessEtapa, onUpdateErrorEtapa);

            } else {
                Principal.identity().then(function (user) {
                    var data = {
                      user: user
                    };
                    vm.armazenamentosafra.criador = user.login;
                });
                Etapa.save(vm.etapa, onSaveSuccessEtapa, onSaveErrorEtapa);
            }
        }

        
        function onSaveSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.armazenamentosafra.etapa = new Etapa();
            vm.armazenamentosafra.etapa = result;
            Armazenamentosafra.save(vm.armazenamentosafra, onSaveSuccess, onSaveError);
        }

        function onSaveErrorEtapa () {
            vm.isSaving = false;
        }

        function onUpdateSuccessEtapa (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.armazenamentosafra.etapa = new Etapa();
            vm.armazenamentosafra.etapa = result;
            Armazenamentosafra.update(vm.armazenamentosafra, onSaveSuccess, onSaveError);
        }

        function onUpdateErrorEtapa () {
            vm.isSaving = false;
        }
        

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:armazenamentosafraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;


        }

        function onSaveError () {
            vm.isSaving = false;
        }

        

        vm.datePickerOpenStatus.dataarmazenamento = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ArmazenamentosafraDetailController', ArmazenamentosafraDetailController);

    ArmazenamentosafraDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Armazenamentosafra', 'Safra', 'Etapa', 'Atividade'];

    function ArmazenamentosafraDetailController($scope, $rootScope, $stateParams, previousState, entity, Armazenamentosafra, Safra, Etapa, Atividade) {
        var vm = this;

        vm.armazenamentosafra = entity;
        vm.previousState = previousState.name;

        vm.atividades = [];

        loadAll();

        function loadAll(){
            Atividade.queryByEtapa({etapaid: vm.armazenamentosafra.etapa.id}, function(result) {
                vm.atividades = result;
                vm.searchQuery = null;
            });
        }

        var unsubscribe = $rootScope.$on('netWordAgroApp:armazenamentosafraUpdate', function(event, result) {
            vm.armazenamentosafra = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ArmazenamentosafraDeleteController',ArmazenamentosafraDeleteController);

    ArmazenamentosafraDeleteController.$inject = ['$uibModalInstance', 'entity', 'Armazenamentosafra', 'Etapa'];

    function ArmazenamentosafraDeleteController($uibModalInstance, entity, Armazenamentosafra, Etapa) {
        var vm = this;

        vm.armazenamentosafra = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Armazenamentosafra.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    Etapa.delete({id: vm.armazenamentosafra.etapa.id},
                        function () {
                            $uibModalInstance.close(true);
                        });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('armazenamentosafra', {
            parent: 'entity',
            url: '/armazenamentosafra',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.armazenamentosafra.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/armazenamentosafra/armazenamentosafras.html',
                    controller: 'ArmazenamentosafraController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('armazenamentosafra');
                    $translatePartialLoader.addPart('tipomedidaarmaz');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('armazenamentosafra-detail', {
            parent: 'armazenamentosafra',
            url: '/armazenamentosafra/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.armazenamentosafra.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/armazenamentosafra/armazenamentosafra-detail.html',
                    controller: 'ArmazenamentosafraDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('armazenamentosafra');
                    $translatePartialLoader.addPart('tipomedidaarmaz');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Armazenamentosafra', function($stateParams, Armazenamentosafra) {
                    return Armazenamentosafra.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'armazenamentosafra',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('armazenamentosafra-detail.edit', {
            parent: 'armazenamentosafra-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/armazenamentosafra/armazenamentosafra-dialog.html',
                    controller: 'ArmazenamentosafraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Armazenamentosafra', function(Armazenamentosafra) {
                            return Armazenamentosafra.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('armazenamentosafra.new', {
            parent: 'armazenamentosafra',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/armazenamentosafra/armazenamentosafra-dialog.html',
                    controller: 'ArmazenamentosafraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dataarmazenamento: null,
                                quantidadearmazenada: null,
                                unidademedida: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('armazenamentosafra', null, { reload: 'armazenamentosafra' });
                }, function() {
                    $state.go('armazenamentosafra');
                });
            }]
        })
        .state('armazenamentosafra.edit', {
            parent: 'armazenamentosafra',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/armazenamentosafra/armazenamentosafra-dialog.html',
                    controller: 'ArmazenamentosafraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Armazenamentosafra', function(Armazenamentosafra) {
                            return Armazenamentosafra.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('armazenamentosafra', null, { reload: 'armazenamentosafra' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('armazenamentosafra.delete', {
            parent: 'armazenamentosafra',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/armazenamentosafra/armazenamentosafra-delete-dialog.html',
                    controller: 'ArmazenamentosafraDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Armazenamentosafra', function(Armazenamentosafra) {
                            return Armazenamentosafra.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('armazenamentosafra', null, { reload: 'armazenamentosafra' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Armazenamentosafra', Armazenamentosafra);

    Armazenamentosafra.$inject = ['$resource', 'DateUtils'];

    function Armazenamentosafra ($resource, DateUtils) {
        var resourceUrl =  'api/armazenamentosafras/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataarmazenamento = DateUtils.convertLocalDateFromServer(data.dataarmazenamento);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dataarmazenamento = DateUtils.convertLocalDateToServer(copy.dataarmazenamento);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dataarmazenamento = DateUtils.convertLocalDateToServer(copy.dataarmazenamento);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('ArmazenamentosafraSearch', ArmazenamentosafraSearch);

    ArmazenamentosafraSearch.$inject = ['$resource'];

    function ArmazenamentosafraSearch($resource) {
        var resourceUrl =  'api/_search/armazenamentosafras/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ArmazenamentosafraController', ArmazenamentosafraController);

    ArmazenamentosafraController.$inject = ['Armazenamentosafra', 'ArmazenamentosafraSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function ArmazenamentosafraController(Armazenamentosafra, ArmazenamentosafraSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.armazenamentosafras = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                ArmazenamentosafraSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Armazenamentosafra.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.armazenamentosafras.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.armazenamentosafras = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.armazenamentosafras = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.armazenamentosafras = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ArmazenamentoinsumosDialogController', ArmazenamentoinsumosDialogController);

    ArmazenamentoinsumosDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Armazenamentoinsumos'];

    function ArmazenamentoinsumosDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Armazenamentoinsumos) {
        var vm = this;

        vm.armazenamentoinsumos = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.armazenamentoinsumos.id !== null) {
                Armazenamentoinsumos.update(vm.armazenamentoinsumos, onSaveSuccess, onSaveError);
            } else {
                Armazenamentoinsumos.save(vm.armazenamentoinsumos, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:armazenamentoinsumosUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ArmazenamentoinsumosDetailController', ArmazenamentoinsumosDetailController);

    ArmazenamentoinsumosDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Armazenamentoinsumos'];

    function ArmazenamentoinsumosDetailController($scope, $rootScope, $stateParams, previousState, entity, Armazenamentoinsumos) {
        var vm = this;

        vm.armazenamentoinsumos = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:armazenamentoinsumosUpdate', function(event, result) {
            vm.armazenamentoinsumos = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ArmazenamentoinsumosDeleteController',ArmazenamentoinsumosDeleteController);

    ArmazenamentoinsumosDeleteController.$inject = ['$uibModalInstance', 'entity', 'Armazenamentoinsumos'];

    function ArmazenamentoinsumosDeleteController($uibModalInstance, entity, Armazenamentoinsumos) {
        var vm = this;

        vm.armazenamentoinsumos = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Armazenamentoinsumos.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('armazenamentoinsumos', {
            parent: 'entity',
            url: '/armazenamentoinsumos',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.armazenamentoinsumos.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/armazenamentoinsumos/armazenamentoinsumos.html',
                    controller: 'ArmazenamentoinsumosController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('armazenamentoinsumos');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('armazenamentoinsumos-detail', {
            parent: 'armazenamentoinsumos',
            url: '/armazenamentoinsumos/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.armazenamentoinsumos.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/armazenamentoinsumos/armazenamentoinsumos-detail.html',
                    controller: 'ArmazenamentoinsumosDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('armazenamentoinsumos');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Armazenamentoinsumos', function($stateParams, Armazenamentoinsumos) {
                    return Armazenamentoinsumos.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'armazenamentoinsumos',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('armazenamentoinsumos-detail.edit', {
            parent: 'armazenamentoinsumos-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/armazenamentoinsumos/armazenamentoinsumos-dialog.html',
                    controller: 'ArmazenamentoinsumosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Armazenamentoinsumos', function(Armazenamentoinsumos) {
                            return Armazenamentoinsumos.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('armazenamentoinsumos.new', {
            parent: 'armazenamentoinsumos',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/armazenamentoinsumos/armazenamentoinsumos-dialog.html',
                    controller: 'ArmazenamentoinsumosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('armazenamentoinsumos', null, { reload: 'armazenamentoinsumos' });
                }, function() {
                    $state.go('armazenamentoinsumos');
                });
            }]
        })
        .state('armazenamentoinsumos.edit', {
            parent: 'armazenamentoinsumos',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/armazenamentoinsumos/armazenamentoinsumos-dialog.html',
                    controller: 'ArmazenamentoinsumosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Armazenamentoinsumos', function(Armazenamentoinsumos) {
                            return Armazenamentoinsumos.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('armazenamentoinsumos', null, { reload: 'armazenamentoinsumos' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('armazenamentoinsumos.delete', {
            parent: 'armazenamentoinsumos',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/armazenamentoinsumos/armazenamentoinsumos-delete-dialog.html',
                    controller: 'ArmazenamentoinsumosDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Armazenamentoinsumos', function(Armazenamentoinsumos) {
                            return Armazenamentoinsumos.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('armazenamentoinsumos', null, { reload: 'armazenamentoinsumos' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Armazenamentoinsumos', Armazenamentoinsumos);

    Armazenamentoinsumos.$inject = ['$resource'];

    function Armazenamentoinsumos ($resource) {
        var resourceUrl =  'api/armazenamentoinsumos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('ArmazenamentoinsumosSearch', ArmazenamentoinsumosSearch);

    ArmazenamentoinsumosSearch.$inject = ['$resource'];

    function ArmazenamentoinsumosSearch($resource) {
        var resourceUrl =  'api/_search/armazenamentoinsumos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ArmazenamentoinsumosController', ArmazenamentoinsumosController);

    ArmazenamentoinsumosController.$inject = ['Armazenamentoinsumos', 'ArmazenamentoinsumosSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function ArmazenamentoinsumosController(Armazenamentoinsumos, ArmazenamentoinsumosSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.armazenamentoinsumos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                ArmazenamentoinsumosSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Armazenamentoinsumos.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.armazenamentoinsumos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.armazenamentoinsumos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.armazenamentoinsumos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.armazenamentoinsumos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AquisicaosugeridaDialogController', AquisicaosugeridaDialogController);

    AquisicaosugeridaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Aquisicaosugerida', 'Aquisicao', 'Receituario', 'Atividade', 'Propriedade'];

    function AquisicaosugeridaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Aquisicaosugerida, Aquisicao, Receituario, Atividade, Propriedade) {
        var vm = this;

        vm.aquisicaosugerida = entity;
        vm.clear = clear;
        vm.save = save;
        vm.aprovar = aprovar;
        vm.aquisicaos = Aquisicao.query();
        vm.receituarios = Receituario.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
            history.go(-1);

        }

        function save () {
            vm.isSaving = true;
            if (vm.aquisicaosugerida.id !== null) {
                Aquisicaosugerida.update(vm.aquisicaosugerida, onSaveSuccess, onSaveError);
            } else {
                Aquisicaosugerida.save(vm.aquisicaosugerida, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:aquisicaosugeridaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            history.go(-1);
        }

        function onSaveError () {
            vm.isSaving = false;
            history.go(-1);
        }

        function aprovar(id){
            var aq = new Aquisicao();
            aq.produtoaquisitado = vm.aquisicaosugerida.produtoaquisitado;
            aq.valor = vm.aquisicaosugerida.valor;
            aq.quantidade = vm.aquisicaosugerida.quantidade;
            aq.medida = vm.aquisicaosugerida.medidaquantidade;
            aq.dataaquisicao = new Date();
            aq.aquisicaosugerida = new Aquisicaosugerida();
            aq.aquisicaosugerida.id = vm.aquisicaosugerida.id;
            aq.atividade = new Atividade();
            aq.atividade.id = vm.aquisicaosugerida.receituario.atividade.id;
            aq.propriedade = new Propriedade();
            aq.propriedade.id = vm.aquisicaosugerida.receituario.atividade.etapa.safra.propriedade.id;
            Aquisicao.save(aq, onSaveSuccess, onSaveError);
            aq = null;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AquisicaosugeridaDetailController', AquisicaosugeridaDetailController);

    AquisicaosugeridaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Aquisicaosugerida', 'Aquisicao', 'Receituario'];

    function AquisicaosugeridaDetailController($scope, $rootScope, $stateParams, previousState, entity, Aquisicaosugerida, Aquisicao, Receituario) {
        var vm = this;

        vm.aquisicaosugerida = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:aquisicaosugeridaUpdate', function(event, result) {
            vm.aquisicaosugerida = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AquisicaosugeridaDeleteController',AquisicaosugeridaDeleteController);

    AquisicaosugeridaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Aquisicaosugerida'];

    function AquisicaosugeridaDeleteController($uibModalInstance, entity, Aquisicaosugerida) {
        var vm = this;

        vm.aquisicaosugerida = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
            history.go(-1);
        }

        function confirmDelete (id) {
            Aquisicaosugerida.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    history.go(-1);

                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('aquisicaosugerida', {
            parent: 'entity',
            url: '/aquisicaosugerida',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.aquisicaosugerida.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/aquisicaosugerida/aquisicaosugeridas.html',
                    controller: 'AquisicaosugeridaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('aquisicaosugerida');
                    $translatePartialLoader.addPart('tipomedidaaquisicaosugerida');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('aquisicaosugerida-detail', {
            parent: 'aquisicaosugerida',
            url: '/aquisicaosugerida/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.aquisicaosugerida.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/aquisicaosugerida/aquisicaosugerida-detail.html',
                    controller: 'AquisicaosugeridaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('aquisicaosugerida');
                    $translatePartialLoader.addPart('tipomedidaaquisicaosugerida');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Aquisicaosugerida', function($stateParams, Aquisicaosugerida) {
                    return Aquisicaosugerida.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'aquisicaosugerida',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('aquisicaosugerida-detail.edit', {
            parent: 'aquisicaosugerida-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aquisicaosugerida/aquisicaosugerida-dialog.html',
                    controller: 'AquisicaosugeridaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Aquisicaosugerida', function(Aquisicaosugerida) {
                            return Aquisicaosugerida.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('aquisicaosugerida.new', {
            parent: 'aquisicaosugerida',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aquisicaosugerida/aquisicaosugerida-dialog.html',
                    controller: 'AquisicaosugeridaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                produtoaquisitado: null,
                                valor: null,
                                quantidade: null,
                                medidaquantidade: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('aquisicaosugerida', null, { reload: 'aquisicaosugerida' });
                }, function() {
                    $state.go('aquisicaosugerida');
                });
            }]
        })
        .state('aquisicaosugerida.edit', {
            parent: 'aquisicaosugerida',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aquisicaosugerida/aquisicaosugerida-dialog.html',
                    controller: 'AquisicaosugeridaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Aquisicaosugerida', function(Aquisicaosugerida) {
                            return Aquisicaosugerida.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('aquisicaosugerida', null, { reload: 'aquisicaosugerida' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('aquisicaosugerida.delete', {
            parent: 'aquisicaosugerida',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aquisicaosugerida/aquisicaosugerida-delete-dialog.html',
                    controller: 'AquisicaosugeridaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Aquisicaosugerida', function(Aquisicaosugerida) {
                            return Aquisicaosugerida.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('aquisicaosugerida', null, { reload: 'aquisicaosugerida' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('aquisicaosugerida.aprovar', {
            parent: 'aquisicaosugerida',
            url: '/{id}/aprovar',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aquisicaosugerida/aquisicaosugerida-aprovar-dialog.html',
                    controller: 'AquisicaosugeridaDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Aquisicaosugerida', function(Aquisicaosugerida) {
                            return Aquisicaosugerida.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('aquisicaosugerida', null, { reload: 'aquisicaosugerida' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Aquisicaosugerida', Aquisicaosugerida);

    Aquisicaosugerida.$inject = ['$resource'];

    function Aquisicaosugerida ($resource) {
        var resourceUrl =  'api/aquisicaosugeridas/:id';

        return $resource(resourceUrl, {}, {
            'queryByReceituario':{
                url: 'api/aquisicaosugeridas/receituarios/:recid',
                method: 'GET',
                isArray: true
            },
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('AquisicaosugeridaSearch', AquisicaosugeridaSearch);

    AquisicaosugeridaSearch.$inject = ['$resource'];

    function AquisicaosugeridaSearch($resource) {
        var resourceUrl =  'api/_search/aquisicaosugeridas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AquisicaosugeridaController', AquisicaosugeridaController);

    AquisicaosugeridaController.$inject = ['Aquisicaosugerida', 'AquisicaosugeridaSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function AquisicaosugeridaController(Aquisicaosugerida, AquisicaosugeridaSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.aquisicaosugeridas = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                AquisicaosugeridaSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Aquisicaosugerida.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.aquisicaosugeridas.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.aquisicaosugeridas = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.aquisicaosugeridas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.aquisicaosugeridas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AquisicaoplanDialogController', AquisicaoplanDialogController);

    AquisicaoplanDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Aquisicaoplan', 'Localarmazenamento', 'Atividade', 'Logrecinsumoplan', 'Principal', 'Propriedade'];

    function AquisicaoplanDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Aquisicaoplan, Localarmazenamento, Atividade, Logrecinsumoplan, Principal, Propriedade) {
        var vm = this;

        vm.aquisicaoplan = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.localarmazenamentos = Localarmazenamento.query();
        vm.atividades = Atividade.query();
        vm.logrecinsumoplans = Logrecinsumoplan.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.aquisicaoplan.id !== null) {
                Aquisicaoplan.update(vm.aquisicaoplan, onSaveSuccess, onSaveError);
            } else {
                Aquisicaoplan.save(vm.aquisicaoplan, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:aquisicaoplanUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dataaquisicao = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AquisicaoplanDetailController', AquisicaoplanDetailController);

    AquisicaoplanDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Aquisicaoplan', 'Localarmazenamento', 'Atividade', 'Logrecinsumoplan'];

    function AquisicaoplanDetailController($scope, $rootScope, $stateParams, previousState, entity, Aquisicaoplan, Localarmazenamento, Atividade, Logrecinsumoplan) {
        var vm = this;

        vm.aquisicaoplan = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:aquisicaoplanUpdate', function(event, result) {
            vm.aquisicaoplan = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AquisicaoplanDeleteController',AquisicaoplanDeleteController);

    AquisicaoplanDeleteController.$inject = ['$uibModalInstance', 'entity', 'Aquisicaoplan'];

    function AquisicaoplanDeleteController($uibModalInstance, entity, Aquisicaoplan) {
        var vm = this;

        vm.aquisicaoplan = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Aquisicaoplan.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('aquisicaoplan', {
            parent: 'entity',
            url: '/aquisicaoplan',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.aquisicaoplan.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/aquisicaoplan/aquisicaoplans.html',
                    controller: 'AquisicaoplanController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('aquisicaoplan');
                    $translatePartialLoader.addPart('tipomedidaquantidade');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('aquisicaoplan-detail', {
            parent: 'aquisicaoplan',
            url: '/aquisicaoplan/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.aquisicaoplan.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/aquisicaoplan/aquisicaoplan-detail.html',
                    controller: 'AquisicaoplanDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('aquisicaoplan');
                    $translatePartialLoader.addPart('tipomedidaquantidade');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Aquisicaoplan', function($stateParams, Aquisicaoplan) {
                    return Aquisicaoplan.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'aquisicaoplan',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('aquisicaoplan-detail.edit', {
            parent: 'aquisicaoplan-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aquisicaoplan/aquisicaoplan-dialog.html',
                    controller: 'AquisicaoplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Aquisicaoplan', function(Aquisicaoplan) {
                            return Aquisicaoplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('aquisicaoplan.new', {
            parent: 'aquisicaoplan',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aquisicaoplan/aquisicaoplan-dialog.html',
                    controller: 'AquisicaoplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                produtoaquisitado: null,
                                valor: null,
                                quantidade: null,
                                medidaquantidade: null,
                                dataaquisicao: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('aquisicaoplan', null, { reload: 'aquisicaoplan' });
                }, function() {
                    $state.go('aquisicaoplan');
                });
            }]
        })
        .state('aquisicaoplan.edit', {
            parent: 'aquisicaoplan',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aquisicaoplan/aquisicaoplan-dialog.html',
                    controller: 'AquisicaoplanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Aquisicaoplan', function(Aquisicaoplan) {
                            return Aquisicaoplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('aquisicaoplan', null, { reload: 'aquisicaoplan' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('aquisicaoplan.delete', {
            parent: 'aquisicaoplan',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aquisicaoplan/aquisicaoplan-delete-dialog.html',
                    controller: 'AquisicaoplanDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Aquisicaoplan', function(Aquisicaoplan) {
                            return Aquisicaoplan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('aquisicaoplan', null, { reload: 'aquisicaoplan' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Aquisicaoplan', Aquisicaoplan);

    Aquisicaoplan.$inject = ['$resource', 'DateUtils'];

    function Aquisicaoplan ($resource, DateUtils) {
        var resourceUrl =  'api/aquisicaoplans/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataaquisicao = DateUtils.convertLocalDateFromServer(data.dataaquisicao);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dataaquisicao = DateUtils.convertLocalDateToServer(copy.dataaquisicao);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dataaquisicao = DateUtils.convertLocalDateToServer(copy.dataaquisicao);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('AquisicaoplanSearch', AquisicaoplanSearch);

    AquisicaoplanSearch.$inject = ['$resource'];

    function AquisicaoplanSearch($resource) {
        var resourceUrl =  'api/_search/aquisicaoplans/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AquisicaoplanController', AquisicaoplanController);

    AquisicaoplanController.$inject = ['Aquisicaoplan', 'AquisicaoplanSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function AquisicaoplanController(Aquisicaoplan, AquisicaoplanSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.aquisicaoplans = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                AquisicaoplanSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Aquisicaoplan.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.aquisicaoplans.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.aquisicaoplans = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.aquisicaoplans = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.aquisicaoplans = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AquisicaoInsumoController',AquisicaoInsumoController);

    AquisicaoInsumoController.$inject = ['$uibModalInstance', 'entity', 'Aquisicao','Localarmazenamento', 'Insumo'];

    function AquisicaoInsumoController($uibModalInstance, entity, Aquisicao, Localarmazenamento, Insumo) {
        var vm = this;

        vm.aquisicao = entity;
        vm.insumo = insumo;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.clear = clear;

        vm.insumo.nome = vm.aquisicao.produtoaquisitado;
        vm.localarmazenamentos = Localarmazenamento.query();
        vm.insumo.aquisicao = vm.aquisicao.id;
        
        vm.armazenados = Insumo.query();

        vm.armazenados.$promise.then(function(data){
            var i = 0;
            vm.aquisicao.restante = vm.aquisicao.quantidade;
            
            for(i=0; i<data.length; i++){
                if(data[i].aquisicao.id === vm.aquisicao.id){
                    vm.aquisicao.restante = vm.aquisicao.restante - data[i].quantidadearmazenada;
                }
            }
            if(vm.aquisicao.restante===0){
                vm.ativado=true;
            }
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function insumo(id){
            vm.novoinsumo = new Insumo();
            vm.novoinsumo.quantidadearmazenada = vm.insumo.quantidadearmazenada;
            vm.novoinsumo.dataentrada = new Date(vm.insumo.dataentrada);
            vm.novoinsumo.aquisicao = new Aquisicao();
            vm.novoinsumo.aquisicao.id = id;
            vm.novoinsumo.quantidadedisponivel = vm.novoinsumo.quantidadearmazenada;
            vm.novoinsumo.localarmazenamento = new Localarmazenamento();
            vm.novoinsumo.localarmazenamento.id = vm.insumo.localarmazenamento.id;
            vm.novoinsumo.localarmazenamento.nomelocal = vm.insumo.localarmazenamento.nomelocal;
            vm.novoinsumo.nome = vm.insumo.nome + " em " + vm.insumo.localarmazenamento.nomelocal;

            console.log(vm.novoinsumo);
            Insumo.save(vm.novoinsumo, onSaveSuccess, onSaveError);
        }

        vm.datePickerOpenStatus.dataentrada = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

    
        function onSaveSuccess (result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AquisicaoDialogController', AquisicaoDialogController);

    AquisicaoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'DataUtils', 'entity', 'Aquisicao', 'Aquisicaosugerida', 'Insumo', 'Logrecinsumo', 'Propriedade', 'Atividade', 'Logrecinsumotestem'];

    function AquisicaoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, DataUtils, entity, Aquisicao, Aquisicaosugerida, Insumo, Logrecinsumo, Propriedade, Atividade, Logrecinsumotestem) {
        var vm = this;

        vm.aquisicao = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.aquisicaosugeridas = Aquisicaosugerida.query({filter: 'aquisicao-is-null'});
        $q.all([vm.aquisicao.$promise, vm.aquisicaosugeridas.$promise]).then(function() {
            if (!vm.aquisicao.aquisicaosugerida || !vm.aquisicao.aquisicaosugerida.id) {
                return $q.reject();
            }
            return Aquisicaosugerida.get({id : vm.aquisicao.aquisicaosugerida.id}).$promise;
        }).then(function(aquisicaosugerida) {
            vm.aquisicaosugeridas.push(aquisicaosugerida);
        });
        vm.insumos = Insumo.query();
        vm.logrecinsumos = Logrecinsumo.query();
        vm.propriedades = Propriedade.query();
        vm.atividades = Atividade.query();
        vm.logrecinsumotestems = Logrecinsumotestem.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.aquisicao.id !== null) {
                Aquisicao.update(vm.aquisicao, onSaveSuccess, onSaveError);
            } else {
                Aquisicao.save(vm.aquisicao, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:aquisicaoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setNotafiscal = function ($file, aquisicao) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        aquisicao.notafiscal = base64Data;
                        aquisicao.notafiscalContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AquisicaoDetailController', AquisicaoDetailController);

    AquisicaoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Aquisicao', 'Aquisicaosugerida', 'Insumo', 'Logrecinsumo', 'Propriedade', 'Atividade', 'Logrecinsumotestem'];

    function AquisicaoDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Aquisicao, Aquisicaosugerida, Insumo, Logrecinsumo, Propriedade, Atividade, Logrecinsumotestem) {
        var vm = this;

        vm.aquisicao = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('netWordAgroApp:aquisicaoUpdate', function(event, result) {
            vm.aquisicao = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AquisicaoDeleteController',AquisicaoDeleteController);

    AquisicaoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Aquisicao'];

    function AquisicaoDeleteController($uibModalInstance, entity, Aquisicao) {
        var vm = this;

        vm.aquisicao = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Aquisicao.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('aquisicao', {
            parent: 'entity',
            url: '/aquisicao',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.aquisicao.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/aquisicao/aquisicaos.html',
                    controller: 'AquisicaoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('aquisicao');
                    $translatePartialLoader.addPart('tipomedidaaquisicao');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('aquisicao-detail', {
            parent: 'aquisicao',
            url: '/aquisicao/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.aquisicao.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/aquisicao/aquisicao-detail.html',
                    controller: 'AquisicaoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('aquisicao');
                    $translatePartialLoader.addPart('tipomedidaaquisicao');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Aquisicao', function($stateParams, Aquisicao) {
                    return Aquisicao.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'aquisicao',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('aquisicao-detail.edit', {
            parent: 'aquisicao-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aquisicao/aquisicao-dialog.html',
                    controller: 'AquisicaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Aquisicao', function(Aquisicao) {
                            return Aquisicao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('aquisicao.new', {
            parent: 'aquisicao',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aquisicao/aquisicao-dialog.html',
                    controller: 'AquisicaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                produtoaquisitado: null,
                                valor: null,
                                quantidade: null,
                                medida: null,
                                notafiscal: null,
                                notafiscalContentType: null,
                                numeronota: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('aquisicao', null, { reload: 'aquisicao' });
                }, function() {
                    $state.go('aquisicao');
                });
            }]
        })
        .state('aquisicao.edit', {
            parent: 'aquisicao',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aquisicao/aquisicao-dialog.html',
                    controller: 'AquisicaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Aquisicao', function(Aquisicao) {
                            return Aquisicao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('aquisicao', null, { reload: 'aquisicao' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('aquisicao.delete', {
            parent: 'aquisicao',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aquisicao/aquisicao-delete-dialog.html',
                    controller: 'AquisicaoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Aquisicao', function(Aquisicao) {
                            return Aquisicao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('aquisicao', null, { reload: 'aquisicao' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('aquisicao.insumo', {
            parent: 'aquisicao',
            url: '/{id}/insumo',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aquisicao/aquisicao-insumo-dialog.html',
                    controller: 'AquisicaoInsumoController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Aquisicao', function(Aquisicao) {
                            return Aquisicao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('aquisicao', null, { reload: 'aquisicao' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Aquisicao', Aquisicao);

    Aquisicao.$inject = ['$resource'];

    function Aquisicao ($resource) {
        var resourceUrl =  'api/aquisicaos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('AquisicaoSearch', AquisicaoSearch);

    AquisicaoSearch.$inject = ['$resource'];

    function AquisicaoSearch($resource) {
        var resourceUrl =  'api/_search/aquisicaos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AquisicaoController', AquisicaoController);

    AquisicaoController.$inject = ['DataUtils', 'Aquisicao', 'AquisicaoSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function AquisicaoController(DataUtils, Aquisicao, AquisicaoSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.aquisicaos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                AquisicaoSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Aquisicao.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.aquisicaos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.aquisicaos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.aquisicaos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.aquisicaos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AprovacaomapaVisualizarController', AprovacaomapaVisualizarController);

    AprovacaomapaVisualizarController.$inject = ['DataUtils', 'Aprovacaomapa', 'Mapaimagem', 'ParseLinks', 'AlertService', 'paginationConstants', '$stateParams'];

    function AprovacaomapaVisualizarController(DataUtils, Aprovacaomapa, Mapaimagem, ParseLinks, AlertService, paginationConstants, $stateParams) {
        var vm = this;
        vm.carregando = true;
        vm.sucesso = sucesso;

        vm.idmapa = $stateParams.id;


        function sucesso(data){
            vm.fileURL = 'data:' + data[0].imagempequenaContentType +';base64,' + data[0].imagempequena;
            vm.carregando = false;
        }

        Aprovacaomapa.queryImagemPequena({mapaid: vm.idmapa}, vm.sucesso);

    
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AprovacaomapaDialogController', AprovacaomapaDialogController);

    AprovacaomapaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Aprovacaomapa', 'Safra', 'Atributo'];

    function AprovacaomapaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Aprovacaomapa, Safra, Atributo) {
        var vm = this;

        vm.aprovacaomapa = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.safras = Safra.querySafraIdNome(
            {size: 1000, sort:"nomesafra,asc"}
        );
        vm.atributos = Atributo.query({
            size:1000, sort:"nomeatributo,asc"
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.aprovacaomapa.id !== null) {
                console.log(vm.mapaimagem);
                vm.aprovacaomapa.data.setHours(0);
                Aprovacaomapa.update(vm.aprovacaomapa, onSaveSuccess, onSaveError);
            } else {
                Aprovacaomapa.save(vm.aprovacaomapa, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:aprovacaomapaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setImagem = function ($file, aprovacaomapa) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        aprovacaomapa.imagem = base64Data;
                        aprovacaomapa.imagemContentType = $file.type;
                    });
                });
            }
        };

        vm.setImagempequena = function ($file, aprovacaomapa) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        aprovacaomapa.imagempequena = base64Data;
                        aprovacaomapa.imagempequenaContentType = $file.type;
                    });
                });
            }
        };

        vm.setShapefile = function ($file, mapaimagem) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        mapaimagem.shapefile = base64Data;
                        mapaimagem.shapefileContentType = $file.type;
                    });
                });
            }
        };
        
        vm.setWKT = function ($file, mapaimagem) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        mapaimagem.wkt = base64Data;
                        mapaimagem.wktContentType = $file.type;
                    });
                });
            }
        };
        
        vm.setCSV = function ($file, mapaimagem) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        mapaimagem.csv = base64Data;
                        mapaimagem.csvContentType = $file.type;
                    });
                });
            }
        };

        vm.datePickerOpenStatus.data = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AprovacaomapaDetailController', AprovacaomapaDetailController);

    AprovacaomapaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Aprovacaomapa', 'Safra', 'Atributo'];

    function AprovacaomapaDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Aprovacaomapa, Safra, Atributo) {
        var vm = this;

        vm.aprovacaomapa = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('netWordAgroApp:aprovacaomapaUpdate', function(event, result) {
            vm.aprovacaomapa = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AprovacaomapaDeleteController',AprovacaomapaDeleteController);

    AprovacaomapaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Aprovacaomapa'];

    function AprovacaomapaDeleteController($uibModalInstance, entity, Aprovacaomapa) {
        var vm = this;

        vm.aprovacaomapa = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Aprovacaomapa.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AprovacaomapaAprovarController',AprovacaomapaAprovarController);

    AprovacaomapaAprovarController.$inject = ['$uibModalInstance', 'entity', 'Aprovacaomapa', 'Mapaimagem', 'Propriedade'];

    function AprovacaomapaAprovarController($uibModalInstance, entity, Aprovacaomapa, Mapaimagem, Propriedade) {
        var vm = this;

        vm.aprovacaomapa = entity;
        vm.clear = clear;
        vm.confirmarAprovacao = confirmarAprovacao;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmarAprovacao (id) {
            Aprovacaomapa.get({id: id}, function (data) {
                var mapa = new Mapaimagem();
                mapa = data;
                mapa.id = null;
                Propriedade.get({id: data.safra.propriedade.id}, function (prop) {
                    mapa.propriedade = prop;
                    Mapaimagem.save(mapa, function () {
                        Aprovacaomapa.delete({id: id}, function () {                   
                            $uibModalInstance.close(true);
                        });
                    });
                });
            });

            

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('aprovacaomapa', {
            parent: 'entity',
            url: '/aprovacaomapa',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.aprovacaomapa.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/aprovacaomapa/aprovacaomapas.html',
                    controller: 'AprovacaomapaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('aprovacaomapa');
                    $translatePartialLoader.addPart('tipoimagem');
                    $translatePartialLoader.addPart('mapaimagem');
                    $translatePartialLoader.addPart('tipomapa');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('aprovacaomapa-detail', {
            parent: 'aprovacaomapa',
            url: '/aprovacaomapa/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.aprovacaomapa.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/aprovacaomapa/aprovacaomapa-detail.html',
                    controller: 'AprovacaomapaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('aprovacaomapa');
                    $translatePartialLoader.addPart('tipoimagem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Aprovacaomapa', function($stateParams, Aprovacaomapa) {
                    return Aprovacaomapa.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'aprovacaomapa',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('aprovacaomapa-detail.edit', {
            parent: 'aprovacaomapa-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aprovacaomapa/aprovacaomapa-dialog.html',
                    controller: 'AprovacaomapaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Aprovacaomapa', function(Aprovacaomapa) {
                            return Aprovacaomapa.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('aprovacaomapa.new', {
            parent: 'aprovacaomapa',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aprovacaomapa/aprovacaomapa-dialog.html',
                    controller: 'AprovacaomapaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nomemapa: null,
                                imagem: null,
                                imagemContentType: null,
                                imagempequena: null,
                                imagempequenaContentType: null,
                                latitudecentro: null,
                                longitudecentro: null,
                                tipoimagem: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('aprovacaomapa', null, { reload: 'aprovacaomapa' });
                }, function() {
                    $state.go('aprovacaomapa');
                });
            }]
        })
        .state('aprovacaomapa.edit', {
            parent: 'aprovacaomapa',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aprovacaomapa/aprovacaomapa-dialog.html',
                    controller: 'AprovacaomapaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Aprovacaomapa', function(Aprovacaomapa) {
                            return Aprovacaomapa.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('aprovacaomapa', null, { reload: 'aprovacaomapa' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('aprovacaomapa-visualizarimagem', {
            parent: 'aprovacaomapa',
            url: '/visualizarimagem/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.mapaimagem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/aprovacaomapa/aprovacaomapa-visualizar.html',
                    controller: 'AprovacaomapaVisualizarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('aprovacaomapa');
                    $translatePartialLoader.addPart('tipoimagem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', function($stateParams, Aprovacaomapa) {
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'aprovacaomapa',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('aprovacaomapa.aprovar', {
            parent: 'aprovacaomapa',
            url: '/{id}/aprovar',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aprovacaomapa/aprovacaomapa-aprovar.html',
                    controller: 'AprovacaomapaAprovarController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Aprovacaomapa', function(Aprovacaomapa) {
                            return Aprovacaomapa.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('aprovacaomapa', null, { reload: 'aprovacaomapa' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('aprovacaomapa.delete', {
            parent: 'aprovacaomapa',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aprovacaomapa/aprovacaomapa-delete-dialog.html',
                    controller: 'AprovacaomapaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Aprovacaomapa', function(Aprovacaomapa) {
                            return Aprovacaomapa.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('aprovacaomapa', null, { reload: 'aprovacaomapa' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Aprovacaomapa', Aprovacaomapa);

    Aprovacaomapa.$inject = ['$resource'];

    function Aprovacaomapa ($resource) {
        var resourceUrl =  'api/aprovacaomapas/:id';

        return $resource(resourceUrl, {}, {
            'queryImagemPequena': { 
                url: '/api/aprovacaomapas/imagempequena/:mapaid',
                method: 'GET', 
                isArray: true
            },
            'queryImagem': { 
                url: '/api/aprovacaomapas/imagemgrande/:mapaid',
                method: 'GET', 
                isArray: true
            },
            'queryComparativoPragaSaude': { 
                url: '/api/aprovacaomapapraga/:safraid/:busca',
                method: 'GET', 
                isArray: true},
            'queryComparativoNutricional': { 
                url: '/api/aprovacaomapanutricional/:safraid/:busca',
                method: 'GET', 
                isArray: true},
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'queryShapefile': { 
                url: '/api/aprovacaomapasshapefile/:mapaid',
                method: 'GET', 
                isArray: true},
            'queryCSV': { 
                url: '/api/aprovacaomapascsv/:mapaid',
                method: 'GET', 
                isArray: true},
            'queryWKT': { 
                url: '/api/aprovacaomapaswkt/:mapaid',
                method: 'GET', 
                isArray: true},
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('AprovacaomapaSearch', AprovacaomapaSearch);

    AprovacaomapaSearch.$inject = ['$resource'];

    function AprovacaomapaSearch($resource) {
        var resourceUrl =  'api/_search/aprovacaomapas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AprovacaomapaController', AprovacaomapaController);

    AprovacaomapaController.$inject = ['DataUtils', 'Aprovacaomapa', 'AprovacaomapaSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'Propriedade'];

    function AprovacaomapaController(DataUtils, Aprovacaomapa, AprovacaomapaSearch, ParseLinks, AlertService, paginationConstants, Propriedade) {

        var vm = this;

        vm.aprovacaomapas = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = false;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.sucessoDownload = sucessoDownload;
        vm.download = download;
        vm.carregaImagem = carregaImagem;
        vm.imagens = {};
        
        vm.download = download;
        vm.sucessoDownload = sucessoDownload;

        vm.downloadShape = downloadShape;
        vm.sucessoDownloadShape = sucessoDownloadShape;
        
        vm.downloadWKT = downloadWKT;
        vm.sucessoDownloadWKT = sucessoDownloadWKT;
        
        vm.downloadCSV = downloadCSV;
        vm.sucessoDownloadCSV = sucessoDownloadCSV;

        vm.filtropropriedade = null;

        vm.filtropropriedades = Propriedade.queryNomesPropriedades({
            size: 1000
        });

        vm.changeFiltro = function (){
            console.log("Propriedade alterada!");
            console.log(vm.filtropropriedade);
            vm.page = 0;
            vm.aprovacaomapas = [];
            loadAll();
        };


        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                AprovacaomapaSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Aprovacaomapa.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                /*
                for (var i = 0; i < data.length; i++) {
                    vm.aprovacaomapas.push(data[i]);
                    vm.carregaImagem(data[i].id);
                }*/

                for(var i = 0; i < data.length; i++) {
                    if(vm.filtropropriedade === null || parseInt(vm.filtropropriedade.id) === data[i].propriedade_id){
                        console.log("Added");
                        vm.aprovacaomapas.push(data[i]);
                        vm.carregaImagem(data[i].id);
                    }
                }
                if(vm.aprovacaomapas.length == 0 && vm.page < vm.links['last']){
                    console.log("Vazio");
                    vm.page = vm.page + 1;
                    loadPage(vm.page);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.aprovacaomapas = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.aprovacaomapas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.aprovacaomapas = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }

        function b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;
          
            var byteCharacters = atob(b64Data);
            var byteArrays = [];
          
            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);
            
                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
            
                var byteArray = new Uint8Array(byteNumbers);
            
                byteArrays.push(byteArray);
            }
          
            var blob = new Blob(byteArrays, {type: contentType});
            return blob;
        }

        function sucessoDownload(data){
            var filename = 'mapa';
            console.log("SUCESSO");
            var ct = data[0].imagemContentType;
            var dados = data[0].imagem;
            
            /*
                element.setAttribute('href', 'data:' + ct + ';base64,' + dados);
                element.setAttribute('download', 'download');
            
                element.style.display = 'none';
                
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            */

           var blob = b64toBlob(dados, ct);

           if(window.navigator.msSaveOrOpenBlob) {
               window.navigator.msSaveBlob(blob, filename);
           }
           else{
               var elem = window.document.createElement('a');
               elem.href = window.URL.createObjectURL(blob);
               elem.download = filename;        
               document.body.appendChild(elem);
               elem.click();        
               document.body.removeChild(elem);
           }
        }

        
        function download(id){
            
            Aprovacaomapa.queryImagem({mapaid: id}, vm.sucessoDownload);
        }
    

        function carregaImagem(id){
            Aprovacaomapa.queryImagemPequena({mapaid: id}, function (data) {
                var fileURL = 'data:' + data[0].imagempequenaContentType +';base64,' + data[0].imagempequena;
                vm.imagens[id] = fileURL;
            });
        }

        // Download Shapefiles / CSV / WKT

        function b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;
          
            var byteCharacters = atob(b64Data);
            var byteArrays = [];
          
            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);
            
                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
            
                var byteArray = new Uint8Array(byteNumbers);
            
                byteArrays.push(byteArray);
            }
          
            var blob = new Blob(byteArrays, {type: contentType});
            return blob;
        }

        function sucessoDownload(data){
            var filename = 'mapa';
            console.log("SUCESSO");
            var ct = data[0].imagemContentType;
            var dados = data[0].imagem;

           var blob = b64toBlob(dados, ct);

           if(window.navigator.msSaveOrOpenBlob) {
               window.navigator.msSaveBlob(blob, filename);
           }
           else{
               var elem = window.document.createElement('a');
               elem.href = window.URL.createObjectURL(blob);
               elem.download = filename;
               document.body.appendChild(elem);
               elem.click();
               document.body.removeChild(elem);
           }
        }
        
        function sucessoDownloadShape(data){
            var filename = 'shapefile';
            console.log("SUCESSO");
            var ct = data[0].shapefileContentType;
            var dados = data[0].shapefile;
            
            if(ct === null) {
                alert("Nenhum shapefile associado ao mapa");
                return;
            }

            /*
                element.setAttribute('href', 'data:' + ct + ';base64,' + dados);
                element.setAttribute('download', 'download');
            
                element.style.display = 'none';
                
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            */

           var blob = b64toBlob(dados, ct);

           if(window.navigator.msSaveOrOpenBlob) {
               window.navigator.msSaveBlob(blob, filename);
           }
           else{
               var elem = window.document.createElement('a');
               elem.href = window.URL.createObjectURL(blob);
               elem.download = filename;        
               document.body.appendChild(elem);
               elem.click();        
               document.body.removeChild(elem);
           }
        }
        
        function sucessoDownloadCSV(data){
            var filename = 'proposta.csv';
            console.log("SUCESSO");
            var ct = data[0].csvContentType;
            var dados = data[0].csv;
            
            if(ct === null) {
                alert("Nenhuma proposta associada ao mapa");
                return;
            }

           var blob = b64toBlob(dados, ct);

           if(window.navigator.msSaveOrOpenBlob) {
               window.navigator.msSaveBlob(blob, filename);
           }
           else{
               var elem = window.document.createElement('a');
               elem.href = window.URL.createObjectURL(blob);
               elem.download = filename;        
               document.body.appendChild(elem);
               elem.click();        
               document.body.removeChild(elem);
           }
        }
        
        function sucessoDownloadWKT(data){
            var filename = 'wkt.wkt';
            console.log("SUCESSO");
            var ct = data[0].wktContentType;
            var dados = data[0].wkt;
            
            if(ct === null) {
                alert("Nenhum wkt associado ao mapa");
                return;
            }

           var blob = b64toBlob(dados, ct);

           if(window.navigator.msSaveOrOpenBlob) {
               window.navigator.msSaveBlob(blob, filename);
           }
           else{
               var elem = window.document.createElement('a');
               elem.href = window.URL.createObjectURL(blob);
               elem.download = filename;        
               document.body.appendChild(elem);
               elem.click();        
               document.body.removeChild(elem);
           }
        }

        function downloadShape(id){
            Aprovacaomapa.queryShapefile({mapaid: id}, vm.sucessoDownloadShape);
        }

        function downloadCSV(id){
            Aprovacaomapa.queryCSV({mapaid: id}, vm.sucessoDownloadCSV);
        }
        
        function downloadWKT(id){
            Aprovacaomapa.queryWKT({mapaid: id}, vm.sucessoDownloadWKT);
        }
    }
    
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AplicacaoDialogController', AplicacaoDialogController);

    AplicacaoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Aplicacao', 'Atividade', 'Quadrantesolo'];

    function AplicacaoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Aplicacao, Atividade, Quadrantesolo) {
        var vm = this;

        vm.aplicacao = entity;
        vm.clear = clear;
        vm.save = save;
        vm.atividades = Atividade.query();
        vm.quadrantesolos = Quadrantesolo.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.aplicacao.id !== null) {
                Aplicacao.update(vm.aplicacao, onSaveSuccess, onSaveError);
            } else {
                Aplicacao.save(vm.aplicacao, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:aplicacaoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AplicacaoDetailController', AplicacaoDetailController);

    AplicacaoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Aplicacao', 'Atividade', 'Quadrantesolo'];

    function AplicacaoDetailController($scope, $rootScope, $stateParams, previousState, entity, Aplicacao, Atividade, Quadrantesolo) {
        var vm = this;

        vm.aplicacao = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:aplicacaoUpdate', function(event, result) {
            vm.aplicacao = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AplicacaoDeleteController',AplicacaoDeleteController);

    AplicacaoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Aplicacao'];

    function AplicacaoDeleteController($uibModalInstance, entity, Aplicacao) {
        var vm = this;

        vm.aplicacao = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Aplicacao.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('aplicacao', {
            parent: 'entity',
            url: '/aplicacao',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.aplicacao.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/aplicacao/aplicacaos.html',
                    controller: 'AplicacaoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('aplicacao');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('aplicacao-detail', {
            parent: 'aplicacao',
            url: '/aplicacao/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.aplicacao.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/aplicacao/aplicacao-detail.html',
                    controller: 'AplicacaoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('aplicacao');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Aplicacao', function($stateParams, Aplicacao) {
                    return Aplicacao.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'aplicacao',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('aplicacao-detail.edit', {
            parent: 'aplicacao-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aplicacao/aplicacao-dialog.html',
                    controller: 'AplicacaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Aplicacao', function(Aplicacao) {
                            return Aplicacao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('aplicacao.new', {
            parent: 'aplicacao',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aplicacao/aplicacao-dialog.html',
                    controller: 'AplicacaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('aplicacao', null, { reload: 'aplicacao' });
                }, function() {
                    $state.go('aplicacao');
                });
            }]
        })
        .state('aplicacao.edit', {
            parent: 'aplicacao',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aplicacao/aplicacao-dialog.html',
                    controller: 'AplicacaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Aplicacao', function(Aplicacao) {
                            return Aplicacao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('aplicacao', null, { reload: 'aplicacao' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('aplicacao.delete', {
            parent: 'aplicacao',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aplicacao/aplicacao-delete-dialog.html',
                    controller: 'AplicacaoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Aplicacao', function(Aplicacao) {
                            return Aplicacao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('aplicacao', null, { reload: 'aplicacao' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Aplicacao', Aplicacao);

    Aplicacao.$inject = ['$resource'];

    function Aplicacao ($resource) {
        var resourceUrl =  'api/aplicacaos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('AplicacaoSearch', AplicacaoSearch);

    AplicacaoSearch.$inject = ['$resource'];

    function AplicacaoSearch($resource) {
        var resourceUrl =  'api/_search/aplicacaos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AplicacaoController', AplicacaoController);

    AplicacaoController.$inject = ['Aplicacao', 'AplicacaoSearch', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function AplicacaoController(Aplicacao, AplicacaoSearch, ParseLinks, AlertService, paginationConstants) {

        var vm = this;

        vm.aplicacaos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                AplicacaoSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Aplicacao.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.aplicacaos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.aplicacaos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.aplicacaos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.aplicacaos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AlocacaoinsumosDialogController', AlocacaoinsumosDialogController);

    AlocacaoinsumosDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Alocacaoinsumos', 'Servico', 'Insumo'];

    function AlocacaoinsumosDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Alocacaoinsumos, Servico, Insumo) {
        var vm = this;

        vm.alocacaoinsumos = entity;
        vm.clear = clear;
        vm.mudaSelecao = mudaSelecao;
        vm.save = save;
        vm.servicos = Servico.query();
        vm.insumos = Insumo.query();
        var idservico = $stateParams.idservico;

        if(vm.alocacaoinsumos.id!==null){
            mudaSelecao();
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
            history.go(-1);
        }

        function save () {
            vm.isSaving = true;
            vm.alocacaoinsumos.servico = new Servico();
            vm.alocacaoinsumos.servico.id = idservico;
            if (vm.alocacaoinsumos.id !== null) {
                Alocacaoinsumos.update(vm.alocacaoinsumos, onSaveSuccess, onSaveError);
            } else {
                Alocacaoinsumos.save(vm.alocacaoinsumos, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:alocacaoinsumosUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            history.go(-1);
        }

        function onSaveError () {
            vm.isSaving = false;
            history.go(-1);
        }

        function mudaSelecao(){
            Insumo.get({id: vm.alocacaoinsumos.insumo.id}).$promise.then(function(data){
                vm.alocacaoinsumos.medida = data.aquisicao.medida;
                vm.restante = data.quantidadedisponivel;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AlocacaoinsumosDetailController', AlocacaoinsumosDetailController);

    AlocacaoinsumosDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Alocacaoinsumos', 'Servico', 'Insumo'];

    function AlocacaoinsumosDetailController($scope, $rootScope, $stateParams, previousState, entity, Alocacaoinsumos, Servico, Insumo) {
        var vm = this;

        vm.alocacaoinsumos = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:alocacaoinsumosUpdate', function(event, result) {
            vm.alocacaoinsumos = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AlocacaoinsumosDeleteController',AlocacaoinsumosDeleteController);

    AlocacaoinsumosDeleteController.$inject = ['$uibModalInstance', 'entity', 'Alocacaoinsumos'];

    function AlocacaoinsumosDeleteController($uibModalInstance, entity, Alocacaoinsumos) {
        var vm = this;

        vm.alocacaoinsumos = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Alocacaoinsumos.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    history.go(-1);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('alocacaoinsumos', {
            parent: 'entity',
            url: '/alocacaoinsumos',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.alocacaoinsumos.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/alocacaoinsumos/alocacaoinsumos.html',
                    controller: 'AlocacaoinsumosController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('alocacaoinsumos');
                    $translatePartialLoader.addPart('tipomedidaalocacao');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('alocacaoinsumos-detail', {
            parent: 'alocacaoinsumos',
            url: '/alocacaoinsumos/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'netWordAgroApp.alocacaoinsumos.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/alocacaoinsumos/alocacaoinsumos-detail.html',
                    controller: 'AlocacaoinsumosDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('alocacaoinsumos');
                    $translatePartialLoader.addPart('tipomedidaalocacao');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Alocacaoinsumos', function($stateParams, Alocacaoinsumos) {
                    return Alocacaoinsumos.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'alocacaoinsumos',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('alocacaoinsumos-detail.edit', {
            parent: 'alocacaoinsumos-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/alocacaoinsumos/alocacaoinsumos-dialog.html',
                    controller: 'AlocacaoinsumosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Alocacaoinsumos', function(Alocacaoinsumos) {
                            return Alocacaoinsumos.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('alocacaoinsumos.new', {
            parent: 'alocacaoinsumos',
            url: '/new?{idservico}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/alocacaoinsumos/alocacaoinsumos-dialog.html',
                    controller: 'AlocacaoinsumosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                quantidade: null,
                                medida: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('alocacaoinsumos', null, { reload: 'alocacaoinsumos' });
                }, function() {
                    $state.go('alocacaoinsumos');
                });
            }]
        })
        .state('alocacaoinsumos.edit', {
            parent: 'alocacaoinsumos',
            url: '/{id}/edit?{idservico}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/alocacaoinsumos/alocacaoinsumos-dialog.html',
                    controller: 'AlocacaoinsumosDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Alocacaoinsumos', function(Alocacaoinsumos) {
                            return Alocacaoinsumos.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('alocacaoinsumos', null, { reload: 'alocacaoinsumos' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('alocacaoinsumos.delete', {
            parent: 'alocacaoinsumos',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/alocacaoinsumos/alocacaoinsumos-delete-dialog.html',
                    controller: 'AlocacaoinsumosDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Alocacaoinsumos', function(Alocacaoinsumos) {
                            return Alocacaoinsumos.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('alocacaoinsumos', null, { reload: 'alocacaoinsumos' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Alocacaoinsumos', Alocacaoinsumos);

    Alocacaoinsumos.$inject = ['$resource'];

    function Alocacaoinsumos ($resource) {
        var resourceUrl =  'api/alocacaoinsumos/:id';

        return $resource(resourceUrl, {}, {
            'queryByServico': {
                url: 'api/alocacaoinsumos/servicos/:id',
                method: 'GET',
                isArray: 'true'
            },
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('AlocacaoinsumosSearch', AlocacaoinsumosSearch);

    AlocacaoinsumosSearch.$inject = ['$resource'];

    function AlocacaoinsumosSearch($resource) {
        var resourceUrl =  'api/_search/alocacaoinsumos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AlocacaoinsumosController', AlocacaoinsumosController);

    AlocacaoinsumosController.$inject = ['Alocacaoinsumos', 'AlocacaoinsumosSearch', 'ParseLinks', 'AlertService', '$stateParams', 'paginationConstants'];

    function AlocacaoinsumosController(Alocacaoinsumos, AlocacaoinsumosSearch, ParseLinks, AlertService, $stateParams, paginationConstants) {

        var vm = this;

        vm.alocacaoinsumos = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;


        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                AlocacaoinsumosSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Alocacaoinsumos.query({
                    page: vm.page,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.alocacaoinsumos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.alocacaoinsumos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.alocacaoinsumos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.alocacaoinsumos = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info" data-translate="global.item-count" ' +
        'translate-value-first="{{(($ctrl.page - 1) * $ctrl.itemsPerPage) === 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}}" ' +
        'translate-value-second="{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}}" ' +
        'translate-value-total="{{$ctrl.queryCount}}">' +
        'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
        '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
        'of {{$ctrl.queryCount}} items.' +
        '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('netWordAgroApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .constant('errorConstants', (function() {
            var problemBaseUrl = 'http://www.jhipster.tech/problem';
            return {
                EMAIL_ALREADY_USED_TYPE: problemBaseUrl + '/email-already-used',
                LOGIN_ALREADY_USED_TYPE: problemBaseUrl + '/login-already-used',
                EMAIL_NOT_FOUND_TYPE: problemBaseUrl + '/email-not-found'
            }
        })());
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1]-1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            var fileURL = 'data:' + type +';base64,' + data;
            var win = $window.open('', '_blank');
            win.document.write(
                '<iframe src="' +
                fileURL +
                '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
            );
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .filter('findLanguageFromKey', findLanguageFromKey)
        .filter('findLanguageRtlFromKey', findLanguageRtlFromKey);

    var languages = {
        'en': { name: 'English' },
        'pt-br': { name: 'Português (Brasil)' },
        'es': { name: 'Español' }
        // jhipster-needle-i18n-language-key-pipe - JHipster will add/remove languages in this object
    };

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return languages[lang].name;
        }
    }

    function findLanguageRtlFromKey() {
        return findLanguageRtlFromKeyFilter;

        function findLanguageRtlFromKeyFilter(lang) {
            return languages[lang].rtl;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('netWordAgroApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'pt-br',
            'en',
            'es'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('netWordAgroApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('netWordAgroApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (angular.isString(errorHeader)) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('netWordAgroApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('netWordAgroApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('netWordAgroApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            if (!config || !config.url || /^http/.test(config.url)) return config;

            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }


        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "pt-br"');
                $cookies.putObject(name, 'pt-br');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider', 'BUILD_TIMESTAMP'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider, BUILD_TIMESTAMP) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json' + (BUILD_TIMESTAMP ? '?build=' + BUILD_TIMESTAMP : '')
        });

        $translateProvider.preferredLanguage('pt-br');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('netWordAgroApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('BUILD_TIMESTAMP', 1698946944482)
;
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_PROPRIETARIO', 'ROLE_ENGENHEIRO_AGRONOMO', 'ROLE_FUNC_ADMINISTRATIVO', 'ROLE_FUNC_OPERACIONAL', 'ROLE_GESTOR_PROP', 'ROLE_PROPRIETARIO COOPERADO', "ROLE_TECNICO_CAMPO", "ROLE_GESTOR_PARCEIROS"];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load(login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/{login}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_PROPRIETARIO', 'ROLE_ENGENHEIRO_AGRONOMO', 'ROLE_FUNC_ADMINISTRATIVO', 'ROLE_FUNC_OPERACIONAL', 'ROLE_GESTOR_PROP', 'ROLE_PROPRIETARIO COOPERADO', "ROLE_TECNICO_CAMPO", "ROLE_GESTOR_PARCEIROS"];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.includes('web.rest') || key.includes('service')) {
                    vm.servicesStats[key] = value;
                }
            });

        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('netWordAgroApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ElasticsearchReindexDialogController', ElasticsearchReindexDialogController);

    ElasticsearchReindexDialogController.$inject = ['$uibModalInstance', 'ElasticsearchReindex'];

    function ElasticsearchReindexDialogController($uibModalInstance, ElasticsearchReindex) {
        var vm = this;

        vm.clear = clear;
        vm.confirmReindex = confirmReindex;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmReindex() {
            ElasticsearchReindex.reindex(function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('elasticsearch-reindex', {
            parent: 'admin',
            url: '/elasticsearch-reindex',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'elasticsearch.reindex.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex.html',
                    controller: 'ElasticsearchReindexController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('elasticsearch-reindex');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('elasticsearch-reindex.dialog', {
            parent: 'elasticsearch-reindex',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html',
                    controller: 'ElasticsearchReindexDialogController',
                    controllerAs: 'vm',
                    size: 'sm'
                }).result.finally(function () {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('ElasticsearchReindex', ElasticsearchReindex);

    ElasticsearchReindex.$inject = ['$resource'];

    function ElasticsearchReindex($resource) {
        var service = $resource('api/elasticsearch/index', {}, {
            'reindex': {method: 'POST'}
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ElasticsearchReindexController', ElasticsearchReindexController);

    ElasticsearchReindexController.$inject = [];

    function ElasticsearchReindexController() {
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth', 'errorConstants'];

    function RequestResetController ($timeout, Auth, errorConstants) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_NOT_FOUND_TYPE) {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService', 'errorConstants'];

    function RegisterController ($translate, $timeout, Auth, LoginService, errorConstants) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.LOGIN_ALREADY_USED_TYPE) {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_ALREADY_USED_TYPE) {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('netWordAgroApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="img-responsive img-rounded"><img src="content/images/logo.png" width="100%"></span></div><div class="col-md-8"><h1 data-translate="home.title">Welcome, Java Hipster!</h1><div ng-switch="vm.isAuthenticated()"><div class="alert alert-success" ng-switch-when="true" data-translate="home.logged.message" translate-values="{username: \'{{vm.account.login}}\'}">You are logged in as user "{{vm.account.login}}".</div></div><p data-translate="home.question">If you have any question on JHipster:</p><ul><li><a href="http://www.networdtecnologia.com.br/" target="_blank" rel="noopener" data-translate="home.link.homepage">Netword Tecnologia</a></li><li><a href="http://www.networdtecnologia.com.br/demoNWAgro.html" target="_blank" rel="noopener" data-translate="home.link.demonstracao">Demonstra\xE7\xE3o NetWordAgro</a></li><!--\n                <li><a href="http://stackoverflow.com/tags/jhipster/info" target="_blank" rel="noopener" data-translate="home.link.stackoverflow">JHipster on Stack Overflow</a></li>\n                <li><a href="https://github.com/jhipster/generator-jhipster/issues?state=open" target="_blank" rel="noopener" data-translate="home.link.bugtracker">JHipster bug tracker</a></li>\n                <li><a href="https://gitter.im/jhipster/generator-jhipster" target="_blank" rel="noopener" data-translate="home.link.chat">JHipster public chat room</a></li>\n                <li><a href="https://twitter.com/java_hipster" target="_blank" rel="noopener" data-translate="home.link.follow">follow @java_hipster on Twitter</a></li>\n                --></ul><p><span data-translate="home.like">If you like JHipster, don\'t forget to give us a star on </span>&nbsp;<a href="https://facebook.com/NetWordTecnologia" target="_blank" rel="noopener" data-translate="home.github">GitHub</a>!</p></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>Email is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" data-translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form><p></p><div class="alert alert-warning" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><h3 ng-hide="filteredConfig.length === 0">Spring configuration</h3><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length === 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-success break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><h4 ng-hide="filtered.length === 0"><span>{{key}}</span></h4><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length === 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-success break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html','<form name="reindexForm" ng-submit="vm.confirmReindex()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="elasticsearch.reindex.dialog.title">Confirm reindex operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="elasticsearch.reindex.dialog.question">Are you sure you want to reindex Elasticsearch? This could take a while!</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span data-translate="elasticsearch.reindex.dialog.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-exclamation-sign"></span>&nbsp; <span data-translate="elasticsearch.reindex.dialog.confirm">Reindex</span></button></div></form>');
$templateCache.put('app/admin/elasticsearch-reindex/elasticsearch-reindex.html','<div class="clearfix"><h1 data-translate="elasticsearch.reindex.title">Reindex Elasticsearch</h1><jhi-alert></jhi-alert><p data-translate="elasticsearch.reindex.instructions1">This will send a request to reindex all data from your primary datasource into Elasticsearch. This will fix missing data and mapping issues, however you will lose any ES data and mapping that was defined outside of your application. This request will return immediately and the reindexing will run in the background. You will see "Elasticsearch: Successfully performed reindexing" in your logs when this is complete.</p><p data-translate="elasticsearch.reindex.instructions2">This can take a long time and is susceptible to concurrency issues so it should be performed when the number of users is low.</p><button type="button" class="btn btn-primary pull-right" ui-sref="elasticsearch-reindex.dialog"><span class="glyphicon glyphicon-exclamation-sign"></span> <span data-translate="elasticsearch.reindex.go">Go</span></button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> [<b>{{vm.user.login}}</b>]</h2><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated" data-translate="userManagement.deactivated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated" data-translate="userManagement.activated">Activated</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.user.id"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" required ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="vm.currentAccount.login === user.login" data-translate="userManagement.activated">Activated</button></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login === user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav ng-show="!(vm.$state.includes(\'mapa-interativo-mobile\') || vm.$state.includes(\'mapa-calor-mobile\'))" class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/logo.png" alt="logo"> <span data-translate="global.title">NetWordAgro</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" data-translate="global.menu.home">Home</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><!--Menu Propriedade --><li ng-class="{active: vm.$state.includes(\'pais\') || vm.$state.includes(\'regiao\') || vm.$state.includes(\'estado\')\n            || vm.$state.includes(\'cidade\') || vm.$state.includes(\'microregiao\') || vm.$state.includes(\'propriedade\') \n            || vm.$state.includes(\'georeferenciamento\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="propriedades-menu" has-any-authority="ROLE_ADMIN,ROLE_GESTOR_PARCEIROS"><span><span class="glyphicon glyphicon-map-marker"></span> <span class="hidden-sm" data-translate="global.menu.propriedades.main">Propriedades </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="pais" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.propriedades.pais">Pa\xEDs</span></a></li><li ui-sref-active="active"><a ui-sref="regiao" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.propriedades.regiao">Regi\xE3o</span></a></li><li ui-sref-active="active"><a ui-sref="estado" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.propriedades.estado">Estado</span></a></li><li ui-sref-active="active"><a ui-sref="microregiao" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.propriedades.microregiao">Microrregiao</span></a></li><li ui-sref-active="active"><a ui-sref="cidade" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.propriedades.cidade">Cidade</span></a></li><li ui-sref-active="active"><a ui-sref="propriedade" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.propriedades.propriedade">Propriedade</span></a></li><li ui-sref-active="active"><a ui-sref="georeferenciamento" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.propriedades.georeferenciamento">Georreferenciamento</span></a></li><!--\n                        <li ui-sref-active="active">\n                                <a ui-sref="unidade" ng-click="vm.collapseNavbar()">\n                                    <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                    <span data-translate="global.menu.propriedades.unidade">Unidade</span>\n                                </a>\n                            </li>\n                        --><li ui-sref-active="active"><a ui-sref="fazenda" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.propriedades.fazenda">Fazenda</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_PROPRIETARIO, ROLE_FUNC_OPERACIONAL, ROLE_GESTOR_PROP"><a ui-sref="localarmazenamento" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-log-in"></span> <span class="hidden-sm" data-translate="global.menu.localarmazenamento">localarmazenamento</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_PROPRIETARIO, ROLE_FUNC_OPERACIONAL, ROLE_GESTOR_PROP"><a ui-sref="insumo" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-download-alt"></span> <span class="hidden-sm" data-translate="global.menu.controleinsumos">controleinsumos</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_GESTOR_PARCEIROS"><a ui-sref="pessoa" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.pessoa">pessoa</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_GESTOR_PARCEIROS"><a ui-sref="unidade" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.propriedades.unidade">unidade</span></a></li><!--<li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_GESTOR_PARCEIROS">\n                    <a ui-sref="tecnico" ng-click="vm.collapseNavbar()">\n                        <span class="glyphicon glyphicon-user">\n                        </span>\n                        <span class="hidden-sm" data-translate="global.menu.tecnico">Tecnico</span>\n                    </a>\n                </li>\n                \n                <li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_GESTOR_PARCEIROS">\n                    <a ui-sref="gestor" ng-click="vm.collapseNavbar()">\n                        <span class="glyphicon glyphicon-user">\n                        </span>\n                        <span class="hidden-sm" data-translate="global.menu.gestor">gestor</span>\n                    </a>\n                </li>--><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_GESTOR_PARCEIROS"><a ui-sref="sensor" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-hdd"></span> <span class="hidden-sm" data-translate="global.menu.sensor">sensor</span></a></li><!--Menu Cultura--><li ng-class="{active: vm.$state.includes(\'cultura\') || vm.$state.includes(\'solo\') || vm.$state.includes(\'caracteristicacultura\')\n                || vm.$state.includes(\'caracteristicasolo\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer" has-any-authority="ROLE_ADMIN,ROLE_GESTOR_PARCEIROS"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-leaf"></span> <span class="hidden-sm" data-translate="global.menu.culturaesolo.main">Cultura e Solo </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" has-any-authority="ROLE_ADMIN"><a ui-sref="cultura" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.culturaesolo.cultura">Cultura</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN"><a ui-sref="caracteristicacultura" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.culturaesolo.caracteristicacultura">Caracter\xEDsticas da Cultura</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN"><a ui-sref="solo" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.culturaesolo.solo">Solo</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN"><a ui-sref="caracteristicasolo" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.culturaesolo.caracteristicasolo">Caracter\xEDsticas do solo</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_GESTOR_PARCEIROS"><a ui-sref="safra" ng-click="vm.collapseNavbar()" has-any-authority="ROLE_ADMIN,ROLE_GESTOR_PARCEIROS"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.culturaesolo.safra">Safra</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><!--Menu Atributos--><li ng-class="{active: vm.$state.includes(\'atributo\') || vm.$state.includes(\'concentracaoidealatributo\') || vm.$state.includes(\'corratribce\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu" has-authority="ROLE_ADMIN"><span><span class="glyphicon glyphicon-grain"></span> <span class="hidden-sm" data-translate="global.menu.atributos.main">Atributos de solo </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="atributo" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.atributos.atributo">Atributo</span></a></li><li ui-sref-active="active"><a ui-sref="concentracaoidealatributo" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.atributos.concentracaoidealatributo">Concenta\xE7\xE3o ideal de atributo</span></a></li><li ui-sref-active="active"><a ui-sref="corratribce" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.atributos.corratribce">Correla\xE7\xE3o Atributo - Condutividade El\xE9trica</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><!--Menu Pesquisa--><li ng-class="{active: vm.$state.includes(\'pesquisa\') || vm.$state.includes(\'atributopesquisa\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu" has-authority="ROLE_ADMIN"><span><span class="glyphicon glyphicon-search"></span> <span class="hidden-sm" data-translate="global.menu.pesquisas.main">Pesquisas </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="pesquisa" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.pesquisas.pesquisa">Pesquisa</span></a></li><li ui-sref-active="active"><a ui-sref="atributopesquisa" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.pesquisas.atributopesquisa">Atributo de Pesquisas</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><!--Menu Mapeamento--><li ng-class="{active: vm.$state.includes(\'matrizsensoriamento\') || vm.$state.includes(\'quadrantesolo\')\n                || vm.$state.includes(\'quadranteimagem\')\n                || vm.$state.includes(\'pontossensoriamentosolo\') || vm.$state.includes(\'medicaoatriblavoura\') || vm.$state.includes(\'medicaoatribpesq\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu" has-authority="ROLE_ADMIN"><span><span class="glyphicon glyphicon-screenshot"></span> <span class="hidden-sm" data-translate="global.menu.mapeamento.main">Mapeamentos </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="matrizsensoriamento" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.mapeamento.matrizsensoriamento">Matrizes de Sensoriamento</span></a></li><li ui-sref-active="active"><a ui-sref="quadrantesolo" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.mapeamento.quadrantesolo">Quadrante de Solo</span></a></li><li ui-sref-active="active"><a ui-sref="quadranteimagem" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.mapeamento.quadranteimagem">Imagem de Quadrante</span></a></li><li ui-sref-active="active"><a ui-sref="pontossensoriamentosolo" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.mapeamento.pontossensoriamentosolo">Pontos de Sensoriamento</span></a></li><li ui-sref-active="active"><a ui-sref="medicaoatriblavoura" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.mapeamento.medicaoatriblavoura">Medi\xE7\xE3o de Atributos de Lavoura</span></a></li><li ui-sref-active="active"><a ui-sref="medicaoatribpesq" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.mapeamento.medicaoatribpesq">Medi\xE7\xE3o de Atributos do Solo</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'safra\') || vm.$state.includes(\'custoshabituaisfertilizantes\')\n                || vm.$state.includes(\'custoshabituaisdefensivos\') || vm.$state.includes(\'custoshabituaisproducao\') || vm.$state.includes(\'indicadoreshabituais\') \n                || vm.$state.includes(\'custosnwfertilizantes\') || vm.$state.includes(\'custosnwdefensivos\') || vm.$state.includes(\'custosnwproducao\')\n                || vm.$state.includes(\'indicadoresnw\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer" has-any-authority="ROLE_ADMIN, ROLE_PROPRIETARIO, ROLE_FUNC_ADMINISTRATIVO, ROLE_GESTOR_PROP"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-piggy-bank"></span> <span class="hidden-sm" data-translate="global.menu.custos.main">Custos </span><b class="caret"></b> </span></a><!-- Menu custos --><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="custoshabituaisfertilizantes" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.custos.custoshabituaisfertilizantes">Custoshabituaisfertilizantes</span></a></li><li ui-sref-active="active"><a ui-sref="custoshabituaisdefensivos" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.custos.custoshabituaisdefensivos">Custoshabituaisdefensivos</span></a></li><li ui-sref-active="active"><a ui-sref="custoshabituaisproducao" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.custos.custoshabituaisproducao">Custoshabituaisproducao</span></a></li><li ui-sref-active="active"><a ui-sref="indicadoreshabituais" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.custos.indicadoreshabituais">Indicadoreshabituais</span></a></li><li ui-sref-active="active"><a ui-sref="custosnwfertilizantes" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.custos.custosnwfertilizantes">Custosnwfertilizantes</span></a></li><li ui-sref-active="active"><a ui-sref="custosnwdefensivos" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.custos.custosnwdefensivos">Custosnwdefensivos</span></a></li><li ui-sref-active="active"><a ui-sref="custosnwproducao" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.custos.custosnwproducao">Custosnwproducao</span></a></li><li ui-sref-active="active"><a ui-sref="indicadoresnw" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.custos.indicadoresnw">Indicadoresnw</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'relatorio\') || vm.$state.includes(\'relatoriocustosnw\') || vm.$state.includes(\'comparativo\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu" has-any-authority="ROLE_ADMIN, ROLE_FUNC_ADMINISTRATIVO, ROLE_PROPRIETARIO"><span><span class="glyphicon glyphicon-file"></span> <span class="hidden-sm" data-translate="global.menu.relatorios.main">Relat\xF3rios </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="relatorio" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.relatorios.relatorio">Relatorio</span></a></li><li ui-sref-active="active"><a ui-sref="relatoriocustosnw" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.relatorios.relatoriocustosnw">Relatoriocustosnw</span></a></li><li ui-sref-active="active"><a ui-sref="comparativo" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.relatorios.comparativo">Comparativo</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'aquisicaoplan\') || vm.$state.includes(\'preplantioplan\') || vm.$state.includes(\'plantioplan\')\n                || vm.$state.includes(\'manutencaosafraplan\') || vm.$state.includes(\'colheitaplan\') || vm.$state.includes(\'armazenamentosafraplan\')\n                || vm.$state.includes(\'comercializacaoplan\') || vm.$state.includes(\'logrecinsumoplan\') || vm.$state.includes(\'logentregaarmazplan\')\n                || vm.$state.includes(\'entregasafracomercplan\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu" has-any-authority="ROLE_ADMIN, ROLE_PROPRIETARIO, ROLE_GESTOR_PROP"><span><span class="glyphicon glyphicon glyphicon-calendar"></span> <span class="hidden-sm" data-translate="global.menu.planejamento.main">Planejamento </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="aquisicaoplan" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.planejamento.aquisicaoplan">Aquisicaoplan</span></a></li><li ui-sref-active="active"><a ui-sref="preplantioplan" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.planejamento.preplantioplan">Preplantioplan</span></a></li><li ui-sref-active="active"><a ui-sref="plantioplan" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.planejamento.plantioplan">Plantioplan</span></a></li><li ui-sref-active="active"><a ui-sref="manutencaosafraplan" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.planejamento.manutencaosafraplan">Manutencaosafraplan</span></a></li><li ui-sref-active="active"><a ui-sref="colheitaplan" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.planejamento.colheitaplan">Colheitaplan</span></a></li><li ui-sref-active="active"><a ui-sref="armazenamentosafraplan" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.planejamento.armazenamentosafraplan">Armazenamentosafraplan</span></a></li><li ui-sref-active="active"><a ui-sref="comercializacaoplan" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.planejamento.comercializacaoplan">Comercializacaoplan</span></a></li><li ui-sref-active="active"><a ui-sref="logrecinsumoplan" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.planejamento.logrecinsumoplan">Logrecinsumoplan</span></a></li><li ui-sref-active="active"><a ui-sref="logentregaarmazplan" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.planejamento.logentregaarmazplan">Logentregaarmazplan</span></a></li><li ui-sref-active="active"><a ui-sref="entregasafracomercplan" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.planejamento.entregasafracomercplan">Entregasafracomercplan</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'aquisicao\') || vm.$state.includes(\'aquisicaosugerida\') || vm.$state.includes(\'preplantio\') || vm.$state.includes(\'plantio\')\n                || vm.$state.includes(\'manutencaosafra\') || vm.$state.includes(\'colheita\') || vm.$state.includes(\'armazenamentosafra\')\n                || vm.$state.includes(\'comercializacao\') || vm.$state.includes(\'logrecinsumo\') || vm.$state.includes(\'logentregaarmaz\')\n                || vm.$state.includes(\'entregasafracomerc\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu" has-any-authority="ROLE_ADMIN, ROLE_PROPRIETARIO, ROLE_FUNC_ADMINISTRATIVO, ROLE_FUNC_OPERACIONAL, ROLE_GESTOR_PROP, ROLE_GESTOR_PARCEIROS"><span><span class="glyphicon glyphicon-check"></span> <span class="hidden-sm" data-translate="global.menu.execucao.main">Execu\xE7\xE3o </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_PROPRIETARIO, ROLE_FUNC_ADMINISTRATIVO, ROLE_FUNC_OPERACIONAL, ROLE_GESTOR_PROP"><a ui-sref="aquisicaosugerida" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.execucao.aquisicaosugerida">Aquisicaosugerida</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_PROPRIETARIO, ROLE_FUNC_ADMINISTRATIVO, ROLE_FUNC_OPERACIONAL, ROLE_GESTOR_PROP"><a ui-sref="aquisicao" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.execucao.aquisicao">Aquisicao</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_PROPRIETARIO, ROLE_FUNC_ADMINISTRATIVO, ROLE_FUNC_OPERACIONAL, ROLE_GESTOR_PROP"><a ui-sref="preplantio" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.execucao.preplantio">Preplantioplan</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_PROPRIETARIO, ROLE_FUNC_ADMINISTRATIVO, ROLE_FUNC_OPERACIONAL, ROLE_GESTOR_PROP"><a ui-sref="plantio" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.execucao.plantio">Plantioplan</span></a></li><li ui-sref-active="active"><a ui-sref="manutencaosafra" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.execucao.manutencaosafra">Manutencaosafraplan</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_PROPRIETARIO, ROLE_FUNC_ADMINISTRATIVO, ROLE_FUNC_OPERACIONAL, ROLE_GESTOR_PROP"><a ui-sref="colheita" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.execucao.colheita">Colheitaplan</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_PROPRIETARIO, ROLE_FUNC_ADMINISTRATIVO, ROLE_FUNC_OPERACIONAL, ROLE_GESTOR_PROP"><a ui-sref="armazenamentosafra" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.execucao.armazenamentosafra">Armazenamentosafraplan</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_PROPRIETARIO, ROLE_FUNC_ADMINISTRATIVO, ROLE_FUNC_OPERACIONAL, ROLE_GESTOR_PROP"><a ui-sref="comercializacao" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.execucao.comercializacao">Comercializacaoplan</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_PROPRIETARIO, ROLE_FUNC_ADMINISTRATIVO, ROLE_FUNC_OPERACIONAL, ROLE_GESTOR_PROP"><a ui-sref="logrecinsumo" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.execucao.logrecinsumo">Logrecinsumoplan</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_PROPRIETARIO, ROLE_FUNC_ADMINISTRATIVO, ROLE_FUNC_OPERACIONAL, ROLE_GESTOR_PROP"><a ui-sref="logentregaarmaz" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.execucao.logentregaarmaz">Logentregaarmazplan</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_PROPRIETARIO, ROLE_FUNC_ADMINISTRATIVO, ROLE_FUNC_OPERACIONAL, ROLE_GESTOR_PROP"><a ui-sref="entregasafracomerc" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.execucao.entregasafracomerc">Entregasafracomercplan</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'aquisicao\') || vm.$state.includes(\'aquisicaosugerida\') || vm.$state.includes(\'preplantiotestem\') || vm.$state.includes(\'plantiotestem\')\n                || vm.$state.includes(\'manutencaosafratestem\') || vm.$state.includes(\'colheitatestem\') || vm.$state.includes(\'armazenamentosafratestem\')\n                || vm.$state.includes(\'comercializacaotestem\') || vm.$state.includes(\'logrecinsumotestem\') || vm.$state.includes(\'logentregaarmaztestem\')\n                || vm.$state.includes(\'entregasafracomerctestem\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu" has-any-authority="ROLE_ADMIN, ROLE_PROPRIETARIO, ROLE_FUNC_ADMINISTRATIVO, ROLE_FUNC_OPERACIONAL, ROLE_GESTOR_PROP"><span><span class="glyphicon glyphicon-duplicate"></span> <span class="hidden-sm" data-translate="global.menu.areatestemunho.main">Areatestemunho </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="aquisicao" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.areatestemunho.aquisicao">Aquisicao</span></a></li><li ui-sref-active="active"><a ui-sref="preplantiotestem" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.areatestemunho.preplantio">Preplantioplan</span></a></li><li ui-sref-active="active"><a ui-sref="plantiotestem" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.areatestemunho.plantio">Plantioplan</span></a></li><li ui-sref-active="active"><a ui-sref="manutencaosafratestem" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.areatestemunho.manutencaosafra">Manutencaosafraplan</span></a></li><li ui-sref-active="active"><a ui-sref="colheitatestem" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.areatestemunho.colheita">Colheitaplan</span></a></li><li ui-sref-active="active"><a ui-sref="armazenamentosafratestem" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.areatestemunho.armazenamentosafra">Armazenamentosafraplan</span></a></li><li ui-sref-active="active"><a ui-sref="comercializacaotestem" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.areatestemunho.comercializacao">Comercializacaoplan</span></a></li><li ui-sref-active="active"><a ui-sref="logrecinsumotestem" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.areatestemunho.logrecinsumo">Logrecinsumoplan</span></a></li><li ui-sref-active="active"><a ui-sref="logentregaarmaztestem" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.areatestemunho.logentregaarmaz">Logentregaarmazplan</span></a></li><li ui-sref-active="active"><a ui-sref="entregasafracomerctestem" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.areatestemunho.entregasafracomerc">Entregasafracomercplan</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_PROPRIETARIO, ROLE_GESTOR_PROP"><a ui-sref="painel" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span> <span class="hidden-sm" data-translate="global.menu.painel">Painel</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_GESTOR_PROP"><a ui-sref="uploadnw" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-upload"></span> <span class="hidden-sm">Uploads</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_GESTOR_PARCEIROS"><a ui-sref="automatizacao" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span> <span class="hidden-sm">Automatiza\xE7\xE3o</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_USER"><a ui-sref="mapa-interativo" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm" data-translate="global.menu.mapasinterativos">mapas interativos</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_USER"><a ui-sref="mapa-calor" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-fire"></span> <span class="hidden-sm" data-translate="global.menu.mapasdecalor">mapasdecalor</span></a></li><li ng-class="{active: vm.$state.includes(\'mapaimagem\') || vm.$state.includes(\'propostareceituario\') || vm.$state.includes(\'mapacomparativo\') || vm.$state.includes(\'receituario\') || vm.$state.includes(\'imagemtermica\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu" has-any-authority="ROLE_ADMIN, ROLE_PROPRIETARIO, ROLE_ENGENHEIRO_AGRONOMO, ROLE_GESTOR_PROP, ROLE_GESTOR_PARCEIROS"><span><span class="glyphicon glyphicon-picture"></span> <span class="hidden-sm" data-translate="global.menu.mapas.main">Mapas e receitu\xE1rios </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="mapaimagem" ng-click="vm.collapseNavbar()" has-any-authority="ROLE_ADMIN, ROLE_PROPRIETARIO, ROLE_ENGENHEIRO_AGRONOMO, ROLE_GESTOR_PROP, ROLE_GESTOR_PARCEIROS"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.mapas.mapaimagem">Mapas</span></a></li><!--<li ui-sref-active="active">\n                                <a ui-sref="mapacomparativo" ng-click="vm.collapseNavbar()">\n                                    <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                    <span data-translate="global.menu.mapas.comparativo">Comparativo</span>\n                                </a>\n                        </li>--><!--\n                        <li ui-sref-active="active">\n                            <a ui-sref="receituario" ng-click="vm.collapseNavbar()" has-any-authority="ROLE_ADMIN, ROLE_PROPRIETARIO, ROLE_ENGENHEIRO_AGRONOMO, ROLE_GESTOR_PROP">\n                                <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                <span data-translate="global.menu.mapas.receituario">Receitu\xE1rio</span>\n                            </a>\n                        </li>--><!--\n                        <li ui-sref-active="active">\n                            <a ui-sref="propostareceituario" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                <span data-translate="global.menu.mapas.propostareceituario">propostareceituario</span>\n                            </a>\n                        </li>\n                        --><li ui-sref-active="active"><a ui-sref="imagemtermica" ng-click="vm.collapseNavbar()" has-any-authority="ROLE_ADMIN, ROLE_PROPRIETARIO, ROLE_ENGENHEIRO_AGRONOMO, ROLE_GESTOR_PROP"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.mapas.imagemtermica">imagemtermica</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_GESTOR_PARCEIROS"><a ui-sref="aprovacaomapa" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.mapas.aprovacaomapa">aprovacaomapa</span></a></li></ul></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_GESTOR_PARCEIROS"><a ui-sref="maquinario" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-cog"></span> <span data-translate="global.menu.maquinario">maquinario</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_GESTOR_PARCEIROS"><a ui-sref="produto" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-oil"></span> <span data-translate="global.menu.produto">produto</span></a></li><li ng-class="{active: vm.$state.includes(\'pedido\') || vm.$state.includes(\'pedido-fazer\') || vm.$state.includes(\'pedidonutricional\') || vm.$state.includes(\'pedido-nutricional-fazer\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu" has-any-authority="ROLE_ADMIN, ROLE_PROPRIETARIO, ROLE_ENGENHEIRO_AGRONOMO, ROLE_GESTOR_PROP, ROLE_GESTOR_PARCEIROS"><span><span class="glyphicon glyphicon-inbox"></span> <span class="hidden-sm" data-translate="global.menu.pedido">Mapas e receitu\xE1rios </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="pedido" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.pedido">Pedido</span></a></li><li ui-sref-active="active"><a ui-sref="pedido-fazer" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.pedido-fazer">Pedido Fazer</span></a></li><li ui-sref-active="active"><a ui-sref="pedidonutricional" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.pedidonutricional">Pedido Nutricional</span></a></li><li ui-sref-active="active"><a ui-sref="pedido-nutricional-fazer" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.pedido-fazer-nutricional">Pedido Fazer Nutricional</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_GESTOR_PARCEIROS"><a ui-sref="avaliacaosolo" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-signal"></span> <span data-translate="global.menu.avaliacaosolo">avaliacao solo</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN"><a ui-sref="diariodebordo" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span> <span data-translate="global.menu.diariodebordo">diariodebordo</span></a></li><li ng-class="{active: vm.$state.includes(\'empresaparceira\') || vm.$state.includes(\'propaganda\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu" has-authority="ROLE_ADMIN"><span><span class="glyphicon glyphicon-usd"></span> <span class="hidden-sm" data-translate="global.menu.propagandas.main">Propagandas </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="empresaparceira" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.propagandas.empresaparceira">Empresaparceira</span></a></li><li ui-sref-active="active"><a ui-sref="propaganda" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.propagandas.propaganda">Propaganda</span></a></li><li ui-sref-active="active"><a ui-sref="controlepropagandas" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.propagandas.controlepropagandas">Controlepropagandas</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="sessions" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-cloud"></span>&nbsp; <span data-translate="global.menu.account.sessions">Sessions</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="configuracaomapacalor" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.configuracaomapacalor">Configura\xE7\xE3o de mapa de calor</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.http.403">You are not authorized to access this page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div></div></div></div>');
$templateCache.put('app/entities/aprovacaomapa/aprovacaomapa-aprovar.html','<form name="deleteForm" ng-submit="vm.confirmarAprovacao(vm.aprovacaomapa.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="netWordAgroApp.aprovacaomapa.aprovartitle">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.aprovacaomapa.aprovarpergunta" translate-values="{id: \'{{vm.aprovacaomapa.id}}\'}">Are you sure you want to delete this Aprovacaomapa?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-success"><span class="glyphicon glyphicon-check"></span>&nbsp;<span data-translate="entity.action.save">Delete</span></button></div></form>');
$templateCache.put('app/entities/aprovacaomapa/aprovacaomapa-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.aprovacaomapa.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.aprovacaomapa.delete.question" translate-values="{id: \'{{vm.aprovacaomapa.id}}\'}">Are you sure you want to delete this Aprovacaomapa?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/aprovacaomapa/aprovacaomapa-detail.html','<div><h2><span data-translate="netWordAgroApp.aprovacaomapa.detail.title">Aprovacaomapa</span> {{vm.aprovacaomapa.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.aprovacaomapa.nomemapa">Nomemapa</span></dt><dd><span>{{vm.aprovacaomapa.nomemapa}}</span></dd><dt><span data-translate="netWordAgroApp.aprovacaomapa.imagem">Imagem</span></dt><dd><div ng-if="vm.aprovacaomapa.imagem"><a ng-click="vm.openFile(vm.aprovacaomapa.imagemContentType, vm.aprovacaomapa.imagem)"><img data-ng-src="{{\'data:\' + vm.aprovacaomapa.imagemContentType + \';base64,\' + vm.aprovacaomapa.imagem}}" style="max-width: 100%" alt="aprovacaomapa image"> </a>{{vm.aprovacaomapa.imagemContentType}}, {{vm.byteSize(vm.aprovacaomapa.imagem)}}</div></dd><dt><span data-translate="netWordAgroApp.aprovacaomapa.imagempequena">Imagempequena</span></dt><dd><div ng-if="vm.aprovacaomapa.imagempequena"><a ng-click="vm.openFile(vm.aprovacaomapa.imagempequenaContentType, vm.aprovacaomapa.imagempequena)"><img data-ng-src="{{\'data:\' + vm.aprovacaomapa.imagempequenaContentType + \';base64,\' + vm.aprovacaomapa.imagempequena}}" style="max-width: 100%" alt="aprovacaomapa image"> </a>{{vm.aprovacaomapa.imagempequenaContentType}}, {{vm.byteSize(vm.aprovacaomapa.imagempequena)}}</div></dd><dt><span data-translate="netWordAgroApp.aprovacaomapa.latitudecentro">Latitudecentro</span></dt><dd><span>{{vm.aprovacaomapa.latitudecentro}}</span></dd><dt><span data-translate="netWordAgroApp.aprovacaomapa.longitudecentro">Longitudecentro</span></dt><dd><span>{{vm.aprovacaomapa.longitudecentro}}</span></dd><dt><span data-translate="netWordAgroApp.aprovacaomapa.tipoimagem">Tipoimagem</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipoimagem.\' + vm.aprovacaomapa.tipoimagem}}">{{vm.aprovacaomapa.tipoimagem}}</span></dd><dt><span data-translate="netWordAgroApp.aprovacaomapa.data">Data</span></dt><dd><span>{{vm.aprovacaomapa.data | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.aprovacaomapa.tipomapa">Tipomapa</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipomapa.\' + vm.aprovacaomapa.tipomapa}}">{{vm.aprovacaomapa.tipomapa}}</span></dd><dt><span data-translate="netWordAgroApp.aprovacaomapa.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.aprovacaomapa.safra.id})">{{vm.aprovacaomapa.safra.nomesafra}}</a></dd><dt><span data-translate="netWordAgroApp.aprovacaomapa.atributo">Atributo</span></dt><dd><a ui-sref="atributo-detail({id:vm.aprovacaomapa.atributo.id})">{{vm.aprovacaomapa.atributo.nomeatributo}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="aprovacaomapa-detail.edit({id:vm.aprovacaomapa.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/aprovacaomapa/aprovacaomapa-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAprovacaomapaLabel" data-translate="netWordAgroApp.aprovacaomapa.home.createOrEditLabel">Create or edit a Aprovacaomapa</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.aprovacaomapa.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.aprovacaomapa.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.aprovacaomapa.nomemapa" for="field_nomemapa">Nomemapa</label><input type="text" class="form-control" name="nomemapa" id="field_nomemapa" ng-model="vm.aprovacaomapa.nomemapa"></div><div class="form-group" ngf-drop ngf-change="vm.setImagem($file, vm.aprovacaomapa)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="netWordAgroApp.aprovacaomapa.imagem" for="field_imagem">Imagem</label><div><img data-ng-src="{{\'data:\' + vm.aprovacaomapa.imagemContentType + \';base64,\' + vm.aprovacaomapa.imagem}}" style="max-height: 100px" ng-if="vm.aprovacaomapa.imagem" alt="aprovacaomapa image"><div ng-if="vm.aprovacaomapa.imagem" class="help-block clearfix"><span class="pull-left">{{vm.aprovacaomapa.imagemContentType}}, {{vm.byteSize(vm.aprovacaomapa.imagem)}}</span> <button type="button" ng-click="vm.aprovacaomapa.imagem=null;vm.aprovacaomapa.imagemContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setImagem($file, vm.aprovacaomapa)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="imagem" id="field_imagem" ng-model="vm.aprovacaomapa.imagem"> <input type="hidden" class="form-control" name="imagemContentType" id="field_imagemContentType" ng-model="vm.aprovacaomapa.imagemContentType"></div><div class="form-group" ngf-drop ngf-change="vm.setImagempequena($file, vm.aprovacaomapa)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="netWordAgroApp.aprovacaomapa.imagempequena" for="field_imagempequena">Imagempequena</label><div><img data-ng-src="{{\'data:\' + vm.aprovacaomapa.imagempequenaContentType + \';base64,\' + vm.aprovacaomapa.imagempequena}}" style="max-height: 100px" ng-if="vm.aprovacaomapa.imagempequena" alt="aprovacaomapa image"><div ng-if="vm.aprovacaomapa.imagempequena" class="help-block clearfix"><span class="pull-left">{{vm.aprovacaomapa.imagempequenaContentType}}, {{vm.byteSize(vm.aprovacaomapa.imagempequena)}}</span> <button type="button" ng-click="vm.aprovacaomapa.imagempequena=null;vm.aprovacaomapa.imagempequenaContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setImagempequena($file, vm.aprovacaomapa)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="imagempequena" id="field_imagempequena" ng-model="vm.aprovacaomapa.imagempequena"> <input type="hidden" class="form-control" name="imagempequenaContentType" id="field_imagempequenaContentType" ng-model="vm.aprovacaomapa.imagempequenaContentType"></div><!--\n        <div class="form-group">\n            <label class="control-label" data-translate="netWordAgroApp.aprovacaomapa.latitudecentro" for="field_latitudecentro">Latitudecentro</label>\n            <input type="text" class="form-control" name="latitudecentro" id="field_latitudecentro"\n                    ng-model="vm.aprovacaomapa.latitudecentro"\n                    />\n        </div>\n        <div class="form-group">\n            <label class="control-label" data-translate="netWordAgroApp.aprovacaomapa.longitudecentro" for="field_longitudecentro">Longitudecentro</label>\n            <input type="text" class="form-control" name="longitudecentro" id="field_longitudecentro"\n                    ng-model="vm.aprovacaomapa.longitudecentro"\n                    />\n        </div>\n        --><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.aprovacaomapa.tipoimagem" for="field_tipoimagem">Tipoimagem</label><select class="form-control" name="tipoimagem" ng-model="vm.aprovacaomapa.tipoimagem" id="field_tipoimagem"><option value="RGB" data-translate="netWordAgroApp.Tipoimagem.RGB">RGB</option><option value="RGN" data-translate="netWordAgroApp.Tipoimagem.RGN">RGN</option><option value="TERMICA" data-translate="netWordAgroApp.Tipoimagem.termica">TERMICA</option></select></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.aprovacaomapa.data" for="field_data">Data</label><div class="input-group"><input id="field_data" type="text" class="form-control" name="data" uib-datepicker-popup="{{dateformat}}" ng-model="vm.aprovacaomapa.data" is-open="vm.datePickerOpenStatus.data"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'data\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.aprovacaomapa.tipomapa" for="field_tipomapa">Tipomapa</label><select class="form-control" name="tipomapa" ng-model="vm.aprovacaomapa.tipomapa" id="field_tipomapa"><option value="acarorajado" data-translate="netWordAgroApp.Tipomapa.acarorajado">acarorajado</option><option value="amargoso" data-translate="netWordAgroApp.Tipomapa.amargoso">amargoso</option><option value="antracnose" data-translate="netWordAgroApp.Tipomapa.antracnose">antracnose</option><option value="bicudo" data-translate="netWordAgroApp.Tipomapa.bicudo">bicudo</option><option value="brocadacana" data-translate="netWordAgroApp.Tipomapa.broca">broca</option><option value="buva" data-translate="netWordAgroApp.Tipomapa.buva">buva</option><option value="cigarrinha" data-translate="netWordAgroApp.Tipomapa.cigarrinha">cigarrinha</option><option value="coracaomorto" data-translate="netWordAgroApp.Tipomapa.coracaomorto">coracaomorto</option><option value="coro" data-translate="netWordAgroApp.Tipomapa.coro">coro</option><option value="dessecacao" data-translate="netWordAgroApp.Tipomapa.dessecacao">dessecacao</option><option value="doenca" data-translate="netWordAgroApp.Tipomapa.doenca">doenca</option><option value="falhaplantio" data-translate="netWordAgroApp.Tipomapa.falhaplantio">falhaplantio</option><option value="ferrugem" data-translate="netWordAgroApp.Tipomapa.ferrugem">ferrugem</option><option value="folhaestreita" data-translate="netWordAgroApp.Tipomapa.folhaestreita">folhaestreita</option><option value="folhaestreitacana" data-translate="netWordAgroApp.Tipomapa.folhaestreitacana">folhaestreitacana</option><option value="folhalarga" data-translate="netWordAgroApp.Tipomapa.folhalarga">folhalarga</option><option value="folhalargacana" data-translate="netWordAgroApp.Tipomapa.folhalargacana">folhalargacana</option><option value="helmintosporiose" data-translate="netWordAgroApp.Tipomapa.helmintosporiose">helmintosporiose</option><option value="lagarta" data-translate="netWordAgroApp.Tipomapa.lagarta">lagarta</option><option value="manchaalvo" data-translate="netWordAgroApp.Tipomapa.manchaalvo">manchaalvo</option><option value="manchafoliar" data-translate="netWordAgroApp.Tipomapa.manchafoliar">manchafoliar</option><option value="milho" data-translate="netWordAgroApp.Tipomapa.milho">milho</option><option value="mofobranco" data-translate="netWordAgroApp.Tipomapa.mofobranco">mofobranco</option><option value="nematoide" data-translate="netWordAgroApp.Tipomapa.nematoide">nematoide</option><option value="nutricional" data-translate="netWordAgroApp.Tipomapa.nutricional">nutricional</option><option value="oidio" data-translate="netWordAgroApp.Tipomapa.oidio">oidio</option><option value="percevejo" data-translate="netWordAgroApp.Tipomapa.percevejo">percevejo</option><option value="ervadaninha" data-translate="netWordAgroApp.Tipomapa.ervadaninha">ervadaninha</option><option value="plantadaninhacana" data-translate="netWordAgroApp.Tipomapa.plantadaninhacana">plantadaninhacana</option><option value="plantio" data-translate="netWordAgroApp.Tipomapa.plantio">plantio</option><option value="praga" data-translate="netWordAgroApp.Tipomapa.praga">praga</option><option value="pulgao" data-translate="netWordAgroApp.Tipomapa.pulgao">pulgao</option><option value="ramularia" data-translate="netWordAgroApp.Tipomapa.ramularia">ramularia</option><option value="tripes" data-translate="netWordAgroApp.Tipomapa.tripes">tripes</option><option value="saude" data-translate="netWordAgroApp.Tipomapa.saude">saude</option><option value="umidade" data-translate="netWordAgroApp.Tipomapa.umidade">umidade</option></select></div><div class="form-group" ngf-drop ngf-change="vm.setShapefile($file, vm.aprovacaomapa)"><label class="control-label" data-translate="netWordAgroApp.mapaimagem.shapefile" for="field_shapefile">Shapefile</label><div><div ng-if="vm.aprovacaomapa.shapefile" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.aprovacaomapa.shapefileContentType, vm.aprovacaomapa.shapefile)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.aprovacaomapa.shapefileContentType}}, {{vm.byteSize(vm.aprovacaomapa.shapefile)}}</span> <button type="button" ng-click="vm.aprovacaomapa.shapefile=null;vm.aprovacaomapa.shapefileContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setShapefile($file, vm.aprovacaomapa)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="shapefile" id="field_shapefile" ng-model="vm.aprovacaomapa.shapefile"> <input type="hidden" class="form-control" name="shapefileContentType" id="field_shapefileContentType" ng-model="vm.aprovacaomapa.shapefileContentType"></div><div class="form-group" ngf-drop ngf-change="vm.setCSV($file, vm.aprovacaomapa)"><label class="control-label" data-translate="netWordAgroApp.mapaimagem.csv" for="field_csv">CSV</label><div><div ng-if="vm.aprovacaomapa.csv" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.aprovacaomapa.csvContentType, vm.aprovacaomapa.csv)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.aprovacaomapa.csvContentType}}, {{vm.byteSize(vm.aprovacaomapa.csv)}}</span> <button type="button" ng-click="vm.aprovacaomapa.csv=null;vm.aprovacaomapa.csvContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setCSV($file, vm.aprovacaomapa)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="csv" id="field_csv" ng-model="vm.aprovacaomapa.csv"> <input type="hidden" class="form-control" name="csvContentType" id="field_csvContentType" ng-model="vm.aprovacaomapa.csvContentType"></div><div class="form-group" ngf-drop ngf-change="vm.setWKT($file, vm.aprovacaomapa)"><label class="control-label" data-translate="netWordAgroApp.mapaimagem.wkt" for="field_wkt">WKT</label><div><div ng-if="vm.aprovacaomapa.wkt" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.aprovacaomapa.wktContentType, vm.aprovacaomapa.wkt)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.aprovacaomapa.wktContentType}}, {{vm.byteSize(vm.aprovacaomapa.wkt)}}</span> <button type="button" ng-click="vm.aprovacaomapa.wkt=null;vm.aprovacaomapa.wktContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setWKT($file, vm.aprovacaomapa)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="wkt" id="field_shapefile" ng-model="vm.aprovacaomapa.wkt"> <input type="hidden" class="form-control" name="wktContentType" id="field_wktContentType" ng-model="vm.aprovacaomapa.wktContentType"></div><div class="form-group"><label data-translate="netWordAgroApp.aprovacaomapa.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.aprovacaomapa.safra" ng-options="safra as safra.nomesafra for safra in vm.safras track by safra.id"><option value=""></option></select></div><div class="form-group"><label data-translate="netWordAgroApp.aprovacaomapa.atributo" for="field_atributo">Atributo</label><select class="form-control" id="field_atributo" name="atributo" ng-model="vm.aprovacaomapa.atributo" ng-options="atributo as atributo.nomeatributo for atributo in vm.atributos track by atributo.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/aprovacaomapa/aprovacaomapa-visualizar.html','<h2>Mapa {{vm.idmapa}}</h2><div ng-if="vm.carregando"><h4>Aguarde, estamos carregando o seu mapa...</h4></div><center><div ng-show="!vm.carregando" class="img-zoom-container"><img id="myimage" src="{{vm.fileURL}}" width="80%"></div></center><button type="submit" ui-sref="aprovacaomapa" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button>');
$templateCache.put('app/entities/aprovacaomapa/aprovacaomapas.html','<div><h2 data-translate="netWordAgroApp.aprovacaomapa.home.title">Aprovacaomapas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="aprovacaomapa.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.aprovacaomapa.home.createLabel">Create new Aprovacaomapa</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.aprovacaomapa.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><div class="container-fluid" style="margin-top:10px"><div class="row"><div class="col-xs-4 no-padding-left"><form name="filtrar" class="form-inline"><label class="control-label" data-translate="netWordAgroApp.mapaimagem.filtrarporpropriedade" for="field_filtropropriedade">Tipomapa</label><select class="form-control" id="field_filtropropriedade" name="filtropropriedade" ng-model="vm.filtropropriedade" ng-options="prop as prop.nomepropriedade for prop in vm.filtropropriedades track by prop.id" ng-change="vm.changeFiltro()"><option value></option></select></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomemapa"><span data-translate="netWordAgroApp.aprovacaomapa.nomemapa">Nomemapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipomapa"><span data-translate="netWordAgroApp.aprovacaomapa.tipomapa">Tipomapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="data"><span data-translate="netWordAgroApp.aprovacaomapa.data">Data</span> <span class="glyphicon glyphicon-sort"></span></th><!-- <th jh-sort-by="latitudecentro"><span data-translate="netWordAgroApp.aprovacaomapa.latitudecentro">Latitudecentro</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th jh-sort-by="longitudecentro"><span data-translate="netWordAgroApp.aprovacaomapa.longitudecentro">Longitudecentro</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th jh-sort-by="tipoimagem"><span data-translate="netWordAgroApp.aprovacaomapa.tipoimagem">Tipoimagem</span> <span class="glyphicon glyphicon-sort"></span></th> --><th jh-sort-by="safra.nomesafra"><span data-translate="netWordAgroApp.aprovacaomapa.safra">Safra</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="atributo.nomeatributo"><span data-translate="netWordAgroApp.aprovacaomapa.atributo">Atributo</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="netWordAgroApp.mapaimagem.shapefile">Shapefile</span> (.shp)</th><th><span data-translate="netWordAgroApp.mapaimagem.csv">CSV</span></th><th><span data-translate="netWordAgroApp.mapaimagem.wkt">WKT</span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat-start="aprovacaomapa in vm.aprovacaomapas track by aprovacaomapa.id" style="background-color: #F5F5F5"></tr><tr><td><a ui-sref="aprovacaomapa-detail({id:aprovacaomapa.id})">{{aprovacaomapa.id}}</a></td><td>{{aprovacaomapa.nomemapa}}</td><td data-translate="{{\'netWordAgroApp.Tipomapa.\' + aprovacaomapa.tipomapa}}"></td><td>{{aprovacaomapa.data}}</td><!-- <td>{{aprovacaomapa.latitudecentro}}</td>\n                        <td>{{aprovacaomapa.longitudecentro}}</td>\n                        <td data-translate="{{\'netWordAgroApp.Tipoimagem.\' + aprovacaomapa.tipoimagem}}">{{aprovacaomapa.tipoimagem}}</td> --><td><a ui-sref="safra-detail({id:aprovacaomapa.safra_id})">{{aprovacaomapa.safra_nomesafra}}</a></td><td><a ui-sref="safra-detail({id:aprovacaomapa.safra_id})">{{aprovacaomapa.atributo_nomeatributo}}</a></td><td><button class="btn btn-info btn-sm" ng-click="vm.downloadShape(aprovacaomapa.id)" style="width:100%"><span class="glyphicon glyphicon-download-alt"></span> <span class="hidden-sm-down">Shapefile</span></button></td><td><button class="btn btn-info btn-sm" ng-click="vm.downloadCSV(aprovacaomapa.id)" style="width:100%"><span class="glyphicon glyphicon-download-alt"></span> <span class="hidden-sm-down">CSV</span></button></td><td><button class="btn btn-info btn-sm" ng-click="vm.downloadWKT(aprovacaomapa.id)" style="width:100%"><span class="glyphicon glyphicon-download-alt"></span> <span class="hidden-sm-down">WKT</span></button></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ng-click="vm.download(aprovacaomapa.id)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-download-alt"></span> <span class="hidden-sm-down" data-translate="netWordAgroApp.aprovacaomapa.download"></span></button> <button type="submit" ui-sref="aprovacaomapa.edit({id:aprovacaomapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="aprovacaomapa.delete({id:aprovacaomapa.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button> <button type="submit" ui-sref="aprovacaomapa.aprovar({id:aprovacaomapa.id})" class="btn btn-success btn-sm"><span class="glyphicon glyphicon-ok-circle"></span> <span class="hidden-sm-down" data-translate="netWordAgroApp.aprovacaomapa.aprovar"></span></button></div></td></tr><tr ng-repeat-end style="background-color: #F9F9F9"><td colspan="13"><center><img id="myimage" style="max-height:600px" class="img-responsive" src="{{vm.imagens[aprovacaomapa.id]}}"></center></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/alocacaoinsumos/alocacaoinsumos-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.alocacaoinsumos.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.alocacaoinsumos.delete.question" translate-values="{id: \'{{vm.alocacaoinsumos.id}}\'}">Are you sure you want to delete this Alocacaoinsumos?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/alocacaoinsumos/alocacaoinsumos-detail.html','<script type="text/javascript">function Voltar(){\n        history.go(-1);\n    }</script><div><h2><span data-translate="netWordAgroApp.alocacaoinsumos.detail.title">Alocacaoinsumos</span> {{vm.alocacaoinsumos.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.alocacaoinsumos.quantidade">Quantidade</span></dt><dd><span>{{vm.alocacaoinsumos.quantidade}}</span></dd><dt><span data-translate="netWordAgroApp.alocacaoinsumos.medida">Medida</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipomedidaalocacao.\' + vm.alocacaoinsumos.medida}}">{{vm.alocacaoinsumos.medida}}</span></dd><dt><span data-translate="netWordAgroApp.alocacaoinsumos.servico">Servico</span></dt><dd><a ui-sref="servico-detail({id:vm.alocacaoinsumos.servico.id})">{{vm.alocacaoinsumos.servico.nome}}</a></dd><dt><span data-translate="netWordAgroApp.alocacaoinsumos.insumo">Insumo</span></dt><dd><a ui-sref="insumo-detail({id:vm.alocacaoinsumos.insumo.id})">{{vm.alocacaoinsumos.insumo.nome}}</a></dd></dl><button type="submit" onclick="Voltar()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="alocacaoinsumos-detail.edit({id:vm.alocacaoinsumos.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/alocacaoinsumos/alocacaoinsumos-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAlocacaoinsumosLabel" data-translate="netWordAgroApp.alocacaoinsumos.home.createOrEditLabel">Create or edit a Alocacaoinsumos</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.alocacaoinsumos.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.alocacaoinsumos.id" readonly="readonly"></div><div class="form-group"><label data-translate="netWordAgroApp.alocacaoinsumos.insumo" for="field_insumo">Insumo</label><select class="form-control" id="field_insumo" name="insumo" ng-model="vm.alocacaoinsumos.insumo" ng-options="insumo as insumo.nome for insumo in vm.insumos track by insumo.id" ng-change="vm.mudaSelecao()" required></select></div><div ng-show="editForm.insumo.$invalid"><p class="help-block" ng-show="editForm.insumo.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.alocacaoinsumos.quantidade" for="field_quantidade">Quantidade</label><input type="number" class="form-control" name="quantidade" id="field_quantidade" ng-model="vm.alocacaoinsumos.quantidade" required min="0" max="{{vm.restante}}"><div ng-show="editForm.quantidade.$invalid"><p class="help-block" ng-show="editForm.quantidade.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.quantidade.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.quantidade.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.alocacaoinsumos.medida" for="field_medida">Medida</label><select class="form-control" name="medida" ng-model="vm.alocacaoinsumos.medida" id="field_medida" required readonly="readonly"><option value="g" data-translate="netWordAgroApp.Tipomedidaalocacao.g">g</option><option value="kg" data-translate="netWordAgroApp.Tipomedidaalocacao.kg">kg</option><option value="ml" data-translate="netWordAgroApp.Tipomedidaalocacao.ml">ml</option><option value="l" data-translate="netWordAgroApp.Tipomedidaalocacao.l">l</option></select><div ng-show="editForm.medida.$invalid"><p class="help-block" ng-show="editForm.medida.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><!--\n        <div class="form-group">\n            <label data-translate="netWordAgroApp.alocacaoinsumos.servico" for="field_servico">Servico</label>\n            <select class="form-control" id="field_servico" name="servico" ng-model="vm.alocacaoinsumos.servico" ng-options="servico as servico.nome for servico in vm.servicos track by servico.id" required >\n            </select>\n        </div>\n        <div ng-show="editForm.servico.$invalid">\n            <p class="help-block"\n                ng-show="editForm.servico.$error.required" data-translate="entity.validation.required">\n                This field is required.\n            </p>\n        </div>\n    --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/alocacaoinsumos/alocacaoinsumos.html','<div><h2 data-translate="netWordAgroApp.alocacaoinsumos.home.title">Alocacaoinsumos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="alocacaoinsumos.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.alocacaoinsumos.home.createLabel">Create new Alocacaoinsumos</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.alocacaoinsumos.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quantidade"><span data-translate="netWordAgroApp.alocacaoinsumos.quantidade">Quantidade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="medida"><span data-translate="netWordAgroApp.alocacaoinsumos.medida">Medida</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="servico.nome"><span data-translate="netWordAgroApp.alocacaoinsumos.servico">Servico</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="insumo.nome"><span data-translate="netWordAgroApp.alocacaoinsumos.insumo">Insumo</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="alocacaoinsumos in vm.alocacaoinsumos track by alocacaoinsumos.id"><td><a ui-sref="alocacaoinsumos-detail({id:alocacaoinsumos.id})">{{alocacaoinsumos.id}}</a></td><td>{{alocacaoinsumos.quantidade}}</td><td data-translate="{{\'netWordAgroApp.Tipomedidaalocacao.\' + alocacaoinsumos.medida}}">{{alocacaoinsumos.medida}}</td><td><a ui-sref="servico-detail({id:alocacaoinsumos.servico.id})">{{alocacaoinsumos.servico.nome}}</a></td><td><a ui-sref="insumo-detail({id:alocacaoinsumos.insumo.id})">{{alocacaoinsumos.insumo.nome}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="alocacaoinsumos-detail({id:alocacaoinsumos.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="alocacaoinsumos.edit({id:alocacaoinsumos.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="alocacaoinsumos.delete({id:alocacaoinsumos.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/aplicacao/aplicacao-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.aplicacao.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.aplicacao.delete.question" translate-values="{id: \'{{vm.aplicacao.id}}\'}">Are you sure you want to delete this Aplicacao?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/aplicacao/aplicacao-detail.html','<div><h2><span data-translate="netWordAgroApp.aplicacao.detail.title">Aplicacao</span> {{vm.aplicacao.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.aplicacao.atividade">Atividade</span></dt><dd><a ui-sref="atividade-detail({id:vm.aplicacao.atividade.id})">{{vm.aplicacao.atividade.nome}}</a></dd><dt><span data-translate="netWordAgroApp.aplicacao.quadrantesolo">Quadrantesolo</span></dt><dd><a ui-sref="quadrantesolo-detail({id:vm.aplicacao.quadrantesolo.id})">{{vm.aplicacao.quadrantesolo.nomequadrante}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="aplicacao-detail.edit({id:vm.aplicacao.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/aplicacao/aplicacao-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAplicacaoLabel" data-translate="netWordAgroApp.aplicacao.home.createOrEditLabel">Create or edit a Aplicacao</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.aplicacao.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.aplicacao.id" readonly="readonly"></div><div class="form-group"><label data-translate="netWordAgroApp.aplicacao.atividade" for="field_atividade">Atividade</label><select class="form-control" id="field_atividade" name="atividade" ng-model="vm.aplicacao.atividade" ng-options="atividade as atividade.nome for atividade in vm.atividades track by atividade.id" required></select></div><div ng-show="editForm.atividade.$invalid"><p class="help-block" ng-show="editForm.atividade.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.aplicacao.quadrantesolo" for="field_quadrantesolo">Quadrantesolo</label><select class="form-control" id="field_quadrantesolo" name="quadrantesolo" ng-model="vm.aplicacao.quadrantesolo" ng-options="quadrantesolo as quadrantesolo.nomequadrante for quadrantesolo in vm.quadrantesolos track by quadrantesolo.id" required></select></div><div ng-show="editForm.quadrantesolo.$invalid"><p class="help-block" ng-show="editForm.quadrantesolo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/aplicacao/aplicacaos.html','<div><h2 data-translate="netWordAgroApp.aplicacao.home.title">Aplicacaos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="aplicacao.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.aplicacao.home.createLabel">Create new Aplicacao</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.aplicacao.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="atividade.nome"><span data-translate="netWordAgroApp.aplicacao.atividade">Atividade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quadrantesolo.nomequadrante"><span data-translate="netWordAgroApp.aplicacao.quadrantesolo">Quadrantesolo</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="aplicacao in vm.aplicacaos track by aplicacao.id"><td><a ui-sref="aplicacao-detail({id:aplicacao.id})">{{aplicacao.id}}</a></td><td><a ui-sref="atividade-detail({id:aplicacao.atividade.id})">{{aplicacao.atividade.nome}}</a></td><td><a ui-sref="quadrantesolo-detail({id:aplicacao.quadrantesolo.id})">{{aplicacao.quadrantesolo.nomequadrante}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="aplicacao-detail({id:aplicacao.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="aplicacao.edit({id:aplicacao.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="aplicacao.delete({id:aplicacao.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/aquisicao/aquisicao-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.aquisicao.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.aquisicao.delete.question" translate-values="{id: \'{{vm.aquisicao.id}}\'}">Are you sure you want to delete this Aquisicao?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/aquisicao/aquisicao-detail.html','<div><h2><span data-translate="netWordAgroApp.aquisicao.detail.title">Aquisicao</span> {{vm.aquisicao.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.aquisicao.produtoaquisitado">Produtoaquisitado</span></dt><dd><span>{{vm.aquisicao.produtoaquisitado}}</span></dd><dt><span data-translate="netWordAgroApp.aquisicao.valor">Valor</span></dt><dd><span>{{vm.aquisicao.valor}}</span></dd><dt><span data-translate="netWordAgroApp.aquisicao.quantidade">Quantidade</span></dt><dd><span>{{vm.aquisicao.quantidade}}</span></dd><dt><span data-translate="netWordAgroApp.aquisicao.medida">Medida</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipomedidaaquisicao.\' + vm.aquisicao.medida}}">{{vm.aquisicao.medida}}</span></dd><dt><span data-translate="netWordAgroApp.aquisicao.notafiscal">Notafiscal</span></dt><dd><div ng-if="vm.aquisicao.notafiscal"><a ng-click="vm.openFile(vm.aquisicao.notafiscalContentType, vm.aquisicao.notafiscal)" data-translate="entity.action.open">open</a> {{vm.aquisicao.notafiscalContentType}}, {{vm.byteSize(vm.aquisicao.notafiscal)}}</div></dd><dt><span data-translate="netWordAgroApp.aquisicao.numeronota">Numeronota</span></dt><dd><span>{{vm.aquisicao.numeronota}}</span></dd><dt><span data-translate="netWordAgroApp.aquisicao.aquisicaosugerida">Aquisicaosugerida</span></dt><dd><a ui-sref="aquisicaosugerida-detail({id:vm.aquisicao.aquisicaosugerida.id})">{{vm.aquisicao.aquisicaosugerida.produtoaquisitado}}</a></dd><dt><span data-translate="netWordAgroApp.aquisicao.logrecinsumo">Logrecinsumo</span></dt><dd><a ui-sref="logrecinsumo-detail({id:vm.aquisicao.logrecinsumo.id})">{{vm.aquisicao.logrecinsumo.id}}</a></dd><dt><span data-translate="netWordAgroApp.aquisicao.propriedade">Propriedade</span></dt><dd><a ui-sref="propriedade-detail({id:vm.aquisicao.propriedade.id})">{{vm.aquisicao.propriedade.nomepropriedade}}</a></dd><dt><span data-translate="netWordAgroApp.aquisicao.atividade">Atividade</span></dt><dd><a ui-sref="atividade-detail({id:vm.aquisicao.atividade.id})">{{vm.aquisicao.atividade.nome}}</a></dd><dt><span data-translate="netWordAgroApp.aquisicao.logrecinsumotestem">Logrecinsumotestem</span></dt><dd><a ui-sref="logrecinsumotestem-detail({id:vm.aquisicao.logrecinsumotestem.id})">{{vm.aquisicao.logrecinsumotestem.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="aquisicao-detail.edit({id:vm.aquisicao.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/aquisicao/aquisicao-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAquisicaoLabel" data-translate="netWordAgroApp.aquisicao.home.createOrEditLabel">Create or edit a Aquisicao</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.aquisicao.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.aquisicao.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.aquisicao.produtoaquisitado" for="field_produtoaquisitado">Produtoaquisitado</label><input type="text" class="form-control" name="produtoaquisitado" id="field_produtoaquisitado" ng-model="vm.aquisicao.produtoaquisitado" required><div ng-show="editForm.produtoaquisitado.$invalid"><p class="help-block" ng-show="editForm.produtoaquisitado.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.aquisicao.valor" for="field_valor">Valor</label><input type="number" class="form-control" name="valor" id="field_valor" ng-model="vm.aquisicao.valor" required><div ng-show="editForm.valor.$invalid"><p class="help-block" ng-show="editForm.valor.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.valor.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.aquisicao.quantidade" for="field_quantidade">Quantidade</label><input type="number" class="form-control" name="quantidade" id="field_quantidade" ng-model="vm.aquisicao.quantidade" required><div ng-show="editForm.quantidade.$invalid"><p class="help-block" ng-show="editForm.quantidade.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.quantidade.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.aquisicao.medida" for="field_medida">Medida</label><select class="form-control" name="medida" ng-model="vm.aquisicao.medida" id="field_medida" required><option value="ML" data-translate="netWordAgroApp.Tipomedidaaquisicao.ML">ML</option><option value="L" data-translate="netWordAgroApp.Tipomedidaaquisicao.L">L</option><option value="G" data-translate="netWordAgroApp.Tipomedidaaquisicao.G">G</option><option value="KG" data-translate="netWordAgroApp.Tipomedidaaquisicao.KG">KG</option><option value="SACA" data-translate="netWordAgroApp.Tipomedidaaquisicao.SACA">SACA</option><option value="TON" data-translate="netWordAgroApp.Tipomedidaaquisicao.TON">TON</option><option value="UNIDADES" data-translate="netWordAgroApp.Tipomedidaaquisicao.UNIDADES">UNIDADES</option></select><div ng-show="editForm.medida.$invalid"><p class="help-block" ng-show="editForm.medida.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setNotafiscal($file, vm.aquisicao)"><label class="control-label" data-translate="netWordAgroApp.aquisicao.notafiscal" for="field_notafiscal">Notafiscal</label><div><div ng-if="vm.aquisicao.notafiscal" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.aquisicao.notafiscalContentType, vm.aquisicao.notafiscal)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.aquisicao.notafiscalContentType}}, {{vm.byteSize(vm.aquisicao.notafiscal)}}</span> <button type="button" ng-click="vm.aquisicao.notafiscal=null;vm.aquisicao.notafiscalContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setNotafiscal($file, vm.aquisicao)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="notafiscal" id="field_notafiscal" ng-model="vm.aquisicao.notafiscal"> <input type="hidden" class="form-control" name="notafiscalContentType" id="field_notafiscalContentType" ng-model="vm.aquisicao.notafiscalContentType"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.aquisicao.numeronota" for="field_numeronota">Numeronota</label><input type="text" class="form-control" name="numeronota" id="field_numeronota" ng-model="vm.aquisicao.numeronota"></div><div class="form-group"><label data-translate="netWordAgroApp.aquisicao.aquisicaosugerida" for="field_aquisicaosugerida">Aquisicaosugerida</label><select class="form-control" id="field_aquisicaosugerida" name="aquisicaosugerida" ng-model="vm.aquisicao.aquisicaosugerida" ng-options="aquisicaosugerida as aquisicaosugerida.produtoaquisitado for aquisicaosugerida in vm.aquisicaosugeridas | orderBy:\'id\' track by aquisicaosugerida.id"><option value=""></option></select></div><div class="form-group"><label data-translate="netWordAgroApp.aquisicao.logrecinsumo" for="field_logrecinsumo">Logrecinsumo</label><select class="form-control" id="field_logrecinsumo" name="logrecinsumo" ng-model="vm.aquisicao.logrecinsumo" ng-options="logrecinsumo as logrecinsumo.id for logrecinsumo in vm.logrecinsumos track by logrecinsumo.id"><option value=""></option></select></div><div class="form-group"><label data-translate="netWordAgroApp.aquisicao.propriedade" for="field_propriedade">Propriedade</label><select class="form-control" id="field_propriedade" name="propriedade" ng-model="vm.aquisicao.propriedade" ng-options="propriedade as propriedade.nomepropriedade for propriedade in vm.propriedades track by propriedade.id" required></select></div><div ng-show="editForm.propriedade.$invalid"><p class="help-block" ng-show="editForm.propriedade.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.aquisicao.atividade" for="field_atividade">Atividade</label><select class="form-control" id="field_atividade" name="atividade" ng-model="vm.aquisicao.atividade" ng-options="atividade as atividade.nome for atividade in vm.atividades track by atividade.id" required></select></div><div ng-show="editForm.atividade.$invalid"><p class="help-block" ng-show="editForm.atividade.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.aquisicao.logrecinsumotestem" for="field_logrecinsumotestem">Logrecinsumotestem</label><select class="form-control" id="field_logrecinsumotestem" name="logrecinsumotestem" ng-model="vm.aquisicao.logrecinsumotestem" ng-options="logrecinsumotestem as logrecinsumotestem.id for logrecinsumotestem in vm.logrecinsumotestems track by logrecinsumotestem.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/aquisicao/aquisicao-insumo-dialog.html','<form name="editForm" ng-submit="vm.insumo(vm.aquisicao.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="netWordAgroApp.aquisicao.dialoginsumo.title">Armazenar Insumo</h4></div><div class="modal-body"><div class="help-block panel-heading panel-warning bg-warning" ng-show="vm.ativado" data-translate="netWordAgroApp.aquisicao.dialoginsumo.armazenamentocompleto">Est\xE1 aquisicao j\xE1 foi completamente armazenada</div><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.insumo.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.insumo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.insumo.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.insumo.nome" required readonly="readonly"><div ng-show="editForm.nome.$invalid"><p class="help-block" ng-show="editForm.nome.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.insumo.dataentrada" for="field_dataentrada">Dataentrada</label><div class="input-group"><input id="field_dataentrada" type="text" class="form-control" name="dataentrada" uib-datepicker-popup="{{dateformat}}" ng-model="vm.insumo.dataentrada" is-open="vm.datePickerOpenStatus.dataentrada" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataentrada\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.dataentrada.$invalid"><p class="help-block" ng-show="editForm.dataentrada.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.insumo.quantidadearmazenada" for="field_quantidadearmazenada">Quantidadearmazenada</label><input type="number" class="form-control" name="quantidadearmazenada" id="field_quantidadearmazenada" ng-model="vm.insumo.quantidadearmazenada" required min="0" max="{{vm.aquisicao.restante}}"><label data-translate="{{\'netWordAgroApp.Tipomedidaaquisicao.\' + vm.aquisicao.medida}}">{{vm.aquisicao.medida}}</label><div ng-show="editForm.quantidadearmazenada.$invalid"><p class="help-block" ng-show="editForm.quantidadearmazenada.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.quantidadearmazenada.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.quantidadearmazenada.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><!--\n        <div class="form-group">\n            <label class="control-label" data-translate="netWordAgroApp.insumo.quantidadedisponivel" for="field_quantidadedisponivel">Quantidadedisponivel</label>\n            <input type="number" class="form-control" name="quantidadedisponivel" id="field_quantidadedisponivel"\n                    ng-model="vm.insumo.quantidadedisponivel"\n                    required min="0" max="{{vm.aquisicao.restante}}"/> <label data-translate="{{\'netWordAgroApp.Tipomedidaaquisicao.\' + vm.aquisicao.medida}}">{{vm.aquisicao.medida}}</label>\n            <div ng-show="editForm.quantidadedisponivel.$invalid">\n                <p class="help-block"\n                    ng-show="editForm.quantidadedisponivel.$error.required" data-translate="entity.validation.required">\n                    This field is required.\n                </p>\n                <p class="help-block"\n                    ng-show="editForm.quantidadedisponivel.$error.min" data-translate="entity.validation.min" translate-value-min="0">\n                    This field should be at least 0.\n                </p>\n                <p class="help-block"\n                    ng-show="editForm.quantidadedisponivel.$error.number" data-translate="entity.validation.number">\n                    This field should be a number.\n                </p>\n            </div>\n        </div>\n    --><div class="form-group"><label data-translate="netWordAgroApp.insumo.aquisicao" for="field_aquisicao">Aquisicao</label><input type="text" class="form-control" id="field_aquisicao" name="aquisicao" ng-model="vm.insumo.aquisicao" required readonly="readonly"></div><div ng-show="editForm.aquisicao.$invalid"><p class="help-block" ng-show="editForm.aquisicao.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.insumo.localarmazenamento" for="field_localarmazenamento">Localarmazenamento</label><select class="form-control" id="field_localarmazenamento" name="localarmazenamento" ng-model="vm.insumo.localarmazenamento" ng-options="localarmazenamento as localarmazenamento.nomelocal for localarmazenamento in vm.localarmazenamentos track by localarmazenamento.id" required></select></div><div ng-show="editForm.localarmazenamento.$invalid"><p class="help-block" ng-show="editForm.localarmazenamento.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-default" data-dismiss="modal" ng-disabled="vm.ativado"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/aquisicao/aquisicaos.html','<div><h2 data-translate="netWordAgroApp.aquisicao.home.title">Aquisicaos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="aquisicao.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.aquisicao.home.createLabel">Create new Aquisicao</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.aquisicao.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="produtoaquisitado"><span data-translate="netWordAgroApp.aquisicao.produtoaquisitado">Produtoaquisitado</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valor"><span data-translate="netWordAgroApp.aquisicao.valor">Valor</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quantidade"><span data-translate="netWordAgroApp.aquisicao.quantidade">Quantidade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="medida"><span data-translate="netWordAgroApp.aquisicao.medida">Medida</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="notafiscal"><span data-translate="netWordAgroApp.aquisicao.notafiscal">Notafiscal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="numeronota"><span data-translate="netWordAgroApp.aquisicao.numeronota">Numeronota</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="aquisicaosugerida.produtoaquisitado"><span data-translate="netWordAgroApp.aquisicao.aquisicaosugerida">Aquisicaosugerida</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="logrecinsumo.id"><span data-translate="netWordAgroApp.aquisicao.logrecinsumo">Logrecinsumo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="propriedade.nomepropriedade"><span data-translate="netWordAgroApp.aquisicao.propriedade">Propriedade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="atividade.nome"><span data-translate="netWordAgroApp.aquisicao.atividade">Atividade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="logrecinsumotestem.id"><span data-translate="netWordAgroApp.aquisicao.logrecinsumotestem">Logrecinsumotestem</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="aquisicao in vm.aquisicaos track by aquisicao.id"><td><a ui-sref="aquisicao-detail({id:aquisicao.id})">{{aquisicao.id}}</a></td><td>{{aquisicao.produtoaquisitado}}</td><td>{{aquisicao.valor}}</td><td>{{aquisicao.quantidade}}</td><td data-translate="{{\'netWordAgroApp.Tipomedidaaquisicao.\' + aquisicao.medida}}">{{aquisicao.medida}}</td><td><a ng-if="aquisicao.notafiscal" ng-click="vm.openFile(aquisicao.notafiscalContentType, aquisicao.notafiscal)" data-translate="entity.action.open">open</a> <span ng-if="aquisicao.notafiscal">{{aquisicao.notafiscalContentType}}, {{vm.byteSize(aquisicao.notafiscal)}}</span></td><td>{{aquisicao.numeronota}}</td><td><a ui-sref="aquisicaosugerida-detail({id:aquisicao.aquisicaosugerida.id})">{{aquisicao.aquisicaosugerida.produtoaquisitado}}</a></td><td><a ui-sref="logrecinsumo-detail({id:aquisicao.logrecinsumo.id})">{{aquisicao.logrecinsumo.id}}</a></td><td><a ui-sref="propriedade-detail({id:aquisicao.propriedade.id})">{{aquisicao.propriedade.nomepropriedade}}</a></td><td><a ui-sref="atividade-detail({id:aquisicao.atividade.id})">{{aquisicao.atividade.nome}}</a></td><td><a ui-sref="logrecinsumotestem-detail({id:aquisicao.logrecinsumotestem.id})">{{aquisicao.logrecinsumotestem.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="aquisicao-detail({id:aquisicao.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="aquisicao.edit({id:aquisicao.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="aquisicao.delete({id:aquisicao.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button> <button type="submit" ui-sref="aquisicao.insumo({id:aquisicao.id})" class="btn btn-success btn-sm"><span class="glyphicon glyphicon-download-alt"></span> <span class="hidden-sm-down" data-translate="netWordAgroApp.aquisicao.armazenarinsumo">Armazenar Insumo</span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/aquisicaoplan/aquisicaoplan-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.aquisicaoplan.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.aquisicaoplan.delete.question" translate-values="{id: \'{{vm.aquisicaoplan.id}}\'}">Are you sure you want to delete this Aquisicaoplan?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/aquisicaoplan/aquisicaoplan-detail.html','<div><h2><span data-translate="netWordAgroApp.aquisicaoplan.detail.title">Aquisicaoplan</span> {{vm.aquisicaoplan.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.aquisicaoplan.produtoaquisitado">Produtoaquisitado</span></dt><dd><span>{{vm.aquisicaoplan.produtoaquisitado}}</span></dd><dt><span data-translate="netWordAgroApp.aquisicaoplan.valor">Valor</span></dt><dd><span>{{vm.aquisicaoplan.valor}}</span></dd><dt><span data-translate="netWordAgroApp.aquisicaoplan.quantidade">Quantidade</span></dt><dd><span>{{vm.aquisicaoplan.quantidade}}</span></dd><dt><span data-translate="netWordAgroApp.aquisicaoplan.medidaquantidade">Medidaquantidade</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipomedidaquantidade.\' + vm.aquisicaoplan.medidaquantidade}}">{{vm.aquisicaoplan.medidaquantidade}}</span></dd><dt><span data-translate="netWordAgroApp.aquisicaoplan.dataaquisicao">Dataaquisicao</span></dt><dd><span>{{vm.aquisicaoplan.dataaquisicao | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.aquisicaoplan.localarmazenamento">Localarmazenamento</span></dt><dd><a ui-sref="localarmazenamento-detail({id:vm.aquisicaoplan.localarmazenamento.id})">{{vm.aquisicaoplan.localarmazenamento.nomelocal}}</a></dd><dt><span data-translate="netWordAgroApp.aquisicaoplan.atividade">Atividade</span></dt><dd><a ui-sref="atividade-detail({id:vm.aquisicaoplan.atividade.id})">{{vm.aquisicaoplan.atividade.nome}}</a></dd><dt><span data-translate="netWordAgroApp.aquisicaoplan.logrecinsumoplan">Logrecinsumoplan</span></dt><dd><a ui-sref="logrecinsumoplan-detail({id:vm.aquisicaoplan.logrecinsumoplan.id})">{{vm.aquisicaoplan.logrecinsumoplan.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="aquisicaoplan-detail.edit({id:vm.aquisicaoplan.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/aquisicaoplan/aquisicaoplan-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAquisicaoplanLabel" data-translate="netWordAgroApp.aquisicaoplan.home.createOrEditLabel">Create or edit a Aquisicaoplan</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.aquisicaoplan.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.aquisicaoplan.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.aquisicaoplan.produtoaquisitado" for="field_produtoaquisitado">Produtoaquisitado</label><input type="text" class="form-control" name="produtoaquisitado" id="field_produtoaquisitado" ng-model="vm.aquisicaoplan.produtoaquisitado" required><div ng-show="editForm.produtoaquisitado.$invalid"><p class="help-block" ng-show="editForm.produtoaquisitado.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.aquisicaoplan.valor" for="field_valor">Valor</label><input type="number" class="form-control" name="valor" id="field_valor" ng-model="vm.aquisicaoplan.valor" required><div ng-show="editForm.valor.$invalid"><p class="help-block" ng-show="editForm.valor.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.valor.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.aquisicaoplan.quantidade" for="field_quantidade">Quantidade</label><input type="number" class="form-control" name="quantidade" id="field_quantidade" ng-model="vm.aquisicaoplan.quantidade" required min="0"><div ng-show="editForm.quantidade.$invalid"><p class="help-block" ng-show="editForm.quantidade.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.quantidade.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.quantidade.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.aquisicaoplan.medidaquantidade" for="field_medidaquantidade">Medidaquantidade</label><select class="form-control" name="medidaquantidade" ng-model="vm.aquisicaoplan.medidaquantidade" id="field_medidaquantidade" required><option value="g" data-translate="netWordAgroApp.Tipomedidaquantidade.g">g</option><option value="kg" data-translate="netWordAgroApp.Tipomedidaquantidade.kg">kg</option><option value="ml" data-translate="netWordAgroApp.Tipomedidaquantidade.ml">ml</option><option value="l" data-translate="netWordAgroApp.Tipomedidaquantidade.l">l</option></select><div ng-show="editForm.medidaquantidade.$invalid"><p class="help-block" ng-show="editForm.medidaquantidade.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.aquisicaoplan.dataaquisicao" for="field_dataaquisicao">Dataaquisicao</label><div class="input-group"><input id="field_dataaquisicao" type="text" class="form-control" name="dataaquisicao" uib-datepicker-popup="{{dateformat}}" ng-model="vm.aquisicaoplan.dataaquisicao" is-open="vm.datePickerOpenStatus.dataaquisicao" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataaquisicao\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.dataaquisicao.$invalid"><p class="help-block" ng-show="editForm.dataaquisicao.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.aquisicaoplan.localarmazenamento" for="field_localarmazenamento">Localarmazenamento</label><select class="form-control" id="field_localarmazenamento" name="localarmazenamento" ng-model="vm.aquisicaoplan.localarmazenamento" ng-options="localarmazenamento as localarmazenamento.nomelocal for localarmazenamento in vm.localarmazenamentos track by localarmazenamento.id" required></select></div><div ng-show="editForm.localarmazenamento.$invalid"><p class="help-block" ng-show="editForm.localarmazenamento.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.aquisicaoplan.atividade" for="field_atividade">Atividade</label><select class="form-control" id="field_atividade" name="atividade" ng-model="vm.aquisicaoplan.atividade" ng-options="atividade as atividade.nome for atividade in vm.atividades track by atividade.id" required></select></div><div ng-show="editForm.atividade.$invalid"><p class="help-block" ng-show="editForm.atividade.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.aquisicaoplan.logrecinsumoplan" for="field_logrecinsumoplan">Logrecinsumoplan</label><select class="form-control" id="field_logrecinsumoplan" name="logrecinsumoplan" ng-model="vm.aquisicaoplan.logrecinsumoplan" ng-options="logrecinsumoplan as logrecinsumoplan.id for logrecinsumoplan in vm.logrecinsumoplans track by logrecinsumoplan.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/aquisicaoplan/aquisicaoplans.html','<div><h2 data-translate="netWordAgroApp.aquisicaoplan.home.title">Aquisicaoplans</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="aquisicaoplan.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.aquisicaoplan.home.createLabel">Create new Aquisicaoplan</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.aquisicaoplan.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="produtoaquisitado"><span data-translate="netWordAgroApp.aquisicaoplan.produtoaquisitado">Produtoaquisitado</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valor"><span data-translate="netWordAgroApp.aquisicaoplan.valor">Valor</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quantidade"><span data-translate="netWordAgroApp.aquisicaoplan.quantidade">Quantidade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="medidaquantidade"><span data-translate="netWordAgroApp.aquisicaoplan.medidaquantidade">Medidaquantidade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dataaquisicao"><span data-translate="netWordAgroApp.aquisicaoplan.dataaquisicao">Dataaquisicao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.aquisicaoplan.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="atividade.nome"><span data-translate="netWordAgroApp.aquisicaoplan.atividade">Atividade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="logrecinsumoplan.id"><span data-translate="netWordAgroApp.aquisicaoplan.logrecinsumoplan">Logrecinsumoplan</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="aquisicaoplan in vm.aquisicaoplans track by aquisicaoplan.id"><td><a ui-sref="aquisicaoplan-detail({id:aquisicaoplan.id})">{{aquisicaoplan.id}}</a></td><td>{{aquisicaoplan.produtoaquisitado}}</td><td>{{aquisicaoplan.valor}}</td><td>{{aquisicaoplan.quantidade}}</td><td data-translate="{{\'netWordAgroApp.Tipomedidaquantidade.\' + aquisicaoplan.medidaquantidade}}">{{aquisicaoplan.medidaquantidade}}</td><td>{{aquisicaoplan.dataaquisicao | date:\'mediumDate\'}}</td><td><a ui-sref="localarmazenamento-detail({id:aquisicaoplan.localarmazenamento.id})">{{aquisicaoplan.localarmazenamento.nomelocal}}</a></td><td><a ui-sref="atividade-detail({id:aquisicaoplan.atividade.id})">{{aquisicaoplan.atividade.nome}}</a></td><td><a ui-sref="logrecinsumoplan-detail({id:aquisicaoplan.logrecinsumoplan.id})">{{aquisicaoplan.logrecinsumoplan.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="aquisicaoplan-detail({id:aquisicaoplan.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="aquisicaoplan.edit({id:aquisicaoplan.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="aquisicaoplan.delete({id:aquisicaoplan.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/aquisicaosugerida/aquisicaosugerida-aprovar-dialog.html','<form name="aprovaForm" ng-submit="vm.aprovar(vm.aquisicaosugerida.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Aprova\xE7\xE3o</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Deseja aprovar a aquisi\xE7\xE3o desse produto? Voc\xEA poder\xE1 editar todos os detalhes sobre esta compra na aba de Aquisi\xE7\xF5es.</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-success"><span class="glyphicon glyphicon-ok"></span>&nbsp;Aprovar</button></div></form>');
$templateCache.put('app/entities/aquisicaosugerida/aquisicaosugerida-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.aquisicaosugerida.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.aquisicaosugerida.delete.question" translate-values="{id: \'{{vm.aquisicaosugerida.id}}\'}">Are you sure you want to delete this Aquisicaosugerida?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/aquisicaosugerida/aquisicaosugerida-detail.html','<script type="text/javascript">function Voltar(){\n        history.go(-1);\n    }</script><div><h2><span data-translate="netWordAgroApp.aquisicaosugerida.detail.title">Aquisicaosugerida</span> {{vm.aquisicaosugerida.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.aquisicaosugerida.produtoaquisitado">Produtoaquisitado</span></dt><dd><span>{{vm.aquisicaosugerida.produtoaquisitado}}</span></dd><dt><span data-translate="netWordAgroApp.aquisicaosugerida.valor">Valor</span></dt><dd><span>{{vm.aquisicaosugerida.valor}}</span></dd><dt><span data-translate="netWordAgroApp.aquisicaosugerida.quantidade">Quantidade</span></dt><dd><span>{{vm.aquisicaosugerida.quantidade}}</span></dd><dt><span data-translate="netWordAgroApp.aquisicaosugerida.medidaquantidade">Medidaquantidade</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipomedidaaquisicaosugerida.\' + vm.aquisicaosugerida.medidaquantidade}}">{{vm.aquisicaosugerida.medidaquantidade}}</span></dd><dt><span data-translate="netWordAgroApp.aquisicaosugerida.receituario">Receituario</span></dt><dd><a ui-sref="receituario-detail({id:vm.aquisicaosugerida.receituario.id})">{{vm.aquisicaosugerida.receituario.produto}}</a></dd></dl><button type="submit" onclick="Voltar()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="aquisicaosugerida-detail.edit({id:vm.aquisicaosugerida.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/aquisicaosugerida/aquisicaosugerida-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAquisicaosugeridaLabel" data-translate="netWordAgroApp.aquisicaosugerida.home.createOrEditLabel">Create or edit a Aquisicaosugerida</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.aquisicaosugerida.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.aquisicaosugerida.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.aquisicaosugerida.produtoaquisitado" for="field_produtoaquisitado">Produtoaquisitado</label><input type="text" class="form-control" name="produtoaquisitado" id="field_produtoaquisitado" ng-model="vm.aquisicaosugerida.produtoaquisitado" required><div ng-show="editForm.produtoaquisitado.$invalid"><p class="help-block" ng-show="editForm.produtoaquisitado.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.aquisicaosugerida.valor" for="field_valor">Valor</label><input type="number" class="form-control" name="valor" id="field_valor" ng-model="vm.aquisicaosugerida.valor" required><div ng-show="editForm.valor.$invalid"><p class="help-block" ng-show="editForm.valor.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.valor.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.aquisicaosugerida.quantidade" for="field_quantidade">Quantidade</label><input type="number" class="form-control" name="quantidade" id="field_quantidade" ng-model="vm.aquisicaosugerida.quantidade" required><div ng-show="editForm.quantidade.$invalid"><p class="help-block" ng-show="editForm.quantidade.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.quantidade.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.aquisicaosugerida.medidaquantidade" for="field_medidaquantidade">Medidaquantidade</label><select class="form-control" name="medidaquantidade" ng-model="vm.aquisicaosugerida.medidaquantidade" id="field_medidaquantidade" required><option value="g" data-translate="netWordAgroApp.Tipomedidaaquisicaosugerida.g">g</option><option value="kg" data-translate="netWordAgroApp.Tipomedidaaquisicaosugerida.kg">kg</option><option value="ml" data-translate="netWordAgroApp.Tipomedidaaquisicaosugerida.ml">ml</option><option value="l" data-translate="netWordAgroApp.Tipomedidaaquisicaosugerida.l">l</option></select><div ng-show="editForm.medidaquantidade.$invalid"><p class="help-block" ng-show="editForm.medidaquantidade.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.aquisicaosugerida.receituario" for="field_receituario">Receituario</label><select class="form-control" id="field_receituario" name="receituario" ng-model="vm.aquisicaosugerida.receituario" ng-options="receituario as receituario.produto for receituario in vm.receituarios track by receituario.id" required></select></div><div ng-show="editForm.receituario.$invalid"><p class="help-block" ng-show="editForm.receituario.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/aquisicaosugerida/aquisicaosugeridas.html','<div><h2 data-translate="netWordAgroApp.aquisicaosugerida.home.title">Aquisicaosugeridas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="aquisicaosugerida.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.aquisicaosugerida.home.createLabel">Create new Aquisicaosugerida</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.aquisicaosugerida.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="produtoaquisitado"><span data-translate="netWordAgroApp.aquisicaosugerida.produtoaquisitado">Produtoaquisitado</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valor"><span data-translate="netWordAgroApp.aquisicaosugerida.valor">Valor</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quantidade"><span data-translate="netWordAgroApp.aquisicaosugerida.quantidade">Quantidade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="medidaquantidade"><span data-translate="netWordAgroApp.aquisicaosugerida.medidaquantidade">Medidaquantidade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="receituario.produto"><span data-translate="netWordAgroApp.aquisicaosugerida.receituario">Receituario</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="aquisicaosugerida in vm.aquisicaosugeridas track by aquisicaosugerida.id"><td><a ui-sref="aquisicaosugerida-detail({id:aquisicaosugerida.id})">{{aquisicaosugerida.id}}</a></td><td>{{aquisicaosugerida.produtoaquisitado}}</td><td>{{aquisicaosugerida.valor}}</td><td>{{aquisicaosugerida.quantidade}}</td><td data-translate="{{\'netWordAgroApp.Tipomedidaaquisicaosugerida.\' + aquisicaosugerida.medidaquantidade}}">{{aquisicaosugerida.medidaquantidade}}</td><td><a ui-sref="receituario-detail({id:aquisicaosugerida.receituario.id})">{{aquisicaosugerida.receituario.produto}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="aquisicaosugerida-detail({id:aquisicaosugerida.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="aquisicaosugerida.aprovar({id:aquisicaosugerida.id})" class="btn btn-success btn-sm"><span class="glyphicon glyphicon-ok"></span> <span class="hidden-sm-down">Aprovar Compra</span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/armazenamentoinsumos/armazenamentoinsumos-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.armazenamentoinsumos.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.armazenamentoinsumos.delete.question" translate-values="{id: \'{{vm.armazenamentoinsumos.id}}\'}">Are you sure you want to delete this Armazenamentoinsumos?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/armazenamentoinsumos/armazenamentoinsumos-detail.html','<div><h2><span data-translate="netWordAgroApp.armazenamentoinsumos.detail.title">Armazenamentoinsumos</span> {{vm.armazenamentoinsumos.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="armazenamentoinsumos-detail.edit({id:vm.armazenamentoinsumos.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/armazenamentoinsumos/armazenamentoinsumos-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myArmazenamentoinsumosLabel" data-translate="netWordAgroApp.armazenamentoinsumos.home.createOrEditLabel">Create or edit a Armazenamentoinsumos</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.armazenamentoinsumos.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.armazenamentoinsumos.id" readonly="readonly"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/armazenamentoinsumos/armazenamentoinsumos.html','<div><h2 data-translate="netWordAgroApp.armazenamentoinsumos.home.title">Armazenamentoinsumos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="armazenamentoinsumos.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.armazenamentoinsumos.home.createLabel">Create new Armazenamentoinsumos</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.armazenamentoinsumos.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="armazenamentoinsumos in vm.armazenamentoinsumos track by armazenamentoinsumos.id"><td><a ui-sref="armazenamentoinsumos-detail({id:armazenamentoinsumos.id})">{{armazenamentoinsumos.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="armazenamentoinsumos-detail({id:armazenamentoinsumos.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="armazenamentoinsumos.edit({id:armazenamentoinsumos.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="armazenamentoinsumos.delete({id:armazenamentoinsumos.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/atividade/atividade-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.atividade.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.atividade.delete.question" translate-values="{id: \'{{vm.atividade.id}}\'}">Are you sure you want to delete this Atividade?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/atividade/atividade-detail.html','<script type="text/javascript">function Voltar(){\n        history.go(-1);\n    }</script><div><h2><span data-translate="netWordAgroApp.atividade.detail.title">Atividade</span> {{vm.atividade.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.atividade.nome">Nome</span></dt><dd><span>{{vm.atividade.nome}}</span></dd><dt><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span></dt><dd><span>{{vm.atividade.descricao}}</span></dd><dt><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span></dt><dd><span>{{vm.atividade.datainicio | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span></dt><dd><span>{{vm.atividade.datatermino | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipolocal.\' + vm.atividade.tipolocal}}">{{vm.atividade.tipolocal}}</span></dd><dt><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span></dt><dd><a ui-sref="localarmazenamento-detail({id:vm.atividade.localarmazenamento.id})">{{vm.atividade.localarmazenamento.nomelocal}}</a></dd><dt><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.atividade.etapa.id})">{{vm.atividade.etapa.nomeetapa}}</a></dd></dl><button type="submit" onclick="Voltar()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="atividade-detail.edit({id:vm.atividade.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.servico.home.title">Servicos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="servico.new({idativ:vm.atividade.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.servico.home.createLabel">Create new Servico</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.servico.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.servico.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.servico.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valor"><span data-translate="netWordAgroApp.servico.valor">Valor</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomeresponsavel"><span data-translate="netWordAgroApp.servico.nomeresponsavel">Nomeresponsavel</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tiporesponsavel"><span data-translate="netWordAgroApp.servico.tiporesponsavel">Tiporesponsavel</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datacontratacao"><span data-translate="netWordAgroApp.servico.datacontratacao">Datacontratacao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datarealizacao"><span data-translate="netWordAgroApp.servico.datarealizacao">Datarealizacao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fluxo"><span data-translate="netWordAgroApp.servico.fluxo">Fluxo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="atividade.nome"><span data-translate="netWordAgroApp.servico.atividade">Atividade</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="servico in vm.servicos track by servico.id"><td><a ui-sref="servico-detail({id:servico.id})">{{servico.id}}</a></td><td>{{servico.nome}}</td><td>{{servico.descricao}}</td><td>{{servico.valor}}</td><td>{{servico.nomeresponsavel}}</td><td data-translate="{{\'netWordAgroApp.Tiposervico.\' + servico.tiporesponsavel}}">{{servico.tiporesponsavel}}</td><td>{{servico.datacontratacao | date:\'mediumDate\'}}</td><td>{{servico.datarealizacao | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipofluxo.\' + servico.fluxo}}">{{servico.fluxo}}</td><td><a ui-sref="atividade-detail({id:servico.atividade.id})">{{servico.atividade.nome}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="servico-detail({id:servico.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="servico.edit({id:servico.id, idativ:vm.atividade.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="servico.delete({id:servico.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/atividade/atividade-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAtividadeLabel" data-translate="netWordAgroApp.atividade.home.createOrEditLabel">Create or edit a Atividade</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.atividade.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.atividade.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.atividade.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.atividade.nome" required><div ng-show="editForm.nome.$invalid"><p class="help-block" ng-show="editForm.nome.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.atividade.descricao" for="field_descricao">Descricao</label><input type="text" class="form-control" name="descricao" id="field_descricao" ng-model="vm.atividade.descricao" required><div ng-show="editForm.descricao.$invalid"><p class="help-block" ng-show="editForm.descricao.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.atividade.datainicio" for="field_datainicio">Datainicio</label><div class="input-group"><input id="field_datainicio" type="text" class="form-control" name="datainicio" uib-datepicker-popup="{{dateformat}}" ng-model="vm.atividade.datainicio" is-open="vm.datePickerOpenStatus.datainicio" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datainicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datainicio.$invalid"><p class="help-block" ng-show="editForm.datainicio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.atividade.datatermino" for="field_datatermino">Datatermino</label><div class="input-group"><input id="field_datatermino" type="text" class="form-control" name="datatermino" uib-datepicker-popup="{{dateformat}}" ng-model="vm.atividade.datatermino" is-open="vm.datePickerOpenStatus.datatermino" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datatermino\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datatermino.$invalid"><p class="help-block" ng-show="editForm.datatermino.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.atividade.tipolocal" for="field_tipolocal">Tipolocal</label><select class="form-control" name="tipolocal" ng-model="vm.atividade.tipolocal" id="field_tipolocal" required><option value="propriedade" data-translate="netWordAgroApp.Tipolocal.propriedade">propriedade</option><option value="outro" data-translate="netWordAgroApp.Tipolocal.outro">outro</option></select><div ng-show="editForm.tipolocal.$invalid"><p class="help-block" ng-show="editForm.tipolocal.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.atividade.localarmazenamento" for="field_localarmazenamento">Localarmazenamento</label><select class="form-control" id="field_localarmazenamento" name="localarmazenamento" ng-model="vm.atividade.localarmazenamento" ng-options="localarmazenamento as localarmazenamento.nomelocal for localarmazenamento in vm.localarmazenamentos track by localarmazenamento.id"></select></div><!--\n        <div ng-show="editForm.localarmazenamento.$invalid">\n            <p class="help-block"\n                ng-show="editForm.localarmazenamento.$error.required" data-translate="entity.validation.required">\n                This field is required.\n            </p>\n        </div>\n        <div class="form-group">\n            <label data-translate="netWordAgroApp.atividade.etapa" for="field_etapa">Etapa</label>\n            <select class="form-control" id="field_etapa" name="etapa" ng-model="vm.atividade.etapa" ng-options="etapa as etapa.nomeetapa for etapa in vm.etapas track by etapa.id">\n                <option value=""></option>\n            </select>\n        </div>\n    --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/atividade/atividades.html','<div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/armazenamentosafra/armazenamentosafra-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.armazenamentosafra.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.armazenamentosafra.delete.question" translate-values="{id: \'{{vm.armazenamentosafra.id}}\'}">Are you sure you want to delete this Armazenamentosafra?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/armazenamentosafra/armazenamentosafra-detail.html','<div><h2><span data-translate="netWordAgroApp.armazenamentosafra.detail.title">Armazenamentosafra</span> {{vm.armazenamentosafra.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.armazenamentosafra.dataarmazenamento">Dataarmazenamento</span></dt><dd><span>{{vm.armazenamentosafra.dataarmazenamento | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.armazenamentosafra.quantidadearmazenada">Quantidadearmazenada</span></dt><dd><span>{{vm.armazenamentosafra.quantidadearmazenada}}</span></dd><dt><span data-translate="netWordAgroApp.armazenamentosafra.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.armazenamentosafra.safra.id})">{{vm.armazenamentosafra.safra.nomesafra}}</a></dd><dt><span data-translate="netWordAgroApp.armazenamentosafra.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.armazenamentosafra.etapa.id})">{{vm.armazenamentosafra.etapa.nomeetapa}}</a></dd></dl><button type="submit" ui-sref="armazenamentosafra" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="armazenamentosafra-detail.edit({id:vm.armazenamentosafra.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.armazenamentosafra.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.armazenamentosafra.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/armazenamentosafra/armazenamentosafra-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myArmazenamentosafraLabel" data-translate="netWordAgroApp.armazenamentosafra.home.createOrEditLabel">Create or edit a Armazenamentosafra</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.armazenamentosafra.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.armazenamentosafra.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.armazenamentosafra.$invalid"><p class="help-block" ng-show="editForm.armazenamentosafra.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.armazenamentosafra.dataarmazenamento" for="field_dataarmazenamento">Dataarmazenamento</label><div class="input-group"><input id="field_dataarmazenamento" type="text" class="form-control" name="dataarmazenamento" uib-datepicker-popup="{{dateformat}}" ng-model="vm.armazenamentosafra.dataarmazenamento" is-open="vm.datePickerOpenStatus.dataarmazenamento" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataarmazenamento\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.dataarmazenamento.$invalid"><p class="help-block" ng-show="editForm.dataarmazenamento.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.armazenamentosafra.quantidadearmazenada" for="field_quantidadearmazenada">Quantidadearmazenada</label><input type="number" class="form-control" name="quantidadearmazenada" id="field_quantidadearmazenada" ng-model="vm.armazenamentosafra.quantidadearmazenada" required min="0"><div ng-show="editForm.quantidadearmazenada.$invalid"><p class="help-block" ng-show="editForm.quantidadearmazenada.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.quantidadearmazenada.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.quantidadearmazenada.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.armazenamentosafra.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.armazenamentosafra.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/armazenamentosafra/armazenamentosafras.html','<div><h2 data-translate="netWordAgroApp.armazenamentosafra.home.title">Armazenamentosafras</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="armazenamentosafra.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.armazenamentosafra.home.createLabel">Create new Armazenamentosafra</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.armazenamentosafra.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dataarmazenamento"><span data-translate="netWordAgroApp.armazenamentosafra.dataarmazenamento">Dataarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quantidadearmazenada"><span data-translate="netWordAgroApp.armazenamentosafra.quantidadearmazenada">Quantidadearmazenada</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.armazenamentosafra.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="armazenamentosafra in vm.armazenamentosafras track by armazenamentosafra.id"><td><a ui-sref="armazenamentosafra-detail({id:armazenamentosafra.id})">{{armazenamentosafra.id}}</a></td><td>{{armazenamentosafra.dataarmazenamento | date:\'mediumDate\'}}</td><td>{{armazenamentosafra.quantidadearmazenada}}</td><td><a ui-sref="etapa-detail({id:armazenamentosafra.etapa.id})">{{armazenamentosafra.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="armazenamentosafra-detail({id:armazenamentosafra.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="armazenamentosafra.edit({id:armazenamentosafra.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="armazenamentosafra.delete({id:armazenamentosafra.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/armazenamentosafratestem/armazenamentosafratestem-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.armazenamentosafratestem.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.armazenamentosafratestem.delete.question" translate-values="{id: \'{{vm.armazenamentosafratestem.id}}\'}">Are you sure you want to delete this Armazenamentosafratestem?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/armazenamentosafratestem/armazenamentosafratestem-detail.html','<div><h2><span data-translate="netWordAgroApp.armazenamentosafratestem.detail.title">Armazenamentosafratestem</span> {{vm.armazenamentosafratestem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.armazenamentosafratestem.dataarmazenamento">Dataarmazenamento</span></dt><dd><span>{{vm.armazenamentosafratestem.dataarmazenamento | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.armazenamentosafratestem.quantidadearmazenada">Quantidadearmazenada</span></dt><dd><span>{{vm.armazenamentosafratestem.quantidadearmazenada}}</span></dd><dt><span data-translate="netWordAgroApp.armazenamentosafratestem.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.armazenamentosafratestem.etapa.id})">{{vm.armazenamentosafratestem.etapa.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="armazenamentosafratestem-detail.edit({id:vm.armazenamentosafratestem.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.armazenamentosafratestem.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.armazenamentosafratestem.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/armazenamentosafratestem/armazenamentosafratestem-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myarmazenamentosafratestemLabel" data-translate="netWordAgroApp.armazenamentosafratestem.home.createOrEditLabel">Create or edit a armazenamentosafratestem</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.armazenamentosafratestem.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.armazenamentosafratestem.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.armazenamentosafratestem.$invalid"><p class="help-block" ng-show="editForm.armazenamentosafratestem.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.armazenamentosafratestem.dataarmazenamento" for="field_dataarmazenamento">Dataarmazenamento</label><div class="input-group"><input id="field_dataarmazenamento" type="text" class="form-control" name="dataarmazenamento" uib-datepicker-popup="{{dateformat}}" ng-model="vm.armazenamentosafratestem.dataarmazenamento" is-open="vm.datePickerOpenStatus.dataarmazenamento" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataarmazenamento\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.dataarmazenamento.$invalid"><p class="help-block" ng-show="editForm.dataarmazenamento.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.armazenamentosafratestem.quantidadearmazenada" for="field_quantidadearmazenada">Quantidadearmazenada</label><input type="number" class="form-control" name="quantidadearmazenada" id="field_quantidadearmazenada" ng-model="vm.armazenamentosafratestem.quantidadearmazenada" required min="0"><div ng-show="editForm.quantidadearmazenada.$invalid"><p class="help-block" ng-show="editForm.quantidadearmazenada.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.quantidadearmazenada.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.quantidadearmazenada.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.armazenamentosafratestem.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.armazenamentosafratestem.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/armazenamentosafratestem/armazenamentosafratestems.html','<div><h2 data-translate="netWordAgroApp.armazenamentosafratestem.home.title">Armazenamentosafratestems</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="armazenamentosafratestem.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.armazenamentosafratestem.home.createLabel">Create new Armazenamentosafratestem</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.armazenamentosafratestem.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dataarmazenamento"><span data-translate="netWordAgroApp.armazenamentosafratestem.dataarmazenamento">Dataarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quantidadearmazenada"><span data-translate="netWordAgroApp.armazenamentosafratestem.quantidadearmazenada">Quantidadearmazenada</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.id"><span data-translate="netWordAgroApp.armazenamentosafratestem.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="armazenamentosafratestem in vm.armazenamentosafratestems track by armazenamentosafratestem.id"><td><a ui-sref="armazenamentosafratestem-detail({id:armazenamentosafratestem.id})">{{armazenamentosafratestem.id}}</a></td><td>{{armazenamentosafratestem.dataarmazenamento | date:\'mediumDate\'}}</td><td>{{armazenamentosafratestem.quantidadearmazenada}}</td><td><a ui-sref="etapa-detail({id:armazenamentosafratestem.etapa.id})">{{armazenamentosafratestem.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="armazenamentosafratestem-detail({id:armazenamentosafratestem.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="armazenamentosafratestem.edit({id:armazenamentosafratestem.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="armazenamentosafratestem.delete({id:armazenamentosafratestem.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/armazenamentosafraplan/armazenamentosafraplan-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.armazenamentosafraplan.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.armazenamentosafraplan.delete.question" translate-values="{id: \'{{vm.armazenamentosafraplan.id}}\'}">Are you sure you want to delete this Armazenamentosafraplan?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/armazenamentosafraplan/armazenamentosafraplan-detail.html','<div><h2><span data-translate="netWordAgroApp.armazenamentosafraplan.detail.title">Armazenamentosafraplan</span> {{vm.armazenamentosafraplan.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.armazenamentosafraplan.dataarmazenamento">Dataarmazenamento</span></dt><dd><span>{{vm.armazenamentosafraplan.dataarmazenamento | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.armazenamentosafraplan.quantidadearmazenada">Quantidadearmazenada</span></dt><dd><span>{{vm.armazenamentosafraplan.quantidadearmazenada}}</span></dd><dt><span data-translate="netWordAgroApp.armazenamentosafraplan.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.armazenamentosafraplan.safra.id})">{{vm.armazenamentosafraplan.safra.nomesafra}}</a></dd><dt><span data-translate="netWordAgroApp.armazenamentosafraplan.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.armazenamentosafraplan.etapa.id})">{{vm.armazenamentosafraplan.etapa.nomeetapa}}</a></dd></dl><button type="submit" ui-sref="armazenamentosafraplan" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="armazenamentosafraplan-detail.edit({id:vm.armazenamentosafraplan.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.armazenamentosafraplan.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.armazenamentosafraplan.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/armazenamentosafraplan/armazenamentosafraplan-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myArmazenamentosafraplanLabel" data-translate="netWordAgroApp.armazenamentosafraplan.home.createOrEditLabel">Create or edit a Armazenamentosafraplan</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.armazenamentosafraplan.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.armazenamentosafraplan.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.armazenamentosafraplan.$invalid"><p class="help-block" ng-show="editForm.armazenamentosafraplan.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.armazenamentosafraplan.dataarmazenamento" for="field_dataarmazenamento">Dataarmazenamento</label><div class="input-group"><input id="field_dataarmazenamento" type="text" class="form-control" name="dataarmazenamento" uib-datepicker-popup="{{dateformat}}" ng-model="vm.armazenamentosafraplan.dataarmazenamento" is-open="vm.datePickerOpenStatus.dataarmazenamento" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataarmazenamento\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.dataarmazenamento.$invalid"><p class="help-block" ng-show="editForm.dataarmazenamento.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.armazenamentosafraplan.quantidadearmazenada" for="field_quantidadearmazenada">Quantidadearmazenada</label><input type="number" class="form-control" name="quantidadearmazenada" id="field_quantidadearmazenada" ng-model="vm.armazenamentosafraplan.quantidadearmazenada" required min="0"><div ng-show="editForm.quantidadearmazenada.$invalid"><p class="help-block" ng-show="editForm.quantidadearmazenada.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.quantidadearmazenada.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.quantidadearmazenada.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.armazenamentosafraplan.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.armazenamentosafraplan.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/armazenamentosafraplan/armazenamentosafraplans.html','<div><h2 data-translate="netWordAgroApp.armazenamentosafraplan.home.title">Armazenamentosafraplans</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="armazenamentosafraplan.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.armazenamentosafraplan.home.createLabel">Create new Armazenamentosafraplan</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.armazenamentosafraplan.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dataarmazenamento"><span data-translate="netWordAgroApp.armazenamentosafraplan.dataarmazenamento">Dataarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quantidadearmazenada"><span data-translate="netWordAgroApp.armazenamentosafraplan.quantidadearmazenada">Quantidadearmazenada</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.armazenamentosafraplan.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="armazenamentosafraplan in vm.armazenamentosafraplans track by armazenamentosafraplan.id"><td><a ui-sref="armazenamentosafraplan-detail({id:armazenamentosafraplan.id})">{{armazenamentosafraplan.id}}</a></td><td>{{armazenamentosafraplan.dataarmazenamento | date:\'mediumDate\'}}</td><td>{{armazenamentosafraplan.quantidadearmazenada}}</td><td><a ui-sref="etapa-detail({id:armazenamentosafraplan.etapa.id})">{{armazenamentosafraplan.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="armazenamentosafraplan-detail({id:armazenamentosafraplan.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="armazenamentosafraplan.edit({id:armazenamentosafraplan.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="armazenamentosafraplan.delete({id:armazenamentosafraplan.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/atributo/atributo-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.atributo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.atributo.delete.question" translate-values="{id: \'{{vm.atributo.id}}\'}">Are you sure you want to delete this Atributo?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/atributo/atributo-detail.html','<div><h2><span data-translate="netWordAgroApp.atributo.detail.title">Atributo</span> {{vm.atributo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.atributo.nomeatributo">Nomeatributo</span></dt><dd><span>{{vm.atributo.nomeatributo}}</span></dd><dt><span data-translate="netWordAgroApp.atributo.funcaoatributo">Funcaoatributo</span></dt><dd><span>{{vm.atributo.funcaoatributo}}</span></dd><dt><span data-translate="netWordAgroApp.atributo.caracatributo">Caracatributo</span></dt><dd><span>{{vm.atributo.caracatributo}}</span></dd><dt><span data-translate="netWordAgroApp.atributo.tipoatributo">Tipoatributo</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipoatributo.\' + vm.atributo.tipoatributo}}">{{vm.atributo.tipoatributo}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="atributo-detail.edit({id:vm.atributo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/atributo/atributo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAtributoLabel" data-translate="netWordAgroApp.atributo.home.createOrEditLabel">Create or edit a Atributo</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.atributo.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.atributo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.atributo.nomeatributo" for="field_nomeatributo">Nomeatributo</label><input type="text" class="form-control" name="nomeatributo" id="field_nomeatributo" ng-model="vm.atributo.nomeatributo" required ng-maxlength="50"><div ng-show="editForm.nomeatributo.$invalid"><p class="help-block" ng-show="editForm.nomeatributo.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nomeatributo.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.atributo.funcaoatributo" for="field_funcaoatributo">Funcaoatributo</label><input type="text" class="form-control" name="funcaoatributo" id="field_funcaoatributo" ng-model="vm.atributo.funcaoatributo" required ng-maxlength="500"><div ng-show="editForm.funcaoatributo.$invalid"><p class="help-block" ng-show="editForm.funcaoatributo.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.funcaoatributo.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="500">This field cannot be longer than 500 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.atributo.caracatributo" for="field_caracatributo">Caracatributo</label><input type="text" class="form-control" name="caracatributo" id="field_caracatributo" ng-model="vm.atributo.caracatributo" required><div ng-show="editForm.caracatributo.$invalid"><p class="help-block" ng-show="editForm.caracatributo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.atributo.tipoatributo" for="field_tipoatributo">Tipoatributo</label><select class="form-control" name="tipoatributo" ng-model="vm.atributo.tipoatributo" id="field_tipoatributo" required><option value="fisico" data-translate="netWordAgroApp.Tipoatributo.fisico">fisico</option><option value="quimico" data-translate="netWordAgroApp.Tipoatributo.quimico">quimico</option></select><div ng-show="editForm.tipoatributo.$invalid"><p class="help-block" ng-show="editForm.tipoatributo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/atributo/atributos.html','<div><h2 data-translate="netWordAgroApp.atributo.home.title">Atributos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atributo.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atributo.home.createLabel">Create new Atributo</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atributo.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomeatributo"><span data-translate="netWordAgroApp.atributo.nomeatributo">Nomeatributo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="funcaoatributo"><span data-translate="netWordAgroApp.atributo.funcaoatributo">Funcaoatributo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="caracatributo"><span data-translate="netWordAgroApp.atributo.caracatributo">Caracatributo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipoatributo"><span data-translate="netWordAgroApp.atributo.tipoatributo">Tipoatributo</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atributo in vm.atributos track by atributo.id"><td><a ui-sref="atributo-detail({id:atributo.id})">{{atributo.id}}</a></td><td>{{atributo.nomeatributo}}</td><td>{{atributo.funcaoatributo}}</td><td>{{atributo.caracatributo}}</td><td data-translate="{{\'netWordAgroApp.Tipoatributo.\' + atributo.tipoatributo}}">{{atributo.tipoatributo}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atributo-detail({id:atributo.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atributo.edit({id:atributo.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atributo.delete({id:atributo.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/automatizacao/automatizacao-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.automatizacao.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.automatizacao.delete.question" translate-values="{id: \'{{vm.automatizacao.id}}\'}">Are you sure you want to delete this Automatizacao?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/automatizacao/automatizacao-detail.html','<div><h2><span data-translate="netWordAgroApp.automatizacao.detail.title">Automatizacao</span> {{vm.automatizacao.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.automatizacao.inicioprocessamento">Inicioprocessamento</span></dt><dd><span>{{vm.automatizacao.inicioprocessamento}}</span></dd><dt><span data-translate="netWordAgroApp.automatizacao.fimprocessamento">Fimprocessamento</span></dt><dd><span>{{vm.automatizacao.fimprocessamento}}</span></dd><dt><span data-translate="netWordAgroApp.automatizacao.status">Status</span></dt><dd><span>{{vm.automatizacao.status}}</span></dd><dt><span data-translate="netWordAgroApp.automatizacao.maquinaresponsavel">Maquinaresponsavel</span></dt><dd><span>{{vm.automatizacao.maquinaresponsavel}}</span></dd><dt><span data-translate="netWordAgroApp.automatizacao.log">Log</span></dt><dd><span>{{vm.automatizacao.log}}</span></dd><dt><span data-translate="netWordAgroApp.automatizacao.descricao">Descricao</span></dt><dd><span>{{vm.automatizacao.descricao}}</span></dd><dt><span data-translate="netWordAgroApp.automatizacao.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.automatizacao.safra.id})">{{vm.automatizacao.safra.nomesafra}}</a></dd><dt><span data-translate="netWordAgroApp.automatizacao.propriedade">Propriedade</span></dt><dd><a ui-sref="propriedade-detail({id:vm.automatizacao.propriedade.id})">{{vm.automatizacao.propriedade.nomepropriedade}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="automatizacao-detail.edit({id:vm.automatizacao.id})" class="btn btn-primary" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/automatizacao/automatizacao-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAutomatizacaoLabel" data-translate="netWordAgroApp.automatizacao.home.createOrEditLabel">Create or edit a Automatizacao</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.automatizacao.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.automatizacao.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.automatizacao.inicioprocessamento" for="field_inicioprocessamento">Inicioprocessamento</label><input type="text" class="form-control" name="inicioprocessamento" id="field_inicioprocessamento" ng-model="vm.automatizacao.inicioprocessamento"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.automatizacao.fimprocessamento" for="field_fimprocessamento">Fimprocessamento</label><input type="text" class="form-control" name="fimprocessamento" id="field_fimprocessamento" ng-model="vm.automatizacao.fimprocessamento"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.automatizacao.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.automatizacao.status"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.automatizacao.maquinaresponsavel" for="field_maquinaresponsavel">Maquinaresponsavel</label><input type="text" class="form-control" name="maquinaresponsavel" id="field_maquinaresponsavel" ng-model="vm.automatizacao.maquinaresponsavel"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.automatizacao.log" for="field_log">Log</label><input type="text" class="form-control" name="log" id="field_log" ng-model="vm.automatizacao.log"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.automatizacao.descricao" for="field_descricao">Descricao</label><input type="text" class="form-control" name="descricao" id="field_descricao" ng-model="vm.automatizacao.descricao"></div><div class="form-group"><label data-translate="netWordAgroApp.automatizacao.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.automatizacao.safra" ng-options="safra as safra.nomesafra for safra in vm.safras track by safra.id"><option value=""></option></select></div><div class="form-group"><label data-translate="netWordAgroApp.automatizacao.propriedade" for="field_propriedade">Propriedade</label><select class="form-control" id="field_propriedade" name="propriedade" ng-model="vm.automatizacao.propriedade" ng-options="propriedade as propriedade.nomepropriedade for propriedade in vm.propriedades track by propriedade.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/automatizacao/automatizacaos.html','<div><h2 data-translate="netWordAgroApp.automatizacao.home.title">Automatizacaos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><!--<button class="btn btn-primary" ui-sref="automatizacao.new" >\n                    <span class="glyphicon glyphicon-plus"></span>\n                    <span class="hidden-xs-down"  data-translate="netWordAgroApp.automatizacao.home.createLabel">\n                        Create new Automatizacao\n                    </span>\n                </button>--></div><div class="col-xs-8 no-padding-right"><!--<form name="searchForm" class="form-inline">\n                    <div class="input-group pull-right" >\n                        <input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.automatizacao.home.search\' | translate }}">\n                        <span  class="input-group-btn width-min" >\n                            <button class="btn btn-info" ng-click="vm.search(vm.searchQuery)">\n                                <span class="glyphicon glyphicon-search"></span>\n                            </button>\n                        </span>\n                        <span class="input-group-btn width-min" ng-if="vm.currentSearch">\n                            <button class="btn btn-info" ng-click="vm.clear()">\n                                <span class="glyphicon glyphicon-trash"></span>\n                            </button>\n                        </span>\n                    </div>\n                </form>--></div></div></div><div class="container-fluid" style="margin-top:10px"><div class="row"><div class="col-xs-4 no-padding-left"><form name="filtrar" class="form-inline"><label class="control-label" data-translate="netWordAgroApp.mapaimagem.filtrarporpropriedade" for="field_filtropropriedade">Tipomapa</label><select class="form-control" id="field_filtropropriedade" name="filtropropriedade" ng-model="vm.filtropropriedade" ng-options="prop as prop.nomepropriedade for prop in vm.filtropropriedades track by prop.id" ng-change="vm.changeFiltro()"><option value></option></select></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="inicioprocessamento"><span data-translate="netWordAgroApp.automatizacao.inicioprocessamento">Inicioprocessamento</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fimprocessamento"><span data-translate="netWordAgroApp.automatizacao.fimprocessamento">Fimprocessamento</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span data-translate="netWordAgroApp.automatizacao.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="maquinaresponsavel"><span data-translate="netWordAgroApp.automatizacao.maquinaresponsavel">Maquinaresponsavel</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="log"><span data-translate="netWordAgroApp.automatizacao.log">Log</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao" style="min-width: 500px"><span data-translate="netWordAgroApp.automatizacao.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="safra.nomesafra" style="min-width: 200px"><span data-translate="netWordAgroApp.automatizacao.safra">Safra</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="propriedade.nomepropriedade" style="min-width: 200px"><span data-translate="netWordAgroApp.automatizacao.propriedade">Propriedade</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="automatizacao in vm.automatizacaos track by automatizacao.id"><td><a ui-sref="automatizacao-detail({id:automatizacao.id})">{{automatizacao.id}}</a></td><td>{{automatizacao.inicioprocessamento}}</td><td>{{automatizacao.fimprocessamento}}</td><td>{{automatizacao.status}}</td><td>{{automatizacao.maquinaresponsavel}}</td><td>{{automatizacao.log}}</td><td>{{automatizacao.descricao}}</td><td><a ui-sref="safra-detail({id:automatizacao.safra.id})">{{automatizacao.safra.nomesafra}}</a></td><td><a ui-sref="propriedade-detail({id:automatizacao.propriedade.id})">{{automatizacao.propriedade.nomepropriedade}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="automatizacao-detail({id:automatizacao.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span><!--  <span class="hidden-sm-down" data-translate="entity.action.view"></span> --></button> <button type="submit" ui-sref="automatizacao.edit({id:automatizacao.id})" class="btn btn-primary btn-sm" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-pencil"></span><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--></button> <button type="submit" ui-sref="automatizacao.delete({id:automatizacao.id})" class="btn btn-danger btn-sm" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-remove-circle"></span><!-- <span class="hidden-sm-down" data-translate="entity.action.delete"></span> --></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/atributopesquisa/atributopesquisa-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.atributopesquisa.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.atributopesquisa.delete.question" translate-values="{id: \'{{vm.atributopesquisa.id}}\'}">Are you sure you want to delete this Atributopesquisa?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/atributopesquisa/atributopesquisa-detail.html','<div><h2><span data-translate="netWordAgroApp.atributopesquisa.detail.title">Atributopesquisa</span> {{vm.atributopesquisa.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.atributopesquisa.pesquisa">Pesquisa</span></dt><dd><a ui-sref="pesquisa-detail({id:vm.atributopesquisa.pesquisa.id})">{{vm.atributopesquisa.pesquisa.nomepesquisa}}</a></dd><dt><span data-translate="netWordAgroApp.atributopesquisa.atributo">Atributo</span></dt><dd><a ui-sref="atributo-detail({id:vm.atributopesquisa.atributo.id})">{{vm.atributopesquisa.atributo.nomeatributo}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="atributopesquisa-detail.edit({id:vm.atributopesquisa.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/atributopesquisa/atributopesquisa-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAtributopesquisaLabel" data-translate="netWordAgroApp.atributopesquisa.home.createOrEditLabel">Create or edit a Atributopesquisa</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.atributopesquisa.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.atributopesquisa.id" readonly="readonly"></div><div class="form-group"><label data-translate="netWordAgroApp.atributopesquisa.pesquisa" for="field_pesquisa">Pesquisa</label><select class="form-control" id="field_pesquisa" name="pesquisa" ng-model="vm.atributopesquisa.pesquisa" ng-options="pesquisa as pesquisa.nomepesquisa for pesquisa in vm.pesquisas track by pesquisa.id" required></select></div><div ng-show="editForm.pesquisa.$invalid"><p class="help-block" ng-show="editForm.pesquisa.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.atributopesquisa.atributo" for="field_atributo">Atributo</label><select class="form-control" id="field_atributo" name="atributo" ng-model="vm.atributopesquisa.atributo" ng-options="atributo as atributo.nomeatributo for atributo in vm.atributos track by atributo.id" required></select></div><div ng-show="editForm.atributo.$invalid"><p class="help-block" ng-show="editForm.atributo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/atributopesquisa/atributopesquisas.html','<div><h2 data-translate="netWordAgroApp.atributopesquisa.home.title">Atributopesquisas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atributopesquisa.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atributopesquisa.home.createLabel">Create new Atributopesquisa</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atributopesquisa.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pesquisa.nomepesquisa"><span data-translate="netWordAgroApp.atributopesquisa.pesquisa">Pesquisa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="atributo.nomeatributo"><span data-translate="netWordAgroApp.atributopesquisa.atributo">Atributo</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atributopesquisa in vm.atributopesquisas track by atributopesquisa.id"><td><a ui-sref="atributopesquisa-detail({id:atributopesquisa.id})">{{atributopesquisa.id}}</a></td><td><a ui-sref="pesquisa-detail({id:atributopesquisa.pesquisa.id})">{{atributopesquisa.pesquisa.nomepesquisa}}</a></td><td><a ui-sref="atributo-detail({id:atributopesquisa.atributo.id})">{{atributopesquisa.atributo.nomeatributo}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atributopesquisa-detail({id:atributopesquisa.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atributopesquisa.edit({id:atributopesquisa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atributopesquisa.delete({id:atributopesquisa.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/caracteristicacultura/caracteristicacultura-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.caracteristicacultura.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.caracteristicacultura.delete.question" translate-values="{id: \'{{vm.caracteristicacultura.id}}\'}">Are you sure you want to delete this Caracteristicacultura?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/caracteristicacultura/caracteristicacultura-detail.html','<div><h2><span data-translate="netWordAgroApp.caracteristicacultura.detail.title">Caracteristicacultura</span> {{vm.caracteristicacultura.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.caracteristicacultura.descaracteristica">Descaracteristica</span></dt><dd><span>{{vm.caracteristicacultura.descaracteristica}}</span></dd><dt><span data-translate="netWordAgroApp.caracteristicacultura.destipcaracteristica">Destipcaracteristica</span></dt><dd><span>{{vm.caracteristicacultura.destipcaracteristica}}</span></dd><dt><span data-translate="netWordAgroApp.caracteristicacultura.valorcaracteristica">Valorcaracteristica</span></dt><dd><span>{{vm.caracteristicacultura.valorcaracteristica}}</span></dd><dt><span data-translate="netWordAgroApp.caracteristicacultura.cultura">Cultura</span></dt><dd><a ui-sref="cultura-detail({id:vm.caracteristicacultura.cultura.id})">{{vm.caracteristicacultura.cultura.nomecultura}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="caracteristicacultura-detail.edit({id:vm.caracteristicacultura.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/caracteristicacultura/caracteristicacultura-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCaracteristicaculturaLabel" data-translate="netWordAgroApp.caracteristicacultura.home.createOrEditLabel">Create or edit a Caracteristicacultura</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.caracteristicacultura.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.caracteristicacultura.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.caracteristicacultura.descaracteristica" for="field_descaracteristica">Descaracteristica</label><input type="text" class="form-control" name="descaracteristica" id="field_descaracteristica" ng-model="vm.caracteristicacultura.descaracteristica" required ng-maxlength="50"><div ng-show="editForm.descaracteristica.$invalid"><p class="help-block" ng-show="editForm.descaracteristica.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.descaracteristica.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.caracteristicacultura.destipcaracteristica" for="field_destipcaracteristica">Destipcaracteristica</label><input type="text" class="form-control" name="destipcaracteristica" id="field_destipcaracteristica" ng-model="vm.caracteristicacultura.destipcaracteristica" required ng-maxlength="10"><div ng-show="editForm.destipcaracteristica.$invalid"><p class="help-block" ng-show="editForm.destipcaracteristica.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.destipcaracteristica.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.caracteristicacultura.valorcaracteristica" for="field_valorcaracteristica">Valorcaracteristica</label><input type="number" class="form-control" name="valorcaracteristica" id="field_valorcaracteristica" ng-model="vm.caracteristicacultura.valorcaracteristica" required><div ng-show="editForm.valorcaracteristica.$invalid"><p class="help-block" ng-show="editForm.valorcaracteristica.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.valorcaracteristica.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.caracteristicacultura.cultura" for="field_cultura">Cultura</label><select class="form-control" id="field_cultura" name="cultura" ng-model="vm.caracteristicacultura.cultura" ng-options="cultura as cultura.nomecultura for cultura in vm.culturas track by cultura.id" required></select></div><div ng-show="editForm.cultura.$invalid"><p class="help-block" ng-show="editForm.cultura.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/caracteristicacultura/caracteristicaculturas.html','<div><h2 data-translate="netWordAgroApp.caracteristicacultura.home.title">Caracteristicaculturas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="caracteristicacultura.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.caracteristicacultura.home.createLabel">Create new Caracteristicacultura</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.caracteristicacultura.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descaracteristica"><span data-translate="netWordAgroApp.caracteristicacultura.descaracteristica">Descaracteristica</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="destipcaracteristica"><span data-translate="netWordAgroApp.caracteristicacultura.destipcaracteristica">Destipcaracteristica</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorcaracteristica"><span data-translate="netWordAgroApp.caracteristicacultura.valorcaracteristica">Valorcaracteristica</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cultura.nomecultura"><span data-translate="netWordAgroApp.caracteristicacultura.cultura">Cultura</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="caracteristicacultura in vm.caracteristicaculturas track by caracteristicacultura.id"><td><a ui-sref="caracteristicacultura-detail({id:caracteristicacultura.id})">{{caracteristicacultura.id}}</a></td><td>{{caracteristicacultura.descaracteristica}}</td><td>{{caracteristicacultura.destipcaracteristica}}</td><td>{{caracteristicacultura.valorcaracteristica}}</td><td><a ui-sref="cultura-detail({id:caracteristicacultura.cultura.id})">{{caracteristicacultura.cultura.nomecultura}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="caracteristicacultura-detail({id:caracteristicacultura.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="caracteristicacultura.edit({id:caracteristicacultura.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="caracteristicacultura.delete({id:caracteristicacultura.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/avaliacaosolo/avaliacaosolo-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.avaliacaosolo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.avaliacaosolo.delete.question" translate-values="{id: \'{{vm.avaliacaosolo.id}}\'}">Are you sure you want to delete this Avaliacaosolo?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/avaliacaosolo/avaliacaosolo-detail.html','<div><h2><span data-translate="netWordAgroApp.avaliacaosolo.detail.title">Avaliacaosolo</span> {{vm.avaliacaosolo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.avaliacaosolo.usuario">Usuario</span></dt><dd><span>{{vm.avaliacaosolo.usuario}}</span></dd><dt><span data-translate="netWordAgroApp.avaliacaosolo.medicoes">Medicoes</span></dt><dd><div ng-if="vm.avaliacaosolo.medicoes"><a ng-click="vm.openFile(vm.avaliacaosolo.medicoesContentType, vm.avaliacaosolo.medicoes)" data-translate="entity.action.open">open</a> {{vm.avaliacaosolo.medicoesContentType}}, {{vm.byteSize(vm.avaliacaosolo.medicoes)}}</div></dd><dt><span data-translate="netWordAgroApp.avaliacaosolo.medicoesinfo">Medicoesinfo</span></dt><dd><div ng-if="vm.avaliacaosolo.medicoesinfo"><a ng-click="vm.openFile(vm.avaliacaosolo.medicoesinfoContentType, vm.avaliacaosolo.medicoesinfo)" data-translate="entity.action.open">open</a> {{vm.avaliacaosolo.medicoesinfoContentType}}, {{vm.byteSize(vm.avaliacaosolo.medicoesinfo)}}</div></dd><dt><span data-translate="netWordAgroApp.avaliacaosolo.dataavaliacao">Dataavaliacao</span></dt><dd><span>{{vm.avaliacaosolo.dataavaliacao}}</span></dd><dt><span data-translate="netWordAgroApp.avaliacaosolo.sensores">Sensores</span></dt><dd><span>{{vm.avaliacaosolo.sensores}}</span></dd><dt><span data-translate="netWordAgroApp.avaliacaosolo.propriedade">Propriedade</span></dt><dd><a ui-sref="propriedade-detail({id:vm.avaliacaosolo.propriedade.id})">{{vm.avaliacaosolo.propriedade.nomepropriedade}}</a></dd><dt><span data-translate="netWordAgroApp.avaliacaosolo.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.avaliacaosolo.safra.id})">{{vm.avaliacaosolo.safra.nomesafra}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="avaliacaosolo-detail.edit({id:vm.avaliacaosolo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/avaliacaosolo/avaliacaosolo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAvaliacaosoloLabel" data-translate="netWordAgroApp.avaliacaosolo.home.createOrEditLabel">Create or edit a Avaliacaosolo</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.avaliacaosolo.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.avaliacaosolo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.avaliacaosolo.usuario" for="field_usuario">Usuario</label><input type="text" class="form-control" name="usuario" id="field_usuario" ng-model="vm.avaliacaosolo.usuario"></div><div class="form-group" ngf-drop ngf-change="vm.setMedicoes($file, vm.avaliacaosolo)"><label class="control-label" data-translate="netWordAgroApp.avaliacaosolo.medicoes" for="field_medicoes">Medicoes</label><div><div ng-if="vm.avaliacaosolo.medicoes" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.avaliacaosolo.medicoesContentType, vm.avaliacaosolo.medicoes)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.avaliacaosolo.medicoesContentType}}, {{vm.byteSize(vm.avaliacaosolo.medicoes)}}</span> <button type="button" ng-click="vm.avaliacaosolo.medicoes=null;vm.avaliacaosolo.medicoesContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setMedicoes($file, vm.avaliacaosolo)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="medicoes" id="field_medicoes" ng-model="vm.avaliacaosolo.medicoes"> <input type="hidden" class="form-control" name="medicoesContentType" id="field_medicoesContentType" ng-model="vm.avaliacaosolo.medicoesContentType"></div><div class="form-group" ngf-drop ngf-change="vm.setMedicoesinfo($file, vm.avaliacaosolo)"><label class="control-label" data-translate="netWordAgroApp.avaliacaosolo.medicoesinfo" for="field_medicoesinfo">Medicoesinfo</label><div><div ng-if="vm.avaliacaosolo.medicoesinfo" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.avaliacaosolo.medicoesinfoContentType, vm.avaliacaosolo.medicoesinfo)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.avaliacaosolo.medicoesinfoContentType}}, {{vm.byteSize(vm.avaliacaosolo.medicoesinfo)}}</span> <button type="button" ng-click="vm.avaliacaosolo.medicoesinfo=null;vm.avaliacaosolo.medicoesinfoContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setMedicoesinfo($file, vm.avaliacaosolo)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="medicoesinfo" id="field_medicoesinfo" ng-model="vm.avaliacaosolo.medicoesinfo"> <input type="hidden" class="form-control" name="medicoesinfoContentType" id="field_medicoesinfoContentType" ng-model="vm.avaliacaosolo.medicoesinfoContentType"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.avaliacaosolo.dataavaliacao" for="field_dataavaliacao">Dataavaliacao</label><input type="text" class="form-control" name="dataavaliacao" id="field_dataavaliacao" ng-model="vm.avaliacaosolo.dataavaliacao"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.avaliacaosolo.sensores" for="field_sensores">Sensores</label><input type="text" class="form-control" name="sensores" id="field_sensores" ng-model="vm.avaliacaosolo.sensores"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.avaliacaosolo.profundidade" for="field_profundidade">Profundidade</label><input type="text" class="form-control" name="profundidade" id="field_profundidade" ng-model="vm.avaliacaosolo.profundidade"></div><div class="form-group"><label data-translate="netWordAgroApp.avaliacaosolo.propriedade" for="field_propriedade">Propriedade</label><select class="form-control" id="field_propriedade" name="propriedade" ng-model="vm.avaliacaosolo.propriedade" ng-options="propriedade as propriedade.nomepropriedade for propriedade in vm.propriedades track by propriedade.id"><option value=""></option></select></div><div class="form-group"><label data-translate="netWordAgroApp.avaliacaosolo.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.avaliacaosolo.safra" ng-options="safra as safra.nomesafra for safra in vm.safras track by safra.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/avaliacaosolo/avaliacaosolos.html','<div><h2 data-translate="netWordAgroApp.avaliacaosolo.home.title">Avaliacaosolos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="avaliacaosolo.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.avaliacaosolo.home.createLabel">Create new Avaliacaosolo</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.avaliacaosolo.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="usuario"><span data-translate="netWordAgroApp.avaliacaosolo.usuario">Usuario</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="medicoes"><span data-translate="netWordAgroApp.avaliacaosolo.medicoes">Medicoes</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="medicoesinfo"><span data-translate="netWordAgroApp.avaliacaosolo.medicoesinfo">Medicoesinfo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dataavaliacao"><span data-translate="netWordAgroApp.avaliacaosolo.dataavaliacao">Dataavaliacao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sensores"><span data-translate="netWordAgroApp.avaliacaosolo.sensores">Sensores</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="profundidade"><span data-translate="netWordAgroApp.avaliacaosolo.profundidade">profundidade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="propriedade.nomepropriedade"><span data-translate="netWordAgroApp.avaliacaosolo.propriedade">Propriedade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="safra.nomesafra"><span data-translate="netWordAgroApp.avaliacaosolo.safra">Safra</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="avaliacaosolo in vm.avaliacaosolos track by avaliacaosolo.id"><td><a ui-sref="avaliacaosolo-detail({id:avaliacaosolo.id})">{{avaliacaosolo.id}}</a></td><td>{{avaliacaosolo.usuario}}</td><td><button class="btn btn-info btn-sm" ng-click="vm.downloadMedicoes(avaliacaosolo.id)"><span class="glyphicon glyphicon-download-alt"></span> <span class="hidden-sm-down">Download</span></button></td><td><button class="btn btn-info btn-sm" ng-click="vm.downloadMedicoesInfo(avaliacaosolo.id)"><span class="glyphicon glyphicon-download-alt"></span> <span class="hidden-sm-down">Download</span></button></td><td>{{avaliacaosolo.dataavaliacao}}</td><td>{{avaliacaosolo.sensores}}</td><td>{{avaliacaosolo.profundidade}}</td><td><a ui-sref="propriedade-detail({id:avaliacaosolo.propriedade_id})">{{avaliacaosolo.propriedade_nomepropriedade}}</a></td><td><a ui-sref="safra-detail({id:avaliacaosolo.safra_id})">{{avaliacaosolo.safra_nomesafra}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="avaliacaosolo-detail({id:avaliacaosolo.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="avaliacaosolo.edit({id:avaliacaosolo.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="avaliacaosolo.delete({id:avaliacaosolo.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/caracteristicasolo/caracteristicasolo-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.caracteristicasolo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.caracteristicasolo.delete.question" translate-values="{id: \'{{vm.caracteristicasolo.id}}\'}">Are you sure you want to delete this Caracteristicasolo?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/caracteristicasolo/caracteristicasolo-detail.html','<div><h2><span data-translate="netWordAgroApp.caracteristicasolo.detail.title">Caracteristicasolo</span> {{vm.caracteristicasolo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.caracteristicasolo.descaracteristica">Descaracteristica</span></dt><dd><span>{{vm.caracteristicasolo.descaracteristica}}</span></dd><dt><span data-translate="netWordAgroApp.caracteristicasolo.destipcaracteristica">Destipcaracteristica</span></dt><dd><span>{{vm.caracteristicasolo.destipcaracteristica}}</span></dd><dt><span data-translate="netWordAgroApp.caracteristicasolo.valorcaracteristica">Valorcaracteristica</span></dt><dd><span>{{vm.caracteristicasolo.valorcaracteristica}}</span></dd><dt><span data-translate="netWordAgroApp.caracteristicasolo.solo">Solo</span></dt><dd><a ui-sref="solo-detail({id:vm.caracteristicasolo.solo.id})">{{vm.caracteristicasolo.solo.nomesolo}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="caracteristicasolo-detail.edit({id:vm.caracteristicasolo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/caracteristicasolo/caracteristicasolo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCaracteristicasoloLabel" data-translate="netWordAgroApp.caracteristicasolo.home.createOrEditLabel">Create or edit a Caracteristicasolo</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.caracteristicasolo.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.caracteristicasolo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.caracteristicasolo.descaracteristica" for="field_descaracteristica">Descaracteristica</label><input type="text" class="form-control" name="descaracteristica" id="field_descaracteristica" ng-model="vm.caracteristicasolo.descaracteristica" required ng-maxlength="50"><div ng-show="editForm.descaracteristica.$invalid"><p class="help-block" ng-show="editForm.descaracteristica.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.descaracteristica.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.caracteristicasolo.destipcaracteristica" for="field_destipcaracteristica">Destipcaracteristica</label><input type="text" class="form-control" name="destipcaracteristica" id="field_destipcaracteristica" ng-model="vm.caracteristicasolo.destipcaracteristica" required ng-maxlength="10"><div ng-show="editForm.destipcaracteristica.$invalid"><p class="help-block" ng-show="editForm.destipcaracteristica.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.destipcaracteristica.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.caracteristicasolo.valorcaracteristica" for="field_valorcaracteristica">Valorcaracteristica</label><input type="number" class="form-control" name="valorcaracteristica" id="field_valorcaracteristica" ng-model="vm.caracteristicasolo.valorcaracteristica" required><div ng-show="editForm.valorcaracteristica.$invalid"><p class="help-block" ng-show="editForm.valorcaracteristica.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.valorcaracteristica.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.caracteristicasolo.solo" for="field_solo">Solo</label><select class="form-control" id="field_solo" name="solo" ng-model="vm.caracteristicasolo.solo" ng-options="solo as solo.nomesolo for solo in vm.solos track by solo.id" required></select></div><div ng-show="editForm.solo.$invalid"><p class="help-block" ng-show="editForm.solo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/caracteristicasolo/caracteristicasolos.html','<div><h2 data-translate="netWordAgroApp.caracteristicasolo.home.title">Caracteristicasolos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="caracteristicasolo.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.caracteristicasolo.home.createLabel">Create new Caracteristicasolo</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.caracteristicasolo.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descaracteristica"><span data-translate="netWordAgroApp.caracteristicasolo.descaracteristica">Descaracteristica</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="destipcaracteristica"><span data-translate="netWordAgroApp.caracteristicasolo.destipcaracteristica">Destipcaracteristica</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorcaracteristica"><span data-translate="netWordAgroApp.caracteristicasolo.valorcaracteristica">Valorcaracteristica</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="solo.nomesolo"><span data-translate="netWordAgroApp.caracteristicasolo.solo">Solo</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="caracteristicasolo in vm.caracteristicasolos track by caracteristicasolo.id"><td><a ui-sref="caracteristicasolo-detail({id:caracteristicasolo.id})">{{caracteristicasolo.id}}</a></td><td>{{caracteristicasolo.descaracteristica}}</td><td>{{caracteristicasolo.destipcaracteristica}}</td><td>{{caracteristicasolo.valorcaracteristica}}</td><td><a ui-sref="solo-detail({id:caracteristicasolo.solo.id})">{{caracteristicasolo.solo.nomesolo}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="caracteristicasolo-detail({id:caracteristicasolo.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="caracteristicasolo.edit({id:caracteristicasolo.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="caracteristicasolo.delete({id:caracteristicasolo.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/colheita/colheita-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.colheita.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.colheita.delete.question" translate-values="{id: \'{{vm.colheita.id}}\'}">Are you sure you want to delete this Colheita?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/colheita/colheita-detail.html','<div><h2><span data-translate="netWordAgroApp.colheita.detail.title">Colheita</span> {{vm.colheita.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.colheita.datainicio">Datainicio</span></dt><dd><span>{{vm.colheita.datainicio | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.colheita.datatermino">Datatermino</span></dt><dd><span>{{vm.colheita.datatermino | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.colheita.areacolhida">Areacolhida</span></dt><dd><span>{{vm.colheita.areacolhida}}</span></dd><dt><span data-translate="netWordAgroApp.colheita.quantidadecolhida">Quantidadecolhida</span></dt><dd><span>{{vm.colheita.quantidadecolhida}}</span></dd><dt><span data-translate="netWordAgroApp.colheita.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.colheita.safra.id})">{{vm.colheita.safra.nomesafra}}</a></dd><dt><span data-translate="netWordAgroApp.colheita.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.colheita.etapa.id})">{{vm.colheita.etapa.nomeetapa}}</a></dd></dl><button type="submit" ui-sref="colheita" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="colheita-detail.edit({id:vm.colheita.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.colheita.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.colheita.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/colheita/colheita-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myColheitaLabel" data-translate="netWordAgroApp.colheita.home.createOrEditLabel">Create or edit a Colheita</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.colheita.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.colheita.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.colheita.$invalid"><p class="help-block" ng-show="editForm.colheita.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.colheita.datainicio" for="field_datainicio">Datainicio</label><div class="input-group"><input id="field_datainicio" type="text" class="form-control" name="datainicio" uib-datepicker-popup="{{dateformat}}" ng-model="vm.colheita.datainicio" is-open="vm.datePickerOpenStatus.datainicio" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datainicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datainicio.$invalid"><p class="help-block" ng-show="editForm.datainicio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.colheita.datatermino" for="field_datatermino">Datatermino</label><div class="input-group"><input id="field_datatermino" type="text" class="form-control" name="datatermino" uib-datepicker-popup="{{dateformat}}" ng-model="vm.colheita.datatermino" is-open="vm.datePickerOpenStatus.datatermino" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datatermino\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datatermino.$invalid"><p class="help-block" ng-show="editForm.datatermino.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.colheita.areacolhida" for="field_areacolhida">Areacolhida</label><input type="number" class="form-control" name="areacolhida" id="field_areacolhida" ng-model="vm.colheita.areacolhida" required min="0"><div ng-show="editForm.areacolhida.$invalid"><p class="help-block" ng-show="editForm.areacolhida.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.areacolhida.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.areacolhida.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.colheita.quantidadecolhida" for="field_quantidadecolhida">Quantidadecolhida</label><input type="number" class="form-control" name="quantidadecolhida" id="field_quantidadecolhida" ng-model="vm.colheita.quantidadecolhida" required min="0"><div ng-show="editForm.quantidadecolhida.$invalid"><p class="help-block" ng-show="editForm.quantidadecolhida.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.quantidadecolhida.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.quantidadecolhida.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.colheita.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.colheita.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/colheita/colheitas.html','<div><h2 data-translate="netWordAgroApp.colheita.home.title">Colheitas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="colheita.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.colheita.home.createLabel">Create new Colheita</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.colheita.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.colheita.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.colheita.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="areacolhida"><span data-translate="netWordAgroApp.colheita.areacolhida">Areacolhida</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quantidadecolhida"><span data-translate="netWordAgroApp.colheita.quantidadecolhida">Quantidadecolhida</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.colheita.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="colheita in vm.colheitas track by colheita.id"><td><a ui-sref="colheita-detail({id:colheita.id})">{{colheita.id}}</a></td><td>{{colheita.datainicio | date:\'mediumDate\'}}</td><td>{{colheita.datatermino | date:\'mediumDate\'}}</td><td>{{colheita.areacolhida}}</td><td>{{colheita.quantidadecolhida}}</td><td><a ui-sref="etapa-detail({id:colheita.etapa.id})">{{colheita.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="colheita-detail({id:colheita.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="colheita.edit({id:colheita.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="colheita.delete({id:colheita.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/cidade/cidade-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.cidade.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.cidade.delete.question" translate-values="{id: \'{{vm.cidade.id}}\'}">Are you sure you want to delete this Cidade?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/cidade/cidade-detail.html','<div><h2><span data-translate="netWordAgroApp.cidade.detail.title">Cidade</span> {{vm.cidade.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.cidade.nomecidade">Nomecidade</span></dt><dd><span>{{vm.cidade.nomecidade}}</span></dd><dt><span data-translate="netWordAgroApp.cidade.imagemcidade">Imagemcidade</span></dt><dd><div ng-if="vm.cidade.imagemcidade"><a ng-click="vm.openFile(vm.cidade.imagemcidadeContentType, vm.cidade.imagemcidade)"><img data-ng-src="{{\'data:\' + vm.cidade.imagemcidadeContentType + \';base64,\' + vm.cidade.imagemcidade}}" style="max-width: 100%" alt="cidade image"> </a>{{vm.cidade.imagemcidadeContentType}}, {{vm.byteSize(vm.cidade.imagemcidade)}}</div></dd><dt><span data-translate="netWordAgroApp.cidade.microregiao">Microregiao</span></dt><dd><a ui-sref="microregiao-detail({id:vm.cidade.microregiao.id})">{{vm.cidade.microregiao.nomemicroregiao}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="cidade-detail.edit({id:vm.cidade.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/cidade/cidade-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCidadeLabel" data-translate="netWordAgroApp.cidade.home.createOrEditLabel">Create or edit a Cidade</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.cidade.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.cidade.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.cidade.nomecidade" for="field_nomecidade">Nomecidade</label><input type="text" class="form-control" name="nomecidade" id="field_nomecidade" ng-model="vm.cidade.nomecidade" required ng-maxlength="30"><div ng-show="editForm.nomecidade.$invalid"><p class="help-block" ng-show="editForm.nomecidade.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nomecidade.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">This field cannot be longer than 30 characters.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setImagemcidade($file, vm.cidade)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="netWordAgroApp.cidade.imagemcidade" for="field_imagemcidade">Imagemcidade</label><div><img data-ng-src="{{\'data:\' + vm.cidade.imagemcidadeContentType + \';base64,\' + vm.cidade.imagemcidade}}" style="max-height: 100px" ng-if="vm.cidade.imagemcidade" alt="cidade image"><div ng-if="vm.cidade.imagemcidade" class="help-block clearfix"><span class="pull-left">{{vm.cidade.imagemcidadeContentType}}, {{vm.byteSize(vm.cidade.imagemcidade)}}</span> <button type="button" ng-click="vm.cidade.imagemcidade=null;vm.cidade.imagemcidadeContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setImagemcidade($file, vm.cidade)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="imagemcidade" id="field_imagemcidade" ng-model="vm.cidade.imagemcidade"> <input type="hidden" class="form-control" name="imagemcidadeContentType" id="field_imagemcidadeContentType" ng-model="vm.cidade.imagemcidadeContentType"></div><div class="form-group"><label data-translate="netWordAgroApp.cidade.microregiao" for="field_microregiao">Microregiao</label><select class="form-control" id="field_microregiao" name="microregiao" ng-model="vm.cidade.microregiao" ng-options="microregiao as microregiao.nomemicroregiao for microregiao in vm.microregiaos track by microregiao.id" required></select></div><div ng-show="editForm.microregiao.$invalid"><p class="help-block" ng-show="editForm.microregiao.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/cidade/cidades.html','<div><h2 data-translate="netWordAgroApp.cidade.home.title">Cidades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="cidade.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.cidade.home.createLabel">Create new Cidade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.cidade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomecidade"><span data-translate="netWordAgroApp.cidade.nomecidade">Nomecidade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="imagemcidade"><span data-translate="netWordAgroApp.cidade.imagemcidade">Imagemcidade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="microregiao.nomemicroregiao"><span data-translate="netWordAgroApp.cidade.microregiao">Microregiao</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="cidade in vm.cidades track by cidade.id"><td><a ui-sref="cidade-detail({id:cidade.id})">{{cidade.id}}</a></td><td>{{cidade.nomecidade}}</td><td><a ng-if="cidade.imagemcidade" ng-click="vm.openFile(cidade.imagemcidadeContentType, cidade.imagemcidade)"><img data-ng-src="{{\'data:\' + cidade.imagemcidadeContentType + \';base64,\' + cidade.imagemcidade}}" style="max-height: 30px" alt="cidade image"> </a><span ng-if="cidade.imagemcidade">{{cidade.imagemcidadeContentType}}, {{vm.byteSize(cidade.imagemcidade)}}</span></td><td><a ui-sref="microregiao-detail({id:cidade.microregiao.id})">{{cidade.microregiao.nomemicroregiao}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="cidade-detail({id:cidade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="cidade.edit({id:cidade.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="cidade.delete({id:cidade.id})" class="btn btn-danger btn-sm" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/colheitaplan/colheitaplan-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.colheitaplan.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.colheitaplan.delete.question" translate-values="{id: \'{{vm.colheitaplan.id}}\'}">Are you sure you want to delete this Colheitaplan?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/colheitaplan/colheitaplan-detail.html','<div><h2><span data-translate="netWordAgroApp.colheitaplan.detail.title">Colheitaplan</span> {{vm.colheitaplan.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.colheitaplan.datainicio">Datainicio</span></dt><dd><span>{{vm.colheitaplan.datainicio | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.colheitaplan.datatermino">Datatermino</span></dt><dd><span>{{vm.colheitaplan.datatermino | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.colheitaplan.areacolhida">Areacolhida</span></dt><dd><span>{{vm.colheitaplan.areacolhida}}</span></dd><dt><span data-translate="netWordAgroApp.colheitaplan.quantidadecolhida">Quantidadecolhida</span></dt><dd><span>{{vm.colheitaplan.quantidadecolhida}}</span></dd><dt><span data-translate="netWordAgroApp.colheitaplan.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.colheitaplan.safra.id})">{{vm.colheitaplan.safra.nomesafra}}</a></dd><dt><span data-translate="netWordAgroApp.colheitaplan.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.colheitaplan.etapa.id})">{{vm.colheitaplan.etapa.nomeetapa}}</a></dd></dl><button type="submit" ui-sref="colheitaplan" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="colheitaplan-detail.edit({id:vm.colheitaplan.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.colheitaplan.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.colheitaplan.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/colheitaplan/colheitaplan-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myColheitaplanLabel" data-translate="netWordAgroApp.colheitaplan.home.createOrEditLabel">Create or edit a Colheitaplan</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.colheitaplan.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.colheitaplan.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.colheitaplan.$invalid"><p class="help-block" ng-show="editForm.colheitaplan.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.colheitaplan.datainicio" for="field_datainicio">Datainicio</label><div class="input-group"><input id="field_datainicio" type="text" class="form-control" name="datainicio" uib-datepicker-popup="{{dateformat}}" ng-model="vm.colheitaplan.datainicio" is-open="vm.datePickerOpenStatus.datainicio" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datainicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datainicio.$invalid"><p class="help-block" ng-show="editForm.datainicio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.colheitaplan.datatermino" for="field_datatermino">Datatermino</label><div class="input-group"><input id="field_datatermino" type="text" class="form-control" name="datatermino" uib-datepicker-popup="{{dateformat}}" ng-model="vm.colheitaplan.datatermino" is-open="vm.datePickerOpenStatus.datatermino" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datatermino\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datatermino.$invalid"><p class="help-block" ng-show="editForm.datatermino.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.colheitaplan.areacolhida" for="field_areacolhida">Areacolhida</label><input type="number" class="form-control" name="areacolhida" id="field_areacolhida" ng-model="vm.colheitaplan.areacolhida" required min="0"><div ng-show="editForm.areacolhida.$invalid"><p class="help-block" ng-show="editForm.areacolhida.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.areacolhida.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.areacolhida.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.colheitaplan.quantidadecolhida" for="field_quantidadecolhida">Quantidadecolhida</label><input type="number" class="form-control" name="quantidadecolhida" id="field_quantidadecolhida" ng-model="vm.colheitaplan.quantidadecolhida" required min="0"><div ng-show="editForm.quantidadecolhida.$invalid"><p class="help-block" ng-show="editForm.quantidadecolhida.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.quantidadecolhida.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.quantidadecolhida.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.colheitaplan.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.colheitaplan.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/colheitaplan/colheitaplans.html','<div><h2 data-translate="netWordAgroApp.colheitaplan.home.title">Colheitaplans</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="colheitaplan.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.colheitaplan.home.createLabel">Create new Colheitaplan</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.colheitaplan.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.colheitaplan.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.colheitaplan.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="areacolhida"><span data-translate="netWordAgroApp.colheitaplan.areacolhida">Areacolhida</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quantidadecolhida"><span data-translate="netWordAgroApp.colheitaplan.quantidadecolhida">Quantidadecolhida</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.colheitaplan.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="colheitaplan in vm.colheitaplans track by colheitaplan.id"><td><a ui-sref="colheitaplan-detail({id:colheitaplan.id})">{{colheitaplan.id}}</a></td><td>{{colheitaplan.datainicio | date:\'mediumDate\'}}</td><td>{{colheitaplan.datatermino | date:\'mediumDate\'}}</td><td>{{colheitaplan.areacolhida}}</td><td>{{colheitaplan.quantidadecolhida}}</td><td><a ui-sref="etapa-detail({id:colheitaplan.etapa.id})">{{colheitaplan.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="colheitaplan-detail({id:colheitaplan.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="colheitaplan.edit({id:colheitaplan.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="colheitaplan.delete({id:colheitaplan.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/colheitatestem/colheitatestem-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.colheitatestem.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.colheitatestem.delete.question" translate-values="{id: \'{{vm.colheitatestem.id}}\'}">Are you sure you want to delete this Colheitatestem?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/colheitatestem/colheitatestem-detail.html','<div><h2><span data-translate="netWordAgroApp.colheitatestem.detail.title">Colheitatestem</span> {{vm.colheitatestem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.colheitatestem.datainicio">Datainicio</span></dt><dd><span>{{vm.colheitatestem.datainicio | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.colheitatestem.datafim">Datafim</span></dt><dd><span>{{vm.colheitatestem.datafim | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.colheitatestem.areacolhida">Areacolhida</span></dt><dd><span>{{vm.colheitatestem.areacolhida}}</span></dd><dt><span data-translate="netWordAgroApp.colheitatestem.quantidadecolhida">Quantidadecolhida</span></dt><dd><span>{{vm.colheitatestem.quantidadecolhida}}</span></dd><dt><span data-translate="netWordAgroApp.colheitatestem.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.colheitatestem.etapa.id})">{{vm.colheitatestem.etapa.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="colheitatestem-detail.edit({id:vm.colheitatestem.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.colheitatestem.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.colheitatestem.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/colheitatestem/colheitatestem-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mycolheitatestemLabel" data-translate="netWordAgroApp.colheitatestem.home.createOrEditLabel">Create or edit a colheitatestem</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.colheitatestem.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.colheitatestem.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.colheitatestem.$invalid"><p class="help-block" ng-show="editForm.colheitatestem.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.colheitatestem.datainicio" for="field_datainicio">datainicio</label><div class="input-group"><input id="field_data" type="text" class="form-control" name="datainicio" uib-datepicker-popup="{{dateformat}}" ng-model="vm.colheitatestem.datainicio" is-open="vm.datePickerOpenStatus.datainicio" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datainicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.data.$invalid"><p class="help-block" ng-show="editForm.data.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.colheitatestem.datafim" for="field_datafim">datafim</label><div class="input-group"><input id="field_datafim" type="text" class="form-control" name="datafim" uib-datepicker-popup="{{dateformat}}" ng-model="vm.colheitatestem.datafim" is-open="vm.datePickerOpenStatus.datafim" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datafim\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datafim.$invalid"><p class="help-block" ng-show="editForm.datafim.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.colheitatestem.areacolhida" for="field_areacolhida">Areacolhida</label><input type="number" class="form-control" name="areacolhida" id="field_areacolhida" ng-model="vm.colheitatestem.areacolhida" required min="0"><div ng-show="editForm.areacolhida.$invalid"><p class="help-block" ng-show="editForm.areacolhida.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.areacolhida.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.areacolhida.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.colheitatestem.quantidadecolhida" for="field_quantidadecolhida">Quantidadecolhida</label><input type="number" class="form-control" name="quantidadecolhida" id="field_quantidadecolhida" ng-model="vm.colheitatestem.quantidadecolhida" required min="0"><div ng-show="editForm.quantidadecolhida.$invalid"><p class="help-block" ng-show="editForm.quantidadecolhida.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.quantidadecolhida.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.quantidadecolhida.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.colheitatestem.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.colheitatestem.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/colheitatestem/colheitatestems.html','<div><h2 data-translate="netWordAgroApp.colheitatestem.home.title">Colheitatestems</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="colheitatestem.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.colheitatestem.home.createLabel">Create new Colheitatestem</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.colheitatestem.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.colheitatestem.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datafim"><span data-translate="netWordAgroApp.colheitatestem.datafim">Datafim</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="areacolhida"><span data-translate="netWordAgroApp.colheitatestem.areacolhida">Areacolhida</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quantidadecolhida"><span data-translate="netWordAgroApp.colheitatestem.quantidadecolhida">Quantidadecolhida</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.id"><span data-translate="netWordAgroApp.colheitatestem.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="colheitatestem in vm.colheitatestems track by colheitatestem.id"><td><a ui-sref="colheitatestem-detail({id:colheitatestem.id})">{{colheitatestem.id}}</a></td><td>{{colheitatestem.datainicio | date:\'mediumDate\'}}</td><td>{{colheitatestem.datafim | date:\'mediumDate\'}}</td><td>{{colheitatestem.areacolhida}}</td><td>{{colheitatestem.quantidadecolhida}}</td><td><a ui-sref="etapa-detail({id:colheitatestem.etapa.id})">{{colheitatestem.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="colheitatestem-detail({id:colheitatestem.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="colheitatestem.edit({id:colheitatestem.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="colheitatestem.delete({id:colheitatestem.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/comercializacao/comercializacao-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.comercializacao.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.comercializacao.delete.question" translate-values="{id: \'{{vm.comercializacao.id}}\'}">Are you sure you want to delete this Comercializacao?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/comercializacao/comercializacao-detail.html','<div><h2><span data-translate="netWordAgroApp.comercializacao.detail.title">Comercializacao</span> {{vm.comercializacao.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.comercializacao.datainicio">Datainicio</span></dt><dd><span>{{vm.comercializacao.datainicio | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.comercializacao.datatermino">Datatermino</span></dt><dd><span>{{vm.comercializacao.datatermino | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.comercializacao.quantidadevendida">Quantidadevendida</span></dt><dd><span>{{vm.comercializacao.quantidadevendida}}</span></dd><dt><span data-translate="netWordAgroApp.comercializacao.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.comercializacao.safra.id})">{{vm.comercializacao.safra.nomesafra}}</a></dd><dt><span data-translate="netWordAgroApp.comercializacao.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.comercializacao.etapa.id})">{{vm.comercializacao.etapa.nomeetapa}}</a></dd></dl><button type="submit" ui-sref="comercializacao" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="comercializacao-detail.edit({id:vm.comercializacao.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.comercializacao.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.comercializacao.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/comercializacao/comercializacao-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myComercializacaoLabel" data-translate="netWordAgroApp.comercializacao.home.createOrEditLabel">Create or edit a Comercializacao</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.comercializacao.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.comercializacao.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.comercializacao.$invalid"><p class="help-block" ng-show="editForm.comercializacao.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.comercializacao.datainicio" for="field_datainicio">Datainicio</label><div class="input-group"><input id="field_datainicio" type="text" class="form-control" name="datainicio" uib-datepicker-popup="{{dateformat}}" ng-model="vm.comercializacao.datainicio" is-open="vm.datePickerOpenStatus.datainicio" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datainicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datainicio.$invalid"><p class="help-block" ng-show="editForm.datainicio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.comercializacao.datatermino" for="field_datatermino">Datatermino</label><div class="input-group"><input id="field_datatermino" type="text" class="form-control" name="datatermino" uib-datepicker-popup="{{dateformat}}" ng-model="vm.comercializacao.datatermino" is-open="vm.datePickerOpenStatus.datatermino" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datatermino\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datatermino.$invalid"><p class="help-block" ng-show="editForm.datatermino.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.comercializacao.quantidadevendida" for="field_quantidadevendida">Quantidadevendida</label><input type="number" class="form-control" name="quantidadevendida" id="field_quantidadevendida" ng-model="vm.comercializacao.quantidadevendida" required min="0"><div ng-show="editForm.quantidadevendida.$invalid"><p class="help-block" ng-show="editForm.quantidadevendida.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.quantidadevendida.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.quantidadevendida.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.comercializacao.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.comercializacao.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/comercializacao/comercializacaos.html','<div><h2 data-translate="netWordAgroApp.comercializacao.home.title">Comercializacaos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="comercializacao.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.comercializacao.home.createLabel">Create new Comercializacao</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.comercializacao.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.comercializacao.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.comercializacao.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quantidadevendida"><span data-translate="netWordAgroApp.comercializacao.quantidadevendida">Quantidadevendida</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.comercializacao.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="comercializacao in vm.comercializacaos track by comercializacao.id"><td><a ui-sref="comercializacao-detail({id:comercializacao.id})">{{comercializacao.id}}</a></td><td>{{comercializacao.datainicio | date:\'mediumDate\'}}</td><td>{{comercializacao.datatermino | date:\'mediumDate\'}}</td><td>{{comercializacao.quantidadevendida}}</td><td><a ui-sref="etapa-detail({id:comercializacao.etapa.id})">{{comercializacao.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="comercializacao-detail({id:comercializacao.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="comercializacao.edit({id:comercializacao.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="comercializacao.delete({id:comercializacao.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/comercializacaoplan/comercializacaoplan-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.comercializacaoplan.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.comercializacaoplan.delete.question" translate-values="{id: \'{{vm.comercializacaoplan.id}}\'}">Are you sure you want to delete this Comercializacaoplan?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/comercializacaoplan/comercializacaoplan-detail.html','<div><h2><span data-translate="netWordAgroApp.comercializacaoplan.detail.title">Comercializacaoplan</span> {{vm.comercializacaoplan.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.comercializacaoplan.datainicio">Datainicio</span></dt><dd><span>{{vm.comercializacaoplan.datainicio | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.comercializacaoplan.datatermino">Datatermino</span></dt><dd><span>{{vm.comercializacaoplan.datatermino | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.comercializacaoplan.quantidadevendida">Quantidadevendida</span></dt><dd><span>{{vm.comercializacaoplan.quantidadevendida}}</span></dd><dt><span data-translate="netWordAgroApp.comercializacaoplan.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.comercializacaoplan.safra.id})">{{vm.comercializacaoplan.safra.nomesafra}}</a></dd><dt><span data-translate="netWordAgroApp.comercializacaoplan.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.comercializacaoplan.etapa.id})">{{vm.comercializacaoplan.etapa.nomeetapa}}</a></dd></dl><button type="submit" ui-sref="comercializacaoplan" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="comercializacaoplan-detail.edit({id:vm.comercializacaoplan.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.comercializacaoplan.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.comercializacaoplan.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/comercializacaoplan/comercializacaoplan-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myComercializacaoplanLabel" data-translate="netWordAgroApp.comercializacaoplan.home.createOrEditLabel">Create or edit a Comercializacaoplan</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.comercializacaoplan.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.comercializacaoplan.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.comercializacaoplan.$invalid"><p class="help-block" ng-show="editForm.comercializacaoplan.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.comercializacaoplan.datainicio" for="field_datainicio">Datainicio</label><div class="input-group"><input id="field_datainicio" type="text" class="form-control" name="datainicio" uib-datepicker-popup="{{dateformat}}" ng-model="vm.comercializacaoplan.datainicio" is-open="vm.datePickerOpenStatus.datainicio" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datainicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datainicio.$invalid"><p class="help-block" ng-show="editForm.datainicio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.comercializacaoplan.datatermino" for="field_datatermino">Datatermino</label><div class="input-group"><input id="field_datatermino" type="text" class="form-control" name="datatermino" uib-datepicker-popup="{{dateformat}}" ng-model="vm.comercializacaoplan.datatermino" is-open="vm.datePickerOpenStatus.datatermino" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datatermino\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datatermino.$invalid"><p class="help-block" ng-show="editForm.datatermino.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.comercializacaoplan.quantidadevendida" for="field_quantidadevendida">Quantidadevendida</label><input type="number" class="form-control" name="quantidadevendida" id="field_quantidadevendida" ng-model="vm.comercializacaoplan.quantidadevendida" required min="0"><div ng-show="editForm.quantidadevendida.$invalid"><p class="help-block" ng-show="editForm.quantidadevendida.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.quantidadevendida.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.quantidadevendida.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.comercializacaoplan.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.comercializacaoplan.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/comercializacaoplan/comercializacaoplans.html','<div><h2 data-translate="netWordAgroApp.comercializacaoplan.home.title">Comercializacaoplans</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="comercializacaoplan.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.comercializacaoplan.home.createLabel">Create new Comercializacaoplan</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.comercializacaoplan.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.comercializacaoplan.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.comercializacaoplan.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quantidadevendida"><span data-translate="netWordAgroApp.comercializacaoplan.quantidadevendida">Quantidadevendida</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.comercializacaoplan.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="comercializacaoplan in vm.comercializacaoplans track by comercializacaoplan.id"><td><a ui-sref="comercializacaoplan-detail({id:comercializacaoplan.id})">{{comercializacaoplan.id}}</a></td><td>{{comercializacaoplan.datainicio | date:\'mediumDate\'}}</td><td>{{comercializacaoplan.datatermino | date:\'mediumDate\'}}</td><td>{{comercializacaoplan.quantidadevendida}}</td><td><a ui-sref="etapa-detail({id:comercializacaoplan.etapa.id})">{{comercializacaoplan.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="comercializacaoplan-detail({id:comercializacaoplan.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="comercializacaoplan.edit({id:comercializacaoplan.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="comercializacaoplan.delete({id:comercializacaoplan.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/comercializacaotestem/comercializacaotestem-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.comercializacaotestem.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.comercializacaotestem.delete.question" translate-values="{id: \'{{vm.comercializacaotestem.id}}\'}">Are you sure you want to delete this Comercializacaotestem?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/comercializacaotestem/comercializacaotestem-detail.html','<div><h2><span data-translate="netWordAgroApp.comercializacaotestem.detail.title">Comercializacaotestem</span> {{vm.comercializacaotestem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.comercializacaotestem.data">Data</span></dt><dd><span>{{vm.comercializacaotestem.data | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.comercializacaotestem.datafim">Datafim</span></dt><dd><span>{{vm.comercializacaotestem.datafim | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.comercializacaotestem.quantidadevendida">Quantidadevendida</span></dt><dd><span>{{vm.comercializacaotestem.quantidadevendida}}</span></dd><dt><span data-translate="netWordAgroApp.comercializacaotestem.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.comercializacaotestem.etapa.id})">{{vm.comercializacaotestem.etapa.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="comercializacaotestem-detail.edit({id:vm.comercializacaotestem.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.comercializacaotestem.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.comercializacaotestem.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/comercializacaotestem/comercializacaotestem-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mycomercializacaotestemLabel" data-translate="netWordAgroApp.comercializacaotestem.home.createOrEditLabel">Create or edit a comercializacaotestem</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.comercializacaotestem.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.comercializacaotestem.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.comercializacaotestem.$invalid"><p class="help-block" ng-show="editForm.comercializacaotestem.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.comercializacaotestem.data" for="field_data">data</label><div class="input-group"><input id="field_data" type="text" class="form-control" name="data" uib-datepicker-popup="{{dateformat}}" ng-model="vm.comercializacaotestem.data" is-open="vm.datePickerOpenStatus.data" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'data\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.data.$invalid"><p class="help-block" ng-show="editForm.data.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.comercializacaotestem.datafim" for="field_datafim">datafim</label><div class="input-group"><input id="field_datafim" type="text" class="form-control" name="datafim" uib-datepicker-popup="{{dateformat}}" ng-model="vm.comercializacaotestem.datafim" is-open="vm.datePickerOpenStatus.datafim" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datafim\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datafim.$invalid"><p class="help-block" ng-show="editForm.datafim.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.comercializacaotestem.quantidadevendida" for="field_quantidadevendida">Quantidadevendida</label><input type="number" class="form-control" name="quantidadevendida" id="field_quantidadevendida" ng-model="vm.comercializacaotestem.quantidadevendida" required min="0"><div ng-show="editForm.quantidadevendida.$invalid"><p class="help-block" ng-show="editForm.quantidadevendida.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.quantidadevendida.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.quantidadevendida.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.comercializacaotestem.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.comercializacaotestem.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/comercializacaotestem/comercializacaotestems.html','<div><h2 data-translate="netWordAgroApp.comercializacaotestem.home.title">Comercializacaotestems</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="comercializacaotestem.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.comercializacaotestem.home.createLabel">Create new Comercializacaotestem</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.comercializacaotestem.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="data"><span data-translate="netWordAgroApp.comercializacaotestem.data">Data</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datafim"><span data-translate="netWordAgroApp.comercializacaotestem.datafim">Datafim</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quantidadevendida"><span data-translate="netWordAgroApp.comercializacaotestem.quantidadevendida">Quantidadevendida</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.id"><span data-translate="netWordAgroApp.comercializacaotestem.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="comercializacaotestem in vm.comercializacaotestems track by comercializacaotestem.id"><td><a ui-sref="comercializacaotestem-detail({id:comercializacaotestem.id})">{{comercializacaotestem.id}}</a></td><td>{{comercializacaotestem.data | date:\'mediumDate\'}}</td><td>{{comercializacaotestem.datafim | date:\'mediumDate\'}}</td><td>{{comercializacaotestem.quantidadevendida}}</td><td><a ui-sref="etapa-detail({id:comercializacaotestem.etapa.id})">{{comercializacaotestem.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="comercializacaotestem-detail({id:comercializacaotestem.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="comercializacaotestem.edit({id:comercializacaotestem.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="comercializacaotestem.delete({id:comercializacaotestem.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/comparativo/comparativo-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.comparativo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.comparativo.delete.question" translate-values="{id: \'{{vm.comparativo.id}}\'}">Are you sure you want to delete this Comparativo?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/comparativo/comparativo-detail.html','<div><h2><span data-translate="netWordAgroApp.comparativo.detail.title">Comparativo</span> {{vm.comparativo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="comparativo-detail.edit({id:vm.comparativo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/comparativo/comparativo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myComparativoLabel" data-translate="netWordAgroApp.comparativo.home.createOrEditLabel">Create or edit a Comparativo</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.comparativo.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.comparativo.id" readonly="readonly"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/comparativo/comparativos-en.html','<script src="bower_components/chart.js/dist/Chart.min.js"></script><script src="bower_components/pdfmake/build/pdfmake.min.js"></script><script src="bower_components/pdfmake/build/vfs_fonts.js"></script><script src="bower_components/criacaopdf.js"></script><script type="text/javascript">function preencheSelector(){\n        $(\'#gerapdf\').attr(\'disabled\', true);\n\n        var $select = $(\'#selecsafra\');\n        $.ajax({\n            url:  \'/api/nomesafras/\',\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) {\n                $select.html(\'\');\n                listaOpcoes = json.map(function(item) {\n                    return item.nome;\n                });\n\n                for (i = 0; i < listaOpcoes.length; i++) {\n                    $select.append(\'<option id="\' + listaOpcoes[i] + \'">\' + listaOpcoes[i] + \'</option>\');\n                }\n                console.log("preenchido");\n            }\n        });\n    }\n\n    function dadosSafra(safra){\n        var tipoSafra = {\n                "verao":"Summer",\n                "safrinha":"Midseason",\n                "inverno": "Winter"\n        };\n\n        var urlJSON = "/api/dadossafra/" + safra;\n\n        $.ajax({\n            url:  urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) {\n\n            propriedade = json.map(function(item) {\n                return item.nomepropriedade;\n            });\n\n            ano = json.map(function(item) {\n                return item.ano;\n            });\n\n            tsafra = json.map(function(item) {\n                return tipoSafra[item.safra];\n            });\n\n            nomeSafra = json.map(function(item) {\n                return item.nome;\n            });\n\n            $("#titulo").html("<h3>Costs Comparative: <small id=\'nomeprop\'>" + propriedade + "</small></h3>");\n            $("#dadossafra").css(\'visibility\', \'visible\');\n            $("#dadossafra").html(\'Harvest name: \' + nomeSafra + \'<br>\' + \'Harvest: \' + tsafra + \'<br>\' + \'Harvest Year: \' + ano + \'<br>\');\n        }\n        });\n\n  \n    }\n\n    function limpa(){\n        $("#graficochf").html(\'\');\n        $("#graficochf").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosfert"></canvas>\');\n        $("#graficochp").html(\'\');\n        $("#graficochp").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosprod"></canvas>\');\n        $("#graficochd").html(\'\');\n        $("#graficochd").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosdef"></canvas>\');\n        $("#tabelachd").html(\'\');\n        $("#tabelachf").html(\'\');\n        $("#tabelachp").html(\'\');\n    }\n\n    function dadosFert(safra){\n        var lblfert = {\n            "fertilizantequimico":"Chemical Fertilizer",\n            "fertilizantefoliar":"Foliar Fertilizer",\n            "materialorganico":"Organic Material",\n            "corretivo":"Corrective"\n        };\n\n        var urlJSONnw = "/api/custonwfertsafra/" + safra;\n        var urlJSONhab = "/api/custohabfertsafra/" + safra;\n\n\n        $.ajax({\n            url:  urlJSONnw,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(jsonnw) {\n    \n            $.ajax({\n                url:  urlJSONhab,\n                type: \'GET\',\n                beforeSend: function(xhr) {\n                    xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n                },\n                success: function(jsonhab) {\n\n                    listaTiponw = jsonnw.map(function(item) {\n                        return lblfert[item.tipo];\n                    });\n\n                    listaValornw = jsonnw.map(function(item) {\n                        return item.valor;\n                    });\n\n                    listaTipohab = jsonhab.map(function(item) {\n                        return lblfert[item.tipo];\n                    });\n\n                    listaValorhab = jsonhab.map(function(item) {\n                        return item.valor;\n                    });\n\n                    var l = Object.values(lblfert);\n                    var listahabgraf = [];\n                    var listanwgraf = [];\n\n                    for(i=0; i< l.length; i++){\n                        var comp = l[i];\n                        var valornw=0;\n                        var valorhab=0;\n\n                        for(j=0; j<listaTiponw.length; j++){\n                            if(listaTiponw[j]==comp){\n                                valornw = listaValornw[j];\n                                break;\n                            }\n                        }\n\n                        for(j=0; j<listaTipohab.length; j++){\n                            if(listaTipohab[j]==comp){\n                                valorhab = listaValorhab[j];\n                                break;\n                            }\n                        }\n                        \n                        listahabgraf.push(valorhab);\n                        listanwgraf.push(valornw);\n                    }\n\n                    var ctx = document.getElementById(\'grafcustosfert\').getContext(\'2d\');\n\n                    var chart = new Chart(ctx, {\n                        type: \'bar\',\n\n                        data: {\n                            labels: Object.values(lblfert),\n                            datasets: [{\n                                    label: "Usual Fertilizers Costs",\n                                    backgroundColor: \'rgb(204, 255, 102)\', \n                                    //borderColor: \'rgb(255, 99, 132)\',\n                                    data: listahabgraf,\n                                },\n                                {\n                                    label: "NetWord Fertilizers Costs",\n                                    backgroundColor: \'rgb(136, 204, 0)\', \n                                    //borderColor: \'rgb(255, 99, 132)\',\n                                    data: listanwgraf,\n                                }\n                            ]\n                        },\n\n                        // Configuration options go here\n                        options: {\n                            scales: {\n                                barValueSpacing: 20,\n                                yAxes: [{\n                                scaleLabel: {\n                                    display: true,\n                                    labelString: \'Value ($)\'\n                                },   \n                                ticks: {\n                                    suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                                }\n                                }],\n\n                                xAxes: [{\n                                scaleLabel: {\n                                    display: true,\n                                    labelString: \'Type Of Cost\'\n                                }\n                                }]\n                            }     \n\n                        }\n                    });\n\n                    $("#tabelachf").append(\'<table class="table table-striped" id="tabchf"></table>\');\n                    $("#tabchf").append(\'<tbody id="tabchfbody"></tbody>\');\n                    $("#tabchf").append(\'<thead><tr><th>Type Of Cost</th> <th>Usual Value ($)</th> <th>NetWord Value ($)</th></tr></thead>\');\n                    var l = Object.values(lblfert);\n                    for(i=0; i< l.length; i++){\n                        var comp = l[i];\n                        var valornw=0;\n                        var valorhab=0;\n\n                        for(j=0; j<listaTiponw.length; j++){\n                            if(listaTiponw[j]==comp){\n                                valornw = listaValornw[j];\n                                break;\n                            }\n                        }\n\n                        for(j=0; j<listaTipohab.length; j++){\n                            if(listaTipohab[j]==comp){\n                                valorhab = listaValorhab[j];\n                                break;\n                            }\n                        }\n\n                        $("#tabchfbody").append(\'<tr> <td>\' + comp + \'</td> <td> \' + valorhab +  \'</td> <td> \' + valornw + \'</td> </tr>\');\n\n                    }\n                }\n            });\n        }\n        });\n    }\n\n    function dadosDef(safra){\n         \n        var lbldef = {\n            "inseticidaparasemente": "Seed Inseticide",\n            "inseticidaparalagarta": "Caterpillar Inseticide",\n            "inseticidaparapercevejo": "Bedbug Inseticide",\n            "fungicidaparasemente": "Seed Fungicide",\n            "fungicida": "Fungicide",\n            "herbicidaparaplantadaninha": "Weed Herbicide",\n            "herbicidaparaprecolheita": "Pre Harvest Herbicide",\n            "larvicida": "Larvicide"\n        };\n\n        var urlJSONnw = "/api/custonwdefsafra/" + safra;\n        var urlJSONhab = "/api/custohabdefsafra/" + safra;\n\n\n        $.ajax({\n            url:  urlJSONnw,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(jsonnw) {\n    \n            $.ajax({\n                url:  urlJSONhab,\n                type: \'GET\',\n                beforeSend: function(xhr) {\n                    xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n                },\n                success: function(jsonhab) {\n                    listaTiponw = jsonnw.map(function(item) {\n                        return lbldef[item.tipo];\n                    });\n\n                    listaValornw = jsonnw.map(function(item) {\n                        return item.valor;\n                    });\n\n                    listaTipohab = jsonhab.map(function(item) {\n                        return lbldef[item.tipo];\n                    });\n\n                    listaValorhab = jsonhab.map(function(item) {\n                        return item.valor;\n                    });\n\n                    var l = Object.values(lbldef);\n                    var listahabgraf = [];\n                    var listanwgraf = [];\n\n                    for(i=0; i< l.length; i++){\n                        var comp = l[i];\n                        var valornw=0;\n                        var valorhab=0;\n\n                        for(j=0; j<listaTiponw.length; j++){\n                            if(listaTiponw[j]==comp){\n                                valornw = listaValornw[j];\n                                break;\n                            }\n                        }\n\n                        for(j=0; j<listaTipohab.length; j++){\n                            if(listaTipohab[j]==comp){\n                                valorhab = listaValorhab[j];\n                                break;\n                            }\n                        }\n                        \n                        listahabgraf.push(valorhab);\n                        listanwgraf.push(valornw);\n                    }\n                    \n                    var ctx = document.getElementById(\'grafcustosdef\').getContext(\'2d\');        \n\n                    var chart = new Chart(ctx, {\n                        type: \'bar\',\n\n                        data: {\n                            labels: Object.values(lbldef),\n                            datasets: [\n                                {\n                                    label: "Usual Defensive Costs",\n                                    backgroundColor: \'rgb(255, 102, 102)\', \n                                    //borderColor: \'rgb(255, 99, 132)\',\n                                    data: listahabgraf,\n                                },\n                                {\n                                    label: "Defensive Costs NetWord",\n                                    backgroundColor: \'rgb(255, 51, 51)\', \n                                    //borderColor: \'rgb(255, 99, 132)\',\n                                    data: listanwgraf,\n                                }\n                            ]\n                        },\n\n                        // Configuration options go here\n                        options: {\n                            scales: {\n                                yAxes: [{\n                                scaleLabel: {\n                                    display: true,\n                                    labelString: \'Value ($)\'\n                                },   \n                                ticks: {\n                                    suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                                }\n                                }],\n\n                                xAxes: [{\n                                scaleLabel: {\n                                    display: true,\n                                    labelString: \'Type Of Cost\'\n                                }\n                                }]\n                            }     \n\n                        }\n                    });\n\n                    $("#tabelachd").append(\'<table class="table table-striped" id="tabchd"></table>\');\n                    $("#tabchd").append(\'<tbody id="tabchdbody"></tbody>\');\n                    $("#tabchd").append(\'<thead><tr><th>Type Of Cost</th> <th>Usual Value ($)</th> <th>NetWord Value($) </th></tr></thead>\');\n                    var l = Object.values(lbldef);\n                    for(i=0; i< l.length; i++){\n                        var comp = l[i];\n                        var valornw=0;\n                        var valorhab=0;\n\n                        for(j=0; j<listaTiponw.length; j++){\n                            if(listaTiponw[j]==comp){\n                                valornw = listaValornw[j];\n                                break;\n                            }\n                        }\n\n                        for(j=0; j<listaTipohab.length; j++){\n                            if(listaTipohab[j]==comp){\n                                valorhab = listaValorhab[j];\n                                break;\n                            }\n                        }\n\n                        $("#tabchdbody").append(\'<tr> <td>\' + comp + \'</td> <td> \' + valorhab +  \'</td> <td> \' + valornw + \'</td> </tr>\');\n\n                    }\n                }\n            });\n        }\n        });\n    }\n\n    function dadosProd(safra){\n        var lblprod = {\n            "analisedesolo": "Soil Analysis",\n            "combustivel": "Fuel",\n            "operacaodamaquina": "Machine Operation",\n            "alugueldamaquina": "Machine Rent",\n            "manutencaodamaquina": "Machine Maintenance"\n        };\n\n        \n        var urlJSONnw = "/api/custonwprodsafra/" + safra;\n        var urlJSONhab = "/api/custohabprodsafra/" + safra;\n\n        $.ajax({\n            url:  urlJSONnw,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(jsonnw) {\n    \n            $.ajax({\n                url:  urlJSONhab,\n                type: \'GET\',\n                beforeSend: function(xhr) {\n                    xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n                },\n                success: function(jsonhab) {\n\n                    listaTiponw = jsonnw.map(function(item) {\n                        return lblprod[item.tipo];\n                    });\n\n                    listaValornw = jsonnw.map(function(item) {\n                        return item.valor;\n                    });\n\n                    listaTipohab = jsonhab.map(function(item) {\n                        return lblprod[item.tipo];\n                    });\n\n                    listaValorhab = jsonhab.map(function(item) {\n                        return item.valor;\n                    }); \n\n                    var l = Object.values(lblprod);\n                    var listahabgraf = [];\n                    var listanwgraf = [];\n\n                    for(i=0; i< l.length; i++){\n                        var comp = l[i];\n                        var valornw=0;\n                        var valorhab=0;\n\n                        for(j=0; j<listaTiponw.length; j++){\n                            if(listaTiponw[j]==comp){\n                                valornw = listaValornw[j];\n                                break;\n                            }\n                        }\n\n                        for(j=0; j<listaTipohab.length; j++){\n                            if(listaTipohab[j]==comp){\n                                valorhab = listaValorhab[j];\n                                break;\n                            }\n                        }\n                        \n                        listahabgraf.push(valorhab);\n                        listanwgraf.push(valornw);\n                    }\n\n                                    \n                    var ctx = document.getElementById(\'grafcustosprod\').getContext(\'2d\');\n                    \n                    var chart = new Chart(ctx, {\n                        type: \'bar\',\n\n                        data: {\n                            labels: Object.values(lblprod),\n                            datasets: [\n                                {\n                                    label: "Usual Production Costs",\n                                    backgroundColor: \'rgb(153, 204, 255)\', \n                                    //borderColor: \'rgb(255, 99, 132)\',\n                                    data: listahabgraf,\n                                },\n                                {\n                                    label: "Netword Production Costs",\n                                    backgroundColor: \'rgb(0, 115, 230)\', \n                                    //borderColor: \'rgb(255, 99, 132)\',\n                                    data: listanwgraf,\n                                }\n                            ]\n                        },\n\n                        // Configuration options go here\n                        options: {\n                            scales: {\n                                yAxes: [{\n                                scaleLabel: {\n                                    display: true,\n                                    labelString: \'Value ($)\'\n                                },   \n                                ticks: {\n                                    suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                                }\n                                }],\n\n                                xAxes: [{\n                                scaleLabel: {\n                                    display: true,\n                                    labelString: \'Type of cost\'\n                                }\n                                }]\n                            }     \n\n                        }\n                    });\n\n                    $("#tabelachp").append(\'<table class="table table-striped" id="tabchp"></table>\');\n                    $("#tabchp").append(\'<tbody id="tabchpbody"></tbody>\');\n                    $("#tabchp").append(\'<thead><tr><th>Type of Cost</th> <th>Usual Value ($)</th> <th>NetWord Value ($) </th></tr></thead>\');\n                    var l = Object.values(lblprod);\n                    for(i=0; i< l.length; i++){\n                        var comp = l[i];\n                        var valornw=0;\n                        var valorhab=0;\n\n                        for(j=0; j<listaTiponw.length; j++){\n                            if(listaTiponw[j]==comp){\n                                valornw = listaValornw[j];\n                                break;\n                            }\n                        }\n\n                        for(j=0; j<listaTipohab.length; j++){\n                            if(listaTipohab[j]==comp){\n                                valorhab = listaValorhab[j];\n                                break;\n                            }\n                        }\n\n                        $("#tabchpbody").append(\'<tr> <td>\' + comp + \'</td> <td> \' + valorhab +  \'</td> <td> \' + valornw + \'</td> </tr>\');\n                    }\n                }\n            });\n        }\n        });\n    } \n\n    function montaRelatorio(){\n        $(\'#gerapdf\').attr(\'disabled\', false);\n\n        var $select = $(\'#selecsafra\');\n        var safra = $select.val();\n\n        limpa();\n        dadosSafra(safra);\n        dadosFert(safra);\n        dadosDef(safra);\n        dadosProd(safra);\n    }\n\n    function gerarpdf(){\n        var conteudo = [];\n\n        addLogo(conteudo, 100);\n\n        // Titulo do relat\xF3rio\n        conteudo.push(\' \');\n\n        var titulo = {};\n        titulo.text = \'Comparative Costs Report\';\n        titulo.fontSize = 15;\n        titulo.alignment = \'center\';\n        conteudo.push(titulo);\n\n        conteudo.push(\' \'); \n\n        conteudo.push("Property: " + $(\'#nomeprop\').html());\n        conteudo.push(($("#dadossafra").html()).split(\'<br>\'));\n        \n        //Tabelas e imagens\n        conteudo.push(\' \');\n        conteudo.push(\'Prodution Costs\');\n        \n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosprod\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chp\n        addTabelaPdf2("#tabelachp", conteudo, \'en\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        conteudo.push(\'Defensive Costs\');\n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosdef\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chd\n        addTabelaPdf2("#tabelachd", conteudo, \'en\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        conteudo.push(\'Custos de fertilizantes\');\n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosfert\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chf\n        addTabelaPdf2("#tabelachf", conteudo, \'en\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        addMomentoPdf(conteudo, \'en\');\n\n        // Gera\xE7\xE3o do documento\n        var doc = { content: conteudo };\n        pdfMake.createPdf(doc).download();\n    }\n    preencheSelector();</script><div><div class="container-fluid"><div class="well">Select the harvest:<form name="formSafra"><select id="selecsafra" name="safras"></select><button onclick="montaRelatorio()">Show report</button> <button id="gerapdf" onclick="gerarpdf()">Generate PDF</button></form></div><div id="relatorio" class="col-xs-12"><div class="row"><div id="titulo" class="col-xs-12 no-padding-left"></div></div><div class="row"><div class="well" style="visibility: hidden" id="dadossafra"></div></div><div class="row"><div class="row"><div id="graficochp" class="col-xs-12 no-padding-left"><canvas id="grafcustosprod"></canvas></div></div><div class="row"><div id="tabelachp" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div><div class="row" style="margin-top:20px"><div class="row"><div id="graficochd" class="col-xs-12 no-padding-left"><canvas id="grafcustosdef"></canvas></div></div><div class="row"><div id="tabelachd" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div><div class="row" style="margin-top:20px"><div class="row"><div id="graficochf" class="col-xs-12 no-padding-left"><canvas id="grafcustosfert"></canvas></div></div><div class="row"><div id="tabelachf" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div></div></div></div>');
$templateCache.put('app/entities/comparativo/comparativos-es.html','<script src="bower_components/chart.js/dist/Chart.min.js"></script><script src="bower_components/pdfmake/build/pdfmake.min.js"></script><script src="bower_components/pdfmake/build/vfs_fonts.js"></script><script src="bower_components/criacaopdf.js"></script><script type="text/javascript">function preencheSelector(){\n        $(\'#gerapdf\').attr(\'disabled\', true);\n\n        var $select = $(\'#selecsafra\');\n        $.ajax({\n            url:  \'/api/nomesafras/\',\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) {\n                $select.html(\'\');\n                listaOpcoes = json.map(function(item) {\n                    return item.nome;\n                });\n\n                for (i = 0; i < listaOpcoes.length; i++) {\n                    $select.append(\'<option id="\' + listaOpcoes[i] + \'">\' + listaOpcoes[i] + \'</option>\');\n                }\n                console.log("preenchido");\n            }\n        });\n\n    }\n\n    function dadosSafra(safra){\n        var tipoSafra = {\n                "verao":"Verano",\n                "safrinha":"Fuera de la temporada",\n                "inverno": "Invierno"\n        };\n\n        var urlJSON = "/api/dadossafra/" + safra;\n\n        $.ajax({\n            url:  urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) {\n                propriedade = json.map(function(item) {\n                    return item.nomepropriedade;\n                });\n\n                ano = json.map(function(item) {\n                    return item.ano;\n                });\n\n                tsafra = json.map(function(item) {\n                    return tipoSafra[item.safra];\n                });\n\n                nomeSafra = json.map(function(item) {\n                    return item.nome;\n                });\n\n                $("#titulo").html("<h3>Comparativo de costos: <small id=\'nomeprop\'>" + propriedade + "</small></h3>");\n                $("#dadossafra").css(\'visibility\', \'visible\');\n                $("#dadossafra").html(\'Nombre de la cosecha: \' + nomeSafra + \'<br>\' + \'Cosecha: \' + tsafra + \'<br>\' + \'A\xF1o de la cosecha: \' + ano + \'<br>\');\n            }\n        });\n\n  \n    }\n\n    function limpa(){\n        $("#graficochf").html(\'\');\n        $("#graficochf").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosfert"></canvas>\');\n        $("#graficochp").html(\'\');\n        $("#graficochp").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosprod"></canvas>\');\n        $("#graficochd").html(\'\');\n        $("#graficochd").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosdef"></canvas>\');\n        $("#tabelachd").html(\'\');\n        $("#tabelachf").html(\'\');\n        $("#tabelachp").html(\'\');\n    }\n\n    function dadosFert(safra){\n        var lblfert = {\n            "fertilizantequimico":"Fertilizante Qu\xEDmico",\n            "fertilizantefoliar":"Fertilizante para Hoja",\n            "materialorganico":"Material Org\xE1nico",\n            "corretivo":"Correctivo"\n        };\n\n        var urlJSONnw = "/api/custonwfertsafra/" + safra;\n        var urlJSONhab = "/api/custohabfertsafra/" + safra;\n\n\n        $.ajax({\n            url:  urlJSONnw,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(jsonnw) {\n    \n            $.ajax({\n                url:  urlJSONhab,\n                type: \'GET\',\n                beforeSend: function(xhr) {\n                    xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n                },\n                success: function(jsonhab) {\n                        \n                    listaTiponw = jsonnw.map(function(item) {\n                        return lblfert[item.tipo];\n                    });\n\n                    listaValornw = jsonnw.map(function(item) {\n                        return item.valor;\n                    });\n\n                    listaTipohab = jsonhab.map(function(item) {\n                        return lblfert[item.tipo];\n                    });\n\n                    listaValorhab = jsonhab.map(function(item) {\n                        return item.valor;\n                    });\n\n                    var l = Object.values(lblfert);\n                    var listahabgraf = [];\n                    var listanwgraf = [];\n\n                    for(i=0; i< l.length; i++){\n                        var comp = l[i];\n                        var valornw=0;\n                        var valorhab=0;\n\n                        for(j=0; j<listaTiponw.length; j++){\n                            if(listaTiponw[j]==comp){\n                                valornw = listaValornw[j];\n                                break;\n                            }\n                        }\n\n                        for(j=0; j<listaTipohab.length; j++){\n                            if(listaTipohab[j]==comp){\n                                valorhab = listaValorhab[j];\n                                break;\n                            }\n                        }\n                        \n                        listahabgraf.push(valorhab);\n                        listanwgraf.push(valornw);\n                    }\n\n                    var ctx = document.getElementById(\'grafcustosfert\').getContext(\'2d\');\n\n                    var chart = new Chart(ctx, {\n                        type: \'bar\',\n\n                        data: {\n                            labels: Object.values(lblfert),\n                            datasets: [{\n                                    label: "Costos con fertilizantes Habituales",\n                                    backgroundColor: \'rgb(204, 255, 102)\', \n                                    //borderColor: \'rgb(255, 99, 132)\',\n                                    data: listahabgraf,\n                                },\n                                {\n                                    label: "Custos con fertilizantes NW",\n                                    backgroundColor: \'rgb(136, 204, 0)\', \n                                    //borderColor: \'rgb(255, 99, 132)\',\n                                    data: listanwgraf,\n                                }\n                            ]\n                        },\n\n                        // Configuration options go here\n                        options: {\n                            scales: {\n                                barValueSpacing: 20,\n                                yAxes: [{\n                                scaleLabel: {\n                                    display: true,\n                                    labelString: \'Valor ($)\'\n                                },   \n                                ticks: {\n                                    suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                                }\n                                }],\n\n                                xAxes: [{\n                                scaleLabel: {\n                                    display: true,\n                                    labelString: \'Tipo del Costo\'\n                                }\n                                }]\n                            }     \n\n                        }\n                    });\n\n                    $("#tabelachf").append(\'<table class="table table-striped" id="tabchf"></table>\');\n                    $("#tabchf").append(\'<tbody id="tabchfbody"></tbody>\');\n                    $("#tabchf").append(\'<thead><tr><th>Tipo del Costo</th> <th>Valor Habitual ($)</th> <th>Valor NetWord ($)</th></tr></thead>\');\n                    var l = Object.values(lblfert);\n                    for(i=0; i< l.length; i++){\n                        var comp = l[i];\n                        var valornw=0;\n                        var valorhab=0;\n\n                        for(j=0; j<listaTiponw.length; j++){\n                            if(listaTiponw[j]==comp){\n                                valornw = listaValornw[j];\n                                break;\n                            }\n                        }\n\n                        for(j=0; j<listaTipohab.length; j++){\n                            if(listaTipohab[j]==comp){\n                                valorhab = listaValorhab[j];\n                                break;\n                            }\n                        }\n\n                        $("#tabchfbody").append(\'<tr> <td>\' + comp + \'</td> <td> \' + valorhab +  \'</td> <td> \' + valornw + \'</td> </tr>\');\n\n                    }\n                }\n            });\n        }\n        });\n    }\n\n    function dadosDef(safra){\n         \n        var lbldef = {\n            "inseticidaparasemente": "Insecticida para la Semilla",\n            "inseticidaparalagarta": "Insecticida para la Oruga",\n            "inseticidaparapercevejo": "Insecticida para la Chincheta",\n            "fungicidaparasemente": "Fungicida para la Semilla",\n            "fungicida": "Fungicida",\n            "herbicidaparaplantadaninha": "Herbicida para la Planta Da\xF1ina",\n            "herbicidaparaprecolheita": "Herbicida para Pre-cosecha",\n            "larvicida": "Larvicida"\n        };\n\n        var urlJSONnw = "/api/custonwdefsafra/" + safra;\n        var urlJSONhab = "/api/custohabdefsafra/" + safra;\n\n\n        $.ajax({\n            url:  urlJSONnw,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(jsonnw) {\n    \n            $.ajax({\n                url:  urlJSONhab,\n                type: \'GET\',\n                beforeSend: function(xhr) {\n                    xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n                },\n                success: function(jsonhab) {\n                    listaTiponw = jsonnw.map(function(item) {\n                        return lbldef[item.tipo];\n                    });\n\n                    listaValornw = jsonnw.map(function(item) {\n                        return item.valor;\n                    });\n\n                    listaTipohab = jsonhab.map(function(item) {\n                        return lbldef[item.tipo];\n                    });\n\n                    listaValorhab = jsonhab.map(function(item) {\n                        return item.valor;\n                    });\n\n                    var l = Object.values(lbldef);\n                    var listahabgraf = [];\n                    var listanwgraf = [];\n\n                    for(i=0; i< l.length; i++){\n                        var comp = l[i];\n                        var valornw=0;\n                        var valorhab=0;\n\n                        for(j=0; j<listaTiponw.length; j++){\n                            if(listaTiponw[j]==comp){\n                                valornw = listaValornw[j];\n                                break;\n                            }\n                        }\n\n                        for(j=0; j<listaTipohab.length; j++){\n                            if(listaTipohab[j]==comp){\n                                valorhab = listaValorhab[j];\n                                break;\n                            }\n                        }\n                        \n                        listahabgraf.push(valorhab);\n                        listanwgraf.push(valornw);\n                    }\n                    \n                    var ctx = document.getElementById(\'grafcustosdef\').getContext(\'2d\');        \n\n                    var chart = new Chart(ctx, {\n                        type: \'bar\',\n\n                        data: {\n                            labels: Object.values(lbldef),\n                            datasets: [\n                                {\n                                    label: "Costos con defensivos",\n                                    backgroundColor: \'rgb(255, 102, 102)\', \n                                    //borderColor: \'rgb(255, 99, 132)\',\n                                    data: listahabgraf,\n                                },\n                                {\n                                    label: "Costos con defensivos",\n                                    backgroundColor: \'rgb(255, 51, 51)\', \n                                    //borderColor: \'rgb(255, 99, 132)\',\n                                    data: listanwgraf,\n                                }\n                            ]\n                        },\n\n                        // Configuration options go here\n                        options: {\n                            scales: {\n                                yAxes: [{\n                                scaleLabel: {\n                                    display: true,\n                                    labelString: \'Valor ($)\'\n                                },   \n                                ticks: {\n                                    suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                                }\n                                }],\n\n                                xAxes: [{\n                                scaleLabel: {\n                                    display: true,\n                                    labelString: \'Tipo del costo\'\n                                }\n                                }]\n                            }     \n\n                        }\n                    });\n\n                    $("#tabelachd").append(\'<table class="table table-striped" id="tabchd"></table>\');\n                    $("#tabchd").append(\'<tbody id="tabchdbody"></tbody>\');\n                    $("#tabchd").append(\'<thead><tr><th>Tipo de Costo</th> <th>Valor Habitual ($)</th> <th>Valor NetWord ($) </th></tr></thead>\');\n                    var l = Object.values(lbldef);\n                    for(i=0; i< l.length; i++){\n                        var comp = l[i];\n                        var valornw=0;\n                        var valorhab=0;\n\n                        for(j=0; j<listaTiponw.length; j++){\n                            if(listaTiponw[j]==comp){\n                                valornw = listaValornw[j];\n                                break;\n                            }\n                        }\n\n                        for(j=0; j<listaTipohab.length; j++){\n                            if(listaTipohab[j]==comp){\n                                valorhab = listaValorhab[j];\n                                break;\n                            }\n                        }\n\n                        $("#tabchdbody").append(\'<tr> <td>\' + comp + \'</td> <td> \' + valorhab +  \'</td> <td> \' + valornw + \'</td> </tr>\');\n\n                    }\n                }\n            });\n        }\n        });\n    }\n\n    function dadosProd(safra){\n        var lblprod = {\n            "analisedesolo": "An\xE1lisis de Suelo",\n            "combustivel": "Combustible de la M\xE1quina",\n            "operacaodamaquina": "Operaci\xF3n de la M\xE1quina",\n            "alugueldamaquina": "Alquiler de la M\xE1quina",\n            "manutencaodamaquina": "Mantenimiento de la M\xE1quina"\n        };\n\n        \n        var urlJSONnw = "/api/custonwprodsafra/" + safra;\n        var urlJSONhab = "/api/custohabprodsafra/" + safra;\n\n        $.ajax({\n            url:  urlJSONnw,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(jsonnw) {\n    \n            $.ajax({\n                url:  urlJSONhab,\n                type: \'GET\',\n                beforeSend: function(xhr) {\n                    xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n                },\n                success: function(jsonhab) {\n\n                    listaTiponw = jsonnw.map(function(item) {\n                        return lblprod[item.tipo];\n                    });\n\n                    listaValornw = jsonnw.map(function(item) {\n                        return item.valor;\n                    });\n\n                    listaTipohab = jsonhab.map(function(item) {\n                        return lblprod[item.tipo];\n                    });\n\n                    listaValorhab = jsonhab.map(function(item) {\n                        return item.valor;\n                    }); \n\n                    var l = Object.values(lblprod);\n                    var listahabgraf = [];\n                    var listanwgraf = [];\n\n                    for(i=0; i< l.length; i++){\n                        var comp = l[i];\n                        var valornw=0;\n                        var valorhab=0;\n\n                        for(j=0; j<listaTiponw.length; j++){\n                            if(listaTiponw[j]==comp){\n                                valornw = listaValornw[j];\n                                break;\n                            }\n                        }\n\n                        for(j=0; j<listaTipohab.length; j++){\n                            if(listaTipohab[j]==comp){\n                                valorhab = listaValorhab[j];\n                                break;\n                            }\n                        }\n                        \n                        listahabgraf.push(valorhab);\n                        listanwgraf.push(valornw);\n                    }\n\n                                    \n                    var ctx = document.getElementById(\'grafcustosprod\').getContext(\'2d\');\n                    \n                    var chart = new Chart(ctx, {\n                        type: \'bar\',\n\n                        data: {\n                            labels: Object.values(lblprod),\n                            datasets: [\n                                {\n                                    label: "Costos de producci\xF3n Habituales",\n                                    backgroundColor: \'rgb(153, 204, 255)\', \n                                    //borderColor: \'rgb(255, 99, 132)\',\n                                    data: listahabgraf,\n                                },\n                                {\n                                    label: "Costos de producci\xF3n NetWord",\n                                    backgroundColor: \'rgb(0, 115, 230)\', \n                                    //borderColor: \'rgb(255, 99, 132)\',\n                                    data: listanwgraf,\n                                }\n                            ]\n                        },\n\n                        // Configuration options go here\n                        options: {\n                            scales: {\n                                yAxes: [{\n                                scaleLabel: {\n                                    display: true,\n                                    labelString: \'Valor ($)\'\n                                },   \n                                ticks: {\n                                    suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                                }\n                                }],\n\n                                xAxes: [{\n                                scaleLabel: {\n                                    display: true,\n                                    labelString: \'Tipo de costo\'\n                                }\n                                }]\n                            }     \n\n                        }\n                    });\n\n                    $("#tabelachp").append(\'<table class="table table-striped" id="tabchp"></table>\');\n                    $("#tabchp").append(\'<tbody id="tabchpbody"></tbody>\');\n                    $("#tabchp").append(\'<thead><tr><th>Tipo de Costo</th> <th>Valor Habitual ($)</th> <th>Valor NetWord ($) </th></tr></thead>\');\n                    var l = Object.values(lblprod);\n                    for(i=0; i< l.length; i++){\n                        var comp = l[i];\n                        var valornw=0;\n                        var valorhab=0;\n\n                        for(j=0; j<listaTiponw.length; j++){\n                            if(listaTiponw[j]==comp){\n                                valornw = listaValornw[j];\n                                break;\n                            }\n                        }\n\n                        for(j=0; j<listaTipohab.length; j++){\n                            if(listaTipohab[j]==comp){\n                                valorhab = listaValorhab[j];\n                                break;\n                            }\n                        }\n\n                        $("#tabchpbody").append(\'<tr> <td>\' + comp + \'</td> <td> \' + valorhab +  \'</td> <td> \' + valornw + \'</td> </tr>\');\n\n                    }\n                }\n            });\n        }\n        });\n    } \n\n    function montaRelatorio(){\n        $(\'#gerapdf\').attr(\'disabled\', false);\n\n        var $select = $(\'#selecsafra\');\n        var safra = $select.val();\n\n        limpa();\n        dadosSafra(safra);\n        dadosFert(safra);\n        dadosDef(safra);\n        dadosProd(safra);\n    }\n\n    function gerarpdf(){\n        var conteudo = [];\n\n        addLogo(conteudo, 100);\n\n        // Titulo do relat\xF3rio\n        conteudo.push(\' \');\n\n        var titulo = {};\n        titulo.text = \'Informe del Comparativo dos Costos\';\n        titulo.fontSize = 15;\n        titulo.alignment = \'center\';\n        conteudo.push(titulo);\n\n        conteudo.push(\' \'); \n\n        conteudo.push("Propiedad: " + $(\'#nomeprop\').html());\n        conteudo.push(($("#dadossafra").html()).split(\'<br>\'));\n        \n        //Tabelas e imagens\n        conteudo.push(\' \');\n        conteudo.push(\'Costos de producci\xF3n\');\n        \n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosprod\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chp\n        addTabelaPdf2("#tabelachp", conteudo, \'es\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        conteudo.push(\'Costos con defensivos\');\n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosdef\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chd\n        addTabelaPdf2("#tabelachd", conteudo, \'es\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        conteudo.push(\'Costos con fertilizantes\');\n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosfert\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chf\n        addTabelaPdf2("#tabelachf", conteudo, \'es\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        addMomentoPdf(conteudo, \'es\');\n\n        // Gera\xE7\xE3o do documento\n        var doc = { content: conteudo };\n        pdfMake.createPdf(doc).download();\n    }\n    preencheSelector();</script><div><div class="container-fluid"><div class="well">Seleccione la cosecha:<form name="formSafra"><select id="selecsafra" name="safras"></select><button onclick="montaRelatorio()">Mostrar Informe</button> <button id="gerapdf" onclick="gerarpdf()">Generar PDF</button></form></div><div id="relatorio" class="col-xs-12"><div class="row"><div id="titulo" class="col-xs-12 no-padding-left"></div></div><div class="row"><div class="well" style="visibility: hidden" id="dadossafra"></div></div><div class="row"><div class="row"><div id="graficochp" class="col-xs-12 no-padding-left"><canvas id="grafcustosprod"></canvas></div></div><div class="row"><div id="tabelachp" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div><div class="row" style="margin-top:20px"><div class="row"><div id="graficochd" class="col-xs-12 no-padding-left"><canvas id="grafcustosdef"></canvas></div></div><div class="row"><div id="tabelachd" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div><div class="row" style="margin-top:20px"><div class="row"><div id="graficochf" class="col-xs-12 no-padding-left"><canvas id="grafcustosfert"></canvas></div></div><div class="row"><div id="tabelachf" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div></div></div></div>');
$templateCache.put('app/entities/comparativo/comparativos.html','<script src="bower_components/chart.js/dist/Chart.min.js"></script><script src="bower_components/pdfmake/build/pdfmake.min.js"></script><script src="bower_components/pdfmake/build/vfs_fonts.js"></script><script src="bower_components/criacaopdf.js"></script><script type="text/javascript">function linguagem(){   \n        $.ajax({\n            url:  \'/api/account/\',\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) { \n            \n                var linguagem = json.langKey;\n\n                if(linguagem==="en"){\n                    window.location.assign("/#/comparativo-en");\n                }\n                else if(linguagem==="es"){\n                    window.location.assign("/#/comparativo-es");\n                }\n            }\n        });\n    }\n\n    function preencheSelector(){\n        $(\'#gerapdf\').attr(\'disabled\', true);\n\n        var $select = $(\'#selecsafra\');\n\n        $.ajax({\n            url:  \'/api/nomesafras/\',\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) {\n                $select.html(\'\');\n                listaOpcoes = json.map(function(item) {\n                    return item.nome;\n                });\n\n                for (i = 0; i < listaOpcoes.length; i++) {\n                    $select.append(\'<option id="\' + listaOpcoes[i] + \'">\' + listaOpcoes[i] + \'</option>\');\n                }\n                console.log("preenchido");\n            }\n        });\n    }\n\n    function dadosSafra(safra){\n        var tipoSafra = {\n                "verao":"Ver\xE3o",\n                "safrinha":"Safrinha",\n                "inverno": "Inverno"\n        };\n\n        var urlJSON = "/api/dadossafra/" + safra;\n\n        $.ajax({\n            url:  urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) {\n                propriedade = json.map(function(item) {\n                    return item.nomepropriedade;\n                });\n\n                ano = json.map(function(item) {\n                    return item.ano;\n                });\n\n                tsafra = json.map(function(item) {\n                    return tipoSafra[item.safra];\n                });\n\n                nomeSafra = json.map(function(item) {\n                    return item.nome;\n                });\n\n                $("#titulo").html("<h3>Comparativo de custos: <small id=\'nomeprop\'>" + propriedade + "</small></h3>");\n                $("#dadossafra").css(\'visibility\', \'visible\');\n                $("#dadossafra").html(\'Nome da safra: \' + nomeSafra + \'<br>\' + \'Safra: \' + tsafra + \'<br>\' + \'Ano da safra: \' + ano + \'<br>\');\n            }\n        });\n\n  \n    }\n\n    function limpa(){\n        $("#graficochf").html(\'\');\n        $("#graficochf").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosfert"></canvas>\');\n        $("#graficochp").html(\'\');\n        $("#graficochp").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosprod"></canvas>\');\n        $("#graficochd").html(\'\');\n        $("#graficochd").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosdef"></canvas>\');\n        $("#tabelachd").html(\'\');\n        $("#tabelachf").html(\'\');\n        $("#tabelachp").html(\'\');\n    }\n\n    function dadosFert(safra){\n        var lblfert = {\n                "fertilizantequimico":"Fertilizante Qu\xEDmico",\n                "fertilizantefoliar":"Fertilizante Foliar",\n                "materialorganico":"Material Org\xE2nico",\n                "corretivo":"Corretivo"\n        };\n\n        var urlJSONnw = "/api/custonwfertsafra/" + safra;\n        var urlJSONhab = "/api/custohabfertsafra/" + safra;\n\n\n        $.ajax({\n            url:  urlJSONnw,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(jsonnw) {\n    \n            $.ajax({\n                url:  urlJSONhab,\n                type: \'GET\',\n                beforeSend: function(xhr) {\n                    xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n                },\n                success: function(jsonhab) {\n                    listaTiponw = jsonnw.map(function(item) {\n                        return lblfert[item.tipo];\n                    });\n\n                    listaValornw = jsonnw.map(function(item) {\n                        return item.valor;\n                    });\n\n                    listaTipohab = jsonhab.map(function(item) {\n                        return lblfert[item.tipo];\n                    });\n\n                    listaValorhab = jsonhab.map(function(item) {\n                        return item.valor;\n                    });\n\n                    var l = Object.values(lblfert);\n                    var listahabgraf = [];\n                    var listanwgraf = [];\n\n                    for(i=0; i< l.length; i++){\n                        var comp = l[i];\n                        var valornw=0;\n                        var valorhab=0;\n\n                        for(j=0; j<listaTiponw.length; j++){\n                            if(listaTiponw[j]==comp){\n                                valornw = listaValornw[j];\n                                break;\n                            }\n                        }\n\n                        for(j=0; j<listaTipohab.length; j++){\n                            if(listaTipohab[j]==comp){\n                                valorhab = listaValorhab[j];\n                                break;\n                            }\n                        }\n                        \n                        listahabgraf.push(valorhab);\n                        listanwgraf.push(valornw);\n                    }\n\n                    var ctx = document.getElementById(\'grafcustosfert\').getContext(\'2d\');\n\n                    var chart = new Chart(ctx, {\n                        type: \'bar\',\n\n                        data: {\n                            labels: Object.values(lblfert),\n                            datasets: [{\n                                    label: "Custos de fertilizantes Hab",\n                                    backgroundColor: \'rgb(204, 255, 102)\', \n                                    //borderColor: \'rgb(255, 99, 132)\',\n                                    data: listahabgraf,\n                                },\n                                {\n                                    label: "Custos de fertilizantes NW",\n                                    backgroundColor: \'rgb(136, 204, 0)\', \n                                    //borderColor: \'rgb(255, 99, 132)\',\n                                    data: listanwgraf,\n                                }\n                            ]\n                        },\n\n                        // Configuration options go here\n                        options: {\n                            scales: {\n                                barValueSpacing: 20,\n                                yAxes: [{\n                                scaleLabel: {\n                                    display: true,\n                                    labelString: \'Valor (R$)\'\n                                },   \n                                ticks: {\n                                    suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                                }\n                                }],\n\n                                xAxes: [{\n                                scaleLabel: {\n                                    display: true,\n                                    labelString: \'Tipo de custo\'\n                                }\n                                }]\n                            }     \n\n                        }\n                    });\n\n                    $("#tabelachf").append(\'<table class="table table-striped" id="tabchf"></table>\');\n                    $("#tabchf").append(\'<tbody id="tabchfbody"></tbody>\');\n                    $("#tabchf").append(\'<thead><tr><th>Tipo de Gasto</th> <th>Valor Habitual (R$)</th> <th>Valor NetWord (R$)</th></tr></thead>\');\n                    var l = Object.values(lblfert);\n                    for(i=0; i< l.length; i++){\n                        var comp = l[i];\n                        var valornw=0;\n                        var valorhab=0;\n\n                        for(j=0; j<listaTiponw.length; j++){\n                            if(listaTiponw[j]==comp){\n                                valornw = listaValornw[j];\n                                break;\n                            }\n                        }\n\n                        for(j=0; j<listaTipohab.length; j++){\n                            if(listaTipohab[j]==comp){\n                                valorhab = listaValorhab[j];\n                                break;\n                            }\n                        }\n\n                        $("#tabchfbody").append(\'<tr> <td>\' + comp + \'</td> <td> \' + valorhab +  \'</td> <td> \' + valornw + \'</td> </tr>\');\n\n                    }\n                }\n            });\n        \n        }\n        });\n    }\n\n    function dadosDef(safra){\n         \n        var lbldef = {\n            "inseticidaparasemente": "Inseticida para Semente",\n            "inseticidaparalagarta": "Inseticida para Lagarta",\n            "inseticidaparapercevejo": "Inseticida para Percevejo",\n            "fungicidaparasemente": "Fungicida para Semente",\n            "fungicida": "Fungicida",\n            "herbicidaparaplantadaninha": "Herbicida para Planta Daninha",\n            "herbicidaparaprecolheita": "Herbicida para Pr\xE9-Colheita",\n            "larvicida": "Larvicida"\n        };\n\n        var urlJSONnw = "/api/custonwdefsafra/" + safra;\n        var urlJSONhab = "/api/custohabdefsafra/" + safra;\n\n\n        $.ajax({\n            url:  urlJSONnw,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(jsonnw) {\n    \n            $.ajax({\n                url:  urlJSONhab,\n                type: \'GET\',\n                beforeSend: function(xhr) {\n                    xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n                },\n                success: function(jsonhab) {\n                    listaTiponw = jsonnw.map(function(item) {\n                        return lbldef[item.tipo];\n                    });\n\n                    listaValornw = jsonnw.map(function(item) {\n                        return item.valor;\n                    });\n\n                    listaTipohab = jsonhab.map(function(item) {\n                        return lbldef[item.tipo];\n                    });\n\n                    listaValorhab = jsonhab.map(function(item) {\n                        return item.valor;\n                    });\n\n                    var l = Object.values(lbldef);\n                    var listahabgraf = [];\n                    var listanwgraf = [];\n\n                    for(i=0; i< l.length; i++){\n                        var comp = l[i];\n                        var valornw=0;\n                        var valorhab=0;\n\n                        for(j=0; j<listaTiponw.length; j++){\n                            if(listaTiponw[j]==comp){\n                                valornw = listaValornw[j];\n                                break;\n                            }\n                        }\n\n                        for(j=0; j<listaTipohab.length; j++){\n                            if(listaTipohab[j]==comp){\n                                valorhab = listaValorhab[j];\n                                break;\n                            }\n                        }\n                        \n                        listahabgraf.push(valorhab);\n                        listanwgraf.push(valornw);\n                    }\n                    \n                    var ctx = document.getElementById(\'grafcustosdef\').getContext(\'2d\');        \n\n                    var chart = new Chart(ctx, {\n                        type: \'bar\',\n\n                        data: {\n                            labels: Object.values(lbldef),\n                            datasets: [\n                                {\n                                    label: "Custos de defensivos",\n                                    backgroundColor: \'rgb(255, 102, 102)\', \n                                    //borderColor: \'rgb(255, 99, 132)\',\n                                    data: listahabgraf,\n                                },\n                                {\n                                    label: "Custos de defensivos",\n                                    backgroundColor: \'rgb(255, 51, 51)\', \n                                    //borderColor: \'rgb(255, 99, 132)\',\n                                    data: listanwgraf,\n                                }\n                            ]\n                        },\n\n                        // Configuration options go here\n                        options: {\n                            scales: {\n                                yAxes: [{\n                                scaleLabel: {\n                                    display: true,\n                                    labelString: \'Valor (R$)\'\n                                },   \n                                ticks: {\n                                    suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                                }\n                                }],\n\n                                xAxes: [{\n                                scaleLabel: {\n                                    display: true,\n                                    labelString: \'Tipo de custo\'\n                                }\n                                }]\n                            }     \n\n                        }\n                    });\n\n                    $("#tabelachd").append(\'<table class="table table-striped" id="tabchd"></table>\');\n                    $("#tabchd").append(\'<tbody id="tabchdbody"></tbody>\');\n                    $("#tabchd").append(\'<thead><tr><th>Tipo de Gasto</th> <th>Valor Habitual (R$)</th> <th>Valor NetWord (R$) </th></tr></thead>\');\n                    var l = Object.values(lbldef);\n                    for(i=0; i< l.length; i++){\n                        var comp = l[i];\n                        var valornw=0;\n                        var valorhab=0;\n\n                        for(j=0; j<listaTiponw.length; j++){\n                            if(listaTiponw[j]==comp){\n                                valornw = listaValornw[j];\n                                break;\n                            }\n                        }\n\n                        for(j=0; j<listaTipohab.length; j++){\n                            if(listaTipohab[j]==comp){\n                                valorhab = listaValorhab[j];\n                                break;\n                            }\n                        }\n\n                        $("#tabchdbody").append(\'<tr> <td>\' + comp + \'</td> <td> \' + valorhab +  \'</td> <td> \' + valornw + \'</td> </tr>\');\n\n                    }\n                }\n            });\n        }\n        });\n    }\n\n    function dadosProd(safra){\n        var lblprod = {\n            "analisedesolo": "An\xE1lise de Solo",\n            "combustivel": "Combust\xEDvel da M\xE1quina",\n            "operacaodamaquina": "Opera\xE7\xE3o da M\xE1quina",\n            "alugueldamaquina": "Aluguel da M\xE1quina",\n            "manutencaodamaquina": "Manuten\xE7\xE3o da M\xE1quina"\n        };\n\n        \n        var urlJSONnw = "/api/custonwprodsafra/" + safra;\n        var urlJSONhab = "/api/custohabprodsafra/" + safra;\n\n        $.ajax({\n            url:  urlJSONnw,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(jsonnw) {\n    \n            $.ajax({\n                url:  urlJSONhab,\n                type: \'GET\',\n                beforeSend: function(xhr) {\n                    xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n                },\n                success: function(jsonhab) {\n\n                    listaTiponw = jsonnw.map(function(item) {\n                        return lblprod[item.tipo];\n                    });\n\n                    listaValornw = jsonnw.map(function(item) {\n                        return item.valor;\n                    });\n\n                    listaTipohab = jsonhab.map(function(item) {\n                        return lblprod[item.tipo];\n                    });\n\n                    listaValorhab = jsonhab.map(function(item) {\n                        return item.valor;\n                    }); \n\n                    var l = Object.values(lblprod);\n                    var listahabgraf = [];\n                    var listanwgraf = [];\n\n                    for(i=0; i< l.length; i++){\n                        var comp = l[i];\n                        var valornw=0;\n                        var valorhab=0;\n\n                        for(j=0; j<listaTiponw.length; j++){\n                            if(listaTiponw[j]==comp){\n                                valornw = listaValornw[j];\n                                break;\n                            }\n                        }\n\n                        for(j=0; j<listaTipohab.length; j++){\n                            if(listaTipohab[j]==comp){\n                                valorhab = listaValorhab[j];\n                                break;\n                            }\n                        }\n                        \n                        listahabgraf.push(valorhab);\n                        listanwgraf.push(valornw);\n                    }\n\n                                    \n                    var ctx = document.getElementById(\'grafcustosprod\').getContext(\'2d\');\n                    \n                    var chart = new Chart(ctx, {\n                        type: \'bar\',\n\n                        data: {\n                            labels: Object.values(lblprod),\n                            datasets: [\n                                {\n                                    label: "Custos de produ\xE7\xE3o Habituais",\n                                    backgroundColor: \'rgb(153, 204, 255)\', \n                                    //borderColor: \'rgb(255, 99, 132)\',\n                                    data: listahabgraf,\n                                },\n                                {\n                                    label: "Custos de produ\xE7\xE3o NW",\n                                    backgroundColor: \'rgb(0, 115, 230)\', \n                                    //borderColor: \'rgb(255, 99, 132)\',\n                                    data: listanwgraf,\n                                }\n                            ]\n                        },\n\n                        // Configuration options go here\n                        options: {\n                            scales: {\n                                yAxes: [{\n                                scaleLabel: {\n                                    display: true,\n                                    labelString: \'Valor (R$)\'\n                                },   \n                                ticks: {\n                                    suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                                }\n                                }],\n\n                                xAxes: [{\n                                scaleLabel: {\n                                    display: true,\n                                    labelString: \'Tipo de custo\'\n                                }\n                                }]\n                            }     \n\n                        }\n                    });\n\n                    $("#tabelachp").append(\'<table class="table table-striped" id="tabchp"></table>\');\n                    $("#tabchp").append(\'<tbody id="tabchpbody"></tbody>\');\n                    $("#tabchp").append(\'<thead><tr><th>Tipo de Gasto</th> <th>Valor Habitual (R$)</th> <th>Valor NetWord (R$) </th></tr></thead>\');\n                    var l = Object.values(lblprod);\n                    for(i=0; i< l.length; i++){\n                        var comp = l[i];\n                        var valornw=0;\n                        var valorhab=0;\n\n                        for(j=0; j<listaTiponw.length; j++){\n                            if(listaTiponw[j]==comp){\n                                valornw = listaValornw[j];\n                                break;\n                            }\n                        }\n\n                        for(j=0; j<listaTipohab.length; j++){\n                            if(listaTipohab[j]==comp){\n                                valorhab = listaValorhab[j];\n                                break;\n                            }\n                        }\n\n                        $("#tabchpbody").append(\'<tr> <td>\' + comp + \'</td> <td> \' + valorhab +  \'</td> <td> \' + valornw + \'</td> </tr>\');\n\n                    }\n                }\n            });\n        }\n        });\n    } \n\n    function montaRelatorio(){\n        $(\'#gerapdf\').attr(\'disabled\', false);\n\n        var $select = $(\'#selecsafra\');\n        var safra = $select.val();\n\n        limpa();\n        dadosSafra(safra);\n        dadosFert(safra);\n        dadosDef(safra);\n        dadosProd(safra);\n    }\n\n    function gerarpdf(){\n        var conteudo = [];\n\n        addLogo(conteudo, 100);\n\n        // Titulo do relat\xF3rio\n        conteudo.push(\' \');\n\n        var titulo = {};\n        titulo.text = \'Relat\xF3rio Comparativo dos Custos\';\n        titulo.fontSize = 15;\n        titulo.alignment = \'center\';\n        conteudo.push(titulo);\n\n        conteudo.push(\' \'); \n\n        conteudo.push("Propriedade: " + $(\'#nomeprop\').html());\n        conteudo.push(($("#dadossafra").html()).split(\'<br>\'));\n        \n        //Tabelas e imagens\n        conteudo.push(\' \');\n        conteudo.push(\'Custos de produ\xE7\xE3o\');\n        \n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosprod\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chp\n        addTabelaPdf2("#tabelachp", conteudo, \'pt\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        conteudo.push(\'Custos de defensivos\');\n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosdef\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chd\n        addTabelaPdf2("#tabelachd", conteudo, \'pt\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        conteudo.push(\'Custos de fertilizantes\');\n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosfert\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chf\n        addTabelaPdf2("#tabelachf", conteudo, \'pt\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        addMomentoPdf(conteudo, \'pt\');\n\n        // Gera\xE7\xE3o do documento\n        var doc = { content: conteudo };\n        pdfMake.createPdf(doc).download();\n    }\n\n    linguagem();\n    preencheSelector();</script><div><div class="container-fluid"><div class="well">Selecione a safra:<form name="formSafra"><select id="selecsafra" name="safras"></select><button onclick="montaRelatorio()">Mostrar relat\xF3rio</button> <button id="gerapdf" onclick="gerarpdf()">Gerar PDF</button></form></div><div id="relatorio" class="col-xs-12"><div class="row"><div id="titulo" class="col-xs-12 no-padding-left"></div></div><div class="row"><div class="well" style="visibility: hidden" id="dadossafra"></div></div><div class="row"><div class="row"><div id="graficochp" class="col-xs-12 no-padding-left"><canvas id="grafcustosprod"></canvas></div></div><div class="row"><div id="tabelachp" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div><div class="row" style="margin-top:20px"><div class="row"><div id="graficochd" class="col-xs-12 no-padding-left"><canvas id="grafcustosdef"></canvas></div></div><div class="row"><div id="tabelachd" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div><div class="row" style="margin-top:20px"><div class="row"><div id="graficochf" class="col-xs-12 no-padding-left"><canvas id="grafcustosfert"></canvas></div></div><div class="row"><div id="tabelachf" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div></div></div></div>');
$templateCache.put('app/entities/concentracaoidealatributo/concentracaoidealatributo-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.concentracaoidealatributo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.concentracaoidealatributo.delete.question" translate-values="{id: \'{{vm.concentracaoidealatributo.id}}\'}">Are you sure you want to delete this Concentracaoidealatributo?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/concentracaoidealatributo/concentracaoidealatributo-detail.html','<div><h2><span data-translate="netWordAgroApp.concentracaoidealatributo.detail.title">Concentracaoidealatributo</span> {{vm.concentracaoidealatributo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.concentracaoidealatributo.valorconcentracaoatributo">Valorconcentracaoatributo</span></dt><dd><span>{{vm.concentracaoidealatributo.valorconcentracaoatributo}}</span></dd><dt><span data-translate="netWordAgroApp.concentracaoidealatributo.referencia">Referencia</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tiporeferenciaatributo.\' + vm.concentracaoidealatributo.referencia}}">{{vm.concentracaoidealatributo.referencia}}</span></dd><dt><span data-translate="netWordAgroApp.concentracaoidealatributo.cultura">Cultura</span></dt><dd><a ui-sref="cultura-detail({id:vm.concentracaoidealatributo.cultura.id})">{{vm.concentracaoidealatributo.cultura.nomecultura}}</a></dd><dt><span data-translate="netWordAgroApp.concentracaoidealatributo.atributo">Atributo</span></dt><dd><a ui-sref="atributo-detail({id:vm.concentracaoidealatributo.atributo.id})">{{vm.concentracaoidealatributo.atributo.nomeatributo}}</a></dd><dt><span data-translate="netWordAgroApp.concentracaoidealatributo.cidade">Cidade</span></dt><dd><a ui-sref="cidade-detail({id:vm.concentracaoidealatributo.cidade.id})">{{vm.concentracaoidealatributo.cidade.nomecidade}}</a></dd><dt><span data-translate="netWordAgroApp.concentracaoidealatributo.propriedade">Propriedade</span></dt><dd><a ui-sref="propriedade-detail({id:vm.concentracaoidealatributo.propriedade.id})">{{vm.concentracaoidealatributo.propriedade.nomepropriedade}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="concentracaoidealatributo-detail.edit({id:vm.concentracaoidealatributo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/concentracaoidealatributo/concentracaoidealatributo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myConcentracaoidealatributoLabel" data-translate="netWordAgroApp.concentracaoidealatributo.home.createOrEditLabel">Create or edit a Concentracaoidealatributo</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="netWordAgroApp.concentracaoidealatributo.atributo" for="field_atributo">Atributo</label><select class="form-control" id="field_atributo" name="atributo" ng-model="vm.concentracaoidealatributo.atributo" ng-options="atributo as atributo.nomeatributo for atributo in vm.atributos track by atributo.id" required></select></div><div ng-show="editForm.atributo.$invalid"><p class="help-block" ng-show="editForm.atributo.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group" ng-show="vm.concentracaoidealatributo.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.concentracaoidealatributo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.concentracaoidealatributo.valorconcentracaoatributo" for="field_valorconcentracaoatributo">Valorconcentracaoatributo</label><input type="number" class="form-control" name="valorconcentracaoatributo" id="field_valorconcentracaoatributo" ng-model="vm.concentracaoidealatributo.valorconcentracaoatributo" required><div ng-show="editForm.valorconcentracaoatributo.$invalid"><p class="help-block" ng-show="editForm.valorconcentracaoatributo.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.valorconcentracaoatributo.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.concentracaoidealatributo.referencia" for="field_referencia">Referencia</label><select ng-change="vm.selecaoreferencia()" class="form-control" name="referencia" ng-model="vm.concentracaoidealatributo.referencia" id="field_referencia" required><option value="cidade" data-translate="netWordAgroApp.Tiporeferenciaatributo.cidade">cidade</option><option value="propriedade" data-translate="netWordAgroApp.Tiporeferenciaatributo.propriedade">propriedade</option></select><div ng-show="editForm.referencia.$invalid"><p class="help-block" ng-show="editForm.referencia.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.concentracaoidealatributo.cultura" for="field_cultura">Cultura</label><select class="form-control" id="field_cultura" name="cultura" ng-model="vm.concentracaoidealatributo.cultura" ng-options="cultura as cultura.nomecultura for cultura in vm.culturas track by cultura.id" required></select></div><div ng-show="editForm.cultura.$invalid"><p class="help-block" ng-show="editForm.cultura.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group" ng-show="exibecidade"><label data-translate="netWordAgroApp.concentracaoidealatributo.cidade" for="field_cidade">Cidade</label><select ng-required="exibecidade" class="form-control" id="field_cidade" name="cidade" ng-model="vm.concentracaoidealatributo.cidade" ng-options="cidade as cidade.nomecidade for cidade in vm.cidades track by cidade.id"><option value=""></option></select></div><div class="form-group" ng-show="exibeprop"><label data-translate="netWordAgroApp.concentracaoidealatributo.propriedade" for="field_propriedade">Propriedade</label><select ng-required="exibeprop" class="form-control" id="field_propriedade" name="propriedade" ng-model="vm.concentracaoidealatributo.propriedade" ng-options="propriedade as propriedade.nomepropriedade for propriedade in vm.propriedades track by propriedade.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/concentracaoidealatributo/concentracaoidealatributos.html','<div><h2 data-translate="netWordAgroApp.concentracaoidealatributo.home.title">Concentracaoidealatributos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="concentracaoidealatributo.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.concentracaoidealatributo.home.createLabel">Create new Concentracaoidealatributo</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.concentracaoidealatributo.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorconcentracaoatributo"><span data-translate="netWordAgroApp.concentracaoidealatributo.valorconcentracaoatributo">Valorconcentracaoatributo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="referencia"><span data-translate="netWordAgroApp.concentracaoidealatributo.referencia">Referencia</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cultura.nomecultura"><span data-translate="netWordAgroApp.concentracaoidealatributo.cultura">Cultura</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="atributo.nomeatributo"><span data-translate="netWordAgroApp.concentracaoidealatributo.atributo">Atributo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cidade.nomecidade"><span data-translate="netWordAgroApp.concentracaoidealatributo.cidade">Cidade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="propriedade.nomepropriedade"><span data-translate="netWordAgroApp.concentracaoidealatributo.propriedade">Propriedade</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="concentracaoidealatributo in vm.concentracaoidealatributos track by concentracaoidealatributo.id"><td><a ui-sref="concentracaoidealatributo-detail({id:concentracaoidealatributo.id})">{{concentracaoidealatributo.id}}</a></td><td>{{concentracaoidealatributo.valorconcentracaoatributo}}</td><td data-translate="{{\'netWordAgroApp.Tiporeferenciaatributo.\' + concentracaoidealatributo.referencia}}">{{concentracaoidealatributo.referencia}}</td><td><a ui-sref="cultura-detail({id:concentracaoidealatributo.cultura.id})">{{concentracaoidealatributo.cultura.nomecultura}}</a></td><td><a ui-sref="atributo-detail({id:concentracaoidealatributo.atributo.id})">{{concentracaoidealatributo.atributo.nomeatributo}}</a></td><td><a ui-sref="cidade-detail({id:concentracaoidealatributo.cidade.id})">{{concentracaoidealatributo.cidade.nomecidade}}</a></td><td><a ui-sref="propriedade-detail({id:concentracaoidealatributo.propriedade.id})">{{concentracaoidealatributo.propriedade.nomepropriedade}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="concentracaoidealatributo-detail({id:concentracaoidealatributo.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="concentracaoidealatributo.edit({id:concentracaoidealatributo.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="concentracaoidealatributo.delete({id:concentracaoidealatributo.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/concentracaoindice/concentracaoindice-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.concentracaoindice.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.concentracaoindice.delete.question" translate-values="{id: \'{{vm.concentracaoindice.id}}\'}">Are you sure you want to delete this Concentracaoindice?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/concentracaoindice/concentracaoindice-detail.html','<div><h2><span data-translate="netWordAgroApp.concentracaoindice.detail.title">Concentracaoindice</span> {{vm.concentracaoindice.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.concentracaoindice.nome">Nome</span></dt><dd><span>{{vm.concentracaoindice.nome}}</span></dd><dt><span data-translate="netWordAgroApp.concentracaoindice.data">Data</span></dt><dd><span>{{vm.concentracaoindice.data | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.concentracaoindice.latitude">Latitude</span></dt><dd><span>{{vm.concentracaoindice.latitude}}</span></dd><dt><span data-translate="netWordAgroApp.concentracaoindice.longitude">Longitude</span></dt><dd><span>{{vm.concentracaoindice.longitude}}</span></dd><dt><span data-translate="netWordAgroApp.concentracaoindice.indice">Indice</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipoindice.\' + vm.concentracaoindice.indice}}">{{vm.concentracaoindice.indice}}</span></dd><dt><span data-translate="netWordAgroApp.concentracaoindice.valorindice">Valorindice</span></dt><dd><span>{{vm.concentracaoindice.valorindice}}</span></dd><dt><span data-translate="netWordAgroApp.concentracaoindice.atributo">Atributo</span></dt><dd><a ui-sref="atributo-detail({id:vm.concentracaoindice.atributo.id})">{{vm.concentracaoindice.atributo.nomeatributo}}</a></dd><dt><span data-translate="netWordAgroApp.concentracaoindice.corratribce">Corratribce</span></dt><dd><a ui-sref="corratribce-detail({id:vm.concentracaoindice.corratribce.id})">{{vm.concentracaoindice.corratribce.vlrconcentracao}}</a></dd><dt><span data-translate="netWordAgroApp.concentracaoindice.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.concentracaoindice.safra.id})">{{vm.concentracaoindice.safra.nomesafra}}</a></dd><dt><span data-translate="netWordAgroApp.concentracaoindice.propriedade">Propriedade</span></dt><dd><a ui-sref="propriedade-detail({id:vm.concentracaoindice.propriedade.id})">{{vm.concentracaoindice.propriedade.nomepropriedade}}</a></dd><dt><span data-translate="netWordAgroApp.concentracaoindice.mapaimagem">Mapaimagem</span></dt><dd><a ui-sref="mapaimagem-detail({id:vm.concentracaoindice.mapaimagem.id})">{{vm.concentracaoindice.mapaimagem.nomemapa}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="concentracaoindice-detail.edit({id:vm.concentracaoindice.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/concentracaoindice/concentracaoindice-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myConcentracaoindiceLabel" data-translate="netWordAgroApp.concentracaoindice.home.createOrEditLabel">Create or edit a Concentracaoindice</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.concentracaoindice.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.concentracaoindice.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.concentracaoindice.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.concentracaoindice.nome" required><div ng-show="editForm.nome.$invalid"><p class="help-block" ng-show="editForm.nome.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.concentracaoindice.data" for="field_data">Data</label><div class="input-group"><input id="field_data" type="text" class="form-control" name="data" uib-datepicker-popup="{{dateformat}}" ng-model="vm.concentracaoindice.data" is-open="vm.datePickerOpenStatus.data" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'data\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.data.$invalid"><p class="help-block" ng-show="editForm.data.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.concentracaoindice.latitude" for="field_latitude">Latitude</label><input type="text" class="form-control" name="latitude" id="field_latitude" ng-model="vm.concentracaoindice.latitude" required><div ng-show="editForm.latitude.$invalid"><p class="help-block" ng-show="editForm.latitude.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.concentracaoindice.longitude" for="field_longitude">Longitude</label><input type="text" class="form-control" name="longitude" id="field_longitude" ng-model="vm.concentracaoindice.longitude"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.concentracaoindice.indice" for="field_indice">Indice</label><select class="form-control" name="indice" ng-model="vm.concentracaoindice.indice" id="field_indice" required><option value="GLI" data-translate="netWordAgroApp.Tipoindice.GLI">GLI</option><option value="NDVI" data-translate="netWordAgroApp.Tipoindice.NDVI">NDVI</option><option value="RDVI" data-translate="netWordAgroApp.Tipoindice.RDVI">RDVI</option><option value="SAVI" data-translate="netWordAgroApp.Tipoindice.SAVI">SAVI</option><option value="GOSAVI" data-translate="netWordAgroApp.Tipoindice.GOSAVI">GOSAVI</option><option value="MNLI" data-translate="netWordAgroApp.Tipoindice.MNLI">MNLI</option></select><div ng-show="editForm.indice.$invalid"><p class="help-block" ng-show="editForm.indice.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.concentracaoindice.valorindice" for="field_valorindice">Valorindice</label><input type="number" class="form-control" name="valorindice" id="field_valorindice" ng-model="vm.concentracaoindice.valorindice" required><div ng-show="editForm.valorindice.$invalid"><p class="help-block" ng-show="editForm.valorindice.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.valorindice.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.concentracaoindice.atributo" for="field_atributo">Atributo</label><select class="form-control" id="field_atributo" name="atributo" ng-model="vm.concentracaoindice.atributo" ng-options="atributo as atributo.nomeatributo for atributo in vm.atributos track by atributo.id" required></select></div><div ng-show="editForm.atributo.$invalid"><p class="help-block" ng-show="editForm.atributo.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.concentracaoindice.corratribce" for="field_corratribce">Corratribce</label><select class="form-control" id="field_corratribce" name="corratribce" ng-model="vm.concentracaoindice.corratribce" ng-options="corratribce as corratribce.vlrconcentracao for corratribce in vm.corratribces track by corratribce.id" required></select></div><div ng-show="editForm.corratribce.$invalid"><p class="help-block" ng-show="editForm.corratribce.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.concentracaoindice.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.concentracaoindice.safra" ng-options="safra as safra.nomesafra for safra in vm.safras track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.concentracaoindice.propriedade" for="field_propriedade">Propriedade</label><select class="form-control" id="field_propriedade" name="propriedade" ng-model="vm.concentracaoindice.propriedade" ng-options="propriedade as propriedade.nomepropriedade for propriedade in vm.propriedades track by propriedade.id" required></select></div><div ng-show="editForm.propriedade.$invalid"><p class="help-block" ng-show="editForm.propriedade.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.concentracaoindice.mapaimagem" for="field_mapaimagem">Mapaimagem</label><select class="form-control" id="field_mapaimagem" name="mapaimagem" ng-model="vm.concentracaoindice.mapaimagem" ng-options="mapaimagem as mapaimagem.nomemapa for mapaimagem in vm.mapaimagems track by mapaimagem.id" required></select></div><div ng-show="editForm.mapaimagem.$invalid"><p class="help-block" ng-show="editForm.mapaimagem.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/concentracaoindice/concentracaoindices.html','<div><h2 data-translate="netWordAgroApp.concentracaoindice.home.title">Concentracaoindices</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="concentracaoindice.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.concentracaoindice.home.createLabel">Create new Concentracaoindice</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.concentracaoindice.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.concentracaoindice.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="data"><span data-translate="netWordAgroApp.concentracaoindice.data">Data</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="latitude"><span data-translate="netWordAgroApp.concentracaoindice.latitude">Latitude</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="longitude"><span data-translate="netWordAgroApp.concentracaoindice.longitude">Longitude</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="indice"><span data-translate="netWordAgroApp.concentracaoindice.indice">Indice</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorindice"><span data-translate="netWordAgroApp.concentracaoindice.valorindice">Valorindice</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="atributo.nomeatributo"><span data-translate="netWordAgroApp.concentracaoindice.atributo">Atributo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="corratribce.vlrconcentracao"><span data-translate="netWordAgroApp.concentracaoindice.corratribce">Corratribce</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="safra.nomesafra"><span data-translate="netWordAgroApp.concentracaoindice.safra">Safra</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="propriedade.nomepropriedade"><span data-translate="netWordAgroApp.concentracaoindice.propriedade">Propriedade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="mapaimagem.nomemapa"><span data-translate="netWordAgroApp.concentracaoindice.mapaimagem">Mapaimagem</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="concentracaoindice in vm.concentracaoindices track by concentracaoindice.id"><td><a ui-sref="concentracaoindice-detail({id:concentracaoindice.id})">{{concentracaoindice.id}}</a></td><td>{{concentracaoindice.nome}}</td><td>{{concentracaoindice.data | date:\'mediumDate\'}}</td><td>{{concentracaoindice.latitude}}</td><td>{{concentracaoindice.longitude}}</td><td data-translate="{{\'netWordAgroApp.Tipoindice.\' + concentracaoindice.indice}}">{{concentracaoindice.indice}}</td><td>{{concentracaoindice.valorindice}}</td><td><a ui-sref="atributo-detail({id:concentracaoindice.atributo.id})">{{concentracaoindice.atributo.nomeatributo}}</a></td><td><a ui-sref="corratribce-detail({id:concentracaoindice.corratribce.id})">{{concentracaoindice.corratribce.vlrconcentracao}}</a></td><td><a ui-sref="safra-detail({id:concentracaoindice.safra.id})">{{concentracaoindice.safra.nomesafra}}</a></td><td><a ui-sref="propriedade-detail({id:concentracaoindice.propriedade.id})">{{concentracaoindice.propriedade.nomepropriedade}}</a></td><td><a ui-sref="mapaimagem-detail({id:concentracaoindice.mapaimagem.id})">{{concentracaoindice.mapaimagem.nomemapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="concentracaoindice-detail({id:concentracaoindice.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="concentracaoindice.edit({id:concentracaoindice.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="concentracaoindice.delete({id:concentracaoindice.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/configuracaomapacalor/configuracaomapacalor-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.configuracaomapacalor.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.configuracaomapacalor.delete.question" translate-values="{id: \'{{vm.configuracaomapacalor.id}}\'}">Are you sure you want to delete this Configuracaomapacalor?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/configuracaomapacalor/configuracaomapacalor-detail.html','<div><h2><span data-translate="netWordAgroApp.configuracaomapacalor.detail.title">Configuracaomapacalor</span> {{vm.configuracaomapacalor.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.configuracaomapacalor.pouco">Pouco</span></dt><dd><span>{{vm.configuracaomapacalor.pouco}}</span></dd><dt><span data-translate="netWordAgroApp.configuracaomapacalor.muito">Muito</span></dt><dd><span>{{vm.configuracaomapacalor.muito}}</span></dd><dt><span data-translate="netWordAgroApp.configuracaomapacalor.tipomapa">Tipomapa</span></dt><dd><span>{{vm.configuracaomapacalor.tipomapa}}</span></dd><dt><span data-translate="netWordAgroApp.configuracaomapacalor.cultura">Cultura</span></dt><dd><a ui-sref="cultura-detail({id:vm.configuracaomapacalor.cultura.id})">{{vm.configuracaomapacalor.cultura.nomecultura}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="configuracaomapacalor-detail.edit({id:vm.configuracaomapacalor.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/configuracaomapacalor/configuracaomapacalor-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myConfiguracaomapacalorLabel" data-translate="netWordAgroApp.configuracaomapacalor.home.createOrEditLabel">Create or edit a Configuracaomapacalor</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.configuracaomapacalor.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.configuracaomapacalor.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.configuracaomapacalor.pouco" for="field_pouco">Pouco</label><input type="number" class="form-control" name="pouco" id="field_pouco" ng-model="vm.configuracaomapacalor.pouco" required><div ng-show="editForm.pouco.$invalid"><p class="help-block" ng-show="editForm.pouco.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.pouco.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.configuracaomapacalor.muito" for="field_muito">Muito</label><input type="number" class="form-control" name="muito" id="field_muito" ng-model="vm.configuracaomapacalor.muito" required><div ng-show="editForm.muito.$invalid"><p class="help-block" ng-show="editForm.muito.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.muito.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><!--        <div class="form-group">\n            <label class="control-label" data-translate="netWordAgroApp.configuracaomapacalor.tipomapa" for="field_tipomapa">Tipomapa</label>\n            <input type="text" class="form-control" name="tipomapa" id="field_tipomapa"\n                    ng-model="vm.configuracaomapacalor.tipomapa"\n                    required/>\n            <div ng-show="editForm.tipomapa.$invalid">\n                <p class="help-block"\n                    ng-show="editForm.tipomapa.$error.required" data-translate="entity.validation.required">\n                    This field is required.\n                </p>\n            </div>\n        </div>\n--><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.configuracaomapacalor.tipomapa" for="field_tipomapa">Tipomapa</label><select class="form-control" name="tipomapa" ng-model="vm.configuracaomapacalor.tipomapa" id="field_tipomapa"><option value="null"></option><option value="percevejo" data-translate="netWordAgroApp.Tipomapa.percevejo">percevejo</option><option value="ferrugem" data-translate="netWordAgroApp.Tipomapa.ferrugem">ferrugem</option><option value="lagarta" data-translate="netWordAgroApp.Tipomapa.lagarta">lagarta</option><option value="manchaalvo" data-translate="netWordAgroApp.Tipomapa.manchaalvo">manchaalvo</option><!--<option value="nutricional" data-translate="netWordAgroApp.Tipomapa.nutricional">nutricional</option>\n\n            <option value="saude" data-translate="netWordAgroApp.Tipomapa.saude">saude</option>\n            <option value="plantio" data-translate="netWordAgroApp.Tipomapa.plantio">plantio</option>\n            <option value="umidade" data-translate="netWordAgroApp.Tipomapa.umidade">umidade</option>--><option value="ervadaninha" data-translate="netWordAgroApp.Tipomapa.ervadaninha">ervadaninha</option><option value="pulgao" data-translate="netWordAgroApp.Tipomapa.pulgao">pulgao</option><option value="helmintosporiose" data-translate="netWordAgroApp.Tipomapa.helmintosporiose">helmintosporiose</option><option value="oidio" data-translate="netWordAgroApp.Tipomapa.oidio">oidio</option><option value="doenca" data-translate="netWordAgroApp.Tipomapa.doenca">doenca</option><option value="plantadaninhacana" data-translate="netWordAgroApp.Tipomapa.plantadaninhacana">plantadaninhacana</option><option value="praga" data-translate="netWordAgroApp.Tipomapa.praga">praga</option><option value="amargoso" data-translate="netWordAgroApp.Tipomapa.amargoso">amargoso</option><option value="buva" data-translate="netWordAgroApp.Tipomapa.buva">buva</option><option value="falhaplantio" data-translate="netWordAgroApp.Tipomapa.falhaplantio">falhaplantio</option><option value="milho" data-translate="netWordAgroApp.Tipomapa.milho">milho</option><option value="folhalarga" data-translate="netWordAgroApp.Tipomapa.folhalarga">folhalarga</option><option value="folhaestreita" data-translate="netWordAgroApp.Tipomapa.folhaestreita">folhaestreita</option><option value="bicudo" data-translate="netWordAgroApp.Tipomapa.bicudo">bicudo</option><option value="cigarrinha" data-translate="netWordAgroApp.Tipomapa.cigarrinha">cigarrinha</option><option value="brocadacana" data-translate="netWordAgroApp.Tipomapa.broca">broca</option><option value="folhalargacana" data-translate="netWordAgroApp.Tipomapa.folhalargacana">folhalargacana</option><option value="folhaestreitacana" data-translate="netWordAgroApp.Tipomapa.folhaestreitacana">folhaestreitacana</option></select></div><div class="form-group"><label data-translate="netWordAgroApp.configuracaomapacalor.cultura" for="field_cultura">Cultura</label><select class="form-control" id="field_cultura" name="cultura" ng-model="vm.configuracaomapacalor.cultura" ng-options="cultura as cultura.nomecultura for cultura in vm.culturas track by cultura.id" required><option value="null"></option></select></div><div ng-show="editForm.cultura.$invalid"><p class="help-block" ng-show="editForm.cultura.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/configuracaomapacalor/configuracaomapacalors.html','<div><h2 data-translate="netWordAgroApp.configuracaomapacalor.home.title">Configuracaomapacalors</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="configuracaomapacalor.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.configuracaomapacalor.home.createLabel">Create new Configuracaomapacalor</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.configuracaomapacalor.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pouco"><span data-translate="netWordAgroApp.configuracaomapacalor.pouco">Pouco</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="muito"><span data-translate="netWordAgroApp.configuracaomapacalor.muito">Muito</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipomapa"><span data-translate="netWordAgroApp.configuracaomapacalor.tipomapa">Tipomapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cultura.nomecultura"><span data-translate="netWordAgroApp.configuracaomapacalor.cultura">Cultura</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="configuracaomapacalor in vm.configuracaomapacalors track by configuracaomapacalor.id"><td><a ui-sref="configuracaomapacalor-detail({id:configuracaomapacalor.id})">{{configuracaomapacalor.id}}</a></td><td>{{configuracaomapacalor.pouco}}</td><td>{{configuracaomapacalor.muito}}</td><td>{{configuracaomapacalor.tipomapa}}</td><td><a ui-sref="cultura-detail({id:configuracaomapacalor.cultura.id})">{{configuracaomapacalor.cultura.nomecultura}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="configuracaomapacalor-detail({id:configuracaomapacalor.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="configuracaomapacalor.edit({id:configuracaomapacalor.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="configuracaomapacalor.delete({id:configuracaomapacalor.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/controleaplicacao/controleaplicacao-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.controleaplicacao.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.controleaplicacao.delete.question" translate-values="{id: \'{{vm.controleaplicacao.id}}\'}">Are you sure you want to delete this Controleaplicacao?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/controleaplicacao/controleaplicacao-detail.html','<div><h2><span data-translate="netWordAgroApp.controleaplicacao.detail.title">Controleaplicacao</span> {{vm.controleaplicacao.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.controleaplicacao.data">Data</span></dt><dd><span>{{vm.controleaplicacao.data | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.controleaplicacao.tipoaplicacao">Tipoaplicacao</span></dt><dd><span>{{vm.controleaplicacao.tipoaplicacao}}</span></dd><dt><span data-translate="netWordAgroApp.controleaplicacao.produto">Produto</span></dt><dd><span>{{vm.controleaplicacao.produto}}</span></dd><dt><span data-translate="netWordAgroApp.controleaplicacao.quantidadeproduto">Quantidadeproduto</span></dt><dd><span>{{vm.controleaplicacao.quantidadeproduto}}</span></dd><dt><span data-translate="netWordAgroApp.controleaplicacao.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.controleaplicacao.safra.id})">{{vm.controleaplicacao.safra.nomesafra}}</a></dd><dt><span data-translate="netWordAgroApp.controleaplicacao.propriedade">Propriedade</span></dt><dd><a ui-sref="propriedade-detail({id:vm.controleaplicacao.propriedade.id})">{{vm.controleaplicacao.propriedade.nomepropriedade}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="controleaplicacao-detail.edit({id:vm.controleaplicacao.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/controleaplicacao/controleaplicacao-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myControleaplicacaoLabel" data-translate="netWordAgroApp.controleaplicacao.home.createOrEditLabel">Create or edit a Controleaplicacao</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.controleaplicacao.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.controleaplicacao.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.controleaplicacao.data" for="field_data">Data</label><div class="input-group"><input id="field_data" type="text" class="form-control" name="data" uib-datepicker-popup="{{dateformat}}" ng-model="vm.controleaplicacao.data" is-open="vm.datePickerOpenStatus.data"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'data\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.controleaplicacao.tipoaplicacao" for="field_tipoaplicacao">Tipoaplicacao</label><input type="text" class="form-control" name="tipoaplicacao" id="field_tipoaplicacao" ng-model="vm.controleaplicacao.tipoaplicacao"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.controleaplicacao.produto" for="field_produto">Produto</label><input type="text" class="form-control" name="produto" id="field_produto" ng-model="vm.controleaplicacao.produto"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.controleaplicacao.quantidadeproduto" for="field_quantidadeproduto">Quantidadeproduto</label><input type="text" class="form-control" name="quantidadeproduto" id="field_quantidadeproduto" ng-model="vm.controleaplicacao.quantidadeproduto"></div><div class="form-group"><label data-translate="netWordAgroApp.controleaplicacao.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.controleaplicacao.safra" ng-options="safra as safra.nomesafra for safra in vm.safras track by safra.id"><option value=""></option></select></div><div class="form-group"><label data-translate="netWordAgroApp.controleaplicacao.propriedade" for="field_propriedade">Propriedade</label><select class="form-control" id="field_propriedade" name="propriedade" ng-model="vm.controleaplicacao.propriedade" ng-options="propriedade as propriedade.nomepropriedade for propriedade in vm.propriedades track by propriedade.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/controleaplicacao/controleaplicacaos.html','<div><h2 data-translate="netWordAgroApp.controleaplicacao.home.title">Controleaplicacaos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="controleaplicacao.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.controleaplicacao.home.createLabel">Create new Controleaplicacao</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.controleaplicacao.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="data"><span data-translate="netWordAgroApp.controleaplicacao.data">Data</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipoaplicacao"><span data-translate="netWordAgroApp.controleaplicacao.tipoaplicacao">Tipoaplicacao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="produto"><span data-translate="netWordAgroApp.controleaplicacao.produto">Produto</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quantidadeproduto"><span data-translate="netWordAgroApp.controleaplicacao.quantidadeproduto">Quantidadeproduto</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="safra.nomesafra"><span data-translate="netWordAgroApp.controleaplicacao.safra">Safra</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="propriedade.nomepropriedade"><span data-translate="netWordAgroApp.controleaplicacao.propriedade">Propriedade</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="controleaplicacao in vm.controleaplicacaos track by controleaplicacao.id"><td><a ui-sref="controleaplicacao-detail({id:controleaplicacao.id})">{{controleaplicacao.id}}</a></td><td>{{controleaplicacao.data | date:\'mediumDate\'}}</td><td>{{controleaplicacao.tipoaplicacao}}</td><td>{{controleaplicacao.produto}}</td><td>{{controleaplicacao.quantidadeproduto}}</td><td><a ui-sref="safra-detail({id:controleaplicacao.safra.id})">{{controleaplicacao.safra.nomesafra}}</a></td><td><a ui-sref="propriedade-detail({id:controleaplicacao.propriedade.id})">{{controleaplicacao.propriedade.nomepropriedade}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="controleaplicacao-detail({id:controleaplicacao.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="controleaplicacao.edit({id:controleaplicacao.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="controleaplicacao.delete({id:controleaplicacao.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/controlepropagandas/controlepropagandas-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.controlepropagandas.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.controlepropagandas.delete.question" translate-values="{id: \'{{vm.controlepropagandas.id}}\'}">Are you sure you want to delete this Controlepropagandas?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/controlepropagandas/controlepropagandas-detail.html','<div><h2><span data-translate="netWordAgroApp.controlepropagandas.detail.title">Controlepropagandas</span> {{vm.controlepropagandas.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.controlepropagandas.idbanner">Idbanner</span></dt><dd><span>{{vm.controlepropagandas.idbanner}}</span></dd><dt><span data-translate="netWordAgroApp.controlepropagandas.linkacessado">Linkacessado</span></dt><dd><span>{{vm.controlepropagandas.linkacessado}}</span></dd><dt><span data-translate="netWordAgroApp.controlepropagandas.horario">Horario</span></dt><dd><span>{{vm.controlepropagandas.horario | date:\'medium\'}}</span></dd><dt><span data-translate="netWordAgroApp.controlepropagandas.usuario">Usuario</span></dt><dd><span>{{vm.controlepropagandas.usuario}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="controlepropagandas-detail.edit({id:vm.controlepropagandas.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/controlepropagandas/controlepropagandas-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myControlepropagandasLabel" data-translate="netWordAgroApp.controlepropagandas.home.createOrEditLabel">Create or edit a Controlepropagandas</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.controlepropagandas.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.controlepropagandas.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.controlepropagandas.idbanner" for="field_idbanner">Idbanner</label><input type="number" class="form-control" name="idbanner" id="field_idbanner" ng-model="vm.controlepropagandas.idbanner"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.controlepropagandas.linkacessado" for="field_linkacessado">Linkacessado</label><input type="text" class="form-control" name="linkacessado" id="field_linkacessado" ng-model="vm.controlepropagandas.linkacessado"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.controlepropagandas.horario" for="field_horario">Horario</label><div class="input-group"><input id="field_horario" type="text" class="form-control" name="horario" datetime-picker="{{dateformat}}" ng-model="vm.controlepropagandas.horario" is-open="vm.datePickerOpenStatus.horario"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'horario\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.controlepropagandas.usuario" for="field_usuario">Usuario</label><input type="text" class="form-control" name="usuario" id="field_usuario" ng-model="vm.controlepropagandas.usuario"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/controlepropagandas/controlepropagandas.html','<div><h2 data-translate="netWordAgroApp.controlepropagandas.home.title">Controlepropagandas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="controlepropagandas.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.controlepropagandas.home.createLabel">Create new Controlepropagandas</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.controlepropagandas.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="idbanner"><span data-translate="netWordAgroApp.controlepropagandas.idbanner">Idbanner</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="linkacessado"><span data-translate="netWordAgroApp.controlepropagandas.linkacessado">Linkacessado</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="horario"><span data-translate="netWordAgroApp.controlepropagandas.horario">Horario</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="usuario"><span data-translate="netWordAgroApp.controlepropagandas.usuario">Usuario</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="controlepropagandas in vm.controlepropagandas track by controlepropagandas.id"><td><a ui-sref="controlepropagandas-detail({id:controlepropagandas.id})">{{controlepropagandas.id}}</a></td><td>{{controlepropagandas.idbanner}}</td><td>{{controlepropagandas.linkacessado}}</td><td>{{controlepropagandas.horario | date:\'medium\'}}</td><td>{{controlepropagandas.usuario}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="controlepropagandas-detail({id:controlepropagandas.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="controlepropagandas.edit({id:controlepropagandas.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="controlepropagandas.delete({id:controlepropagandas.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/cooperativa/cooperativa-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.cooperativa.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.cooperativa.delete.question" translate-values="{id: \'{{vm.cooperativa.id}}\'}">Are you sure you want to delete this Cooperativa?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/cooperativa/cooperativa-detail.html','<div><h2><span data-translate="netWordAgroApp.cooperativa.detail.title">Cooperativa</span> {{vm.cooperativa.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.cooperativa.nome">Nome</span></dt><dd><span>{{vm.cooperativa.nome}}</span></dd><dt><span data-translate="netWordAgroApp.cooperativa.cnpj">Cnpj</span></dt><dd><span>{{vm.cooperativa.cnpj}}</span></dd><dt><span data-translate="netWordAgroApp.cooperativa.nomeresponsavel">Nomeresponsavel</span></dt><dd><span>{{vm.cooperativa.nomeresponsavel}}</span></dd><dt><span data-translate="netWordAgroApp.cooperativa.telefoneresponsavel">Telefoneresponsavel</span></dt><dd><span>{{vm.cooperativa.telefoneresponsavel}}</span></dd><dt><span data-translate="netWordAgroApp.cooperativa.emailresponsavel">Emailresponsavel</span></dt><dd><span>{{vm.cooperativa.emailresponsavel}}</span></dd><dt><span data-translate="netWordAgroApp.cooperativa.logotipo">Logotipo</span></dt><dd><div ng-if="vm.cooperativa.logotipo"><a ng-click="vm.openFile(vm.cooperativa.logotipoContentType, vm.cooperativa.logotipo)"><img data-ng-src="{{\'data:\' + vm.cooperativa.logotipoContentType + \';base64,\' + vm.cooperativa.logotipo}}" style="max-width: 100%" alt="cooperativa image"> </a>{{vm.cooperativa.logotipoContentType}}, {{vm.byteSize(vm.cooperativa.logotipo)}}</div></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="cooperativa-detail.edit({id:vm.cooperativa.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/cooperativa/cooperativa-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCooperativaLabel" data-translate="netWordAgroApp.cooperativa.home.createOrEditLabel">Create or edit a Cooperativa</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.cooperativa.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.cooperativa.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.cooperativa.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.cooperativa.nome" required><div ng-show="editForm.nome.$invalid"><p class="help-block" ng-show="editForm.nome.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.cooperativa.cnpj" for="field_cnpj">Cnpj</label><input type="text" class="form-control" name="cnpj" id="field_cnpj" ng-model="vm.cooperativa.cnpj" required><div ng-show="editForm.cnpj.$invalid"><p class="help-block" ng-show="editForm.cnpj.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.cooperativa.nomeresponsavel" for="field_nomeresponsavel">Nomeresponsavel</label><input type="text" class="form-control" name="nomeresponsavel" id="field_nomeresponsavel" ng-model="vm.cooperativa.nomeresponsavel" required><div ng-show="editForm.nomeresponsavel.$invalid"><p class="help-block" ng-show="editForm.nomeresponsavel.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.cooperativa.telefoneresponsavel" for="field_telefoneresponsavel">Telefoneresponsavel</label><input type="text" class="form-control" name="telefoneresponsavel" id="field_telefoneresponsavel" ng-model="vm.cooperativa.telefoneresponsavel"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.cooperativa.emailresponsavel" for="field_emailresponsavel">Emailresponsavel</label><input type="text" class="form-control" name="emailresponsavel" id="field_emailresponsavel" ng-model="vm.cooperativa.emailresponsavel"></div><div class="form-group" ngf-drop ngf-change="vm.setLogotipo($file, vm.cooperativa)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="netWordAgroApp.cooperativa.logotipo" for="field_logotipo">Logotipo</label><div><img data-ng-src="{{\'data:\' + vm.cooperativa.logotipoContentType + \';base64,\' + vm.cooperativa.logotipo}}" style="max-height: 100px" ng-if="vm.cooperativa.logotipo" alt="cooperativa image"><div ng-if="vm.cooperativa.logotipo" class="help-block clearfix"><span class="pull-left">{{vm.cooperativa.logotipoContentType}}, {{vm.byteSize(vm.cooperativa.logotipo)}}</span> <button type="button" ng-click="vm.cooperativa.logotipo=null;vm.cooperativa.logotipoContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setLogotipo($file, vm.cooperativa)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="logotipo" id="field_logotipo" ng-model="vm.cooperativa.logotipo"> <input type="hidden" class="form-control" name="logotipoContentType" id="field_logotipoContentType" ng-model="vm.cooperativa.logotipoContentType"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/cooperativa/cooperativas.html','<div><h2 data-translate="netWordAgroApp.cooperativa.home.title">Cooperativas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="cooperativa.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.cooperativa.home.createLabel">Create new Cooperativa</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.cooperativa.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.cooperativa.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cnpj"><span data-translate="netWordAgroApp.cooperativa.cnpj">Cnpj</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomeresponsavel"><span data-translate="netWordAgroApp.cooperativa.nomeresponsavel">Nomeresponsavel</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="telefoneresponsavel"><span data-translate="netWordAgroApp.cooperativa.telefoneresponsavel">Telefoneresponsavel</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="emailresponsavel"><span data-translate="netWordAgroApp.cooperativa.emailresponsavel">Emailresponsavel</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="logotipo"><span data-translate="netWordAgroApp.cooperativa.logotipo">Logotipo</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="cooperativa in vm.cooperativas track by cooperativa.id"><td><a ui-sref="cooperativa-detail({id:cooperativa.id})">{{cooperativa.id}}</a></td><td>{{cooperativa.nome}}</td><td>{{cooperativa.cnpj}}</td><td>{{cooperativa.nomeresponsavel}}</td><td>{{cooperativa.telefoneresponsavel}}</td><td>{{cooperativa.emailresponsavel}}</td><td><a ng-if="cooperativa.logotipo" ng-click="vm.openFile(cooperativa.logotipoContentType, cooperativa.logotipo)"><img data-ng-src="{{\'data:\' + cooperativa.logotipoContentType + \';base64,\' + cooperativa.logotipo}}" style="max-height: 30px" alt="cooperativa image"> </a><span ng-if="cooperativa.logotipo">{{cooperativa.logotipoContentType}}, {{vm.byteSize(cooperativa.logotipo)}}</span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="cooperativa-detail({id:cooperativa.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="cooperativa.edit({id:cooperativa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="cooperativa.delete({id:cooperativa.id})" class="btn btn-danger btn-sm" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/corratribce/corratribce-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.corratribce.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.corratribce.delete.question" translate-values="{id: \'{{vm.corratribce.id}}\'}">Are you sure you want to delete this Corratribce?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/corratribce/corratribce-detail.html','<div><h2><span data-translate="netWordAgroApp.corratribce.detail.title">Corratribce</span> {{vm.corratribce.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.corratribce.freqcorr">Freqcorr</span></dt><dd><span>{{vm.corratribce.freqcorr}}</span></dd><dt><span data-translate="netWordAgroApp.corratribce.condcorr">Condcorr</span></dt><dd><span>{{vm.corratribce.condcorr}}</span></dd><dt><span data-translate="netWordAgroApp.corratribce.tempCorr">Temp Corr</span></dt><dd><span>{{vm.corratribce.tempCorr}}</span></dd><dt><span data-translate="netWordAgroApp.corratribce.umidcorr">Umidcorr</span></dt><dd><span>{{vm.corratribce.umidcorr}}</span></dd><dt><span data-translate="netWordAgroApp.corratribce.vlrconcentracao">Vlrconcentracao</span></dt><dd><span>{{vm.corratribce.vlrconcentracao}}</span></dd><dt><span data-translate="netWordAgroApp.corratribce.atributo">Atributo</span></dt><dd><a ui-sref="atributo-detail({id:vm.corratribce.atributo.id})">{{vm.corratribce.atributo.nomeatributo}}</a></dd><dt><span data-translate="netWordAgroApp.corratribce.cultura">Cultura</span></dt><dd><a ui-sref="cultura-detail({id:vm.corratribce.cultura.id})">{{vm.corratribce.cultura.nomecultura}}</a></dd><dt><span data-translate="netWordAgroApp.corratribce.solo">Solo</span></dt><dd><a ui-sref="solo-detail({id:vm.corratribce.solo.id})">{{vm.corratribce.solo.nomesolo}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="corratribce-detail.edit({id:vm.corratribce.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/corratribce/corratribce-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCorratribceLabel" data-translate="netWordAgroApp.corratribce.home.createOrEditLabel">Create or edit a Corratribce</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.corratribce.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.corratribce.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.corratribce.freqcorr" for="field_freqcorr">Freqcorr</label><input type="number" class="form-control" name="freqcorr" id="field_freqcorr" ng-model="vm.corratribce.freqcorr" required><div ng-show="editForm.freqcorr.$invalid"><p class="help-block" ng-show="editForm.freqcorr.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.freqcorr.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.corratribce.condcorr" for="field_condcorr">Condcorr</label><input type="number" class="form-control" name="condcorr" id="field_condcorr" ng-model="vm.corratribce.condcorr" required><div ng-show="editForm.condcorr.$invalid"><p class="help-block" ng-show="editForm.condcorr.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.condcorr.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.corratribce.tempCorr" for="field_tempCorr">Temp Corr</label><input type="number" class="form-control" name="tempCorr" id="field_tempCorr" ng-model="vm.corratribce.tempCorr" required><div ng-show="editForm.tempCorr.$invalid"><p class="help-block" ng-show="editForm.tempCorr.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.tempCorr.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.corratribce.umidcorr" for="field_umidcorr">Umidcorr</label><input type="number" class="form-control" name="umidcorr" id="field_umidcorr" ng-model="vm.corratribce.umidcorr" required><div ng-show="editForm.umidcorr.$invalid"><p class="help-block" ng-show="editForm.umidcorr.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.umidcorr.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.corratribce.vlrconcentracao" for="field_vlrconcentracao">Vlrconcentracao</label><input type="number" class="form-control" name="vlrconcentracao" id="field_vlrconcentracao" ng-model="vm.corratribce.vlrconcentracao" required><div ng-show="editForm.vlrconcentracao.$invalid"><p class="help-block" ng-show="editForm.vlrconcentracao.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.vlrconcentracao.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.corratribce.atributo" for="field_atributo">Atributo</label><select class="form-control" id="field_atributo" name="atributo" ng-model="vm.corratribce.atributo" ng-options="atributo as atributo.nomeatributo for atributo in vm.atributos track by atributo.id" required></select></div><div ng-show="editForm.atributo.$invalid"><p class="help-block" ng-show="editForm.atributo.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.corratribce.cultura" for="field_cultura">Cultura</label><select class="form-control" id="field_cultura" name="cultura" ng-model="vm.corratribce.cultura" ng-options="cultura as cultura.nomecultura for cultura in vm.culturas track by cultura.id" required></select></div><div ng-show="editForm.cultura.$invalid"><p class="help-block" ng-show="editForm.cultura.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.corratribce.solo" for="field_solo">Solo</label><select class="form-control" id="field_solo" name="solo" ng-model="vm.corratribce.solo" ng-options="solo as solo.nomesolo for solo in vm.solos track by solo.id" required></select></div><div ng-show="editForm.solo.$invalid"><p class="help-block" ng-show="editForm.solo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/corratribce/corratribces.html','<div><h2 data-translate="netWordAgroApp.corratribce.home.title">Corratribces</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="corratribce.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.corratribce.home.createLabel">Create new Corratribce</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.corratribce.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="freqcorr"><span data-translate="netWordAgroApp.corratribce.freqcorr">Freqcorr</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="condcorr"><span data-translate="netWordAgroApp.corratribce.condcorr">Condcorr</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tempCorr"><span data-translate="netWordAgroApp.corratribce.tempCorr">Temp Corr</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="umidcorr"><span data-translate="netWordAgroApp.corratribce.umidcorr">Umidcorr</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="vlrconcentracao"><span data-translate="netWordAgroApp.corratribce.vlrconcentracao">Vlrconcentracao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="atributo.nomeatributo"><span data-translate="netWordAgroApp.corratribce.atributo">Atributo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cultura.nomecultura"><span data-translate="netWordAgroApp.corratribce.cultura">Cultura</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="solo.nomesolo"><span data-translate="netWordAgroApp.corratribce.solo">Solo</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="corratribce in vm.corratribces track by corratribce.id"><td><a ui-sref="corratribce-detail({id:corratribce.id})">{{corratribce.id}}</a></td><td>{{corratribce.freqcorr}}</td><td>{{corratribce.condcorr}}</td><td>{{corratribce.tempCorr}}</td><td>{{corratribce.umidcorr}}</td><td>{{corratribce.vlrconcentracao}}</td><td><a ui-sref="atributo-detail({id:corratribce.atributo.id})">{{corratribce.atributo.nomeatributo}}</a></td><td><a ui-sref="cultura-detail({id:corratribce.cultura.id})">{{corratribce.cultura.nomecultura}}</a></td><td><a ui-sref="solo-detail({id:corratribce.solo.id})">{{corratribce.solo.nomesolo}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="corratribce-detail({id:corratribce.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="corratribce.edit({id:corratribce.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="corratribce.delete({id:corratribce.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/cultura/cultura-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.cultura.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.cultura.delete.question" translate-values="{id: \'{{vm.cultura.id}}\'}">Are you sure you want to delete this Cultura?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/cultura/cultura-detail.html','<div><h2><span data-translate="netWordAgroApp.cultura.detail.title">Cultura</span> {{vm.cultura.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.cultura.nomecultura">Nomecultura</span></dt><dd><span>{{vm.cultura.nomecultura}}</span></dd><dt><span data-translate="netWordAgroApp.cultura.imagemcultura">Imagemcultura</span></dt><dd><div ng-if="vm.cultura.imagemcultura"><a ng-click="vm.openFile(vm.cultura.imagemculturaContentType, vm.cultura.imagemcultura)"><img data-ng-src="{{\'data:\' + vm.cultura.imagemculturaContentType + \';base64,\' + vm.cultura.imagemcultura}}" style="max-width: 100%" alt="cultura image"> </a>{{vm.cultura.imagemculturaContentType}}, {{vm.byteSize(vm.cultura.imagemcultura)}}</div></dd><dt><span data-translate="netWordAgroApp.cultura.produtividademinima">Produtividademinima</span></dt><dd><span>{{vm.cultura.produtividademinima}}</span></dd><dt><span data-translate="netWordAgroApp.cultura.produtividademedia">Produtividademedia</span></dt><dd><span>{{vm.cultura.produtividademedia}}</span></dd><dt><span data-translate="netWordAgroApp.cultura.produtividademaxima">Produtividademaxima</span></dt><dd><span>{{vm.cultura.produtividademaxima}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="cultura-detail.edit({id:vm.cultura.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/cultura/cultura-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCulturaLabel" data-translate="netWordAgroApp.cultura.home.createOrEditLabel">Create or edit a Cultura</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.cultura.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.cultura.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.cultura.nomecultura" for="field_nomecultura">Nomecultura</label><input type="text" class="form-control" name="nomecultura" id="field_nomecultura" ng-model="vm.cultura.nomecultura" required ng-maxlength="35"><div ng-show="editForm.nomecultura.$invalid"><p class="help-block" ng-show="editForm.nomecultura.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nomecultura.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="35">This field cannot be longer than 35 characters.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setImagemcultura($file, vm.cultura)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="netWordAgroApp.cultura.imagemcultura" for="field_imagemcultura">Imagemcultura</label><div><img data-ng-src="{{\'data:\' + vm.cultura.imagemculturaContentType + \';base64,\' + vm.cultura.imagemcultura}}" style="max-height: 100px" ng-if="vm.cultura.imagemcultura" alt="cultura image"><div ng-if="vm.cultura.imagemcultura" class="help-block clearfix"><span class="pull-left">{{vm.cultura.imagemculturaContentType}}, {{vm.byteSize(vm.cultura.imagemcultura)}}</span> <button type="button" ng-click="vm.cultura.imagemcultura=null;vm.cultura.imagemculturaContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setImagemcultura($file, vm.cultura)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="imagemcultura" id="field_imagemcultura" ng-model="vm.cultura.imagemcultura" required> <input type="hidden" class="form-control" name="imagemculturaContentType" id="field_imagemculturaContentType" ng-model="vm.cultura.imagemculturaContentType"><div ng-show="editForm.imagemcultura.$invalid"><p class="help-block" ng-show="editForm.imagemcultura.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.cultura.produtividademinima" for="field_produtividademinima">Produtividademinima</label><input type="number" class="form-control" name="produtividademinima" id="field_produtividademinima" ng-model="vm.cultura.produtividademinima" required><div ng-show="editForm.produtividademinima.$invalid"><p class="help-block" ng-show="editForm.produtividademinima.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.produtividademinima.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.cultura.produtividademedia" for="field_produtividademedia">Produtividademedia</label><input type="number" class="form-control" name="produtividademedia" id="field_produtividademedia" ng-model="vm.cultura.produtividademedia" required><div ng-show="editForm.produtividademedia.$invalid"><p class="help-block" ng-show="editForm.produtividademedia.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.produtividademedia.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.cultura.produtividademaxima" for="field_produtividademaxima">Produtividademaxima</label><input type="number" class="form-control" name="produtividademaxima" id="field_produtividademaxima" ng-model="vm.cultura.produtividademaxima" required><div ng-show="editForm.produtividademaxima.$invalid"><p class="help-block" ng-show="editForm.produtividademaxima.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.produtividademaxima.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/cultura/culturas.html','<div><h2 data-translate="netWordAgroApp.cultura.home.title">Culturas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="cultura.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.cultura.home.createLabel">Create new Cultura</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.cultura.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomecultura"><span data-translate="netWordAgroApp.cultura.nomecultura">Nomecultura</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="imagemcultura"><span data-translate="netWordAgroApp.cultura.imagemcultura">Imagemcultura</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="produtividademinima"><span data-translate="netWordAgroApp.cultura.produtividademinima">Produtividademinima</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="produtividademedia"><span data-translate="netWordAgroApp.cultura.produtividademedia">Produtividademedia</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="produtividademaxima"><span data-translate="netWordAgroApp.cultura.produtividademaxima">Produtividademaxima</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="cultura in vm.culturas track by cultura.id"><td><a ui-sref="cultura-detail({id:cultura.id})">{{cultura.id}}</a></td><td>{{cultura.nomecultura}}</td><td><a ng-if="cultura.imagemcultura" ng-click="vm.openFile(cultura.imagemculturaContentType, cultura.imagemcultura)"><img data-ng-src="{{\'data:\' + cultura.imagemculturaContentType + \';base64,\' + cultura.imagemcultura}}" style="max-height: 30px" alt="cultura image"> </a><span ng-if="cultura.imagemcultura">{{cultura.imagemculturaContentType}}, {{vm.byteSize(cultura.imagemcultura)}}</span></td><td>{{cultura.produtividademinima}}</td><td>{{cultura.produtividademedia}}</td><td>{{cultura.produtividademaxima}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="cultura-detail({id:cultura.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="cultura.edit({id:cultura.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="cultura.delete({id:cultura.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/custoshabituaisdefensivos/custoshabituaisdefensivos-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.custoshabituaisdefensivos.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.custoshabituaisdefensivos.delete.question" translate-values="{id: \'{{vm.custoshabituaisdefensivos.id}}\'}">Are you sure you want to delete this Custoshabituaisdefensivos?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custoshabituaisdefensivos/custoshabituaisdefensivos-detail.html','<div><h2><span data-translate="netWordAgroApp.custoshabituaisdefensivos.detail.title">Custoshabituaisdefensivos</span> {{vm.custoshabituaisdefensivos.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.custoshabituaisdefensivos.descricaogastos">Descricaogastos</span></dt><dd><span>{{vm.custoshabituaisdefensivos.descricaogastos}}</span></dd><dt><span data-translate="netWordAgroApp.custoshabituaisdefensivos.tipogasto">Tipogasto</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipodefensivo.\' + vm.custoshabituaisdefensivos.tipogasto}}">{{vm.custoshabituaisdefensivos.tipogasto}}</span></dd><dt><span data-translate="netWordAgroApp.custoshabituaisdefensivos.valor">Valor</span></dt><dd><span>{{vm.custoshabituaisdefensivos.valor}}</span></dd><dt><span data-translate="netWordAgroApp.custoshabituaisdefensivos.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.custoshabituaisdefensivos.safra.id})">{{vm.custoshabituaisdefensivos.safra.nomesafra}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custoshabituaisdefensivos-detail.edit({id:vm.custoshabituaisdefensivos.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custoshabituaisdefensivos/custoshabituaisdefensivos-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCustoshabituaisdefensivosLabel" data-translate="netWordAgroApp.custoshabituaisdefensivos.home.createOrEditLabel">Create or edit a Custoshabituaisdefensivos</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.custoshabituaisdefensivos.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.custoshabituaisdefensivos.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.custoshabituaisdefensivos.descricaogastos" for="field_descricaogastos">Descricaogastos</label><input type="text" class="form-control" name="descricaogastos" id="field_descricaogastos" ng-model="vm.custoshabituaisdefensivos.descricaogastos" required ng-maxlength="500"><div ng-show="editForm.descricaogastos.$invalid"><p class="help-block" ng-show="editForm.descricaogastos.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.descricaogastos.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="500">This field cannot be longer than 500 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.custoshabituaisdefensivos.tipogasto" for="field_tipogasto">Tipogasto</label><select class="form-control" name="tipogasto" ng-model="vm.custoshabituaisdefensivos.tipogasto" id="field_tipogasto" required><option value="inseticidaparasemente" data-translate="netWordAgroApp.Tipodefensivo.inseticidaparasemente">inseticidaparasemente</option><option value="inseticidaparalagarta" data-translate="netWordAgroApp.Tipodefensivo.inseticidaparalagarta">inseticidaparalagarta</option><option value="inseticidaparapercevejo" data-translate="netWordAgroApp.Tipodefensivo.inseticidaparapercevejo">inseticidaparapercevejo</option><option value="fungicidaparasemente" data-translate="netWordAgroApp.Tipodefensivo.fungicidaparasemente">fungicidaparasemente</option><option value="fungicida" data-translate="netWordAgroApp.Tipodefensivo.fungicida">fungicida</option><option value="herbicidaparaplantadaninha" data-translate="netWordAgroApp.Tipodefensivo.herbicidaparaplantadaninha">herbicidaparaplantadaninha</option><option value="herbicidaparaprecolheita" data-translate="netWordAgroApp.Tipodefensivo.herbicidaparaprecolheita">herbicidaparaprecolheita</option><option value="larvicida" data-translate="netWordAgroApp.Tipodefensivo.larvicida">larvicida</option></select><div ng-show="editForm.tipogasto.$invalid"><p class="help-block" ng-show="editForm.tipogasto.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.custoshabituaisdefensivos.valor" for="field_valor">Valor</label><input type="number" class="form-control" name="valor" id="field_valor" ng-model="vm.custoshabituaisdefensivos.valor" min="0" required><div ng-show="editForm.valor.$invalid"><p class="help-block" ng-show="editForm.valor.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.valor.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.custoshabituaisdefensivos.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.custoshabituaisdefensivos.safra" ng-options="safra as safra.nomesafra for safra in vm.safras track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/custoshabituaisdefensivos/custoshabituaisdefensivos.html','<div><h2 data-translate="netWordAgroApp.custoshabituaisdefensivos.home.title">Custoshabituaisdefensivos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="custoshabituaisdefensivos.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.custoshabituaisdefensivos.home.createLabel">Create new Custoshabituaisdefensivos</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.custoshabituaisdefensivos.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricaogastos"><span data-translate="netWordAgroApp.custoshabituaisdefensivos.descricaogastos">Descricaogastos</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipogasto"><span data-translate="netWordAgroApp.custoshabituaisdefensivos.tipogasto">Tipogasto</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valor"><span data-translate="netWordAgroApp.custoshabituaisdefensivos.valor">Valor</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="safra.nomesafra"><span data-translate="netWordAgroApp.custoshabituaisdefensivos.safra">Safra</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="custoshabituaisdefensivos in vm.custoshabituaisdefensivos track by custoshabituaisdefensivos.id"><td><a ui-sref="custoshabituaisdefensivos-detail({id:custoshabituaisdefensivos.id})">{{custoshabituaisdefensivos.id}}</a></td><td>{{custoshabituaisdefensivos.descricaogastos}}</td><td data-translate="{{\'netWordAgroApp.Tipodefensivo.\' + custoshabituaisdefensivos.tipogasto}}">{{custoshabituaisdefensivos.tipogasto}}</td><td>{{custoshabituaisdefensivos.valor}}</td><td><a ui-sref="safra-detail({id:custoshabituaisdefensivos.safra.id})">{{custoshabituaisdefensivos.safra.nomesafra}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="custoshabituaisdefensivos-detail({id:custoshabituaisdefensivos.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="custoshabituaisdefensivos.edit({id:custoshabituaisdefensivos.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="custoshabituaisdefensivos.delete({id:custoshabituaisdefensivos.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/custoshabituaisfertilizantes/custoshabituaisfertilizantes-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.custoshabituaisfertilizantes.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.custoshabituaisfertilizantes.delete.question" translate-values="{id: \'{{vm.custoshabituaisfertilizantes.id}}\'}">Are you sure you want to delete this Custoshabituaisfertilizantes?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custoshabituaisfertilizantes/custoshabituaisfertilizantes-detail.html','<div><h2><span data-translate="netWordAgroApp.custoshabituaisfertilizantes.detail.title">Custoshabituaisfertilizantes</span> {{vm.custoshabituaisfertilizantes.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.custoshabituaisfertilizantes.descricaogastos">Descricaogastos</span></dt><dd><span>{{vm.custoshabituaisfertilizantes.descricaogastos}}</span></dd><dt><span data-translate="netWordAgroApp.custoshabituaisfertilizantes.tipogasto">Tipogasto</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipofertilizante.\' + vm.custoshabituaisfertilizantes.tipogasto}}">{{vm.custoshabituaisfertilizantes.tipogasto}}</span></dd><dt><span data-translate="netWordAgroApp.custoshabituaisfertilizantes.valor">Valor</span></dt><dd><span>{{vm.custoshabituaisfertilizantes.valor}}</span></dd><dt><span data-translate="netWordAgroApp.custoshabituaisfertilizantes.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.custoshabituaisfertilizantes.safra.id})">{{vm.custoshabituaisfertilizantes.safra.nomesafra}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custoshabituaisfertilizantes-detail.edit({id:vm.custoshabituaisfertilizantes.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custoshabituaisfertilizantes/custoshabituaisfertilizantes-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCustoshabituaisfertilizantesLabel" data-translate="netWordAgroApp.custoshabituaisfertilizantes.home.createOrEditLabel">Create or edit a Custoshabituaisfertilizantes</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.custoshabituaisfertilizantes.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.custoshabituaisfertilizantes.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.custoshabituaisfertilizantes.descricaogastos" for="field_descricaogastos">Descricaogastos</label><input type="text" class="form-control" name="descricaogastos" id="field_descricaogastos" ng-model="vm.custoshabituaisfertilizantes.descricaogastos" required ng-maxlength="500"><div ng-show="editForm.descricaogastos.$invalid"><p class="help-block" ng-show="editForm.descricaogastos.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.descricaogastos.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="500">This field cannot be longer than 500 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.custoshabituaisfertilizantes.tipogasto" for="field_tipogasto">Tipogasto</label><select class="form-control" name="tipogasto" ng-model="vm.custoshabituaisfertilizantes.tipogasto" id="field_tipogasto" required><option value="fertilizantequimico" data-translate="netWordAgroApp.Tipofertilizante.fertilizantequimico">fertilizantequimico</option><option value="fertilizantefoliar" data-translate="netWordAgroApp.Tipofertilizante.fertilizantefoliar">fertilizantefoliar</option><option value="corretivo" data-translate="netWordAgroApp.Tipofertilizante.corretivo">corretivo</option><option value="materialorganico" data-translate="netWordAgroApp.Tipofertilizante.materialorganico">materialorganico</option></select><div ng-show="editForm.tipogasto.$invalid"><p class="help-block" ng-show="editForm.tipogasto.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.custoshabituaisfertilizantes.valor" for="field_valor">Valor</label><input type="number" class="form-control" name="valor" id="field_valor" ng-model="vm.custoshabituaisfertilizantes.valor" min="0" required><div ng-show="editForm.valor.$invalid"><p class="help-block" ng-show="editForm.valor.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.valor.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.custoshabituaisfertilizantes.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.custoshabituaisfertilizantes.safra" ng-options="safra as safra.nomesafra for safra in vm.safras track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/custoshabituaisfertilizantes/custoshabituaisfertilizantes.html','<div><h2 data-translate="netWordAgroApp.custoshabituaisfertilizantes.home.title">Custoshabituaisfertilizantes</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="custoshabituaisfertilizantes.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.custoshabituaisfertilizantes.home.createLabel">Create new Custoshabituaisfertilizantes</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.custoshabituaisfertilizantes.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricaogastos"><span data-translate="netWordAgroApp.custoshabituaisfertilizantes.descricaogastos">Descricaogastos</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipogasto"><span data-translate="netWordAgroApp.custoshabituaisfertilizantes.tipogasto">Tipogasto</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valor"><span data-translate="netWordAgroApp.custoshabituaisfertilizantes.valor">Valor</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="safra.nomesafra"><span data-translate="netWordAgroApp.custoshabituaisfertilizantes.safra">Safra</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="custoshabituaisfertilizantes in vm.custoshabituaisfertilizantes track by custoshabituaisfertilizantes.id"><td><a ui-sref="custoshabituaisfertilizantes-detail({id:custoshabituaisfertilizantes.id})">{{custoshabituaisfertilizantes.id}}</a></td><td>{{custoshabituaisfertilizantes.descricaogastos}}</td><td data-translate="{{\'netWordAgroApp.Tipofertilizante.\' + custoshabituaisfertilizantes.tipogasto}}">{{custoshabituaisfertilizantes.tipogasto}}</td><td>{{custoshabituaisfertilizantes.valor}}</td><td><a ui-sref="safra-detail({id:custoshabituaisfertilizantes.safra.id})">{{custoshabituaisfertilizantes.safra.nomesafra}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="custoshabituaisfertilizantes-detail({id:custoshabituaisfertilizantes.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="custoshabituaisfertilizantes.edit({id:custoshabituaisfertilizantes.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="custoshabituaisfertilizantes.delete({id:custoshabituaisfertilizantes.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/custoshabituaisproducao/custoshabituaisproducao-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.custoshabituaisproducao.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.custoshabituaisproducao.delete.question" translate-values="{id: \'{{vm.custoshabituaisproducao.id}}\'}">Are you sure you want to delete this Custoshabituaisproducao?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custoshabituaisproducao/custoshabituaisproducao-detail.html','<div><h2><span data-translate="netWordAgroApp.custoshabituaisproducao.detail.title">Custoshabituaisproducao</span> {{vm.custoshabituaisproducao.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.custoshabituaisproducao.quantidademaquinas">Quantidademaquinas</span></dt><dd><span>{{vm.custoshabituaisproducao.quantidademaquinas}}</span></dd><dt><span data-translate="netWordAgroApp.custoshabituaisproducao.tipogasto">Tipogasto</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipoproducao.\' + vm.custoshabituaisproducao.tipogasto}}">{{vm.custoshabituaisproducao.tipogasto}}</span></dd><dt><span data-translate="netWordAgroApp.custoshabituaisproducao.horamaquina">Horamaquina</span></dt><dd><span>{{vm.custoshabituaisproducao.horamaquina}}</span></dd><dt><span data-translate="netWordAgroApp.custoshabituaisproducao.valor">Valor</span></dt><dd><span>{{vm.custoshabituaisproducao.valor}}</span></dd><dt><span data-translate="netWordAgroApp.custoshabituaisproducao.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.custoshabituaisproducao.safra.id})">{{vm.custoshabituaisproducao.safra.nomesafra}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custoshabituaisproducao-detail.edit({id:vm.custoshabituaisproducao.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custoshabituaisproducao/custoshabituaisproducao-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCustoshabituaisproducaoLabel" data-translate="netWordAgroApp.custoshabituaisproducao.home.createOrEditLabel">Create or edit a Custoshabituaisproducao</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.custoshabituaisproducao.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.custoshabituaisproducao.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.custoshabituaisproducao.quantidademaquinas" for="field_quantidademaquinas">Quantidademaquinas</label><input type="number" class="form-control" name="quantidademaquinas" id="field_quantidademaquinas" ng-model="vm.custoshabituaisproducao.quantidademaquinas" required><div ng-show="editForm.quantidademaquinas.$invalid"><p class="help-block" ng-show="editForm.quantidademaquinas.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.quantidademaquinas.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.custoshabituaisproducao.tipogasto" for="field_tipogasto">Tipogasto</label><select class="form-control" name="tipogasto" ng-model="vm.custoshabituaisproducao.tipogasto" id="field_tipogasto" required><option value="analisedesolo" data-translate="netWordAgroApp.Tipoproducao.analisedesolo">analisedesolo</option><option value="combustivel" data-translate="netWordAgroApp.Tipoproducao.combustivel">combustivel</option><option value="operacaodamaquina" data-translate="netWordAgroApp.Tipoproducao.operacaodamaquina">operacaodamaquina</option><option value="alugueldamaquina" data-translate="netWordAgroApp.Tipoproducao.alugueldamaquina">alugueldamaquina</option><option value="manutencaodamaquina" data-translate="netWordAgroApp.Tipoproducao.manutencaodamaquina">manutencaodamaquina</option></select><div ng-show="editForm.tipogasto.$invalid"><p class="help-block" ng-show="editForm.tipogasto.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.custoshabituaisproducao.horamaquina" for="field_horamaquina">Horamaquina</label><input type="number" class="form-control" name="horamaquina" id="field_horamaquina" ng-model="vm.custoshabituaisproducao.horamaquina" required><div ng-show="editForm.horamaquina.$invalid"><p class="help-block" ng-show="editForm.horamaquina.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.horamaquina.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.custoshabituaisproducao.valor" for="field_valor">Valor</label><input type="number" class="form-control" name="valor" id="field_valor" ng-model="vm.custoshabituaisproducao.valor" min="0" required><div ng-show="editForm.valor.$invalid"><p class="help-block" ng-show="editForm.valor.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.valor.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.custoshabituaisproducao.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.custoshabituaisproducao.safra" ng-options="safra as safra.nomesafra for safra in vm.safras track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/custoshabituaisproducao/custoshabituaisproducaos.html','<div><h2 data-translate="netWordAgroApp.custoshabituaisproducao.home.title">Custoshabituaisproducaos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="custoshabituaisproducao.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.custoshabituaisproducao.home.createLabel">Create new Custoshabituaisproducao</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.custoshabituaisproducao.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quantidademaquinas"><span data-translate="netWordAgroApp.custoshabituaisproducao.quantidademaquinas">Quantidademaquinas</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipogasto"><span data-translate="netWordAgroApp.custoshabituaisproducao.tipogasto">Tipogasto</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="horamaquina"><span data-translate="netWordAgroApp.custoshabituaisproducao.horamaquina">Horamaquina</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valor"><span data-translate="netWordAgroApp.custoshabituaisproducao.valor">Valor</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="safra.nomesafra"><span data-translate="netWordAgroApp.custoshabituaisproducao.safra">Safra</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="custoshabituaisproducao in vm.custoshabituaisproducaos track by custoshabituaisproducao.id"><td><a ui-sref="custoshabituaisproducao-detail({id:custoshabituaisproducao.id})">{{custoshabituaisproducao.id}}</a></td><td>{{custoshabituaisproducao.quantidademaquinas}}</td><td data-translate="{{\'netWordAgroApp.Tipoproducao.\' + custoshabituaisproducao.tipogasto}}">{{custoshabituaisproducao.tipogasto}}</td><td>{{custoshabituaisproducao.horamaquina}}</td><td>{{custoshabituaisproducao.valor}}</td><td><a ui-sref="safra-detail({id:custoshabituaisproducao.safra.id})">{{custoshabituaisproducao.safra.nomesafra}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="custoshabituaisproducao-detail({id:custoshabituaisproducao.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="custoshabituaisproducao.edit({id:custoshabituaisproducao.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="custoshabituaisproducao.delete({id:custoshabituaisproducao.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/custosnwdefensivos/custosnwdefensivos-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.custosnwdefensivos.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.custosnwdefensivos.delete.question" translate-values="{id: \'{{vm.custosnwdefensivos.id}}\'}">Are you sure you want to delete this Custosnwdefensivos?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custosnwdefensivos/custosnwdefensivos-detail.html','<div><h2><span data-translate="netWordAgroApp.custosnwdefensivos.detail.title">Custosnwdefensivos</span> {{vm.custosnwdefensivos.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.custosnwdefensivos.descricaogastos">Descricaogastos</span></dt><dd><span>{{vm.custosnwdefensivos.descricaogastos}}</span></dd><dt><span data-translate="netWordAgroApp.custosnwdefensivos.tipogasto">Tipogasto</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipodefensivo.\' + vm.custosnwdefensivos.tipogasto}}">{{vm.custosnwdefensivos.tipogasto}}</span></dd><dt><span data-translate="netWordAgroApp.custosnwdefensivos.valor">Valor</span></dt><dd><span>{{vm.custosnwdefensivos.valor}}</span></dd><dt><span data-translate="netWordAgroApp.custosnwdefensivos.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.custosnwdefensivos.safra.id})">{{vm.custosnwdefensivos.safra.nomesafra}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custosnwdefensivos-detail.edit({id:vm.custosnwdefensivos.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custosnwdefensivos/custosnwdefensivos-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCustosnwdefensivosLabel" data-translate="netWordAgroApp.custosnwdefensivos.home.createOrEditLabel">Create or edit a Custosnwdefensivos</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.custosnwdefensivos.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.custosnwdefensivos.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.custosnwdefensivos.descricaogastos" for="field_descricaogastos">Descricaogastos</label><input type="text" class="form-control" name="descricaogastos" id="field_descricaogastos" ng-model="vm.custosnwdefensivos.descricaogastos" required ng-maxlength="500"><div ng-show="editForm.descricaogastos.$invalid"><p class="help-block" ng-show="editForm.descricaogastos.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.descricaogastos.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="500">This field cannot be longer than 500 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.custosnwdefensivos.tipogasto" for="field_tipogasto">Tipogasto</label><select class="form-control" name="tipogasto" ng-model="vm.custosnwdefensivos.tipogasto" id="field_tipogasto" required><option value="inseticidaparasemente" data-translate="netWordAgroApp.Tipodefensivo.inseticidaparasemente">inseticidaparasemente</option><option value="inseticidaparalagarta" data-translate="netWordAgroApp.Tipodefensivo.inseticidaparalagarta">inseticidaparalagarta</option><option value="inseticidaparapercevejo" data-translate="netWordAgroApp.Tipodefensivo.inseticidaparapercevejo">inseticidaparapercevejo</option><option value="fungicidaparasemente" data-translate="netWordAgroApp.Tipodefensivo.fungicidaparasemente">fungicidaparasemente</option><option value="fungicida" data-translate="netWordAgroApp.Tipodefensivo.fungicida">fungicida</option><option value="herbicidaparaplantadaninha" data-translate="netWordAgroApp.Tipodefensivo.herbicidaparaplantadaninha">herbicidaparaplantadaninha</option><option value="herbicidaparaprecolheita" data-translate="netWordAgroApp.Tipodefensivo.herbicidaparaprecolheita">herbicidaparaprecolheita</option><option value="larvicida" data-translate="netWordAgroApp.Tipodefensivo.larvicida">larvicida</option></select><div ng-show="editForm.tipogasto.$invalid"><p class="help-block" ng-show="editForm.tipogasto.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.custosnwdefensivos.valor" for="field_valor">Valor</label><input type="number" class="form-control" name="valor" id="field_valor" ng-model="vm.custosnwdefensivos.valor" min="0" required><div ng-show="editForm.valor.$invalid"><p class="help-block" ng-show="editForm.valor.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.valor.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.custosnwdefensivos.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.custosnwdefensivos.safra" ng-options="safra as safra.nomesafra for safra in vm.safras track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/custosnwdefensivos/custosnwdefensivos.html','<div><h2 data-translate="netWordAgroApp.custosnwdefensivos.home.title">Custosnwdefensivos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="custosnwdefensivos.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.custosnwdefensivos.home.createLabel">Create new Custosnwdefensivos</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.custosnwdefensivos.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricaogastos"><span data-translate="netWordAgroApp.custosnwdefensivos.descricaogastos">Descricaogastos</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipogasto"><span data-translate="netWordAgroApp.custosnwdefensivos.tipogasto">Tipogasto</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valor"><span data-translate="netWordAgroApp.custosnwdefensivos.valor">Valor</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="safra.nomesafra"><span data-translate="netWordAgroApp.custosnwdefensivos.safra">Safra</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="custosnwdefensivos in vm.custosnwdefensivos track by custosnwdefensivos.id"><td><a ui-sref="custosnwdefensivos-detail({id:custosnwdefensivos.id})">{{custosnwdefensivos.id}}</a></td><td>{{custosnwdefensivos.descricaogastos}}</td><td data-translate="{{\'netWordAgroApp.Tipodefensivo.\' + custosnwdefensivos.tipogasto}}">{{custosnwdefensivos.tipogasto}}</td><td>{{custosnwdefensivos.valor}}</td><td><a ui-sref="safra-detail({id:custosnwdefensivos.safra.id})">{{custosnwdefensivos.safra.nomesafra}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="custosnwdefensivos-detail({id:custosnwdefensivos.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="custosnwdefensivos.edit({id:custosnwdefensivos.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="custosnwdefensivos.delete({id:custosnwdefensivos.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/custosnwfertilizantes/custosnwfertilizantes-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.custosnwfertilizantes.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.custosnwfertilizantes.delete.question" translate-values="{id: \'{{vm.custosnwfertilizantes.id}}\'}">Are you sure you want to delete this Custosnwfertilizantes?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custosnwfertilizantes/custosnwfertilizantes-detail.html','<div><h2><span data-translate="netWordAgroApp.custosnwfertilizantes.detail.title">Custosnwfertilizantes</span> {{vm.custosnwfertilizantes.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.custosnwfertilizantes.descricaogastos">Descricaogastos</span></dt><dd><span>{{vm.custosnwfertilizantes.descricaogastos}}</span></dd><dt><span data-translate="netWordAgroApp.custosnwfertilizantes.tipogasto">Tipogasto</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipofertilizante.\' + vm.custosnwfertilizantes.tipogasto}}">{{vm.custosnwfertilizantes.tipogasto}}</span></dd><dt><span data-translate="netWordAgroApp.custosnwfertilizantes.valor">Valor</span></dt><dd><span>{{vm.custosnwfertilizantes.valor}}</span></dd><dt><span data-translate="netWordAgroApp.custosnwfertilizantes.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.custosnwfertilizantes.safra.id})">{{vm.custosnwfertilizantes.safra.nomesafra}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custosnwfertilizantes-detail.edit({id:vm.custosnwfertilizantes.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custosnwfertilizantes/custosnwfertilizantes-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCustosnwfertilizantesLabel" data-translate="netWordAgroApp.custosnwfertilizantes.home.createOrEditLabel">Create or edit a Custosnwfertilizantes</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.custosnwfertilizantes.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.custosnwfertilizantes.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.custosnwfertilizantes.descricaogastos" for="field_descricaogastos">Descricaogastos</label><input type="text" class="form-control" name="descricaogastos" id="field_descricaogastos" ng-model="vm.custosnwfertilizantes.descricaogastos" required ng-maxlength="500"><div ng-show="editForm.descricaogastos.$invalid"><p class="help-block" ng-show="editForm.descricaogastos.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.descricaogastos.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="500">This field cannot be longer than 500 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.custosnwfertilizantes.tipogasto" for="field_tipogasto">Tipogasto</label><select class="form-control" name="tipogasto" ng-model="vm.custosnwfertilizantes.tipogasto" id="field_tipogasto" required><option value="fertilizantequimico" data-translate="netWordAgroApp.Tipofertilizante.fertilizantequimico">fertilizantequimico</option><option value="fertilizantefoliar" data-translate="netWordAgroApp.Tipofertilizante.fertilizantefoliar">fertilizantefoliar</option><option value="corretivo" data-translate="netWordAgroApp.Tipofertilizante.corretivo">corretivo</option><option value="materialorganico" data-translate="netWordAgroApp.Tipofertilizante.materialorganico">materialorganico</option></select><div ng-show="editForm.tipogasto.$invalid"><p class="help-block" ng-show="editForm.tipogasto.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.custosnwfertilizantes.valor" for="field_valor">Valor</label><input type="number" class="form-control" name="valor" id="field_valor" ng-model="vm.custosnwfertilizantes.valor" min="0" required><div ng-show="editForm.valor.$invalid"><p class="help-block" ng-show="editForm.valor.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.valor.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.custosnwfertilizantes.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.custosnwfertilizantes.safra" ng-options="safra as safra.nomesafra for safra in vm.safras track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/custosnwfertilizantes/custosnwfertilizantes.html','<div><h2 data-translate="netWordAgroApp.custosnwfertilizantes.home.title">Custosnwfertilizantes</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="custosnwfertilizantes.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.custosnwfertilizantes.home.createLabel">Create new Custosnwfertilizantes</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.custosnwfertilizantes.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricaogastos"><span data-translate="netWordAgroApp.custosnwfertilizantes.descricaogastos">Descricaogastos</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipogasto"><span data-translate="netWordAgroApp.custosnwfertilizantes.tipogasto">Tipogasto</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valor"><span data-translate="netWordAgroApp.custosnwfertilizantes.valor">Valor</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="safra.nomesafra"><span data-translate="netWordAgroApp.custosnwfertilizantes.safra">Safra</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="custosnwfertilizantes in vm.custosnwfertilizantes track by custosnwfertilizantes.id"><td><a ui-sref="custosnwfertilizantes-detail({id:custosnwfertilizantes.id})">{{custosnwfertilizantes.id}}</a></td><td>{{custosnwfertilizantes.descricaogastos}}</td><td data-translate="{{\'netWordAgroApp.Tipofertilizante.\' + custosnwfertilizantes.tipogasto}}">{{custosnwfertilizantes.tipogasto}}</td><td>{{custosnwfertilizantes.valor}}</td><td><a ui-sref="safra-detail({id:custosnwfertilizantes.safra.id})">{{custosnwfertilizantes.safra.nomesafra}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="custosnwfertilizantes-detail({id:custosnwfertilizantes.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="custosnwfertilizantes.edit({id:custosnwfertilizantes.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="custosnwfertilizantes.delete({id:custosnwfertilizantes.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/custosnwproducao/custosnwproducao-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.custosnwproducao.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.custosnwproducao.delete.question" translate-values="{id: \'{{vm.custosnwproducao.id}}\'}">Are you sure you want to delete this Custosnwproducao?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/custosnwproducao/custosnwproducao-detail.html','<div><h2><span data-translate="netWordAgroApp.custosnwproducao.detail.title">Custosnwproducao</span> {{vm.custosnwproducao.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.custosnwproducao.quantidademaquinas">Quantidademaquinas</span></dt><dd><span>{{vm.custosnwproducao.quantidademaquinas}}</span></dd><dt><span data-translate="netWordAgroApp.custosnwproducao.tipogasto">Tipogasto</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipoproducao.\' + vm.custosnwproducao.tipogasto}}">{{vm.custosnwproducao.tipogasto}}</span></dd><dt><span data-translate="netWordAgroApp.custosnwproducao.horamaquina">Horamaquina</span></dt><dd><span>{{vm.custosnwproducao.horamaquina}}</span></dd><dt><span data-translate="netWordAgroApp.custosnwproducao.valor">Valor</span></dt><dd><span>{{vm.custosnwproducao.valor}}</span></dd><dt><span data-translate="netWordAgroApp.custosnwproducao.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.custosnwproducao.safra.id})">{{vm.custosnwproducao.safra.nomesafra}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="custosnwproducao-detail.edit({id:vm.custosnwproducao.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/custosnwproducao/custosnwproducao-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCustosnwproducaoLabel" data-translate="netWordAgroApp.custosnwproducao.home.createOrEditLabel">Create or edit a Custosnwproducao</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.custosnwproducao.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.custosnwproducao.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.custosnwproducao.quantidademaquinas" for="field_quantidademaquinas">Quantidademaquinas</label><input type="number" class="form-control" name="quantidademaquinas" id="field_quantidademaquinas" ng-model="vm.custosnwproducao.quantidademaquinas" required><div ng-show="editForm.quantidademaquinas.$invalid"><p class="help-block" ng-show="editForm.quantidademaquinas.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.quantidademaquinas.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.custosnwproducao.tipogasto" for="field_tipogasto">Tipogasto</label><select class="form-control" name="tipogasto" ng-model="vm.custosnwproducao.tipogasto" id="field_tipogasto" required><option value="analisedesolo" data-translate="netWordAgroApp.Tipoproducao.analisedesolo">analisedesolo</option><option value="combustivel" data-translate="netWordAgroApp.Tipoproducao.combustivel">combustiveldamaquina</option><option value="operacaodamaquina" data-translate="netWordAgroApp.Tipoproducao.operacaodamaquina">operacaodamaquina</option><option value="alugueldamaquina" data-translate="netWordAgroApp.Tipoproducao.alugueldamaquina">alugueldamaquina</option><option value="manutencaodamaquina" data-translate="netWordAgroApp.Tipoproducao.manutencaodamaquina">manutencaodamaquina</option></select><div ng-show="editForm.tipogasto.$invalid"><p class="help-block" ng-show="editForm.tipogasto.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.custosnwproducao.horamaquina" for="field_horamaquina">Horamaquina</label><input type="number" class="form-control" name="horamaquina" id="field_horamaquina" ng-model="vm.custosnwproducao.horamaquina" required><div ng-show="editForm.horamaquina.$invalid"><p class="help-block" ng-show="editForm.horamaquina.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.horamaquina.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.custosnwproducao.valor" for="field_valor">Valor</label><input type="number" class="form-control" name="valor" id="field_valor" ng-model="vm.custosnwproducao.valor" min="0" required><div ng-show="editForm.valor.$invalid"><p class="help-block" ng-show="editForm.valor.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.valor.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.custosnwproducao.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.custosnwproducao.safra" ng-options="safra as safra.nomesafra for safra in vm.safras track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/custosnwproducao/custosnwproducaos.html','<div><h2 data-translate="netWordAgroApp.custosnwproducao.home.title">Custosnwproducaos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="custosnwproducao.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.custosnwproducao.home.createLabel">Create new Custosnwproducao</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.custosnwproducao.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quantidademaquinas"><span data-translate="netWordAgroApp.custosnwproducao.quantidademaquinas">Quantidademaquinas</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipogasto"><span data-translate="netWordAgroApp.custosnwproducao.tipogasto">Tipogasto</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="horamaquina"><span data-translate="netWordAgroApp.custosnwproducao.horamaquina">Horamaquina</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valor"><span data-translate="netWordAgroApp.custosnwproducao.valor">Valor</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="safra.nomesafra"><span data-translate="netWordAgroApp.custosnwproducao.safra">Safra</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="custosnwproducao in vm.custosnwproducaos track by custosnwproducao.id"><td><a ui-sref="custosnwproducao-detail({id:custosnwproducao.id})">{{custosnwproducao.id}}</a></td><td>{{custosnwproducao.quantidademaquinas}}</td><td data-translate="{{\'netWordAgroApp.Tipoproducao.\' + custosnwproducao.tipogasto}}">{{custosnwproducao.tipogasto}}</td><td>{{custosnwproducao.horamaquina}}</td><td>{{custosnwproducao.valor}}</td><td><a ui-sref="safra-detail({id:custosnwproducao.safra.id})">{{custosnwproducao.safra.nomesafra}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="custosnwproducao-detail({id:custosnwproducao.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="custosnwproducao.edit({id:custosnwproducao.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="custosnwproducao.delete({id:custosnwproducao.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/entregasafracomerc/entregasafracomerc-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.entregasafracomerc.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.entregasafracomerc.delete.question" translate-values="{id: \'{{vm.entregasafracomerc.id}}\'}">Are you sure you want to delete this Entregasafracomerc?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/entregasafracomerc/entregasafracomerc-detail.html','<div><h2><span data-translate="netWordAgroApp.entregasafracomerc.detail.title">Entregasafracomerc</span> {{vm.entregasafracomerc.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.entregasafracomerc.datainicio">Datainicio</span></dt><dd><span>{{vm.entregasafracomerc.datainicio | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.entregasafracomerc.datafim">Datafim</span></dt><dd><span>{{vm.entregasafracomerc.datafim | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.entregasafracomerc.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.entregasafracomerc.safra.id})">{{vm.entregasafracomerc.safra.nomesafra}}</a></dd><dt><span data-translate="netWordAgroApp.entregasafracomerc.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.entregasafracomerc.etapa.id})">{{vm.entregasafracomerc.etapa.nomeetapa}}</a></dd></dl><button type="submit" ui-sref="entregasafracomerc" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="entregasafracomerc-detail.edit({id:vm.entregasafracomerc.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.entregasafracomerc.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.entregasafracomerc.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/entregasafracomerc/entregasafracomerc-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEntregasafracomercLabel" data-translate="netWordAgroApp.entregasafracomerc.home.createOrEditLabel">Create or edit a Entregasafracomerc</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.entregasafracomerc.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.entregasafracomerc.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.entregasafracomerc.$invalid"><p class="help-block" ng-show="editForm.entregasafracomerc.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.entregasafracomerc.datainicio" for="field_datainicio">Datainicio</label><div class="input-group"><input id="field_datainicio" type="text" class="form-control" name="datainicio" uib-datepicker-popup="{{dateformat}}" ng-model="vm.entregasafracomerc.datainicio" is-open="vm.datePickerOpenStatus.datainicio" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datainicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datainicio.$invalid"><p class="help-block" ng-show="editForm.datainicio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.entregasafracomerc.datafim" for="field_datafim">Datafim</label><div class="input-group"><input id="field_datafim" type="text" class="form-control" name="datafim" uib-datepicker-popup="{{dateformat}}" ng-model="vm.entregasafracomerc.datafim" is-open="vm.datePickerOpenStatus.datafim" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datafim\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datafim.$invalid"><p class="help-block" ng-show="editForm.datafim.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.entregasafracomerc.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.entregasafracomerc.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div><!--\n        <div class="form-group">\n            <label data-translate="netWordAgroApp.entregasafracomerc.etapa" for="field_etapa">Etapa</label>\n            <select class="form-control" id="field_etapa" name="etapa" ng-model="vm.entregasafracomerc.etapa" ng-options="etapa as etapa.nomeetapa for etapa in vm.etapas track by etapa.id">\n                <option value=""></option>\n            </select>\n        </div>\n    --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/entregasafracomerc/entregasafracomercs.html','<div><h2 data-translate="netWordAgroApp.entregasafracomerc.home.title">Entregasafracomercs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="entregasafracomerc.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.entregasafracomerc.home.createLabel">Create new Entregasafracomerc</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.entregasafracomerc.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.entregasafracomerc.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datafim"><span data-translate="netWordAgroApp.entregasafracomerc.datafim">Datafim</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.entregasafracomerc.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="entregasafracomerc in vm.entregasafracomercs track by entregasafracomerc.id"><td><a ui-sref="entregasafracomerc-detail({id:entregasafracomerc.id})">{{entregasafracomerc.id}}</a></td><td>{{entregasafracomerc.datainicio | date:\'mediumDate\'}}</td><td>{{entregasafracomerc.datafim | date:\'mediumDate\'}}</td><td><a ui-sref="etapa-detail({id:entregasafracomerc.etapa.id})">{{entregasafracomerc.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="entregasafracomerc-detail({id:entregasafracomerc.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="entregasafracomerc.edit({id:entregasafracomerc.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="entregasafracomerc.delete({id:entregasafracomerc.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/diariodebordo/diariodebordo-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.diariodebordo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.diariodebordo.delete.question" translate-values="{id: \'{{vm.diariodebordo.id}}\'}">Are you sure you want to delete this Diariodebordo?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/diariodebordo/diariodebordo-detail.html','<div><h2><span data-translate="netWordAgroApp.diariodebordo.detail.title">Diariodebordo</span> {{vm.diariodebordo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.diariodebordo.dataavaliacao">Dataavaliacao</span></dt><dd><span>{{vm.diariodebordo.dataavaliacao}}</span></dd><dt><span data-translate="netWordAgroApp.diariodebordo.arquivodiario">Arquivodiario</span></dt><dd><div ng-if="vm.diariodebordo.arquivodiario"><a ng-click="vm.openFile(vm.diariodebordo.arquivodiarioContentType, vm.diariodebordo.arquivodiario)" data-translate="entity.action.open">open</a> {{vm.diariodebordo.arquivodiarioContentType}}, {{vm.byteSize(vm.diariodebordo.arquivodiario)}}</div></dd><dt><span data-translate="netWordAgroApp.diariodebordo.arquivoobservacoes">Arquivoobservacoes</span></dt><dd><div ng-if="vm.diariodebordo.arquivoobservacoes"><a ng-click="vm.openFile(vm.diariodebordo.arquivoobservacoesContentType, vm.diariodebordo.arquivoobservacoes)" data-translate="entity.action.open">open</a> {{vm.diariodebordo.arquivoobservacoesContentType}}, {{vm.byteSize(vm.diariodebordo.arquivoobservacoes)}}</div></dd><dt><span data-translate="netWordAgroApp.diariodebordo.tipoincidencia">Tipoincidencia</span></dt><dd><span>{{vm.diariodebordo.tipoincidencia}}</span></dd><dt><span data-translate="netWordAgroApp.diariodebordo.propriedade">Propriedade</span></dt><dd><a ui-sref="propriedade-detail({id:vm.diariodebordo.propriedade.id})">{{vm.diariodebordo.propriedade.nomepropriedade}}</a></dd><dt><span data-translate="netWordAgroApp.diariodebordo.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.diariodebordo.safra.id})">{{vm.diariodebordo.safra.nomesafra}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="diariodebordo-detail.edit({id:vm.diariodebordo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/diariodebordo/diariodebordo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDiariodebordoLabel" data-translate="netWordAgroApp.diariodebordo.home.createOrEditLabel">Create or edit a Diariodebordo</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.diariodebordo.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.diariodebordo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.diariodebordo.dataavaliacao" for="field_dataavaliacao">Dataavaliacao</label><input type="text" class="form-control" name="dataavaliacao" id="field_dataavaliacao" ng-model="vm.diariodebordo.dataavaliacao"></div><div class="form-group" ngf-drop ngf-change="vm.setArquivodiario($file, vm.diariodebordo)"><label class="control-label" data-translate="netWordAgroApp.diariodebordo.arquivodiario" for="field_arquivodiario">Arquivodiario</label><div><div ng-if="vm.diariodebordo.arquivodiario" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.diariodebordo.arquivodiarioContentType, vm.diariodebordo.arquivodiario)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.diariodebordo.arquivodiarioContentType}}, {{vm.byteSize(vm.diariodebordo.arquivodiario)}}</span> <button type="button" ng-click="vm.diariodebordo.arquivodiario=null;vm.diariodebordo.arquivodiarioContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setArquivodiario($file, vm.diariodebordo)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="arquivodiario" id="field_arquivodiario" ng-model="vm.diariodebordo.arquivodiario"> <input type="hidden" class="form-control" name="arquivodiarioContentType" id="field_arquivodiarioContentType" ng-model="vm.diariodebordo.arquivodiarioContentType"></div><div class="form-group" ngf-drop ngf-change="vm.setArquivoobservacoes($file, vm.diariodebordo)"><label class="control-label" data-translate="netWordAgroApp.diariodebordo.arquivoobservacoes" for="field_arquivoobservacoes">Arquivoobservacoes</label><div><div ng-if="vm.diariodebordo.arquivoobservacoes" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.diariodebordo.arquivoobservacoesContentType, vm.diariodebordo.arquivoobservacoes)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.diariodebordo.arquivoobservacoesContentType}}, {{vm.byteSize(vm.diariodebordo.arquivoobservacoes)}}</span> <button type="button" ng-click="vm.diariodebordo.arquivoobservacoes=null;vm.diariodebordo.arquivoobservacoesContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setArquivoobservacoes($file, vm.diariodebordo)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="arquivoobservacoes" id="field_arquivoobservacoes" ng-model="vm.diariodebordo.arquivoobservacoes"> <input type="hidden" class="form-control" name="arquivoobservacoesContentType" id="field_arquivoobservacoesContentType" ng-model="vm.diariodebordo.arquivoobservacoesContentType"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.diariodebordo.tipoincidencia" for="field_tipoincidencia">Tipoincidencia</label><input type="text" class="form-control" name="tipoincidencia" id="field_tipoincidencia" ng-model="vm.diariodebordo.tipoincidencia"></div><div class="form-group"><label data-translate="netWordAgroApp.diariodebordo.propriedade" for="field_propriedade">Propriedade</label><select class="form-control" id="field_propriedade" name="propriedade" ng-model="vm.diariodebordo.propriedade" ng-options="propriedade as propriedade.nomepropriedade for propriedade in vm.propriedades track by propriedade.id"><option value=""></option></select></div><div class="form-group"><label data-translate="netWordAgroApp.diariodebordo.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.diariodebordo.safra" ng-options="safra as safra.nomesafra for safra in vm.safras track by safra.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/diariodebordo/diariodebordos.html','<div><h2 data-translate="netWordAgroApp.diariodebordo.home.title">Diariodebordos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="diariodebordo.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.diariodebordo.home.createLabel">Create new Diariodebordo</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.diariodebordo.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="container-fluid" style="margin-top:10px"><div class="row"><div class="col-xs-4 no-padding-left"><form name="filtrar" class="form-inline"><label class="control-label" data-translate="netWordAgroApp.mapaimagem.filtrarporpropriedade" for="field_filtropropriedade"></label><select class="form-control" id="field_filtropropriedade" name="filtropropriedade" ng-model="vm.filtropropriedade" ng-options="prop as prop.nomepropriedade for prop in vm.filtropropriedades track by prop.id" ng-change="vm.changeFiltro()"><option value></option></select></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dataavaliacao"><span data-translate="netWordAgroApp.diariodebordo.dataavaliacao">Dataavaliacao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="arquivodiario"><span data-translate="netWordAgroApp.diariodebordo.arquivodiario">Arquivodiario</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="arquivoobservacoes"><span data-translate="netWordAgroApp.diariodebordo.arquivoobservacoes">Arquivoobservacoes</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipoincidencia"><span data-translate="netWordAgroApp.diariodebordo.tipoincidencia">Tipoincidencia</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="propriedade.nomepropriedade"><span data-translate="netWordAgroApp.diariodebordo.propriedade">Propriedade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="safra.nomesafra"><span data-translate="netWordAgroApp.diariodebordo.safra">Safra</span> <span class="glyphicon glyphicon-sort"></span></th><th>Enviado por</th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="diariodebordo in vm.diariodebordos track by diariodebordo.id"><td><a ui-sref="diariodebordo-detail({id:diariodebordo.id})">{{diariodebordo.id}}</a></td><td>{{diariodebordo.dataavaliacao}}</td><td><button class="btn btn-info btn-sm" ng-click="vm.downloadDiario(diariodebordo.id)"><span class="glyphicon glyphicon-download-alt"></span> <span class="hidden-sm-down">Download Di\xE1rio</span></button></td><td><button class="btn btn-info btn-sm" ng-click="vm.downloadObservacoes(diariodebordo.id)"><span class="glyphicon glyphicon-download-alt"></span> <span class="hidden-sm-down">Download Observa\xE7\xF5es</span></button></td><td>{{diariodebordo.tipoincidencia}}</td><td><a ui-sref="propriedade-detail({id:diariodebordo.propriedade_id})">{{diariodebordo.propriedade_nomepropriedade}}</a></td><td><a ui-sref="safra-detail({id:diariodebordo.safra_id})">{{diariodebordo.safra_nomesafra}}</a></td><td>{{diariodebordo.usuario}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="diariodebordo-detail({id:diariodebordo.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="diariodebordo.edit({id:diariodebordo.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="diariodebordo.delete({id:diariodebordo.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/empresaparceira/empresaparceira-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.empresaparceira.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.empresaparceira.delete.question" translate-values="{id: \'{{vm.empresaparceira.id}}\'}">Are you sure you want to delete this Empresaparceira?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/empresaparceira/empresaparceira-detail.html','<div><h2><span data-translate="netWordAgroApp.empresaparceira.detail.title">Empresaparceira</span> {{vm.empresaparceira.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.empresaparceira.nome">Nome</span></dt><dd><span>{{vm.empresaparceira.nome}}</span></dd><dt><span data-translate="netWordAgroApp.empresaparceira.tiporegistro">Tiporegistro</span></dt><dd><span>{{vm.empresaparceira.tiporegistro}}</span></dd><dt><span data-translate="netWordAgroApp.empresaparceira.cnpjregistro">Cnpjregistro</span></dt><dd><span>{{vm.empresaparceira.cnpjregistro}}</span></dd><dt><span data-translate="netWordAgroApp.empresaparceira.email">Email</span></dt><dd><span>{{vm.empresaparceira.email}}</span></dd><dt><span data-translate="netWordAgroApp.empresaparceira.telefone">Telefone</span></dt><dd><span>{{vm.empresaparceira.telefone}}</span></dd><dt><span data-translate="netWordAgroApp.empresaparceira.enderecofisico">Enderecofisico</span></dt><dd><span>{{vm.empresaparceira.enderecofisico}}</span></dd><dt><span data-translate="netWordAgroApp.empresaparceira.siteempresa">Siteempresa</span></dt><dd><span>{{vm.empresaparceira.siteempresa}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="empresaparceira-detail.edit({id:vm.empresaparceira.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/empresaparceira/empresaparceira-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEmpresaparceiraLabel" data-translate="netWordAgroApp.empresaparceira.home.createOrEditLabel">Create or edit a Empresaparceira</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.empresaparceira.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.empresaparceira.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.empresaparceira.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.empresaparceira.nome" required><div ng-show="editForm.nome.$invalid"><p class="help-block" ng-show="editForm.nome.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.empresaparceira.tiporegistro" for="field_tiporegistro">Tiporegistro</label><input type="text" class="form-control" name="tiporegistro" id="field_tiporegistro" ng-model="vm.empresaparceira.tiporegistro" required><div ng-show="editForm.tiporegistro.$invalid"><p class="help-block" ng-show="editForm.tiporegistro.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.empresaparceira.cnpjregistro" for="field_cnpjregistro">Cnpjregistro</label><input type="text" class="form-control" name="cnpjregistro" id="field_cnpjregistro" ng-model="vm.empresaparceira.cnpjregistro" required><div ng-show="editForm.cnpjregistro.$invalid"><p class="help-block" ng-show="editForm.cnpjregistro.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.empresaparceira.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.empresaparceira.email" required><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.empresaparceira.telefone" for="field_telefone">Telefone</label><input type="text" class="form-control" name="telefone" id="field_telefone" ng-model="vm.empresaparceira.telefone" required><div ng-show="editForm.telefone.$invalid"><p class="help-block" ng-show="editForm.telefone.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.empresaparceira.enderecofisico" for="field_enderecofisico">Enderecofisico</label><input type="text" class="form-control" name="enderecofisico" id="field_enderecofisico" ng-model="vm.empresaparceira.enderecofisico" required><div ng-show="editForm.enderecofisico.$invalid"><p class="help-block" ng-show="editForm.enderecofisico.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.empresaparceira.siteempresa" for="field_siteempresa">Siteempresa</label><input type="text" class="form-control" name="siteempresa" id="field_siteempresa" ng-model="vm.empresaparceira.siteempresa"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/empresaparceira/empresaparceiras.html','<div><h2 data-translate="netWordAgroApp.empresaparceira.home.title">Empresaparceiras</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="empresaparceira.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.empresaparceira.home.createLabel">Create new Empresaparceira</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.empresaparceira.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.empresaparceira.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tiporegistro"><span data-translate="netWordAgroApp.empresaparceira.tiporegistro">Tiporegistro</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cnpjregistro"><span data-translate="netWordAgroApp.empresaparceira.cnpjregistro">Cnpjregistro</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="netWordAgroApp.empresaparceira.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="telefone"><span data-translate="netWordAgroApp.empresaparceira.telefone">Telefone</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="enderecofisico"><span data-translate="netWordAgroApp.empresaparceira.enderecofisico">Enderecofisico</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="siteempresa"><span data-translate="netWordAgroApp.empresaparceira.siteempresa">Siteempresa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="empresaparceira in vm.empresaparceiras track by empresaparceira.id"><td><a ui-sref="empresaparceira-detail({id:empresaparceira.id})">{{empresaparceira.id}}</a></td><td>{{empresaparceira.nome}}</td><td>{{empresaparceira.tiporegistro}}</td><td>{{empresaparceira.cnpjregistro}}</td><td>{{empresaparceira.email}}</td><td>{{empresaparceira.telefone}}</td><td>{{empresaparceira.enderecofisico}}</td><td>{{empresaparceira.siteempresa}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="empresaparceira-detail({id:empresaparceira.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="empresaparceira.edit({id:empresaparceira.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="empresaparceira.delete({id:empresaparceira.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/entregasafracomerctestem/entregasafracomerctestem-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.entregasafracomerctestem.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.entregasafracomerctestem.delete.question" translate-values="{id: \'{{vm.entregasafracomerctestem.id}}\'}">Are you sure you want to delete this Entregasafracomerctestem?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/entregasafracomerctestem/entregasafracomerctestem-detail.html','<div><h2><span data-translate="netWordAgroApp.entregasafracomerctestem.detail.title">Entregasafracomerctestem</span> {{vm.entregasafracomerctestem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.entregasafracomerctestem.data">Data</span></dt><dd><span>{{vm.entregasafracomerctestem.data | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.entregasafracomerctestem.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.entregasafracomerctestem.etapa.id})">{{vm.entregasafracomerctestem.etapa.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="entregasafracomerctestem-detail.edit({id:vm.entregasafracomerctestem.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.entregasafracomerctestem.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.entregasafracomerctestem.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/entregasafracomerctestem/entregasafracomerctestem-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myentregasafracomerctestemLabel" data-translate="netWordAgroApp.entregasafracomerctestem.home.createOrEditLabel">Create or edit a entregasafracomerctestem</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.entregasafracomerctestem.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.entregasafracomerctestem.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.entregasafracomerctestem.$invalid"><p class="help-block" ng-show="editForm.entregasafracomerctestem.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.entregasafracomerctestem.data" for="field_data">data</label><div class="input-group"><input id="field_data" type="text" class="form-control" name="data" uib-datepicker-popup="{{dateformat}}" ng-model="vm.entregasafracomerctestem.data" is-open="vm.datePickerOpenStatus.data" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'data\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.data.$invalid"><p class="help-block" ng-show="editForm.data.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.entregasafracomerctestem.datafim" for="field_datafim">Datafim</label><div class="input-group"><input id="field_datafim" type="text" class="form-control" name="datafim" uib-datepicker-popup="{{dateformat}}" ng-model="vm.entregasafracomerctestem.datafim" is-open="vm.datePickerOpenStatus.datafim" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datafim\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datafim.$invalid"><p class="help-block" ng-show="editForm.datafim.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.entregasafracomerctestem.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.entregasafracomerctestem.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div><!--\n        <div class="form-group">\n            <label data-translate="netWordAgroApp.entregasafracomerctestem.etapa" for="field_etapa">Etapa</label>\n            <select class="form-control" id="field_etapa" name="etapa" ng-model="vm.entregasafracomerctestem.etapa" ng-options="etapa as etapa.nomeetapa for etapa in vm.etapas track by etapa.id">\n                <option value=""></option>\n            </select>\n        </div>\n    --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/entregasafracomerctestem/entregasafracomerctestems.html','<div><h2 data-translate="netWordAgroApp.entregasafracomerctestem.home.title">Entregasafracomerctestems</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="entregasafracomerctestem.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.entregasafracomerctestem.home.createLabel">Create new Entregasafracomerctestem</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.entregasafracomerctestem.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="data"><span data-translate="netWordAgroApp.entregasafracomerctestem.data">Data</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datafim"><span data-translate="netWordAgroApp.entregasafracomerctestem.datafim">Datafim</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.id"><span data-translate="netWordAgroApp.entregasafracomerctestem.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="entregasafracomerctestem in vm.entregasafracomerctestems track by entregasafracomerctestem.id"><td><a ui-sref="entregasafracomerctestem-detail({id:entregasafracomerctestem.id})">{{entregasafracomerctestem.id}}</a></td><td>{{entregasafracomerctestem.data | date:\'mediumDate\'}}</td><td>{{entregasafracomerctestem.datafim | date:\'mediumDate\'}}</td><td><a ui-sref="etapa-detail({id:entregasafracomerctestem.etapa.id})">{{entregasafracomerctestem.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="entregasafracomerctestem-detail({id:entregasafracomerctestem.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="entregasafracomerctestem.edit({id:entregasafracomerctestem.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="entregasafracomerctestem.delete({id:entregasafracomerctestem.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/entregasafracomercplan/entregasafracomercplan-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.entregasafracomercplan.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.entregasafracomercplan.delete.question" translate-values="{id: \'{{vm.entregasafracomercplan.id}}\'}">Are you sure you want to delete this Entregasafracomercplan?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/entregasafracomercplan/entregasafracomercplan-detail.html','<div><h2><span data-translate="netWordAgroApp.entregasafracomercplan.detail.title">Entregasafracomercplan</span> {{vm.entregasafracomercplan.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.entregasafracomercplan.datainicio">Datainicio</span></dt><dd><span>{{vm.entregasafracomercplan.datainicio | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.entregasafracomercplan.datatermino">Datatermino</span></dt><dd><span>{{vm.entregasafracomercplan.datatermino | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.entregasafracomercplan.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.entregasafracomercplan.safra.id})">{{vm.entregasafracomercplan.safra.nomesafra}}</a></dd><dt><span data-translate="netWordAgroApp.entregasafracomercplan.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.entregasafracomercplan.etapa.id})">{{vm.entregasafracomercplan.etapa.nomeetapa}}</a></dd></dl><button type="submit" ui-sref="entregasafracomercplan" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="entregasafracomercplan-detail.edit({id:vm.entregasafracomercplan.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.entregasafracomercplan.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.entregasafracomercplan.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/entregasafracomercplan/entregasafracomercplan-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEntregasafracomercplanLabel" data-translate="netWordAgroApp.entregasafracomercplan.home.createOrEditLabel">Create or edit a Entregasafracomercplan</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.entregasafracomercplan.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.entregasafracomercplan.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.entregasafracomercplan.$invalid"><p class="help-block" ng-show="editForm.entregasafracomercplan.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.entregasafracomercplan.datainicio" for="field_datainicio">Datainicio</label><div class="input-group"><input id="field_datainicio" type="text" class="form-control" name="datainicio" uib-datepicker-popup="{{dateformat}}" ng-model="vm.entregasafracomercplan.datainicio" is-open="vm.datePickerOpenStatus.datainicio" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datainicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datainicio.$invalid"><p class="help-block" ng-show="editForm.datainicio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.entregasafracomercplan.datatermino" for="field_datatermino">Datatermino</label><div class="input-group"><input id="field_datatermino" type="text" class="form-control" name="datatermino" uib-datepicker-popup="{{dateformat}}" ng-model="vm.entregasafracomercplan.datatermino" is-open="vm.datePickerOpenStatus.datatermino" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datatermino\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datatermino.$invalid"><p class="help-block" ng-show="editForm.datatermino.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.entregasafracomercplan.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.entregasafracomercplan.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div><!--\n        <div class="form-group">\n            <label data-translate="netWordAgroApp.entregasafracomercplan.etapa" for="field_etapa">Etapa</label>\n            <select class="form-control" id="field_etapa" name="etapa" ng-model="vm.entregasafracomercplan.etapa" ng-options="etapa as etapa.nomeetapa for etapa in vm.etapas track by etapa.id">\n                <option value=""></option>\n            </select>\n        </div>\n    --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/entregasafracomercplan/entregasafracomercplans.html','<div><h2 data-translate="netWordAgroApp.entregasafracomercplan.home.title">Entregasafracomercplans</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="entregasafracomercplan.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.entregasafracomercplan.home.createLabel">Create new Entregasafracomercplan</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.entregasafracomercplan.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.entregasafracomercplan.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.entregasafracomercplan.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.entregasafracomercplan.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="entregasafracomercplan in vm.entregasafracomercplans track by entregasafracomercplan.id"><td><a ui-sref="entregasafracomercplan-detail({id:entregasafracomercplan.id})">{{entregasafracomercplan.id}}</a></td><td>{{entregasafracomercplan.datainicio | date:\'mediumDate\'}}</td><td>{{entregasafracomercplan.datatermino | date:\'mediumDate\'}}</td><td><a ui-sref="etapa-detail({id:entregasafracomercplan.etapa.id})">{{entregasafracomercplan.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="entregasafracomercplan-detail({id:entregasafracomercplan.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="entregasafracomercplan.edit({id:entregasafracomercplan.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="entregasafracomercplan.delete({id:entregasafracomercplan.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/estado/estado-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.estado.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.estado.delete.question" translate-values="{id: \'{{vm.estado.id}}\'}">Are you sure you want to delete this Estado?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/estado/estado-detail.html','<div><h2><span data-translate="netWordAgroApp.estado.detail.title">Estado</span> {{vm.estado.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.estado.nomeestado">Nomeestado</span></dt><dd><span>{{vm.estado.nomeestado}}</span></dd><dt><span data-translate="netWordAgroApp.estado.siglaestado">Siglaestado</span></dt><dd><span>{{vm.estado.siglaestado}}</span></dd><dt><span data-translate="netWordAgroApp.estado.imagemestado">Imagemestado</span></dt><dd><div ng-if="vm.estado.imagemestado"><a ng-click="vm.openFile(vm.estado.imagemestadoContentType, vm.estado.imagemestado)"><img data-ng-src="{{\'data:\' + vm.estado.imagemestadoContentType + \';base64,\' + vm.estado.imagemestado}}" style="max-width: 100%" alt="estado image"> </a>{{vm.estado.imagemestadoContentType}}, {{vm.byteSize(vm.estado.imagemestado)}}</div></dd><dt><span data-translate="netWordAgroApp.estado.regiao">Regiao</span></dt><dd><a ui-sref="regiao-detail({id:vm.estado.regiao.id})">{{vm.estado.regiao.nomeregiao}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="estado-detail.edit({id:vm.estado.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/estado/estado-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEstadoLabel" data-translate="netWordAgroApp.estado.home.createOrEditLabel">Create or edit a Estado</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.estado.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.estado.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.estado.nomeestado" for="field_nomeestado">Nomeestado</label><input type="text" class="form-control" name="nomeestado" id="field_nomeestado" ng-model="vm.estado.nomeestado" required ng-maxlength="20"><div ng-show="editForm.nomeestado.$invalid"><p class="help-block" ng-show="editForm.nomeestado.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nomeestado.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.estado.siglaestado" for="field_siglaestado">Siglaestado</label><input type="text" class="form-control" name="siglaestado" id="field_siglaestado" ng-model="vm.estado.siglaestado" required ng-maxlength="3"><div ng-show="editForm.siglaestado.$invalid"><p class="help-block" ng-show="editForm.siglaestado.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.siglaestado.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="3">This field cannot be longer than 3 characters.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setImagemestado($file, vm.estado)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="netWordAgroApp.estado.imagemestado" for="field_imagemestado">Imagemestado</label><div><img data-ng-src="{{\'data:\' + vm.estado.imagemestadoContentType + \';base64,\' + vm.estado.imagemestado}}" style="max-height: 100px" ng-if="vm.estado.imagemestado" alt="estado image"><div ng-if="vm.estado.imagemestado" class="help-block clearfix"><span class="pull-left">{{vm.estado.imagemestadoContentType}}, {{vm.byteSize(vm.estado.imagemestado)}}</span> <button type="button" ng-click="vm.estado.imagemestado=null;vm.estado.imagemestadoContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setImagemestado($file, vm.estado)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="imagemestado" id="field_imagemestado" ng-model="vm.estado.imagemestado"> <input type="hidden" class="form-control" name="imagemestadoContentType" id="field_imagemestadoContentType" ng-model="vm.estado.imagemestadoContentType"></div><div class="form-group"><label data-translate="netWordAgroApp.estado.regiao" for="field_regiao">Regiao</label><select class="form-control" id="field_regiao" name="regiao" ng-model="vm.estado.regiao" ng-options="regiao as regiao.nomeregiao for regiao in vm.regiaos track by regiao.id" required></select></div><div ng-show="editForm.regiao.$invalid"><p class="help-block" ng-show="editForm.regiao.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/estado/estados.html','<div><h2 data-translate="netWordAgroApp.estado.home.title">Estados</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="estado.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.estado.home.createLabel">Create new Estado</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.estado.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomeestado"><span data-translate="netWordAgroApp.estado.nomeestado">Nomeestado</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="siglaestado"><span data-translate="netWordAgroApp.estado.siglaestado">Siglaestado</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="imagemestado"><span data-translate="netWordAgroApp.estado.imagemestado">Imagemestado</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="regiao.nomeregiao"><span data-translate="netWordAgroApp.estado.regiao">Regiao</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="estado in vm.estados track by estado.id"><td><a ui-sref="estado-detail({id:estado.id})">{{estado.id}}</a></td><td>{{estado.nomeestado}}</td><td>{{estado.siglaestado}}</td><td><a ng-if="estado.imagemestado" ng-click="vm.openFile(estado.imagemestadoContentType, estado.imagemestado)"><img data-ng-src="{{\'data:\' + estado.imagemestadoContentType + \';base64,\' + estado.imagemestado}}" style="max-height: 30px" alt="estado image"> </a><span ng-if="estado.imagemestado">{{estado.imagemestadoContentType}}, {{vm.byteSize(estado.imagemestado)}}</span></td><td><a ui-sref="regiao-detail({id:estado.regiao.id})">{{estado.regiao.nomeregiao}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="estado-detail({id:estado.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="estado.edit({id:estado.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="estado.delete({id:estado.id})" class="btn btn-danger btn-sm" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/fazenda/fazenda-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.fazenda.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.fazenda.delete.question" translate-values="{id: \'{{vm.fazenda.id}}\'}">Are you sure you want to delete this Fazenda?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/fazenda/fazenda-detail.html','<div><h2><span data-translate="netWordAgroApp.fazenda.detail.title">Fazenda</span> {{vm.fazenda.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.fazenda.nome">Nome</span></dt><dd><span>{{vm.fazenda.nome}}</span></dd><dt><span data-translate="netWordAgroApp.fazenda.cidade">Cidade</span></dt><dd><a ui-sref="cidade-detail({id:vm.fazenda.cidade.id})">{{vm.fazenda.cidade.nomecidade}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="fazenda-detail.edit({id:vm.fazenda.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/fazenda/fazenda-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFazendaLabel" data-translate="netWordAgroApp.fazenda.home.createOrEditLabel">Create or edit a Fazenda</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.fazenda.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.fazenda.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.fazenda.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.fazenda.nome" required><div ng-show="editForm.nome.$invalid"><p class="help-block" ng-show="editForm.nome.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.fazenda.cidade" for="field_cidade">Cidade</label><select class="form-control" id="field_cidade" name="cidade" ng-model="vm.fazenda.cidade" ng-options="cidade as cidade.nomecidade for cidade in vm.cidades track by cidade.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/fazenda/fazendas.html','<div><h2 data-translate="netWordAgroApp.fazenda.home.title">Fazendas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="fazenda.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.fazenda.home.createLabel">Create new Fazenda</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.fazenda.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.fazenda.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cidade.nomecidade"><span data-translate="netWordAgroApp.fazenda.cidade">Cidade</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="fazenda in vm.fazendas track by fazenda.id"><td><a ui-sref="fazenda-detail({id:fazenda.id})">{{fazenda.id}}</a></td><td>{{fazenda.nome}}</td><td><a ui-sref="cidade-detail({id:fazenda.cidade.id})">{{fazenda.cidade.nomecidade}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="fazenda-detail({id:fazenda.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="fazenda.edit({id:fazenda.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="fazenda.delete({id:fazenda.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/etapa/etapa-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.etapa.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.etapa.delete.question" translate-values="{id: \'{{vm.etapa.id}}\'}">Are you sure you want to delete this Etapa?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/etapa/etapa-detail.html','<div><h2><span data-translate="netWordAgroApp.etapa.detail.title">Etapa</span> {{vm.etapa.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.etapa.tipoetapa">Tipoetapa</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipoetapa.\' + vm.etapa.tipoetapa}}">{{vm.etapa.tipoetapa}}</span></dd><dt><span data-translate="netWordAgroApp.etapa.nomeetapa">Nomeetapa</span></dt><dd><span>{{vm.etapa.nomeetapa}}</span></dd><dt><span data-translate="netWordAgroApp.etapa.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.etapa.safra.id})">{{vm.etapa.safra.nomesafra}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="etapa-detail.edit({id:vm.etapa.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/etapa/etapa-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEtapaLabel" data-translate="netWordAgroApp.etapa.home.createOrEditLabel">Create or edit a Etapa</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.etapa.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.etapa.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.tipoetapa" for="field_tipoetapa">Tipoetapa</label><select class="form-control" name="tipoetapa" ng-model="vm.etapa.tipoetapa" id="field_tipoetapa" required><option value="logrecinsumo" data-translate="netWordAgroApp.Tipoetapa.logrecinsumo">logrecinsumo</option><option value="logrecinsumoplan" data-translate="netWordAgroApp.Tipoetapa.logrecinsumoplan">logrecinsumoplan</option><option value="logentregaarmaz" data-translate="netWordAgroApp.Tipoetapa.logentregaarmaz">logentregaarmaz</option><option value="logentregaarmazplan" data-translate="netWordAgroApp.Tipoetapa.logentregaarmazplan">logentregaarmazplan</option><option value="entregasafracomerc" data-translate="netWordAgroApp.Tipoetapa.entregasafracomerc">entregasafracomerc</option><option value="entregasafracomercplan" data-translate="netWordAgroApp.Tipoetapa.entregasafracomercplan">entregasafracomercplan</option><option value="comercializacao" data-translate="netWordAgroApp.Tipoetapa.comercializacao">comercializacao</option><option value="comercializacaoplan" data-translate="netWordAgroApp.Tipoetapa.comercializacaoplan">comercializacaoplan</option><option value="manutencaosafra" data-translate="netWordAgroApp.Tipoetapa.manutencaosafra">manutencaosafra</option><option value="manutencaosafraplan" data-translate="netWordAgroApp.Tipoetapa.manutencaosafraplan">manutencaosafraplan</option><option value="armazenamentosafra" data-translate="netWordAgroApp.Tipoetapa.armazenamentosafra">armazenamentosafra</option><option value="armazenamentosafraplan" data-translate="netWordAgroApp.Tipoetapa.armazenamentosafraplan">armazenamentosafraplan</option><option value="colheita" data-translate="netWordAgroApp.Tipoetapa.colheita">colheita</option><option value="colheitaplan" data-translate="netWordAgroApp.Tipoetapa.colheitaplan">colheitaplan</option><option value="plantio" data-translate="netWordAgroApp.Tipoetapa.plantio">plantio</option><option value="plantioplan" data-translate="netWordAgroApp.Tipoetapa.plantioplan">plantioplan</option><option value="preplantio" data-translate="netWordAgroApp.Tipoetapa.preplantio">preplantio</option><option value="preplantioplan" data-translate="netWordAgroApp.Tipoetapa.preplantioplan">preplantioplan</option></select><div ng-show="editForm.tipoetapa.$invalid"><p class="help-block" ng-show="editForm.tipoetapa.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.nomeetapa.$invalid"><p class="help-block" ng-show="editForm.nomeetapa.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.etapa.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.etapa.safra" ng-options="safra as safra.nomesafra for safra in vm.safras track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/etapa/etapas.html','<div><h2 data-translate="netWordAgroApp.etapa.home.title">Etapas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="etapa.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.etapa.home.createLabel">Create new Etapa</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.etapa.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipoetapa"><span data-translate="netWordAgroApp.etapa.tipoetapa">Tipoetapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomeetapa"><span data-translate="netWordAgroApp.etapa.nomeetapa">Nomeetapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="safra.nomesafra"><span data-translate="netWordAgroApp.etapa.safra">Safra</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="etapa in vm.etapas track by etapa.id"><td><a ui-sref="etapa-detail({id:etapa.id})">{{etapa.id}}</a></td><td data-translate="{{\'netWordAgroApp.Tipoetapa.\' + etapa.tipoetapa}}">{{etapa.tipoetapa}}</td><td>{{etapa.nomeetapa}}</td><td><a ui-sref="safra-detail({id:etapa.safra.id})">{{etapa.safra.nomesafra}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="etapa-detail({id:etapa.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="etapa.edit({id:etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="etapa.delete({id:etapa.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/georeferenciamento/georeferenciamento-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.georeferenciamento.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.georeferenciamento.delete.question" translate-values="{id: \'{{vm.georeferenciamento.id}}\'}">Are you sure you want to delete this Georeferenciamento?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/georeferenciamento/georeferenciamento-detail.html','<div><h2><span data-translate="netWordAgroApp.georeferenciamento.detail.title">Georeferenciamento</span> {{vm.georeferenciamento.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.georeferenciamento.desposicao">Desposicao</span></dt><dd><span>{{vm.georeferenciamento.desposicao}}</span></dd><dt><span data-translate="netWordAgroApp.georeferenciamento.vallatitude">Vallatitude</span></dt><dd><span>{{vm.georeferenciamento.vallatitude}}</span></dd><dt><span data-translate="netWordAgroApp.georeferenciamento.vallongitude">Vallongitude</span></dt><dd><span>{{vm.georeferenciamento.vallongitude}}</span></dd><dt><span data-translate="netWordAgroApp.georeferenciamento.propriedade">Propriedade</span></dt><dd><a ui-sref="propriedade-detail({id:vm.georeferenciamento.propriedade.id})">{{vm.georeferenciamento.propriedade.nomepropriedade}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="georeferenciamento-detail.edit({id:vm.georeferenciamento.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/georeferenciamento/georeferenciamento-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myGeoreferenciamentoLabel" data-translate="netWordAgroApp.georeferenciamento.home.createOrEditLabel">Create or edit a Georeferenciamento</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.georeferenciamento.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.georeferenciamento.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.georeferenciamento.desposicao" for="field_desposicao">Desposicao</label><input type="text" class="form-control" name="desposicao" id="field_desposicao" ng-model="vm.georeferenciamento.desposicao" required ng-maxlength="50"><div ng-show="editForm.desposicao.$invalid"><p class="help-block" ng-show="editForm.desposicao.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.desposicao.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.georeferenciamento.vallatitude" for="field_vallatitude">Vallatitude</label><input type="text" class="form-control" name="vallatitude" id="field_vallatitude" ng-model="vm.georeferenciamento.vallatitude" required><div ng-show="editForm.vallatitude.$invalid"><p class="help-block" ng-show="editForm.vallatitude.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.georeferenciamento.vallongitude" for="field_vallongitude">Vallongitude</label><input type="text" class="form-control" name="vallongitude" id="field_vallongitude" ng-model="vm.georeferenciamento.vallongitude" required><div ng-show="editForm.vallongitude.$invalid"><p class="help-block" ng-show="editForm.vallongitude.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.georeferenciamento.propriedade" for="field_propriedade">Propriedade</label><select class="form-control" id="field_propriedade" name="propriedade" ng-model="vm.georeferenciamento.propriedade" ng-options="propriedade as propriedade.nomepropriedade for propriedade in vm.propriedades track by propriedade.id" required></select></div><div ng-show="editForm.propriedade.$invalid"><p class="help-block" ng-show="editForm.propriedade.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/georeferenciamento/georeferenciamentos.html','<div><h2 data-translate="netWordAgroApp.georeferenciamento.home.title">Georeferenciamentos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="georeferenciamento.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.georeferenciamento.home.createLabel">Create new Georeferenciamento</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.georeferenciamento.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="desposicao"><span data-translate="netWordAgroApp.georeferenciamento.desposicao">Desposicao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="vallatitude"><span data-translate="netWordAgroApp.georeferenciamento.vallatitude">Vallatitude</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="vallongitude"><span data-translate="netWordAgroApp.georeferenciamento.vallongitude">Vallongitude</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="propriedade.nomepropriedade"><span data-translate="netWordAgroApp.georeferenciamento.propriedade">Propriedade</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="georeferenciamento in vm.georeferenciamentos track by georeferenciamento.id"><td><a ui-sref="georeferenciamento-detail({id:georeferenciamento.id})">{{georeferenciamento.id}}</a></td><td>{{georeferenciamento.desposicao}}</td><td>{{georeferenciamento.vallatitude}}</td><td>{{georeferenciamento.vallongitude}}</td><td><a ui-sref="propriedade-detail({id:georeferenciamento.propriedade.id})">{{georeferenciamento.propriedade.nomepropriedade}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="georeferenciamento-detail({id:georeferenciamento.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="georeferenciamento.edit({id:georeferenciamento.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="georeferenciamento.delete({id:georeferenciamento.id})" class="btn btn-danger btn-sm" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/gestor/gestor-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.gestor.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.gestor.delete.question" translate-values="{id: \'{{vm.gestor.id}}\'}">Are you sure you want to delete this Gestor?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/gestor/gestor-detail.html','<div><h2><span data-translate="netWordAgroApp.gestor.detail.title">Gestor</span> {{vm.gestor.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.gestor.nome">Nome</span></dt><dd><span>{{vm.gestor.nome}}</span></dd><dt><span data-translate="netWordAgroApp.gestor.sobrenome">Sobrenome</span></dt><dd><span>{{vm.gestor.sobrenome}}</span></dd><dt><span data-translate="netWordAgroApp.gestor.email">Email</span></dt><dd><span>{{vm.gestor.email}}</span></dd><dt><span data-translate="netWordAgroApp.gestor.foto">Foto</span></dt><dd><div ng-if="vm.gestor.foto"><a ng-click="vm.openFile(vm.gestor.fotoContentType, vm.gestor.foto)"><img data-ng-src="{{\'data:\' + vm.gestor.fotoContentType + \';base64,\' + vm.gestor.foto}}" style="max-width: 100%" alt="gestor image"> </a>{{vm.gestor.fotoContentType}}, {{vm.byteSize(vm.gestor.foto)}}</div></dd><dt><span data-translate="netWordAgroApp.gestor.login">Login</span></dt><dd><span>{{vm.gestor.login}}</span></dd><dt><span data-translate="netWordAgroApp.gestor.cpf">Cpf</span></dt><dd><span>{{vm.gestor.cpf}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="gestor-detail.edit({id:vm.gestor.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/gestor/gestor-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myGestorLabel" data-translate="netWordAgroApp.gestor.home.createOrEditLabel">Create or edit a Gestor</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.gestor.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.gestor.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.gestor.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.gestor.nome"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.gestor.sobrenome" for="field_sobrenome">Sobrenome</label><input type="text" class="form-control" name="sobrenome" id="field_sobrenome" ng-model="vm.gestor.sobrenome"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.gestor.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.gestor.email"></div><div class="form-group" ngf-drop ngf-change="vm.setFoto($file, vm.gestor)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="netWordAgroApp.gestor.foto" for="field_foto">Foto</label><div><img data-ng-src="{{\'data:\' + vm.gestor.fotoContentType + \';base64,\' + vm.gestor.foto}}" style="max-height: 100px" ng-if="vm.gestor.foto" alt="gestor image"><div ng-if="vm.gestor.foto" class="help-block clearfix"><span class="pull-left">{{vm.gestor.fotoContentType}}, {{vm.byteSize(vm.gestor.foto)}}</span> <button type="button" ng-click="vm.gestor.foto=null;vm.gestor.fotoContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setFoto($file, vm.gestor)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="foto" id="field_foto" ng-model="vm.gestor.foto"> <input type="hidden" class="form-control" name="fotoContentType" id="field_fotoContentType" ng-model="vm.gestor.fotoContentType"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.gestor.login" for="field_login">Login</label><input type="text" class="form-control" name="login" id="field_login" ng-model="vm.gestor.login"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.gestor.cpf" for="field_cpf">Cpf</label><input type="text" class="form-control" name="cpf" id="field_cpf" ng-model="vm.gestor.cpf"></div><div class="form-group"><label data-translate="netWordAgroApp.gestor.unidades" for="field_propriedade">Unidades</label><select class="form-control" id="field_propriedade" name="propriedade" ng-model="vm.gestor.unidade" ng-options="unidade as unidade.nome for unidade in vm.unidades track by unidade.id" required multiple="multiple"></select></div><div ng-show="editForm.propriedade.$invalid"><p class="help-block" ng-show="editForm.propriedade.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/gestor/gestors.html','<div><h2 data-translate="netWordAgroApp.gestor.home.title">Gestors</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="gestor.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.gestor.home.createLabel">Create new Gestor</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.gestor.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.gestor.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sobrenome"><span data-translate="netWordAgroApp.gestor.sobrenome">Sobrenome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="netWordAgroApp.gestor.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="foto"><span data-translate="netWordAgroApp.gestor.foto">Foto</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="netWordAgroApp.gestor.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cpf"><span data-translate="netWordAgroApp.gestor.cpf">Cpf</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="gestor in vm.gestors track by gestor.id"><td><a ui-sref="gestor-detail({id:gestor.id})">{{gestor.id}}</a></td><td>{{gestor.nome}}</td><td>{{gestor.sobrenome}}</td><td>{{gestor.email}}</td><td><a ng-if="gestor.foto" ng-click="vm.openFile(gestor.fotoContentType, gestor.foto)"><img data-ng-src="{{\'data:\' + gestor.fotoContentType + \';base64,\' + gestor.foto}}" style="max-height: 30px" alt="gestor image"> </a><span ng-if="gestor.foto">{{gestor.fotoContentType}}, {{vm.byteSize(gestor.foto)}}</span></td><td>{{gestor.login}}</td><td>{{gestor.cpf}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="gestor-detail({id:gestor.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="gestor.edit({id:gestor.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="gestor.delete({id:gestor.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/imagemtermica/imagemtermica-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.imagemtermica.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.imagemtermica.delete.question" translate-values="{id: \'{{vm.imagemtermica.id}}\'}">Are you sure you want to delete this Imagemtermica?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/imagemtermica/imagemtermica-detail.html','<div><h2><span data-translate="netWordAgroApp.imagemtermica.detail.title">Imagemtermica</span> {{vm.imagemtermica.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.imagemtermica.nome">Nome</span></dt><dd><span>{{vm.imagemtermica.nome}}</span></dd><dt><span data-translate="netWordAgroApp.imagemtermica.data">Data</span></dt><dd><span>{{vm.imagemtermica.data | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.imagemtermica.latitude">Latitude</span></dt><dd><span>{{vm.imagemtermica.latitude}}</span></dd><dt><span data-translate="netWordAgroApp.imagemtermica.longitude">Longitude</span></dt><dd><span>{{vm.imagemtermica.longitude}}</span></dd><dt><span data-translate="netWordAgroApp.imagemtermica.tipopraga">Tipopraga</span></dt><dd><span>{{vm.imagemtermica.tipopraga}}</span></dd><dt><span data-translate="netWordAgroApp.imagemtermica.valortermico">Valortermico</span></dt><dd><span>{{vm.imagemtermica.valortermico}}</span></dd><dt><span data-translate="netWordAgroApp.imagemtermica.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.imagemtermica.safra.id})">{{vm.imagemtermica.safra.nomesafra}}</a></dd><dt><span data-translate="netWordAgroApp.imagemtermica.propriedade">Propriedade</span></dt><dd><a ui-sref="propriedade-detail({id:vm.imagemtermica.propriedade.id})">{{vm.imagemtermica.propriedade.nomepropriedade}}</a></dd><dt><span data-translate="netWordAgroApp.imagemtermica.mapaimagem">Mapaimagem</span></dt><dd><a ui-sref="mapaimagem-detail({id:vm.imagemtermica.mapaimagem.id})">{{vm.imagemtermica.mapaimagem.nomemapa}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="imagemtermica-detail.edit({id:vm.imagemtermica.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/imagemtermica/imagemtermica-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myImagemtermicaLabel" data-translate="netWordAgroApp.imagemtermica.home.createOrEditLabel">Create or edit a Imagemtermica</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.imagemtermica.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.imagemtermica.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.imagemtermica.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.imagemtermica.nome" required><div ng-show="editForm.nome.$invalid"><p class="help-block" ng-show="editForm.nome.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.imagemtermica.data" for="field_data">Data</label><div class="input-group"><input id="field_data" type="text" class="form-control" name="data" uib-datepicker-popup="{{dateformat}}" ng-model="vm.imagemtermica.data" is-open="vm.datePickerOpenStatus.data" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'data\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.data.$invalid"><p class="help-block" ng-show="editForm.data.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.imagemtermica.latitude" for="field_latitude">Latitude</label><input type="text" class="form-control" name="latitude" id="field_latitude" ng-model="vm.imagemtermica.latitude" required><div ng-show="editForm.latitude.$invalid"><p class="help-block" ng-show="editForm.latitude.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.imagemtermica.longitude" for="field_longitude">Longitude</label><input type="text" class="form-control" name="longitude" id="field_longitude" ng-model="vm.imagemtermica.longitude" required><div ng-show="editForm.longitude.$invalid"><p class="help-block" ng-show="editForm.longitude.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.imagemtermica.tipopraga" for="field_tipopraga">Tipopraga</label><input type="text" class="form-control" name="tipopraga" id="field_tipopraga" ng-model="vm.imagemtermica.tipopraga" required><div ng-show="editForm.tipopraga.$invalid"><p class="help-block" ng-show="editForm.tipopraga.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.imagemtermica.valortermico" for="field_valortermico">Valortermico</label><input type="number" class="form-control" name="valortermico" id="field_valortermico" ng-model="vm.imagemtermica.valortermico" required><div ng-show="editForm.valortermico.$invalid"><p class="help-block" ng-show="editForm.valortermico.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.valortermico.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.imagemtermica.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.imagemtermica.safra" ng-options="safra as safra.nomesafra for safra in vm.safras track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.imagemtermica.propriedade" for="field_propriedade">Propriedade</label><select class="form-control" id="field_propriedade" name="propriedade" ng-model="vm.imagemtermica.propriedade" ng-options="propriedade as propriedade.nomepropriedade for propriedade in vm.propriedades track by propriedade.id" required></select></div><div ng-show="editForm.propriedade.$invalid"><p class="help-block" ng-show="editForm.propriedade.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.imagemtermica.mapaimagem" for="field_mapaimagem">Mapaimagem</label><select class="form-control" id="field_mapaimagem" name="mapaimagem" ng-model="vm.imagemtermica.mapaimagem" ng-options="mapaimagem as mapaimagem.nomemapa for mapaimagem in vm.mapaimagems track by mapaimagem.id" required></select></div><div ng-show="editForm.mapaimagem.$invalid"><p class="help-block" ng-show="editForm.mapaimagem.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/imagemtermica/imagemtermicas.html','<div><h2 data-translate="netWordAgroApp.imagemtermica.home.title">Imagemtermicas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="imagemtermica.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.imagemtermica.home.createLabel">Create new Imagemtermica</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.imagemtermica.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.imagemtermica.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="data"><span data-translate="netWordAgroApp.imagemtermica.data">Data</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="latitude"><span data-translate="netWordAgroApp.imagemtermica.latitude">Latitude</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="longitude"><span data-translate="netWordAgroApp.imagemtermica.longitude">Longitude</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipopraga"><span data-translate="netWordAgroApp.imagemtermica.tipopraga">Tipopraga</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valortermico"><span data-translate="netWordAgroApp.imagemtermica.valortermico">Valortermico</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="safra.nomesafra"><span data-translate="netWordAgroApp.imagemtermica.safra">Safra</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="propriedade.nomepropriedade"><span data-translate="netWordAgroApp.imagemtermica.propriedade">Propriedade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="mapaimagem.nomemapa"><span data-translate="netWordAgroApp.imagemtermica.mapaimagem">Mapaimagem</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="imagemtermica in vm.imagemtermicas track by imagemtermica.id"><td><a ui-sref="imagemtermica-detail({id:imagemtermica.id})">{{imagemtermica.id}}</a></td><td>{{imagemtermica.nome}}</td><td>{{imagemtermica.data | date:\'mediumDate\'}}</td><td>{{imagemtermica.latitude}}</td><td>{{imagemtermica.longitude}}</td><td>{{imagemtermica.tipopraga}}</td><td>{{imagemtermica.valortermico}}</td><td><a ui-sref="safra-detail({id:imagemtermica.safra.id})">{{imagemtermica.safra.nomesafra}}</a></td><td><a ui-sref="propriedade-detail({id:imagemtermica.propriedade.id})">{{imagemtermica.propriedade.nomepropriedade}}</a></td><td><a ui-sref="mapaimagem-detail({id:imagemtermica.mapaimagem.id})">{{imagemtermica.mapaimagem.nomemapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="imagemtermica-detail({id:imagemtermica.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="imagemtermica.edit({id:imagemtermica.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="imagemtermica.delete({id:imagemtermica.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/indicadoreshabituais/indicadoreshabituais-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.indicadoreshabituais.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.indicadoreshabituais.delete.question" translate-values="{id: \'{{vm.indicadoreshabituais.id}}\'}">Are you sure you want to delete this Indicadoreshabituais?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/indicadoreshabituais/indicadoreshabituais-detail.html','<div><h2><span data-translate="netWordAgroApp.indicadoreshabituais.detail.title">Indicadoreshabituais</span> {{vm.indicadoreshabituais.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.indicadoreshabituais.produtividadehectare">Produtividadehectare</span></dt><dd><span>{{vm.indicadoreshabituais.produtividadehectare}}</span></dd><dt><span data-translate="netWordAgroApp.indicadoreshabituais.rentabilidadehectare">Rentabilidadehectare</span></dt><dd><span>{{vm.indicadoreshabituais.rentabilidadehectare}}</span></dd><dt><span data-translate="netWordAgroApp.indicadoreshabituais.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.indicadoreshabituais.safra.id})">{{vm.indicadoreshabituais.safra.nomesafra}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="indicadoreshabituais-detail.edit({id:vm.indicadoreshabituais.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/indicadoreshabituais/indicadoreshabituais-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myIndicadoreshabituaisLabel" data-translate="netWordAgroApp.indicadoreshabituais.home.createOrEditLabel">Create or edit a Indicadoreshabituais</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.indicadoreshabituais.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.indicadoreshabituais.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.indicadoreshabituais.produtividadehectare" for="field_produtividadehectare">Produtividadehectare</label><input type="number" class="form-control" name="produtividadehectare" id="field_produtividadehectare" ng-model="vm.indicadoreshabituais.produtividadehectare" min="0" required><div ng-show="editForm.produtividadehectare.$invalid"><p class="help-block" ng-show="editForm.produtividadehectare.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.produtividadehectare.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.indicadoreshabituais.rentabilidadehectare" for="field_rentabilidadehectare">Rentabilidadehectare</label><input type="number" class="form-control" name="rentabilidadehectare" id="field_rentabilidadehectare" ng-model="vm.indicadoreshabituais.rentabilidadehectare" min="0" required><div ng-show="editForm.rentabilidadehectare.$invalid"><p class="help-block" ng-show="editForm.rentabilidadehectare.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.rentabilidadehectare.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.indicadoreshabituais.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.indicadoreshabituais.safra" ng-options="safra as safra.nomesafra for safra in vm.safras track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/indicadoreshabituais/indicadoreshabituais.html','<div><h2 data-translate="netWordAgroApp.indicadoreshabituais.home.title">Indicadoreshabituais</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="indicadoreshabituais.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.indicadoreshabituais.home.createLabel">Create new Indicadoreshabituais</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.indicadoreshabituais.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="produtividadehectare"><span data-translate="netWordAgroApp.indicadoreshabituais.produtividadehectare">Produtividadehectare</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="rentabilidadehectare"><span data-translate="netWordAgroApp.indicadoreshabituais.rentabilidadehectare">Rentabilidadehectare</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="safra.nomesafra"><span data-translate="netWordAgroApp.indicadoreshabituais.safra">Safra</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="indicadoreshabituais in vm.indicadoreshabituais track by indicadoreshabituais.id"><td><a ui-sref="indicadoreshabituais-detail({id:indicadoreshabituais.id})">{{indicadoreshabituais.id}}</a></td><td>{{indicadoreshabituais.produtividadehectare}}</td><td>{{indicadoreshabituais.rentabilidadehectare}}</td><td><a ui-sref="safra-detail({id:indicadoreshabituais.safra.id})">{{indicadoreshabituais.safra.nomesafra}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="indicadoreshabituais-detail({id:indicadoreshabituais.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="indicadoreshabituais.edit({id:indicadoreshabituais.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="indicadoreshabituais.delete({id:indicadoreshabituais.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/indicadoresnw/indicadoresnw-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.indicadoresnw.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.indicadoresnw.delete.question" translate-values="{id: \'{{vm.indicadoresnw.id}}\'}">Are you sure you want to delete this Indicadoresnw?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/indicadoresnw/indicadoresnw-detail.html','<div><h2><span data-translate="netWordAgroApp.indicadoresnw.detail.title">Indicadoresnw</span> {{vm.indicadoresnw.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.indicadoresnw.produtividadehectare">Produtividadehectare</span></dt><dd><span>{{vm.indicadoresnw.produtividadehectare}}</span></dd><dt><span data-translate="netWordAgroApp.indicadoresnw.rentabilidadehectare">Rentabilidadehectare</span></dt><dd><span>{{vm.indicadoresnw.rentabilidadehectare}}</span></dd><dt><span data-translate="netWordAgroApp.indicadoresnw.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.indicadoresnw.safra.id})">{{vm.indicadoresnw.safra.nomesafra}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="indicadoresnw-detail.edit({id:vm.indicadoresnw.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/indicadoresnw/indicadoresnw-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myIndicadoresnwLabel" data-translate="netWordAgroApp.indicadoresnw.home.createOrEditLabel">Create or edit a Indicadoresnw</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.indicadoresnw.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.indicadoresnw.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.indicadoresnw.produtividadehectare" for="field_produtividadehectare">Produtividadehectare</label><input type="number" class="form-control" name="produtividadehectare" id="field_produtividadehectare" ng-model="vm.indicadoresnw.produtividadehectare" min="0" required><div ng-show="editForm.produtividadehectare.$invalid"><p class="help-block" ng-show="editForm.produtividadehectare.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.produtividadehectare.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.indicadoresnw.rentabilidadehectare" for="field_rentabilidadehectare">Rentabilidadehectare</label><input type="number" class="form-control" name="rentabilidadehectare" id="field_rentabilidadehectare" ng-model="vm.indicadoresnw.rentabilidadehectare" min="0" required><div ng-show="editForm.rentabilidadehectare.$invalid"><p class="help-block" ng-show="editForm.rentabilidadehectare.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.rentabilidadehectare.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.indicadoresnw.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.indicadoresnw.safra" ng-options="safra as safra.nomesafra for safra in vm.safras track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/indicadoresnw/indicadoresnws.html','<div><h2 data-translate="netWordAgroApp.indicadoresnw.home.title">Indicadoresnws</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="indicadoresnw.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.indicadoresnw.home.createLabel">Create new Indicadoresnw</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.indicadoresnw.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="produtividadehectare"><span data-translate="netWordAgroApp.indicadoresnw.produtividadehectare">Produtividadehectare</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="rentabilidadehectare"><span data-translate="netWordAgroApp.indicadoresnw.rentabilidadehectare">Rentabilidadehectare</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="safra.nomesafra"><span data-translate="netWordAgroApp.indicadoresnw.safra">Safra</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="indicadoresnw in vm.indicadoresnws track by indicadoresnw.id"><td><a ui-sref="indicadoresnw-detail({id:indicadoresnw.id})">{{indicadoresnw.id}}</a></td><td>{{indicadoresnw.produtividadehectare}}</td><td>{{indicadoresnw.rentabilidadehectare}}</td><td><a ui-sref="safra-detail({id:indicadoresnw.safra.id})">{{indicadoresnw.safra.nomesafra}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="indicadoresnw-detail({id:indicadoresnw.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="indicadoresnw.edit({id:indicadoresnw.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="indicadoresnw.delete({id:indicadoresnw.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/localarmazenamento/localarmazenamento-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.localarmazenamento.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.localarmazenamento.delete.question" translate-values="{id: \'{{vm.localarmazenamento.id}}\'}">Are you sure you want to delete this Localarmazenamento?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/localarmazenamento/localarmazenamento-detail.html','<div><h2><span data-translate="netWordAgroApp.localarmazenamento.detail.title">Localarmazenamento</span> {{vm.localarmazenamento.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.localarmazenamento.nomelocal">Nomelocal</span></dt><dd><span>{{vm.localarmazenamento.nomelocal}}</span></dd><dt><span data-translate="netWordAgroApp.localarmazenamento.tipolocalarmaz">Tipolocalarmaz</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipolocalarmazenamento.\' + vm.localarmazenamento.tipolocalarmaz}}">{{vm.localarmazenamento.tipolocalarmaz}}</span></dd><dt><span data-translate="netWordAgroApp.localarmazenamento.capacidade">Capacidade</span></dt><dd><span>{{vm.localarmazenamento.capacidade}}</span></dd><dt><span data-translate="netWordAgroApp.localarmazenamento.medidacapacidade">Medidacapacidade</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipomedidacapacidade.\' + vm.localarmazenamento.medidacapacidade}}">{{vm.localarmazenamento.medidacapacidade}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="localarmazenamento-detail.edit({id:vm.localarmazenamento.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/localarmazenamento/localarmazenamento-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myLocalarmazenamentoLabel" data-translate="netWordAgroApp.localarmazenamento.home.createOrEditLabel">Create or edit a Localarmazenamento</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.localarmazenamento.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.localarmazenamento.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.localarmazenamento.nomelocal" for="field_nomelocal">Nomelocal</label><input type="text" class="form-control" name="nomelocal" id="field_nomelocal" ng-model="vm.localarmazenamento.nomelocal" required><div ng-show="editForm.nomelocal.$invalid"><p class="help-block" ng-show="editForm.nomelocal.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.localarmazenamento.tipolocalarmaz" for="field_tipolocalarmaz">Tipolocalarmaz</label><select class="form-control" name="tipolocalarmaz" ng-model="vm.localarmazenamento.tipolocalarmaz" id="field_tipolocalarmaz" required><option value="silo" data-translate="netWordAgroApp.Tipolocalarmazenamento.silo">silo</option><option value="galpao" data-translate="netWordAgroApp.Tipolocalarmazenamento.galpao">galpao</option><option value="estoque" data-translate="netWordAgroApp.Tipolocalarmazenamento.estoque">estoque</option><option value="outro" data-translate="netWordAgroApp.Tipolocalarmazenamento.outro">outro</option></select><div ng-show="editForm.tipolocalarmaz.$invalid"><p class="help-block" ng-show="editForm.tipolocalarmaz.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.localarmazenamento.capacidade" for="field_capacidade">Capacidade</label><input type="number" class="form-control" name="capacidade" id="field_capacidade" ng-model="vm.localarmazenamento.capacidade" required min="0"><div ng-show="editForm.capacidade.$invalid"><p class="help-block" ng-show="editForm.capacidade.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.capacidade.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.capacidade.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.localarmazenamento.medidacapacidade" for="field_medidacapacidade">Medidacapacidade</label><select class="form-control" name="medidacapacidade" ng-model="vm.localarmazenamento.medidacapacidade" id="field_medidacapacidade" required><option value="saca" data-translate="netWordAgroApp.Tipomedidacapacidade.saca">saca</option><option value="kg" data-translate="netWordAgroApp.Tipomedidacapacidade.kg">kg</option><option value="ton" data-translate="netWordAgroApp.Tipomedidacapacidade.ton">ton</option><option value="l" data-translate="netWordAgroApp.Tipomedidacapacidade.l">l</option></select><div ng-show="editForm.medidacapacidade.$invalid"><p class="help-block" ng-show="editForm.medidacapacidade.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/localarmazenamento/localarmazenamentos.html','<div><h2 data-translate="netWordAgroApp.localarmazenamento.home.title">Localarmazenamentos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="localarmazenamento.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.localarmazenamento.home.createLabel">Create new Localarmazenamento</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.localarmazenamento.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomelocal"><span data-translate="netWordAgroApp.localarmazenamento.nomelocal">Nomelocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocalarmaz"><span data-translate="netWordAgroApp.localarmazenamento.tipolocalarmaz">Tipolocalarmaz</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="capacidade"><span data-translate="netWordAgroApp.localarmazenamento.capacidade">Capacidade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="medidacapacidade"><span data-translate="netWordAgroApp.localarmazenamento.medidacapacidade">Medidacapacidade</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="localarmazenamento in vm.localarmazenamentos track by localarmazenamento.id"><td><a ui-sref="localarmazenamento-detail({id:localarmazenamento.id})">{{localarmazenamento.id}}</a></td><td>{{localarmazenamento.nomelocal}}</td><td data-translate="{{\'netWordAgroApp.Tipolocalarmazenamento.\' + localarmazenamento.tipolocalarmaz}}">{{localarmazenamento.tipolocalarmaz}}</td><td>{{localarmazenamento.capacidade}}</td><td data-translate="{{\'netWordAgroApp.Tipomedidacapacidade.\' + localarmazenamento.medidacapacidade}}">{{localarmazenamento.medidacapacidade}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="localarmazenamento-detail({id:localarmazenamento.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="localarmazenamento.edit({id:localarmazenamento.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button><!--<button type="submit"\n                                    ui-sref="localarmazenamento.delete({id:localarmazenamento.id})"\n                                    class="btn btn-danger btn-sm">\n                                <span class="glyphicon glyphicon-remove-circle"></span>\n                                <span class="hidden-sm-down" data-translate="entity.action.delete"></span>\n                            </button>--></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/insumo/insumo-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.insumo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.insumo.delete.question" translate-values="{id: \'{{vm.insumo.id}}\'}">Are you sure you want to delete this Insumo?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/insumo/insumo-detail.html','<div><h2><span data-translate="netWordAgroApp.insumo.detail.title">Insumo</span> {{vm.insumo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.insumo.nome">Nome</span></dt><dd><span>{{vm.insumo.nome}}</span></dd><dt><span data-translate="netWordAgroApp.insumo.dataentrada">Dataentrada</span></dt><dd><span>{{vm.insumo.dataentrada | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.insumo.quantidadearmazenada">Quantidadearmazenada</span></dt><dd><span>{{vm.insumo.quantidadearmazenada}}</span></dd><dt><span data-translate="netWordAgroApp.insumo.quantidadedisponivel">Quantidadedisponivel</span></dt><dd><span>{{vm.insumo.quantidadedisponivel}}</span></dd><dt><span data-translate="netWordAgroApp.insumo.localarmazenamento">Localarmazenamento</span></dt><dd><a ui-sref="localarmazenamento-detail({id:vm.insumo.localarmazenamento.id})">{{vm.insumo.localarmazenamento.nomelocal}}</a></dd><dt><span data-translate="netWordAgroApp.insumo.aquisicao">Aquisicao</span></dt><dd><a ui-sref="aquisicao-detail({id:vm.insumo.aquisicao.id})">{{vm.insumo.aquisicao.produtoaquisitado}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="insumo-detail.edit({id:vm.insumo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/insumo/insumo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInsumoLabel" data-translate="netWordAgroApp.insumo.home.createOrEditLabel">Create or edit a Insumo</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.insumo.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.insumo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.insumo.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.insumo.nome" required><div ng-show="editForm.nome.$invalid"><p class="help-block" ng-show="editForm.nome.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.insumo.dataentrada" for="field_dataentrada">Dataentrada</label><div class="input-group"><input id="field_dataentrada" type="text" class="form-control" name="dataentrada" uib-datepicker-popup="{{dateformat}}" ng-model="vm.insumo.dataentrada" is-open="vm.datePickerOpenStatus.dataentrada" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataentrada\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.dataentrada.$invalid"><p class="help-block" ng-show="editForm.dataentrada.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.insumo.quantidadearmazenada" for="field_quantidadearmazenada">Quantidadearmazenada</label><input type="number" class="form-control" name="quantidadearmazenada" id="field_quantidadearmazenada" ng-model="vm.insumo.quantidadearmazenada" required min="0" max="{{vm.restante}}" ng-change="vm.mudaMax()"><div ng-show="editForm.quantidadearmazenada.$invalid"><p class="help-block" ng-show="editForm.quantidadearmazenada.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.quantidadearmazenada.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.quantidadearmazenada.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.insumo.quantidadedisponivel" for="field_quantidadedisponivel">Quantidadedisponivel</label><input type="number" class="form-control" name="quantidadedisponivel" id="field_quantidadedisponivel" ng-model="vm.insumo.quantidadedisponivel" required min="0" max="{{vm.maxarmazenado}}"><div ng-show="editForm.quantidadedisponivel.$invalid"><p class="help-block" ng-show="editForm.quantidadedisponivel.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.quantidadedisponivel.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.quantidadedisponivel.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.insumo.localarmazenamento" for="field_localarmazenamento">Localarmazenamento</label><select class="form-control" id="field_localarmazenamento" name="localarmazenamento" ng-model="vm.insumo.localarmazenamento" ng-options="localarmazenamento as localarmazenamento.nomelocal for localarmazenamento in vm.localarmazenamentos track by localarmazenamento.id" required></select></div><div ng-show="editForm.localarmazenamento.$invalid"><p class="help-block" ng-show="editForm.localarmazenamento.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.insumo.aquisicao" for="field_aquisicao">Aquisicao</label><select class="form-control" id="field_aquisicao" name="aquisicao" ng-model="vm.insumo.aquisicao" ng-options="aquisicao as aquisicao.produtoaquisitado for aquisicao in vm.aquisicaos track by aquisicao.id" required></select></div><div ng-show="editForm.aquisicao.$invalid"><p class="help-block" ng-show="editForm.aquisicao.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/insumo/insumos.html','<div><h2 data-translate="netWordAgroApp.insumo.home.title">Insumos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="insumo.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.insumo.home.createLabel">Create new Insumo</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.insumo.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.insumo.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dataentrada"><span data-translate="netWordAgroApp.insumo.dataentrada">Dataentrada</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quantidadearmazenada"><span data-translate="netWordAgroApp.insumo.quantidadearmazenada">Quantidadearmazenada</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quantidadedisponivel"><span data-translate="netWordAgroApp.insumo.quantidadedisponivel">Quantidadedisponivel</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.insumo.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="aquisicao.produtoaquisitado"><span data-translate="netWordAgroApp.insumo.aquisicao">Aquisicao</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="insumo in vm.insumos track by insumo.id"><td><a ui-sref="insumo-detail({id:insumo.id})">{{insumo.id}}</a></td><td>{{insumo.nome}}</td><td>{{insumo.dataentrada | date:\'mediumDate\'}}</td><td>{{insumo.quantidadearmazenada}}</td><td>{{insumo.quantidadedisponivel}}</td><td><a ui-sref="localarmazenamento-detail({id:insumo.localarmazenamento.id})">{{insumo.localarmazenamento.nomelocal}}</a></td><td><a ui-sref="aquisicao-detail({id:insumo.aquisicao.id})">{{insumo.aquisicao.produtoaquisitado}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="insumo-detail({id:insumo.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="insumo.edit({id:insumo.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="insumo.delete({id:insumo.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/logentregaarmazplan/logentregaarmazplan-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.logentregaarmazplan.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.logentregaarmazplan.delete.question" translate-values="{id: \'{{vm.logentregaarmazplan.id}}\'}">Are you sure you want to delete this Logentregaarmazplan?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/logentregaarmazplan/logentregaarmazplan-detail.html','<div><h2><span data-translate="netWordAgroApp.logentregaarmazplan.detail.title">Logentregaarmazplan</span> {{vm.logentregaarmazplan.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.logentregaarmazplan.datainicio">Datainicio</span></dt><dd><span>{{vm.logentregaarmazplan.datainicio | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.logentregaarmazplan.datatermino">Datatermino</span></dt><dd><span>{{vm.logentregaarmazplan.datatermino | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.logentregaarmazplan.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.logentregaarmazplan.safra.id})">{{vm.logentregaarmazplan.safra.nomesafra}}</a></dd><dt><span data-translate="netWordAgroApp.logentregaarmazplan.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.logentregaarmazplan.etapa.id})">{{vm.logentregaarmazplan.etapa.nomeetapa}}</a></dd></dl><button type="submit" ui-sref="logentregaarmazplan" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="logentregaarmazplan-detail.edit({id:vm.logentregaarmazplan.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.logentregaarmazplan.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.logentregaarmazplan.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/logentregaarmazplan/logentregaarmazplan-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myLogentregaarmazplanLabel" data-translate="netWordAgroApp.logentregaarmazplan.home.createOrEditLabel">Create or edit a Logentregaarmazplan</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.logentregaarmazplan.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.logentregaarmazplan.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.logentregaarmazplan.$invalid"><p class="help-block" ng-show="editForm.logentregaarmazplan.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.logentregaarmazplan.datainicio" for="field_datainicio">Datainicio</label><div class="input-group"><input id="field_datainicio" type="text" class="form-control" name="datainicio" uib-datepicker-popup="{{dateformat}}" ng-model="vm.logentregaarmazplan.datainicio" is-open="vm.datePickerOpenStatus.datainicio" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datainicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datainicio.$invalid"><p class="help-block" ng-show="editForm.datainicio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.logentregaarmazplan.datatermino" for="field_datatermino">Datatermino</label><div class="input-group"><input id="field_datatermino" type="text" class="form-control" name="datatermino" uib-datepicker-popup="{{dateformat}}" ng-model="vm.logentregaarmazplan.datatermino" is-open="vm.datePickerOpenStatus.datatermino" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datatermino\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datatermino.$invalid"><p class="help-block" ng-show="editForm.datatermino.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.logentregaarmazplan.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.logentregaarmazplan.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div><!--\n        <div class="form-group">\n            <label data-translate="netWordAgroApp.logentregaarmazplan.etapa" for="field_etapa">Etapa</label>\n            <select class="form-control" id="field_etapa" name="etapa" ng-model="vm.logentregaarmazplan.etapa" ng-options="etapa as etapa.nomeetapa for etapa in vm.etapas track by etapa.id">\n                <option value=""></option>\n            </select>\n        </div>\n    --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/logentregaarmazplan/logentregaarmazplans.html','<div><h2 data-translate="netWordAgroApp.logentregaarmazplan.home.title">Logentregaarmazplans</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="logentregaarmazplan.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.logentregaarmazplan.home.createLabel">Create new Logentregaarmazplan</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.logentregaarmazplan.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.logentregaarmazplan.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.logentregaarmazplan.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.logentregaarmazplan.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="logentregaarmazplan in vm.logentregaarmazplans track by logentregaarmazplan.id"><td><a ui-sref="logentregaarmazplan-detail({id:logentregaarmazplan.id})">{{logentregaarmazplan.id}}</a></td><td>{{logentregaarmazplan.datainicio | date:\'mediumDate\'}}</td><td>{{logentregaarmazplan.datatermino | date:\'mediumDate\'}}</td><td><a ui-sref="etapa-detail({id:logentregaarmazplan.etapa.id})">{{logentregaarmazplan.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="logentregaarmazplan-detail({id:logentregaarmazplan.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="logentregaarmazplan.edit({id:logentregaarmazplan.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="logentregaarmazplan.delete({id:logentregaarmazplan.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/logentregaarmaz/logentregaarmaz-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.logentregaarmaz.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.logentregaarmaz.delete.question" translate-values="{id: \'{{vm.logentregaarmaz.id}}\'}">Are you sure you want to delete this Logentregaarmaz?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/logentregaarmaz/logentregaarmaz-detail.html','<div><h2><span data-translate="netWordAgroApp.logentregaarmaz.detail.title">Logentregaarmaz</span> {{vm.logentregaarmaz.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.logentregaarmaz.datainicio">Datainicio</span></dt><dd><span>{{vm.logentregaarmaz.datainicio | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.logentregaarmaz.datatermino">Datatermino</span></dt><dd><span>{{vm.logentregaarmaz.datatermino | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.logentregaarmaz.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.logentregaarmaz.safra.id})">{{vm.logentregaarmaz.safra.nomesafra}}</a></dd><dt><span data-translate="netWordAgroApp.logentregaarmaz.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.logentregaarmaz.etapa.id})">{{vm.logentregaarmaz.etapa.nomeetapa}}</a></dd></dl><button type="submit" ui-sref="logentregaarmaz" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="logentregaarmaz-detail.edit({id:vm.logentregaarmaz.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.logentregaarmaz.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.logentregaarmaz.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/logentregaarmaz/logentregaarmaz-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myLogentregaarmazLabel" data-translate="netWordAgroApp.logentregaarmaz.home.createOrEditLabel">Create or edit a Logentregaarmaz</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.logentregaarmaz.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.logentregaarmaz.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.logentregaarmaz.$invalid"><p class="help-block" ng-show="editForm.logentregaarmaz.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.logentregaarmaz.datainicio" for="field_datainicio">Datainicio</label><div class="input-group"><input id="field_datainicio" type="text" class="form-control" name="datainicio" uib-datepicker-popup="{{dateformat}}" ng-model="vm.logentregaarmaz.datainicio" is-open="vm.datePickerOpenStatus.datainicio" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datainicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datainicio.$invalid"><p class="help-block" ng-show="editForm.datainicio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.logentregaarmaz.datatermino" for="field_datatermino">Datatermino</label><div class="input-group"><input id="field_datatermino" type="text" class="form-control" name="datatermino" uib-datepicker-popup="{{dateformat}}" ng-model="vm.logentregaarmaz.datatermino" is-open="vm.datePickerOpenStatus.datatermino" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datatermino\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datatermino.$invalid"><p class="help-block" ng-show="editForm.datatermino.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.logentregaarmaz.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.logentregaarmaz.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div><!--\n        <div class="form-group">\n            <label data-translate="netWordAgroApp.logentregaarmaz.etapa" for="field_etapa">Etapa</label>\n            <select class="form-control" id="field_etapa" name="etapa" ng-model="vm.logentregaarmaz.etapa" ng-options="etapa as etapa.nomeetapa for etapa in vm.etapas track by etapa.id">\n                <option value=""></option>\n            </select>\n        </div>\n    --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/logentregaarmaz/logentregaarmazs.html','<div><h2 data-translate="netWordAgroApp.logentregaarmaz.home.title">Logentregaarmazs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="logentregaarmaz.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.logentregaarmaz.home.createLabel">Create new Logentregaarmaz</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.logentregaarmaz.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.logentregaarmaz.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.logentregaarmaz.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.logentregaarmaz.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="logentregaarmaz in vm.logentregaarmazs track by logentregaarmaz.id"><td><a ui-sref="logentregaarmaz-detail({id:logentregaarmaz.id})">{{logentregaarmaz.id}}</a></td><td>{{logentregaarmaz.datainicio | date:\'mediumDate\'}}</td><td>{{logentregaarmaz.datatermino | date:\'mediumDate\'}}</td><td><a ui-sref="etapa-detail({id:logentregaarmaz.etapa.id})">{{logentregaarmaz.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="logentregaarmaz-detail({id:logentregaarmaz.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="logentregaarmaz.edit({id:logentregaarmaz.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="logentregaarmaz.delete({id:logentregaarmaz.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/logentregaarmaztestem/logentregaarmaztestem-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.logentregaarmaztestem.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.logentregaarmaztestem.delete.question" translate-values="{id: \'{{vm.logentregaarmaztestem.id}}\'}">Are you sure you want to delete this Logentregaarmaztestem?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/logentregaarmaztestem/logentregaarmaztestem-detail.html','<div><h2><span data-translate="netWordAgroApp.logentregaarmaztestem.detail.title">Logentregaarmaztestem</span> {{vm.logentregaarmaztestem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.logentregaarmaztestem.datainicio">Datainicio</span></dt><dd><span>{{vm.logentregaarmaztestem.datainicio | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.logentregaarmaztestem.datatermino">Datatermino</span></dt><dd><span>{{vm.logentregaarmaztestem.datatermino | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.logentregaarmaztestem.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.logentregaarmaztestem.etapa.id})">{{vm.logentregaarmaztestem.etapa.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="logentregaarmaztestem-detail.edit({id:vm.logentregaarmaztestem.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.logentregaarmaztestem.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.logentregaarmaztestem.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/logentregaarmaztestem/logentregaarmaztestem-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mylogentregaarmaztestemLabel" data-translate="netWordAgroApp.logentregaarmaztestem.home.createOrEditLabel">Create or edit a logentregaarmaztestem</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.logentregaarmaztestem.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.logentregaarmaztestem.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.logentregaarmaztestem.$invalid"><p class="help-block" ng-show="editForm.logentregaarmaztestem.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.logentregaarmaztestem.datainicio" for="field_datainicio">Datainicio</label><div class="input-group"><input id="field_datainicio" type="text" class="form-control" name="datainicio" uib-datepicker-popup="{{dateformat}}" ng-model="vm.logentregaarmaztestem.datainicio" is-open="vm.datePickerOpenStatus.datainicio" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datainicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datainicio.$invalid"><p class="help-block" ng-show="editForm.datainicio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.logentregaarmaztestem.datatermino" for="field_datatermino">Datatermino</label><div class="input-group"><input id="field_datatermino" type="text" class="form-control" name="datatermino" uib-datepicker-popup="{{dateformat}}" ng-model="vm.logentregaarmaztestem.datatermino" is-open="vm.datePickerOpenStatus.datatermino" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datatermino\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datatermino.$invalid"><p class="help-block" ng-show="editForm.datatermino.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.logentregaarmaztestem.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.logentregaarmaztestem.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div><!--\n        <div class="form-group">\n            <label data-translate="netWordAgroApp.logentregaarmaztestem.etapa" for="field_etapa">Etapa</label>\n            <select class="form-control" id="field_etapa" name="etapa" ng-model="vm.logentregaarmaztestem.etapa" ng-options="etapa as etapa.nomeetapa for etapa in vm.etapas track by etapa.id">\n                <option value=""></option>\n            </select>\n        </div>\n    --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/logentregaarmaztestem/logentregaarmaztestems.html','<div><h2 data-translate="netWordAgroApp.logentregaarmaztestem.home.title">Logentregaarmaztestems</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="logentregaarmaztestem.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.logentregaarmaztestem.home.createLabel">Create new Logentregaarmaztestem</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.logentregaarmaztestem.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.logentregaarmaztestem.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.logentregaarmaztestem.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.id"><span data-translate="netWordAgroApp.logentregaarmaztestem.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="logentregaarmaztestem in vm.logentregaarmaztestems track by logentregaarmaztestem.id"><td><a ui-sref="logentregaarmaztestem-detail({id:logentregaarmaztestem.id})">{{logentregaarmaztestem.id}}</a></td><td>{{logentregaarmaztestem.datainicio | date:\'mediumDate\'}}</td><td>{{logentregaarmaztestem.datatermino | date:\'mediumDate\'}}</td><td><a ui-sref="etapa-detail({id:logentregaarmaztestem.etapa.id})">{{logentregaarmaztestem.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="logentregaarmaztestem-detail({id:logentregaarmaztestem.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="logentregaarmaztestem.edit({id:logentregaarmaztestem.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="logentregaarmaztestem.delete({id:logentregaarmaztestem.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/logrecinsumo/logrecinsumo-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.logrecinsumo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.logrecinsumo.delete.question" translate-values="{id: \'{{vm.logrecinsumo.id}}\'}">Are you sure you want to delete this Logrecinsumo?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/logrecinsumo/logrecinsumo-detail.html','<div><h2><span data-translate="netWordAgroApp.logrecinsumo.detail.title">Logrecinsumo</span> {{vm.logrecinsumo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.logrecinsumo.datainicio">Datainicio</span></dt><dd><span>{{vm.logrecinsumo.datainicio | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.logrecinsumo.datatermino">Datatermino</span></dt><dd><span>{{vm.logrecinsumo.datatermino | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.logrecinsumo.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.logrecinsumo.safra.id})">{{vm.logrecinsumo.safra.nomesafra}}</a></dd><dt><span data-translate="netWordAgroApp.logrecinsumo.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.logrecinsumo.etapa.id})">{{vm.logrecinsumo.etapa.nomeetapa}}</a></dd></dl><button type="submit" ui-sref="logrecinsumo" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="logrecinsumo-detail.edit({id:vm.logrecinsumo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.logrecinsumo.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.logrecinsumo.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/logrecinsumo/logrecinsumo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myLogrecinsumoLabel" data-translate="netWordAgroApp.logrecinsumo.home.createOrEditLabel">Create or edit a Logrecinsumo</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.logrecinsumo.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.logrecinsumo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.logrecinsumo.$invalid"><p class="help-block" ng-show="editForm.logrecinsumo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.logrecinsumo.datainicio" for="field_datainicio">Datainicio</label><div class="input-group"><input id="field_datainicio" type="text" class="form-control" name="datainicio" uib-datepicker-popup="{{dateformat}}" ng-model="vm.logrecinsumo.datainicio" is-open="vm.datePickerOpenStatus.datainicio" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datainicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datainicio.$invalid"><p class="help-block" ng-show="editForm.datainicio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.logrecinsumo.datatermino" for="field_datatermino">Datatermino</label><div class="input-group"><input id="field_datatermino" type="text" class="form-control" name="datatermino" uib-datepicker-popup="{{dateformat}}" ng-model="vm.logrecinsumo.datatermino" is-open="vm.datePickerOpenStatus.datatermino" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datatermino\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datatermino.$invalid"><p class="help-block" ng-show="editForm.datatermino.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.logrecinsumo.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.logrecinsumo.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div><!--\n        <div class="form-group">\n            <label data-translate="netWordAgroApp.logrecinsumo.etapa" for="field_etapa">Etapa</label>\n            <select class="form-control" id="field_etapa" name="etapa" ng-model="vm.logrecinsumo.etapa" ng-options="etapa as etapa.nomeetapa for etapa in vm.etapas track by etapa.id">\n                <option value=""></option>\n            </select>\n        </div>\n    --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/logrecinsumo/logrecinsumos.html','<div><h2 data-translate="netWordAgroApp.logrecinsumo.home.title">Logrecinsumos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="logrecinsumo.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.logrecinsumo.home.createLabel">Create new Logrecinsumo</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.logrecinsumo.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.logrecinsumo.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.logrecinsumo.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.logrecinsumo.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="logrecinsumo in vm.logrecinsumos track by logrecinsumo.id"><td><a ui-sref="logrecinsumo-detail({id:logrecinsumo.id})">{{logrecinsumo.id}}</a></td><td>{{logrecinsumo.datainicio | date:\'mediumDate\'}}</td><td>{{logrecinsumo.datatermino | date:\'mediumDate\'}}</td><td><a ui-sref="etapa-detail({id:logrecinsumo.etapa.id})">{{logrecinsumo.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="logrecinsumo-detail({id:logrecinsumo.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="logrecinsumo.edit({id:logrecinsumo.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="logrecinsumo.delete({id:logrecinsumo.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/manutencaosafra/manutencaosafra-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.manutencaosafra.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.manutencaosafra.delete.question" translate-values="{id: \'{{vm.manutencaosafra.id}}\'}">Are you sure you want to delete this Manutencaosafra?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/manutencaosafra/manutencaosafra-detail.html','<div><h2><span data-translate="netWordAgroApp.manutencaosafra.detail.title">Manutencaosafra</span> {{vm.manutencaosafra.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.manutencaosafra.datainicio">Datainicio</span></dt><dd><span>{{vm.manutencaosafra.datainicio | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.manutencaosafra.datatermino">Datatermino</span></dt><dd><span>{{vm.manutencaosafra.datatermino | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.manutencaosafra.descricaomanutencao">Descricaomanutencao</span></dt><dd><span>{{vm.manutencaosafra.descricaomanutencao}}</span></dd><dt><span data-translate="netWordAgroApp.manutencaosafra.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.manutencaosafra.safra.id})">{{vm.manutencaosafra.safra.nomesafra}}</a></dd><dt><span data-translate="netWordAgroApp.manutencaosafra.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.manutencaosafra.etapa.id})">{{vm.manutencaosafra.etapa.nomeetapa}}</a></dd></dl><button type="submit" ui-sref="manutencaosafra" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="manutencaosafra-detail.edit({id:vm.manutencaosafra.id})" class="btn btn-primary" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div has-authority="ROLE_ADMIN"><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.manutencaosafra.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.manutencaosafra.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/manutencaosafra/manutencaosafra-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myManutencaosafraLabel" data-translate="netWordAgroApp.manutencaosafra.home.createOrEditLabel">Create or edit a Manutencaosafra</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.manutencaosafra.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.manutencaosafra.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.manutencaosafra.$invalid"><p class="help-block" ng-show="editForm.manutencaosafra.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.manutencaosafra.datainicio" for="field_datainicio">Datainicio</label><div class="input-group"><input id="field_datainicio" type="text" class="form-control" name="datainicio" uib-datepicker-popup="{{dateformat}}" ng-model="vm.manutencaosafra.datainicio" is-open="vm.datePickerOpenStatus.datainicio" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datainicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datainicio.$invalid"><p class="help-block" ng-show="editForm.datainicio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.manutencaosafra.datatermino" for="field_datatermino">Datatermino</label><div class="input-group"><input id="field_datatermino" type="text" class="form-control" name="datatermino" uib-datepicker-popup="{{dateformat}}" ng-model="vm.manutencaosafra.datatermino" is-open="vm.datePickerOpenStatus.datatermino" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datatermino\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datatermino.$invalid"><p class="help-block" ng-show="editForm.datatermino.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.manutencaosafra.descricaomanutencao" for="field_descricaomanutencao">Descricaomanutencao</label><input type="text" class="form-control" name="descricaomanutencao" id="field_descricaomanutencao" ng-model="vm.manutencaosafra.descricaomanutencao" required><div ng-show="editForm.descricaomanutencao.$invalid"><p class="help-block" ng-show="editForm.descricaomanutencao.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.manutencaosafra.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.manutencaosafra.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div><!--\n        <div class="form-group">\n            <label data-translate="netWordAgroApp.manutencaosafra.etapa" for="field_etapa">Etapa</label>\n            <select class="form-control" id="field_etapa" name="etapa" ng-model="vm.manutencaosafra.etapa" ng-options="etapa as etapa.nomeetapa for etapa in vm.etapas track by etapa.id">\n                <option value=""></option>\n            </select>\n        </div>\n    --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/manutencaosafra/manutencaosafras.html','<div><h2 data-translate="netWordAgroApp.manutencaosafra.home.title">Manutencaosafras</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="manutencaosafra.new" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.manutencaosafra.home.createLabel">Create new Manutencaosafra</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline" has-authority="ROLE_ADMIN"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.manutencaosafra.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.manutencaosafra.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.manutencaosafra.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricaomanutencao"><span data-translate="netWordAgroApp.manutencaosafra.descricaomanutencao">Descricaomanutencao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.manutencaosafra.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="manutencaosafra in vm.manutencaosafras track by manutencaosafra.id"><td><a ui-sref="manutencaosafra-detail({id:manutencaosafra.id})">{{manutencaosafra.id}}</a></td><td>{{manutencaosafra.datainicio | date:\'mediumDate\'}}</td><td>{{manutencaosafra.datatermino | date:\'mediumDate\'}}</td><td>{{manutencaosafra.descricaomanutencao}}</td><td><a ui-sref="etapa-detail({id:manutencaosafra.etapa.id})">{{manutencaosafra.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="manutencaosafra-detail({id:manutencaosafra.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="manutencaosafra.edit({id:manutencaosafra.id})" class="btn btn-primary btn-sm" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="manutencaosafra.delete({id:manutencaosafra.id})" class="btn btn-danger btn-sm" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/logrecinsumoplan/logrecinsumoplan-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.logrecinsumoplan.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.logrecinsumoplan.delete.question" translate-values="{id: \'{{vm.logrecinsumoplan.id}}\'}">Are you sure you want to delete this Logrecinsumoplan?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/logrecinsumoplan/logrecinsumoplan-detail.html','<div><h2><span data-translate="netWordAgroApp.logrecinsumoplan.detail.title">Logrecinsumoplan</span> {{vm.logrecinsumoplan.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.logrecinsumoplan.datainicio">Datainicio</span></dt><dd><span>{{vm.logrecinsumoplan.datainicio | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.logrecinsumoplan.datatermino">Datatermino</span></dt><dd><span>{{vm.logrecinsumoplan.datatermino | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.logrecinsumoplan.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.logrecinsumoplan.safra.id})">{{vm.logrecinsumoplan.safra.nomesafra}}</a></dd><dt><span data-translate="netWordAgroApp.logrecinsumoplan.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.logrecinsumoplan.etapa.id})">{{vm.logrecinsumoplan.etapa.nomeetapa}}</a></dd></dl><button type="submit" ui-sref="logrecinsumoplan" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="logrecinsumoplan-detail.edit({id:vm.logrecinsumoplan.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.logrecinsumoplan.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.logrecinsumoplan.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/logrecinsumoplan/logrecinsumoplan-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myLogrecinsumoplanLabel" data-translate="netWordAgroApp.logrecinsumoplan.home.createOrEditLabel">Create or edit a Logrecinsumoplan</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.logrecinsumoplan.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.logrecinsumoplan.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.logrecinsumoplan.$invalid"><p class="help-block" ng-show="editForm.logrecinsumoplan.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.logrecinsumoplan.datainicio" for="field_datainicio">Datainicio</label><div class="input-group"><input id="field_datainicio" type="text" class="form-control" name="datainicio" uib-datepicker-popup="{{dateformat}}" ng-model="vm.logrecinsumoplan.datainicio" is-open="vm.datePickerOpenStatus.datainicio" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datainicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datainicio.$invalid"><p class="help-block" ng-show="editForm.datainicio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.logrecinsumoplan.datatermino" for="field_datatermino">Datatermino</label><div class="input-group"><input id="field_datatermino" type="text" class="form-control" name="datatermino" uib-datepicker-popup="{{dateformat}}" ng-model="vm.logrecinsumoplan.datatermino" is-open="vm.datePickerOpenStatus.datatermino" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datatermino\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datatermino.$invalid"><p class="help-block" ng-show="editForm.datatermino.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.logrecinsumoplan.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.logrecinsumoplan.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div><!--\n        <div class="form-group">\n            <label data-translate="netWordAgroApp.logrecinsumoplan.etapa" for="field_etapa">Etapa</label>\n            <select class="form-control" id="field_etapa" name="etapa" ng-model="vm.logrecinsumoplan.etapa" ng-options="etapa as etapa.nomeetapa for etapa in vm.etapas track by etapa.id">\n                <option value=""></option>\n            </select>\n        </div>\n    --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/logrecinsumoplan/logrecinsumoplans.html','<div><h2 data-translate="netWordAgroApp.logrecinsumoplan.home.title">Logrecinsumoplans</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="logrecinsumoplan.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.logrecinsumoplan.home.createLabel">Create new Logrecinsumoplan</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.logrecinsumoplan.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.logrecinsumoplan.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.logrecinsumoplan.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.logrecinsumoplan.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="logrecinsumoplan in vm.logrecinsumoplans track by logrecinsumoplan.id"><td><a ui-sref="logrecinsumoplan-detail({id:logrecinsumoplan.id})">{{logrecinsumoplan.id}}</a></td><td>{{logrecinsumoplan.datainicio | date:\'mediumDate\'}}</td><td>{{logrecinsumoplan.datatermino | date:\'mediumDate\'}}</td><td><a ui-sref="etapa-detail({id:logrecinsumoplan.etapa.id})">{{logrecinsumoplan.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="logrecinsumoplan-detail({id:logrecinsumoplan.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="logrecinsumoplan.edit({id:logrecinsumoplan.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="logrecinsumoplan.delete({id:logrecinsumoplan.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/logrecinsumotestem/logrecinsumotestem-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.logrecinsumotestem.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.logrecinsumotestem.delete.question" translate-values="{id: \'{{vm.logrecinsumotestem.id}}\'}">Are you sure you want to delete this Logrecinsumotestem?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/logrecinsumotestem/logrecinsumotestem-detail.html','<div><h2><span data-translate="netWordAgroApp.logrecinsumotestem.detail.title">Logrecinsumotestem</span> {{vm.logrecinsumotestem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.logrecinsumotestem.datainicio">Datainicio</span></dt><dd><span>{{vm.logrecinsumotestem.datainicio | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.logrecinsumotestem.datatermino">Datatermino</span></dt><dd><span>{{vm.logrecinsumotestem.datatermino | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.logrecinsumotestem.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.logrecinsumotestem.etapa.id})">{{vm.logrecinsumotestem.etapa.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="logrecinsumotestem-detail.edit({id:vm.logrecinsumotestem.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.logrecinsumotestem.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.logrecinsumotestem.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/logrecinsumotestem/logrecinsumotestem-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mylogrecinsumotestemLabel" data-translate="netWordAgroApp.logrecinsumotestem.home.createOrEditLabel">Create or edit a logrecinsumotestem</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.logrecinsumotestem.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.logrecinsumotestem.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.logrecinsumotestem.$invalid"><p class="help-block" ng-show="editForm.logrecinsumotestem.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.logrecinsumotestem.datainicio" for="field_datainicio">Datainicio</label><div class="input-group"><input id="field_datainicio" type="text" class="form-control" name="datainicio" uib-datepicker-popup="{{dateformat}}" ng-model="vm.logrecinsumotestem.datainicio" is-open="vm.datePickerOpenStatus.datainicio" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datainicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datainicio.$invalid"><p class="help-block" ng-show="editForm.datainicio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.logrecinsumotestem.datatermino" for="field_datatermino">Datatermino</label><div class="input-group"><input id="field_datatermino" type="text" class="form-control" name="datatermino" uib-datepicker-popup="{{dateformat}}" ng-model="vm.logrecinsumotestem.datatermino" is-open="vm.datePickerOpenStatus.datatermino" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datatermino\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datatermino.$invalid"><p class="help-block" ng-show="editForm.datatermino.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.logrecinsumotestem.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.logrecinsumotestem.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div><!--\n        <div class="form-group">\n            <label data-translate="netWordAgroApp.logrecinsumotestem.etapa" for="field_etapa">Etapa</label>\n            <select class="form-control" id="field_etapa" name="etapa" ng-model="vm.logrecinsumotestem.etapa" ng-options="etapa as etapa.nomeetapa for etapa in vm.etapas track by etapa.id">\n                <option value=""></option>\n            </select>\n        </div>\n    --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/logrecinsumotestem/logrecinsumotestems.html','<div><h2 data-translate="netWordAgroApp.logrecinsumotestem.home.title">Logrecinsumotestems</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="logrecinsumotestem.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.logrecinsumotestem.home.createLabel">Create new Logrecinsumotestem</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.logrecinsumotestem.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.logrecinsumotestem.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.logrecinsumotestem.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.id"><span data-translate="netWordAgroApp.logrecinsumotestem.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="logrecinsumotestem in vm.logrecinsumotestems track by logrecinsumotestem.id"><td><a ui-sref="logrecinsumotestem-detail({id:logrecinsumotestem.id})">{{logrecinsumotestem.id}}</a></td><td>{{logrecinsumotestem.datainicio | date:\'mediumDate\'}}</td><td>{{logrecinsumotestem.datatermino | date:\'mediumDate\'}}</td><td><a ui-sref="etapa-detail({id:logrecinsumotestem.etapa.id})">{{logrecinsumotestem.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="logrecinsumotestem-detail({id:logrecinsumotestem.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="logrecinsumotestem.edit({id:logrecinsumotestem.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="logrecinsumotestem.delete({id:logrecinsumotestem.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/manutencaosafratestem/manutencaosafratestem-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.manutencaosafratestem.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.manutencaosafratestem.delete.question" translate-values="{id: \'{{vm.manutencaosafratestem.id}}\'}">Are you sure you want to delete this Manutencaosafratestem?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/manutencaosafratestem/manutencaosafratestem-detail.html','<div><h2><span data-translate="netWordAgroApp.manutencaosafratestem.detail.title">Manutencaosafratestem</span> {{vm.manutencaosafratestem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.manutencaosafratestem.datainicio">Datainicio</span></dt><dd><span>{{vm.manutencaosafratestem.datainicio | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.manutencaosafratestem.datafim">Datafim</span></dt><dd><span>{{vm.manutencaosafratestem.datafim | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.manutencaosafratestem.descricaodamanutencao">Descricaodamanutencao</span></dt><dd><span>{{vm.manutencaosafratestem.descricaodamanutencao}}</span></dd><dt><span data-translate="netWordAgroApp.manutencaosafratestem.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.manutencaosafratestem.etapa.id})">{{vm.manutencaosafratestem.etapa.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="manutencaosafratestem-detail.edit({id:vm.manutencaosafratestem.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.manutencaosafratestem.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.manutencaosafratestem.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/manutencaosafratestem/manutencaosafratestem-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mymanutencaosafratestemLabel" data-translate="netWordAgroApp.manutencaosafratestem.home.createOrEditLabel">Create or edit a manutencaosafratestem</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.manutencaosafratestem.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.manutencaosafratestem.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.manutencaosafratestem.$invalid"><p class="help-block" ng-show="editForm.manutencaosafratestem.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.manutencaosafratestem.datainicio" for="field_datainicio">Datainicio</label><div class="input-group"><input id="field_datainicio" type="text" class="form-control" name="datainicio" uib-datepicker-popup="{{dateformat}}" ng-model="vm.manutencaosafratestem.datainicio" is-open="vm.datePickerOpenStatus.datainicio" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datainicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datainicio.$invalid"><p class="help-block" ng-show="editForm.datainicio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.manutencaosafratestem.datafim" for="field_datafim">datafim</label><div class="input-group"><input id="field_datafim" type="text" class="form-control" name="datafim" uib-datepicker-popup="{{dateformat}}" ng-model="vm.manutencaosafratestem.datafim" is-open="vm.datePickerOpenStatus.datafim" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datafim\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datafim.$invalid"><p class="help-block" ng-show="editForm.datafim.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.manutencaosafratestem.descricaodamanutencao" for="field_descricaodamanutencao">descricaodamanutencao</label><input type="text" class="form-control" name="descricaodamanutencao" id="field_descricaodamanutencao" ng-model="vm.manutencaosafratestem.descricaodamanutencao" required><div ng-show="editForm.descricaodamanutencao.$invalid"><p class="help-block" ng-show="editForm.descricaodamanutencao.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.manutencaosafratestem.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.manutencaosafratestem.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div><!--\n        <div class="form-group">\n            <label data-translate="netWordAgroApp.manutencaosafratestem.etapa" for="field_etapa">Etapa</label>\n            <select class="form-control" id="field_etapa" name="etapa" ng-model="vm.manutencaosafratestem.etapa" ng-options="etapa as etapa.nomeetapa for etapa in vm.etapas track by etapa.id">\n                <option value=""></option>\n            </select>\n        </div>\n    --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/manutencaosafratestem/manutencaosafratestems.html','<div><h2 data-translate="netWordAgroApp.manutencaosafratestem.home.title">Manutencaosafratestems</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="manutencaosafratestem.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.manutencaosafratestem.home.createLabel">Create new Manutencaosafratestem</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.manutencaosafratestem.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.manutencaosafratestem.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datafim"><span data-translate="netWordAgroApp.manutencaosafratestem.datafim">Datafim</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricaodamanutencao"><span data-translate="netWordAgroApp.manutencaosafratestem.descricaodamanutencao">Descricaodamanutencao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.id"><span data-translate="netWordAgroApp.manutencaosafratestem.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="manutencaosafratestem in vm.manutencaosafratestems track by manutencaosafratestem.id"><td><a ui-sref="manutencaosafratestem-detail({id:manutencaosafratestem.id})">{{manutencaosafratestem.id}}</a></td><td>{{manutencaosafratestem.datainicio | date:\'mediumDate\'}}</td><td>{{manutencaosafratestem.datafim | date:\'mediumDate\'}}</td><td>{{manutencaosafratestem.descricaodamanutencao}}</td><td><a ui-sref="etapa-detail({id:manutencaosafratestem.etapa.id})">{{manutencaosafratestem.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="manutencaosafratestem-detail({id:manutencaosafratestem.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="manutencaosafratestem.edit({id:manutencaosafratestem.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="manutencaosafratestem.delete({id:manutencaosafratestem.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/manutencaosafraplan/manutencaosafraplan-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.manutencaosafraplan.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.manutencaosafraplan.delete.question" translate-values="{id: \'{{vm.manutencaosafraplan.id}}\'}">Are you sure you want to delete this Manutencaosafraplan?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/manutencaosafraplan/manutencaosafraplan-detail.html','<div><h2><span data-translate="netWordAgroApp.manutencaosafraplan.detail.title">Manutencaosafraplan</span> {{vm.manutencaosafraplan.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.manutencaosafraplan.datainicio">Datainicio</span></dt><dd><span>{{vm.manutencaosafraplan.datainicio | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.manutencaosafraplan.datatermino">Datatermino</span></dt><dd><span>{{vm.manutencaosafraplan.datatermino | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.manutencaosafraplan.descricaomanutencao">Descricaomanutencao</span></dt><dd><span>{{vm.manutencaosafraplan.descricaomanutencao}}</span></dd><dt><span data-translate="netWordAgroApp.manutencaosafraplan.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.manutencaosafraplan.safra.id})">{{vm.manutencaosafraplan.safra.nomesafra}}</a></dd><dt><span data-translate="netWordAgroApp.manutencaosafraplan.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.manutencaosafraplan.etapa.id})">{{vm.manutencaosafraplan.etapa.nomeetapa}}</a></dd></dl><button type="submit" ui-sref="manutencaosafraplan" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="manutencaosafraplan-detail.edit({id:vm.manutencaosafraplan.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.manutencaosafraplan.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.manutencaosafraplan.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/manutencaosafraplan/manutencaosafraplan-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myManutencaosafraplanLabel" data-translate="netWordAgroApp.manutencaosafraplan.home.createOrEditLabel">Create or edit a Manutencaosafraplan</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.manutencaosafraplan.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.manutencaosafraplan.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.manutencaosafraplan.$invalid"><p class="help-block" ng-show="editForm.manutencaosafraplan.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.manutencaosafraplan.datainicio" for="field_datainicio">Datainicio</label><div class="input-group"><input id="field_datainicio" type="text" class="form-control" name="datainicio" uib-datepicker-popup="{{dateformat}}" ng-model="vm.manutencaosafraplan.datainicio" is-open="vm.datePickerOpenStatus.datainicio" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datainicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datainicio.$invalid"><p class="help-block" ng-show="editForm.datainicio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.manutencaosafraplan.datatermino" for="field_datatermino">Datatermino</label><div class="input-group"><input id="field_datatermino" type="text" class="form-control" name="datatermino" uib-datepicker-popup="{{dateformat}}" ng-model="vm.manutencaosafraplan.datatermino" is-open="vm.datePickerOpenStatus.datatermino" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datatermino\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datatermino.$invalid"><p class="help-block" ng-show="editForm.datatermino.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.manutencaosafraplan.descricaomanutencao" for="field_descricaomanutencao">Descricaomanutencao</label><input type="text" class="form-control" name="descricaomanutencao" id="field_descricaomanutencao" ng-model="vm.manutencaosafraplan.descricaomanutencao" required><div ng-show="editForm.descricaomanutencao.$invalid"><p class="help-block" ng-show="editForm.descricaomanutencao.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.manutencaosafraplan.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.manutencaosafraplan.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div><!--\n        <div class="form-group">\n            <label data-translate="netWordAgroApp.manutencaosafraplan.etapa" for="field_etapa">Etapa</label>\n            <select class="form-control" id="field_etapa" name="etapa" ng-model="vm.manutencaosafraplan.etapa" ng-options="etapa as etapa.nomeetapa for etapa in vm.etapas track by etapa.id">\n                <option value=""></option>\n            </select>\n        </div>\n    --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/manutencaosafraplan/manutencaosafraplans.html','<div><h2 data-translate="netWordAgroApp.manutencaosafraplan.home.title">Manutencaosafraplans</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="manutencaosafraplan.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.manutencaosafraplan.home.createLabel">Create new Manutencaosafraplan</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.manutencaosafraplan.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.manutencaosafraplan.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.manutencaosafraplan.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricaomanutencao"><span data-translate="netWordAgroApp.manutencaosafraplan.descricaomanutencao">Descricaomanutencao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.manutencaosafraplan.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="manutencaosafraplan in vm.manutencaosafraplans track by manutencaosafraplan.id"><td><a ui-sref="manutencaosafraplan-detail({id:manutencaosafraplan.id})">{{manutencaosafraplan.id}}</a></td><td>{{manutencaosafraplan.datainicio | date:\'mediumDate\'}}</td><td>{{manutencaosafraplan.datatermino | date:\'mediumDate\'}}</td><td>{{manutencaosafraplan.descricaomanutencao}}</td><td><a ui-sref="etapa-detail({id:manutencaosafraplan.etapa.id})">{{manutencaosafraplan.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="manutencaosafraplan-detail({id:manutencaosafraplan.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="manutencaosafraplan.edit({id:manutencaosafraplan.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="manutencaosafraplan.delete({id:manutencaosafraplan.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/mapaimagem/comparativo-mapas.html','<style>/* Style the tab */\r\n     .tab {\r\n         overflow: hidden;\r\n         border: 1px solid #ccc;\r\n         background-color: #f1f1f1;\r\n     }\r\n     \r\n     /* Style the buttons that are used to open the tab content */\r\n     .tab button {\r\n         background-color: inherit;\r\n         float: left;\r\n         border: none;\r\n         outline: none;\r\n         cursor: pointer;\r\n         padding: 14px 16px;\r\n         transition: 0.3s;\r\n     }\r\n     \r\n     /* Change background color of buttons on hover */\r\n     .tab button:hover {\r\n         background-color: #cce6ff;\r\n     }\r\n     \r\n     /* Create an active/current tablink class */\r\n     .tab button.active {\r\n         background-color: #b3daff;\r\n     }\r\n\r\n     #btncompmapas:disabled {\r\n         color: #a0a0a0;\r\n     }\r\n     \r\n     /* Style the tab content */\r\n     .tabcontent {\r\n         display: none;\r\n         padding: 6px 12px;\r\n         border: 1px solid #e6f3ff;\r\n         border-top: none;\r\n     }</style><script>function openTab(evt, tabName) {\r\n        console.log("openTab ");\r\n        var i, tabcontent, tablinks;\r\n        tabcontent = document.getElementsByClassName("tabcontent");\r\n        for (i = 0; i < tabcontent.length; i++) {\r\n            tabcontent[i].style.display = "none";\r\n        }\r\n        tablinks = document.getElementsByClassName("tablinks");\r\n        for (i = 0; i < tablinks.length; i++) {\r\n            tablinks[i].className = tablinks[i].className.replace(" active", "");\r\n        }\r\n        document.getElementById(tabName).style.display = "block";\r\n        evt.currentTarget.className += " active";\r\n        }\r\n        // Get the element with id="defaultOpen" and click on it\r\n        document.getElementById("defaultOpen").click();</script><h2 data-translate="netWordAgroApp.mapaimagem.comparativo.title">Comparativo de mapas</h2><div class="tab"><button class="tablinks" onclick="openTab(event, \'Mapas\');" ng-click="vm.typeMap(\'Percevejo\')" id="defaultOpen" data-translate="netWordAgroApp.mapaimagem.comparativo.percevejo">Percevejo</button> <button class="tablinks" onclick="openTab(event, \'Mapas\');" ng-click="vm.typeMap(\'Ferrugem\')" data-translate="netWordAgroApp.mapaimagem.comparativo.ferrugem">Ferrugem</button> <button class="tablinks" onclick="openTab(event, \'Mapas\');" ng-click="vm.typeMap(\'Mancha-Alvo\')" data-translate="netWordAgroApp.mapaimagem.comparativo.mancha">Mancha-Alvo</button> <button class="tablinks" onclick="openTab(event, \'Mapas\');" ng-click="vm.typeMap(\'Lagarta\')" data-translate="netWordAgroApp.mapaimagem.comparativo.lagarta">Lagarta</button> <button class="tablinks" onclick="openTab(event, \'Mapas\');" ng-click="vm.typeMap(\'Sa\xFAde\')" data-translate="netWordAgroApp.mapaimagem.comparativo.saude">Sa\xFAde</button> <button class="tablinks" onclick="openTab(event, \'Mapas\');" ng-click="vm.typeMap(\'Nutricional\')" data-translate="netWordAgroApp.mapaimagem.comparativo.nutricional">Nutricional</button> <button class="tablinks" onclick="openTab(event, \'Mapas\');" ng-click="vm.typeMap(\'Planta Daninha\')" data-translate="netWordAgroApp.mapaimagem.comparativo.plantadaninha">PlantaDaninha</button> <button class="tablinks" onclick="openTab(event, \'Mapas\');" ng-click="vm.typeMap(\'Plantio\')" data-translate="netWordAgroApp.mapaimagem.comparativo.plantio">Plantio</button></div><div class="well"><div class="row"><div class="col-lg-4 col-md-4 col-sm-4"><p id="selecao" data-translate="netWordAgroApp.mapaimagem.comparativo.prop">Selecione a propriedade:</p><select id="selecsafra" name="propriedades" ng-model="vm.propriedade" ng-options="prop as prop.nomepropriedade for prop in vm.propriedades track by prop.id" required ng-change="vm.changePropriedade()"><option value></option></select></div><div class="col-lg-4 col-md-4 col-sm-4" ng-show="vm.propriedade != null"><p id="selecao" data-translate="netWordAgroApp.mapaimagem.comparativo.safra">Selecione a safra:</p><select id="selecsafra" name="safras" ng-model="vm.safra" ng-options="safra as safra.nomesafra for safra in vm.safras track by safra.id" required><option value></option></select></div><div class="col-lg-4 col-md-4 col-sm-4" ng-show="vm.tipoMapa == \'Nutricional\'"><p id="selecaoatributo" data-translate="netWordAgroApp.mapaimagem.comparativo.atributo">Selecione o atributo:</p><select id="selecatributo" name="atributos" ng-model="vm.tipoNutricional"><option value="Nitrog\xEAnio">N</option><option value="F\xF3sforo">P</option><option value="Pot\xE1ssio">K</option><option value="C\xE1lcio">Ca</option><option value="Magn\xE9sio">Mg</option></select></div></div><br><button id="btncompmapas" ng-disabled="vm.safra.nomesafra == null && vm.propriedade == null" ng-click="vm.pressButtonMaps()"><span data-translate="netWordAgroApp.mapaimagem.comparativo.botaomapas">Mostrar mapas</span></button></div><div id="Mapas" class="tabcontent"><h4 data-translate="netWordAgroApp.mapaimagem.comparativo.semmapas" ng-show="vm.textMaps" align="center"></h4><table class="jh-table table table-striped"><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="mapaimagem in vm.mapaimagems track by mapaimagem.id"><td><div class="row"><div class="col-lg-8 col-md-8 col-sm-8"><h4>{{mapaimagem.nomemapa}}</h4></div><div class="col-lg-4 col-md-4 col-sm-4" align="right"><button type="submit" ng-click="vm.download(mapaimagem.id)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-download-alt"></span> <span class="hidden-sm-down" data-translate="netWordAgroApp.mapaimagem.download"></span></button></div></div><center><img id="myimage" style="max-height:600px" class="img-responsive" src="{{mapaimagem.imagempequenaContentType}}"></center></td></tr></tbody></table></div>');
$templateCache.put('app/entities/mapaimagem/mapa-calor-mobile.html','<style type="text/css">#map{\r\n        height: 500px;\r\n        width: 100%;\r\n    }\r\n    \r\n    .label-filtros{\r\n        color: #555555;\r\n        font-weight: bold;\r\n    }\r\n    \r\n    #galeria {\r\n        overflow-x: scroll;\r\n        overflow-y: hidden;\r\n        white-space: nowrap;\r\n        height: auto;\r\n        padding: 10px;\r\n        /*border: 2px outset #555555;*/\r\n    }\r\n    .elemento-galeria{\r\n        display: inline-block;\r\n        background: white;\r\n        border: 1px solid #FAFAFA;\r\n        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\r\n        margin-top: 5px;\r\n        margin-right: 7px;\r\n    }\r\n    .elemento-galeria:hover{\r\n        /*border: 2px solid #4185A3;*/\r\n        border: 1px solid rgba(101, 163, 127, 1);\r\n        box-shadow: 0 4px 8px 0 rgba(101, 163, 127, 0.6), 0 6px 20px 0 rgba(101, 163, 127, 0.59);\r\n        margin-top: 5px;\r\n        margin-right: 7px;\r\n    }\r\n    \r\n    .elemento-galeria:focus{\r\n        border: 2px solid #008000;\r\n        background-color: rgba(0, 255, 0, 0.3);\r\n    }\r\n    \r\n    .circle {\r\n      height:1em;\r\n      width: 1em;\r\n      border-radius: 0%;\r\n      display: inline-block;\r\n      margin-top: 2px;\r\n    }</style><div class="well"><div class="row"><div class="col-xs-12"><label><h4><span data-translate="netWordAgroApp.mapaimagem.filtro">Filtros</span></h4></label></div></div><div class="row"><div class="col-xs-12"><label class="label-filtros"><span data-translate="netWordAgroApp.mapaimagem.propriedade">Propriedades</span></label></div></div><div class="row"><div class="col-xs-12"><select class="form-control" id="field_filtropropriedade" name="filtropropriedade" ng-model="vm.filtroPropriedade" ng-options="prop as prop.nomepropriedade for prop in vm.propriedades track by prop.id" ng-change="vm.changeFiltroPropriedade()"><option value></option></select></div></div><br><div class="row"><div class="col-xs-12"><label class="label-filtros"><span data-translate="netWordAgroApp.mapaimagem.safra">Safras</span></label></div></div><div class="row"><div class="col-xs-12"><select class="form-control" id="field_filtrosafra" name="filtrosafra" ng-model="vm.filtroSafra" ng-options="saf as saf.nomesafra for saf in vm.safras track by saf.id"><option value></option></select></div></div><br><div class="row"><div class="col-xs-12"><label class="label-filtros"><span data-translate="netWordAgroApp.mapaimagem.tipomapa">Tipo de Mapas</span></label></div></div><div class="row"><div class="col-xs-12"><select class="form-control" name="tipomapa" ng-model="vm.filtroTipoMapa" id="field_tipomapa"><option value></option><option value="percevejo" data-translate="netWordAgroApp.Tipomapa.percevejo">percevejo</option><option value="ferrugem" data-translate="netWordAgroApp.Tipomapa.ferrugem">ferrugem</option><option value="lagarta" data-translate="netWordAgroApp.Tipomapa.lagarta">lagarta</option><option value="manchaalvo" data-translate="netWordAgroApp.Tipomapa.manchaalvo">manchaalvo</option><!--<option value="nutricional" data-translate="netWordAgroApp.Tipomapa.nutricional">nutricional</option>\r\n\r\n                <option value="saude" data-translate="netWordAgroApp.Tipomapa.saude">saude</option>\r\n                <option value="plantio" data-translate="netWordAgroApp.Tipomapa.plantio">plantio</option>\r\n                <option value="umidade" data-translate="netWordAgroApp.Tipomapa.umidade">umidade</option>--><option value="ervadaninha" data-translate="netWordAgroApp.Tipomapa.ervadaninha">ervadaninha</option><option value="pulgao" data-translate="netWordAgroApp.Tipomapa.pulgao">pulgao</option><option value="helmintosporiose" data-translate="netWordAgroApp.Tipomapa.helmintosporiose">helmintosporiose</option><option value="oidio" data-translate="netWordAgroApp.Tipomapa.oidio">oidio</option><option value="doenca" data-translate="netWordAgroApp.Tipomapa.doenca">doenca</option><option value="plantadaninhacana" data-translate="netWordAgroApp.Tipomapa.plantadaninhacana">plantadaninhacana</option><option value="praga" data-translate="netWordAgroApp.Tipomapa.praga">praga</option><option value="amargoso" data-translate="netWordAgroApp.Tipomapa.amargoso">amargoso</option><option value="buva" data-translate="netWordAgroApp.Tipomapa.buva">buva</option><option value="falhaplantio" data-translate="netWordAgroApp.Tipomapa.falhaplantio">falhaplantio</option><option value="milho" data-translate="netWordAgroApp.Tipomapa.milho">milho</option><option value="folhalarga" data-translate="netWordAgroApp.Tipomapa.folhalarga">folhalarga</option><option value="folhaestreita" data-translate="netWordAgroApp.Tipomapa.folhaestreita">folhaestreita</option><option value="bicudo" data-translate="netWordAgroApp.Tipomapa.bicudo">bicudo</option><option value="cigarrinha" data-translate="netWordAgroApp.Tipomapa.cigarrinha">cigarrinha</option><option value="brocadacana" data-translate="netWordAgroApp.Tipomapa.broca">broca</option><option value="folhalargacana" data-translate="netWordAgroApp.Tipomapa.folhalargacana">folhalargacana</option><option value="folhaestreitacana" data-translate="netWordAgroApp.Tipomapa.folhaestreitacana">folhaestreitacana</option><option value="coro" data-translate="netWordAgroApp.Tipomapa.coro">coro</option><option value="nematoide" data-translate="netWordAgroApp.Tipomapa.nematoide">nematoide</option><option value="coracaomorto" data-translate="netWordAgroApp.Tipomapa.coracaomorto">coracaomorto</option><option value="manchafoliar" data-translate="netWordAgroApp.Tipomapa.manchafoliar">manchafoliar</option><option value="ramularia" data-translate="netWordAgroApp.Tipomapa.ramularia">ramularia</option><option value="acarorajado" data-translate="netWordAgroApp.Tipomapa.acarorajado">acarorajado</option></select></div></div><br><div class="row"><div class="col-xs-6"><label class="label-filtros"><span data-translate="netWordAgroApp.mapaimagem.dodia">Do dia</span></label></div><div class="col-xs-6"><label class="label-filtros"><span data-translate="netWordAgroApp.mapaimagem.ate">At\xE9 o dia</span></label></div></div><div class="row"><div class="col-xs-6"><div class="input-group"><input id="field_data" type="text" class="form-control" name="data" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.dataInicioIntervalo" is-open="vm.datePickerOpenStatus.dataInicio"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataInicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-6"><div class="input-group"><input id="field_data" type="text" class="form-control" name="data" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.dataFimIntervalo" is-open="vm.datePickerOpenStatus.dataFim"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataFim\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><br><div class="row"><div class="col-xs-12"><button class="btn btn-primary" style="width:100%" ng-click="vm.aplicarFiltros()"><span data-translate="netWordAgroApp.mapaimagem.aplicarFiltros">Aplicar Filtros</span></button></div></div></div><div class="row"><div class="col-xs-12" ng-show="vm.dadosMapas.length!=0"><label><h4><span data-translate="netWordAgroApp.mapaimagem.cliqueparavisualizar">Clique nos mapas para visualizar</span></h4></label></div></div><div class="row"><div class="col-xs-12" ng-show="vm.dadosMapas.length==0"><label><h4><span data-translate="netWordAgroApp.mapaimagem.apliquenovosfiltros">Aplique filtros para ver novos mapas para selecionar</span></h4></label></div></div><div class="row"><div class="col-xs-12" ng-show="vm.carregando"><label><h3><span data-translate="netWordAgroApp.mapaimagem.aguardecarregar">Aguarde o carregamento...</span></h3></label></div></div><div id="galeria" ng-show="vm.dadosMapas.length!=0"><div class="elemento-galeria" ng-repeat="mapa in vm.dadosMapas track by mapa.id" ng-click="vm.adicionarMapasSelecionados(mapa)"><center><div style="width: 6vw" ng-switch on="mapa.tipomapa"><img src="../../../content/images/svg/Tipos Mapa_amargoso.svg" ng-switch-when="amargoso" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_brocadacana.svg" ng-switch-when="brocadacana" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_buva.svg" ng-switch-when="buva" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_doenca.svg" ng-switch-when="doenca" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_falhaplantio.svg" ng-switch-when="falhaplantio" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_ferrugem.svg" ng-switch-when="ferrugem" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_folhaestreita.svg" ng-switch-when="folhaestreita" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_folhaestreitacana.svg" ng-switch-when="folhaestreitacana" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_folhalarga.svg" ng-switch-when="folhalarga" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_folhalargacana.svg" ng-switch-when="folhalargacana" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_helmintosporiose.svg" ng-switch-when="helmintosporiose" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_lagarta.svg" ng-switch-when="lagarta" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_manchaalvo.svg" ng-switch-when="manchaalvo" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_milho.svg" ng-switch-when="milho" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_nutricional.svg" ng-switch-when="nutricional" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_oidio.svg" ng-switch-when="oidio" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_outros.svg" ng-switch-when="outros" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_percevejo.svg" ng-switch-when="percevejo" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_plantadaninha.svg" ng-switch-when="ervadaninha" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_plantadaninhacana.svg" ng-switch-when="plantadaninhacana" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_praga.svg" ng-switch-when="praga" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_pulgao.svg" ng-switch-when="pulgao" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_outros.svg" ng-switch-default style="max-width: 100%" alt="mapaimagem image"></div></center><div style="padding: 5px; background: #FAFAFA; border-top: 1px solid #726CD3">{{mapa.nomemapa}}<br><span data-translate="netWordAgroApp.mapaimagem.data">Data:</span> {{mapa.data | date:"dd/MM/yyyy"}}<br><span ng-show="mapa.areaafetada"><span data-translate="netWordAgroApp.mapaimagem.areaafetada">\xC1rea Afetada:</span> {{mapa.areaafetada}} ha</span></div></div></div><br><br><div class="row"><div id="map" class="col-xs-12"></div></div><br><div class="row" ng-show="vm.mapasSelecionados.length!=0"><div class="col-xs-12"><label><h4><span data-translate="netWordAgroApp.mapaimagem.legenda">Legenda</span></h4></label></div></div><div class="row" ng-repeat="mapa in vm.mapasSelecionados"><div class="col-xs-4" style="padding: 12px; padding-top: 12px; font-size:1em"><span class="circle" style="background:#00FF00"></span> <b><span data-translate="netWordAgroApp.mapaimagem.baixaincidencia">Baixa incid\xEAncia</span></b><br><span class="circle" style="background: #FFFF00"></span> <b><span data-translate="netWordAgroApp.mapaimagem.mediaincidencia">M\xE9dia incid\xEAncia</span></b><br><span class="circle" style="background: #FF0000"></span> <b><span data-translate="netWordAgroApp.mapaimagem.altaincidencia">Alta incid\xEAncia</span></b><br><br><b>{{mapa.nomemapa}}</b><br><span data-translate="netWordAgroApp.mapaimagem.data">Data:</span> {{mapa.data | date:"dd/MM/yyyy"}}<br><span data-translate="netWordAgroApp.mapaimagem.areaafetada">Data:</span> {{mapa.areaafetada}}<br></div></div>');
$templateCache.put('app/entities/mapaimagem/mapa-calor.html','<style type="text/css">#map{\r\n        height: 500px;\r\n        width: 100%;\r\n    }\r\n    \r\n    .label-filtros{\r\n        color: #555555;\r\n        font-weight: bold;\r\n    }\r\n    \r\n    #galeria {\r\n        overflow-x: scroll;\r\n        overflow-y: hidden;\r\n        white-space: nowrap;\r\n        height: auto;\r\n        padding: 10px;\r\n        /*border: 2px outset #555555;*/\r\n    }\r\n    .elemento-galeria{\r\n        display: inline-block;\r\n        background: white;\r\n        border: 1px solid #FAFAFA;\r\n        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\r\n        margin-top: 5px;\r\n        margin-right: 7px;\r\n    }\r\n    .elemento-galeria:hover{\r\n        /*border: 2px solid #4185A3;*/\r\n        border: 1px solid rgba(101, 163, 127, 1);\r\n        box-shadow: 0 4px 8px 0 rgba(101, 163, 127, 0.6), 0 6px 20px 0 rgba(101, 163, 127, 0.59);\r\n        margin-top: 5px;\r\n        margin-right: 7px;\r\n    }\r\n    \r\n    .elemento-galeria:focus{\r\n        border: 2px solid #008000;\r\n        background-color: rgba(0, 255, 0, 0.3);\r\n    }\r\n    \r\n    .circle {\r\n      height:1em;\r\n      width: 1em;\r\n      border-radius: 0%;\r\n      display: inline-block;\r\n      margin-top: 2px;\r\n    }</style><div class="well"><div class="row"><div class="col-xs-12"><label><h4><span data-translate="netWordAgroApp.mapaimagem.filtro">Filtros</span></h4></label></div></div><div class="row"><div class="col-xs-4"><label class="label-filtros"><span data-translate="netWordAgroApp.mapaimagem.propriedade">Propriedades</span></label></div><div class="col-xs-4"><label class="label-filtros"><span data-translate="netWordAgroApp.mapaimagem.safra">Safras</span></label></div><div class="col-xs-4"><label class="label-filtros"><span data-translate="netWordAgroApp.mapaimagem.tipomapa">Tipo de Mapas</span></label></div></div><div class="row"><div class="col-xs-4"><select class="form-control" id="field_filtropropriedade" name="filtropropriedade" ng-model="vm.filtroPropriedade" ng-options="prop as prop.nomepropriedade for prop in vm.propriedades track by prop.id" ng-change="vm.changeFiltroPropriedade()"><option value></option></select></div><div class="col-xs-4"><select class="form-control" id="field_filtrosafra" name="filtrosafra" ng-model="vm.filtroSafra" ng-options="saf as saf.nomesafra for saf in vm.safras track by saf.id"><option value></option></select></div><div class="col-xs-4"><select class="form-control" name="tipomapa" ng-model="vm.filtroTipoMapa" id="field_tipomapa"><option value></option><option value="percevejo" data-translate="netWordAgroApp.Tipomapa.percevejo">percevejo</option><option valute="netWordAgroApp.Tipomapa.ferrugem" e="ferrugem" data-transla>ferrugem</option><option value="lagarta" data-translate="netWordAgroApp.Tipomapa.lagarta">lagarta</option><option value="manchaalvo" data-translate="netWordAgroApp.Tipomapa.manchaalvo">manchaalvo</option><!--<option value="nutricional" data-translate="netWordAgroApp.Tipomapa.nutricional">nutricional</option>\r\n\r\n                <option value="saude" data-translate="netWordAgroApp.Tipomapa.saude">saude</option>\r\n                <option value="plantio" data-translate="netWordAgroApp.Tipomapa.plantio">plantio</option>\r\n                <option value="umidade" data-translate="netWordAgroApp.Tipomapa.umidade">umidade</option>--><option value="ervadaninha" data-translate="netWordAgroApp.Tipomapa.ervadaninha">ervadaninha</option><option value="pulgao" data-translate="netWordAgroApp.Tipomapa.pulgao">pulgao</option><option value="helmintosporiose" data-translate="netWordAgroApp.Tipomapa.helmintosporiose">helmintosporiose</option><option value="oidio" data-translate="netWordAgroApp.Tipomapa.oidio">oidio</option><option value="doenca" data-translate="netWordAgroApp.Tipomapa.doenca">doenca</option><option value="plantadaninhacana" data-translate="netWordAgroApp.Tipomapa.plantadaninhacana">plantadaninhacana</option><option value="praga" data-translate="netWordAgroApp.Tipomapa.praga">praga</option><option value="amargoso" data-translate="netWordAgroApp.Tipomapa.amargoso">amargoso</option><option value="buva" data-translate="netWordAgroApp.Tipomapa.buva">buva</option><option value="falhaplantio" data-translate="netWordAgroApp.Tipomapa.falhaplantio">falhaplantio</option><option value="milho" data-translate="netWordAgroApp.Tipomapa.milho">milho</option><option value="folhalarga" data-translate="netWordAgroApp.Tipomapa.folhalarga">folhalarga</option><option value="folhaestreita" data-translate="netWordAgroApp.Tipomapa.folhaestreita">folhaestreita</option><option value="bicudo" data-translate="netWordAgroApp.Tipomapa.bicudo">bicudo</option><option value="cigarrinha" data-translate="netWordAgroApp.Tipomapa.cigarrinha">cigarrinha</option><option value="brocadacana" data-translate="netWordAgroApp.Tipomapa.broca">broca</option><option value="folhalargacana" data-translate="netWordAgroApp.Tipomapa.folhalargacana">folhalargacana</option><option value="folhaestreitacana" data-translate="netWordAgroApp.Tipomapa.folhaestreitacana">folhaestreitacana</option><option value="coro" data-translate="netWordAgroApp.Tipomapa.coro">coro</option><option value="nematoide" data-translate="netWordAgroApp.Tipomapa.nematoide">nematoide</option><option value="coracaomorto" data-translate="netWordAgroApp.Tipomapa.coracaomorto">coracaomorto</option><option value="manchafoliar" data-translate="netWordAgroApp.Tipomapa.manchafoliar">manchafoliar</option><option value="ramularia" data-translate="netWordAgroApp.Tipomapa.ramularia">ramularia</option><option value="acarorajado" data-translate="netWordAgroApp.Tipomapa.acarorajado">acarorajado</option><option value="tripes" data-translate="netWordAgroApp.Tipomapa.tripes">tripes</option><option value="antracnose" data-translate="netWordAgroApp.Tipomapa.antracnose">antracnose</option><option value="dessecacao" data-translate="netWordAgroApp.Tipomapa.dessecacao">dessecacao</option></select></div></div><br><div class="row"><div class="col-xs-4"><label class="label-filtros"><span data-translate="netWordAgroApp.mapaimagem.dodia">Do dia</span></label></div><div class="col-xs-4"><label class="label-filtros"><span data-translate="netWordAgroApp.mapaimagem.ate">At\xE9 o dia</span></label></div><div class="col-xs-4"></div></div><div class="row"><div class="col-xs-4"><div class="input-group"><input id="field_data" type="text" class="form-control" name="data" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.dataInicioIntervalo" is-open="vm.datePickerOpenStatus.dataInicio"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataInicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-4"><div class="input-group"><input id="field_data" type="text" class="form-control" name="data" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.dataFimIntervalo" is-open="vm.datePickerOpenStatus.dataFim"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataFim\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-4"><button class="btn btn-primary" ng-click="vm.aplicarFiltros()"><span data-translate="netWordAgroApp.mapaimagem.aplicarFiltros">Aplicar Filtros</span></button></div></div></div><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title">Informa\xE7\xF5es sobre Mapas</h4></div><div id="collapse1" class="panel-collapse collapse in"><div class="panel-body"><b>\xC1rea Afetada</b> \xE9 a \xE1rea onde existe o dano ou o agente causador do mesmo, identificada atrav\xE9s do monitoramento.<br>A <b>\xC1rea de Aplica\xE7\xE3o</b> ser\xE1 informada junto com o envio do arquivo shapefile, j\xE1 que esta depende do maquin\xE1rio a ser utilizado. Essa <b>\xC1rea de Aplica\xE7\xE3o</b> que deve ser utilizada para o c\xE1lculo da calda.</div></div></div><div class="row"><div class="col-xs-12" ng-show="vm.dadosMapas.length!=0"><label><h4><span data-translate="netWordAgroApp.mapaimagem.cliqueparavisualizar">Clique nos mapas para visualizar</span></h4></label></div></div><div class="row"><div class="col-xs-12" ng-show="vm.dadosMapas.length==0"><label><h4><span data-translate="netWordAgroApp.mapaimagem.apliquenovosfiltros">Aplique filtros para ver novos mapas para selecionar</span></h4></label></div></div><div class="row"><div class="col-xs-12" ng-show="vm.carregando"><label><h3><span data-translate="netWordAgroApp.mapaimagem.aguardecarregar">Aguarde o carregamento...</span></h3></label></div></div><div id="galeria" ng-show="vm.dadosMapas.length!=0"><div class="elemento-galeria" ng-repeat="mapa in vm.dadosMapas track by mapa.id" ng-click="vm.adicionarMapasSelecionados(mapa)"><center><div style="width: 6vw" ng-switch on="mapa.tipomapa"><img src="../../../content/images/svg/Tipos Mapa_amargoso.svg" ng-switch-when="amargoso" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_brocadacana.svg" ng-switch-when="brocadacana" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_buva.svg" ng-switch-when="buva" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_doenca.svg" ng-switch-when="doenca" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_falhaplantio.svg" ng-switch-when="falhaplantio" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_ferrugem.svg" ng-switch-when="ferrugem" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_folhaestreita.svg" ng-switch-when="folhaestreita" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_folhaestreitacana.svg" ng-switch-when="folhaestreitacana" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_folhalarga.svg" ng-switch-when="folhalarga" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_folhalargacana.svg" ng-switch-when="folhalargacana" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_helmintosporiose.svg" ng-switch-when="helmintosporiose" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_lagarta.svg" ng-switch-when="lagarta" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_manchaalvo.svg" ng-switch-when="manchaalvo" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_milho.svg" ng-switch-when="milho" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_nutricional.svg" ng-switch-when="nutricional" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_oidio.svg" ng-switch-when="oidio" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_outros.svg" ng-switch-when="outros" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_percevejo.svg" ng-switch-when="percevejo" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_plantadaninha.svg" ng-switch-when="ervadaninha" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_plantadaninhacana.svg" ng-switch-when="plantadaninhacana" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_praga.svg" ng-switch-when="praga" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_pulgao.svg" ng-switch-when="pulgao" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_outros.svg" ng-switch-default style="max-width: 100%" alt="mapaimagem image"></div></center><div style="padding: 5px; background: #FAFAFA; border-top: 1px solid #726CD3">{{mapa.nomemapa}}<br><span data-translate="netWordAgroApp.mapaimagem.data">Data:</span> {{mapa.data | date:"dd/MM/yyyy"}}<br><span ng-show="mapa.areaafetada"><span data-translate="netWordAgroApp.mapaimagem.areaafetada">\xC1rea Afetada:</span> {{mapa.areaafetada}} ha</span></div></div></div><br><br><div class="row"><div id="map" class="col-xs-12"></div></div><br><div class="row" ng-show="vm.mapasSelecionados.length!=0"><div class="col-xs-12"><label><h4><span data-translate="netWordAgroApp.mapaimagem.legenda">Legenda</span></h4></label></div></div><div class="row" ng-repeat="mapa in vm.mapasSelecionados"><div class="col-xs-4" style="padding: 12px; padding-top: 12px; font-size:1em"><span class="circle" style="background:#00FF00"></span> <b><span data-translate="netWordAgroApp.mapaimagem.baixaincidencia">Baixa incid\xEAncia</span></b><br><span class="circle" style="background: #FFFF00"></span> <b><span data-translate="netWordAgroApp.mapaimagem.mediaincidencia">M\xE9dia incid\xEAncia</span></b><br><span class="circle" style="background: #FF0000"></span> <b><span data-translate="netWordAgroApp.mapaimagem.altaincidencia">Alta incid\xEAncia</span></b><br><br><b>{{mapa.nomemapa}}</b><br><span data-translate="netWordAgroApp.mapaimagem.data">Data:</span> {{mapa.data | date:"dd/MM/yyyy"}}<br><span data-translate="netWordAgroApp.mapaimagem.areaafetada">Data:</span> {{mapa.areaafetada}}<br></div></div>');
$templateCache.put('app/entities/mapaimagem/mapa-interativo-mobile.html','<style type="text/css">#map{\r\n    height: 500px;\r\n    width: 100%;\r\n}\r\n\r\n.label-filtros{\r\n    color: #555555;\r\n    font-weight: bold;\r\n}\r\n\r\n#galeria {\r\n  overflow-x: scroll;\r\n  overflow-y: hidden;\r\n  white-space: nowrap;\r\n  height: auto;\r\n  padding: 10px;\r\n  /*border: 2px outset #555555;*/\r\n}\r\n.elemento-galeria{\r\n    display: inline-block;\r\n    background: white;\r\n    border: 1px solid #FAFAFA;\r\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\r\n    margin-top: 5px;\r\n    margin-right: 7px;\r\n}\r\n.elemento-galeria:hover{\r\n    /*border: 2px solid #4185A3;*/\r\n    border: 1px solid rgba(101, 163, 127, 1);\r\n    box-shadow: 0 4px 8px 0 rgba(101, 163, 127, 0.6), 0 6px 20px 0 rgba(101, 163, 127, 0.59);\r\n    margin-top: 5px;\r\n    margin-right: 7px;\r\n}\r\n\r\n.elemento-galeria:focus{\r\n    background-color: rgba(0, 255, 0, 0.3);\r\n}\r\n\r\n.circle {\r\n  height:1em;\r\n  width: 1em;\r\n  border-radius: 0%;\r\n  display: inline-block;\r\n  margin-top: 2px;\r\n}</style><div class="well"><div class="row"><div class="col-xs-12" ng-show="vm.carregandoPagina"><label><h3><span data-translate="netWordAgroApp.mapaimagem.aguardecarregar">Aguarde o carregamento...</span></h3></label></div></div><div class="row"><div class="col-xs-12"><label><h4><span data-translate="netWordAgroApp.mapaimagem.filtro">Filtros</span></h4></label></div></div><div class="row"><div class="col-xs-12"><label class="label-filtros"><span data-translate="netWordAgroApp.mapaimagem.propriedade">Propriedades</span></label></div></div><div class="row"><div class="col-xs-12"><select class="form-control" id="field_filtropropriedade" name="filtropropriedade" ng-model="vm.filtroPropriedade" ng-options="prop as prop.nomepropriedade for prop in vm.propriedades track by prop.id" ng-change="vm.changeFiltroPropriedade()"><option value></option></select></div></div><br><div class="row"><div class="col-xs-12"><label class="label-filtros"><span data-translate="netWordAgroApp.mapaimagem.safra">Safras</span></label></div></div><div class="row"><div class="col-xs-12"><select class="form-control" id="field_filtrosafra" name="filtrosafra" ng-model="vm.filtroSafra" ng-options="saf as saf.nomesafra for saf in vm.safras track by saf.id"><option value></option></select></div></div><br><div class="row"><div class="col-xs-12"><label class="label-filtros"><span data-translate="netWordAgroApp.mapaimagem.tipomapa">Tipo de Mapas</span></label></div></div><div class="row"><div class="col-xs-12"><select class="form-control" name="tipomapa" ng-model="vm.filtroTipoMapa" id="field_tipomapa"><option value></option><option value="percevejo" data-translate="netWordAgroApp.Tipomapa.percevejo">percevejo</option><option value="ferrugem" data-translate="netWordAgroApp.Tipomapa.ferrugem">ferrugem</option><option value="lagarta" data-translate="netWordAgroApp.Tipomapa.lagarta">lagarta</option><option value="manchaalvo" data-translate="netWordAgroApp.Tipomapa.manchaalvo">manchaalvo</option><!--<option value="nutricional" data-translate="netWordAgroApp.Tipomapa.nutricional">nutricional</option>\r\n\r\n                <option value="saude" data-translate="netWordAgroApp.Tipomapa.saude">saude</option>\r\n                <option value="plantio" data-translate="netWordAgroApp.Tipomapa.plantio">plantio</option>\r\n                <option value="umidade" data-translate="netWordAgroApp.Tipomapa.umidade">umidade</option>--><option value="ervadaninha" data-translate="netWordAgroApp.Tipomapa.ervadaninha">ervadaninha</option><option value="pulgao" data-translate="netWordAgroApp.Tipomapa.pulgao">pulgao</option><option value="helmintosporiose" data-translate="netWordAgroApp.Tipomapa.helmintosporiose">helmintosporiose</option><option value="oidio" data-translate="netWordAgroApp.Tipomapa.oidio">oidio</option><option value="doenca" data-translate="netWordAgroApp.Tipomapa.doenca">doenca</option><option value="plantadaninhacana" data-translate="netWordAgroApp.Tipomapa.plantadaninhacana">plantadaninhacana</option><option value="praga" data-translate="netWordAgroApp.Tipomapa.praga">praga</option><option value="amargoso" data-translate="netWordAgroApp.Tipomapa.amargoso">amargoso</option><option value="buva" data-translate="netWordAgroApp.Tipomapa.buva">buva</option><option value="falhaplantio" data-translate="netWordAgroApp.Tipomapa.falhaplantio">falhaplantio</option><option value="milho" data-translate="netWordAgroApp.Tipomapa.milho">milho</option><option value="folhalarga" data-translate="netWordAgroApp.Tipomapa.folhalarga">folhalarga</option><option value="folhaestreita" data-translate="netWordAgroApp.Tipomapa.folhaestreita">folhaestreita</option><option value="bicudo" data-translate="netWordAgroApp.Tipomapa.bicudo">bicudo</option><option value="cigarrinha" data-translate="netWordAgroApp.Tipomapa.cigarrinha">cigarrinha</option><option value="brocadacana" data-translate="netWordAgroApp.Tipomapa.broca">broca</option><option value="folhalargacana" data-translate="netWordAgroApp.Tipomapa.folhalargacana">folhalargacana</option><option value="folhaestreitacana" data-translate="netWordAgroApp.Tipomapa.folhaestreitacana">folhaestreitacana</option><option value="coro" data-translate="netWordAgroApp.Tipomapa.coro">coro</option><option value="nematoide" data-translate="netWordAgroApp.Tipomapa.nematoide">nematoide</option><option value="coracaomorto" data-translate="netWordAgroApp.Tipomapa.coracaomorto">coracaomorto</option><option value="manchafoliar" data-translate="netWordAgroApp.Tipomapa.manchafoliar">manchafoliar</option><option value="ramularia" data-translate="netWordAgroApp.Tipomapa.ramularia">ramularia</option><option value="acarorajado" data-translate="netWordAgroApp.Tipomapa.acarorajado">acarorajado</option></select></div></div><br><div class="row"><div class="col-xs-6"><label class="label-filtros"><span data-translate="netWordAgroApp.mapaimagem.dodia">Do dia</span></label></div><div class="col-xs-6"><label class="label-filtros"><span data-translate="netWordAgroApp.mapaimagem.ate">At\xE9 o dia</span></label></div></div><div class="row"><div class="col-xs-6"><div class="input-group"><input id="field_data" type="text" class="form-control" name="data" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.dataInicioIntervalo" is-open="vm.datePickerOpenStatus.dataInicio"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataInicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-6"><div class="input-group"><input id="field_data" type="text" class="form-control" name="data" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.dataFimIntervalo" is-open="vm.datePickerOpenStatus.dataFim"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataFim\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><br><div class="row"><div class="col-xs-12"><button class="btn btn-primary" style="width:100%" ng-click="vm.aplicarFiltros()"><span data-translate="netWordAgroApp.mapaimagem.aplicarFiltros">Aplicar Filtros</span></button></div></div></div><div class="row"><div class="col-xs-12" ng-show="vm.dadosMapas.length!=0"><label><h4><span data-translate="netWordAgroApp.mapaimagem.cliqueparavisualizar">Clique nos mapas para visualizar</span></h4></label></div></div><div class="row"><div class="col-xs-12" ng-show="vm.dadosMapas.length==0"><label><h4><span data-translate="netWordAgroApp.mapaimagem.apliquenovosfiltros">Aplique filtros para ver novos mapas para selecionar</span></h4></label></div></div><div class="row"><div class="col-xs-12" ng-show="vm.carregando"><label><h3><span data-translate="netWordAgroApp.mapaimagem.aguardecarregar">Aguarde o carregamento...</span></h3></label></div></div><div id="galeria" ng-show="vm.dadosMapas.length!=0"><div class="elemento-galeria" ng-repeat="mapa in vm.dadosMapas track by mapa.id" ng-click="vm.adicionarMapasSelecionados(mapa)"><center><div style="width: 6vw" ng-switch on="mapa.tipomapa"><img src="../../../content/images/svg/Tipos Mapa_amargoso.svg" ng-switch-when="amargoso" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_brocadacana.svg" ng-switch-when="brocadacana" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_buva.svg" ng-switch-when="buva" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_doenca.svg" ng-switch-when="doenca" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_falhaplantio.svg" ng-switch-when="falhaplantio" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_ferrugem.svg" ng-switch-when="ferrugem" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_folhaestreita.svg" ng-switch-when="folhaestreita" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_folhaestreitacana.svg" ng-switch-when="folhaestreitacana" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_folhalarga.svg" ng-switch-when="folhalarga" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_folhalargacana.svg" ng-switch-when="folhalargacana" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_helmintosporiose.svg" ng-switch-when="helmintosporiose" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_lagarta.svg" ng-switch-when="lagarta" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_manchaalvo.svg" ng-switch-when="manchaalvo" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_milho.svg" ng-switch-when="milho" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_nutricional.svg" ng-switch-when="nutricional" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_oidio.svg" ng-switch-when="oidio" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_outros.svg" ng-switch-when="outros" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_percevejo.svg" ng-switch-when="percevejo" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_plantadaninha.svg" ng-switch-when="ervadaninha" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_plantadaninhacana.svg" ng-switch-when="plantadaninhacana" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_praga.svg" ng-switch-when="praga" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_pulgao.svg" ng-switch-when="pulgao" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_outros.svg" ng-switch-default style="max-width: 100%" alt="mapaimagem image"></div></center><div style="padding: 5px; background: #FAFAFA; border-top: 1px solid #726CD3">{{mapa.nomemapa}}<br><span data-translate="netWordAgroApp.mapaimagem.data">Data:</span> {{mapa.data | date:"dd/MM/yyyy"}}<br><span ng-show="mapa.areaafetada"><span data-translate="netWordAgroApp.mapaimagem.areaafetada">\xC1rea Afetada:</span> {{mapa.areaafetada}} ha</span></div></div></div><br><br><div class="row"><div id="map" class="col-xs-12"></div></div><br><div class="row" ng-show="vm.mapasSelecionados.length!=0"><div class="col-xs-12"><label><h4><span data-translate="netWordAgroApp.mapaimagem.legenda">Legenda</span></h4></label></div></div><div class="row" ng-repeat="mapa in vm.mapasSelecionados"><div class="col-xs-4" style="padding: 12px; padding-top: 12px; font-size:1em"><span class="circle" ng-style="{background: mapa.wktData[0].cor}"></span> <b>{{mapa.nomemapa}}</b><br><span data-translate="netWordAgroApp.mapaimagem.data">Data:</span> {{mapa.data | date:"dd/MM/yyyy"}}<br><span data-translate="netWordAgroApp.mapaimagem.areaafetada">Data:</span> {{mapa.areaafetada}}<br></div></div>');
$templateCache.put('app/entities/mapaimagem/mapa-interativo.html','<style type="text/css">#map{\r\n    height: 500px;\r\n    width: 100%;\r\n}\r\n\r\n.label-filtros{\r\n    color: #555555;\r\n    font-weight: bold;\r\n}\r\n\r\n#galeria {\r\n  overflow-x: scroll;\r\n  overflow-y: hidden;\r\n  white-space: nowrap;\r\n  height: auto;\r\n  padding: 10px;\r\n  /*border: 2px outset #555555;*/\r\n}\r\n.elemento-galeria{\r\n    display: inline-block;\r\n    background: white;\r\n    border: 1px solid #FAFAFA;\r\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\r\n    margin-top: 5px;\r\n    margin-right: 7px;\r\n}\r\n.elemento-galeria:hover{\r\n    /*border: 2px solid #4185A3;*/\r\n    border: 1px solid rgba(101, 163, 127, 1);\r\n    box-shadow: 0 4px 8px 0 rgba(101, 163, 127, 0.6), 0 6px 20px 0 rgba(101, 163, 127, 0.59);\r\n    margin-top: 5px;\r\n    margin-right: 7px;\r\n}\r\n\r\n.elemento-galeria:focus{\r\n    background-color: rgba(0, 255, 0, 0.3);\r\n}\r\n\r\n.circle {\r\n  height:1em;\r\n  width: 1em;\r\n  border-radius: 0%;\r\n  display: inline-block;\r\n  margin-top: 2px;\r\n}</style><div class="well"><div class="row"><div class="col-xs-12"><label><h4><span data-translate="netWordAgroApp.mapaimagem.filtro">Filtros</span></h4></label></div></div><div class="row"><div class="col-xs-4"><label class="label-filtros"><span data-translate="netWordAgroApp.mapaimagem.propriedade">Propriedades</span></label></div><div class="col-xs-4"><label class="label-filtros"><span data-translate="netWordAgroApp.mapaimagem.safra">Safras</span></label></div><div class="col-xs-4"><label class="label-filtros"><span data-translate="netWordAgroApp.mapaimagem.tipomapa">Tipo de Mapas</span></label></div></div><div class="row"><div class="col-xs-4"><select class="form-control" id="field_filtropropriedade" name="filtropropriedade" ng-model="vm.filtroPropriedade" ng-options="prop as prop.nomepropriedade for prop in vm.propriedades track by prop.id" ng-change="vm.changeFiltroPropriedade()"><option value></option></select></div><div class="col-xs-4"><select class="form-control" id="field_filtrosafra" name="filtrosafra" ng-model="vm.filtroSafra" ng-options="saf as saf.nomesafra for saf in vm.safras track by saf.id"><option value></option></select></div><div class="col-xs-4"><select class="form-control" name="tipomapa" ng-model="vm.filtroTipoMapa" id="field_tipomapa"><option value></option><option value="percevejo" data-translate="netWordAgroApp.Tipomapa.percevejo">percevejo</option><option value="ferrugem" data-translate="netWordAgroApp.Tipomapa.ferrugem">ferrugem</option><option value="lagarta" data-translate="netWordAgroApp.Tipomapa.lagarta">lagarta</option><option value="manchaalvo" data-translate="netWordAgroApp.Tipomapa.manchaalvo">manchaalvo</option><!--<option value="saude" data-translate="netWordAgroApp.Tipomapa.saude">saude</option>\r\n                <option value="plantio" data-translate="netWordAgroApp.Tipomapa.plantio">plantio</option>\r\n                <option value="nutricional" data-translate="netWordAgroApp.Tipomapa.nutricional">nutricional</option>\r\n                <option value="umidade" data-translate="netWordAgroApp.Tipomapa.umidade">umidade</option> --><option value="ervadaninha" data-translate="netWordAgroApp.Tipomapa.ervadaninha">ervadaninha</option><option value="pulgao" data-translate="netWordAgroApp.Tipomapa.pulgao">pulgao</option><option value="helmintosporiose" data-translate="netWordAgroApp.Tipomapa.helmintosporiose">helmintosporiose</option><option value="oidio" data-translate="netWordAgroApp.Tipomapa.oidio">oidio</option><option value="doenca" data-translate="netWordAgroApp.Tipomapa.doenca">doenca</option><option value="plantadaninhacana" data-translate="netWordAgroApp.Tipomapa.plantadaninhacana">plantadaninhacana</option><option value="praga" data-translate="netWordAgroApp.Tipomapa.praga">praga</option><option value="amargoso" data-translate="netWordAgroApp.Tipomapa.amargoso">amargoso</option><option value="buva" data-translate="netWordAgroApp.Tipomapa.buva">buva</option><option value="falhaplantio" data-translate="netWordAgroApp.Tipomapa.falhaplantio">falhaplantio</option><option value="milho" data-translate="netWordAgroApp.Tipomapa.milho">milho</option><option value="folhalarga" data-translate="netWordAgroApp.Tipomapa.folhalarga">folhalarga</option><option value="folhaestreita" data-translate="netWordAgroApp.Tipomapa.folhaestreita">folhaestreita</option><option value="bicudo" data-translate="netWordAgroApp.Tipomapa.bicudo">bicudo</option><option value="cigarrinha" data-translate="netWordAgroApp.Tipomapa.cigarrinha">cigarrinha</option><option value="brocadacana" data-translate="netWordAgroApp.Tipomapa.broca">broca</option><option value="folhalargacana" data-translate="netWordAgroApp.Tipomapa.folhalargacana">folhalargacana</option><option value="folhaestreitacana" data-translate="netWordAgroApp.Tipomapa.folhaestreitacana">folhaestreitacana</option><option value="coro" data-translate="netWordAgroApp.Tipomapa.coro">coro</option><option value="nematoide" data-translate="netWordAgroApp.Tipomapa.nematoide">nematoide</option><option value="coracaomorto" data-translate="netWordAgroApp.Tipomapa.coracaomorto">coracaomorto</option><option value="manchafoliar" data-translate="netWordAgroApp.Tipomapa.manchafoliar">manchafoliar</option><option value="ramularia" data-translate="netWordAgroApp.Tipomapa.ramularia">ramularia</option><option value="acarorajado" data-translate="netWordAgroApp.Tipomapa.acarorajado">acarorajado</option><option value="tripes" data-translate="netWordAgroApp.Tipomapa.tripes">tripes</option><option value="antracnose" data-translate="netWordAgroApp.Tipomapa.antracnose">antracnose</option><option value="dessecacao" data-translate="netWordAgroApp.Tipomapa.dessecacao">dessecacao</option></select></div></div><br><div class="row"><div class="col-xs-4"><label class="label-filtros"><span data-translate="netWordAgroApp.mapaimagem.dodia">Do dia</span></label></div><div class="col-xs-4"><label class="label-filtros"><span data-translate="netWordAgroApp.mapaimagem.ate">At\xE9 o dia</span></label></div><div class="col-xs-4"></div></div><div class="row"><div class="col-xs-4"><div class="input-group"><input id="field_data" type="text" class="form-control" name="data" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.dataInicioIntervalo" is-open="vm.datePickerOpenStatus.dataInicio"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataInicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-4"><div class="input-group"><input id="field_data" type="text" class="form-control" name="data" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.dataFimIntervalo" is-open="vm.datePickerOpenStatus.dataFim"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataFim\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-4"><button class="btn btn-primary" ng-click="vm.aplicarFiltros()"><span data-translate="netWordAgroApp.mapaimagem.aplicarFiltros">Aplicar Filtros</span></button></div></div></div><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title">Informa\xE7\xF5es sobre Mapas</h4></div><div id="collapse1" class="panel-collapse collapse in"><div class="panel-body"><b>\xC1rea Afetada</b> \xE9 a \xE1rea onde existe o dano ou o agente causador do mesmo, identificada atrav\xE9s do monitoramento.<br>A <b>\xC1rea de Aplica\xE7\xE3o</b> ser\xE1 informada junto com o envio do arquivo shapefile, j\xE1 que esta depende do maquin\xE1rio a ser utilizado. Essa <b>\xC1rea de Aplica\xE7\xE3o</b> que deve ser utilizada para o c\xE1lculo da calda.</div></div></div><div class="row"><div class="col-xs-12" ng-show="vm.dadosMapas.length!=0"><label><h4><span data-translate="netWordAgroApp.mapaimagem.cliqueparavisualizar">Clique nos mapas para visualizar</span></h4></label></div></div><div class="row"><div class="col-xs-12" ng-show="vm.dadosMapas.length==0"><label><h4><span data-translate="netWordAgroApp.mapaimagem.apliquenovosfiltros">Aplique filtros para ver novos mapas para selecionar</span></h4></label></div></div><div class="row"><div class="col-xs-12" ng-show="vm.carregando"><label><h3><span data-translate="netWordAgroApp.mapaimagem.aguardecarregar">Aguarde o carregamento...</span></h3></label></div></div><div id="galeria" ng-show="vm.dadosMapas.length!=0"><div class="elemento-galeria" ng-repeat="mapa in vm.dadosMapas track by mapa.id" ng-click="vm.adicionarMapasSelecionados(mapa)"><center><div style="width: 6vw" ng-switch on="mapa.tipomapa"><img src="../../../content/images/svg/Tipos Mapa_amargoso.svg" ng-switch-when="amargoso" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_brocadacana.svg" ng-switch-when="brocadacana" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_buva.svg" ng-switch-when="buva" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_doenca.svg" ng-switch-when="doenca" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_falhaplantio.svg" ng-switch-when="falhaplantio" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_ferrugem.svg" ng-switch-when="ferrugem" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_folhaestreita.svg" ng-switch-when="folhaestreita" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_folhaestreitacana.svg" ng-switch-when="folhaestreitacana" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_folhalarga.svg" ng-switch-when="folhalarga" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_folhalargacana.svg" ng-switch-when="folhalargacana" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_helmintosporiose.svg" ng-switch-when="helmintosporiose" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_lagarta.svg" ng-switch-when="lagarta" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_manchaalvo.svg" ng-switch-when="manchaalvo" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_milho.svg" ng-switch-when="milho" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_nutricional.svg" ng-switch-when="nutricional" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_oidio.svg" ng-switch-when="oidio" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_outros.svg" ng-switch-when="outros" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_percevejo.svg" ng-switch-when="percevejo" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_plantadaninha.svg" ng-switch-when="ervadaninha" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_plantadaninhacana.svg" ng-switch-when="plantadaninhacana" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_praga.svg" ng-switch-when="praga" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_pulgao.svg" ng-switch-when="pulgao" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_outros.svg" ng-switch-default style="max-width: 100%" alt="mapaimagem image"></div></center><div style="padding: 5px; background: #FAFAFA; border-top: 1px solid #726CD3">{{mapa.nomemapa}}<br><span data-translate="netWordAgroApp.mapaimagem.data">Data:</span> {{mapa.data | date:"dd/MM/yyyy"}}<br><span ng-show="mapa.areaafetada"><span data-translate="netWordAgroApp.mapaimagem.areaafetada">\xC1rea Afetada:</span> {{mapa.areaafetada}} ha</span></div></div></div><br><br><div class="row"><div id="map" class="col-xs-12"></div></div><br><div class="row" ng-show="vm.mapasSelecionados.length!=0"><div class="col-xs-12"><label><h4><span data-translate="netWordAgroApp.mapaimagem.legenda">Legenda</span></h4></label></div></div><div class="row" ng-repeat="mapa in vm.mapasSelecionados"><div class="col-xs-4" style="padding: 12px; padding-top: 12px; font-size:1em"><span class="circle" ng-style="{background: mapa.wktData[0].cor}"></span> <b>{{mapa.nomemapa}}</b><br><span data-translate="netWordAgroApp.mapaimagem.data">Data:</span> {{mapa.data | date:"dd/MM/yyyy"}}<br><span data-translate="netWordAgroApp.mapaimagem.areaafetada">Data:</span> {{mapa.areaafetada}}<br></div><div class="col-xs-1" style="padding: 12px; padding-top: 12px; font-size:1em"><button class="btn btn-danger" ng-click="vm.removerMapaSelecionado(mapa)">Remover</button></div></div>');
$templateCache.put('app/entities/mapaimagem/mapaimagem-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.mapaimagem.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.mapaimagem.delete.question" translate-values="{id: \'{{vm.mapaimagem.id}}\'}">Are you sure you want to delete this Mapaimagem?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/mapaimagem/mapaimagem-detail.html','<div><h2><span data-translate="netWordAgroApp.mapaimagem.detail.title">Mapaimagem</span> {{vm.mapaimagem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.mapaimagem.nomemapa">Nomemapa</span></dt><dd><span>{{vm.mapaimagem.nomemapa}}</span></dd><dt><span data-translate="netWordAgroApp.mapaimagem.imagem">Imagem</span></dt><dd><div ng-if="vm.mapaimagem.imagem"><a ng-click="vm.openFile(vm.mapaimagem.imagemContentType, vm.mapaimagem.imagem)"><img data-ng-src="{{\'data:\' + vm.mapaimagem.imagemContentType + \';base64,\' + vm.mapaimagem.imagem}}" style="max-width: 100%" alt="mapaimagem image"> </a>{{vm.mapaimagem.imagemContentType}}, {{vm.byteSize(vm.mapaimagem.imagem)}}</div></dd><dt><span data-translate="netWordAgroApp.mapaimagem.latitudecentro">Latitudecentro</span></dt><dd><span>{{vm.mapaimagem.latitudecentro}}</span></dd><dt><span data-translate="netWordAgroApp.mapaimagem.longitudecentro">Longitudecentro</span></dt><dd><span>{{vm.mapaimagem.longitudecentro}}</span></dd><dt><span data-translate="netWordAgroApp.mapaimagem.tipoimagem">Tipoimagem</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipoimagem.\' + vm.mapaimagem.tipoimagem}}">{{vm.mapaimagem.tipoimagem}}</span></dd><dt><span data-translate="netWordAgroApp.mapaimagem.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.mapaimagem.safra.id})">{{vm.mapaimagem.safra.nomesafra}}</a></dd><dt><span data-translate="netWordAgroApp.mapaimagem.propriedade">Propriedade</span></dt><dd><a ui-sref="propriedade-detail({id:vm.mapaimagem.propriedade.id})">{{vm.mapaimagem.propriedade.nomepropriedade}}</a></dd><dt><span data-translate="netWordAgroApp.mapaimagem.atributo">Atributo</span></dt><dd><a ui-sref="atributo-detail({id:vm.mapaimagem.atributo.id})">{{vm.mapaimagem.atributo.nomeatributo}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="mapaimagem-detail.edit({id:vm.mapaimagem.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/mapaimagem/mapaimagem-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMapaimagemLabel" data-translate="netWordAgroApp.mapaimagem.home.createOrEditLabel">Create or edit a Mapaimagem</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.mapaimagem.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.mapaimagem.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.mapaimagem.nomemapa" for="field_nomemapa">Nomemapa</label><input type="text" class="form-control" name="nomemapa" id="field_nomemapa" ng-model="vm.mapaimagem.nomemapa" required><div ng-show="editForm.nomemapa.$invalid"><p class="help-block" ng-show="editForm.nomemapa.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setImagem($file, vm.mapaimagem)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="netWordAgroApp.mapaimagem.imagem" for="field_imagem">Imagem</label><div><img data-ng-src="{{\'data:\' + vm.mapaimagem.imagemContentType + \';base64,\' + vm.mapaimagem.imagem}}" style="max-height: 100px" ng-if="vm.mapaimagem.imagem" alt="mapaimagem image"><div ng-if="vm.mapaimagem.imagem" class="help-block clearfix"><span class="pull-left">{{vm.mapaimagem.imagemContentType}}, {{vm.byteSize(vm.mapaimagem.imagem)}}</span> <button type="button" ng-click="vm.mapaimagem.imagem=null;vm.mapaimagem.imagemContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setImagem($file, vm.mapaimagem)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="imagem" id="field_imagem" ng-model="vm.mapaimagem.imagem" required> <input type="hidden" class="form-control" name="imagemContentType" id="field_imagemContentType" ng-model="vm.mapaimagem.imagemContentType"><div ng-show="editForm.imagem.$invalid"><p class="help-block" ng-show="editForm.imagem.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><!----><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.mapaimagem.latitudecentro" for="field_latitudecentro">Latitudecentro</label><input type="text" class="form-control" name="latitudecentro" id="field_latitudecentro" ng-model="vm.mapaimagem.latitudecentro"><div ng-show="editForm.latitudecentro.$invalid"><p class="help-block" ng-show="editForm.latitudecentro.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.mapaimagem.longitudecentro" for="field_longitudecentro">Longitudecentro</label><input type="text" class="form-control" name="longitudecentro" id="field_longitudecentro" ng-model="vm.mapaimagem.longitudecentro"><div ng-show="editForm.longitudecentro.$invalid"><p class="help-block" ng-show="editForm.longitudecentro.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.mapaimagem.tipoimagem" for="field_tipoimagem">Tipoimagem</label><select class="form-control" name="tipoimagem" ng-model="vm.mapaimagem.tipoimagem" id="field_tipoimagem" required><option value="RGB" data-translate="netWordAgroApp.Tipoimagem.RGB">RGB</option><option value="RGN" data-translate="netWordAgroApp.Tipoimagem.RGN">RGN</option><option value="TERMICA" data-translate="netWordAgroApp.Tipoimagem.termica">TERMICA</option></select><div ng-show="editForm.tipoimagem.$invalid"><p class="help-block" ng-show="editForm.tipoimagem.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setImagempequena($file, vm.mapaimagem)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="netWordAgroApp.mapaimagem.imagempequena" for="field_imagempequena">Imagempequena</label><div><img data-ng-src="{{\'data:\' + vm.mapaimagem.imagempequenaContentType + \';base64,\' + vm.mapaimagem.imagempequena}}" style="max-height: 100px" ng-if="vm.mapaimagem.imagempequena" alt="mapaimagem image"><div ng-if="vm.mapaimagem.imagempequena" class="help-block clearfix"><span class="pull-left">{{vm.mapaimagem.imagempequenaContentType}}, {{vm.byteSize(vm.mapaimagem.imagempequena)}}</span> <button type="button" ng-click="vm.mapaimagem.imagempequena=null;vm.mapaimagem.imagempequenaContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setImagempequena($file, vm.mapaimagem)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="imagempequena" id="field_imagempequena" ng-model="vm.mapaimagem.imagempequena"> <input type="hidden" class="form-control" name="imagempequenaContentType" id="field_imagempequenaContentType" ng-model="vm.mapaimagem.imagempequenaContentType"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.mapaimagem.data" for="field_data">Data</label><div class="input-group"><input id="field_data" type="text" class="form-control" name="data" uib-datepicker-popup="{{dateformat}}" ng-model="vm.mapaimagem.data" is-open="vm.datePickerOpenStatus.data"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'data\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.mapaimagem.tipomapa" for="field_tipomapa">Tipomapa</label><select class="form-control" name="tipomapa" ng-model="vm.mapaimagem.tipomapa" id="field_tipomapa"><option value="acarorajado" data-translate="netWordAgroApp.Tipomapa.acarorajado">acarorajado</option><option value="amargoso" data-translate="netWordAgroApp.Tipomapa.amargoso">amargoso</option><option value="antracnose" data-translate="netWordAgroApp.Tipomapa.antracnose">antracnose</option><option value="bicudo" data-translate="netWordAgroApp.Tipomapa.bicudo">bicudo</option><option value="brocadacana" data-translate="netWordAgroApp.Tipomapa.broca">broca</option><option value="buva" data-translate="netWordAgroApp.Tipomapa.buva">buva</option><option value="cigarrinha" data-translate="netWordAgroApp.Tipomapa.cigarrinha">cigarrinha</option><option value="coracaomorto" data-translate="netWordAgroApp.Tipomapa.coracaomorto">coracaomorto</option><option value="coro" data-translate="netWordAgroApp.Tipomapa.coro">coro</option><option value="dessecacao" data-translate="netWordAgroApp.Tipomapa.dessecacao">dessecacao</option><option value="doenca" data-translate="netWordAgroApp.Tipomapa.doenca">doenca</option><option value="falhaplantio" data-translate="netWordAgroApp.Tipomapa.falhaplantio">falhaplantio</option><option value="ferrugem" data-translate="netWordAgroApp.Tipomapa.ferrugem">ferrugem</option><option value="folhaestreita" data-translate="netWordAgroApp.Tipomapa.folhaestreita">folhaestreita</option><option value="folhaestreitacana" data-translate="netWordAgroApp.Tipomapa.folhaestreitacana">folhaestreitacana</option><option value="folhalarga" data-translate="netWordAgroApp.Tipomapa.folhalarga">folhalarga</option><option value="folhalargacana" data-translate="netWordAgroApp.Tipomapa.folhalargacana">folhalargacana</option><option value="helmintosporiose" data-translate="netWordAgroApp.Tipomapa.helmintosporiose">helmintosporiose</option><option value="lagarta" data-translate="netWordAgroApp.Tipomapa.lagarta">lagarta</option><option value="manchaalvo" data-translate="netWordAgroApp.Tipomapa.manchaalvo">manchaalvo</option><option value="manchafoliar" data-translate="netWordAgroApp.Tipomapa.manchafoliar">manchafoliar</option><option value="milho" data-translate="netWordAgroApp.Tipomapa.milho">milho</option><option value="mofobranco" data-translate="netWordAgroApp.Tipomapa.mofobranco">mofobranco</option><option value="nematoide" data-translate="netWordAgroApp.Tipomapa.nematoide">nematoide</option><option value="nutricional" data-translate="netWordAgroApp.Tipomapa.nutricional">nutricional</option><option value="oidio" data-translate="netWordAgroApp.Tipomapa.oidio">oidio</option><option value="percevejo" data-translate="netWordAgroApp.Tipomapa.percevejo">percevejo</option><option value="ervadaninha" data-translate="netWordAgroApp.Tipomapa.ervadaninha">ervadaninha</option><option value="plantadaninhacana" data-translate="netWordAgroApp.Tipomapa.plantadaninhacana">plantadaninhacana</option><option value="plantio" data-translate="netWordAgroApp.Tipomapa.plantio">plantio</option><option value="praga" data-translate="netWordAgroApp.Tipomapa.praga">praga</option><option value="pulgao" data-translate="netWordAgroApp.Tipomapa.pulgao">pulgao</option><option value="ramularia" data-translate="netWordAgroApp.Tipomapa.ramularia">ramularia</option><option value="tripes" data-translate="netWordAgroApp.Tipomapa.tripes">tripes</option><option value="saude" data-translate="netWordAgroApp.Tipomapa.saude">saude</option><option value="umidade" data-translate="netWordAgroApp.Tipomapa.umidade">umidade</option></select></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.mapaimagem.areaafetada" for="field_areaafetada">areaafetada</label><input type="text" class="form-control" name="areaafetada" id="field_areaafetada" ng-model="vm.mapaimagem.areaafetada"><div ng-show="editForm.areaafetada.$invalid"><p class="help-block" ng-show="editForm.areaafetada.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setShapefile($file, vm.mapaimagem)"><label class="control-label" data-translate="netWordAgroApp.mapaimagem.shapefile" for="field_shapefile">Shapefile</label><div><div ng-if="vm.mapaimagem.shapefile" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.mapaimagem.shapefileContentType, vm.mapaimagem.shapefile)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.mapaimagem.shapefileContentType}}, {{vm.byteSize(vm.mapaimagem.shapefile)}}</span> <button type="button" ng-click="vm.mapaimagem.shapefile=null;vm.mapaimagem.shapefileContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setShapefile($file, vm.mapaimagem)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="shapefile" id="field_shapefile" ng-model="vm.mapaimagem.shapefile"> <input type="hidden" class="form-control" name="shapefileContentType" id="field_shapefileContentType" ng-model="vm.mapaimagem.shapefileContentType"></div><div class="form-group" ngf-drop ngf-change="vm.setCSV($file, vm.mapaimagem)"><label class="control-label" data-translate="netWordAgroApp.mapaimagem.csv" for="field_csv">CSV</label><div><div ng-if="vm.mapaimagem.csv" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.mapaimagem.csvContentType, vm.mapaimagem.csv)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.mapaimagem.csvContentType}}, {{vm.byteSize(vm.mapaimagem.csv)}}</span> <button type="button" ng-click="vm.mapaimagem.csv=null;vm.mapaimagem.csvContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setCSV($file, vm.mapaimagem)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="csv" id="field_csv" ng-model="vm.mapaimagem.csv" required> <input type="hidden" class="form-control" name="csvContentType" id="field_csvContentType" ng-model="vm.mapaimagem.csvContentType"></div><div class="form-group" ngf-drop ngf-change="vm.setWKT($file, vm.mapaimagem)"><label class="control-label" data-translate="netWordAgroApp.mapaimagem.wkt" for="field_wkt">WKT</label><div><div ng-if="vm.mapaimagem.wkt" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.mapaimagem.wktContentType, vm.mapaimagem.wkt)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.mapaimagem.wktContentType}}, {{vm.byteSize(vm.mapaimagem.wkt)}}</span> <button type="button" ng-click="vm.mapaimagem.wkt=null;vm.mapaimagem.wktContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setWKT($file, vm.mapaimagem)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="wkt" id="field_shapefile" ng-model="vm.mapaimagem.wkt" required> <input type="hidden" class="form-control" name="wktContentType" id="field_wktContentType" ng-model="vm.mapaimagem.wktContentType"></div><div class="form-group"><label data-translate="netWordAgroApp.mapaimagem.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.mapaimagem.safra" ng-options="safra as safra.nomesafra for safra in vm.safras track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.mapaimagem.propriedade" for="field_propriedade">Propriedade</label><select class="form-control" id="field_propriedade" name="propriedade" ng-model="vm.mapaimagem.propriedade" ng-options="propriedade as propriedade.nomepropriedade for propriedade in vm.propriedades track by propriedade.id" required></select></div><div ng-show="editForm.propriedade.$invalid"><p class="help-block" ng-show="editForm.propriedade.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.mapaimagem.atributo" for="field_atributo">Atributo</label><select class="form-control" id="field_atributo" name="atributo" ng-model="vm.mapaimagem.atributo" ng-options="atributo as atributo.nomeatributo for atributo in vm.atributos track by atributo.id"><option value=""></option></select></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.mapaimagem.tolerancia" for="field_tolerancia">Toler\xE2ncia</label><input type="text" class="form-control" name="tolerancia" id="field_tolerancia" ng-model="vm.mapaimagem.tolerancia"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/mapaimagem/mapaimagem-visualizar.html','<div ng-show="!vm.carregando"><h2>{{vm.nomemapa}}</h2></div><h5>Identificador: {{vm.idmapa}}</h5><div ng-if="vm.carregando"><h4>Aguarde, estamos carregando o seu mapa...</h4></div><center><div ng-show="!vm.carregando" class="img-zoom-container"><img id="myimage" src="{{vm.fileURL}}" width="80%"></div></center><button type="submit" ui-sref="mapaimagem" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button>');
$templateCache.put('app/entities/mapaimagem/mapaimagems.html','<div><h2 data-translate="netWordAgroApp.mapaimagem.home.title">Mapaimagems</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="mapaimagem.new" has-any-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.mapaimagem.home.createLabel">Create new Mapaimagem</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.mapaimagem.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="container-fluid" style="margin-top:10px"><div class="row"><div class="col-xs-4 no-padding-left"><form name="filtrar" class="form-inline"><label class="control-label" data-translate="netWordAgroApp.mapaimagem.filtrarporpropriedade" for="field_filtropropriedade">Tipomapa</label><select class="form-control" id="field_filtropropriedade" name="filtropropriedade" ng-model="vm.filtropropriedade" ng-options="prop as prop.nomepropriedade for prop in vm.filtropropriedades track by prop.id" ng-change="vm.changeFiltro()"><option value></option></select></form></div></div></div><br><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title">Informa\xE7\xF5es sobre Mapas</h4></div><div id="collapse1" class="panel-collapse collapse in"><div class="panel-body"><b>\xC1rea Afetada</b> \xE9 a \xE1rea onde existe o dano ou o agente causador do mesmo, identificada atrav\xE9s do monitoramento.<br>A <b>\xC1rea de Aplica\xE7\xE3o</b> ser\xE1 informada junto com o envio do arquivo shapefile, j\xE1 que esta depende do maquin\xE1rio a ser utilizado. Essa <b>\xC1rea de Aplica\xE7\xE3o</b> que deve ser utilizada para o c\xE1lculo da calda.</div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomemapa"><span data-translate="netWordAgroApp.mapaimagem.nomemapa">Nomemapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipomapa"><span data-translate="netWordAgroApp.mapaimagem.tipomapa">Tipomapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="imagem"><span data-translate="netWordAgroApp.mapaimagem.imagem">Imagem</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="data"><span data-translate="netWordAgroApp.mapaimagem.data">Data</span> <span class="glyphicon glyphicon-sort"></span></th><!--\n                    <th jh-sort-by="latitudecentro"><span data-translate="netWordAgroApp.mapaimagem.latitudecentro">Latitudecentro</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th jh-sort-by="longitudecentro"><span data-translate="netWordAgroApp.mapaimagem.longitudecentro">Longitudecentro</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th jh-sort-by="tipoimagem"><span data-translate="netWordAgroApp.mapaimagem.tipoimagem">Tipoimagem</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    --><th jh-sort-by="data"><span data-translate="netWordAgroApp.mapaimagem.areaafetada">AreaAfetada</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="safra.nomesafra"><span data-translate="netWordAgroApp.mapaimagem.safra">Safra</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="netWordAgroApp.mapaimagem.shapefile">Shapefile</span></th><th><span data-translate="netWordAgroApp.mapaimagem.csv">CSV</span></th><th><span data-translate="netWordAgroApp.mapaimagem.wkt">WKT</span></th><th jh-sort-by="propriedade.nomepropriedade"><span data-translate="netWordAgroApp.mapaimagem.propriedade">Propriedade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="atributo.nomeatributo"><span data-translate="netWordAgroApp.mapaimagem.atributo">Atributo</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="mapaimagem in vm.mapaimagems track by mapaimagem.id"><td><a ui-sref="mapaimagem-detail({id:mapaimagem.id})">{{mapaimagem.id}}</a></td><td>{{mapaimagem.nomemapa}}</td><td data-translate="{{\'netWordAgroApp.Tipomapa.\' + mapaimagem.tipomapa}}"></td><td><button ui-sref="mapaimagem-visualizarimagem({id:mapaimagem.id})" class="btn btn-warning btn-sm"><span class="glyphicon glyphicon-picture"></span> <span class="hidden-sm-down" data-translate="netWordAgroApp.mapaimagem.abririmagem">Abrir imagem</span></button></td><td>{{mapaimagem.data}}</td><!--\n                    <td>{{mapaimagem.latitudecentro}}</td>\n                    <td>{{mapaimagem.longitudecentro}}</td>\n                    <td data-translate="{{\'netWordAgroApp.Tipoimagem.\' + mapaimagem.tipoimagem}}">{{mapaimagem.tipoimagem}}</td>\n                    --><td>{{mapaimagem.areaafetada}}</td><td><a ui-sref="safra-detail({id:mapaimagem.safra_id})">{{mapaimagem.safra_nomesafra}}</a></td><td><button class="btn btn-info btn-sm" ng-click="vm.downloadShape(mapaimagem.id)"><span class="glyphicon glyphicon-download-alt"></span> <span class="hidden-sm-down" data-translate="netWordAgroApp.mapaimagem.downloadshapefile">Download Shapefile</span></button></td><td><button class="btn btn-info btn-sm" ng-click="vm.downloadCSV(mapaimagem.id)"><span class="glyphicon glyphicon-download-alt"></span> <span class="hidden-sm-down" data-translate="netWordAgroApp.mapaimagem.downloadcsv">Download CSV</span></button></td><td><button class="btn btn-info btn-sm" ng-click="vm.downloadWKT(mapaimagem.id)"><span class="glyphicon glyphicon-download-alt"></span> <span class="hidden-sm-down" data-translate="netWordAgroApp.mapaimagem.downloadwkt">Download WKT</span></button></td><td><a ui-sref="propriedade-detail({id:mapaimagem.propriedade_id})">{{mapaimagem.propriedade_nomepropriedade}}</a></td><td><a ui-sref="atributo-detail({id:mapaimagem.atributo_id})">{{mapaimagem.atributo_nomeatributo}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ng-click="vm.download(mapaimagem.id)" class="btn btn-info btn-sm" has-any-authority="ROLE_ADMIN, ROLE_GESTOR_PARCEIROS"><span class="glyphicon glyphicon-download-alt"></span> <span class="hidden-sm-down" data-translate="netWordAgroApp.mapaimagem.download"></span></button> <button type="submit" ui-sref="mapaimagem.edit({id:mapaimagem.id})" class="btn btn-primary btn-sm" has-any-authority="ROLE_ADMIN, ROLE_GESTOR_PARCEIROS"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="mapaimagem.delete({id:mapaimagem.id})" class="btn btn-danger btn-sm" has-any-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/maquinario/maquinario-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.maquinario.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.maquinario.delete.question" translate-values="{id: \'{{vm.maquinario.id}}\'}">Are you sure you want to delete this Maquinario?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/maquinario/maquinario-detail.html','<div><h2><span data-translate="netWordAgroApp.maquinario.detail.title">Maquinario</span> {{vm.maquinario.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.maquinario.marca">Marca</span></dt><dd><span>{{vm.maquinario.marca}}</span></dd><dt><span data-translate="netWordAgroApp.maquinario.modelo">Modelo</span></dt><dd><span>{{vm.maquinario.modelo}}</span></dd><dt><span data-translate="netWordAgroApp.maquinario.monitor">Monitor</span></dt><dd><span>{{vm.maquinario.monitor}}</span></dd><dt><span data-translate="netWordAgroApp.maquinario.tamanho">Tamanho</span></dt><dd><span>{{vm.maquinario.tamanho}}</span></dd><dt><span data-translate="netWordAgroApp.maquinario.estruturapastas">Estruturapastas</span></dt><dd><span>{{vm.maquinario.estruturapastas}}</span></dd><dt><span data-translate="netWordAgroApp.maquinario.modogps">Modogps</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipogps.\' + vm.maquinario.modogps}}">{{vm.maquinario.modogps}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="maquinario-detail.edit({id:vm.maquinario.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/maquinario/maquinario-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMaquinarioLabel" data-translate="netWordAgroApp.maquinario.home.createOrEditLabel">Create or edit a Maquinario</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.maquinario.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.maquinario.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.maquinario.marca" for="field_marca">Marca</label><input type="text" class="form-control" name="marca" id="field_marca" ng-model="vm.maquinario.marca"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.maquinario.modelo" for="field_modelo">Modelo</label><input type="text" class="form-control" name="modelo" id="field_modelo" ng-model="vm.maquinario.modelo"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.maquinario.monitor" for="field_monitor">Monitor</label><input type="text" class="form-control" name="monitor" id="field_monitor" ng-model="vm.maquinario.monitor"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.maquinario.tamanho" for="field_tamanho">Tamanho</label><input type="number" class="form-control" name="tamanho" id="field_tamanho" ng-model="vm.maquinario.tamanho"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.maquinario.estruturapastas" for="field_estruturapastas">Estruturapastas</label><input type="text" class="form-control" name="estruturapastas" id="field_estruturapastas" ng-model="vm.maquinario.estruturapastas"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.maquinario.modogps" for="field_modogps">Modogps</label><select class="form-control" name="modogps" ng-model="vm.maquinario.modogps" id="field_modogps"><option value="duascamadas" data-translate="netWordAgroApp.Tipogps.duascamadas">duascamadas</option><option value="poligonos" data-translate="netWordAgroApp.Tipogps.poligonos">poligonos</option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/maquinario/maquinarios.html','<div><h2 data-translate="netWordAgroApp.maquinario.home.title">Maquinarios</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="maquinario.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.maquinario.home.createLabel">Create new Maquinario</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.maquinario.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="marca"><span data-translate="netWordAgroApp.maquinario.marca">Marca</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="modelo"><span data-translate="netWordAgroApp.maquinario.modelo">Modelo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="monitor"><span data-translate="netWordAgroApp.maquinario.monitor">Monitor</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tamanho"><span data-translate="netWordAgroApp.maquinario.tamanho">Tamanho</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="estruturapastas"><span data-translate="netWordAgroApp.maquinario.estruturapastas">Estruturapastas</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="modogps"><span data-translate="netWordAgroApp.maquinario.modogps">Modogps</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="maquinario in vm.maquinarios track by maquinario.id"><td><a ui-sref="maquinario-detail({id:maquinario.id})">{{maquinario.id}}</a></td><td>{{maquinario.marca}}</td><td>{{maquinario.modelo}}</td><td>{{maquinario.monitor}}</td><td>{{maquinario.tamanho}}</td><td>{{maquinario.estruturapastas}}</td><td data-translate="{{\'netWordAgroApp.Tipogps.\' + maquinario.modogps}}">{{maquinario.modogps}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="maquinario-detail({id:maquinario.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="maquinario.edit({id:maquinario.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="maquinario.delete({id:maquinario.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/medicaoatribpesq/medicaoatribpesq-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.medicaoatribpesq.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.medicaoatribpesq.delete.question" translate-values="{id: \'{{vm.medicaoatribpesq.id}}\'}">Are you sure you want to delete this Medicaoatribpesq?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/medicaoatribpesq/medicaoatribpesq-detail.html','<div><h2><span data-translate="netWordAgroApp.medicaoatribpesq.detail.title">Medicaoatribpesq</span> {{vm.medicaoatribpesq.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.medicaoatribpesq.datahoramedicao">Datahoramedicao</span></dt><dd><span>{{vm.medicaoatribpesq.datahoramedicao | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.medicaoatribpesq.freqmedicao">Freqmedicao</span></dt><dd><span>{{vm.medicaoatribpesq.freqmedicao}}</span></dd><dt><span data-translate="netWordAgroApp.medicaoatribpesq.conduteletricamedicao">Conduteletricamedicao</span></dt><dd><span>{{vm.medicaoatribpesq.conduteletricamedicao}}</span></dd><dt><span data-translate="netWordAgroApp.medicaoatribpesq.umidmedicao">Umidmedicao</span></dt><dd><span>{{vm.medicaoatribpesq.umidmedicao}}</span></dd><dt><span data-translate="netWordAgroApp.medicaoatribpesq.tempmedicao">Tempmedicao</span></dt><dd><span>{{vm.medicaoatribpesq.tempmedicao}}</span></dd><dt><span data-translate="netWordAgroApp.medicaoatribpesq.valorconcentracao">Valorconcentracao</span></dt><dd><span>{{vm.medicaoatribpesq.valorconcentracao}}</span></dd><dt><span data-translate="netWordAgroApp.medicaoatribpesq.atributopesquisa">Atributopesquisa</span></dt><dd><a ui-sref="atributopesquisa-detail({id:vm.medicaoatribpesq.atributopesquisa.id})">{{vm.medicaoatribpesq.atributopesquisa.id}}</a></dd><dt><span data-translate="netWordAgroApp.medicaoatribpesq.pesquisa">Pesquisa</span></dt><dd><a ui-sref="pesquisa-detail({id:vm.medicaoatribpesq.pesquisa.id})">{{vm.medicaoatribpesq.pesquisa.nomepesquisa}}</a></dd><dt><span data-translate="netWordAgroApp.medicaoatribpesq.pontossensoriamentosolo">Pontossensoriamentosolo</span></dt><dd><a ui-sref="pontossensoriamentosolo-detail({id:vm.medicaoatribpesq.pontossensoriamentosolo.id})">{{vm.medicaoatribpesq.pontossensoriamentosolo.nomeponto}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="medicaoatribpesq-detail.edit({id:vm.medicaoatribpesq.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/medicaoatribpesq/medicaoatribpesq-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMedicaoatribpesqLabel" data-translate="netWordAgroApp.medicaoatribpesq.home.createOrEditLabel">Create or edit a Medicaoatribpesq</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.medicaoatribpesq.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.medicaoatribpesq.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.medicaoatribpesq.datahoramedicao" for="field_datahoramedicao">Datahoramedicao</label><div class="input-group"><input id="field_datahoramedicao" type="text" class="form-control" name="datahoramedicao" uib-datepicker-popup="{{dateformat}}" ng-model="vm.medicaoatribpesq.datahoramedicao" is-open="vm.datePickerOpenStatus.datahoramedicao" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datahoramedicao\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datahoramedicao.$invalid"><p class="help-block" ng-show="editForm.datahoramedicao.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.medicaoatribpesq.freqmedicao" for="field_freqmedicao">Freqmedicao</label><input type="number" class="form-control" name="freqmedicao" id="field_freqmedicao" ng-model="vm.medicaoatribpesq.freqmedicao" required min="0"><div ng-show="editForm.freqmedicao.$invalid"><p class="help-block" ng-show="editForm.freqmedicao.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.freqmedicao.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.medicaoatribpesq.conduteletricamedicao" for="field_conduteletricamedicao">Conduteletricamedicao</label><input type="number" class="form-control" name="conduteletricamedicao" id="field_conduteletricamedicao" ng-model="vm.medicaoatribpesq.conduteletricamedicao" required min="0"><div ng-show="editForm.conduteletricamedicao.$invalid"><p class="help-block" ng-show="editForm.conduteletricamedicao.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.conduteletricamedicao.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.medicaoatribpesq.umidmedicao" for="field_umidmedicao">Umidmedicao</label><input type="number" class="form-control" name="umidmedicao" id="field_umidmedicao" ng-model="vm.medicaoatribpesq.umidmedicao" required min="0"><div ng-show="editForm.umidmedicao.$invalid"><p class="help-block" ng-show="editForm.umidmedicao.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.umidmedicao.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.medicaoatribpesq.tempmedicao" for="field_tempmedicao">Tempmedicao</label><input type="number" class="form-control" name="tempmedicao" id="field_tempmedicao" ng-model="vm.medicaoatribpesq.tempmedicao" required><div ng-show="editForm.tempmedicao.$invalid"><p class="help-block" ng-show="editForm.tempmedicao.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.tempmedicao.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.medicaoatribpesq.valorconcentracao" for="field_valorconcentracao">Valorconcentracao</label><input type="number" class="form-control" name="valorconcentracao" id="field_valorconcentracao" ng-model="vm.medicaoatribpesq.valorconcentracao" required min="0"><div ng-show="editForm.valorconcentracao.$invalid"><p class="help-block" ng-show="editForm.valorconcentracao.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.valorconcentracao.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.medicaoatribpesq.atributopesquisa" for="field_atributopesquisa">Atributopesquisa</label><select class="form-control" id="field_atributopesquisa" name="atributopesquisa" ng-model="vm.medicaoatribpesq.atributopesquisa" ng-options="atributopesquisa as atributopesquisa.id for atributopesquisa in vm.atributopesquisas track by atributopesquisa.id" required></select></div><div ng-show="editForm.atributopesquisa.$invalid"><p class="help-block" ng-show="editForm.atributopesquisa.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.medicaoatribpesq.pesquisa" for="field_pesquisa">Pesquisa</label><select class="form-control" id="field_pesquisa" name="pesquisa" ng-model="vm.medicaoatribpesq.pesquisa" ng-options="pesquisa as pesquisa.nomepesquisa for pesquisa in vm.pesquisas track by pesquisa.id" required></select></div><div ng-show="editForm.pesquisa.$invalid"><p class="help-block" ng-show="editForm.pesquisa.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.medicaoatribpesq.pontossensoriamentosolo" for="field_pontossensoriamentosolo">Pontossensoriamentosolo</label><select class="form-control" id="field_pontossensoriamentosolo" name="pontossensoriamentosolo" ng-model="vm.medicaoatribpesq.pontossensoriamentosolo" ng-options="pontossensoriamentosolo as pontossensoriamentosolo.nomeponto for pontossensoriamentosolo in vm.pontossensoriamentosolos track by pontossensoriamentosolo.id" required></select></div><div ng-show="editForm.pontossensoriamentosolo.$invalid"><p class="help-block" ng-show="editForm.pontossensoriamentosolo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/medicaoatribpesq/medicaoatribpesqs.html','<div><h2 data-translate="netWordAgroApp.medicaoatribpesq.home.title">Medicaoatribpesqs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="medicaoatribpesq.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.medicaoatribpesq.home.createLabel">Create new Medicaoatribpesq</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.medicaoatribpesq.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datahoramedicao"><span data-translate="netWordAgroApp.medicaoatribpesq.datahoramedicao">Datahoramedicao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="freqmedicao"><span data-translate="netWordAgroApp.medicaoatribpesq.freqmedicao">Freqmedicao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="conduteletricamedicao"><span data-translate="netWordAgroApp.medicaoatribpesq.conduteletricamedicao">Conduteletricamedicao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="umidmedicao"><span data-translate="netWordAgroApp.medicaoatribpesq.umidmedicao">Umidmedicao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tempmedicao"><span data-translate="netWordAgroApp.medicaoatribpesq.tempmedicao">Tempmedicao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorconcentracao"><span data-translate="netWordAgroApp.medicaoatribpesq.valorconcentracao">Valorconcentracao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="atributopesquisa.id"><span data-translate="netWordAgroApp.medicaoatribpesq.atributopesquisa">Atributopesquisa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pesquisa.nomepesquisa"><span data-translate="netWordAgroApp.medicaoatribpesq.pesquisa">Pesquisa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pontossensoriamentosolo.nomeponto"><span data-translate="netWordAgroApp.medicaoatribpesq.pontossensoriamentosolo">Pontossensoriamentosolo</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="medicaoatribpesq in vm.medicaoatribpesqs track by medicaoatribpesq.id"><td><a ui-sref="medicaoatribpesq-detail({id:medicaoatribpesq.id})">{{medicaoatribpesq.id}}</a></td><td>{{medicaoatribpesq.datahoramedicao | date:\'mediumDate\'}}</td><td>{{medicaoatribpesq.freqmedicao}}</td><td>{{medicaoatribpesq.conduteletricamedicao}}</td><td>{{medicaoatribpesq.umidmedicao}}</td><td>{{medicaoatribpesq.tempmedicao}}</td><td>{{medicaoatribpesq.valorconcentracao}}</td><td><a ui-sref="atributopesquisa-detail({id:medicaoatribpesq.atributopesquisa.id})">{{medicaoatribpesq.atributopesquisa.id}}</a></td><td><a ui-sref="pesquisa-detail({id:medicaoatribpesq.pesquisa.id})">{{medicaoatribpesq.pesquisa.nomepesquisa}}</a></td><td><a ui-sref="pontossensoriamentosolo-detail({id:medicaoatribpesq.pontossensoriamentosolo.id})">{{medicaoatribpesq.pontossensoriamentosolo.nomeponto}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="medicaoatribpesq-detail({id:medicaoatribpesq.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="medicaoatribpesq.edit({id:medicaoatribpesq.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="medicaoatribpesq.delete({id:medicaoatribpesq.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/medicaoatriblavoura/medicaoatriblavoura-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.medicaoatriblavoura.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.medicaoatriblavoura.delete.question" translate-values="{id: \'{{vm.medicaoatriblavoura.id}}\'}">Are you sure you want to delete this Medicaoatriblavoura?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/medicaoatriblavoura/medicaoatriblavoura-detail.html','<div><h2><span data-translate="netWordAgroApp.medicaoatriblavoura.detail.title">Medicaoatriblavoura</span> {{vm.medicaoatriblavoura.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.medicaoatriblavoura.nomemonitoramento">Nomemonitoramento</span></dt><dd><span>{{vm.medicaoatriblavoura.nomemonitoramento}}</span></dd><dt><span data-translate="netWordAgroApp.medicaoatriblavoura.corassociada">Corassociada</span></dt><dd><span>{{vm.medicaoatriblavoura.corassociada}}</span></dd><dt><span data-translate="netWordAgroApp.medicaoatriblavoura.tipomonitoramento">Tipomonitoramento</span></dt><dd><span>{{vm.medicaoatriblavoura.tipomonitoramento}}</span></dd><dt><span data-translate="netWordAgroApp.medicaoatriblavoura.valoraquisitado">Valoraquisitado</span></dt><dd><span>{{vm.medicaoatriblavoura.valoraquisitado}}</span></dd><dt><span data-translate="netWordAgroApp.medicaoatriblavoura.pesquisa">Pesquisa</span></dt><dd><a ui-sref="pesquisa-detail({id:vm.medicaoatriblavoura.pesquisa.id})">{{vm.medicaoatriblavoura.pesquisa.nomepesquisa}}</a></dd><dt><span data-translate="netWordAgroApp.medicaoatriblavoura.atributopesquisa">Atributopesquisa</span></dt><dd><a ui-sref="atributopesquisa-detail({id:vm.medicaoatriblavoura.atributopesquisa.id})">{{vm.medicaoatriblavoura.atributopesquisa.id}}</a></dd><dt><span data-translate="netWordAgroApp.medicaoatriblavoura.quadranteimagem">Quadranteimagem</span></dt><dd><a ui-sref="quadranteimagem-detail({id:vm.medicaoatriblavoura.quadranteimagem.id})">{{vm.medicaoatriblavoura.quadranteimagem.nomequadrante}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="medicaoatriblavoura-detail.edit({id:vm.medicaoatriblavoura.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/medicaoatriblavoura/medicaoatriblavoura-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMedicaoatriblavouraLabel" data-translate="netWordAgroApp.medicaoatriblavoura.home.createOrEditLabel">Create or edit a Medicaoatriblavoura</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.medicaoatriblavoura.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.medicaoatriblavoura.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.medicaoatriblavoura.nomemonitoramento" for="field_nomemonitoramento">Nomemonitoramento</label><input type="text" class="form-control" name="nomemonitoramento" id="field_nomemonitoramento" ng-model="vm.medicaoatriblavoura.nomemonitoramento" required><div ng-show="editForm.nomemonitoramento.$invalid"><p class="help-block" ng-show="editForm.nomemonitoramento.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.medicaoatriblavoura.corassociada" for="field_corassociada">Corassociada</label><input type="text" class="form-control" name="corassociada" id="field_corassociada" ng-model="vm.medicaoatriblavoura.corassociada" required><div ng-show="editForm.corassociada.$invalid"><p class="help-block" ng-show="editForm.corassociada.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.medicaoatriblavoura.tipomonitoramento" for="field_tipomonitoramento">Tipomonitoramento</label><input type="text" class="form-control" name="tipomonitoramento" id="field_tipomonitoramento" ng-model="vm.medicaoatriblavoura.tipomonitoramento" required><div ng-show="editForm.tipomonitoramento.$invalid"><p class="help-block" ng-show="editForm.tipomonitoramento.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.medicaoatriblavoura.valoraquisitado" for="field_valoraquisitado">Valoraquisitado</label><input type="text" class="form-control" name="valoraquisitado" id="field_valoraquisitado" ng-model="vm.medicaoatriblavoura.valoraquisitado" required><div ng-show="editForm.valoraquisitado.$invalid"><p class="help-block" ng-show="editForm.valoraquisitado.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.medicaoatriblavoura.pesquisa" for="field_pesquisa">Pesquisa</label><select class="form-control" id="field_pesquisa" name="pesquisa" ng-model="vm.medicaoatriblavoura.pesquisa" ng-options="pesquisa as pesquisa.nomepesquisa for pesquisa in vm.pesquisas track by pesquisa.id" required></select></div><div ng-show="editForm.pesquisa.$invalid"><p class="help-block" ng-show="editForm.pesquisa.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.medicaoatriblavoura.atributopesquisa" for="field_atributopesquisa">Atributopesquisa</label><select class="form-control" id="field_atributopesquisa" name="atributopesquisa" ng-model="vm.medicaoatriblavoura.atributopesquisa" ng-options="atributopesquisa as atributopesquisa.id for atributopesquisa in vm.atributopesquisas track by atributopesquisa.id" required></select></div><div ng-show="editForm.atributopesquisa.$invalid"><p class="help-block" ng-show="editForm.atributopesquisa.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.medicaoatriblavoura.quadranteimagem" for="field_quadranteimagem">Quadranteimagem</label><select class="form-control" id="field_quadranteimagem" name="quadranteimagem" ng-model="vm.medicaoatriblavoura.quadranteimagem" ng-options="quadranteimagem as quadranteimagem.nomequadrante for quadranteimagem in vm.quadranteimagems track by quadranteimagem.id" required></select></div><div ng-show="editForm.quadranteimagem.$invalid"><p class="help-block" ng-show="editForm.quadranteimagem.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/medicaoatriblavoura/medicaoatriblavouras.html','<div><h2 data-translate="netWordAgroApp.medicaoatriblavoura.home.title">Medicaoatriblavouras</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="medicaoatriblavoura.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.medicaoatriblavoura.home.createLabel">Create new Medicaoatriblavoura</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.medicaoatriblavoura.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomemonitoramento"><span data-translate="netWordAgroApp.medicaoatriblavoura.nomemonitoramento">Nomemonitoramento</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="corassociada"><span data-translate="netWordAgroApp.medicaoatriblavoura.corassociada">Corassociada</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipomonitoramento"><span data-translate="netWordAgroApp.medicaoatriblavoura.tipomonitoramento">Tipomonitoramento</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valoraquisitado"><span data-translate="netWordAgroApp.medicaoatriblavoura.valoraquisitado">Valoraquisitado</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pesquisa.nomepesquisa"><span data-translate="netWordAgroApp.medicaoatriblavoura.pesquisa">Pesquisa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="atributopesquisa.id"><span data-translate="netWordAgroApp.medicaoatriblavoura.atributopesquisa">Atributopesquisa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quadranteimagem.nomequadrante"><span data-translate="netWordAgroApp.medicaoatriblavoura.quadranteimagem">Quadranteimagem</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="medicaoatriblavoura in vm.medicaoatriblavouras track by medicaoatriblavoura.id"><td><a ui-sref="medicaoatriblavoura-detail({id:medicaoatriblavoura.id})">{{medicaoatriblavoura.id}}</a></td><td>{{medicaoatriblavoura.nomemonitoramento}}</td><td>{{medicaoatriblavoura.corassociada}}</td><td>{{medicaoatriblavoura.tipomonitoramento}}</td><td>{{medicaoatriblavoura.valoraquisitado}}</td><td><a ui-sref="pesquisa-detail({id:medicaoatriblavoura.pesquisa.id})">{{medicaoatriblavoura.pesquisa.nomepesquisa}}</a></td><td><a ui-sref="atributopesquisa-detail({id:medicaoatriblavoura.atributopesquisa.id})">{{medicaoatriblavoura.atributopesquisa.id}}</a></td><td><a ui-sref="quadranteimagem-detail({id:medicaoatriblavoura.quadranteimagem.id})">{{medicaoatriblavoura.quadranteimagem.nomequadrante}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="medicaoatriblavoura-detail({id:medicaoatriblavoura.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="medicaoatriblavoura.edit({id:medicaoatriblavoura.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="medicaoatriblavoura.delete({id:medicaoatriblavoura.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/matrizsensoriamento/matrizsensoriamento-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.matrizsensoriamento.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.matrizsensoriamento.delete.question" translate-values="{id: \'{{vm.matrizsensoriamento.id}}\'}">Are you sure you want to delete this Matrizsensoriamento?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/matrizsensoriamento/matrizsensoriamento-detail.html','<div><h2><span data-translate="netWordAgroApp.matrizsensoriamento.detail.title">Matrizsensoriamento</span> {{vm.matrizsensoriamento.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.matrizsensoriamento.nomematriz">Nomematriz</span></dt><dd><span>{{vm.matrizsensoriamento.nomematriz}}</span></dd><dt><span data-translate="netWordAgroApp.matrizsensoriamento.imagemmatriz">Imagemmatriz</span></dt><dd><div ng-if="vm.matrizsensoriamento.imagemmatriz"><a ng-click="vm.openFile(vm.matrizsensoriamento.imagemmatrizContentType, vm.matrizsensoriamento.imagemmatriz)"><img data-ng-src="{{\'data:\' + vm.matrizsensoriamento.imagemmatrizContentType + \';base64,\' + vm.matrizsensoriamento.imagemmatriz}}" style="max-width: 100%" alt="matrizsensoriamento image"> </a>{{vm.matrizsensoriamento.imagemmatrizContentType}}, {{vm.byteSize(vm.matrizsensoriamento.imagemmatriz)}}</div></dd><dt><span data-translate="netWordAgroApp.matrizsensoriamento.valorlatitudep1">Valorlatitudep 1</span></dt><dd><span>{{vm.matrizsensoriamento.valorlatitudep1}}</span></dd><dt><span data-translate="netWordAgroApp.matrizsensoriamento.valorlongitudep1">Valorlongitudep 1</span></dt><dd><span>{{vm.matrizsensoriamento.valorlongitudep1}}</span></dd><dt><span data-translate="netWordAgroApp.matrizsensoriamento.valorlatitudep2">Valorlatitudep 2</span></dt><dd><span>{{vm.matrizsensoriamento.valorlatitudep2}}</span></dd><dt><span data-translate="netWordAgroApp.matrizsensoriamento.valorlongitudep2">Valorlongitudep 2</span></dt><dd><span>{{vm.matrizsensoriamento.valorlongitudep2}}</span></dd><dt><span data-translate="netWordAgroApp.matrizsensoriamento.valorlatitudep3">Valorlatitudep 3</span></dt><dd><span>{{vm.matrizsensoriamento.valorlatitudep3}}</span></dd><dt><span data-translate="netWordAgroApp.matrizsensoriamento.valorlongitudep3">Valorlongitudep 3</span></dt><dd><span>{{vm.matrizsensoriamento.valorlongitudep3}}</span></dd><dt><span data-translate="netWordAgroApp.matrizsensoriamento.valorlatitudep4">Valorlatitudep 4</span></dt><dd><span>{{vm.matrizsensoriamento.valorlatitudep4}}</span></dd><dt><span data-translate="netWordAgroApp.matrizsensoriamento.valorlongitudep4">Valorlongitudep 4</span></dt><dd><span>{{vm.matrizsensoriamento.valorlongitudep4}}</span></dd><dt><span data-translate="netWordAgroApp.matrizsensoriamento.pesquisa">Pesquisa</span></dt><dd><a ui-sref="pesquisa-detail({id:vm.matrizsensoriamento.pesquisa.id})">{{vm.matrizsensoriamento.pesquisa.nomepesquisa}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="matrizsensoriamento-detail.edit({id:vm.matrizsensoriamento.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/matrizsensoriamento/matrizsensoriamento-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMatrizsensoriamentoLabel" data-translate="netWordAgroApp.matrizsensoriamento.home.createOrEditLabel">Create or edit a Matrizsensoriamento</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.matrizsensoriamento.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.matrizsensoriamento.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.matrizsensoriamento.nomematriz" for="field_nomematriz">Nomematriz</label><input type="text" class="form-control" name="nomematriz" id="field_nomematriz" ng-model="vm.matrizsensoriamento.nomematriz" required ng-maxlength="50"><div ng-show="editForm.nomematriz.$invalid"><p class="help-block" ng-show="editForm.nomematriz.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nomematriz.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setImagemmatriz($file, vm.matrizsensoriamento)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="netWordAgroApp.matrizsensoriamento.imagemmatriz" for="field_imagemmatriz">Imagemmatriz</label><div><img data-ng-src="{{\'data:\' + vm.matrizsensoriamento.imagemmatrizContentType + \';base64,\' + vm.matrizsensoriamento.imagemmatriz}}" style="max-height: 100px" ng-if="vm.matrizsensoriamento.imagemmatriz" alt="matrizsensoriamento image"><div ng-if="vm.matrizsensoriamento.imagemmatriz" class="help-block clearfix"><span class="pull-left">{{vm.matrizsensoriamento.imagemmatrizContentType}}, {{vm.byteSize(vm.matrizsensoriamento.imagemmatriz)}}</span> <button type="button" ng-click="vm.matrizsensoriamento.imagemmatriz=null;vm.matrizsensoriamento.imagemmatrizContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setImagemmatriz($file, vm.matrizsensoriamento)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="imagemmatriz" id="field_imagemmatriz" ng-model="vm.matrizsensoriamento.imagemmatriz" required> <input type="hidden" class="form-control" name="imagemmatrizContentType" id="field_imagemmatrizContentType" ng-model="vm.matrizsensoriamento.imagemmatrizContentType"><div ng-show="editForm.imagemmatriz.$invalid"><p class="help-block" ng-show="editForm.imagemmatriz.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.matrizsensoriamento.valorlatitudep1" for="field_valorlatitudep1">Valorlatitudep 1</label><input type="text" class="form-control" name="valorlatitudep1" id="field_valorlatitudep1" ng-model="vm.matrizsensoriamento.valorlatitudep1" required><div ng-show="editForm.valorlatitudep1.$invalid"><p class="help-block" ng-show="editForm.valorlatitudep1.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.matrizsensoriamento.valorlongitudep1" for="field_valorlongitudep1">Valorlongitudep 1</label><input type="text" class="form-control" name="valorlongitudep1" id="field_valorlongitudep1" ng-model="vm.matrizsensoriamento.valorlongitudep1" required><div ng-show="editForm.valorlongitudep1.$invalid"><p class="help-block" ng-show="editForm.valorlongitudep1.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.matrizsensoriamento.valorlatitudep2" for="field_valorlatitudep2">Valorlatitudep 2</label><input type="text" class="form-control" name="valorlatitudep2" id="field_valorlatitudep2" ng-model="vm.matrizsensoriamento.valorlatitudep2" required><div ng-show="editForm.valorlatitudep2.$invalid"><p class="help-block" ng-show="editForm.valorlatitudep2.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.matrizsensoriamento.valorlongitudep2" for="field_valorlongitudep2">Valorlongitudep 2</label><input type="text" class="form-control" name="valorlongitudep2" id="field_valorlongitudep2" ng-model="vm.matrizsensoriamento.valorlongitudep2" required><div ng-show="editForm.valorlongitudep2.$invalid"><p class="help-block" ng-show="editForm.valorlongitudep2.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.matrizsensoriamento.valorlatitudep3" for="field_valorlatitudep3">Valorlatitudep 3</label><input type="text" class="form-control" name="valorlatitudep3" id="field_valorlatitudep3" ng-model="vm.matrizsensoriamento.valorlatitudep3" required><div ng-show="editForm.valorlatitudep3.$invalid"><p class="help-block" ng-show="editForm.valorlatitudep3.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.matrizsensoriamento.valorlongitudep3" for="field_valorlongitudep3">Valorlongitudep 3</label><input type="text" class="form-control" name="valorlongitudep3" id="field_valorlongitudep3" ng-model="vm.matrizsensoriamento.valorlongitudep3" required><div ng-show="editForm.valorlongitudep3.$invalid"><p class="help-block" ng-show="editForm.valorlongitudep3.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.matrizsensoriamento.valorlatitudep4" for="field_valorlatitudep4">Valorlatitudep 4</label><input type="text" class="form-control" name="valorlatitudep4" id="field_valorlatitudep4" ng-model="vm.matrizsensoriamento.valorlatitudep4" required><div ng-show="editForm.valorlatitudep4.$invalid"><p class="help-block" ng-show="editForm.valorlatitudep4.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.matrizsensoriamento.valorlongitudep4" for="field_valorlongitudep4">Valorlongitudep 4</label><input type="text" class="form-control" name="valorlongitudep4" id="field_valorlongitudep4" ng-model="vm.matrizsensoriamento.valorlongitudep4" required><div ng-show="editForm.valorlongitudep4.$invalid"><p class="help-block" ng-show="editForm.valorlongitudep4.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.matrizsensoriamento.pesquisa" for="field_pesquisa">Pesquisa</label><select class="form-control" id="field_pesquisa" name="pesquisa" ng-model="vm.matrizsensoriamento.pesquisa" ng-options="pesquisa as pesquisa.nomepesquisa for pesquisa in vm.pesquisas track by pesquisa.id" required></select></div><div ng-show="editForm.pesquisa.$invalid"><p class="help-block" ng-show="editForm.pesquisa.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/matrizsensoriamento/matrizsensoriamentos.html','<div><h2 data-translate="netWordAgroApp.matrizsensoriamento.home.title">Matrizsensoriamentos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="matrizsensoriamento.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.matrizsensoriamento.home.createLabel">Create new Matrizsensoriamento</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.matrizsensoriamento.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomematriz"><span data-translate="netWordAgroApp.matrizsensoriamento.nomematriz">Nomematriz</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="imagemmatriz"><span data-translate="netWordAgroApp.matrizsensoriamento.imagemmatriz">Imagemmatriz</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorlatitudep1"><span data-translate="netWordAgroApp.matrizsensoriamento.valorlatitudep1">Valorlatitudep 1</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorlongitudep1"><span data-translate="netWordAgroApp.matrizsensoriamento.valorlongitudep1">Valorlongitudep 1</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorlatitudep2"><span data-translate="netWordAgroApp.matrizsensoriamento.valorlatitudep2">Valorlatitudep 2</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorlongitudep2"><span data-translate="netWordAgroApp.matrizsensoriamento.valorlongitudep2">Valorlongitudep 2</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorlatitudep3"><span data-translate="netWordAgroApp.matrizsensoriamento.valorlatitudep3">Valorlatitudep 3</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorlongitudep3"><span data-translate="netWordAgroApp.matrizsensoriamento.valorlongitudep3">Valorlongitudep 3</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorlatitudep4"><span data-translate="netWordAgroApp.matrizsensoriamento.valorlatitudep4">Valorlatitudep 4</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorlongitudep4"><span data-translate="netWordAgroApp.matrizsensoriamento.valorlongitudep4">Valorlongitudep 4</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pesquisa.nomepesquisa"><span data-translate="netWordAgroApp.matrizsensoriamento.pesquisa">Pesquisa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="matrizsensoriamento in vm.matrizsensoriamentos track by matrizsensoriamento.id"><td><a ui-sref="matrizsensoriamento-detail({id:matrizsensoriamento.id})">{{matrizsensoriamento.id}}</a></td><td>{{matrizsensoriamento.nomematriz}}</td><td><a ng-if="matrizsensoriamento.imagemmatriz" ng-click="vm.openFile(matrizsensoriamento.imagemmatrizContentType, matrizsensoriamento.imagemmatriz)"><img data-ng-src="{{\'data:\' + matrizsensoriamento.imagemmatrizContentType + \';base64,\' + matrizsensoriamento.imagemmatriz}}" style="max-height: 30px" alt="matrizsensoriamento image"> </a><span ng-if="matrizsensoriamento.imagemmatriz">{{matrizsensoriamento.imagemmatrizContentType}}, {{vm.byteSize(matrizsensoriamento.imagemmatriz)}}</span></td><td>{{matrizsensoriamento.valorlatitudep1}}</td><td>{{matrizsensoriamento.valorlongitudep1}}</td><td>{{matrizsensoriamento.valorlatitudep2}}</td><td>{{matrizsensoriamento.valorlongitudep2}}</td><td>{{matrizsensoriamento.valorlatitudep3}}</td><td>{{matrizsensoriamento.valorlongitudep3}}</td><td>{{matrizsensoriamento.valorlatitudep4}}</td><td>{{matrizsensoriamento.valorlongitudep4}}</td><td><a ui-sref="pesquisa-detail({id:matrizsensoriamento.pesquisa.id})">{{matrizsensoriamento.pesquisa.nomepesquisa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="matrizsensoriamento-detail({id:matrizsensoriamento.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="matrizsensoriamento.edit({id:matrizsensoriamento.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="matrizsensoriamento.delete({id:matrizsensoriamento.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/microregiao/microregiao-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.microregiao.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.microregiao.delete.question" translate-values="{id: \'{{vm.microregiao.id}}\'}">Are you sure you want to delete this Microregiao?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/microregiao/microregiao-detail.html','<div><h2><span data-translate="netWordAgroApp.microregiao.detail.title">Microregiao</span> {{vm.microregiao.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.microregiao.nomemicroregiao">Nomemicroregiao</span></dt><dd><span>{{vm.microregiao.nomemicroregiao}}</span></dd><dt><span data-translate="netWordAgroApp.microregiao.imagemmicroregiao">Imagemmicroregiao</span></dt><dd><div ng-if="vm.microregiao.imagemmicroregiao"><a ng-click="vm.openFile(vm.microregiao.imagemmicroregiaoContentType, vm.microregiao.imagemmicroregiao)"><img data-ng-src="{{\'data:\' + vm.microregiao.imagemmicroregiaoContentType + \';base64,\' + vm.microregiao.imagemmicroregiao}}" style="max-width: 100%" alt="microregiao image"> </a>{{vm.microregiao.imagemmicroregiaoContentType}}, {{vm.byteSize(vm.microregiao.imagemmicroregiao)}}</div></dd><dt><span data-translate="netWordAgroApp.microregiao.estado">Estado</span></dt><dd><a ui-sref="estado-detail({id:vm.microregiao.estado.id})">{{vm.microregiao.estado.nomeestado}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="microregiao-detail.edit({id:vm.microregiao.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/microregiao/microregiao-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMicroregiaoLabel" data-translate="netWordAgroApp.microregiao.home.createOrEditLabel">Create or edit a Microregiao</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.microregiao.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.microregiao.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.microregiao.nomemicroregiao" for="field_nomemicroregiao">Nomemicroregiao</label><input type="text" class="form-control" name="nomemicroregiao" id="field_nomemicroregiao" ng-model="vm.microregiao.nomemicroregiao" required ng-maxlength="30"><div ng-show="editForm.nomemicroregiao.$invalid"><p class="help-block" ng-show="editForm.nomemicroregiao.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nomemicroregiao.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">This field cannot be longer than 30 characters.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setImagemmicroregiao($file, vm.microregiao)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="netWordAgroApp.microregiao.imagemmicroregiao" for="field_imagemmicroregiao">Imagemmicroregiao</label><div><img data-ng-src="{{\'data:\' + vm.microregiao.imagemmicroregiaoContentType + \';base64,\' + vm.microregiao.imagemmicroregiao}}" style="max-height: 100px" ng-if="vm.microregiao.imagemmicroregiao" alt="microregiao image"><div ng-if="vm.microregiao.imagemmicroregiao" class="help-block clearfix"><span class="pull-left">{{vm.microregiao.imagemmicroregiaoContentType}}, {{vm.byteSize(vm.microregiao.imagemmicroregiao)}}</span> <button type="button" ng-click="vm.microregiao.imagemmicroregiao=null;vm.microregiao.imagemmicroregiaoContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setImagemmicroregiao($file, vm.microregiao)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="imagemmicroregiao" id="field_imagemmicroregiao" ng-model="vm.microregiao.imagemmicroregiao"> <input type="hidden" class="form-control" name="imagemmicroregiaoContentType" id="field_imagemmicroregiaoContentType" ng-model="vm.microregiao.imagemmicroregiaoContentType"></div><div class="form-group"><label data-translate="netWordAgroApp.microregiao.estado" for="field_estado">Estado</label><select class="form-control" id="field_estado" name="estado" ng-model="vm.microregiao.estado" ng-options="estado as estado.nomeestado for estado in vm.estados track by estado.id" required></select></div><div ng-show="editForm.estado.$invalid"><p class="help-block" ng-show="editForm.estado.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/microregiao/microregiaos.html','<div><h2 data-translate="netWordAgroApp.microregiao.home.title">Microregiaos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="microregiao.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.microregiao.home.createLabel">Create new Microregiao</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.microregiao.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomemicroregiao"><span data-translate="netWordAgroApp.microregiao.nomemicroregiao">Nomemicroregiao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="imagemmicroregiao"><span data-translate="netWordAgroApp.microregiao.imagemmicroregiao">Imagemmicroregiao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="estado.nomeestado"><span data-translate="netWordAgroApp.microregiao.estado">Estado</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="microregiao in vm.microregiaos track by microregiao.id"><td><a ui-sref="microregiao-detail({id:microregiao.id})">{{microregiao.id}}</a></td><td>{{microregiao.nomemicroregiao}}</td><td><a ng-if="microregiao.imagemmicroregiao" ng-click="vm.openFile(microregiao.imagemmicroregiaoContentType, microregiao.imagemmicroregiao)"><img data-ng-src="{{\'data:\' + microregiao.imagemmicroregiaoContentType + \';base64,\' + microregiao.imagemmicroregiao}}" style="max-height: 30px" alt="microregiao image"> </a><span ng-if="microregiao.imagemmicroregiao">{{microregiao.imagemmicroregiaoContentType}}, {{vm.byteSize(microregiao.imagemmicroregiao)}}</span></td><td><a ui-sref="estado-detail({id:microregiao.estado.id})">{{microregiao.estado.nomeestado}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="microregiao-detail({id:microregiao.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="microregiao.edit({id:microregiao.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="microregiao.delete({id:microregiao.id})" class="btn btn-danger btn-sm" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/monitoramentoportatil/monitoramentoportatil-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.monitoramentoportatil.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.monitoramentoportatil.delete.question" translate-values="{id: \'{{vm.monitoramentoportatil.id}}\'}">Are you sure you want to delete this Monitoramentoportatil?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/monitoramentoportatil/monitoramentoportatil-detail.html','<div><h2><span data-translate="netWordAgroApp.monitoramentoportatil.detail.title">Monitoramentoportatil</span> {{vm.monitoramentoportatil.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.monitoramentoportatil.data">Data</span></dt><dd><span>{{vm.monitoramentoportatil.data | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.monitoramentoportatil.latitude">Latitude</span></dt><dd><span>{{vm.monitoramentoportatil.latitude}}</span></dd><dt><span data-translate="netWordAgroApp.monitoramentoportatil.longitude">Longitude</span></dt><dd><span>{{vm.monitoramentoportatil.longitude}}</span></dd><dt><span data-translate="netWordAgroApp.monitoramentoportatil.tipomonitoramento">Tipomonitoramento</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipomonitoramento.\' + vm.monitoramentoportatil.tipomonitoramento}}">{{vm.monitoramentoportatil.tipomonitoramento}}</span></dd><dt><span data-translate="netWordAgroApp.monitoramentoportatil.tipopraga">Tipopraga</span></dt><dd><span>{{vm.monitoramentoportatil.tipopraga}}</span></dd><dt><span data-translate="netWordAgroApp.monitoramentoportatil.propriedade">Propriedade</span></dt><dd><a ui-sref="propriedade-detail({id:vm.monitoramentoportatil.propriedade.id})">{{vm.monitoramentoportatil.propriedade.nomepropriedade}}</a></dd><dt><span data-translate="netWordAgroApp.monitoramentoportatil.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.monitoramentoportatil.safra.id})">{{vm.monitoramentoportatil.safra.nomesafra}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="monitoramentoportatil-detail.edit({id:vm.monitoramentoportatil.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/monitoramentoportatil/monitoramentoportatil-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMonitoramentoportatilLabel" data-translate="netWordAgroApp.monitoramentoportatil.home.createOrEditLabel">Create or edit a Monitoramentoportatil</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.monitoramentoportatil.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.monitoramentoportatil.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.monitoramentoportatil.data" for="field_data">Data</label><div class="input-group"><input id="field_data" type="text" class="form-control" name="data" uib-datepicker-popup="{{dateformat}}" ng-model="vm.monitoramentoportatil.data" is-open="vm.datePickerOpenStatus.data" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'data\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.data.$invalid"><p class="help-block" ng-show="editForm.data.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.monitoramentoportatil.latitude" for="field_latitude">Latitude</label><input type="text" class="form-control" name="latitude" id="field_latitude" ng-model="vm.monitoramentoportatil.latitude" required><div ng-show="editForm.latitude.$invalid"><p class="help-block" ng-show="editForm.latitude.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.monitoramentoportatil.longitude" for="field_longitude">Longitude</label><input type="text" class="form-control" name="longitude" id="field_longitude" ng-model="vm.monitoramentoportatil.longitude" required><div ng-show="editForm.longitude.$invalid"><p class="help-block" ng-show="editForm.longitude.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.monitoramentoportatil.tipomonitoramento" for="field_tipomonitoramento">Tipomonitoramento</label><select class="form-control" name="tipomonitoramento" ng-model="vm.monitoramentoportatil.tipomonitoramento" id="field_tipomonitoramento" required><option value="condutividade" data-translate="netWordAgroApp.Tipomonitoramento.condutividade">condutividade</option><option value="praga" data-translate="netWordAgroApp.Tipomonitoramento.praga">praga</option><option value="ervadaninha" data-translate="netWordAgroApp.Tipomonitoramento.ervadaninha">ervadaninha</option></select><div ng-show="editForm.tipomonitoramento.$invalid"><p class="help-block" ng-show="editForm.tipomonitoramento.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.monitoramentoportatil.tipopraga" for="field_tipopraga">Tipopraga</label><input type="text" class="form-control" name="tipopraga" id="field_tipopraga" ng-model="vm.monitoramentoportatil.tipopraga"></div><div class="form-group"><label data-translate="netWordAgroApp.monitoramentoportatil.propriedade" for="field_propriedade">Propriedade</label><select class="form-control" id="field_propriedade" name="propriedade" ng-model="vm.monitoramentoportatil.propriedade" ng-options="propriedade as propriedade.nomepropriedade for propriedade in vm.propriedades track by propriedade.id" required></select></div><div ng-show="editForm.propriedade.$invalid"><p class="help-block" ng-show="editForm.propriedade.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.monitoramentoportatil.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.monitoramentoportatil.safra" ng-options="safra as safra.nomesafra for safra in vm.safras track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/monitoramentoportatil/monitoramentoportatils.html','<div><h2 data-translate="netWordAgroApp.monitoramentoportatil.home.title">Monitoramentoportatils</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="monitoramentoportatil.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.monitoramentoportatil.home.createLabel">Create new Monitoramentoportatil</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.monitoramentoportatil.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="data"><span data-translate="netWordAgroApp.monitoramentoportatil.data">Data</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="latitude"><span data-translate="netWordAgroApp.monitoramentoportatil.latitude">Latitude</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="longitude"><span data-translate="netWordAgroApp.monitoramentoportatil.longitude">Longitude</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipomonitoramento"><span data-translate="netWordAgroApp.monitoramentoportatil.tipomonitoramento">Tipomonitoramento</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipopraga"><span data-translate="netWordAgroApp.monitoramentoportatil.tipopraga">Tipopraga</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="propriedade.nomepropriedade"><span data-translate="netWordAgroApp.monitoramentoportatil.propriedade">Propriedade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="safra.nomesafra"><span data-translate="netWordAgroApp.monitoramentoportatil.safra">Safra</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="monitoramentoportatil in vm.monitoramentoportatils track by monitoramentoportatil.id"><td><a ui-sref="monitoramentoportatil-detail({id:monitoramentoportatil.id})">{{monitoramentoportatil.id}}</a></td><td>{{monitoramentoportatil.data | date:\'mediumDate\'}}</td><td>{{monitoramentoportatil.latitude}}</td><td>{{monitoramentoportatil.longitude}}</td><td data-translate="{{\'netWordAgroApp.Tipomonitoramento.\' + monitoramentoportatil.tipomonitoramento}}">{{monitoramentoportatil.tipomonitoramento}}</td><td>{{monitoramentoportatil.tipopraga}}</td><td><a ui-sref="propriedade-detail({id:monitoramentoportatil.propriedade.id})">{{monitoramentoportatil.propriedade.nomepropriedade}}</a></td><td><a ui-sref="safra-detail({id:monitoramentoportatil.safra.id})">{{monitoramentoportatil.safra.nomesafra}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="monitoramentoportatil-detail({id:monitoramentoportatil.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="monitoramentoportatil.edit({id:monitoramentoportatil.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="monitoramentoportatil.delete({id:monitoramentoportatil.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/painel/comparativo.html','<script type="text/javascript" src="/app/entities/painel/auxiliar.js"></script><script src="app/entities/painel/gauge.min.js"></script><script type="text/javascript" src="/app/entities/painel/comparativo.js"></script><div class="well"><p id="selecao3">Selecione a safra:</p><select id="selecsafra3" name="safras"></select><button id="btnrelatorio3" onclick="linguagemcomp()">Mostrar relat\xF3rio</button></div><div class="container"><div class="row"><h3 id="titulodespcomp"></h3><div class="col-xs-10" id="divgrafdespcomp"><canvas id="grafdespcomp"></canvas></div></div><div class="row"><h3 id="tituloreccomp"></h3><div class="col-xs-10" id="divgrafreccomp"><canvas id="grafreccomp"></canvas></div></div><div class="row"><h3 id="titulodespcompetapa"></h3><div class="col-xs-10" id="divgrafdespetapacomp"><canvas id="grafdespetapacomp"></canvas></div></div><div class="row"><h3 id="tituloreccompetapa"></h3><div class="col-xs-10" id="divgrafrecetapacomp"><canvas id="grafrecetapacomp"></canvas></div></div></div>');
$templateCache.put('app/entities/painel/execucao.html','<script type="text/javascript" src="/app/entities/painel/auxiliar.js"></script><script src="app/entities/painel/gauge.min.js"></script><script type="text/javascript" src="/app/entities/painel/execucao.js"></script><div class="well"><p id="selecao2">Selecione a safra:</p><select id="selecsafra2" name="safras"></select><button id="btnrelatorio2" onclick="linguagemexec()">Mostrar relat\xF3rio</button></div><div class="container"><div class="row"><h3 id="titulodespexec"></h3><div class="col-xs-10" id="divgrafdesp"><canvas id="grafdesp"></canvas></div></div><div class="row"><h3 id="titulorecexec"></h3><div class="col-xs-10" id="divgrafrec"><canvas id="grafrec"></canvas></div></div><div class="row"><h3 id="titulodespexecetapa"></h3><div class="col-xs-10" id="divgrafdespetapa"><canvas id="grafdespetapa"></canvas></div></div><div class="row"><h3 id="titulorecexecetapa"></h3><div class="col-xs-10" id="divgrafrecetapa"><canvas id="grafrecetapa"></canvas></div></div><div class="row"><h3 id="titulodistribexec"></h3><div class="col-xs-10" id="divdistribterc"><canvas id="grafdistribterc"></canvas></div></div></div>');
$templateCache.put('app/entities/painel/indicadores.html','<script type="text/javascript" src="/app/entities/painel/auxiliar.js"></script><script src="app/entities/painel/gauge.min.js"></script><script type="text/javascript" src="/app/entities/painel/indicadores.js"></script><div class="well"><p id="selecao4">Selecione a safra:</p><select id="selecsafra4" name="safras"></select><button id="btnrelatorio4" onclick="linguagemind()"><span data-translate="netWordAgroApp.painel.home.title">Mostrar relat\xF3rio</span></button></div><div class="container"><div class="row"><div class="col-xs-5" id="divprodplan"><h3 id="tituloplanprod"></h3><canvas style="width:100%" id="grafprodplan"></canvas><h4 class="well well-sm" id="prodplanvalor"></h4></div><div class="col-xs-5" id="divprodexec"><h3 id="tituloexecprod"></h3><canvas style="width:100%" id="grafprodexec"></canvas><h4 class="well well-sm" id="prodexecvalor"></h4></div></div><div class="row"><div class="col-xs-5" id="divrentplan"><h3 id="tituloplanrent"></h3><canvas style="width:100%" id="grafrentplan"></canvas><h4 class="well well-sm" id="rentplanvalor"></h4></div><div class="col-xs-5" id="divrentexec"><h3 id="tituloexecrent"></h3><canvas style="width:100%" id="grafrentexec"></canvas><h4 class="well well-sm" id="rentexecvalor"></h4></div></div><div></div></div>');
$templateCache.put('app/entities/painel/painel-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.painel.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.painel.delete.question" translate-values="{id: \'{{vm.painel.id}}\'}">Are you sure you want to delete this Painel?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/painel/painel-detail.html','<div><h2><span data-translate="netWordAgroApp.painel.detail.title">Painel</span> {{vm.painel.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="painel-detail.edit({id:vm.painel.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/painel/painel-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPainelLabel" data-translate="netWordAgroApp.painel.home.createOrEditLabel">Create or edit a Painel</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.painel.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.painel.id" readonly="readonly"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/painel/painels-en.html','<script type="text/javascript" src="/app/entities/painel/auxiliar.js"></script><script src="app/entities/painel/gauge.min.js"></script><script type="text/javascript" src="/app/entities/painel/indicadores.js"></script><script type="text/javascript" src="/app/entities/painel/comparativo.js"></script><script type="text/javascript" src="/app/entities/painel/execucao.js"></script><script type="text/javascript" src="/app/entities/painel/planejado.js"></script><style>/* Style the tab */\n.tab {\n    overflow: hidden;\n    border: 1px solid #ccc;\n    background-color: #f1f1f1;\n}\n\n/* Style the buttons that are used to open the tab content */\n.tab button {\n    background-color: inherit;\n    float: left;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    padding: 14px 16px;\n    transition: 0.3s;\n}\n\n/* Change background color of buttons on hover */\n.tab button:hover {\n    background-color: #cce6ff;\n}\n\n/* Create an active/current tablink class */\n.tab button.active {\n    background-color: #b3daff;\n}\n\n/* Style the tab content */\n.tabcontent {\n    display: none;\n    padding: 6px 12px;\n    border: 1px solid #e6f3ff;\n    border-top: none;\n}</style><script>function conteudo(){\n    //$(\'#Planejado\').load("app/entities/painel/planejado.html"); \n    //$(\'#Execucao\').load("app/entities/painel/execucao.html"); \n    //$(\'#Comparativo\').load("app/entities/painel/comparativo.html"); \n    //$(\'#Indicadores\').load("app/entities/painel/indicadores.html"); \n\n  }\n\n  function openTab(evt, tabName) {\n      var i, tabcontent, tablinks;\n      tabcontent = document.getElementsByClassName("tabcontent");\n      for (i = 0; i < tabcontent.length; i++) {\n          tabcontent[i].style.display = "none";\n      }\n      tablinks = document.getElementsByClassName("tablinks");\n      for (i = 0; i < tablinks.length; i++) {\n          tablinks[i].className = tablinks[i].className.replace(" active", "");\n      }\n      document.getElementById(tabName).style.display = "block";\n      evt.currentTarget.className += " active";\n  }\n\n  conteudo();\n\n\n  // Get the element with id="defaultOpen" and click on it\n  document.getElementById("defaultOpen").click();</script><h2 data-translate="netWordAgroApp.painel.home.title">Painel de Controle</h2><div class="tab"><button class="tablinks" onclick="openTab(event, \'Planejado\');" id="defaultOpen" data-translate="netWordAgroApp.painel.planejado">Planejado</button> <button class="tablinks" onclick="openTab(event, \'Execucao\');" data-translate="netWordAgroApp.painel.execucao">Execu\xE7\xE3o</button> <button class="tablinks" onclick="openTab(event, \'Comparativo\');" data-translate="netWordAgroApp.painel.comparativo">Comparativo</button> <button class="tablinks" onclick="openTab(event, \'Indicadores\');" data-translate="netWordAgroApp.painel.indicadores">Indicadores</button></div><div id="Planejado" class="tabcontent"></div><div id="Execucao" class="tabcontent"></div><div id="Comparativo" class="tabcontent"></div><div id="Indicadores" class="tabcontent"></div>');
$templateCache.put('app/entities/painel/painels-es.html','<script type="text/javascript" src="/app/entities/painel/auxiliar.js"></script><script src="app/entities/painel/gauge.min.js"></script><script type="text/javascript" src="/app/entities/painel/indicadores.js"></script><script type="text/javascript" src="/app/entities/painel/comparativo.js"></script><script type="text/javascript" src="/app/entities/painel/execucao.js"></script><script type="text/javascript" src="/app/entities/painel/planejado.js"></script><style>/* Style the tab */\n.tab {\n    overflow: hidden;\n    border: 1px solid #ccc;\n    background-color: #f1f1f1;\n}\n\n/* Style the buttons that are used to open the tab content */\n.tab button {\n    background-color: inherit;\n    float: left;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    padding: 14px 16px;\n    transition: 0.3s;\n}\n\n/* Change background color of buttons on hover */\n.tab button:hover {\n    background-color: #cce6ff;\n}\n\n/* Create an active/current tablink class */\n.tab button.active {\n    background-color: #b3daff;\n}\n\n/* Style the tab content */\n.tabcontent {\n    display: none;\n    padding: 6px 12px;\n    border: 1px solid #e6f3ff;\n    border-top: none;\n}</style><script>function conteudo(){\n    //$(\'#Planejado\').load("app/entities/painel/planejado.html"); \n    //$(\'#Execucao\').load("app/entities/painel/execucao.html"); \n    //$(\'#Comparativo\').load("app/entities/painel/comparativo.html"); \n    //$(\'#Indicadores\').load("app/entities/painel/indicadores.html"); \n\n  }\n\n  function openTab(evt, tabName) {\n      var i, tabcontent, tablinks;\n      tabcontent = document.getElementsByClassName("tabcontent");\n      for (i = 0; i < tabcontent.length; i++) {\n          tabcontent[i].style.display = "none";\n      }\n      tablinks = document.getElementsByClassName("tablinks");\n      for (i = 0; i < tablinks.length; i++) {\n          tablinks[i].className = tablinks[i].className.replace(" active", "");\n      }\n      document.getElementById(tabName).style.display = "block";\n      evt.currentTarget.className += " active";\n  }\n\n  conteudo();\n\n\n  // Get the element with id="defaultOpen" and click on it\n  document.getElementById("defaultOpen").click();</script><h2 data-translate="netWordAgroApp.painel.home.title">Painel de Controle</h2><div class="tab"><button class="tablinks" onclick="openTab(event, \'Planejado\');" id="defaultOpen" data-translate="netWordAgroApp.painel.planejado">Planejado</button> <button class="tablinks" onclick="openTab(event, \'Execucao\');" data-translate="netWordAgroApp.painel.execucao">Execu\xE7\xE3o</button> <button class="tablinks" onclick="openTab(event, \'Comparativo\');" data-translate="netWordAgroApp.painel.comparativo">Comparativo</button> <button class="tablinks" onclick="openTab(event, \'Indicadores\');" data-translate="netWordAgroApp.painel.indicadores">Indicadores</button></div><div id="Planejado" class="tabcontent"></div><div id="Execucao" class="tabcontent"></div><div id="Comparativo" class="tabcontent"></div><div id="Indicadores" class="tabcontent"></div>');
$templateCache.put('app/entities/painel/painels.html','<style>/* Style the tab */\n.tab {\n    overflow: hidden;\n    border: 1px solid #ccc;\n    background-color: #f1f1f1;\n}\n\n/* Style the buttons that are used to open the tab content */\n.tab button {\n    background-color: inherit;\n    float: left;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    padding: 14px 16px;\n    transition: 0.3s;\n}\n\n/* Change background color of buttons on hover */\n.tab button:hover {\n    background-color: #cce6ff;\n}\n\n/* Create an active/current tablink class */\n.tab button.active {\n    background-color: #b3daff;\n}\n\n/* Style the tab content */\n.tabcontent {\n    display: none;\n    padding: 6px 12px;\n    border: 1px solid #e6f3ff;\n    border-top: none;\n}</style><script>function conteudo(){\n    $(\'#Planejado\').load("planejado.html"); \n    $(\'#Execucao\').load("execucao.html"); \n    $(\'#Comparativo\').load("comparativo.html"); \n    $(\'#Indicadores\').load("indicadores.html"); \n  }\n\n  function openTab(evt, tabName) {\n      var i, tabcontent, tablinks;\n      tabcontent = document.getElementsByClassName("tabcontent");\n      for (i = 0; i < tabcontent.length; i++) {\n          tabcontent[i].style.display = "none";\n      }\n      tablinks = document.getElementsByClassName("tablinks");\n      for (i = 0; i < tablinks.length; i++) {\n          tablinks[i].className = tablinks[i].className.replace(" active", "");\n      }\n      document.getElementById(tabName).style.display = "block";\n      evt.currentTarget.className += " active";\n  }\n\n  conteudo();\n\n\n  // Get the element with id="defaultOpen" and click on it\n  document.getElementById("defaultOpen").click();</script><h2 data-translate="netWordAgroApp.painel.home.title">Painel de Controle</h2><div class="tab"><button class="tablinks" onclick="openTab(event, \'Planejado\');" id="defaultOpen" data-translate="netWordAgroApp.painel.planejado">Planejado</button> <button class="tablinks" onclick="openTab(event, \'Execucao\');" data-translate="netWordAgroApp.painel.execucao">Execu\xE7\xE3o</button> <button class="tablinks" onclick="openTab(event, \'Comparativo\');" data-translate="netWordAgroApp.painel.comparativo">Comparativo</button> <button class="tablinks" onclick="openTab(event, \'Indicadores\');" data-translate="netWordAgroApp.painel.indicadores">Indicadores</button></div><div id="Planejado" class="tabcontent"></div><div id="Execucao" class="tabcontent"></div><div id="Comparativo" class="tabcontent"></div><div id="Indicadores" class="tabcontent"></div>');
$templateCache.put('app/entities/painel/planejado.html','<script type="text/javascript" src="/app/entities/painel/auxiliar.js"></script><script src="app/entities/painel/gauge.min.js"></script><script type="text/javascript" src="/app/entities/painel/planejado.js"></script><script>function linguagemTopo(){\r\n        $.getJSON("/api/account/", function(json){ \r\n        var linguagem = json.langKey;\r\n\r\n        if(linguagem==="pt-br"){\r\n            $("#selecao").html(\'Selecione a safra: \');\r\n            $("#btnrelatorio").html("Gerar Relat\xF3rio");\r\n            $("#selecao2").html(\'Selecione a safra: \');\r\n            $("#btnrelatorio2").html("Gerar Relat\xF3rio");\r\n            $("#selecao3").html(\'Selecione a safra: \');\r\n            $("#btnrelatorio3").html("Gerar Relat\xF3rio");\r\n            $("#selecao4").html(\'Selecione a safra: \');\r\n            $("#btnrelatorio4").html("Gerar Relat\xF3rio");\r\n        }\r\n        else if(linguagem==="en"){\r\n            $("#selecao").html(\'Select the harvest: \');\r\n            $("#btnrelatorio").html("Generate report");\r\n            $("#selecao2").html(\'Select the harvest: \');\r\n            $("#btnrelatorio2").html("Generate report");\r\n            $("#selecao3").html(\'Select the harvest: \');\r\n            $("#btnrelatorio3").html("Generate report");\r\n            $("#selecao4").html(\'Select the harvest: \');\r\n            $("#btnrelatorio4").html("Generate report");\r\n        }\r\n        else{\r\n            $("#selecao").html(\'Seleccione la cosecha: \');\r\n            $("#btnrelatorio").html("Generar Informe"); \r\n            $("#selecao2").html(\'Seleccione la cosecha: \');\r\n            $("#btnrelatorio2").html("Generar Informe"); \r\n            $("#selecao3").html(\'Seleccione la cosecha: \');\r\n            $("#btnrelatorio3").html("Generar Informe"); \r\n            $("#selecao4").html(\'Seleccione la cosecha: \');\r\n            $("#btnrelatorio4").html("Generar Informe"); \r\n        }\r\n\r\n    });\r\n}\r\n    \r\n    linguagemTopo();</script><div class="well"><p id="selecao">Selecione a safra:</p><select id="selecsafra" name="safras"></select><button id="btnrelatorio" onclick="linguagemplan()">Mostrar relat\xF3rio</button></div><div class="container"><div class="row"><h3 id="titulodespplan"></h3><div class="col-xs-10" id="divgrafdespplan"><canvas id="grafdespplan"></canvas></div></div><div class="row"><h3 id="titulorecplan"></h3><div class="col-xs-10" id="divgrafrecpplan"><canvas id="grafrecplan"></canvas></div></div><div class="row"><h3 id="titulodespetapaplan"></h3><div class="col-xs-10" id="divgrafdespetapaplan"><canvas id="grafdespetapaplan"></canvas></div></div><div class="row"><h3 id="titulorecetapaplan"></h3><div class="col-xs-10" id="divgrafrecetapaplan"><canvas id="grafrecetapaplan"></canvas></div></div><div class="row"><h3 id="titulodistribplan"></h3><div class="col-xs-10" id="divdistribtercplan"><canvas id="grafdistribtercplan"></canvas></div></div></div>');
$templateCache.put('app/entities/pedido/pedido-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.pedido.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.pedido.delete.question" translate-values="{id: \'{{vm.pedido.id}}\'}">Are you sure you want to delete this Pedido?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/pedido/pedido-detail.html','<div><h2><span data-translate="netWordAgroApp.pedido.detail.title">Pedido</span> {{vm.pedido.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.pedido.idsmapas">Idsmapas</span></dt><dd><span>{{vm.pedido.idsmapas}}</span></dd><dt><span data-translate="netWordAgroApp.pedido.vazao">Vazao</span></dt><dd><span>{{vm.pedido.vazao}}</span></dd><dt><span data-translate="netWordAgroApp.pedido.status">Status</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipostatus.\' + vm.pedido.status}}">{{vm.pedido.status}}</span></dd><dt><span data-translate="netWordAgroApp.pedido.shapefile">Shapefile</span></dt><dd><div ng-if="vm.pedido.shapefile"><a ng-click="vm.openFile(vm.pedido.shapefileContentType, vm.pedido.shapefile)" data-translate="entity.action.open">open</a> {{vm.pedido.shapefileContentType}}, {{vm.byteSize(vm.pedido.shapefile)}}</div></dd><dt><span data-translate="netWordAgroApp.pedido.crea">Crea</span></dt><dd><span>{{vm.pedido.crea}}</span></dd><dt><span data-translate="netWordAgroApp.pedido.maquinario">Maquinario</span></dt><dd><a ui-sref="maquinario-detail({id:vm.pedido.maquinario.id})">{{vm.pedido.maquinario.modelo}}</a></dd><dt><span data-translate="netWordAgroApp.pedido.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.pedido.safra.id})">{{vm.pedido.safra.nomesafra}}</a></dd><dt><span data-translate="netWordAgroApp.pedido.propriedade">Propriedade</span></dt><dd><a ui-sref="propriedade-detail({id:vm.pedido.propriedade.id})">{{vm.pedido.propriedade.nomepropriedade}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="pedido-detail.edit({id:vm.pedido.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/pedido/pedido-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPedidoLabel" data-translate="netWordAgroApp.pedido.home.createOrEditLabel">Create or edit a Pedido</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.pedido.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.pedido.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pedido.idsmapas" for="field_idsmapas">Idsmapas</label><input type="text" class="form-control" name="idsmapas" id="field_idsmapas" ng-model="vm.pedido.idsmapas"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pedido.vazao" for="field_vazao">Vazao</label><input type="number" class="form-control" name="vazao" id="field_vazao" ng-model="vm.pedido.vazao"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pedido.status" for="field_status">Status</label><select class="form-control" name="status" ng-model="vm.pedido.status" id="field_status"><option value="aguardando" data-translate="netWordAgroApp.Tipostatus.aguardando">aguardando</option><option value="concluido" data-translate="netWordAgroApp.Tipostatus.concluido">concluido</option><option value="emandamento" data-translate="netWordAgroApp.Tipostatus.emandamento">emandamento</option><option value="cancelado" data-translate="netWordAgroApp.Tipostatus.cancelado">cancelado</option></select></div><div class="form-group" ngf-drop ngf-change="vm.setShapefile($file, vm.pedido)"><label class="control-label" data-translate="netWordAgroApp.pedido.shapefile" for="field_shapefile">Shapefile</label><div><div ng-if="vm.pedido.shapefile" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.pedido.shapefileContentType, vm.pedido.shapefile)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.pedido.shapefileContentType}}, {{vm.byteSize(vm.pedido.shapefile)}}</span> <button type="button" ng-click="vm.pedido.shapefile=null;vm.pedido.shapefileContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setShapefile($file, vm.pedido)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="shapefile" id="field_shapefile" ng-model="vm.pedido.shapefile"> <input type="hidden" class="form-control" name="shapefileContentType" id="field_shapefileContentType" ng-model="vm.pedido.shapefileContentType"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pedido.crea" for="field_crea">Crea</label><input type="text" class="form-control" name="crea" id="field_crea" ng-model="vm.pedido.crea"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pedido.tipos" for="field_tipos">Tipos</label><input type="text" class="form-control" name="tipos" id="field_tipos" ng-model="vm.pedido.tipos"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pedido.datas" for="field_datas">Datas</label><input type="text" class="form-control" name="datas" id="field_datas" ng-model="vm.pedido.datas"></div><div class="form-group" ngf-drop ngf-change="vm.setReceituario($file, vm.pedido)"><label class="control-label" data-translate="netWordAgroApp.pedido.receituario" for="field_receituario">Receituario</label><div><div ng-if="vm.pedido.receituario" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.pedido.receituarioContentType, vm.pedido.receituario)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.pedido.receituarioContentType}}, {{vm.byteSize(vm.pedido.receituario)}}</span> <button type="button" ng-click="vm.pedido.receituario=null;vm.pedido.receituarioContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setReceituario($file, vm.pedido)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="receituario" id="field_receituario" ng-model="vm.pedido.receituario"> <input type="hidden" class="form-control" name="receituarioContentType" id="field_receituarioContentType" ng-model="vm.pedido.receituarioContentType"></div><div class="form-group"><label data-translate="netWordAgroApp.pedido.maquinario" for="field_maquinario">Maquinario</label><select class="form-control" id="field_maquinario" name="maquinario" ng-model="vm.pedido.maquinario" ng-options="maquinario as maquinario.modelo for maquinario in vm.maquinarios track by maquinario.id"><option value=""></option></select></div><div class="form-group"><label data-translate="netWordAgroApp.pedido.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.pedido.safra" ng-options="safra as safra.nomesafra for safra in vm.safras track by safra.id"><option value=""></option></select></div><div class="form-group"><label data-translate="netWordAgroApp.pedido.propriedade" for="field_propriedade">Propriedade</label><select class="form-control" id="field_propriedade" name="propriedade" ng-model="vm.pedido.propriedade" ng-options="propriedade as propriedade.nomepropriedade for propriedade in vm.propriedades track by propriedade.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/pedido/pedido-fazer.html','<style type="text/css">#map{\n        height: 500px;\n        width: 100%;\n    }\n    \n    .label-filtros{\n        color: #555555;\n        font-weight: bold;\n    }\n    \n    #galeria {\n      overflow-x: scroll;\n      overflow-y: hidden;\n      white-space: nowrap;\n      height: auto;\n      padding: 10px;\n      /*border: 2px outset #555555;*/\n    }\n    .elemento-galeria{\n        display: inline-block;\n        background: white;\n        border: 1px solid #FAFAFA;\n        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n        margin-top: 5px;\n        margin-right: 7px;\n    }\n    .elemento-galeria:hover{\n        /*border: 2px solid #4185A3;*/\n        border: 1px solid rgba(101, 163, 127, 1);\n        box-shadow: 0 4px 8px 0 rgba(101, 163, 127, 0.6), 0 6px 20px 0 rgba(101, 163, 127, 0.59);\n        margin-top: 5px;\n        margin-right: 7px;\n    }\n    \n    .elemento-galeria:focus{\n        background-color: rgba(0, 255, 0, 0.3);\n    }\n    \n    .circle {\n      height:1em;\n      width: 1em;\n      border-radius: 0%;\n      display: inline-block;\n      margin-top: 2px;\n    }</style><div class="well"><div class="row"><div class="col-xs-12"><label><h4><span data-translate="netWordAgroApp.mapaimagem.filtro">Filtros</span></h4></label></div></div><div class="row"><div class="col-xs-4"><label class="label-filtros"><span data-translate="netWordAgroApp.mapaimagem.propriedade">Propriedades</span></label></div><div class="col-xs-4"><label class="label-filtros"><span data-translate="netWordAgroApp.mapaimagem.safra">Safras</span></label></div><div class="col-xs-4"><label class="label-filtros"><span data-translate="netWordAgroApp.mapaimagem.tipomapa">Tipo de Mapas</span></label></div></div><div class="row"><div class="col-xs-4"><select class="form-control" id="field_filtropropriedade" name="filtropropriedade" ng-model="vm.filtroPropriedade" ng-options="prop as prop.nomepropriedade for prop in vm.propriedades track by prop.id" ng-change="vm.changeFiltroPropriedade()"><option value></option></select></div><div class="col-xs-4"><select class="form-control" id="field_filtrosafra" name="filtrosafra" ng-model="vm.filtroSafra" ng-options="saf as saf.nomesafra for saf in vm.safras track by saf.id"><option value></option></select></div><div class="col-xs-4"><select class="form-control" name="tipomapa" ng-model="vm.filtroTipoMapa" id="field_tipomapa"><option value></option><option value="acarorajado" data-translate="netWordAgroApp.Tipomapa.acarorajado">acarorajado</option><option value="amargoso" data-translate="netWordAgroApp.Tipomapa.amargoso">amargoso</option><option value="antracnose" data-translate="netWordAgroApp.Tipomapa.antracnose">antracnose</option><option value="bicudo" data-translate="netWordAgroApp.Tipomapa.bicudo">bicudo</option><option value="brocadacana" data-translate="netWordAgroApp.Tipomapa.broca">broca</option><option value="buva" data-translate="netWordAgroApp.Tipomapa.buva">buva</option><option value="cigarrinha" data-translate="netWordAgroApp.Tipomapa.cigarrinha">cigarrinha</option><option value="coracaomorto" data-translate="netWordAgroApp.Tipomapa.coracaomorto">coracaomorto</option><option value="coro" data-translate="netWordAgroApp.Tipomapa.coro">coro</option><option value="dessecacao" data-translate="netWordAgroApp.Tipomapa.dessecacao">dessecacao</option><option value="doenca" data-translate="netWordAgroApp.Tipomapa.doenca">doenca</option><option value="falhaplantio" data-translate="netWordAgroApp.Tipomapa.falhaplantio">falhaplantio</option><option value="ferrugem" data-translate="netWordAgroApp.Tipomapa.ferrugem">ferrugem</option><option value="folhaestreita" data-translate="netWordAgroApp.Tipomapa.folhaestreita">folhaestreita</option><option value="folhaestreitacana" data-translate="netWordAgroApp.Tipomapa.folhaestreitacana">folhaestreitacana</option><option value="folhalarga" data-translate="netWordAgroApp.Tipomapa.folhalarga">folhalarga</option><option value="folhalargacana" data-translate="netWordAgroApp.Tipomapa.folhalargacana">folhalargacana</option><option value="helmintosporiose" data-translate="netWordAgroApp.Tipomapa.helmintosporiose">helmintosporiose</option><option value="lagarta" data-translate="netWordAgroApp.Tipomapa.lagarta">lagarta</option><option value="manchaalvo" data-translate="netWordAgroApp.Tipomapa.manchaalvo">manchaalvo</option><option value="manchafoliar" data-translate="netWordAgroApp.Tipomapa.manchafoliar">manchafoliar</option><option value="milho" data-translate="netWordAgroApp.Tipomapa.milho">milho</option><option value="mofobranco" data-translate="netWordAgroApp.Tipomapa.mofobranco">mofobranco</option><option value="nematoide" data-translate="netWordAgroApp.Tipomapa.nematoide">nematoide</option><option value="nutricional" data-translate="netWordAgroApp.Tipomapa.nutricional">nutricional</option><option value="oidio" data-translate="netWordAgroApp.Tipomapa.oidio">oidio</option><option value="percevejo" data-translate="netWordAgroApp.Tipomapa.percevejo">percevejo</option><option value="ervadaninha" data-translate="netWordAgroApp.Tipomapa.ervadaninha">ervadaninha</option><option value="plantadaninhacana" data-translate="netWordAgroApp.Tipomapa.plantadaninhacana">plantadaninhacana</option><option value="plantio" data-translate="netWordAgroApp.Tipomapa.plantio">plantio</option><option value="praga" data-translate="netWordAgroApp.Tipomapa.praga">praga</option><option value="pulgao" data-translate="netWordAgroApp.Tipomapa.pulgao">pulgao</option><option value="ramularia" data-translate="netWordAgroApp.Tipomapa.ramularia">ramularia</option><option value="tripes" data-translate="netWordAgroApp.Tipomapa.tripes">tripes</option><option value="saude" data-translate="netWordAgroApp.Tipomapa.saude">saude</option><option value="umidade" data-translate="netWordAgroApp.Tipomapa.umidade">umidade</option></select></div></div><br><div class="row"><div class="col-xs-4"><label class="label-filtros"><span>Pr\xF3ximo ao dia</span></label></div></div><div class="row"><div class="col-xs-4"><div class="input-group"><input id="field_data" type="text" class="form-control" name="data" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.dataInicioIntervalo" is-open="vm.datePickerOpenStatus.dataInicio"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataInicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-4"><button class="btn btn-primary" ng-click="vm.aplicarFiltros()"><span data-translate="netWordAgroApp.mapaimagem.aplicarFiltros">Aplicar Filtros</span></button></div></div></div><br><div class="row"><div class="col-xs-12" ng-show="vm.dadosMapas.length!=0"><label><h4><span>Clique nos mapas para adicionar ao pedido</span></h4></label></div></div><div id="galeria" ng-show="vm.dadosMapas.length!=0"><div class="elemento-galeria" ng-repeat="mapa in vm.dadosMapas track by mapa.id" ng-click="vm.adicionarMapasSelecionados(mapa)"><center><div style="width: 6vw" ng-switch on="mapa.tipomapa"><img src="../../../content/images/svg/Tipos Mapa_amargoso.svg" ng-switch-when="amargoso" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_brocadacana.svg" ng-switch-when="brocadacana" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_buva.svg" ng-switch-when="buva" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_doenca.svg" ng-switch-when="doenca" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_falhaplantio.svg" ng-switch-when="falhaplantio" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_ferrugem.svg" ng-switch-when="ferrugem" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_folhaestreita.svg" ng-switch-when="folhaestreita" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_folhaestreitacana.svg" ng-switch-when="folhaestreitacana" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_folhalarga.svg" ng-switch-when="folhalarga" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_folhalargacana.svg" ng-switch-when="folhalargacana" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_helmintosporiose.svg" ng-switch-when="helmintosporiose" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_lagarta.svg" ng-switch-when="lagarta" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_manchaalvo.svg" ng-switch-when="manchaalvo" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_milho.svg" ng-switch-when="milho" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_nutricional.svg" ng-switch-when="nutricional" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_oidio.svg" ng-switch-when="oidio" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_outros.svg" ng-switch-when="outros" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_percevejo.svg" ng-switch-when="percevejo" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_plantadaninha.svg" ng-switch-when="ervadaninha" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_plantadaninhacana.svg" ng-switch-when="plantadaninhacana" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_praga.svg" ng-switch-when="praga" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_pulgao.svg" ng-switch-when="pulgao" style="max-width: 100%" alt="mapaimagem image"> <img src="../../../content/images/svg/Tipos Mapa_outros.svg" ng-switch-default style="max-width: 100%" alt="mapaimagem image"></div></center><div style="padding: 5px; background: #FAFAFA; border-top: 1px solid #726CD3">{{mapa.nomemapa}}<br><span data-translate="netWordAgroApp.mapaimagem.data">Data:</span> {{mapa.data | date:"dd/MM/yyyy"}}<br><span ng-show="mapa.areaafetada"><span data-translate="netWordAgroApp.mapaimagem.areaafetada">\xC1rea Afetada:</span> {{mapa.areaafetada}} ha</span></div></div></div><div class="row"><div class="col-xs-12" ng-show="vm.dadosMapas.length==0"><label><h4><span data-translate="netWordAgroApp.mapaimagem.apliquenovosfiltros">Aplique filtros para ver novos mapas para selecionar</span></h4></label><br></div></div><div class="well"><div class="row"><div class="col-xs-12"><label><h4><span>Dados adicionados</span></h4></label></div></div><div class="row"><div class="col-xs-4"><div class="input-group"><label class="label-filtros"><span>Vaz\xE3o (l/ha)</span></label></div></div><div class="col-xs-4"><div class="input-group"><label class="label-filtros"><span>Maquin\xE1rio</span></label></div></div><div class="col-xs-4"><div class="input-group"><label class="label-filtros"><span>CREA ou CFTA</span></label></div></div></div><div class="row"><div class="col-xs-4"><div class="input-group"><input id="field_vazao" type="number" step="0.01" min="0" class="form-control" name="data" ng-model="vm.vazao"></div></div><div class="col-xs-4"><div class="form-group"><select class="form-control" id="field_maquinario" name="maquinario" ng-model="vm.maquinario" ng-options=\'maquinario as (maquinario.marca + " - " + maquinario.modelo + " - " + maquinario.monitor) for maquinario in vm.maquinarios track by maquinario.id\'><option value=""></option></select></div></div><div class="col-xs-4"><div class="input-group"><input id="field_crea" type="text" class="form-control" name="crea" ng-model="vm.crea"></div></div></div><div class="row"><div class="col-xs-8"><div class="input-group"><label class="label-filtros"><span>Nome do Engenheiro<span></span></span></label></div></div></div><div class="row"><div class="col-xs-8"><div class="form-group"><input id="field_nome" type="text" class="form-control" name="nome" ng-model="vm.nomeengenheiro"></div></div></div></div><br><div class="well"><div class="row" ng-show="vm.mapasSelecionados.length!=0"><div class="col-xs-12"><label><h4><span>Mapas adicionados ao pedido</span></h4></label></div></div><div class="row" ng-repeat="mapa in vm.mapasSelecionados"><div class="col-xs-4" style="padding: 12px; padding-top: 12px; font-size:1em"><b>{{mapa.nomemapa}}</b><br><span data-translate="netWordAgroApp.mapaimagem.data">Data:</span> {{mapa.data | date:"dd/MM/yyyy"}}<br></div><div class="col-xs-1" style="padding: 12px; padding-top: 12px; font-size:1em"><button class="btn btn-danger" ng-click="vm.removerMapaSelecionado(mapa)">Remover</button></div></div></div><div class="well"><div class="row"><div class="col-xs-12"><label><h4><span>Receitu\xE1rio</span></h4></label></div></div><div class="row"><div class="col-xs-12"><label><h5><span>Adicione aqui os produtos a serem aplicados</span></h5></label><br><label><h5><span>Se for relevante, adicione na ordem de preparo da calda</span></h5></label></div></div><div class="row" ng-repeat="produto in vm.produtosPedido"><div class="col-xs-12 well"><i>Produto {{produto.ordem}}</i><br><br><div class="row"><div class="form-group col-xs-3"><label data-translate="netWordAgroApp.pedidoProduto.tipo" for="field_produto">Tipo</label><select class="form-control" id="field_tipo" name="tipo" ng-model="produto.tipo" ng-change="vm.changeFiltroTipo(produto.tipo, produto.ordem)"><option value=""></option><option value="fungicida" data-translate="netWordAgroApp.Tipoproduto.fungicida">fungicida</option><option value="herbicida" data-translate="netWordAgroApp.Tipoproduto.herbicida">herbicida</option><option value="inseticida" data-translate="netWordAgroApp.Tipoproduto.inseticida">inseticida</option><option value="adjuvante" data-translate="netWordAgroApp.Tipoproduto.adjuvante">adjuvante</option></select></div><div class="form-group col-xs-7"><label data-translate="netWordAgroApp.pedidoProduto.produto" for="field_produto">Produto</label><select class="form-control" id="field_produto" name="produto" ng-model="produto.produto" ng-options="produto as produto.nomecomercial for produto in vm.produtos[produto.ordem] track by produto.id" ng-disabled="produto.tipo==null || produto.tipo==\'\'"><option value=""></option></select></div><div class="form-group col-xs-2"><label class="control-label" data-translate="netWordAgroApp.pedidoProduto.dose" for="field_dose">Dose</label><input type="number" class="form-control" name="dose" id="field_dose" ng-model="produto.dose"><label ng-show="produto.produto.consistencia==\'solido\'">kg</label><label ng-show="produto.produto.consistencia==\'liquido\'">litros</label></div></div><div class="row" ng-show="produto.produto != null"><div class="col-xs-10"><label class="control-label">Princ\xEDpio ativo: {{produto.produto.principioativo}}</label></div></div><br><div class="row"><div class="col-xs-2"><button class="btn btn-danger" ng-click="vm.removerProduto(produto)"><span class="glyphicon glyphicon-minus"></span> Remover</button></div><div class="col-xs-2"><button class="btn btn-info" ng-click="vm.moverProdutoCima(produto)"><span class="glyphicon glyphicon-arrow-up"></span> Mover para cima</button></div><div class="col-xs-2"><button class="btn btn-info" ng-click="vm.moverProdutoBaixo(produto)"><span class="glyphicon glyphicon-arrow-down"></span> Mover para baixo</button></div></div></div></div><div class="row"><div class="col-xs-12"><button class="btn btn-primary" ng-click="vm.adicionarProduto()">Adicionar Produto</button></div></div></div><br><br><div class="row" ng-show="vm.mapasSelecionados.length!=0"><div class="col-xs-12"><button class="btn btn-success" ng-click="vm.confirmarPedido()">Enviar Pedido</button></div></div><jhi-alert></jhi-alert>');
$templateCache.put('app/entities/pedido/pedidos.html','<div><h2 data-translate="netWordAgroApp.pedido.home.title">Pedidos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="pedido.new" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-plus"></span><!--<span class="hidden-xs-down"  data-translate="netWordAgroApp.pedido.home.createLabel">\n                        Create new Pedido\n                    </span>--></button></div><div class="col-xs-8 no-padding-right" has-authority="ROLE_ADMIN"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.pedido.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipos"><span data-translate="netWordAgroApp.pedido.tipos">Tipos</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datas"><span data-translate="netWordAgroApp.pedido.datas">Datas</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="vazao"><span data-translate="netWordAgroApp.pedido.vazao">Vazao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span data-translate="netWordAgroApp.pedido.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Shapefile</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Receitu\xE1rio</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="pedido in vm.pedidos track by pedido.id"><td><a ui-sref="pedido-detail({id:pedido.id})">{{pedido.id}}</a></td><td>{{pedido.tipos}}</td><td>{{pedido.datas | date:"dd/MM/yyyy"}}</td><td>{{pedido.vazao}}</td><td data-translate="{{\'netWordAgroApp.Tipostatus.\' + pedido.status}}">{{pedido.status}}</td><td><button class="btn btn-info btn-sm" ng-click="vm.downloadShape(pedido.id)" ng-disabled="pedido.status!=\'concluido\'"><span class="glyphicon glyphicon-download-alt"></span> <span class="hidden-sm-down">Download Shapefile</span></button></td><td><button class="btn btn-info btn-sm" ng-click="vm.downloadReceituario(pedido.id)" ng-disabled="pedido.status!=\'concluido\'"><span class="glyphicon glyphicon-download-alt"></span> <span class="hidden-sm-down">Download Receituario</span></button></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="pedido-detail({id:pedido.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="pedido.edit({id:pedido.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="pedido.delete({id:pedido.id})" class="btn btn-danger btn-sm" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/pedido-produto/pedido-produto-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.pedidoProduto.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.pedidoProduto.delete.question" translate-values="{id: \'{{vm.pedidoProduto.id}}\'}">Are you sure you want to delete this Pedido Produto?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/pedido-produto/pedido-produto-detail.html','<div><h2><span data-translate="netWordAgroApp.pedidoProduto.detail.title">Pedido Produto</span> {{vm.pedidoProduto.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.pedidoProduto.dose">Dose</span></dt><dd><span>{{vm.pedidoProduto.dose}}</span></dd><dt><span data-translate="netWordAgroApp.pedidoProduto.ordem">Ordem</span></dt><dd><span>{{vm.pedidoProduto.ordem}}</span></dd><dt><span data-translate="netWordAgroApp.pedidoProduto.quantidadetotal">Quantidadetotal</span></dt><dd><span>{{vm.pedidoProduto.quantidadetotal}}</span></dd><dt><span data-translate="netWordAgroApp.pedidoProduto.produto">Produto</span></dt><dd><a ui-sref="produto-detail({id:vm.pedidoProduto.produto.id})">{{vm.pedidoProduto.produto.nomecomercial}}</a></dd><dt><span data-translate="netWordAgroApp.pedidoProduto.pedido">Pedido</span></dt><dd><a ui-sref="pedido-detail({id:vm.pedidoProduto.pedido.id})">{{vm.pedidoProduto.pedido.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="pedido-produto-detail.edit({id:vm.pedidoProduto.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/pedido-produto/pedido-produto-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPedidoProdutoLabel" data-translate="netWordAgroApp.pedidoProduto.home.createOrEditLabel">Create or edit a Pedido Produto</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.pedidoProduto.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.pedidoProduto.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pedidoProduto.dose" for="field_dose">Dose</label><input type="text" class="form-control" name="dose" id="field_dose" ng-model="vm.pedidoProduto.dose"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pedidoProduto.ordem" for="field_ordem">Ordem</label><input type="number" class="form-control" name="ordem" id="field_ordem" ng-model="vm.pedidoProduto.ordem"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pedidoProduto.quantidadetotal" for="field_quantidadetotal">Quantidadetotal</label><input type="text" class="form-control" name="quantidadetotal" id="field_quantidadetotal" ng-model="vm.pedidoProduto.quantidadetotal"></div><div class="form-group"><label data-translate="netWordAgroApp.pedidoProduto.produto" for="field_produto">Produto</label><select class="form-control" id="field_produto" name="produto" ng-model="vm.pedidoProduto.produto" ng-options="produto as produto.nomecomercial for produto in vm.produtos track by produto.id"><option value=""></option></select></div><div class="form-group"><label data-translate="netWordAgroApp.pedidoProduto.pedido" for="field_pedido">Pedido</label><select class="form-control" id="field_pedido" name="pedido" ng-model="vm.pedidoProduto.pedido" ng-options="pedido as pedido.id for pedido in vm.pedidos track by pedido.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/pedido-produto/pedido-produtos.html','<div><h2 data-translate="netWordAgroApp.pedidoProduto.home.title">Pedido Produtos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="pedido-produto.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.pedidoProduto.home.createLabel">Create new Pedido Produto</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.pedidoProduto.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dose"><span data-translate="netWordAgroApp.pedidoProduto.dose">Dose</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ordem"><span data-translate="netWordAgroApp.pedidoProduto.ordem">Ordem</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quantidadetotal"><span data-translate="netWordAgroApp.pedidoProduto.quantidadetotal">Quantidadetotal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="produto.nomecomercial"><span data-translate="netWordAgroApp.pedidoProduto.produto">Produto</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pedido.id"><span data-translate="netWordAgroApp.pedidoProduto.pedido">Pedido</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="pedidoProduto in vm.pedidoProdutos track by pedidoProduto.id"><td><a ui-sref="pedido-produto-detail({id:pedidoProduto.id})">{{pedidoProduto.id}}</a></td><td>{{pedidoProduto.dose}}</td><td>{{pedidoProduto.ordem}}</td><td>{{pedidoProduto.quantidadetotal}}</td><td><a ui-sref="produto-detail({id:pedidoProduto.produto.id})">{{pedidoProduto.produto.nomecomercial}}</a></td><td><a ui-sref="pedido-detail({id:pedidoProduto.pedido.id})">{{pedidoProduto.pedido.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="pedido-produto-detail({id:pedidoProduto.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="pedido-produto.edit({id:pedidoProduto.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="pedido-produto.delete({id:pedidoProduto.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/pesquisa/pesquisa-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.pesquisa.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.pesquisa.delete.question" translate-values="{id: \'{{vm.pesquisa.id}}\'}">Are you sure you want to delete this Pesquisa?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/pesquisa/pesquisa-detail.html','<div><h2><span data-translate="netWordAgroApp.pesquisa.detail.title">Pesquisa</span> {{vm.pesquisa.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.pesquisa.nomepesquisa">Nomepesquisa</span></dt><dd><span>{{vm.pesquisa.nomepesquisa}}</span></dd><dt><span data-translate="netWordAgroApp.pesquisa.datapesquisa">Datapesquisa</span></dt><dd><span>{{vm.pesquisa.datapesquisa | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.pesquisa.obspesquisa">Obspesquisa</span></dt><dd><span>{{vm.pesquisa.obspesquisa}}</span></dd><dt><span data-translate="netWordAgroApp.pesquisa.propriedade">Propriedade</span></dt><dd><a ui-sref="propriedade-detail({id:vm.pesquisa.propriedade.id})">{{vm.pesquisa.propriedade.nomepropriedade}}</a></dd><dt><span data-translate="netWordAgroApp.pesquisa.cultura">Cultura</span></dt><dd><a ui-sref="cultura-detail({id:vm.pesquisa.cultura.id})">{{vm.pesquisa.cultura.nomecultura}}</a></dd><dt><span data-translate="netWordAgroApp.pesquisa.solo">Solo</span></dt><dd><a ui-sref="solo-detail({id:vm.pesquisa.solo.id})">{{vm.pesquisa.solo.nomesolo}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="pesquisa-detail.edit({id:vm.pesquisa.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/pesquisa/pesquisa-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPesquisaLabel" data-translate="netWordAgroApp.pesquisa.home.createOrEditLabel">Create or edit a Pesquisa</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.pesquisa.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.pesquisa.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pesquisa.nomepesquisa" for="field_nomepesquisa">Nomepesquisa</label><input type="text" class="form-control" name="nomepesquisa" id="field_nomepesquisa" ng-model="vm.pesquisa.nomepesquisa" required ng-maxlength="50"><div ng-show="editForm.nomepesquisa.$invalid"><p class="help-block" ng-show="editForm.nomepesquisa.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nomepesquisa.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pesquisa.datapesquisa" for="field_datapesquisa">Datapesquisa</label><div class="input-group"><input id="field_datapesquisa" type="text" class="form-control" name="datapesquisa" uib-datepicker-popup="{{dateformat}}" ng-model="vm.pesquisa.datapesquisa" is-open="vm.datePickerOpenStatus.datapesquisa" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datapesquisa\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datapesquisa.$invalid"><p class="help-block" ng-show="editForm.datapesquisa.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pesquisa.obspesquisa" for="field_obspesquisa">Obspesquisa</label><input type="text" class="form-control" name="obspesquisa" id="field_obspesquisa" ng-model="vm.pesquisa.obspesquisa" required ng-maxlength="250"><div ng-show="editForm.obspesquisa.$invalid"><p class="help-block" ng-show="editForm.obspesquisa.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.obspesquisa.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="250">This field cannot be longer than 250 characters.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.pesquisa.propriedade" for="field_propriedade">Propriedade</label><select class="form-control" id="field_propriedade" name="propriedade" ng-model="vm.pesquisa.propriedade" ng-options="propriedade as propriedade.nomepropriedade for propriedade in vm.propriedades track by propriedade.id" required></select></div><div ng-show="editForm.propriedade.$invalid"><p class="help-block" ng-show="editForm.propriedade.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.pesquisa.cultura" for="field_cultura">Cultura</label><select class="form-control" id="field_cultura" name="cultura" ng-model="vm.pesquisa.cultura" ng-options="cultura as cultura.nomecultura for cultura in vm.culturas track by cultura.id" required></select></div><div ng-show="editForm.cultura.$invalid"><p class="help-block" ng-show="editForm.cultura.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.pesquisa.solo" for="field_solo">Solo</label><select class="form-control" id="field_solo" name="solo" ng-model="vm.pesquisa.solo" ng-options="solo as solo.nomesolo for solo in vm.solos track by solo.id" required></select></div><div ng-show="editForm.solo.$invalid"><p class="help-block" ng-show="editForm.solo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/pesquisa/pesquisas.html','<div><h2 data-translate="netWordAgroApp.pesquisa.home.title">Pesquisas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="pesquisa.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.pesquisa.home.createLabel">Create new Pesquisa</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.pesquisa.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomepesquisa"><span data-translate="netWordAgroApp.pesquisa.nomepesquisa">Nomepesquisa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datapesquisa"><span data-translate="netWordAgroApp.pesquisa.datapesquisa">Datapesquisa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="obspesquisa"><span data-translate="netWordAgroApp.pesquisa.obspesquisa">Obspesquisa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="propriedade.nomepropriedade"><span data-translate="netWordAgroApp.pesquisa.propriedade">Propriedade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cultura.nomecultura"><span data-translate="netWordAgroApp.pesquisa.cultura">Cultura</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="solo.nomesolo"><span data-translate="netWordAgroApp.pesquisa.solo">Solo</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="pesquisa in vm.pesquisas track by pesquisa.id"><td><a ui-sref="pesquisa-detail({id:pesquisa.id})">{{pesquisa.id}}</a></td><td>{{pesquisa.nomepesquisa}}</td><td>{{pesquisa.datapesquisa | date:\'mediumDate\'}}</td><td>{{pesquisa.obspesquisa}}</td><td><a ui-sref="propriedade-detail({id:pesquisa.propriedade.id})">{{pesquisa.propriedade.nomepropriedade}}</a></td><td><a ui-sref="cultura-detail({id:pesquisa.cultura.id})">{{pesquisa.cultura.nomecultura}}</a></td><td><a ui-sref="solo-detail({id:pesquisa.solo.id})">{{pesquisa.solo.nomesolo}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="pesquisa-detail({id:pesquisa.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="pesquisa.edit({id:pesquisa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="pesquisa.delete({id:pesquisa.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/pais/pais-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.pais.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.pais.delete.question" translate-values="{id: \'{{vm.pais.id}}\'}">Are you sure you want to delete this Pais?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/pais/pais-detail.html','<div><h2><span data-translate="netWordAgroApp.pais.detail.title">Pais</span> {{vm.pais.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.pais.nomepais">Nomepais</span></dt><dd><span>{{vm.pais.nomepais}}</span></dd><dt><span data-translate="netWordAgroApp.pais.siglapais">Siglapais</span></dt><dd><span>{{vm.pais.siglapais}}</span></dd><dt><span data-translate="netWordAgroApp.pais.imagempais">Imagempais</span></dt><dd><div ng-if="vm.pais.imagempais"><a ng-click="vm.openFile(vm.pais.imagempaisContentType, vm.pais.imagempais)"><img data-ng-src="{{\'data:\' + vm.pais.imagempaisContentType + \';base64,\' + vm.pais.imagempais}}" style="max-width: 100%" alt="pais image"> </a>{{vm.pais.imagempaisContentType}}, {{vm.byteSize(vm.pais.imagempais)}}</div></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="pais-detail.edit({id:vm.pais.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/pais/pais-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPaisLabel" data-translate="netWordAgroApp.pais.home.createOrEditLabel">Create or edit a Pais</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.pais.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.pais.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pais.nomepais" for="field_nomepais">Nomepais</label><input type="text" class="form-control" name="nomepais" id="field_nomepais" ng-model="vm.pais.nomepais" required ng-maxlength="35"><div ng-show="editForm.nomepais.$invalid"><p class="help-block" ng-show="editForm.nomepais.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nomepais.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="35">This field cannot be longer than 35 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pais.siglapais" for="field_siglapais">Siglapais</label><input type="text" class="form-control" name="siglapais" id="field_siglapais" ng-model="vm.pais.siglapais" required ng-minlength="2" ng-maxlength="3"><div ng-show="editForm.siglapais.$invalid"><p class="help-block" ng-show="editForm.siglapais.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.siglapais.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.siglapais.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="3">This field cannot be longer than 3 characters.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setImagempais($file, vm.pais)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="netWordAgroApp.pais.imagempais" for="field_imagempais">Imagempais</label><div><img data-ng-src="{{\'data:\' + vm.pais.imagempaisContentType + \';base64,\' + vm.pais.imagempais}}" style="max-height: 100px" ng-if="vm.pais.imagempais" alt="pais image"><div ng-if="vm.pais.imagempais" class="help-block clearfix"><span class="pull-left">{{vm.pais.imagempaisContentType}}, {{vm.byteSize(vm.pais.imagempais)}}</span> <button type="button" ng-click="vm.pais.imagempais=null;vm.pais.imagempaisContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setImagempais($file, vm.pais)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="imagempais" id="field_imagempais" ng-model="vm.pais.imagempais" required> <input type="hidden" class="form-control" name="imagempaisContentType" id="field_imagempaisContentType" ng-model="vm.pais.imagempaisContentType"><div ng-show="editForm.imagempais.$invalid"><p class="help-block" ng-show="editForm.imagempais.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/pais/pais.html','<div><h2 data-translate="netWordAgroApp.pais.home.title">Pais</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="pais.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.pais.home.createLabel">Create new Pais</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.pais.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomepais"><span data-translate="netWordAgroApp.pais.nomepais">Nomepais</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="siglapais"><span data-translate="netWordAgroApp.pais.siglapais">Siglapais</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="imagempais"><span data-translate="netWordAgroApp.pais.imagempais">Imagempais</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="pais in vm.pais track by pais.id"><td><a ui-sref="pais-detail({id:pais.id})">{{pais.id}}</a></td><td>{{pais.nomepais}}</td><td>{{pais.siglapais}}</td><td><a ng-if="pais.imagempais" ng-click="vm.openFile(pais.imagempaisContentType, pais.imagempais)"><img data-ng-src="{{\'data:\' + pais.imagempaisContentType + \';base64,\' + pais.imagempais}}" style="max-height: 30px" alt="pais image"> </a><span ng-if="pais.imagempais">{{pais.imagempaisContentType}}, {{vm.byteSize(pais.imagempais)}}</span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="pais-detail({id:pais.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="pais.edit({id:pais.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="pais.delete({id:pais.id})" class="btn btn-danger btn-sm" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/pedidonutricional/pedido-nutricional-fazer.html','<style type="text/css">#map{\n        height: 500px;\n        width: 100%;\n    }\n    \n    .label-filtros{\n        color: #555555;\n        font-weight: bold;\n    }\n    \n    #galeria {\n      overflow-x: scroll;\n      overflow-y: hidden;\n      white-space: nowrap;\n      height: auto;\n      padding: 10px;\n      /*border: 2px outset #555555;*/\n    }\n    .elemento-galeria{\n        display: inline-block;\n        background: white;\n        border: 1px solid #FAFAFA;\n        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n        margin-top: 5px;\n        margin-right: 7px;\n    }\n    .elemento-galeria:hover{\n        /*border: 2px solid #4185A3;*/\n        border: 1px solid rgba(101, 163, 127, 1);\n        box-shadow: 0 4px 8px 0 rgba(101, 163, 127, 0.6), 0 6px 20px 0 rgba(101, 163, 127, 0.59);\n        margin-top: 5px;\n        margin-right: 7px;\n    }\n    \n    .elemento-galeria:focus{\n        background-color: rgba(0, 255, 0, 0.3);\n    }\n    \n    .circle {\n      height:1em;\n      width: 1em;\n      border-radius: 0%;\n      display: inline-block;\n      margin-top: 2px;\n    }</style><h2 data-translate="netWordAgroApp.pedidonutricional.home.title">Pedido de Shapefile Nutricional</h2><div class="well"><div class="row"><div class="col-xs-12"><label><h4><span>Dados b\xE1sicos</span></h4></label></div></div><div class="row"><div class="col-xs-4"><label class="label-filtros"><span data-translate="netWordAgroApp.mapaimagem.propriedade">Propriedades</span></label></div><div class="col-xs-4"><label class="label-filtros"><span data-translate="netWordAgroApp.mapaimagem.safra">Safras</span></label></div><div class="col-xs-4"><label class="label-filtros"><span data-translate="netWordAgroApp.mapaimagem.atributo">Atributo</span></label></div></div><div class="row"><div class="col-xs-4"><select class="form-control" id="field_filtropropriedade" name="filtropropriedade" ng-model="vm.filtroPropriedade" ng-options="prop as prop.nomepropriedade for prop in vm.propriedades track by prop.id" ng-change="vm.changeFiltroPropriedade()"><option value></option></select></div><div class="col-xs-4"><select class="form-control" id="field_filtrosafra" name="filtrosafra" ng-model="vm.filtroSafra" ng-options="saf as saf.nomesafra for saf in vm.safras track by saf.id"><option value></option></select></div><div class="col-xs-4"><select class="form-control" id="field_filtrosafra" name="filtrosafra" ng-model="vm.filtroAtributo" ng-options="atr as atr.nomeatributo for atr in vm.atributos track by atr.id"><option value></option></select></div></div></div><div class="well"><div class="row"><div class="col-xs-12"><label><h4><span>Dados do formulado</span></h4></label></div></div><div class="row"><div class="col-xs-4"><div class="input-group"><label class="label-filtros"><span>Formulado Composto</span></label></div></div><div class="col-xs-4"><div class="input-group"><label class="label-filtros"><span>Nome do Formulado</span></label></div></div><div class="col-xs-4"><div class="input-group"><label class="label-filtros"><span>% do composto no formulado</span></label></div></div></div><div class="row"><div class="col-xs-4"><div class="input-group"><input id="field_composto" type="text" class="form-control" name="formuladocomposto" ng-model="vm.formuladocomposto"></div></div><div class="col-xs-4"><div class="input-group"><input id="field_nomeformulado" type="text" class="form-control" name="nomeformulado" ng-model="vm.nomeformulado"></div></div><div class="col-xs-4"><div class="input-group"><input id="field_porcentagemcomposto" type="number" step="0.01" min="-100" max="100" class="form-control" name="porcentagemcomposto" ng-model="vm.porcentagemcomposto"></div></div></div><br><div class="row"><div class="col-xs-4"><div class="input-group"><label class="label-filtros"><span>% de acr\xE9scimo</span></label></div></div></div><div class="row"><div class="col-xs-4"><div class="input-group"><input id="field_porcentagemacrescimo" type="number" step="0.01" min="-100" max="100" class="form-control" name="porcentagemacrescimo" ng-model="vm.porcentagemacrescimo"></div></div></div></div><!--Dados adicionais--><div class="well"><div class="row"><div class="col-xs-12"><label><h4><span>Dados adicionais</span></h4></label></div></div><div class="row"><div class="col-xs-4"><div class="input-group"><label class="label-filtros"><span>CREA ou CFTA</span></label></div></div><div class="col-xs-4"><div class="input-group"><label class="label-filtros"><span>\xC1rea Total</span></label></div></div></div><div class="row"><div class="col-xs-4"><div class="input-group"><input id="field_crea" type="text" class="form-control" name="crea" ng-model="vm.crea"></div></div><div class="col-xs-4"><select class="form-control" id="field_areatotal" name="areatotal" ng-model="vm.areatotal"><option value=""></option><option value="sim">Sim</option><option value="n\xE3o">N\xE3o</option></select></div></div><br></div>"<div class="row"><div class="col-xs-12"><button class="btn btn-success" ng-click="vm.confirmarPedido()">Enviar Pedido</button></div></div>"<jhi-alert></jhi-alert>');
$templateCache.put('app/entities/pedidonutricional/pedidonutricional-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.pedidonutricional.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.pedidonutricional.delete.question" translate-values="{id: \'{{vm.pedidonutricional.id}}\'}">Are you sure you want to delete this Pedidonutricional?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/pedidonutricional/pedidonutricional-detail.html','<div><h2><span data-translate="netWordAgroApp.pedidonutricional.detail.title">Pedidonutricional</span> {{vm.pedidonutricional.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.pedidonutricional.idsmapas">Idsmapas</span></dt><dd><span>{{vm.pedidonutricional.idsmapas}}</span></dd><dt><span data-translate="netWordAgroApp.pedidonutricional.formuladocomposto">Formuladocomposto</span></dt><dd><span>{{vm.pedidonutricional.formuladocomposto}}</span></dd><dt><span data-translate="netWordAgroApp.pedidonutricional.nomeformulado">Nomeformulado</span></dt><dd><span>{{vm.pedidonutricional.nomeformulado}}</span></dd><dt><span data-translate="netWordAgroApp.pedidonutricional.nutriente">Nutriente</span></dt><dd><span>{{vm.pedidonutricional.nutriente}}</span></dd><dt><span data-translate="netWordAgroApp.pedidonutricional.porcentagemformula">Porcentagemformula</span></dt><dd><span>{{vm.pedidonutricional.porcentagemformula}}</span></dd><dt><span data-translate="netWordAgroApp.pedidonutricional.porcentagemacrescimo">Porcentagemacrescimo</span></dt><dd><span>{{vm.pedidonutricional.porcentagemacrescimo}}</span></dd><dt><span data-translate="netWordAgroApp.pedidonutricional.areatotal">Areatotal</span></dt><dd><span>{{vm.pedidonutricional.areatotal}}</span></dd><dt><span data-translate="netWordAgroApp.pedidonutricional.crea">Crea</span></dt><dd><span>{{vm.pedidonutricional.crea}}</span></dd><dt><span data-translate="netWordAgroApp.pedidonutricional.datas">Datas</span></dt><dd><span>{{vm.pedidonutricional.datas}}</span></dd><dt><span data-translate="netWordAgroApp.pedidonutricional.status">Status</span></dt><dd><span>{{vm.pedidonutricional.status}}</span></dd><dt><span data-translate="netWordAgroApp.pedidonutricional.shapefile">Shapefile</span></dt><dd><div ng-if="vm.pedidonutricional.shapefile"><a ng-click="vm.openFile(vm.pedidonutricional.shapefileContentType, vm.pedidonutricional.shapefile)" data-translate="entity.action.open">open</a> {{vm.pedidonutricional.shapefileContentType}}, {{vm.byteSize(vm.pedidonutricional.shapefile)}}</div></dd><dt><span data-translate="netWordAgroApp.pedidonutricional.propriedade">Propriedade</span></dt><dd><a ui-sref="propriedade-detail({id:vm.pedidonutricional.propriedade.id})">{{vm.pedidonutricional.propriedade.nomepropriedade}}</a></dd><dt><span data-translate="netWordAgroApp.pedidonutricional.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.pedidonutricional.safra.id})">{{vm.pedidonutricional.safra.nomesafra}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="pedidonutricional-detail.edit({id:vm.pedidonutricional.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/pedidonutricional/pedidonutricional-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPedidonutricionalLabel" data-translate="netWordAgroApp.pedidonutricional.home.createOrEditLabel">Create or edit a Pedidonutricional</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.pedidonutricional.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.pedidonutricional.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pedidonutricional.idsmapas" for="field_idsmapas">Idsmapas</label><input type="text" class="form-control" name="idsmapas" id="field_idsmapas" ng-model="vm.pedidonutricional.idsmapas"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pedidonutricional.formuladocomposto" for="field_formuladocomposto">Formuladocomposto</label><input type="text" class="form-control" name="formuladocomposto" id="field_formuladocomposto" ng-model="vm.pedidonutricional.formuladocomposto"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pedidonutricional.nomeformulado" for="field_nomeformulado">Nomeformulado</label><input type="text" class="form-control" name="nomeformulado" id="field_nomeformulado" ng-model="vm.pedidonutricional.nomeformulado"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pedidonutricional.nutriente" for="field_nutriente">Nutriente</label><input type="text" class="form-control" name="nutriente" id="field_nutriente" ng-model="vm.pedidonutricional.nutriente"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pedidonutricional.porcentagemformula" for="field_porcentagemformula">Porcentagemformula</label><input type="text" class="form-control" name="porcentagemformula" id="field_porcentagemformula" ng-model="vm.pedidonutricional.porcentagemformula"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pedidonutricional.porcentagemacrescimo" for="field_porcentagemacrescimo">Porcentagemacrescimo</label><input type="text" class="form-control" name="porcentagemacrescimo" id="field_porcentagemacrescimo" ng-model="vm.pedidonutricional.porcentagemacrescimo"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pedidonutricional.areatotal" for="field_areatotal">Areatotal</label><input type="text" class="form-control" name="areatotal" id="field_areatotal" ng-model="vm.pedidonutricional.areatotal"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pedidonutricional.crea" for="field_crea">Crea</label><input type="text" class="form-control" name="crea" id="field_crea" ng-model="vm.pedidonutricional.crea"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pedidonutricional.datas" for="field_datas">Datas</label><input type="text" class="form-control" name="datas" id="field_datas" ng-model="vm.pedidonutricional.datas"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pedidonutricional.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.pedidonutricional.status"></div><div class="form-group" ngf-drop ngf-change="vm.setShapefile($file, vm.pedidonutricional)"><label class="control-label" data-translate="netWordAgroApp.pedidonutricional.shapefile" for="field_shapefile">Shapefile</label><div><div ng-if="vm.pedidonutricional.shapefile" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.pedidonutricional.shapefileContentType, vm.pedidonutricional.shapefile)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.pedidonutricional.shapefileContentType}}, {{vm.byteSize(vm.pedidonutricional.shapefile)}}</span> <button type="button" ng-click="vm.pedidonutricional.shapefile=null;vm.pedidonutricional.shapefileContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setShapefile($file, vm.pedidonutricional)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="shapefile" id="field_shapefile" ng-model="vm.pedidonutricional.shapefile"> <input type="hidden" class="form-control" name="shapefileContentType" id="field_shapefileContentType" ng-model="vm.pedidonutricional.shapefileContentType"></div><div class="form-group"><label data-translate="netWordAgroApp.pedidonutricional.propriedade" for="field_propriedade">Propriedade</label><select class="form-control" id="field_propriedade" name="propriedade" ng-model="vm.pedidonutricional.propriedade" ng-options="propriedade as propriedade.nomepropriedade for propriedade in vm.propriedades track by propriedade.id"><option value=""></option></select></div><div class="form-group"><label data-translate="netWordAgroApp.pedidonutricional.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.pedidonutricional.safra" ng-options="safra as safra.nomesafra for safra in vm.safras track by safra.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/pedidonutricional/pedidonutricionals.html','<div><h2 data-translate="netWordAgroApp.pedidonutricional.home.title">Pedidonutricionals</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><!--<button class="btn btn-primary" ui-sref="pedidonutricional.new" >\n                    <span class="glyphicon glyphicon-plus"></span>\n                    <span class="hidden-xs-down"  data-translate="netWordAgroApp.pedidonutricional.home.createLabel">\n                        Create new Pedidonutricional\n                    </span>\n                </button>--></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.pedidonutricional.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="formuladocomposto"><span data-translate="netWordAgroApp.pedidonutricional.formuladocomposto">Formuladocomposto</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomeformulado"><span data-translate="netWordAgroApp.pedidonutricional.nomeformulado">Nomeformulado</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nutriente"><span data-translate="netWordAgroApp.pedidonutricional.nutriente">Nutriente</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="porcentagemformula"><span data-translate="netWordAgroApp.pedidonutricional.porcentagemformula">Porcentagemformula</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="porcentagemacrescimo"><span data-translate="netWordAgroApp.pedidonutricional.porcentagemacrescimo">Porcentagemacrescimo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="areatotal"><span data-translate="netWordAgroApp.pedidonutricional.areatotal">Areatotal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="crea"><span data-translate="netWordAgroApp.pedidonutricional.crea">Crea</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datas"><span data-translate="netWordAgroApp.pedidonutricional.datas">Datas</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span data-translate="netWordAgroApp.pedidonutricional.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="shapefile"><span data-translate="netWordAgroApp.pedidonutricional.shapefile">Shapefile</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="propriedade.nomepropriedade"><span data-translate="netWordAgroApp.pedidonutricional.propriedade">Propriedade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="safra.nomesafra"><span data-translate="netWordAgroApp.pedidonutricional.safra">Safra</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="pedidonutricional in vm.pedidonutricionals track by pedidonutricional.id"><td><a ui-sref="pedidonutricional-detail({id:pedidonutricional.id})">{{pedidonutricional.id}}</a></td><td>{{pedidonutricional.formuladocomposto}}</td><td>{{pedidonutricional.nomeformulado}}</td><td>{{pedidonutricional.nutriente}}</td><td>{{pedidonutricional.porcentagemformula}}</td><td>{{pedidonutricional.porcentagemacrescimo}}</td><td>{{pedidonutricional.areatotal}}</td><td>{{pedidonutricional.crea}}</td><td>{{pedidonutricional.datas | date:"dd/MM/yyyy"}}</td><td>{{pedidonutricional.status}}</td><td><button class="btn btn-info btn-sm" ng-click="vm.downloadShape(pedidonutricional.id)" ng-disabled="!(pedidonutricional.status==\'concluido\' || pedidonutricional.status==\'conclu\xEDdo\')"><span class="glyphicon glyphicon-download-alt"></span> <span class="hidden-sm-down">Download</span></button></td><td><a ui-sref="propriedade-detail({id:pedidonutricional.propriedade.id})">{{pedidonutricional.propriedade.nomepropriedade}}</a></td><td><a ui-sref="safra-detail({id:pedidonutricional.safra.id})">{{pedidonutricional.safra.nomesafra}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="pedidonutricional-detail({id:pedidonutricional.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="pedidonutricional.edit({id:pedidonutricional.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="pedidonutricional.delete({id:pedidonutricional.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/pessoa/pessoa-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.pessoa.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.pessoa.delete.question" translate-values="{id: \'{{vm.pessoa.id}}\'}">Are you sure you want to delete this Pessoa?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/pessoa/pessoa-detail.html','<div><h2><span data-translate="netWordAgroApp.pessoa.detail.title">Pessoa</span> {{vm.pessoa.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.pessoa.nome">Nome</span></dt><dd><span>{{vm.pessoa.nome}}</span></dd><dt><span data-translate="netWordAgroApp.pessoa.sobrenome">Sobrenome</span></dt><dd><span>{{vm.pessoa.sobrenome}}</span></dd><dt><span data-translate="netWordAgroApp.pessoa.cpf">Cpf</span></dt><dd><span>{{vm.pessoa.cpf}}</span></dd><dt><span data-translate="netWordAgroApp.pessoa.cargo">Cargo</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipocargo.\' + vm.pessoa.cargo}}">{{vm.pessoa.cargo}}</span></dd><dt><span data-translate="netWordAgroApp.pessoa.email">Email</span></dt><dd><span>{{vm.pessoa.email}}</span></dd><dt><span data-translate="netWordAgroApp.pessoa.foto">Foto</span></dt><dd><div ng-if="vm.pessoa.foto"><a ng-click="vm.openFile(vm.pessoa.fotoContentType, vm.pessoa.foto)"><img data-ng-src="{{\'data:\' + vm.pessoa.fotoContentType + \';base64,\' + vm.pessoa.foto}}" style="max-width: 100%" alt="pessoa image"> </a>{{vm.pessoa.fotoContentType}}, {{vm.byteSize(vm.pessoa.foto)}}</div></dd><dt><span data-translate="netWordAgroApp.pessoa.login">Login</span></dt><dd><span>{{vm.pessoa.login}}</span></dd><dt><span data-translate="netWordAgroApp.pessoa.propriedade">Propriedade</span></dt><dd><a ui-sref="propriedade-detail({id:vm.pessoa.propriedade.id})">{{vm.pessoa.propriedade.nomepropriedade}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="pessoa-detail.edit({id:vm.pessoa.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/pessoa/pessoa-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPessoaLabel" data-translate="netWordAgroApp.pessoa.home.createOrEditLabel">Create or edit a Pessoa</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.pessoa.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.pessoa.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pessoa.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.pessoa.nome" required><div ng-show="editForm.nome.$invalid"><p class="help-block" ng-show="editForm.nome.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pessoa.sobrenome" for="field_sobrenome">Sobrenome</label><input type="text" class="form-control" name="sobrenome" id="field_sobrenome" ng-model="vm.pessoa.sobrenome" required><div ng-show="editForm.sobrenome.$invalid"><p class="help-block" ng-show="editForm.sobrenome.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pessoa.telefone" for="field_telefone">Telefone</label><input type="text" class="form-control" name="telefone" id="field_telefone" ng-model="vm.pessoa.telefone" required><div ng-show="editForm.sobrenome.$invalid"><p class="help-block" ng-show="editForm.sobrenome.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pessoa.cpf" for="field_cpf">Cpf</label><input type="text" class="form-control" name="cpf" id="field_cpf" ng-model="vm.pessoa.cpf" required><div ng-show="editForm.cpf.$invalid"><p class="help-block" ng-show="editForm.cpf.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pessoa.cargo" for="field_cargo">Cargo</label><select class="form-control" name="cargo" ng-model="vm.pessoa.cargo" id="field_cargo" required><option value="proprietario" data-translate="netWordAgroApp.Tipocargo.proprietario">proprietario</option><option value="engagronomo" data-translate="netWordAgroApp.Tipocargo.engagronomo">engagronomo</option><option value="funcadmin" data-translate="netWordAgroApp.Tipocargo.funcadmin">funcadmin</option><option value="funcoperac" data-translate="netWordAgroApp.Tipocargo.funcoperac">funcoperac</option><option value="cooperado" data-translate="netWordAgroApp.Tipocargo.cooperado">funcadmin</option><!--<option value="gestor" data-translate="netWordAgroApp.Tipocargo.gestor">funcoperac</option>--><option value="tecnicocampo" data-translate="netWordAgroApp.Tipocargo.tecnicocampo">tecnicocampo</option><option value="gestorparceiro" data-translate="netWordAgroApp.Tipocargo.gestorparceiro">gestorparceiro</option></select><div ng-show="editForm.cargo.$invalid"><p class="help-block" ng-show="editForm.cargo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pessoa.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.pessoa.email" required><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setFoto($file, vm.pessoa)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="netWordAgroApp.pessoa.foto" for="field_foto">Foto</label><div><img data-ng-src="{{\'data:\' + vm.pessoa.fotoContentType + \';base64,\' + vm.pessoa.foto}}" style="max-height: 100px" ng-if="vm.pessoa.foto" alt="pessoa image"><div ng-if="vm.pessoa.foto" class="help-block clearfix"><span class="pull-left">{{vm.pessoa.fotoContentType}}, {{vm.byteSize(vm.pessoa.foto)}}</span> <button type="button" ng-click="vm.pessoa.foto=null;vm.pessoa.fotoContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setFoto($file, vm.pessoa)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="foto" id="field_foto" ng-model="vm.pessoa.foto"> <input type="hidden" class="form-control" name="fotoContentType" id="field_fotoContentType" ng-model="vm.pessoa.fotoContentType"></div><div class="form-group" ng-hide="vm.pessoa.cargo==\'cooperado\'"><label class="control-label" data-translate="netWordAgroApp.pessoa.login" for="field_login">Login</label><input type="text" class="form-control" name="login" id="field_login" ng-model="vm.pessoa.login" required></div><!--\n \t\t<div class="form-group">\n            <label data-translate="netWordAgroApp.pessoa.cooperativa" for="field_cooperativa">Cooperativa</label>\n            <select class="form-control" id="field_cooperativa" name="cooperativa" ng-model="vm.cooperativa" ng-change="vm.changeCooperativa()">\n                <option></option>\n                <option\n\t\t\t            ng-repeat="cooperativa in vm.cooperativas"\n\t\t\t            value="{{cooperativa.id}}">\n\t\t\t      \t\t{{cooperativa.nome}}\n\t\t\t    </option>\n            </select>\n        </div>--><div class="form-group"><label data-translate="netWordAgroApp.pessoa.unidade" for="field_cooperativa">Unidade</label><select class="form-control" id="field_unidade" name="unidade" ng-model="vm.pessoa.unidade" ng-change="vm.changeUnidade()" required><option></option><option ng-repeat="unidade in vm.unidades" value="{{unidade.id}}">{{unidade.nome}}</option></select><div ng-show="editForm.unidade.$invalid"><p class="help-block" ng-show="editForm.unidade.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><!--\n        <div class="form-group">\n            <label data-translate="netWordAgroApp.pessoa.propriedade" for="field_propriedade">Propriedade</label>\n            <select class="form-control" id="field_propriedade" name="propriedade" ng-model="vm.pessoa.propriedade" ng-options="propriedade as propriedade.nomepropriedade for propriedade in vm.propriedades track by propriedade.id" required multiple>\n            </select>\n        </div>\n--><div class="form-group"><label data-translate="netWordAgroApp.pessoa.propriedade" for="field_propriedade">Propriedade</label><br><div style="max-height: 300px; overflow: auto"><span ng-repeat="propriedade in vm.propriedades track by propriedade.id"><input type="checkbox" ng-change="vm.changeCheckbox(propriedade)" ng-model="vm.checkboxes[propriedade.id]"> {{propriedade.nomepropriedade}}<br></span></div></div><div ng-show="editForm.propriedade.$invalid"><p class="help-block" ng-show="editForm.propriedade.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/pessoa/pessoas.html','<div><h2 data-translate="netWordAgroApp.pessoa.home.title">Pessoas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="pessoa.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.pessoa.home.createLabel">Create new Pessoa</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.pessoa.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><div class="container-fluid" style="margin-top:10px"><div class="row"><div class="col-xs-4 no-padding-left"><form name="filtrar" class="form-inline"><label class="control-label" data-translate="netWordAgroApp.pessoa.filtrarporcargo" for="field_filtropropriedade">Tipomapa</label><select class="form-control" name="cargo" ng-model="vm.filtrocargo" id="field_cargo" ng-change="vm.changeFiltro()"><option value="proprietario" data-translate="netWordAgroApp.Tipocargo.proprietario">proprietario</option><option value="engagronomo" data-translate="netWordAgroApp.Tipocargo.engagronomo">engagronomo</option><option value="funcadmin" data-translate="netWordAgroApp.Tipocargo.funcadmin">funcadmin</option><option value="funcoperac" data-translate="netWordAgroApp.Tipocargo.funcoperac">funcoperac</option><option value="cooperado" data-translate="netWordAgroApp.Tipocargo.cooperado">funcadmin</option><!--<option value="gestor" data-translate="netWordAgroApp.Tipocargo.gestor">funcoperac</option>--><option value="tecnicocampo" data-translate="netWordAgroApp.Tipocargo.tecnicocampo">tecnicocampo</option><option value="gestorparceiro" data-translate="netWordAgroApp.Tipocargo.gestorparceiro">gestorparceiro</option></select></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.pessoa.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sobrenome"><span data-translate="netWordAgroApp.pessoa.sobrenome">Sobrenome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cpf"><span data-translate="netWordAgroApp.pessoa.cpf">Cpf</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cargo"><span data-translate="netWordAgroApp.pessoa.cargo">Cargo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="netWordAgroApp.pessoa.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="foto"><span data-translate="netWordAgroApp.pessoa.foto">Foto</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="netWordAgroApp.pessoa.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="pessoa in vm.pessoas track by pessoa.id"><td><a ui-sref="pessoa-detail({id:pessoa.id})">{{pessoa.id}}</a></td><td>{{pessoa.nome}}</td><td>{{pessoa.sobrenome}}</td><td>{{pessoa.cpf}}</td><td data-translate="{{\'netWordAgroApp.Tipocargo.\' + pessoa.cargo}}">{{pessoa.cargo}}</td><td>{{pessoa.email}}</td><td><a ng-if="pessoa.foto" ng-click="vm.openFile(pessoa.fotoContentType, pessoa.foto)"><img data-ng-src="{{\'data:\' + pessoa.fotoContentType + \';base64,\' + pessoa.foto}}" style="max-height: 30px" alt="pessoa image"> </a><span ng-if="pessoa.foto">{{pessoa.fotoContentType}}, {{vm.byteSize(pessoa.foto)}}</span></td><td>{{pessoa.login}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="pessoa-detail({id:pessoa.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="pessoa.edit({id:pessoa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="pessoa.delete({id:pessoa.id})" class="btn btn-danger btn-sm" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/pessoapropriedade/pessoapropriedade-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.pessoapropriedade.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.pessoapropriedade.delete.question" translate-values="{id: \'{{vm.pessoapropriedade.id}}\'}">Are you sure you want to delete this Pessoapropriedade?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/pessoapropriedade/pessoapropriedade-detail.html','<div><h2><span data-translate="netWordAgroApp.pessoapropriedade.detail.title">Pessoapropriedade</span> {{vm.pessoapropriedade.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.pessoapropriedade.pessoa">Pessoa</span></dt><dd><a ui-sref="pessoa-detail({id:vm.pessoapropriedade.pessoa.id})">{{vm.pessoapropriedade.pessoa.nome}}</a></dd><dt><span data-translate="netWordAgroApp.pessoapropriedade.propriedade">Propriedade</span></dt><dd><a ui-sref="propriedade-detail({id:vm.pessoapropriedade.propriedade.id})">{{vm.pessoapropriedade.propriedade.nomepropriedade}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="pessoapropriedade-detail.edit({id:vm.pessoapropriedade.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/pessoapropriedade/pessoapropriedade-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPessoapropriedadeLabel" data-translate="netWordAgroApp.pessoapropriedade.home.createOrEditLabel">Create or edit a Pessoapropriedade</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.pessoapropriedade.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.pessoapropriedade.id" readonly="readonly"></div><div class="form-group"><label data-translate="netWordAgroApp.pessoapropriedade.pessoa" for="field_pessoa">Pessoa</label><select class="form-control" id="field_pessoa" name="pessoa" ng-model="vm.pessoapropriedade.pessoa" ng-options="pessoa as pessoa.nome for pessoa in vm.pessoas track by pessoa.id" required></select></div><div ng-show="editForm.pessoa.$invalid"><p class="help-block" ng-show="editForm.pessoa.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.pessoapropriedade.propriedade" for="field_propriedade">Propriedade</label><select class="form-control" id="field_propriedade" name="propriedade" ng-model="vm.pessoapropriedade.propriedade" ng-options="propriedade as propriedade.nomepropriedade for propriedade in vm.propriedades track by propriedade.id" required></select></div><div ng-show="editForm.propriedade.$invalid"><p class="help-block" ng-show="editForm.propriedade.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/pessoapropriedade/pessoapropriedades.html','<div><h2 data-translate="netWordAgroApp.pessoapropriedade.home.title">Pessoapropriedades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="pessoapropriedade.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.pessoapropriedade.home.createLabel">Create new Pessoapropriedade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.pessoapropriedade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pessoa.nome"><span data-translate="netWordAgroApp.pessoapropriedade.pessoa">Pessoa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="propriedade.nomepropriedade"><span data-translate="netWordAgroApp.pessoapropriedade.propriedade">Propriedade</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="pessoapropriedade in vm.pessoapropriedades track by pessoapropriedade.id"><td><a ui-sref="pessoapropriedade-detail({id:pessoapropriedade.id})">{{pessoapropriedade.id}}</a></td><td><a ui-sref="pessoa-detail({id:pessoapropriedade.pessoa.id})">{{pessoapropriedade.pessoa.nome}}</a></td><td><a ui-sref="propriedade-detail({id:pessoapropriedade.propriedade.id})">{{pessoapropriedade.propriedade.nomepropriedade}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="pessoapropriedade-detail({id:pessoapropriedade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="pessoapropriedade.edit({id:pessoapropriedade.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="pessoapropriedade.delete({id:pessoapropriedade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/plantacao/plantacao-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.plantacao.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.plantacao.delete.question" translate-values="{id: \'{{vm.plantacao.id}}\'}">Are you sure you want to delete this Plantacao?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/plantacao/plantacao-detail.html','<div><h2><span data-translate="netWordAgroApp.plantacao.detail.title">Plantacao</span> {{vm.plantacao.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="plantacao-detail.edit({id:vm.plantacao.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/plantacao/plantacao-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPlantacaoLabel" data-translate="netWordAgroApp.plantacao.home.createOrEditLabel">Create or edit a Plantacao</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.plantacao.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.plantacao.id" readonly="readonly"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/plantacao/plantacaos.html','<div><h2 data-translate="netWordAgroApp.plantacao.home.title">Plantacaos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="plantacao.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.plantacao.home.createLabel">Create new Plantacao</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.plantacao.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="plantacao in vm.plantacaos track by plantacao.id"><td><a ui-sref="plantacao-detail({id:plantacao.id})">{{plantacao.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="plantacao-detail({id:plantacao.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="plantacao.edit({id:plantacao.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="plantacao.delete({id:plantacao.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/plantio/plantio-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.plantio.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.plantio.delete.question" translate-values="{id: \'{{vm.plantio.id}}\'}">Are you sure you want to delete this Plantio?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/plantio/plantio-detail.html','<div><h2><span data-translate="netWordAgroApp.plantio.detail.title">Plantio</span> {{vm.plantio.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.plantio.datainicio">Datainicio</span></dt><dd><span>{{vm.plantio.datainicio | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.plantio.datatermino">Datatermino</span></dt><dd><span>{{vm.plantio.datatermino | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.plantio.areaplantada">Areaplantada</span></dt><dd><span>{{vm.plantio.areaplantada}}</span></dd><dt><span data-translate="netWordAgroApp.plantio.descricaoplantio">Descricaoplantio</span></dt><dd><span>{{vm.plantio.descricaoplantio}}</span></dd><dt><span data-translate="netWordAgroApp.plantio.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.plantio.safra.id})">{{vm.plantio.safra.nomesafra}}</a></dd><dt><span data-translate="netWordAgroApp.plantio.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.plantio.etapa.id})">{{vm.plantio.etapa.nomeetapa}}</a></dd></dl><button type="submit" ui-sref="plantio" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="plantio-detail.edit({id:vm.plantio.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.plantio.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.plantio.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/plantio/plantio-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPlantioLabel" data-translate="netWordAgroApp.plantio.home.createOrEditLabel">Create or edit a Plantio</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.plantio.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.plantio.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.plantio.$invalid"><p class="help-block" ng-show="editForm.plantio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.plantio.datainicio" for="field_datainicio">Datainicio</label><div class="input-group"><input id="field_datainicio" type="text" class="form-control" name="datainicio" uib-datepicker-popup="{{dateformat}}" ng-model="vm.plantio.datainicio" is-open="vm.datePickerOpenStatus.datainicio" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datainicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datainicio.$invalid"><p class="help-block" ng-show="editForm.datainicio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.plantio.datatermino" for="field_datatermino">Datatermino</label><div class="input-group"><input id="field_datatermino" type="text" class="form-control" name="datatermino" uib-datepicker-popup="{{dateformat}}" ng-model="vm.plantio.datatermino" is-open="vm.datePickerOpenStatus.datatermino" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datatermino\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datatermino.$invalid"><p class="help-block" ng-show="editForm.datatermino.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.plantio.areaplantada" for="field_areaplantada">Areaplantada</label><input type="number" class="form-control" name="areaplantada" id="field_areaplantada" ng-model="vm.plantio.areaplantada" required min="0"><div ng-show="editForm.areaplantada.$invalid"><p class="help-block" ng-show="editForm.areaplantada.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.areaplantada.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.areaplantada.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.plantio.descricaoplantio" for="field_descricaoplantio">Descricaoplantio</label><input type="text" class="form-control" name="descricaoplantio" id="field_descricaoplantio" ng-model="vm.plantio.descricaoplantio" required><div ng-show="editForm.descricaoplantio.$invalid"><p class="help-block" ng-show="editForm.descricaoplantio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.plantio.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.plantio.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/plantio/plantios.html','<div><h2 data-translate="netWordAgroApp.plantio.home.title">Plantios</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="plantio.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.plantio.home.createLabel">Create new Plantio</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.plantio.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.plantio.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.plantio.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="areaplantada"><span data-translate="netWordAgroApp.plantio.areaplantada">Areaplantada</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricaoplantio"><span data-translate="netWordAgroApp.plantio.descricaoplantio">Descricaoplantio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.plantio.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="plantio in vm.plantios track by plantio.id"><td><a ui-sref="plantio-detail({id:plantio.id})">{{plantio.id}}</a></td><td>{{plantio.datainicio | date:\'mediumDate\'}}</td><td>{{plantio.datatermino | date:\'mediumDate\'}}</td><td>{{plantio.areaplantada}}</td><td>{{plantio.descricaoplantio}}</td><td><a ui-sref="etapa-detail({id:plantio.etapa.id})">{{plantio.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="plantio-detail({id:plantio.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="plantio.edit({id:plantio.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="plantio.delete({id:plantio.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/plantiotestem/plantiotestem-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.plantiotestem.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.plantiotestem.delete.question" translate-values="{id: \'{{vm.plantiotestem.id}}\'}">Are you sure you want to delete this Plantiotestem?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/plantiotestem/plantiotestem-detail.html','<div><h2><span data-translate="netWordAgroApp.plantiotestem.detail.title">Plantiotestem</span> {{vm.plantiotestem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.plantiotestem.datainicio">Datainicio</span></dt><dd><span>{{vm.plantiotestem.datainicio | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.plantiotestem.datafim">Datafim</span></dt><dd><span>{{vm.plantiotestem.datafim | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.plantiotestem.areaplantada">Areaplantada</span></dt><dd><span>{{vm.plantiotestem.areaplantada}}</span></dd><dt><span data-translate="netWordAgroApp.plantiotestem.descricaoplantio">Descricaoplantio</span></dt><dd><span>{{vm.plantiotestem.descricaoplantio}}</span></dd><dt><span data-translate="netWordAgroApp.plantiotestem.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.plantiotestem.etapa.id})">{{vm.plantiotestem.etapa.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="plantiotestem-detail.edit({id:vm.plantiotestem.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.plantiotestem.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.plantiotestem.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/plantiotestem/plantiotestem-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPlantioLabel" data-translate="netWordAgroApp.plantiotestem.home.createOrEditLabel">Create or edit a Plantio</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.plantiotestem.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.plantiotestem.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.plantiotestem.$invalid"><p class="help-block" ng-show="editForm.plantiotestem.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.plantiotestem.datainicio" for="field_datainicio">Datainicio</label><div class="input-group"><input id="field_datainicio" type="text" class="form-control" name="datainicio" uib-datepicker-popup="{{dateformat}}" ng-model="vm.plantiotestem.datainicio" is-open="vm.datePickerOpenStatus.datainicio" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datainicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datainicio.$invalid"><p class="help-block" ng-show="editForm.datainicio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.plantiotestem.datafim" for="field_datafim">datafim</label><div class="input-group"><input id="field_datafim" type="text" class="form-control" name="datafim" uib-datepicker-popup="{{dateformat}}" ng-model="vm.plantiotestem.datafim" is-open="vm.datePickerOpenStatus.datafim" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datafim\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datafim.$invalid"><p class="help-block" ng-show="editForm.datafim.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.plantiotestem.areaplantada" for="field_areaplantada">Areaplantada</label><input type="number" class="form-control" name="areaplantada" id="field_areaplantada" ng-model="vm.plantiotestem.areaplantada" required min="0"><div ng-show="editForm.areaplantada.$invalid"><p class="help-block" ng-show="editForm.areaplantada.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.areaplantada.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.areaplantada.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.plantiotestem.descricaoplantio" for="field_descricaoplantio">Descricaoplantio</label><input type="text" class="form-control" name="descricaoplantio" id="field_descricaoplantio" ng-model="vm.plantiotestem.descricaoplantio" required><div ng-show="editForm.descricaoplantio.$invalid"><p class="help-block" ng-show="editForm.descricaoplantio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.plantiotestem.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.plantiotestem.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/plantiotestem/plantiotestems.html','<div><h2 data-translate="netWordAgroApp.plantiotestem.home.title">Plantiotestems</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="plantiotestem.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.plantiotestem.home.createLabel">Create new Plantiotestem</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.plantiotestem.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.plantiotestem.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datafim"><span data-translate="netWordAgroApp.plantiotestem.datafim">Datafim</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="areaplantada"><span data-translate="netWordAgroApp.plantiotestem.areaplantada">Areaplantada</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricaoplantio"><span data-translate="netWordAgroApp.plantiotestem.descricaoplantio">Descricaoplantio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.id"><span data-translate="netWordAgroApp.plantiotestem.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="plantiotestem in vm.plantiotestems track by plantiotestem.id"><td><a ui-sref="plantiotestem-detail({id:plantiotestem.id})">{{plantiotestem.id}}</a></td><td>{{plantiotestem.datainicio | date:\'mediumDate\'}}</td><td>{{plantiotestem.datafim | date:\'mediumDate\'}}</td><td>{{plantiotestem.areaplantada}}</td><td>{{plantiotestem.descricaoplantio}}</td><td><a ui-sref="etapa-detail({id:plantiotestem.etapa.id})">{{plantiotestem.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="plantiotestem-detail({id:plantiotestem.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="plantiotestem.edit({id:plantiotestem.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="plantiotestem.delete({id:plantiotestem.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/plantioplan/plantioplan-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.plantioplan.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.plantioplan.delete.question" translate-values="{id: \'{{vm.plantioplan.id}}\'}">Are you sure you want to delete this Plantioplan?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/plantioplan/plantioplan-detail.html','<div><h2><span data-translate="netWordAgroApp.plantioplan.detail.title">Plantioplan</span> {{vm.plantioplan.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.plantioplan.datainicio">Datainicio</span></dt><dd><span>{{vm.plantioplan.datainicio | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.plantioplan.datatermino">Datatermino</span></dt><dd><span>{{vm.plantioplan.datatermino | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.plantioplan.areaplantada">Areaplantada</span></dt><dd><span>{{vm.plantioplan.areaplantada}}</span></dd><dt><span data-translate="netWordAgroApp.plantioplan.descricaoplantio">Descricaoplantio</span></dt><dd><span>{{vm.plantioplan.descricaoplantio}}</span></dd><dt><span data-translate="netWordAgroApp.plantioplan.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.plantioplan.safra.id})">{{vm.plantioplan.safra.nomesafra}}</a></dd><dt><span data-translate="netWordAgroApp.plantioplan.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.plantioplan.etapa.id})">{{vm.plantioplan.etapa.nomeetapa}}</a></dd></dl><button type="submit" ui-sref="plantioplan" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="plantioplan-detail.edit({id:vm.plantioplan.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.plantioplan.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.plantioplan.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/plantioplan/plantioplan-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPlantioplanLabel" data-translate="netWordAgroApp.plantioplan.home.createOrEditLabel">Create or edit a Plantioplan</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.plantioplan.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.plantioplan.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.plantioplan.$invalid"><p class="help-block" ng-show="editForm.plantioplan.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.plantioplan.datainicio" for="field_datainicio">Datainicio</label><div class="input-group"><input id="field_datainicio" type="text" class="form-control" name="datainicio" uib-datepicker-popup="{{dateformat}}" ng-model="vm.plantioplan.datainicio" is-open="vm.datePickerOpenStatus.datainicio" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datainicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datainicio.$invalid"><p class="help-block" ng-show="editForm.datainicio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.plantioplan.datatermino" for="field_datatermino">Datatermino</label><div class="input-group"><input id="field_datatermino" type="text" class="form-control" name="datatermino" uib-datepicker-popup="{{dateformat}}" ng-model="vm.plantioplan.datatermino" is-open="vm.datePickerOpenStatus.datatermino" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datatermino\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datatermino.$invalid"><p class="help-block" ng-show="editForm.datatermino.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.plantioplan.areaplantada" for="field_areaplantada">Areaplantada</label><input type="number" class="form-control" name="areaplantada" id="field_areaplantada" ng-model="vm.plantioplan.areaplantada" required min="0"><div ng-show="editForm.areaplantada.$invalid"><p class="help-block" ng-show="editForm.areaplantada.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.areaplantada.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.areaplantada.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.plantioplan.descricaoplantio" for="field_descricaoplantio">Descricaoplantio</label><input type="text" class="form-control" name="descricaoplantio" id="field_descricaoplantio" ng-model="vm.plantioplan.descricaoplantio" required><div ng-show="editForm.descricaoplantio.$invalid"><p class="help-block" ng-show="editForm.descricaoplantio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.plantioplan.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.plantioplan.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/plantioplan/plantioplans.html','<div><h2 data-translate="netWordAgroApp.plantioplan.home.title">Plantioplans</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="plantioplan.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.plantioplan.home.createLabel">Create new Plantioplan</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.plantioplan.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.plantioplan.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.plantioplan.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="areaplantada"><span data-translate="netWordAgroApp.plantioplan.areaplantada">Areaplantada</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricaoplantio"><span data-translate="netWordAgroApp.plantioplan.descricaoplantio">Descricaoplantio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.plantioplan.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="plantioplan in vm.plantioplans track by plantioplan.id"><td><a ui-sref="plantioplan-detail({id:plantioplan.id})">{{plantioplan.id}}</a></td><td>{{plantioplan.datainicio | date:\'mediumDate\'}}</td><td>{{plantioplan.datatermino | date:\'mediumDate\'}}</td><td>{{plantioplan.areaplantada}}</td><td>{{plantioplan.descricaoplantio}}</td><td><a ui-sref="etapa-detail({id:plantioplan.etapa.id})">{{plantioplan.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="plantioplan-detail({id:plantioplan.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="plantioplan.edit({id:plantioplan.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="plantioplan.delete({id:plantioplan.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/pontossensoriamentosolo/pontossensoriamentosolo-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.pontossensoriamentosolo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.pontossensoriamentosolo.delete.question" translate-values="{id: \'{{vm.pontossensoriamentosolo.id}}\'}">Are you sure you want to delete this Pontossensoriamentosolo?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/pontossensoriamentosolo/pontossensoriamentosolo-detail.html','<div><h2><span data-translate="netWordAgroApp.pontossensoriamentosolo.detail.title">Pontossensoriamentosolo</span> {{vm.pontossensoriamentosolo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.pontossensoriamentosolo.nomeponto">Nomeponto</span></dt><dd><span>{{vm.pontossensoriamentosolo.nomeponto}}</span></dd><dt><span data-translate="netWordAgroApp.pontossensoriamentosolo.vallatitude">Vallatitude</span></dt><dd><span>{{vm.pontossensoriamentosolo.vallatitude}}</span></dd><dt><span data-translate="netWordAgroApp.pontossensoriamentosolo.vallongitude">Vallongitude</span></dt><dd><span>{{vm.pontossensoriamentosolo.vallongitude}}</span></dd><dt><span data-translate="netWordAgroApp.pontossensoriamentosolo.sensorcolocado">Sensorcolocado</span></dt><dd><span>{{vm.pontossensoriamentosolo.sensorcolocado}}</span></dd><dt><span data-translate="netWordAgroApp.pontossensoriamentosolo.testeok">Testeok</span></dt><dd><span>{{vm.pontossensoriamentosolo.testeok}}</span></dd><dt><span data-translate="netWordAgroApp.pontossensoriamentosolo.quadrantesolo">Quadrantesolo</span></dt><dd><a ui-sref="quadrantesolo-detail({id:vm.pontossensoriamentosolo.quadrantesolo.id})">{{vm.pontossensoriamentosolo.quadrantesolo.nomequadrante}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="pontossensoriamentosolo-detail.edit({id:vm.pontossensoriamentosolo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/pontossensoriamentosolo/pontossensoriamentosolo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPontossensoriamentosoloLabel" data-translate="netWordAgroApp.pontossensoriamentosolo.home.createOrEditLabel">Create or edit a Pontossensoriamentosolo</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.pontossensoriamentosolo.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.pontossensoriamentosolo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pontossensoriamentosolo.nomeponto" for="field_nomeponto">Nomeponto</label><input type="text" class="form-control" name="nomeponto" id="field_nomeponto" ng-model="vm.pontossensoriamentosolo.nomeponto" required ng-maxlength="25"><div ng-show="editForm.nomeponto.$invalid"><p class="help-block" ng-show="editForm.nomeponto.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nomeponto.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="25">This field cannot be longer than 25 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pontossensoriamentosolo.vallatitude" for="field_vallatitude">Vallatitude</label><input type="text" class="form-control" name="vallatitude" id="field_vallatitude" ng-model="vm.pontossensoriamentosolo.vallatitude" required><div ng-show="editForm.vallatitude.$invalid"><p class="help-block" ng-show="editForm.vallatitude.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pontossensoriamentosolo.vallongitude" for="field_vallongitude">Vallongitude</label><input type="text" class="form-control" name="vallongitude" id="field_vallongitude" ng-model="vm.pontossensoriamentosolo.vallongitude" required><div ng-show="editForm.vallongitude.$invalid"><p class="help-block" ng-show="editForm.vallongitude.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pontossensoriamentosolo.sensorcolocado" for="field_sensorcolocado">Sensorcolocado</label><input type="checkbox" name="sensorcolocado" id="field_sensorcolocado" ng-model="vm.pontossensoriamentosolo.sensorcolocado"><div ng-show="editForm.sensorcolocado.$invalid"><p class="help-block" ng-show="editForm.sensorcolocado.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.pontossensoriamentosolo.testeok" for="field_testeok">Testeok</label><input type="checkbox" name="testeok" id="field_testeok" ng-model="vm.pontossensoriamentosolo.testeok"><div ng-show="editForm.testeok.$invalid"><p class="help-block" ng-show="editForm.testeok.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.pontossensoriamentosolo.quadrantesolo" for="field_quadrantesolo">Quadrantesolo</label><select class="form-control" id="field_quadrantesolo" name="quadrantesolo" ng-model="vm.pontossensoriamentosolo.quadrantesolo" ng-options="quadrantesolo as quadrantesolo.nomequadrante for quadrantesolo in vm.quadrantesolos track by quadrantesolo.id" required></select></div><div ng-show="editForm.quadrantesolo.$invalid"><p class="help-block" ng-show="editForm.quadrantesolo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/pontossensoriamentosolo/pontossensoriamentosolos.html','<div><h2 data-translate="netWordAgroApp.pontossensoriamentosolo.home.title">Pontossensoriamentosolos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="pontossensoriamentosolo.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.pontossensoriamentosolo.home.createLabel">Create new Pontossensoriamentosolo</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.pontossensoriamentosolo.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomeponto"><span data-translate="netWordAgroApp.pontossensoriamentosolo.nomeponto">Nomeponto</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="vallatitude"><span data-translate="netWordAgroApp.pontossensoriamentosolo.vallatitude">Vallatitude</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="vallongitude"><span data-translate="netWordAgroApp.pontossensoriamentosolo.vallongitude">Vallongitude</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sensorcolocado"><span data-translate="netWordAgroApp.pontossensoriamentosolo.sensorcolocado">Sensorcolocado</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="testeok"><span data-translate="netWordAgroApp.pontossensoriamentosolo.testeok">Testeok</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quadrantesolo.nomequadrante"><span data-translate="netWordAgroApp.pontossensoriamentosolo.quadrantesolo">Quadrantesolo</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="pontossensoriamentosolo in vm.pontossensoriamentosolos track by pontossensoriamentosolo.id"><td><a ui-sref="pontossensoriamentosolo-detail({id:pontossensoriamentosolo.id})">{{pontossensoriamentosolo.id}}</a></td><td>{{pontossensoriamentosolo.nomeponto}}</td><td>{{pontossensoriamentosolo.vallatitude}}</td><td>{{pontossensoriamentosolo.vallongitude}}</td><td>{{pontossensoriamentosolo.sensorcolocado}}</td><td>{{pontossensoriamentosolo.testeok}}</td><td><a ui-sref="quadrantesolo-detail({id:pontossensoriamentosolo.quadrantesolo.id})">{{pontossensoriamentosolo.quadrantesolo.nomequadrante}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="pontossensoriamentosolo-detail({id:pontossensoriamentosolo.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="pontossensoriamentosolo.edit({id:pontossensoriamentosolo.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="pontossensoriamentosolo.delete({id:pontossensoriamentosolo.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/preplantioplan/preplantioplan-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.preplantioplan.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.preplantioplan.delete.question" translate-values="{id: \'{{vm.preplantioplan.id}}\'}">Are you sure you want to delete this Preplantioplan?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/preplantioplan/preplantioplan-detail.html','<div><h2><span data-translate="netWordAgroApp.preplantioplan.detail.title">Preplantioplan</span> {{vm.preplantioplan.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.preplantioplan.datainicio">Datainicio</span></dt><dd><span>{{vm.preplantioplan.datainicio | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.preplantioplan.datatermino">Datatermino</span></dt><dd><span>{{vm.preplantioplan.datatermino | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.preplantioplan.descricaopreplantio">Descricaopreplantio</span></dt><dd><span>{{vm.preplantioplan.descricaopreplantio}}</span></dd><dt><span data-translate="netWordAgroApp.preplantioplan.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.preplantioplan.safra.id})">{{vm.preplantioplan.safra.nomesafra}}</a></dd><dt><span data-translate="netWordAgroApp.preplantioplan.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.preplantioplan.etapa.id})">{{vm.preplantioplan.etapa.nomeetapa}}</a></dd></dl><button type="submit" ui-sref="preplantioplan" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="preplantioplan-detail.edit({id:vm.preplantioplan.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.preplantioplan.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.preplantioplan.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/preplantioplan/preplantioplan-dialog.html','<script type="text/javascript">function EnviaEtapa(){\n    var x = {"nomeetapa" : "Scott", "safra":{"id": 3251}, "tipoetapa":\'preplantioplan\'};\n    var xhr = new XMLHttpRequest();\n    var url = "http://localhost:8080/api/etapas";\n    xhr.open("POST", url, true);\n    xhr.setRequestHeader("Content-type", "application/json");\n    var d = JSON.stringify(x);\n    console.log(d);\n    xhr.send(d);\n}</script><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPreplantioplanLabel" data-translate="netWordAgroApp.preplantioplan.home.createOrEditLabel">Create or edit a Preplantioplan</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.preplantioplan.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.preplantioplan.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.preplantioplan.$invalid"><p class="help-block" ng-show="editForm.preplantioplan.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.preplantioplan.datainicio" for="field_datainicio">Datainicio</label><div class="input-group"><input id="field_datainicio" type="text" class="form-control" name="datainicio" uib-datepicker-popup="{{dateformat}}" ng-model="vm.preplantioplan.datainicio" is-open="vm.datePickerOpenStatus.datainicio" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datainicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datainicio.$invalid"><p class="help-block" ng-show="editForm.datainicio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.preplantioplan.datatermino" for="field_datatermino">Datatermino</label><div class="input-group"><input id="field_datatermino" type="text" class="form-control" name="datatermino" uib-datepicker-popup="{{dateformat}}" ng-model="vm.preplantioplan.datatermino" is-open="vm.datePickerOpenStatus.datatermino" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datatermino\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datatermino.$invalid"><p class="help-block" ng-show="editForm.datatermino.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.preplantioplan.descricaopreplantio" for="field_descricaopreplantio">Descricaopreplantio</label><input type="text" class="form-control" name="descricaopreplantio" id="field_descricaopreplantio" ng-model="vm.preplantioplan.descricaopreplantio" required><div ng-show="editForm.descricaopreplantio.$invalid"><p class="help-block" ng-show="editForm.descricaopreplantio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.preplantioplan.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.preplantioplan.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div><!--\n        <div class="form-group">\n            <label data-translate="netWordAgroApp.preplantioplan.etapa" for="field_etapa">Etapa</label>\n            <select class="form-control" id="field_etapa" name="etapa" ng-model="vm.preplantioplan.etapa" ng-options="etapa as etapa.nomeetapa for etapa in vm.etapas track by etapa.id">\n                <option value=""></option>\n            </select>\n        </div>\n    --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" onclick="EnviaEtapa()" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/preplantioplan/preplantioplans.html','<div><h2 data-translate="netWordAgroApp.preplantioplan.home.title">Preplantioplans</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="preplantioplan.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.preplantioplan.home.createLabel">Create new Preplantioplan</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.preplantioplan.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.preplantioplan.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.preplantioplan.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricaopreplantio"><span data-translate="netWordAgroApp.preplantioplan.descricaopreplantio">Descricaopreplantio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.preplantioplan.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="preplantioplan in vm.preplantioplans track by preplantioplan.id"><td><a ui-sref="preplantioplan-detail({id:preplantioplan.id})">{{preplantioplan.id}}</a></td><td>{{preplantioplan.datainicio | date:\'mediumDate\'}}</td><td>{{preplantioplan.datatermino | date:\'mediumDate\'}}</td><td>{{preplantioplan.descricaopreplantio}}</td><td><a ui-sref="etapa-detail({id:preplantioplan.etapa.id})">{{preplantioplan.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="preplantioplan-detail({id:preplantioplan.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="preplantioplan.edit({id:preplantioplan.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="preplantioplan.delete({id:preplantioplan.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/preplantio/preplantio-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.preplantio.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.preplantio.delete.question" translate-values="{id: \'{{vm.preplantio.id}}\'}">Are you sure you want to delete this Preplantio?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/preplantio/preplantio-detail.html','<div><h2><span data-translate="netWordAgroApp.preplantio.detail.title">Preplantio</span> {{vm.preplantio.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.preplantio.datainicio">Datainicio</span></dt><dd><span>{{vm.preplantio.datainicio | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.preplantio.datatermino">Datatermino</span></dt><dd><span>{{vm.preplantio.datatermino | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.preplantio.descricaopreplantio">Descricaopreplantio</span></dt><dd><span>{{vm.preplantio.descricaopreplantio}}</span></dd><dt><span data-translate="netWordAgroApp.preplantio.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.preplantio.safra.id})">{{vm.preplantio.safra.nomesafra}}</a></dd><dt><span data-translate="netWordAgroApp.preplantio.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.preplantio.etapa.id})">{{vm.preplantio.etapa.nomeetapa}}</a></dd></dl><button type="submit" ui-sref="preplantio" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="preplantio-detail.edit({id:vm.preplantio.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.preplantio.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.preplantio.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/preplantio/preplantio-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPreplantioLabel" data-translate="netWordAgroApp.preplantio.home.createOrEditLabel">Create or edit a Preplantio</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.preplantio.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.preplantio.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.preplantio.$invalid"><p class="help-block" ng-show="editForm.preplantio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.preplantio.datainicio" for="field_datainicio">Datainicio</label><div class="input-group"><input id="field_datainicio" type="text" class="form-control" name="datainicio" uib-datepicker-popup="{{dateformat}}" ng-model="vm.preplantio.datainicio" is-open="vm.datePickerOpenStatus.datainicio" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datainicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datainicio.$invalid"><p class="help-block" ng-show="editForm.datainicio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.preplantio.datatermino" for="field_datatermino">Datatermino</label><div class="input-group"><input id="field_datatermino" type="text" class="form-control" name="datatermino" uib-datepicker-popup="{{dateformat}}" ng-model="vm.preplantio.datatermino" is-open="vm.datePickerOpenStatus.datatermino" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datatermino\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datatermino.$invalid"><p class="help-block" ng-show="editForm.datatermino.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.preplantio.descricaopreplantio" for="field_descricaopreplantio">Descricaopreplantio</label><input type="text" class="form-control" name="descricaopreplantio" id="field_descricaopreplantio" ng-model="vm.preplantio.descricaopreplantio" required><div ng-show="editForm.descricaopreplantio.$invalid"><p class="help-block" ng-show="editForm.descricaopreplantio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.preplantio.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.preplantio.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div><!--\n        <div class="form-group">\n            <label data-translate="netWordAgroApp.preplantio.etapa" for="field_etapa">Etapa</label>\n            <select class="form-control" id="field_etapa" name="etapa" ng-model="vm.preplantio.etapa" ng-options="etapa as etapa.nomeetapa for etapa in vm.etapas track by etapa.id">\n                <option value=""></option>\n            </select>\n        </div>\n    --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/preplantio/preplantios.html','<div><h2 data-translate="netWordAgroApp.preplantio.home.title">Preplantios</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="preplantio.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.preplantio.home.createLabel">Create new Preplantio</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.preplantio.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.preplantio.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.preplantio.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricaopreplantio"><span data-translate="netWordAgroApp.preplantio.descricaopreplantio">Descricaopreplantio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.preplantio.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="preplantio in vm.preplantios track by preplantio.id"><td><a ui-sref="preplantio-detail({id:preplantio.id})">{{preplantio.id}}</a></td><td>{{preplantio.datainicio | date:\'mediumDate\'}}</td><td>{{preplantio.datatermino | date:\'mediumDate\'}}</td><td>{{preplantio.descricaopreplantio}}</td><td><a ui-sref="etapa-detail({id:preplantio.etapa.id})">{{preplantio.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="preplantio-detail({id:preplantio.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="preplantio.edit({id:preplantio.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="preplantio.delete({id:preplantio.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/preplantiotestem/preplantiotestem-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.preplantiotestem.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.preplantiotestem.delete.question" translate-values="{id: \'{{vm.preplantiotestem.id}}\'}">Are you sure you want to delete this Preplantiotestem?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/preplantiotestem/preplantiotestem-detail.html','<div><h2><span data-translate="netWordAgroApp.preplantiotestem.detail.title">Preplantiotestem</span> {{vm.preplantiotestem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.preplantiotestem.datainicio">Datainicio</span></dt><dd><span>{{vm.preplantiotestem.datainicio | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.preplantiotestem.datafim">Datafim</span></dt><dd><span>{{vm.preplantiotestem.datafim | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.preplantiotestem.descricao">Descricao</span></dt><dd><span>{{vm.preplantiotestem.descricao}}</span></dd><dt><span data-translate="netWordAgroApp.preplantiotestem.etapa">Etapa</span></dt><dd><a ui-sref="etapa-detail({id:vm.preplantiotestem.etapa.id})">{{vm.preplantiotestem.etapa.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="preplantiotestem-detail.edit({id:vm.preplantiotestem.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.atividade.home.title">Atividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="atividade.new({idetapa:vm.preplantiotestem.etapa.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.atividade.home.createLabel">Create new Atividade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.atividade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.atividade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.atividade.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.atividade.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.atividade.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipolocal"><span data-translate="netWordAgroApp.atividade.tipolocal">Tipolocal</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.nomeetapa"><span data-translate="netWordAgroApp.atividade.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="localarmazenamento.nomelocal"><span data-translate="netWordAgroApp.atividade.localarmazenamento">Localarmazenamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td><a ui-sref="atividade-detail({id:atividade.id})">{{atividade.id}}</a></td><td>{{atividade.nome}}</td><td>{{atividade.descricao}}</td><td>{{atividade.datainicio | date:\'mediumDate\'}}</td><td>{{atividade.datatermino | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipolocal.\' + atividade.tipolocal}}">{{atividade.tipolocal}}</td><td><a ui-sref="etapa-detail({id:atividade.etapa.id})">{{atividade.etapa.nomeetapa}}</a></td><td><a ui-sref="localarmazenamento-detail({id:atividade.localarmazenamento.id})">{{atividade.localarmazenamento.nomelocal}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="atividade-detail({id:atividade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="atividade.edit({id:atividade.id,idetapa:vm.preplantiotestem.etapa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="atividade.delete({id:atividade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/preplantiotestem/preplantiotestem-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPreplantioLabel" data-translate="netWordAgroApp.preplantiotestem.home.createOrEditLabel">Create or edit a Preplantio</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.preplantiotestem.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.preplantiotestem.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.etapa.nomeetapa" for="field_nomeetapa">Nomeetapa</label><input type="text" class="form-control" name="nomeetapa" id="field_nomeetapa" ng-model="vm.etapa.nomeetapa" required><div ng-show="editForm.preplantiotestem.$invalid"><p class="help-block" ng-show="editForm.preplantiotestem.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.preplantiotestem.datainicio" for="field_datainicio">Datainicio</label><div class="input-group"><input id="field_datainicio" type="text" class="form-control" name="datainicio" uib-datepicker-popup="{{dateformat}}" ng-model="vm.preplantiotestem.datainicio" is-open="vm.datePickerOpenStatus.datainicio" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datainicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datainicio.$invalid"><p class="help-block" ng-show="editForm.datainicio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.preplantiotestem.datafim" for="field_datafim">datafim</label><div class="input-group"><input id="field_datafim" type="text" class="form-control" name="datafim" uib-datepicker-popup="{{dateformat}}" ng-model="vm.preplantiotestem.datafim" is-open="vm.datePickerOpenStatus.datafim" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datafim\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datafim.$invalid"><p class="help-block" ng-show="editForm.datafim.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.preplantiotestem.descricao" for="field_descricao">descricao</label><input type="text" class="form-control" name="descricao" id="field_descricao" ng-model="vm.preplantiotestem.descricao" required><div ng-show="editForm.descricao.$invalid"><p class="help-block" ng-show="editForm.descricao.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.preplantiotestem.safra" for="field_safra">Safra</label><select class="form-control" id="field_safra" name="safra" ng-model="vm.preplantiotestem.safra" ng-options="safra as safra.nomesafra for safra in vm.safras | orderBy:\'id\' track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div><!--\n        <div class="form-group">\n            <label data-translate="netWordAgroApp.preplantiotestem.etapa" for="field_etapa">Etapa</label>\n            <select class="form-control" id="field_etapa" name="etapa" ng-model="vm.preplantiotestem.etapa" ng-options="etapa as etapa.nomeetapa for etapa in vm.etapas track by etapa.id">\n                <option value=""></option>\n            </select>\n        </div>\n    --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/preplantiotestem/preplantiotestems.html','<div><h2 data-translate="netWordAgroApp.preplantiotestem.home.title">Preplantiotestems</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="preplantiotestem.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.preplantiotestem.home.createLabel">Create new Preplantiotestem</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.preplantiotestem.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.preplantiotestem.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datafim"><span data-translate="netWordAgroApp.preplantiotestem.datafim">Datafim</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.preplantiotestem.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etapa.id"><span data-translate="netWordAgroApp.preplantiotestem.etapa">Etapa</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="preplantiotestem in vm.preplantiotestems track by preplantiotestem.id"><td><a ui-sref="preplantiotestem-detail({id:preplantiotestem.id})">{{preplantiotestem.id}}</a></td><td>{{preplantiotestem.datainicio | date:\'mediumDate\'}}</td><td>{{preplantiotestem.datafim | date:\'mediumDate\'}}</td><td>{{preplantiotestem.descricao}}</td><td><a ui-sref="etapa-detail({id:preplantiotestem.etapa.id})">{{preplantiotestem.etapa.nomeetapa}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="preplantiotestem-detail({id:preplantiotestem.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="preplantiotestem.edit({id:preplantiotestem.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="preplantiotestem.delete({id:preplantiotestem.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/produto/produto-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.produto.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.produto.delete.question" translate-values="{id: \'{{vm.produto.id}}\'}">Are you sure you want to delete this Produto?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/produto/produto-detail.html','<div><h2><span data-translate="netWordAgroApp.produto.detail.title">Produto</span> {{vm.produto.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.produto.nomecomercial">Nomecomercial</span></dt><dd><span>{{vm.produto.nomecomercial}}</span></dd><dt><span data-translate="netWordAgroApp.produto.tipo">Tipo</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipoproduto.\' + vm.produto.tipo}}">{{vm.produto.tipo}}</span></dd><dt><span data-translate="netWordAgroApp.produto.principioativo">Principioativo</span></dt><dd><span>{{vm.produto.principioativo}}</span></dd><dt><span data-translate="netWordAgroApp.produto.doseminima">Doseminima</span></dt><dd><span>{{vm.produto.doseminima}}</span></dd><dt><span data-translate="netWordAgroApp.produto.dosemaxima">Dosemaxima</span></dt><dd><span>{{vm.produto.dosemaxima}}</span></dd><dt><span data-translate="netWordAgroApp.produto.eficaciapuro">Eficaciapuro</span></dt><dd><span>{{vm.produto.eficaciapuro}}</span></dd><dt><span data-translate="netWordAgroApp.produto.eficaciamisturado">Eficaciamisturado</span></dt><dd><span>{{vm.produto.eficaciamisturado}}</span></dd><dt><span data-translate="netWordAgroApp.produto.consistencia">Consistencia</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipoconsistencia.\' + vm.produto.consistencia}}">{{vm.produto.consistencia}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="produto-detail.edit({id:vm.produto.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/produto/produto-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProdutoLabel" data-translate="netWordAgroApp.produto.home.createOrEditLabel">Create or edit a Produto</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.produto.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.produto.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.produto.nomecomercial" for="field_nomecomercial">Nomecomercial</label><input type="text" class="form-control" name="nomecomercial" id="field_nomecomercial" ng-model="vm.produto.nomecomercial"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.produto.tipo" for="field_tipo">Tipo</label><select class="form-control" name="tipo" ng-model="vm.produto.tipo" id="field_tipo"><option value="fungicida" data-translate="netWordAgroApp.Tipoproduto.fungicida">fungicida</option><option value="herbicida" data-translate="netWordAgroApp.Tipoproduto.herbicida">herbicida</option><option value="inseticida" data-translate="netWordAgroApp.Tipoproduto.inseticida">inseticida</option><option value="adjuvante" data-translate="netWordAgroApp.Tipoproduto.adjuvante">complementar</option></select></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.produto.principioativo" for="field_principioativo">Principioativo</label><input type="text" class="form-control" name="principioativo" id="field_principioativo" ng-model="vm.produto.principioativo"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.produto.doseminima" for="field_doseminima">Doseminima</label><input type="text" class="form-control" name="doseminima" id="field_doseminima" ng-model="vm.produto.doseminima"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.produto.dosemaxima" for="field_dosemaxima">Dosemaxima</label><input type="text" class="form-control" name="dosemaxima" id="field_dosemaxima" ng-model="vm.produto.dosemaxima"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.produto.eficaciapuro" for="field_eficaciapuro">Eficaciapuro</label><input type="text" class="form-control" name="eficaciapuro" id="field_eficaciapuro" ng-model="vm.produto.eficaciapuro"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.produto.eficaciamisturado" for="field_eficaciamisturado">Eficaciamisturado</label><input type="text" class="form-control" name="eficaciamisturado" id="field_eficaciamisturado" ng-model="vm.produto.eficaciamisturado"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.produto.consistencia" for="field_consistencia">Consistencia</label><select class="form-control" name="consistencia" ng-model="vm.produto.consistencia" id="field_consistencia"><option value="liquido" data-translate="netWordAgroApp.Tipoconsistencia.liquido">liquido</option><option value="solido" data-translate="netWordAgroApp.Tipoconsistencia.solido">solido</option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/produto/produtos.html','<div><h2 data-translate="netWordAgroApp.produto.home.title">Produtos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="produto.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.produto.home.createLabel">Create new Produto</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.produto.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomecomercial"><span data-translate="netWordAgroApp.produto.nomecomercial">Nomecomercial</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipo"><span data-translate="netWordAgroApp.produto.tipo">Tipo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="principioativo"><span data-translate="netWordAgroApp.produto.principioativo">Principioativo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="doseminima"><span data-translate="netWordAgroApp.produto.doseminima">Doseminima</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dosemaxima"><span data-translate="netWordAgroApp.produto.dosemaxima">Dosemaxima</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="eficaciapuro"><span data-translate="netWordAgroApp.produto.eficaciapuro">Eficaciapuro</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="eficaciamisturado"><span data-translate="netWordAgroApp.produto.eficaciamisturado">Eficaciamisturado</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="consistencia"><span data-translate="netWordAgroApp.produto.consistencia">Consistencia</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="produto in vm.produtos track by produto.id"><td><a ui-sref="produto-detail({id:produto.id})">{{produto.id}}</a></td><td>{{produto.nomecomercial}}</td><td data-translate="{{\'netWordAgroApp.Tipoproduto.\' + produto.tipo}}">{{produto.tipo}}</td><td>{{produto.principioativo}}</td><td>{{produto.doseminima}}</td><td>{{produto.dosemaxima}}</td><td>{{produto.eficaciapuro}}</td><td>{{produto.eficaciamisturado}}</td><td data-translate="{{\'netWordAgroApp.Tipoconsistencia.\' + produto.consistencia}}">{{produto.consistencia}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="produto-detail({id:produto.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="produto.edit({id:produto.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="produto.delete({id:produto.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/propaganda/propaganda-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.propaganda.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.propaganda.delete.question" translate-values="{id: \'{{vm.propaganda.id}}\'}">Are you sure you want to delete this Propaganda?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/propaganda/propaganda-detail.html','<div><h2><span data-translate="netWordAgroApp.propaganda.detail.title">Propaganda</span> {{vm.propaganda.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.propaganda.datainicio">Datainicio</span></dt><dd><span>{{vm.propaganda.datainicio | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.propaganda.datatermino">Datatermino</span></dt><dd><span>{{vm.propaganda.datatermino | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.propaganda.valoranuncio">Valoranuncio</span></dt><dd><span>{{vm.propaganda.valoranuncio}}</span></dd><dt><span data-translate="netWordAgroApp.propaganda.banner">Banner</span></dt><dd><div ng-if="vm.propaganda.banner"><a ng-click="vm.openFile(vm.propaganda.bannerContentType, vm.propaganda.banner)"><img data-ng-src="{{\'data:\' + vm.propaganda.bannerContentType + \';base64,\' + vm.propaganda.banner}}" style="max-width: 100%" alt="propaganda image"> </a>{{vm.propaganda.bannerContentType}}, {{vm.byteSize(vm.propaganda.banner)}}</div></dd><dt><span data-translate="netWordAgroApp.propaganda.tipoanuncio">Tipoanuncio</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipoanuncio.\' + vm.propaganda.tipoanuncio}}">{{vm.propaganda.tipoanuncio}}</span></dd><dt><span data-translate="netWordAgroApp.propaganda.link">Link</span></dt><dd><span>{{vm.propaganda.link}}</span></dd><dt><span data-translate="netWordAgroApp.propaganda.direcionamento">Direcionamento</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipodirecionamento.\' + vm.propaganda.direcionamento}}">{{vm.propaganda.direcionamento}}</span></dd><dt><span data-translate="netWordAgroApp.propaganda.empresaparceira">Empresaparceira</span></dt><dd><a ui-sref="empresaparceira-detail({id:vm.propaganda.empresaparceira.id})">{{vm.propaganda.empresaparceira.nome}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="propaganda-detail.edit({id:vm.propaganda.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/propaganda/propaganda-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPropagandaLabel" data-translate="netWordAgroApp.propaganda.home.createOrEditLabel">Create or edit a Propaganda</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.propaganda.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.propaganda.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.propaganda.datainicio" for="field_datainicio">Datainicio</label><div class="input-group"><input id="field_datainicio" type="text" class="form-control" name="datainicio" uib-datepicker-popup="{{dateformat}}" ng-model="vm.propaganda.datainicio" is-open="vm.datePickerOpenStatus.datainicio" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datainicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datainicio.$invalid"><p class="help-block" ng-show="editForm.datainicio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.propaganda.datatermino" for="field_datatermino">Datatermino</label><div class="input-group"><input id="field_datatermino" type="text" class="form-control" name="datatermino" uib-datepicker-popup="{{dateformat}}" ng-model="vm.propaganda.datatermino" is-open="vm.datePickerOpenStatus.datatermino" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datatermino\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datatermino.$invalid"><p class="help-block" ng-show="editForm.datatermino.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.propaganda.valoranuncio" for="field_valoranuncio">Valoranuncio</label><input type="number" class="form-control" name="valoranuncio" id="field_valoranuncio" ng-model="vm.propaganda.valoranuncio" required min="0"><div ng-show="editForm.valoranuncio.$invalid"><p class="help-block" ng-show="editForm.valoranuncio.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.valoranuncio.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be at least 0.</p><p class="help-block" ng-show="editForm.valoranuncio.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setBanner($file, vm.propaganda)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="netWordAgroApp.propaganda.banner" for="field_banner">Banner</label><div><img data-ng-src="{{\'data:\' + vm.propaganda.bannerContentType + \';base64,\' + vm.propaganda.banner}}" style="max-height: 100px" ng-if="vm.propaganda.banner" alt="propaganda image"><div ng-if="vm.propaganda.banner" class="help-block clearfix"><span class="pull-left">{{vm.propaganda.bannerContentType}}, {{vm.byteSize(vm.propaganda.banner)}}</span> <button type="button" ng-click="vm.propaganda.banner=null;vm.propaganda.bannerContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setBanner($file, vm.propaganda)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="banner" id="field_banner" ng-model="vm.propaganda.banner" required> <input type="hidden" class="form-control" name="bannerContentType" id="field_bannerContentType" ng-model="vm.propaganda.bannerContentType"><div ng-show="editForm.banner.$invalid"><p class="help-block" ng-show="editForm.banner.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.propaganda.tipoanuncio" for="field_tipoanuncio">Tipoanuncio</label><select class="form-control" name="tipoanuncio" ng-model="vm.propaganda.tipoanuncio" id="field_tipoanuncio" required><option value="paginainicial" data-translate="netWordAgroApp.Tipoanuncio.paginainicial">paginainicial</option><option value="paginainterna" data-translate="netWordAgroApp.Tipoanuncio.paginainterna">paginainterna</option></select><div ng-show="editForm.tipoanuncio.$invalid"><p class="help-block" ng-show="editForm.tipoanuncio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.propaganda.link" for="field_link">Link</label><input type="text" class="form-control" name="link" id="field_link" ng-model="vm.propaganda.link"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.propaganda.direcionamento" for="field_direcionamento">Direcionamento</label><select class="form-control" name="direcionamento" ng-model="vm.propaganda.direcionamento" id="field_direcionamento" required><option value="mulher" data-translate="netWordAgroApp.Tipodirecionamento.mulher">mulher</option><option value="homem" data-translate="netWordAgroApp.Tipodirecionamento.homem">homem</option><option value="todos" data-translate="netWordAgroApp.Tipodirecionamento.todos">todos</option></select><div ng-show="editForm.direcionamento.$invalid"><p class="help-block" ng-show="editForm.direcionamento.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.propaganda.empresaparceira" for="field_empresaparceira">Empresaparceira</label><select class="form-control" id="field_empresaparceira" name="empresaparceira" ng-model="vm.propaganda.empresaparceira" ng-options="empresaparceira as empresaparceira.nome for empresaparceira in vm.empresaparceiras track by empresaparceira.id" required></select></div><div ng-show="editForm.empresaparceira.$invalid"><p class="help-block" ng-show="editForm.empresaparceira.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/propaganda/propagandas.html','<div><h2 data-translate="netWordAgroApp.propaganda.home.title">Propagandas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="propaganda.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.propaganda.home.createLabel">Create new Propaganda</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.propaganda.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datainicio"><span data-translate="netWordAgroApp.propaganda.datainicio">Datainicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datatermino"><span data-translate="netWordAgroApp.propaganda.datatermino">Datatermino</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valoranuncio"><span data-translate="netWordAgroApp.propaganda.valoranuncio">Valoranuncio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="banner"><span data-translate="netWordAgroApp.propaganda.banner">Banner</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipoanuncio"><span data-translate="netWordAgroApp.propaganda.tipoanuncio">Tipoanuncio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="link"><span data-translate="netWordAgroApp.propaganda.link">Link</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="direcionamento"><span data-translate="netWordAgroApp.propaganda.direcionamento">Direcionamento</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="empresaparceira.nome"><span data-translate="netWordAgroApp.propaganda.empresaparceira">Empresaparceira</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="propaganda in vm.propagandas track by propaganda.id"><td><a ui-sref="propaganda-detail({id:propaganda.id})">{{propaganda.id}}</a></td><td>{{propaganda.datainicio | date:\'mediumDate\'}}</td><td>{{propaganda.datatermino | date:\'mediumDate\'}}</td><td>{{propaganda.valoranuncio}}</td><td><a ng-if="propaganda.banner" ng-click="vm.openFile(propaganda.bannerContentType, propaganda.banner)"><img data-ng-src="{{\'data:\' + propaganda.bannerContentType + \';base64,\' + propaganda.banner}}" style="max-height: 30px" alt="propaganda image"> </a><span ng-if="propaganda.banner">{{propaganda.bannerContentType}}, {{vm.byteSize(propaganda.banner)}}</span></td><td data-translate="{{\'netWordAgroApp.Tipoanuncio.\' + propaganda.tipoanuncio}}">{{propaganda.tipoanuncio}}</td><td>{{propaganda.link}}</td><td data-translate="{{\'netWordAgroApp.Tipodirecionamento.\' + propaganda.direcionamento}}">{{propaganda.direcionamento}}</td><td><a ui-sref="empresaparceira-detail({id:propaganda.empresaparceira.id})">{{propaganda.empresaparceira.nome}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="propaganda-detail({id:propaganda.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="propaganda.edit({id:propaganda.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="propaganda.delete({id:propaganda.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/propriedade/propriedade-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.propriedade.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.propriedade.delete.question" translate-values="{id: \'{{vm.propriedade.id}}\'}">Are you sure you want to delete this Propriedade?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/propriedade/propriedade-detail.html','<div><h2><span data-translate="netWordAgroApp.propriedade.detail.title">Propriedade</span> {{vm.propriedade.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.propriedade.nomepropriedade">Nomepropriedade</span></dt><dd><span>{{vm.propriedade.nomepropriedade}}</span></dd><dt><span data-translate="netWordAgroApp.propriedade.tamanhopropriedade">Tamanhopropriedade</span></dt><dd><span>{{vm.propriedade.tamanhopropriedade}}</span></dd><dt><span data-translate="netWordAgroApp.propriedade.imagempropriedade">Imagempropriedade</span></dt><dd><div ng-if="vm.propriedade.imagempropriedade"><a ng-click="vm.openFile(vm.propriedade.imagempropriedadeContentType, vm.propriedade.imagempropriedade)"><img data-ng-src="{{\'data:\' + vm.propriedade.imagempropriedadeContentType + \';base64,\' + vm.propriedade.imagempropriedade}}" style="max-width: 100%" alt="propriedade image"> </a>{{vm.propriedade.imagempropriedadeContentType}}, {{vm.byteSize(vm.propriedade.imagempropriedade)}}</div></dd><dt><span data-translate="netWordAgroApp.propriedade.maiorlatitude">Maiorlatitude</span></dt><dd><span>{{vm.propriedade.maiorlatitude}}</span></dd><dt><span data-translate="netWordAgroApp.propriedade.maiorlongitude">Maiorlongitude</span></dt><dd><span>{{vm.propriedade.maiorlongitude}}</span></dd><dt><span data-translate="netWordAgroApp.propriedade.menorlatitude">Menorlatitude</span></dt><dd><span>{{vm.propriedade.menorlatitude}}</span></dd><dt><span data-translate="netWordAgroApp.propriedade.menorlongitude">Menorlongitude</span></dt><dd><span>{{vm.propriedade.menorlongitude}}</span></dd><dt><span data-translate="netWordAgroApp.propriedade.regressao">Regressao</span></dt><dd><div ng-if="vm.propriedade.regressao"><a ng-click="vm.openFile(vm.propriedade.regressaoContentType, vm.propriedade.regressao)" data-translate="entity.action.open">open</a> {{vm.propriedade.regressaoContentType}}, {{vm.byteSize(vm.propriedade.regressao)}}</div></dd><dt><span data-translate="netWordAgroApp.propriedade.distribuicao">Distribuicao</span></dt><dd><div ng-if="vm.propriedade.distribuicao"><a ng-click="vm.openFile(vm.propriedade.distribuicaoContentType, vm.propriedade.distribuicao)" data-translate="entity.action.open">open</a> {{vm.propriedade.distribuicaoContentType}}, {{vm.byteSize(vm.propriedade.distribuicao)}}</div></dd><dt><span data-translate="netWordAgroApp.propriedade.cidade">Cidade</span></dt><dd><a ui-sref="cidade-detail({id:vm.propriedade.cidade.id})">{{vm.propriedade.cidade.nomecidade}}</a></dd><dt><span data-translate="netWordAgroApp.propriedade.cooperativa">Cooperativa</span></dt><dd><a ui-sref="cooperativa-detail({id:vm.propriedade.cooperativa.id})">{{vm.propriedade.cooperativa.nome}}</a></dd><dt><span data-translate="netWordAgroApp.propriedade.fazenda">Fazenda</span></dt><dd><a ui-sref="fazenda-detail({id:vm.propriedade.fazenda.id})">{{vm.propriedade.fazenda.nome}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="propriedade-detail.edit({id:vm.propriedade.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/propriedade/propriedade-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPropriedadeLabel" data-translate="netWordAgroApp.propriedade.home.createOrEditLabel">Create or edit a Propriedade</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.propriedade.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.propriedade.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.propriedade.nomepropriedade" for="field_nomepropriedade">Nomepropriedade</label><input type="text" class="form-control" name="nomepropriedade" id="field_nomepropriedade" ng-model="vm.propriedade.nomepropriedade" required ng-maxlength="50"><div ng-show="editForm.nomepropriedade.$invalid"><p class="help-block" ng-show="editForm.nomepropriedade.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nomepropriedade.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.propriedade.tamanhopropriedade" for="field_tamanhopropriedade">Tamanhopropriedade</label><input type="number" class="form-control" name="tamanhopropriedade" id="field_tamanhopropriedade" ng-model="vm.propriedade.tamanhopropriedade" required><div ng-show="editForm.tamanhopropriedade.$invalid"><p class="help-block" ng-show="editForm.tamanhopropriedade.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.tamanhopropriedade.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setImagempropriedade($file, vm.propriedade)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="netWordAgroApp.propriedade.imagempropriedade" for="field_imagempropriedade">Imagempropriedade</label><div><img data-ng-src="{{\'data:\' + vm.propriedade.imagempropriedadeContentType + \';base64,\' + vm.propriedade.imagempropriedade}}" style="max-height: 100px" ng-if="vm.propriedade.imagempropriedade" alt="propriedade image"><div ng-if="vm.propriedade.imagempropriedade" class="help-block clearfix"><span class="pull-left">{{vm.propriedade.imagempropriedadeContentType}}, {{vm.byteSize(vm.propriedade.imagempropriedade)}}</span> <button type="button" ng-click="vm.propriedade.imagempropriedade=null;vm.propriedade.imagempropriedadeContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setImagempropriedade($file, vm.propriedade)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="imagempropriedade" id="field_imagempropriedade" ng-model="vm.propriedade.imagempropriedade"> <input type="hidden" class="form-control" name="imagempropriedadeContentType" id="field_imagempropriedadeContentType" ng-model="vm.propriedade.imagempropriedadeContentType"><div ng-show="editForm.imagempropriedade.$invalid"><p class="help-block" ng-show="editForm.imagempropriedade.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.propriedade.maiorlatitude" for="field_maiorlatitude">Maiorlatitude</label><input type="text" class="form-control" name="maiorlatitude" id="field_maiorlatitude" ng-model="vm.propriedade.maiorlatitude"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.propriedade.maiorlongitude" for="field_maiorlongitude">Maiorlongitude</label><input type="text" class="form-control" name="maiorlongitude" id="field_maiorlongitude" ng-model="vm.propriedade.maiorlongitude"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.propriedade.menorlatitude" for="field_menorlatitude">Menorlatitude</label><input type="text" class="form-control" name="menorlatitude" id="field_menorlatitude" ng-model="vm.propriedade.menorlatitude"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.propriedade.menorlongitude" for="field_menorlongitude">Menorlongitude</label><input type="text" class="form-control" name="menorlongitude" id="field_menorlongitude" ng-model="vm.propriedade.menorlongitude"></div><div class="form-group" ngf-drop ngf-change="vm.setRegressao($file, vm.propriedade)"><label class="control-label" data-translate="netWordAgroApp.propriedade.regressao" for="field_regressao">Regressao</label><div><div ng-if="vm.propriedade.regressao" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.propriedade.regressaoContentType, vm.propriedade.regressao)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.propriedade.regressaoContentType}}, {{vm.byteSize(vm.propriedade.regressao)}}</span> <button type="button" ng-click="vm.propriedade.regressao=null;vm.propriedade.regressaoContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setRegressao($file, vm.propriedade)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="regressao" id="field_regressao" ng-model="vm.propriedade.regressao"> <input type="hidden" class="form-control" name="regressaoContentType" id="field_regressaoContentType" ng-model="vm.propriedade.regressaoContentType"></div><div class="form-group" ngf-drop ngf-change="vm.setDistribuicao($file, vm.propriedade)"><label class="control-label" data-translate="netWordAgroApp.propriedade.distribuicao" for="field_distribuicao">Distribuicao</label><div><div ng-if="vm.propriedade.distribuicao" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.propriedade.distribuicaoContentType, vm.propriedade.distribuicao)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.propriedade.distribuicaoContentType}}, {{vm.byteSize(vm.propriedade.distribuicao)}}</span> <button type="button" ng-click="vm.propriedade.distribuicao=null;vm.propriedade.distribuicaoContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setDistribuicao($file, vm.propriedade)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="distribuicao" id="field_distribuicao" ng-model="vm.propriedade.distribuicao"> <input type="hidden" class="form-control" name="distribuicaoContentType" id="field_distribuicaoContentType" ng-model="vm.propriedade.distribuicaoContentType"></div><div class="form-group" ngf-drop ngf-change="vm.setBorda($file, vm.propriedade)"><label class="control-label" data-translate="netWordAgroApp.propriedade.borda" for="field_borda">borda</label><div><div ng-if="vm.propriedade.borda" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.propriedade.bordaContentType, vm.propriedade.borda)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.propriedade.bordaContentType}}, {{vm.byteSize(vm.propriedade.borda)}}</span> <button type="button" ng-click="vm.propriedade.borda=null;vm.propriedade.bordaContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setBorda($file, vm.propriedade)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="borda" id="field_borda" ng-model="vm.propriedade.borda"> <input type="hidden" class="form-control" name="bordaContentType" id="field_bordaContentType" ng-model="vm.propriedade.bordaContentType"></div><div class="form-group" ngf-drop ngf-change="vm.setKML($file, vm.propriedade)"><label class="control-label" data-translate="netWordAgroApp.propriedade.kml" for="field_kml">kml</label><div><div ng-if="vm.propriedade.kml" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.propriedade.kmlContentType, vm.propriedade.kml)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.propriedade.kmlContentType}}, {{vm.byteSize(vm.propriedade.kml)}}</span> <button type="button" ng-click="vm.propriedade.kml=null;vm.propriedade.kmlContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setKML($file, vm.propriedade)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="kml" id="field_kml" ng-model="vm.propriedade.kml"> <input type="hidden" class="form-control" name="kmlContentType" id="field_kmlContentType" ng-model="vm.propriedade.kmlContentType"></div><!--\n        <div ng-show="editForm.pesquisa.$invalid">\n            <p class="help-block"\n                ng-show="editForm.pesquisa.$error.required" data-translate="entity.validation.required">\n                This field is required.\n            </p>\n        </div>\n        <div ng-show="editForm.cidade.$invalid">\n            <p class="help-block"\n                ng-show="editForm.cidade.$error.required" data-translate="entity.validation.required">\n                This field is required.\n            </p>\n        </div>--><!--\n        <div class="form-group">\n            <label data-translate="netWordAgroApp.propriedade.cooperativa" for="field_cooperativa">Cooperativa</label>\n            <select class="form-control" id="field_cooperativa" name="cooperativa" ng-model="vm.propriedade.cooperativa" ng-options="cooperativa as cooperativa.nome for cooperativa in vm.cooperativas track by cooperativa.id">\n                <option value=""></option>\n            </select>\n        </div>--><div class="form-group"><label data-translate="netWordAgroApp.propriedade.fazenda" for="field_fazenda">Fazenda</label><select class="form-control" id="field_fazenda" name="fazenda" ng-model="vm.propriedade.fazenda" ng-options="fazenda as fazenda.nome for fazenda in vm.fazendas track by fazenda.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/propriedade/propriedades.html','<div><h2 data-translate="netWordAgroApp.propriedade.home.title">Propriedades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="propriedade.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.propriedade.home.createLabel">Create new Propriedade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.propriedade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomepropriedade"><span data-translate="netWordAgroApp.propriedade.nomepropriedade">Nomepropriedade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tamanhopropriedade"><span data-translate="netWordAgroApp.propriedade.tamanhopropriedade">Tamanhopropriedade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="imagempropriedade"><span data-translate="netWordAgroApp.propriedade.imagempropriedade">Imagempropriedade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="maiorlatitude"><span data-translate="netWordAgroApp.propriedade.maiorlatitude">Maiorlatitude</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="maiorlongitude"><span data-translate="netWordAgroApp.propriedade.maiorlongitude">Maiorlongitude</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="menorlatitude"><span data-translate="netWordAgroApp.propriedade.menorlatitude">Menorlatitude</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="menorlongitude"><span data-translate="netWordAgroApp.propriedade.menorlongitude">Menorlongitude</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="regressao"><span data-translate="netWordAgroApp.propriedade.regressao">Regressao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="regressao"><span data-translate="netWordAgroApp.propriedade.borda">Borda</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="distribuicao"><span data-translate="netWordAgroApp.propriedade.distribuicao">Distribuicao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fazenda.nome"><span data-translate="netWordAgroApp.propriedade.fazenda">Fazenda</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="propriedade.kml"><span data-translate="netWordAgroApp.propriedade.kml">KML</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="propriedade in vm.propriedades track by propriedade.id"><td><a ui-sref="propriedade-detail({id:propriedade.id})">{{propriedade.id}}</a></td><td>{{propriedade.nomepropriedade}}</td><td>{{propriedade.tamanhopropriedade}}</td><td><a ng-if="propriedade.imagempropriedade" ng-click="vm.openFile(propriedade.imagempropriedadeContentType, propriedade.imagempropriedade)"><img data-ng-src="{{\'data:\' + propriedade.imagempropriedadeContentType + \';base64,\' + propriedade.imagempropriedade}}" style="max-height: 30px" alt="propriedade image"> </a><span ng-if="propriedade.imagempropriedade">{{propriedade.imagempropriedadeContentType}}, {{vm.byteSize(propriedade.imagempropriedade)}}</span></td><td>{{propriedade.maiorlatitude}}</td><td>{{propriedade.maiorlongitude}}</td><td>{{propriedade.menorlatitude}}</td><td>{{propriedade.menorlongitude}}</td><td><a ng-if="propriedade.regressao" ng-click="vm.openFile(propriedade.regressaoContentType, propriedade.regressao)" data-translate="entity.action.open">open</a> <span ng-if="propriedade.regressao">{{propriedade.regressaoContentType}}, {{vm.byteSize(propriedade.regressao)}}</span></td><td><a ng-if="propriedade.borda" ng-click="vm.openFile(propriedade.bordaContentType, propriedade.borda)" data-translate="entity.action.open">open</a> <span ng-if="propriedade.regressao">{{propriedade.bordaContentType}}, {{vm.byteSize(propriedade.borda)}}</span></td><td><a ng-if="propriedade.distribuicao" ng-click="vm.openFile(propriedade.distribuicaoContentType, propriedade.distribuicao)" data-translate="entity.action.open">open</a> <span ng-if="propriedade.distribuicao">{{propriedade.distribuicaoContentType}}, {{vm.byteSize(propriedade.distribuicao)}}</span></td><td><a ui-sref="fazenda-detail({id:propriedade.fazenda.id})">{{propriedade.fazenda.nome}}</a></td><td><a ng-if="propriedade.kml" ng-click="vm.openFile(propriedade.kmlContentType, propriedade.kml)" data-translate="entity.action.open">open</a> <span ng-if="propriedade.kml">{{propriedade.kmlContentType}}, {{vm.byteSize(propriedade.kml)}}</span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="propriedade-detail({id:propriedade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="propriedade.edit({id:propriedade.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="propriedade.delete({id:propriedade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/propostareceituario/propostareceituario-aprovar-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.aprovacao(vm.propostareceituario.id)" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPropostareceituarioLabel" data-translate="netWordAgroApp.propostareceituario.aprovar.title">Aprovar</h4></div><div class="modal-body"><p data-translate="netWordAgroApp.propostareceituario.aprovar.pergunta">Aprovar?</p><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.receituario.diagnostico" for="field_diagnostico">Diagnostico</label><input type="text" class="form-control" name="diagnostico" id="field_diagnostico" ng-model="vm.receituario.diagnostico" required><div ng-show="editForm.diagnostico.$invalid"><p class="help-block" ng-show="editForm.diagnostico.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.receituario.produto" for="field_produto">Produto</label><input type="text" class="form-control" name="produto" id="field_produto" ng-model="vm.receituario.produto" required><div ng-show="editForm.produto.$invalid"><p class="help-block" ng-show="editForm.produto.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.receituario.quantidade" for="field_quantidade">Quantidade</label><input type="number" class="form-control" name="quantidade" id="field_quantidade" ng-model="vm.receituario.quantidade" required><div ng-show="editForm.quantidade.$invalid"><p class="help-block" ng-show="editForm.quantidade.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.quantidade.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.receituario.medidaquantidade" for="field_medidaquantidade">Medidaquantidade</label><select class="form-control" name="medidaquantidade" ng-model="vm.receituario.medidaquantidade" id="field_medidaquantidade" required><option value="ml" data-translate="netWordAgroApp.Tipomedidaquantidade.ml">ml</option><option value="l" data-translate="netWordAgroApp.Tipomedidaquantidade.l">l</option><option value="g" data-translate="netWordAgroApp.Tipomedidaquantidade.g">g</option><option value="kg" data-translate="netWordAgroApp.Tipomedidaquantidade.kg">kg</option></select><div ng-show="editForm.medidaquantidade.$invalid"><p class="help-block" ng-show="editForm.medidaquantidade.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.receituario.aplicacao" for="field_aplicacao">Aplicacao</label><input type="text" class="form-control" name="aplicacao" id="field_aplicacao" ng-model="vm.receituario.aplicacao" required><div ng-show="editForm.aplicacao.$invalid"><p class="help-block" ng-show="editForm.aplicacao.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.receituario.posaplicacao" for="field_posaplicacao">Posaplicacao</label><input type="text" class="form-control" name="posaplicacao" id="field_posaplicacao" ng-model="vm.receituario.posaplicacao" required><div ng-show="editForm.posaplicacao.$invalid"><p class="help-block" ng-show="editForm.posaplicacao.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.receituario.atividade" for="field_atividade">Atividade</label><select class="form-control" id="field_atividade" name="atividade" ng-model="vm.receituario.atividade" ng-options="atividade as atividade.nome for atividade in vm.atividades track by atividade.id" required></select></div><div ng-show="editForm.atividade.$invalid"><p class="help-block" ng-show="editForm.atividade.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="netWordAgroApp.propostareceituario.aprovar.cancelar">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-success"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span data-translate="netWordAgroApp.propostareceituario.aprovar.confirmar">Save</span></button></div></form>');
$templateCache.put('app/entities/propostareceituario/propostareceituario-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.propostareceituario.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.propostareceituario.delete.question" translate-values="{id: \'{{vm.propostareceituario.id}}\'}">Are you sure you want to delete this Propostareceituario?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/propostareceituario/propostareceituario-detail.html','<div><h2><span data-translate="netWordAgroApp.propostareceituario.detail.title">Propostareceituario</span> {{vm.propostareceituario.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.propostareceituario.nome">Nome</span></dt><dd><span>{{vm.propostareceituario.nome}}</span></dd><dt><span data-translate="netWordAgroApp.propostareceituario.data">Data</span></dt><dd><span>{{vm.propostareceituario.data | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.propostareceituario.latitude">Latitude</span></dt><dd><span>{{vm.propostareceituario.latitude}}</span></dd><dt><span data-translate="netWordAgroApp.propostareceituario.longitude">Longitude</span></dt><dd><span>{{vm.propostareceituario.longitude}}</span></dd><dt><span data-translate="netWordAgroApp.propostareceituario.quantidaderecomendada">Quantidaderecomendada</span></dt><dd><span>{{vm.propostareceituario.quantidaderecomendada}}</span></dd><dt><span data-translate="netWordAgroApp.propostareceituario.tipoproposta">Tipoproposta</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipoproposta.\' + vm.propostareceituario.tipoproposta}}">{{vm.propostareceituario.tipoproposta}}</span></dd><dt><span data-translate="netWordAgroApp.propostareceituario.propriedade">Propriedade</span></dt><dd><a ui-sref="propriedade-detail({id:vm.propostareceituario.propriedade.id})">{{vm.propostareceituario.propriedade.nomepropriedade}}</a></dd><dt><span data-translate="netWordAgroApp.propostareceituario.safra">Safra</span></dt><dd><a ui-sref="safra-detail({id:vm.propostareceituario.safra.id})">{{vm.propostareceituario.safra.nomesafra}}</a></dd><dt><span data-translate="netWordAgroApp.propostareceituario.atributo">Atributo</span></dt><dd><a ui-sref="atributo-detail({id:vm.propostareceituario.atributo.id})">{{vm.propostareceituario.atributo.nomeatributo}}</a></dd><dt><span data-translate="netWordAgroApp.propostareceituario.concentracaoidealatributo">Concentracaoidealatributo</span></dt><dd><a ui-sref="concentracaoidealatributo-detail({id:vm.propostareceituario.concentracaoidealatributo.id})">{{vm.propostareceituario.concentracaoidealatributo.valorconcentracaoatributo}}</a></dd><dt><span data-translate="netWordAgroApp.propostareceituario.concentracaoindice">Concentracaoindice</span></dt><dd><a ui-sref="concentracaoindice-detail({id:vm.propostareceituario.concentracaoindice.id})">{{vm.propostareceituario.concentracaoindice.nome}}</a></dd><dt><span data-translate="netWordAgroApp.propostareceituario.imagemtermica">Imagemtermica</span></dt><dd><a ui-sref="imagemtermica-detail({id:vm.propostareceituario.imagemtermica.id})">{{vm.propostareceituario.imagemtermica.nome}}</a></dd><dt><span data-translate="netWordAgroApp.propostareceituario.mapaimagem">Mapaimagem</span></dt><dd><a ui-sref="mapaimagem-detail({id:vm.propostareceituario.mapaimagem.id})">{{vm.propostareceituario.mapaimagem.nomemapa}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="propostareceituario-detail.edit({id:vm.propostareceituario.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/propostareceituario/propostareceituario-dialog.html','<style>select[readonly] {\n    background: #eee; /*Simular campo inativo - Sugest\xE3o @GabrielRodrigues*/\n    pointer-events: none;\n    touch-action: none;\n    }</style><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPropostareceituarioLabel" data-translate="netWordAgroApp.propostareceituario.home.createOrEditLabel">Create or edit a Propostareceituario</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.propostareceituario.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.propostareceituario.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.propostareceituario.ponto1" for="field_ponto1">Ponto 1</label><input readonly="readonly" type="text" class="form-control" name="ponto1" id="field_ponto1" ng-model="vm.propostareceituario.ponto1"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.propostareceituario.ponto2" for="field_ponto2">Ponto 2</label><input readonly="readonly" type="text" class="form-control" name="ponto2" id="field_ponto2" ng-model="vm.propostareceituario.ponto2"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.propostareceituario.ponto3" for="field_ponto3">Ponto 3</label><input readonly="readonly" type="text" class="form-control" name="ponto3" id="field_ponto3" ng-model="vm.propostareceituario.ponto3"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.propostareceituario.ponto4" for="field_ponto4">Ponto 4</label><input readonly="readonly" type="text" class="form-control" name="ponto4" id="field_ponto4" ng-model="vm.propostareceituario.ponto4"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.propostareceituario.valormedido" for="field_valormedido">Valormedido</label><input readonly="readonly" type="number" class="form-control" name="valormedido" id="field_valormedido" ng-model="vm.propostareceituario.valormedido"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.propostareceituario.necessidade" for="field_necessidade">Necessidade</label><input readonly="readonly" type="number" class="form-control" name="necessidade" id="field_necessidade" ng-model="vm.propostareceituario.necessidade"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.propostareceituario.necessidadeporconstante" for="field_necessidadeporconstante">Necessidadeporconstante</label><input readonly="readonly" type="number" class="form-control" name="necessidadeporconstante" id="field_necessidadeporconstante" ng-model="vm.propostareceituario.necessidadeporconstante"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.propostareceituario.necessidadekgha" for="field_necessidadekgha">Necessidadekgha</label><input readonly="readonly" type="number" class="form-control" name="necessidadekgha" id="field_necessidadekgha" ng-model="vm.propostareceituario.necessidadekgha"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.propostareceituario.quantidadesubstancia" for="field_quantidadesubstancia">Quantidadesubstancia</label><input type="number" class="form-control" name="quantidadesubstancia" id="field_quantidadesubstancia" ng-model="vm.propostareceituario.quantidadesubstancia"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.propostareceituario.identificacaoquadrante" for="field_identificacaoquadrante">Identificacaoquadrante</label><input readonly="readonly" type="number" class="form-control" name="identificacaoquadrante" id="field_identificacaoquadrante" ng-model="vm.propostareceituario.identificacaoquadrante"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.propostareceituario.areahectare" for="field_areahectare">Areahectare</label><input readonly="readonly" type="number" class="form-control" name="areahectare" id="field_areahectare" ng-model="vm.propostareceituario.areahectare"></div><div class="form-group"><label data-translate="netWordAgroApp.propostareceituario.propriedade" for="field_propriedade">Propriedade</label><select readonly="readonly" class="form-control" id="field_propriedade" name="propriedade" ng-model="vm.propostareceituario.propriedade" ng-options="propriedade as propriedade.nomepropriedade for propriedade in vm.propriedades track by propriedade.id" required></select></div><div ng-show="editForm.propriedade.$invalid"><p class="help-block" ng-show="editForm.propriedade.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.propostareceituario.safra" for="field_safra">Safra</label><select readonly="readonly" class="form-control" id="field_safra" name="safra" ng-model="vm.propostareceituario.safra" ng-options="safra as safra.nomesafra for safra in vm.safras track by safra.id" required></select></div><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.propostareceituario.atributo" for="field_atributo">Atributo</label><select readonly="readonly" class="form-control" id="field_atributo" name="atributo" ng-model="vm.propostareceituario.atributo" ng-options="atributo as atributo.nomeatributo for atributo in vm.atributos track by atributo.id"><option value=""></option></select></div><div class="form-group"><label data-translate="netWordAgroApp.propostareceituario.concentracaoidealatributo" for="field_concentracaoidealatributo">Concentracaoidealatributo</label><select readonly="readonly" class="form-control" id="field_concentracaoidealatributo" name="concentracaoidealatributo" ng-model="vm.propostareceituario.concentracaoidealatributo" ng-options="concentracaoidealatributo as concentracaoidealatributo.valorconcentracaoatributo for concentracaoidealatributo in vm.concentracaoidealatributos track by concentracaoidealatributo.id"><option value=""></option></select></div><div class="form-group"><label data-translate="netWordAgroApp.propostareceituario.concentracaoindice" for="field_concentracaoindice">Concentracaoindice</label><select readonly="readonly" class="form-control" id="field_concentracaoindice" name="concentracaoindice" ng-model="vm.propostareceituario.concentracaoindice" ng-options="concentracaoindice as concentracaoindice.nome for concentracaoindice in vm.concentracaoindices track by concentracaoindice.id"><option value=""></option></select></div><div class="form-group"><label data-translate="netWordAgroApp.propostareceituario.imagemtermica" for="field_imagemtermica">Imagemtermica</label><select readonly="readonly" class="form-control" id="field_imagemtermica" name="imagemtermica" ng-model="vm.propostareceituario.imagemtermica" ng-options="imagemtermica as imagemtermica.nome for imagemtermica in vm.imagemtermicas track by imagemtermica.id"><option value=""></option></select></div><div class="form-group"><label data-translate="netWordAgroApp.propostareceituario.mapaimagem" for="field_mapaimagem">Mapaimagem</label><select readonly="readonly" class="form-control" id="field_mapaimagem" name="mapaimagem" ng-model="vm.propostareceituario.mapaimagem" ng-options="mapaimagem as mapaimagem.nomemapa for mapaimagem in vm.mapaimagems track by mapaimagem.id" required></select></div><div ng-show="editForm.mapaimagem.$invalid"><p class="help-block" ng-show="editForm.mapaimagem.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/propostareceituario/propostareceituario-visualizacao.html','<style>* {box-sizing: border-box;}\n        \n        .img-zoom-container {\n          position: relative;\n          margin-left: 50px;\n        }\n        \n        .img-zoom-lens {\n          position: absolute;\n          border: 1px solid #d4d4d4;\n          \n          width: 20px;\n          height: 20px;\n        }\n        \n        .img-zoom-result {\n          position: relative;\n          border: 1px solid #d4d4d4;\n          float: right;\n          width: 400px;\n          height: 400px;\n          margin-right: 20px;\n          margin-top: 100px;\n        }\n\n        thead, tbody { display: block; }\n\n        tbody {\n            display: block;\n            float: left;\n            width: 100%;\n            height: 300px;       /* Just for the demo          */\n            overflow-y: auto;    /* Trigger vertical scroll    */\n        }\n\n        table{\n            table-layout: fixed;\n            width: 100%;\n        }\n        \n        tr{\n            display: block;\n            width: 100%;\n            float:left;\n        }\n\n        tbody td {\n            display: block;\n            float:left;\n            width: 9.9%; \n            overflow: auto;\n        }\n        thead th{\n            display: block;\n            float:left;\n            width: 9.7%;\n        }</style><div><h2 data-translate="netWordAgroApp.propostareceituario.home.title">Proposta</h2><div ng-if="vm.carregando"><h4>Aguarde, estamos carregando o seu mapa...</h4></div><center><div ng-show="!vm.carregando" class="img-zoom-container"><img id="myimage" src="{{vm.fileURL}}" width="600"></div></center><br><h4 class="alert alert-info" ng-show="!vm.carregando" ng-if="vm.propostas.length == 0">N\xE3o h\xE1 propostas associadas a esse mapa.</h4><table class="table table-striped" ng-show="!vm.carregando" ng-if="vm.propostas.length > 0"><thead><th><span data-translate="netWordAgroApp.propostareceituario.identificacaoquadrante"></span></th><th><span data-translate="netWordAgroApp.propostareceituario.ponto1">Ponto1</span></th><th><span data-translate="netWordAgroApp.propostareceituario.ponto2">Ponto2</span></th><th><span data-translate="netWordAgroApp.propostareceituario.ponto3">Ponto3</span></th><th><span data-translate="netWordAgroApp.propostareceituario.ponto4">Ponto4</span></th><th><span data-translate="netWordAgroApp.propostareceituario.valormedido">Valormedido</span></th><th><span data-translate="netWordAgroApp.propostareceituario.necessidadekgha">necessidadekgha</span></th><th><span data-translate="netWordAgroApp.propostareceituario.quantidadesubstancia">necessidadekgha</span></th><th><span data-translate="netWordAgroApp.propostareceituario.areahectare"></span></th><th></th></thead><div><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="propostareceituario in vm.propostas"><td>{{propostareceituario.identificacaoquadrante}}</td><td>{{propostareceituario.ponto1}}</td><td>{{propostareceituario.ponto2}}</td><td>{{propostareceituario.ponto3}}</td><td>{{propostareceituario.ponto4}}</td><td>{{propostareceituario.valormedido}}</td><td>{{propostareceituario.necessidadekgha}}</td><td>{{propostareceituario.quantidadesubstancia}}</td><td>{{propostareceituario.areahectare}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="propostareceituario.edit({idmapa: vm.idmapa, id:propostareceituario.id})" class="btn btn-primary btn-sm" has_authority="ROLE_ADMIN"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="propostareceituario.aprovar({idmapa: vm.idmapa, id:propostareceituario.id})" class="btn btn-success btn-sm"><span class="glyphicon glyphicon-ok"></span></button></div></td></tr></tbody></div></table><button type="submit" ui-sref="propostareceituario" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/entities/propostareceituario/propostareceituarios.html','<div><h3 data-translate="netWordAgroApp.propostareceituario.home.title">Mapaimagems</h3><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"></div><div class="col-xs-8 no-padding-right"></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomemapa"><span data-translate="netWordAgroApp.mapaimagem.nomemapa">Nomemapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="data"><span data-translate="netWordAgroApp.mapaimagem.data">Nomemapa</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="latitudecentro"><span data-translate="netWordAgroApp.mapaimagem.latitudecentro">Latitudecentro</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="longitudecentro"><span data-translate="netWordAgroApp.mapaimagem.longitudecentro">Longitudecentro</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="safra.nomesafra"><span data-translate="netWordAgroApp.mapaimagem.safra">Safra</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="propriedade.nomepropriedade"><span data-translate="netWordAgroApp.mapaimagem.propriedade">Propriedade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="atributo.nomeatributo"><span data-translate="netWordAgroApp.mapaimagem.atributo">Atributo</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="netWordAgroApp.mapaimagem.opcoes">Op\xE7\xF5es</span></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="mapaimagem in vm.mapaimagems track by mapaimagem.id"><td><a ui-sref="mapaimagem-detail({id:mapaimagem.id})">{{mapaimagem.id}}</a></td><td>{{mapaimagem.nomemapa}}</td><td>{{mapaimagem.data}}</td><td>{{mapaimagem.latitudecentro}}</td><td>{{mapaimagem.longitudecentro}}</td><td><a ui-sref="safra-detail({id:mapaimagem.safra_id})">{{mapaimagem.safra_nomesafra}}</a></td><td><a ui-sref="propriedade-detail({id:mapaimagem.propriedade_id})">{{mapaimagem.propriedade_nomepropriedade}}</a></td><td><a ui-sref="atributo-detail({id:mapaimagem.atributo_id})">{{mapaimagem.atributo_nomeatributo}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><!---<a ng-if="mapaimagem.imagem" ng-click="vm.openFile(mapaimagem.imagemContentType, mapaimagem.imagem)">--> <button ui-sref="propostareceituario-visualizacao({idmapa:mapaimagem.id})" class="btn btn-warning btn-sm"><span class="glyphicon glyphicon-file"></span> <span class="hidden-sm-down" data-translate="netWordAgroApp.mapaimagem.acessarprop">Acessar proposta</span></button> <span ng-if="mapaimagem.imagem">{{mapaimagem.imagemContentType}}, {{vm.byteSize(mapaimagem.imagem)}}</span></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/quadranteimagem/quadranteimagem-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.quadranteimagem.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.quadranteimagem.delete.question" translate-values="{id: \'{{vm.quadranteimagem.id}}\'}">Are you sure you want to delete this Quadranteimagem?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/quadranteimagem/quadranteimagem-detail.html','<div><h2><span data-translate="netWordAgroApp.quadranteimagem.detail.title">Quadranteimagem</span> {{vm.quadranteimagem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.quadranteimagem.nomequadrante">Nomequadrante</span></dt><dd><span>{{vm.quadranteimagem.nomequadrante}}</span></dd><dt><span data-translate="netWordAgroApp.quadranteimagem.valorlatitudep1">Valorlatitudep 1</span></dt><dd><span>{{vm.quadranteimagem.valorlatitudep1}}</span></dd><dt><span data-translate="netWordAgroApp.quadranteimagem.valorlongitudep1">Valorlongitudep 1</span></dt><dd><span>{{vm.quadranteimagem.valorlongitudep1}}</span></dd><dt><span data-translate="netWordAgroApp.quadranteimagem.valorlatitudep2">Valorlatitudep 2</span></dt><dd><span>{{vm.quadranteimagem.valorlatitudep2}}</span></dd><dt><span data-translate="netWordAgroApp.quadranteimagem.valorlongitudep2">Valorlongitudep 2</span></dt><dd><span>{{vm.quadranteimagem.valorlongitudep2}}</span></dd><dt><span data-translate="netWordAgroApp.quadranteimagem.valorlatitudep3">Valorlatitudep 3</span></dt><dd><span>{{vm.quadranteimagem.valorlatitudep3}}</span></dd><dt><span data-translate="netWordAgroApp.quadranteimagem.valorlongitudep3">Valorlongitudep 3</span></dt><dd><span>{{vm.quadranteimagem.valorlongitudep3}}</span></dd><dt><span data-translate="netWordAgroApp.quadranteimagem.valorlatitudep4">Valorlatitudep 4</span></dt><dd><span>{{vm.quadranteimagem.valorlatitudep4}}</span></dd><dt><span data-translate="netWordAgroApp.quadranteimagem.valorlongitudep4">Valorlongitudep 4</span></dt><dd><span>{{vm.quadranteimagem.valorlongitudep4}}</span></dd><dt><span data-translate="netWordAgroApp.quadranteimagem.camada">Camada</span></dt><dd><span>{{vm.quadranteimagem.camada}}</span></dd><dt><span data-translate="netWordAgroApp.quadranteimagem.matrizsensoriamento">Matrizsensoriamento</span></dt><dd><a ui-sref="matrizsensoriamento-detail({id:vm.quadranteimagem.matrizsensoriamento.id})">{{vm.quadranteimagem.matrizsensoriamento.nomematriz}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="quadranteimagem-detail.edit({id:vm.quadranteimagem.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/quadranteimagem/quadranteimagem-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myQuadranteimagemLabel" data-translate="netWordAgroApp.quadranteimagem.home.createOrEditLabel">Create or edit a Quadranteimagem</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.quadranteimagem.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.quadranteimagem.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.quadranteimagem.nomequadrante" for="field_nomequadrante">Nomequadrante</label><input type="text" class="form-control" name="nomequadrante" id="field_nomequadrante" ng-model="vm.quadranteimagem.nomequadrante" required><div ng-show="editForm.nomequadrante.$invalid"><p class="help-block" ng-show="editForm.nomequadrante.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.quadranteimagem.valorlatitudep1" for="field_valorlatitudep1">Valorlatitudep 1</label><input type="text" class="form-control" name="valorlatitudep1" id="field_valorlatitudep1" ng-model="vm.quadranteimagem.valorlatitudep1" required><div ng-show="editForm.valorlatitudep1.$invalid"><p class="help-block" ng-show="editForm.valorlatitudep1.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.quadranteimagem.valorlongitudep1" for="field_valorlongitudep1">Valorlongitudep 1</label><input type="text" class="form-control" name="valorlongitudep1" id="field_valorlongitudep1" ng-model="vm.quadranteimagem.valorlongitudep1" required><div ng-show="editForm.valorlongitudep1.$invalid"><p class="help-block" ng-show="editForm.valorlongitudep1.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.quadranteimagem.valorlatitudep2" for="field_valorlatitudep2">Valorlatitudep 2</label><input type="text" class="form-control" name="valorlatitudep2" id="field_valorlatitudep2" ng-model="vm.quadranteimagem.valorlatitudep2" required><div ng-show="editForm.valorlatitudep2.$invalid"><p class="help-block" ng-show="editForm.valorlatitudep2.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.quadranteimagem.valorlongitudep2" for="field_valorlongitudep2">Valorlongitudep 2</label><input type="text" class="form-control" name="valorlongitudep2" id="field_valorlongitudep2" ng-model="vm.quadranteimagem.valorlongitudep2" required><div ng-show="editForm.valorlongitudep2.$invalid"><p class="help-block" ng-show="editForm.valorlongitudep2.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.quadranteimagem.valorlatitudep3" for="field_valorlatitudep3">Valorlatitudep 3</label><input type="text" class="form-control" name="valorlatitudep3" id="field_valorlatitudep3" ng-model="vm.quadranteimagem.valorlatitudep3" required><div ng-show="editForm.valorlatitudep3.$invalid"><p class="help-block" ng-show="editForm.valorlatitudep3.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.quadranteimagem.valorlongitudep3" for="field_valorlongitudep3">Valorlongitudep 3</label><input type="text" class="form-control" name="valorlongitudep3" id="field_valorlongitudep3" ng-model="vm.quadranteimagem.valorlongitudep3" required><div ng-show="editForm.valorlongitudep3.$invalid"><p class="help-block" ng-show="editForm.valorlongitudep3.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.quadranteimagem.valorlatitudep4" for="field_valorlatitudep4">Valorlatitudep 4</label><input type="text" class="form-control" name="valorlatitudep4" id="field_valorlatitudep4" ng-model="vm.quadranteimagem.valorlatitudep4" required><div ng-show="editForm.valorlatitudep4.$invalid"><p class="help-block" ng-show="editForm.valorlatitudep4.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.quadranteimagem.valorlongitudep4" for="field_valorlongitudep4">Valorlongitudep 4</label><input type="text" class="form-control" name="valorlongitudep4" id="field_valorlongitudep4" ng-model="vm.quadranteimagem.valorlongitudep4" required><div ng-show="editForm.valorlongitudep4.$invalid"><p class="help-block" ng-show="editForm.valorlongitudep4.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.quadranteimagem.camada" for="field_camada">Camada</label><input type="number" class="form-control" name="camada" id="field_camada" ng-model="vm.quadranteimagem.camada" required><div ng-show="editForm.camada.$invalid"><p class="help-block" ng-show="editForm.camada.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.camada.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.quadranteimagem.matrizsensoriamento" for="field_matrizsensoriamento">Matrizsensoriamento</label><select class="form-control" id="field_matrizsensoriamento" name="matrizsensoriamento" ng-model="vm.quadranteimagem.matrizsensoriamento" ng-options="matrizsensoriamento as matrizsensoriamento.nomematriz for matrizsensoriamento in vm.matrizsensoriamentos track by matrizsensoriamento.id" required></select></div><div ng-show="editForm.matrizsensoriamento.$invalid"><p class="help-block" ng-show="editForm.matrizsensoriamento.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/quadranteimagem/quadranteimagems.html','<div><h2 data-translate="netWordAgroApp.quadranteimagem.home.title">Quadranteimagems</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="quadranteimagem.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.quadranteimagem.home.createLabel">Create new Quadranteimagem</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.quadranteimagem.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomequadrante"><span data-translate="netWordAgroApp.quadranteimagem.nomequadrante">Nomequadrante</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorlatitudep1"><span data-translate="netWordAgroApp.quadranteimagem.valorlatitudep1">Valorlatitudep 1</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorlongitudep1"><span data-translate="netWordAgroApp.quadranteimagem.valorlongitudep1">Valorlongitudep 1</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorlatitudep2"><span data-translate="netWordAgroApp.quadranteimagem.valorlatitudep2">Valorlatitudep 2</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorlongitudep2"><span data-translate="netWordAgroApp.quadranteimagem.valorlongitudep2">Valorlongitudep 2</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorlatitudep3"><span data-translate="netWordAgroApp.quadranteimagem.valorlatitudep3">Valorlatitudep 3</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorlongitudep3"><span data-translate="netWordAgroApp.quadranteimagem.valorlongitudep3">Valorlongitudep 3</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorlatitudep4"><span data-translate="netWordAgroApp.quadranteimagem.valorlatitudep4">Valorlatitudep 4</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorlongitudep4"><span data-translate="netWordAgroApp.quadranteimagem.valorlongitudep4">Valorlongitudep 4</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="camada"><span data-translate="netWordAgroApp.quadranteimagem.camada">Camada</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="matrizsensoriamento.nomematriz"><span data-translate="netWordAgroApp.quadranteimagem.matrizsensoriamento">Matrizsensoriamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="quadranteimagem in vm.quadranteimagems track by quadranteimagem.id"><td><a ui-sref="quadranteimagem-detail({id:quadranteimagem.id})">{{quadranteimagem.id}}</a></td><td>{{quadranteimagem.nomequadrante}}</td><td>{{quadranteimagem.valorlatitudep1}}</td><td>{{quadranteimagem.valorlongitudep1}}</td><td>{{quadranteimagem.valorlatitudep2}}</td><td>{{quadranteimagem.valorlongitudep2}}</td><td>{{quadranteimagem.valorlatitudep3}}</td><td>{{quadranteimagem.valorlongitudep3}}</td><td>{{quadranteimagem.valorlatitudep4}}</td><td>{{quadranteimagem.valorlongitudep4}}</td><td>{{quadranteimagem.camada}}</td><td><a ui-sref="matrizsensoriamento-detail({id:quadranteimagem.matrizsensoriamento.id})">{{quadranteimagem.matrizsensoriamento.nomematriz}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="quadranteimagem-detail({id:quadranteimagem.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="quadranteimagem.edit({id:quadranteimagem.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="quadranteimagem.delete({id:quadranteimagem.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/quadrantesolo/quadrantesolo-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.quadrantesolo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.quadrantesolo.delete.question" translate-values="{id: \'{{vm.quadrantesolo.id}}\'}">Are you sure you want to delete this Quadrantesolo?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/quadrantesolo/quadrantesolo-detail.html','<div><h2><span data-translate="netWordAgroApp.quadrantesolo.detail.title">Quadrantesolo</span> {{vm.quadrantesolo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.quadrantesolo.nomequadrante">Nomequadrante</span></dt><dd><span>{{vm.quadrantesolo.nomequadrante}}</span></dd><dt><span data-translate="netWordAgroApp.quadrantesolo.valorlatitudep1">Valorlatitudep 1</span></dt><dd><span>{{vm.quadrantesolo.valorlatitudep1}}</span></dd><dt><span data-translate="netWordAgroApp.quadrantesolo.valorlongitudep1">Valorlongitudep 1</span></dt><dd><span>{{vm.quadrantesolo.valorlongitudep1}}</span></dd><dt><span data-translate="netWordAgroApp.quadrantesolo.valorlatitudep2">Valorlatitudep 2</span></dt><dd><span>{{vm.quadrantesolo.valorlatitudep2}}</span></dd><dt><span data-translate="netWordAgroApp.quadrantesolo.valorlongitudep2">Valorlongitudep 2</span></dt><dd><span>{{vm.quadrantesolo.valorlongitudep2}}</span></dd><dt><span data-translate="netWordAgroApp.quadrantesolo.valorlatitudep3">Valorlatitudep 3</span></dt><dd><span>{{vm.quadrantesolo.valorlatitudep3}}</span></dd><dt><span data-translate="netWordAgroApp.quadrantesolo.valorlongitudep3">Valorlongitudep 3</span></dt><dd><span>{{vm.quadrantesolo.valorlongitudep3}}</span></dd><dt><span data-translate="netWordAgroApp.quadrantesolo.valorlatitudep4">Valorlatitudep 4</span></dt><dd><span>{{vm.quadrantesolo.valorlatitudep4}}</span></dd><dt><span data-translate="netWordAgroApp.quadrantesolo.valorlongitudep4">Valorlongitudep 4</span></dt><dd><span>{{vm.quadrantesolo.valorlongitudep4}}</span></dd><dt><span data-translate="netWordAgroApp.quadrantesolo.camada">Camada</span></dt><dd><span>{{vm.quadrantesolo.camada}}</span></dd><dt><span data-translate="netWordAgroApp.quadrantesolo.matrizsensoriamento">Matrizsensoriamento</span></dt><dd><a ui-sref="matrizsensoriamento-detail({id:vm.quadrantesolo.matrizsensoriamento.id})">{{vm.quadrantesolo.matrizsensoriamento.nomematriz}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="quadrantesolo-detail.edit({id:vm.quadrantesolo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/quadrantesolo/quadrantesolo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myQuadrantesoloLabel" data-translate="netWordAgroApp.quadrantesolo.home.createOrEditLabel">Create or edit a Quadrantesolo</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.quadrantesolo.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.quadrantesolo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.quadrantesolo.nomequadrante" for="field_nomequadrante">Nomequadrante</label><input type="text" class="form-control" name="nomequadrante" id="field_nomequadrante" ng-model="vm.quadrantesolo.nomequadrante" required ng-maxlength="15"><div ng-show="editForm.nomequadrante.$invalid"><p class="help-block" ng-show="editForm.nomequadrante.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nomequadrante.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.quadrantesolo.valorlatitudep1" for="field_valorlatitudep1">Valorlatitudep 1</label><input type="text" class="form-control" name="valorlatitudep1" id="field_valorlatitudep1" ng-model="vm.quadrantesolo.valorlatitudep1" required><div ng-show="editForm.valorlatitudep1.$invalid"><p class="help-block" ng-show="editForm.valorlatitudep1.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.quadrantesolo.valorlongitudep1" for="field_valorlongitudep1">Valorlongitudep 1</label><input type="text" class="form-control" name="valorlongitudep1" id="field_valorlongitudep1" ng-model="vm.quadrantesolo.valorlongitudep1" required><div ng-show="editForm.valorlongitudep1.$invalid"><p class="help-block" ng-show="editForm.valorlongitudep1.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.quadrantesolo.valorlatitudep2" for="field_valorlatitudep2">Valorlatitudep 2</label><input type="text" class="form-control" name="valorlatitudep2" id="field_valorlatitudep2" ng-model="vm.quadrantesolo.valorlatitudep2" required><div ng-show="editForm.valorlatitudep2.$invalid"><p class="help-block" ng-show="editForm.valorlatitudep2.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.quadrantesolo.valorlongitudep2" for="field_valorlongitudep2">Valorlongitudep 2</label><input type="text" class="form-control" name="valorlongitudep2" id="field_valorlongitudep2" ng-model="vm.quadrantesolo.valorlongitudep2" required><div ng-show="editForm.valorlongitudep2.$invalid"><p class="help-block" ng-show="editForm.valorlongitudep2.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.quadrantesolo.valorlatitudep3" for="field_valorlatitudep3">Valorlatitudep 3</label><input type="text" class="form-control" name="valorlatitudep3" id="field_valorlatitudep3" ng-model="vm.quadrantesolo.valorlatitudep3" required><div ng-show="editForm.valorlatitudep3.$invalid"><p class="help-block" ng-show="editForm.valorlatitudep3.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.quadrantesolo.valorlongitudep3" for="field_valorlongitudep3">Valorlongitudep 3</label><input type="text" class="form-control" name="valorlongitudep3" id="field_valorlongitudep3" ng-model="vm.quadrantesolo.valorlongitudep3" required><div ng-show="editForm.valorlongitudep3.$invalid"><p class="help-block" ng-show="editForm.valorlongitudep3.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.quadrantesolo.valorlatitudep4" for="field_valorlatitudep4">Valorlatitudep 4</label><input type="text" class="form-control" name="valorlatitudep4" id="field_valorlatitudep4" ng-model="vm.quadrantesolo.valorlatitudep4" required><div ng-show="editForm.valorlatitudep4.$invalid"><p class="help-block" ng-show="editForm.valorlatitudep4.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.quadrantesolo.valorlongitudep4" for="field_valorlongitudep4">Valorlongitudep 4</label><input type="text" class="form-control" name="valorlongitudep4" id="field_valorlongitudep4" ng-model="vm.quadrantesolo.valorlongitudep4" required><div ng-show="editForm.valorlongitudep4.$invalid"><p class="help-block" ng-show="editForm.valorlongitudep4.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.quadrantesolo.camada" for="field_camada">Camada</label><input type="number" class="form-control" name="camada" id="field_camada" ng-model="vm.quadrantesolo.camada" required><div ng-show="editForm.camada.$invalid"><p class="help-block" ng-show="editForm.camada.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.camada.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.quadrantesolo.matrizsensoriamento" for="field_matrizsensoriamento">Matrizsensoriamento</label><select class="form-control" id="field_matrizsensoriamento" name="matrizsensoriamento" ng-model="vm.quadrantesolo.matrizsensoriamento" ng-options="matrizsensoriamento as matrizsensoriamento.nomematriz for matrizsensoriamento in vm.matrizsensoriamentos track by matrizsensoriamento.id" required></select></div><div ng-show="editForm.matrizsensoriamento.$invalid"><p class="help-block" ng-show="editForm.matrizsensoriamento.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/quadrantesolo/quadrantesolos.html','<div><h2 data-translate="netWordAgroApp.quadrantesolo.home.title">Quadrantesolos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="quadrantesolo.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.quadrantesolo.home.createLabel">Create new Quadrantesolo</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.quadrantesolo.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomequadrante"><span data-translate="netWordAgroApp.quadrantesolo.nomequadrante">Nomequadrante</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorlatitudep1"><span data-translate="netWordAgroApp.quadrantesolo.valorlatitudep1">Valorlatitudep 1</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorlongitudep1"><span data-translate="netWordAgroApp.quadrantesolo.valorlongitudep1">Valorlongitudep 1</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorlatitudep2"><span data-translate="netWordAgroApp.quadrantesolo.valorlatitudep2">Valorlatitudep 2</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorlongitudep2"><span data-translate="netWordAgroApp.quadrantesolo.valorlongitudep2">Valorlongitudep 2</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorlatitudep3"><span data-translate="netWordAgroApp.quadrantesolo.valorlatitudep3">Valorlatitudep 3</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorlongitudep3"><span data-translate="netWordAgroApp.quadrantesolo.valorlongitudep3">Valorlongitudep 3</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorlatitudep4"><span data-translate="netWordAgroApp.quadrantesolo.valorlatitudep4">Valorlatitudep 4</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valorlongitudep4"><span data-translate="netWordAgroApp.quadrantesolo.valorlongitudep4">Valorlongitudep 4</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="camada"><span data-translate="netWordAgroApp.quadrantesolo.camada">Camada</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="matrizsensoriamento.nomematriz"><span data-translate="netWordAgroApp.quadrantesolo.matrizsensoriamento">Matrizsensoriamento</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="quadrantesolo in vm.quadrantesolos track by quadrantesolo.id"><td><a ui-sref="quadrantesolo-detail({id:quadrantesolo.id})">{{quadrantesolo.id}}</a></td><td>{{quadrantesolo.nomequadrante}}</td><td>{{quadrantesolo.valorlatitudep1}}</td><td>{{quadrantesolo.valorlongitudep1}}</td><td>{{quadrantesolo.valorlatitudep2}}</td><td>{{quadrantesolo.valorlongitudep2}}</td><td>{{quadrantesolo.valorlatitudep3}}</td><td>{{quadrantesolo.valorlongitudep3}}</td><td>{{quadrantesolo.valorlatitudep4}}</td><td>{{quadrantesolo.valorlongitudep4}}</td><td>{{quadrantesolo.camada}}</td><td><a ui-sref="matrizsensoriamento-detail({id:quadrantesolo.matrizsensoriamento.id})">{{quadrantesolo.matrizsensoriamento.nomematriz}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="quadrantesolo-detail({id:quadrantesolo.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="quadrantesolo.edit({id:quadrantesolo.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="quadrantesolo.delete({id:quadrantesolo.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/receituario/receituario-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.receituario.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.receituario.delete.question" translate-values="{id: \'{{vm.receituario.id}}\'}">Are you sure you want to delete this Receituario?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/receituario/receituario-detail.html','<div><h2><span data-translate="netWordAgroApp.receituario.detail.title">Receituario</span> {{vm.receituario.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.receituario.diagnostico">Diagnostico</span></dt><dd><span>{{vm.receituario.diagnostico}}</span></dd><dt><span data-translate="netWordAgroApp.receituario.produto">Produto</span></dt><dd><span>{{vm.receituario.produto}}</span></dd><dt><span data-translate="netWordAgroApp.receituario.quantidade">Quantidade</span></dt><dd><span>{{vm.receituario.quantidade}}</span></dd><dt><span data-translate="netWordAgroApp.receituario.medidaquantidade">Medidaquantidade</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipomedidaquantidade.\' + vm.receituario.medidaquantidade}}">{{vm.receituario.medidaquantidade}}</span></dd><dt><span data-translate="netWordAgroApp.receituario.aplicacao">Aplicacao</span></dt><dd><span>{{vm.receituario.aplicacao}}</span></dd><dt><span data-translate="netWordAgroApp.receituario.posaplicacao">Posaplicacao</span></dt><dd><span>{{vm.receituario.posaplicacao}}</span></dd><dt><span data-translate="netWordAgroApp.receituario.latitudeespecifica">Latitudeespecifica</span></dt><dd><span>{{vm.receituario.latitudeespecifica}}</span></dd><dt><span data-translate="netWordAgroApp.receituario.longitudeespecifica">Longitudeespecifica</span></dt><dd><span>{{vm.receituario.longitudeespecifica}}</span></dd><dt><span data-translate="netWordAgroApp.receituario.aplicado">Aplicado</span></dt><dd><span>{{vm.receituario.aplicado}}</span></dd><dt><span data-translate="netWordAgroApp.receituario.quadrantesolo">Quadrantesolo</span></dt><dd><a ui-sref="quadrantesolo-detail({id:vm.receituario.quadrantesolo.id})">{{vm.receituario.quadrantesolo.nomequadrante}}</a></dd><dt><span data-translate="netWordAgroApp.receituario.atividade">Atividade</span></dt><dd><a ui-sref="atividade-detail({id:vm.receituario.atividade.id})">{{vm.receituario.atividade.nome}}</a></dd><dt><span data-translate="netWordAgroApp.receituario.propostareceituario">Propostareceituario</span></dt><dd><a ui-sref="propostareceituario-detail({id:vm.receituario.propostareceituario.id})">{{vm.receituario.propostareceituario.nome}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="receituario-detail.edit({id:vm.receituario.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/receituario/receituario-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myReceituarioLabel" data-translate="netWordAgroApp.receituario.home.createOrEditLabel">Create or edit a Receituario</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.receituario.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.receituario.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.receituario.diagnostico" for="field_diagnostico">Diagnostico</label><input type="text" class="form-control" name="diagnostico" id="field_diagnostico" ng-model="vm.receituario.diagnostico" required><div ng-show="editForm.diagnostico.$invalid"><p class="help-block" ng-show="editForm.diagnostico.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.receituario.produto" for="field_produto">Produto</label><input type="text" class="form-control" name="produto" id="field_produto" ng-model="vm.receituario.produto" required><div ng-show="editForm.produto.$invalid"><p class="help-block" ng-show="editForm.produto.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.receituario.quantidade" for="field_quantidade">Quantidade</label><input type="number" class="form-control" name="quantidade" id="field_quantidade" ng-model="vm.receituario.quantidade" required><div ng-show="editForm.quantidade.$invalid"><p class="help-block" ng-show="editForm.quantidade.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.quantidade.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.receituario.medidaquantidade" for="field_medidaquantidade">Medidaquantidade</label><select class="form-control" name="medidaquantidade" ng-model="vm.receituario.medidaquantidade" id="field_medidaquantidade" required><option value="g" data-translate="netWordAgroApp.Tipomedidaquantidade.g">G</option><option value="kg" data-translate="netWordAgroApp.Tipomedidaquantidade.kg">KG</option><option value="ml" data-translate="netWordAgroApp.Tipomedidaquantidade.ml">ML</option><option value="l" data-translate="netWordAgroApp.Tipomedidaquantidade.l">L</option></select><div ng-show="editForm.medidaquantidade.$invalid"><p class="help-block" ng-show="editForm.medidaquantidade.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.receituario.aplicacao" for="field_aplicacao">Aplicacao</label><input type="text" class="form-control" name="aplicacao" id="field_aplicacao" ng-model="vm.receituario.aplicacao" required><div ng-show="editForm.aplicacao.$invalid"><p class="help-block" ng-show="editForm.aplicacao.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.receituario.posaplicacao" for="field_posaplicacao">Posaplicacao</label><input type="text" class="form-control" name="posaplicacao" id="field_posaplicacao" ng-model="vm.receituario.posaplicacao" required><div ng-show="editForm.posaplicacao.$invalid"><p class="help-block" ng-show="editForm.posaplicacao.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.receituario.latitudeespecifica" for="field_latitudeespecifica">Latitudeespecifica</label><input type="text" class="form-control" name="latitudeespecifica" id="field_latitudeespecifica" ng-model="vm.receituario.latitudeespecifica"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.receituario.longitudeespecifica" for="field_longitudeespecifica">Longitudeespecifica</label><input type="text" class="form-control" name="longitudeespecifica" id="field_longitudeespecifica" ng-model="vm.receituario.longitudeespecifica"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.receituario.aplicado" for="field_aplicado">Aplicado</label><input type="checkbox" name="aplicado" id="field_aplicado" ng-model="vm.receituario.aplicado"></div><div class="form-group"><label data-translate="netWordAgroApp.receituario.quadrantesolo" for="field_quadrantesolo">Quadrantesolo</label><select class="form-control" id="field_quadrantesolo" name="quadrantesolo" ng-model="vm.receituario.quadrantesolo" ng-options="quadrantesolo as quadrantesolo.nomequadrante for quadrantesolo in vm.quadrantesolos track by quadrantesolo.id"></select></div><div class="form-group"><label data-translate="netWordAgroApp.receituario.atividade" for="field_atividade">Atividade</label><select class="form-control" id="field_atividade" name="atividade" ng-model="vm.receituario.atividade" ng-options="atividade as atividade.nome for atividade in vm.atividades track by atividade.id" required></select></div><div ng-show="editForm.atividade.$invalid"><p class="help-block" ng-show="editForm.atividade.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/receituario/receituarios.html','<div><h2 data-translate="netWordAgroApp.receituario.home.title">Receituarios</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="receituario.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.receituario.home.createLabel">Create new Receituario</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.receituario.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="diagnostico"><span data-translate="netWordAgroApp.receituario.diagnostico">Diagnostico</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="produto"><span data-translate="netWordAgroApp.receituario.produto">Produto</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quantidade"><span data-translate="netWordAgroApp.receituario.quantidade">Quantidade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="medidaquantidade"><span data-translate="netWordAgroApp.receituario.medidaquantidade">Medidaquantidade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="aplicacao"><span data-translate="netWordAgroApp.receituario.aplicacao">Aplicacao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="posaplicacao"><span data-translate="netWordAgroApp.receituario.posaplicacao">Posaplicacao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="latitudeespecifica"><span data-translate="netWordAgroApp.receituario.latitudeespecifica">Latitudeespecifica</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="longitudeespecifica"><span data-translate="netWordAgroApp.receituario.longitudeespecifica">Longitudeespecifica</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="aplicado"><span data-translate="netWordAgroApp.receituario.aplicado">Aplicado</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quadrantesolo.nomequadrante"><span data-translate="netWordAgroApp.receituario.quadrantesolo">Quadrantesolo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="atividade.nome"><span data-translate="netWordAgroApp.receituario.atividade">Atividade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="propostareceituario.nome"><span data-translate="netWordAgroApp.receituario.propostareceituario">Propostareceituario</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="receituario in vm.receituarios track by receituario.id"><td><a ui-sref="receituario-detail({id:receituario.id})">{{receituario.id}}</a></td><td>{{receituario.diagnostico}}</td><td>{{receituario.produto}}</td><td>{{receituario.quantidade}}</td><td data-translate="{{\'netWordAgroApp.Tipomedidaquantidade.\' + receituario.medidaquantidade}}">{{receituario.medidaquantidade}}</td><td>{{receituario.aplicacao}}</td><td>{{receituario.posaplicacao}}</td><td>{{receituario.latitudeespecifica}}</td><td>{{receituario.longitudeespecifica}}</td><td>{{receituario.aplicado}}</td><td><a ui-sref="quadrantesolo-detail({id:receituario.quadrantesolo.id})">{{receituario.quadrantesolo.nomequadrante}}</a></td><td><a ui-sref="atividade-detail({id:receituario.atividade.id})">{{receituario.atividade.nome}}</a></td><td><a ui-sref="propostareceituario-detail({id:receituario.propostareceituario.id})">{{receituario.propostareceituario.nome}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="receituario-detail({id:receituario.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="receituario.edit({id:receituario.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="receituario.delete({id:receituario.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/relatorio/relatorio-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.relatorio.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.relatorio.delete.question" translate-values="{id: \'{{vm.relatorio.id}}\'}">Are you sure you want to delete this Relatorio?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/relatorio/relatorio-detail.html','<div><h2><span data-translate="netWordAgroApp.relatorio.detail.title">Relatorio</span> {{vm.relatorio.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="relatorio-detail.edit({id:vm.relatorio.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/relatorio/relatorio-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRelatorioLabel" data-translate="netWordAgroApp.relatorio.home.createOrEditLabel">Create or edit a Relatorio</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.relatorio.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.relatorio.id" readonly="readonly"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/relatorio/relatorios-en.html','<script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.4.0/Chart.min.js"></script><script>function addImagemPdf(idCanva, conteudo, largura){\n            var im = {};\n            var canvas = document.querySelector(idCanva).toDataURL(\'image/png\', 1.0);\n            im.image = canvas;\n            im.width = largura;\n            conteudo.push(im);\n        }\n        \n        function addLogo(conteudo, largura){\n            var im = {};\n            im.image = "data:image/png;base64,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";\n            im.width = largura;\n            im.alignment = \'center\';\n            conteudo.push(im);\n        }\n        \n        function addTabelaPdf(idtabela, conteudo, ling){\n            var tblconf = {}; //conteiner da tabela\n            var tbl = {}; //tabela\n            tblconf.layout = \'lightHorizontalLines\';\n        \n            if(ling===\'pt\') tbl.body = [[\'Tipo de Gasto\', \'Valor (R$)\']];\n            else if(ling ===\'en\') tbl.body = [[\'Type of expense\', \'Value ($)\']];\n            else if (ling===\'es\') tbl.body = [[\'Tipo de Costo\', \'Valor ($)\']]\n        \n            tbl.widths = [\'*\', \'*\'];\n            tbl.headerRows = 1;\n        \n            tabhtml = $(idtabela + " tbody");\n            tabhtml.find(\'tr\').each(function (i, el){\n                var $tds = $(this).find(\'td\'),\n                    tipo = $tds.eq(0).text(),\n                    valor = $tds.eq(1).text();\n                tbl.body.push([tipo, valor]);\n            });\n            \n            tblconf.table = tbl;\n        \n            conteudo.push(tblconf);\n        }\n        \n        function addTabelaPdf2(idtabela, conteudo, ling){\n            var tblconf = {}; //conteiner da tabela\n            var tbl = {}; //tabela\n            tblconf.layout = \'lightHorizontalLines\';\n        \n            if(ling===\'pt\')\n                tbl.body = [[\'Tipo de Gasto\', \'Valor Habitual (R$)\', \'Valor NetWord (R$)\']];\n            else if(ling===\'en\')\n                tbl.body = [[\'Type of Expense\', \'Habitual Value ($)\', \'NetWord Value ($)\']];\n            else if(ling===\'es\') \n                tbl.body = [[\'Tipo de Costo\', \'Valor Habitual ($)\', \'Valor NetWord ($)\']];\n        \n            \n            tbl.widths = [\'*\', \'*\', \'*\'];\n            tbl.headerRows = 1;\n        \n            tabhtml = $(idtabela + " tbody");\n            tabhtml.find(\'tr\').each(function (i, el){\n                var $tds = $(this).find(\'td\'),\n                    tipo = $tds.eq(0).text(),\n                    valor1 = $tds.eq(1).text();\n                    valor2 = $tds.eq(2).text();\n                tbl.body.push([tipo, valor1, valor2]);\n            });\n            \n            tblconf.table = tbl;\n        \n            conteudo.push(tblconf);\n        }\n        \n        function addMomentoPdf(conteudo, ling){\n            // Obt\xE9m a data/hora atual\n            var data = new Date();\n        \n            // Guarda cada peda\xE7o em uma vari\xE1vel\n            var dia     = data.getDate();           // 1-31\n            var dia_sem = data.getDay();            // 0-6 (zero=domingo)\n            var mes     = data.getMonth();          // 0-11 (zero=janeiro)\n            var ano4    = data.getFullYear();       // 4 d\xEDgitos\n            var hora    = data.getHours();          // 0-23\n            var min     = data.getMinutes();        // 0-59\n            var seg     = data.getSeconds();        // 0-59\n        \n            // Formata a data e a hora (note o m\xEAs + 1)\n            var str_data = dia + \'/\' + (mes+1) + \'/\' + ano4;\n            var str_hora = hora + \':\' + min + \':\' + seg;\n        \n            var str_data_en =  (mes+1) + \'/\' + dia + \'/\' + ano4;\n        \n            // Mostra o resultado\n            if(ling===\'pt\') conteudo.push(\'Relat\xF3rio gerado em \' + str_data + \' \xE0s \' + str_hora);\n            else if(ling===\'en\') conteudo.push(\'Report generated in \' + str_data_en + \' , \' + str_hora);\n            else if(ling===\'es\') conteudo.push(\'Relatorio generado en \' + str_data + \' , \' + str_hora);\n        \n        }</script><script type="text/javascript">function preencheSelector(){\n        $(\'#gerapdf\').attr(\'disabled\', true);\n\n        var $select = $(\'#selecsafra\');\n\n        $.ajax({\n            url: \'/api/nomesafras/\',\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) { \n                $select.html(\'\');\n                listaOpcoes = json.map(function(item) {\n                    return item.nome;\n                });\n\n                for (i = 0; i < listaOpcoes.length; i++) {\n                    $select.append(\'<option id="\' + listaOpcoes[i] + \'">\' + listaOpcoes[i] + \'</option>\');\n                }\n                console.log("preenchido");\n            }\n        });\n    }\n\n    function dadosSafra(safra){\n        var tipoSafra = {\n                "verao":"Summer",\n                "safrinha":"Midseason",\n                "inverno": "Winter"\n        };\n\n        var urlJSON = "/api/dadossafra/" + safra;\n\n        $.ajax({\n            url: urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) { \n                propriedade = json.map(function(item) {\n                    return item.nomepropriedade;\n                });\n\n                ano = json.map(function(item) {\n                    return item.ano;\n                });\n\n                tsafra = json.map(function(item) {\n                    return tipoSafra[item.safra];\n                });\n\n                nomeSafra = json.map(function(item) {\n                    return item.nome;\n                });\n\n                $("#titulo").html("<h3>Costs Report: <small id=\'nomeprop\'>" + propriedade + "</small></h3>");\n                $("#dadossafra").css(\'visibility\', \'visible\');\n                $("#dadossafra").html("Harvest\'s name: " + nomeSafra + \'<br>\' + \'Harvest: \' + tsafra + \'<br>\' + "Harvest\'s year: " + ano + \'<br>\');\n            }\n        });\n\n  \n    }\n\n    function limpa(){\n        $("#graficochf").html(\'\');\n        $("#graficochf").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosfert"></canvas>\');\n        $("#graficochp").html(\'\');\n        $("#graficochp").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosprod"></canvas>\');\n        $("#graficochd").html(\'\');\n        $("#graficochd").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosdef"></canvas>\');\n        $("#tabelachd").html(\'\');\n        $("#tabelachf").html(\'\');\n        $("#tabelachp").html(\'\');\n    }\n\n    function dadosFert(safra){\n        var lblfert = {\n                "fertilizantequimico":"Chemical Fertilizer",\n                "fertilizantefoliar":"Foliar Fertilizer",\n                "materialorganico":"Organic Material",\n                "corretivo":"Corrective"\n        };\n\n        var urlJSON = "/api/custohabfertsafra/" + safra;\n\n        $.ajax({\n            url: urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) { \n           \n                listaTipo = json.map(function(item) {\n                    return lblfert[item.tipo];\n                });\n\n                listaValor = json.map(function(item) {\n                    return item.valor;\n                });\n                \n                console.log(listaTipo); console.log(listaValor);\n\n                var ctx = document.getElementById(\'grafcustosfert\').getContext(\'2d\');\n\n                var chart = new Chart(ctx, {\n                    type: \'bar\',\n\n                    data: {\n                        labels: Object.values(lblfert),\n                        datasets: [{\n                            label: "Fertilizers Costs",\n                            backgroundColor: \'rgb(204, 255, 102)\', \n                            //borderColor: \'rgb(255, 99, 132)\',\n                            data: listaValor,\n                        }]\n                    },\n\n                    // Configuration options go here\n                    options: {\n                        scales: {\n                            yAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Value ($)\'\n                            },   \n                            ticks: {\n                                suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                            }\n                            }],\n\n                            xAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Type\'\n                            }\n                            }]\n                        }     \n\n                    }\n                });\n\n                $("#tabelachf").append(\'<table class="table table-striped" id="tabchf"></table>\');\n                $("#tabchf").append(\'<tbody id="tabchfbody"></tbody>\');\n                $("#tabchf").append(\'<thead><tr><th>Type of Expense</th> <th>Value ($)</th></tr></thead>\');\n                for(i=0; i<listaTipo.length; i++){\n                    $("#tabchfbody").append(\'<tr> <td>\' + listaTipo[i] + \'</td> <td> \' + listaValor[i] + \'</td> </tr>\');\n                }\n            }\n        });\n    }\n\n    function dadosDef(safra){\n         \n        var lbldef = {\n            "inseticidaparasemente": "Seed Inseticide",\n            "inseticidaparalagarta": "Caterpillar Inseticide",\n            "inseticidaparapercevejo": "Bedbug Inseticide",\n            "fungicidaparasemente": "Seed Fungicide",\n            "fungicida": "Fungicide",\n            "herbicidaparaplantadaninha": "Weed Herbicide",\n            "herbicidaparaprecolheita": "Pre Harvest Herbicide",\n            "larvicida": "Larvicide"\n        };\n\n        var urlJSON = "/api/custohabdefsafra/" + safra;\n\n        $.ajax({\n            url: urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) { \n                listaTipo = json.map(function(item) {\n                    return lbldef[item.tipo];\n                });\n\n                listaValor = json.map(function(item) {\n                    return item.valor;\n                });\n                \n                console.log(listaTipo); console.log(listaValor);\n\n                var ctx = document.getElementById(\'grafcustosdef\').getContext(\'2d\');        \n\n                var chart = new Chart(ctx, {\n                    type: \'bar\',\n\n                    data: {\n                        labels: Object.values(lbldef),\n                        datasets: [{\n                            label: "Defensives Costs",\n                            backgroundColor: \'rgb(255, 102, 102)\', \n                            //borderColor: \'rgb(255, 99, 132)\',\n                            data: listaValor,\n                        }]\n                    },\n\n                    // Configuration options go here\n                    options: {\n                        scales: {\n                            yAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Value ($)\'\n                            },   \n                            ticks: {\n                                suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                            }\n                            }],\n\n                            xAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Type\'\n                            }\n                            }]\n                        }     \n\n                    }\n                });\n\n                $("#tabelachd").append(\'<table class="table table-striped" id="tabchd"></table>\');\n                $("#tabchd").append(\'<tbody id="tabchdbody"></tbody>\');\n                $("#tabchd").append(\'<thead><tr><th>Type of Expense</th> <th>Value ($)</th></tr></thead>\');\n                for(i=0; i<listaTipo.length; i++){\n                    $("#tabchdbody").append(\'<tr> <td>\' + listaTipo[i] + \'</td> <td> \' + listaValor[i] + \'</td> </tr>\');\n                }\n            }\n        });\n    }\n\n    function dadosProd(safra){\n        var lblprod = {\n            "analisedesolo": "Soil Analysis",\n            "combustivel": "Fuel",\n            "operacaodamaquina": "Machine Operation",\n            "alugueldamaquina": "Machine Rent",\n            "manutencaodamaquina": "Machine Maintenance"\n        };\n\n        \n        var urlJSON = "/api/custohabprodsafra/" + safra;\n\n        $.ajax({\n            url: urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) { \n                listaTipo = json.map(function(item) {\n                    return lblprod[item.tipo];\n                });\n\n                listaValor = json.map(function(item) {\n                    return item.valor;\n                });\n                \n                console.log(listaTipo); console.log(listaValor);\n                \n                var ctx = document.getElementById(\'grafcustosprod\').getContext(\'2d\');\n                \n                var chart = new Chart(ctx, {\n                    type: \'bar\',\n\n                    data: {\n                        labels: Object.values(lblprod),\n                        datasets: [{\n                            label: "Production Costs",\n                            backgroundColor: \'rgb(153, 204, 255)\', \n                            //borderColor: \'rgb(255, 99, 132)\',\n                            data: listaValor,\n                        }]\n                    },\n\n                    // Configuration options go here\n                    options: {\n                        scales: {\n                            yAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Value ($)\'\n                            },   \n                            ticks: {\n                                suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                            }\n                            }],\n\n                            xAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Type\'\n                            }\n                            }]\n                        }     \n\n                    }\n                });\n\n                $("#tabelachp").append(\'<table class="table table-striped" id="tabchp"></table>\');\n                $("#tabchp").append(\'<tbody id="tabchpbody"></tbody>\');\n                $("#tabchp").append(\'<thead><tr><th>Type of Expense</th> <th>Value ($)</th></tr></thead>\');\n                for(i=0; i<listaTipo.length; i++){\n                    $("#tabchpbody").append(\'<tr> <td>\' + listaTipo[i] + \'</td> <td> \' + listaValor[i] + \'</td> </tr>\');\n                }\n            }\n        });\n    } \n\n    function montaRelatorio(){\n        $(\'#gerapdf\').attr(\'disabled\', false);\n\n        var $select = $(\'#selecsafra\');\n        var safra = $select.val();\n\n        limpa();\n        dadosSafra(safra);\n        dadosFert(safra);\n        dadosDef(safra);\n        dadosProd(safra);\n    }\n\n    function gerarpdf(){\n        var conteudo = [];\n\n        addLogo(conteudo, 100);\n\n        // Titulo do relat\xF3rio\n        conteudo.push(\' \');\n\n        var titulo = {};\n        titulo.text = \'Report\';\n        titulo.fontSize = 15;\n        titulo.alignment = \'center\';\n        conteudo.push(titulo);\n\n        conteudo.push(\' \'); \n\n        conteudo.push("Property: " + $(\'#nomeprop\').html());\n        conteudo.push(($("#dadossafra").html()).split(\'<br>\'));\n        \n        //Tabelas e imagens\n        conteudo.push(\' \');\n        conteudo.push(\'Production Costs\');\n        \n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosprod\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chp\n        addTabelaPdf("#tabelachp", conteudo, \'en\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        conteudo.push(\'Defensives Costs\');\n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosdef\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chd\n        addTabelaPdf("#tabelachd", conteudo, \'en\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        conteudo.push(\'Fertilizers Costs\');\n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosfert\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chf\n        addTabelaPdf("#tabelachf", conteudo, \'en\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        addMomentoPdf(conteudo, \'en\');\n\n        // Gera\xE7\xE3o do documento\n        var doc = { content: conteudo };\n        pdfMake.createPdf(doc).download();\n    }\n\n    preencheSelector();</script><div><div class="container-fluid"><div class="well">Select the harvest<form name="formSafra"><select id="selecsafra" name="safras"></select><button onclick="montaRelatorio()">Show Report</button> <button id="gerapdf" onclick="gerarpdf()">Generate PDF</button></form></div><div id="relatorio" class="col-xs-12"><div class="row"><div id="titulo" class="col-xs-12 no-padding-left"></div></div><div class="row"><div class="well" style="visibility: hidden" id="dadossafra"></div></div><div class="row"><div class="row"><div id="graficochp" class="col-xs-12 no-padding-left"><canvas id="grafcustosprod"></canvas></div></div><div class="row"><div id="tabelachp" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div><div class="row" style="margin-top:20px"><div class="row"><div id="graficochd" class="col-xs-12 no-padding-left"><canvas id="grafcustosdef"></canvas></div></div><div class="row"><div id="tabelachd" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div><div class="row" style="margin-top:20px"><div class="row"><div id="graficochf" class="col-xs-12 no-padding-left"><canvas id="grafcustosfert"></canvas></div></div><div class="row"><div id="tabelachf" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div></div></div></div>');
$templateCache.put('app/entities/relatorio/relatorios-es.html','<script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.4.0/Chart.min.js"></script><script>function addImagemPdf(idCanva, conteudo, largura){\n            var im = {};\n            var canvas = document.querySelector(idCanva).toDataURL(\'image/png\', 1.0);\n            im.image = canvas;\n            im.width = largura;\n            conteudo.push(im);\n        }\n        \n        function addLogo(conteudo, largura){\n            var im = {};\n            im.image = "data:image/png;base64,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";\n            im.width = largura;\n            im.alignment = \'center\';\n            conteudo.push(im);\n        }\n        \n        function addTabelaPdf(idtabela, conteudo, ling){\n            var tblconf = {}; //conteiner da tabela\n            var tbl = {}; //tabela\n            tblconf.layout = \'lightHorizontalLines\';\n        \n            if(ling===\'pt\') tbl.body = [[\'Tipo de Gasto\', \'Valor (R$)\']];\n            else if(ling ===\'en\') tbl.body = [[\'Type of expense\', \'Value ($)\']];\n            else if (ling===\'es\') tbl.body = [[\'Tipo de Costo\', \'Valor ($)\']]\n        \n            tbl.widths = [\'*\', \'*\'];\n            tbl.headerRows = 1;\n        \n            tabhtml = $(idtabela + " tbody");\n            tabhtml.find(\'tr\').each(function (i, el){\n                var $tds = $(this).find(\'td\'),\n                    tipo = $tds.eq(0).text(),\n                    valor = $tds.eq(1).text();\n                tbl.body.push([tipo, valor]);\n            });\n            \n            tblconf.table = tbl;\n        \n            conteudo.push(tblconf);\n        }\n        \n        function addTabelaPdf2(idtabela, conteudo, ling){\n            var tblconf = {}; //conteiner da tabela\n            var tbl = {}; //tabela\n            tblconf.layout = \'lightHorizontalLines\';\n        \n            if(ling===\'pt\')\n                tbl.body = [[\'Tipo de Gasto\', \'Valor Habitual (R$)\', \'Valor NetWord (R$)\']];\n            else if(ling===\'en\')\n                tbl.body = [[\'Type of Expense\', \'Habitual Value ($)\', \'NetWord Value ($)\']];\n            else if(ling===\'es\') \n                tbl.body = [[\'Tipo de Costo\', \'Valor Habitual ($)\', \'Valor NetWord ($)\']];\n        \n            \n            tbl.widths = [\'*\', \'*\', \'*\'];\n            tbl.headerRows = 1;\n        \n            tabhtml = $(idtabela + " tbody");\n            tabhtml.find(\'tr\').each(function (i, el){\n                var $tds = $(this).find(\'td\'),\n                    tipo = $tds.eq(0).text(),\n                    valor1 = $tds.eq(1).text();\n                    valor2 = $tds.eq(2).text();\n                tbl.body.push([tipo, valor1, valor2]);\n            });\n            \n            tblconf.table = tbl;\n        \n            conteudo.push(tblconf);\n        }\n        \n        function addMomentoPdf(conteudo, ling){\n            // Obt\xE9m a data/hora atual\n            var data = new Date();\n        \n            // Guarda cada peda\xE7o em uma vari\xE1vel\n            var dia     = data.getDate();           // 1-31\n            var dia_sem = data.getDay();            // 0-6 (zero=domingo)\n            var mes     = data.getMonth();          // 0-11 (zero=janeiro)\n            var ano4    = data.getFullYear();       // 4 d\xEDgitos\n            var hora    = data.getHours();          // 0-23\n            var min     = data.getMinutes();        // 0-59\n            var seg     = data.getSeconds();        // 0-59\n        \n            // Formata a data e a hora (note o m\xEAs + 1)\n            var str_data = dia + \'/\' + (mes+1) + \'/\' + ano4;\n            var str_hora = hora + \':\' + min + \':\' + seg;\n        \n            var str_data_en =  (mes+1) + \'/\' + dia + \'/\' + ano4;\n        \n            // Mostra o resultado\n            if(ling===\'pt\') conteudo.push(\'Relat\xF3rio gerado em \' + str_data + \' \xE0s \' + str_hora);\n            else if(ling===\'en\') conteudo.push(\'Report generated in \' + str_data_en + \' , \' + str_hora);\n            else if(ling===\'es\') conteudo.push(\'Relatorio generado en \' + str_data + \' , \' + str_hora);\n        \n        }</script><script type="text/javascript">function preencheSelector(){\n        $(\'#gerapdf\').attr(\'disabled\', true);\n\n        var $select = $(\'#selecsafra\');\n\n        $.ajax({\n            url: \'/api/nomesafras/\',\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) { \n                $select.html(\'\');\n                listaOpcoes = json.map(function(item) {\n                    return item.nome;\n                });\n\n                for (i = 0; i < listaOpcoes.length; i++) {\n                    $select.append(\'<option id="\' + listaOpcoes[i] + \'">\' + listaOpcoes[i] + \'</option>\');\n                }\n                console.log("preenchido");\n            }\n        });\n    }\n\n    function dadosSafra(safra){\n        var tipoSafra = {\n                "verao":"Verano",\n                "safrinha":"Fuera de la temporada",\n                "inverno": "Invierno"\n        };\n\n        var urlJSON = "/api/dadossafra/" + safra;\n\n        $.ajax({\n            url:  urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) { \n                propriedade = json.map(function(item) {\n                    return item.nomepropriedade;\n                });\n\n                ano = json.map(function(item) {\n                    return item.ano;\n                });\n\n                tsafra = json.map(function(item) {\n                    return tipoSafra[item.safra];\n                });\n\n                nomeSafra = json.map(function(item) {\n                    return item.nome;\n                });\n\n                $("#titulo").html("<h3>Relatorio de Costos: <small id=\'nomeprop\'>" + propriedade + "</small></h3>");\n                $("#dadossafra").css(\'visibility\', \'visible\');\n                $("#dadossafra").html("Nombre de la Cosecha: " + nomeSafra + \'<br>\' + \'Cosecha: \' + tsafra + \'<br>\' + "A\xF1o de la cosecha: " + ano + \'<br>\');\n            }\n        });\n\n  \n    }\n\n    function limpa(){\n        $("#graficochf").html(\'\');\n        $("#graficochf").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosfert"></canvas>\');\n        $("#graficochp").html(\'\');\n        $("#graficochp").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosprod"></canvas>\');\n        $("#graficochd").html(\'\');\n        $("#graficochd").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosdef"></canvas>\');\n        $("#tabelachd").html(\'\');\n        $("#tabelachf").html(\'\');\n        $("#tabelachp").html(\'\');\n    }\n\n    function dadosFert(safra){\n        var lblfert = {\n                "fertilizantequimico":"Fertilizante Qu\xEDmico",\n                "fertilizantefoliar":"Fertilizante para Hoja",\n                "materialorganico":"Material Org\xE1nico",\n                "corretivo":"Correctivo"\n        };\n\n        var urlJSON = "/api/custohabfertsafra/" + safra;\n\n         $.ajax({\n            url:  urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) { \n           \n                listaTipo = json.map(function(item) {\n                    return lblfert[item.tipo];\n                });\n\n                listaValor = json.map(function(item) {\n                    return item.valor;\n                });\n                \n                console.log(listaTipo); console.log(listaValor);\n\n                var ctx = document.getElementById(\'grafcustosfert\').getContext(\'2d\');\n\n                var chart = new Chart(ctx, {\n                    type: \'bar\',\n\n                    data: {\n                        labels: Object.values(lblfert),\n                        datasets: [{\n                            label: "Costos con Fertilizantes",\n                            backgroundColor: \'rgb(204, 255, 102)\', \n                            //borderColor: \'rgb(255, 99, 132)\',\n                            data: listaValor,\n                        }]\n                    },\n\n                    // Configuration options go here\n                    options: {\n                        scales: {\n                            yAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Valor ($)\'\n                            },   \n                            ticks: {\n                                suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                            }\n                            }],\n\n                            xAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Tipo\'\n                            }\n                            }]\n                        }     \n\n                    }\n                });\n\n                $("#tabelachf").append(\'<table class="table table-striped" id="tabchf"></table>\');\n                $("#tabchf").append(\'<tbody id="tabchfbody"></tbody>\');\n                $("#tabchf").append(\'<thead><tr><th>Tipo de Costo</th> <th>Valor ($)</th></tr></thead>\');\n                for(i=0; i<listaTipo.length; i++){\n                    $("#tabchfbody").append(\'<tr> <td>\' + listaTipo[i] + \'</td> <td> \' + listaValor[i] + \'</td> </tr>\');\n                }\n            }\n        });\n    }\n\n    function dadosDef(safra){\n         \n        var lbldef = {\n            "inseticidaparasemente": "Insecticida para la Semilla",\n            "inseticidaparalagarta": "Insecticida para la Oruga",\n            "inseticidaparapercevejo": "Insecticida para la Chincheta",\n            "fungicidaparasemente": "Fungicida para la Semilla",\n            "fungicida": "Fungicida",\n            "herbicidaparaplantadaninha": "Herbicida para la Planta Da\xF1ina",\n            "herbicidaparaprecolheita": "Herbicida para Pre-cosecha",\n            "larvicida": "Larvicida"\n        };\n\n        var urlJSON = "/api/custohabdefsafra/" + safra;\n\n         $.ajax({\n            url:  urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) { \n                listaTipo = json.map(function(item) {\n                    return lbldef[item.tipo];\n                });\n\n                listaValor = json.map(function(item) {\n                    return item.valor;\n                });\n                \n                console.log(listaTipo); console.log(listaValor);\n\n                var ctx = document.getElementById(\'grafcustosdef\').getContext(\'2d\');        \n\n                var chart = new Chart(ctx, {\n                    type: \'bar\',\n\n                    data: {\n                        labels: Object.values(lbldef),\n                        datasets: [{\n                            label: "Costos con Defensivos",\n                            backgroundColor: \'rgb(255, 102, 102)\', \n                            //borderColor: \'rgb(255, 99, 132)\',\n                            data: listaValor,\n                        }]\n                    },\n\n                    // Configuration options go here\n                    options: {\n                        scales: {\n                            yAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Valor ($)\'\n                            },   \n                            ticks: {\n                                suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                            }\n                            }],\n\n                            xAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Tipo\'\n                            }\n                            }]\n                        }     \n\n                    }\n                });\n\n                $("#tabelachd").append(\'<table class="table table-striped" id="tabchd"></table>\');\n                $("#tabchd").append(\'<tbody id="tabchdbody"></tbody>\');\n                $("#tabchd").append(\'<thead><tr><th>Tipo de Costo</th> <th>Valor ($)</th></tr></thead>\');\n                for(i=0; i<listaTipo.length; i++){\n                    $("#tabchdbody").append(\'<tr> <td>\' + listaTipo[i] + \'</td> <td> \' + listaValor[i] + \'</td> </tr>\');\n                }\n            }\n        });\n    }\n\n    function dadosProd(safra){\n        var lblprod = {\n            "analisedesolo": "An\xE1lisis de Suelo",\n            "combustivel": "Combustible de la M\xE1quina",\n            "operacaodamaquina": "Operaci\xF3n de la M\xE1quina",\n            "alugueldamaquina": "Alquiler de la M\xE1quina",\n            "manutencaodamaquina": "Mantenimiento de la M\xE1quina"\n        };\n\n        \n        var urlJSON = "/api/custohabprodsafra/" + safra;\n\n        $.ajax({\n            url:  urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) { \n                listaTipo = json.map(function(item) {\n                    return lblprod[item.tipo];\n                });\n\n                listaValor = json.map(function(item) {\n                    return item.valor;\n                });\n                \n                console.log(listaTipo); console.log(listaValor);\n                \n                var ctx = document.getElementById(\'grafcustosprod\').getContext(\'2d\');\n                \n                var chart = new Chart(ctx, {\n                    type: \'bar\',\n\n                    data: {\n                        labels: Object.values(lblprod),\n                        datasets: [{\n                            label: "Costos de Producci\xF3n",\n                            backgroundColor: \'rgb(153, 204, 255)\', \n                            //borderColor: \'rgb(255, 99, 132)\',\n                            data: listaValor,\n                        }]\n                    },\n\n                    // Configuration options go here\n                    options: {\n                        scales: {\n                            yAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Valor ($)\'\n                            },   \n                            ticks: {\n                                suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                            }\n                            }],\n\n                            xAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Tipo\'\n                            }\n                            }]\n                        }     \n\n                    }\n                });\n\n                $("#tabelachp").append(\'<table class="table table-striped" id="tabchp"></table>\');\n                $("#tabchp").append(\'<tbody id="tabchpbody"></tbody>\');\n                $("#tabchp").append(\'<thead><tr><th>Tipo de Costo</th> <th>Valor ($)</th></tr></thead>\');\n                for(i=0; i<listaTipo.length; i++){\n                    $("#tabchpbody").append(\'<tr> <td>\' + listaTipo[i] + \'</td> <td> \' + listaValor[i] + \'</td> </tr>\');\n                }\n            }\n        });\n    } \n\n    function montaRelatorio(){\n        $(\'#gerapdf\').attr(\'disabled\', false);\n\n        var $select = $(\'#selecsafra\');\n        var safra = $select.val();\n\n        limpa();\n        dadosSafra(safra);\n        dadosFert(safra);\n        dadosDef(safra);\n        dadosProd(safra);\n    }\n\n    function gerarpdf(){\n        var conteudo = [];\n\n        addLogo(conteudo, 100);\n\n        // Titulo do relat\xF3rio\n        conteudo.push(\' \');\n\n        var titulo = {};\n        titulo.text = \'Relatorio\';\n        titulo.fontSize = 15;\n        titulo.alignment = \'center\';\n        conteudo.push(titulo);\n\n        conteudo.push(\' \'); \n\n        conteudo.push("Propiedade: " + $(\'#nomeprop\').html());\n        conteudo.push(($("#dadossafra").html()).split(\'<br>\'));\n        \n        //Tabelas e imagens\n        conteudo.push(\' \');\n        conteudo.push(\'Costos de Producci\xF3n\');\n        \n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosprod\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chp\n        addTabelaPdf("#tabelachp", conteudo, \'es\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        conteudo.push(\'Costos con Defensivos\');\n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosdef\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chd\n        addTabelaPdf("#tabelachd", conteudo, \'es\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        conteudo.push(\'Costos con Fertilizantes\');\n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosfert\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chf\n        addTabelaPdf("#tabelachf", conteudo, \'es\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        addMomentoPdf(conteudo, \'es\');\n\n        // Gera\xE7\xE3o do documento\n        var doc = { content: conteudo };\n        pdfMake.createPdf(doc).download();\n    }\n\n    preencheSelector();</script><div><div class="container-fluid"><div class="well">Seleccione la cosecha:<form name="formSafra"><select id="selecsafra" name="safras"></select><button onclick="montaRelatorio()">Presentar informe</button> <button id="gerapdf" onclick="gerarpdf()">Generar PDF</button></form></div><div id="relatorio" class="col-xs-12"><div class="row"><div id="titulo" class="col-xs-12 no-padding-left"></div></div><div class="row"><div class="well" style="visibility: hidden" id="dadossafra"></div></div><div class="row"><div class="row"><div id="graficochp" class="col-xs-12 no-padding-left"><canvas id="grafcustosprod"></canvas></div></div><div class="row"><div id="tabelachp" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div><div class="row" style="margin-top:20px"><div class="row"><div id="graficochd" class="col-xs-12 no-padding-left"><canvas id="grafcustosdef"></canvas></div></div><div class="row"><div id="tabelachd" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div><div class="row" style="margin-top:20px"><div class="row"><div id="graficochf" class="col-xs-12 no-padding-left"><canvas id="grafcustosfert"></canvas></div></div><div class="row"><div id="tabelachf" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div></div></div></div>');
$templateCache.put('app/entities/relatorio/relatorios.html','<script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.4.0/Chart.min.js"></script><script>function addImagemPdf(idCanva, conteudo, largura){\n    var im = {};\n    var canvas = document.querySelector(idCanva).toDataURL(\'image/png\', 1.0);\n    im.image = canvas;\n    im.width = largura;\n    conteudo.push(im);\n}\n\nfunction addLogo(conteudo, largura){\n    var im = {};\n    im.image = "data:image/png;base64,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";\n    im.width = largura;\n    im.alignment = \'center\';\n    conteudo.push(im);\n}\n\nfunction addTabelaPdf(idtabela, conteudo, ling){\n    var tblconf = {}; //conteiner da tabela\n    var tbl = {}; //tabela\n    tblconf.layout = \'lightHorizontalLines\';\n\n    if(ling===\'pt\') tbl.body = [[\'Tipo de Gasto\', \'Valor (R$)\']];\n    else if(ling ===\'en\') tbl.body = [[\'Type of expense\', \'Value ($)\']];\n    else if (ling===\'es\') tbl.body = [[\'Tipo de Costo\', \'Valor ($)\']]\n\n    tbl.widths = [\'*\', \'*\'];\n    tbl.headerRows = 1;\n\n    tabhtml = $(idtabela + " tbody");\n    tabhtml.find(\'tr\').each(function (i, el){\n        var $tds = $(this).find(\'td\'),\n            tipo = $tds.eq(0).text(),\n            valor = $tds.eq(1).text();\n        tbl.body.push([tipo, valor]);\n    });\n    \n    tblconf.table = tbl;\n\n    conteudo.push(tblconf);\n}\n\nfunction addTabelaPdf2(idtabela, conteudo, ling){\n    var tblconf = {}; //conteiner da tabela\n    var tbl = {}; //tabela\n    tblconf.layout = \'lightHorizontalLines\';\n\n    if(ling===\'pt\')\n        tbl.body = [[\'Tipo de Gasto\', \'Valor Habitual (R$)\', \'Valor NetWord (R$)\']];\n    else if(ling===\'en\')\n        tbl.body = [[\'Type of Expense\', \'Habitual Value ($)\', \'NetWord Value ($)\']];\n    else if(ling===\'es\') \n        tbl.body = [[\'Tipo de Costo\', \'Valor Habitual ($)\', \'Valor NetWord ($)\']];\n\n    \n    tbl.widths = [\'*\', \'*\', \'*\'];\n    tbl.headerRows = 1;\n\n    tabhtml = $(idtabela + " tbody");\n    tabhtml.find(\'tr\').each(function (i, el){\n        var $tds = $(this).find(\'td\'),\n            tipo = $tds.eq(0).text(),\n            valor1 = $tds.eq(1).text();\n            valor2 = $tds.eq(2).text();\n        tbl.body.push([tipo, valor1, valor2]);\n    });\n    \n    tblconf.table = tbl;\n\n    conteudo.push(tblconf);\n}\n\nfunction addMomentoPdf(conteudo, ling){\n    // Obt\xE9m a data/hora atual\n    var data = new Date();\n\n    // Guarda cada peda\xE7o em uma vari\xE1vel\n    var dia     = data.getDate();           // 1-31\n    var dia_sem = data.getDay();            // 0-6 (zero=domingo)\n    var mes     = data.getMonth();          // 0-11 (zero=janeiro)\n    var ano4    = data.getFullYear();       // 4 d\xEDgitos\n    var hora    = data.getHours();          // 0-23\n    var min     = data.getMinutes();        // 0-59\n    var seg     = data.getSeconds();        // 0-59\n\n    // Formata a data e a hora (note o m\xEAs + 1)\n    var str_data = dia + \'/\' + (mes+1) + \'/\' + ano4;\n    var str_hora = hora + \':\' + min + \':\' + seg;\n\n    var str_data_en =  (mes+1) + \'/\' + dia + \'/\' + ano4;\n\n    // Mostra o resultado\n    if(ling===\'pt\') conteudo.push(\'Relat\xF3rio gerado em \' + str_data + \' \xE0s \' + str_hora);\n    else if(ling===\'en\') conteudo.push(\'Report generated in \' + str_data_en + \' , \' + str_hora);\n    else if(ling===\'es\') conteudo.push(\'Relatorio generado en \' + str_data + \' , \' + str_hora);\n\n}</script><script type="text/javascript">function linguagem(){   \n        $.ajax({\n            url: \'/api/account/\',\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) { \n                var linguagem = json.langKey;\n\n                if(linguagem==="en"){\n                    window.location.assign("/#/relatorios-en");\n                }\n                else if(linguagem==="es"){\n                    window.location.assign("/#/relatorios-es");\n                }\n            }\n        });\n    }\n\n    function preencheSelector(){\n        $(\'#gerapdf\').attr(\'disabled\', true);\n        console.log("Exec");\n        var $select = $(\'#selecsafra\');\n\n        $.ajax({\n            url: \'/api/nomesafras/\',\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) { \n                $select.html(\'\');\n                listaOpcoes = json.map(function(item) {\n                    return item.nome;\n                });\n\n                for (i = 0; i < listaOpcoes.length; i++) {\n                    $select.append(\'<option id="\' + listaOpcoes[i] + \'">\' + listaOpcoes[i] + \'</option>\');\n                }\n                console.log("preenchido");\n                },\n                error: function(jqXHR, textStatus, errorThrown){\n                    alert(errorThrown);\n                }\n        });\n\n    }\n\n    function dadosSafra(safra){\n        var tipoSafra = {\n                "verao":"Ver\xE3o",\n                "safrinha":"Safrinha",\n                "inverno": "Inverno"\n        };\n\n        var urlJSON = "/api/dadossafra/" + safra;\n\n        $.ajax({\n            url: urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) { \n                propriedade = json.map(function(item) {\n                    return item.nomepropriedade;\n                });\n\n                ano = json.map(function(item) {\n                    return item.ano;\n                });\n\n                tsafra = json.map(function(item) {\n                    return tipoSafra[item.safra];\n                });\n\n                nomeSafra = json.map(function(item) {\n                    return item.nome;\n                });\n\n                $("#titulo").html("<h3>Relat\xF3rio de custos: <small id=\'nomeprop\'>" + propriedade + "</small></h3>");\n                $("#dadossafra").css(\'visibility\', \'visible\');\n                $("#dadossafra").html(\'Nome da safra: \' + nomeSafra + \'<br>\' + \'Safra: \' + tsafra + \'<br>\' + \'Ano da safra: \' + ano + \'<br>\');\n            }\n        });  \n    }\n\n    function limpa(){\n        $("#graficochf").html(\'\');\n        $("#graficochf").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosfert"></canvas>\');\n        $("#graficochp").html(\'\');\n        $("#graficochp").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosprod"></canvas>\');\n        $("#graficochd").html(\'\');\n        $("#graficochd").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosdef"></canvas>\');\n        $("#tabelachd").html(\'\');\n        $("#tabelachf").html(\'\');\n        $("#tabelachp").html(\'\');\n    }\n\n    function dadosFert(safra){\n        var lblfert = {\n                "fertilizantequimico":"Fertilizante Qu\xEDmico",\n                "fertilizantefoliar":"Fertilizante Foliar",\n                "materialorganico":"Material Org\xE2nico",\n                "corretivo":"Corretivo"\n        };\n\n        var urlJSON = "/api/custohabfertsafra/" + safra;\n\n        $.ajax({\n            url: urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) { \n            \n                listaTipo = json.map(function(item) {\n                    return lblfert[item.tipo];\n                });\n\n                listaValor = json.map(function(item) {\n                    return item.valor;\n                });\n                \n                console.log(listaTipo); console.log(listaValor);\n\n                var ctx = document.getElementById(\'grafcustosfert\').getContext(\'2d\');\n\n                var chart = new Chart(ctx, {\n                    type: \'bar\',\n\n                    data: {\n                        labels: Object.values(lblfert),\n                        datasets: [{\n                            label: "Custos de fertilizantes",\n                            backgroundColor: \'rgb(204, 255, 102)\', \n                            //borderColor: \'rgb(255, 99, 132)\',\n                            data: listaValor,\n                        }]\n                    },\n\n                    // Configuration options go here\n                    options: {\n                        scales: {\n                            yAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Valor (R$)\'\n                            },   \n                            ticks: {\n                                suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                            }\n                            }],\n\n                            xAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Tipo de custo\'\n                            }\n                            }]\n                        }     \n\n                    }\n                });\n\n                $("#tabelachf").append(\'<table class="table table-striped" id="tabchf"></table>\');\n                $("#tabchf").append(\'<tbody id="tabchfbody"></tbody>\');\n                $("#tabchf").append(\'<thead><tr><th>Tipo de Gasto</th> <th>Valor (R$)</th></tr></thead>\');\n                for(i=0; i<listaTipo.length; i++){\n                    $("#tabchfbody").append(\'<tr> <td>\' + listaTipo[i] + \'</td> <td> \' + listaValor[i] + \'</td> </tr>\');\n                }   \n            }\n        });\n    }\n\n    function dadosDef(safra){\n         \n        var lbldef = {\n            "inseticidaparasemente": "Inseticida para Semente",\n            "inseticidaparalagarta": "Inseticida para Lagarta",\n            "inseticidaparapercevejo": "Inseticida para Percevejo",\n            "fungicidaparasemente": "Fungicida para Semente",\n            "fungicida": "Fungicida",\n            "herbicidaparaplantadaninha": "Herbicida para Planta Daninha",\n            "herbicidaparaprecolheita": "Herbicida para Pr\xE9-Colheita",\n            "larvicida": "Larvicida"\n        };\n\n        var urlJSON = "/api/custohabdefsafra/" + safra;\n\n        $.ajax({\n            url: urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) { \n                listaTipo = json.map(function(item) {\n                    return lbldef[item.tipo];\n                });\n\n                listaValor = json.map(function(item) {\n                    return item.valor;\n                });\n                \n                console.log(listaTipo); console.log(listaValor);\n\n                var ctx = document.getElementById(\'grafcustosdef\').getContext(\'2d\');        \n\n                var chart = new Chart(ctx, {\n                    type: \'bar\',\n\n                    data: {\n                        labels: Object.values(lbldef),\n                        datasets: [{\n                            label: "Custos de defensivos",\n                            backgroundColor: \'rgb(255, 102, 102)\', \n                            //borderColor: \'rgb(255, 99, 132)\',\n                            data: listaValor,\n                        }]\n                    },\n\n                    // Configuration options go here\n                    options: {\n                        scales: {\n                            yAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Valor (R$)\'\n                            },   \n                            ticks: {\n                                suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                            }\n                            }],\n\n                            xAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Tipo de custo\'\n                            }\n                            }]\n                        }     \n\n                    }\n                });\n\n                $("#tabelachd").append(\'<table class="table table-striped" id="tabchd"></table>\');\n                $("#tabchd").append(\'<tbody id="tabchdbody"></tbody>\');\n                $("#tabchd").append(\'<thead><tr><th>Tipo de Gasto</th> <th>Valor (R$)</th></tr></thead>\');\n                for(i=0; i<listaTipo.length; i++){\n                    $("#tabchdbody").append(\'<tr> <td>\' + listaTipo[i] + \'</td> <td> \' + listaValor[i] + \'</td> </tr>\');\n                }\n            }\n        });\n    }\n\n    function dadosProd(safra){\n        var lblprod = {\n            "analisedesolo": "An\xE1lise de Solo",\n            "combustivel": "Combust\xEDvel da M\xE1quina",\n            "operacaodamaquina": "Opera\xE7\xE3o da M\xE1quina",\n            "alugueldamaquina": "Aluguel da M\xE1quina",\n            "manutencaodamaquina": "Manuten\xE7\xE3o da M\xE1quina"\n        };\n\n        \n        var urlJSON = "/api/custohabprodsafra/" + safra;\n\n        $.ajax({\n            url: urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) { \n\n                listaTipo = json.map(function(item) {\n                    return lblprod[item.tipo];\n                });\n\n                listaValor = json.map(function(item) {\n                    return item.valor;\n                });\n                \n                console.log(listaTipo); console.log(listaValor);\n                \n                var ctx = document.getElementById(\'grafcustosprod\').getContext(\'2d\');\n                \n                var chart = new Chart(ctx, {\n                    type: \'bar\',\n\n                    data: {\n                        labels: Object.values(lblprod),\n                        datasets: [{\n                            label: "Custos de produ\xE7\xE3o",\n                            backgroundColor: \'rgb(153, 204, 255)\', \n                            //borderColor: \'rgb(255, 99, 132)\',\n                            data: listaValor,\n                        }]\n                    },\n\n                    // Configuration options go here\n                    options: {\n                        scales: {\n                            yAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Valor (R$)\'\n                            },   \n                            ticks: {\n                                suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                            }\n                            }],\n\n                            xAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Tipo de custo\'\n                            }\n                            }]\n                        }     \n\n                    }\n                });\n\n                $("#tabelachp").append(\'<table class="table table-striped" id="tabchp"></table>\');\n                $("#tabchp").append(\'<tbody id="tabchpbody"></tbody>\');\n                $("#tabchp").append(\'<thead><tr><th>Tipo de Gasto</th> <th>Valor (R$)</th></tr></thead>\');\n                for(i=0; i<listaTipo.length; i++){\n                    $("#tabchpbody").append(\'<tr> <td>\' + listaTipo[i] + \'</td> <td> \' + listaValor[i] + \'</td> </tr>\');\n                }   \n            }\n        });\n    } \n\n    function montaRelatorio(){\n        $(\'#gerapdf\').attr(\'disabled\', false);\n\n        var $select = $(\'#selecsafra\');\n        var safra = $select.val();\n\n        limpa();\n        dadosSafra(safra);\n        dadosFert(safra);\n        dadosDef(safra);\n        dadosProd(safra);\n    }\n\n    function gerarpdf(){\n        var conteudo = [];\n\n        addLogo(conteudo, 100);\n\n        // Titulo do relat\xF3rio\n        conteudo.push(\' \');\n\n        var titulo = {};\n        titulo.text = \'Relat\xF3rio\';\n        titulo.fontSize = 15;\n        titulo.alignment = \'center\';\n        conteudo.push(titulo);\n\n        conteudo.push(\' \'); \n\n        conteudo.push("Propriedade: " + $(\'#nomeprop\').html());\n        conteudo.push(($("#dadossafra").html()).split(\'<br>\'));\n        \n        //Tabelas e imagens\n        conteudo.push(\' \');\n        conteudo.push(\'Custos de produ\xE7\xE3o\');\n        \n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosprod\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chp\n        addTabelaPdf("#tabelachp", conteudo, \'pt\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        conteudo.push(\'Custos de defensivos\');\n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosdef\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chd\n        addTabelaPdf("#tabelachd", conteudo, \'pt\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        conteudo.push(\'Custos de fertilizantes\');\n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosfert\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chf\n        addTabelaPdf("#tabelachf", conteudo, \'pt\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        addMomentoPdf(conteudo, \'pt\');\n\n        // Gera\xE7\xE3o do documento\n        var doc = { content: conteudo };\n        pdfMake.createPdf(doc).download();\n    }\n\n    linguagem();\n\n    preencheSelector();</script><div><div class="container-fluid"><div class="well">Selecione a safra:<form name="formSafra"><select id="selecsafra" name="safras"></select><button onclick="montaRelatorio()">Mostrar relat\xF3rio</button> <button id="gerapdf" onclick="gerarpdf()">Gerar PDF</button></form></div><div id="relatorio" class="col-xs-12"><div class="row"><div id="titulo" class="col-xs-12 no-padding-left"></div></div><div class="row"><div class="well" style="visibility: hidden" id="dadossafra"></div></div><div class="row"><div class="row"><div id="graficochp" class="col-xs-12 no-padding-left"><canvas id="grafcustosprod"></canvas></div></div><div class="row"><div id="tabelachp" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div><div class="row" style="margin-top:20px"><div class="row"><div id="graficochd" class="col-xs-12 no-padding-left"><canvas id="grafcustosdef"></canvas></div></div><div class="row"><div id="tabelachd" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div><div class="row" style="margin-top:20px"><div class="row"><div id="graficochf" class="col-xs-12 no-padding-left"><canvas id="grafcustosfert"></canvas></div></div><div class="row"><div id="tabelachf" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div></div></div></div>');
$templateCache.put('app/entities/regiao/regiao-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.regiao.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.regiao.delete.question" translate-values="{id: \'{{vm.regiao.id}}\'}">Are you sure you want to delete this Regiao?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/regiao/regiao-detail.html','<div><h2><span data-translate="netWordAgroApp.regiao.detail.title">Regiao</span> {{vm.regiao.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.regiao.nomeregiao">Nomeregiao</span></dt><dd><span>{{vm.regiao.nomeregiao}}</span></dd><dt><span data-translate="netWordAgroApp.regiao.imagemregiao">Imagemregiao</span></dt><dd><div ng-if="vm.regiao.imagemregiao"><a ng-click="vm.openFile(vm.regiao.imagemregiaoContentType, vm.regiao.imagemregiao)"><img data-ng-src="{{\'data:\' + vm.regiao.imagemregiaoContentType + \';base64,\' + vm.regiao.imagemregiao}}" style="max-width: 100%" alt="regiao image"> </a>{{vm.regiao.imagemregiaoContentType}}, {{vm.byteSize(vm.regiao.imagemregiao)}}</div></dd><dt><span data-translate="netWordAgroApp.regiao.pais">Pais</span></dt><dd><a ui-sref="pais-detail({id:vm.regiao.pais.id})">{{vm.regiao.pais.nomepais}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="regiao-detail.edit({id:vm.regiao.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/regiao/regiao-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRegiaoLabel" data-translate="netWordAgroApp.regiao.home.createOrEditLabel">Create or edit a Regiao</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.regiao.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.regiao.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.regiao.nomeregiao" for="field_nomeregiao">Nomeregiao</label><input type="text" class="form-control" name="nomeregiao" id="field_nomeregiao" ng-model="vm.regiao.nomeregiao" required ng-maxlength="30"><div ng-show="editForm.nomeregiao.$invalid"><p class="help-block" ng-show="editForm.nomeregiao.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nomeregiao.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">This field cannot be longer than 30 characters.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setImagemregiao($file, vm.regiao)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="netWordAgroApp.regiao.imagemregiao" for="field_imagemregiao">Imagemregiao</label><div><img data-ng-src="{{\'data:\' + vm.regiao.imagemregiaoContentType + \';base64,\' + vm.regiao.imagemregiao}}" style="max-height: 100px" ng-if="vm.regiao.imagemregiao" alt="regiao image"><div ng-if="vm.regiao.imagemregiao" class="help-block clearfix"><span class="pull-left">{{vm.regiao.imagemregiaoContentType}}, {{vm.byteSize(vm.regiao.imagemregiao)}}</span> <button type="button" ng-click="vm.regiao.imagemregiao=null;vm.regiao.imagemregiaoContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setImagemregiao($file, vm.regiao)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="imagemregiao" id="field_imagemregiao" ng-model="vm.regiao.imagemregiao" required> <input type="hidden" class="form-control" name="imagemregiaoContentType" id="field_imagemregiaoContentType" ng-model="vm.regiao.imagemregiaoContentType"><div ng-show="editForm.imagemregiao.$invalid"><p class="help-block" ng-show="editForm.imagemregiao.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.regiao.pais" for="field_pais">Pais</label><select class="form-control" id="field_pais" name="pais" ng-model="vm.regiao.pais" ng-options="pais as pais.nomepais for pais in vm.pais track by pais.id" required></select></div><div ng-show="editForm.pais.$invalid"><p class="help-block" ng-show="editForm.pais.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/regiao/regiaos.html','<div><h2 data-translate="netWordAgroApp.regiao.home.title">Regiaos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="regiao.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.regiao.home.createLabel">Create new Regiao</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.regiao.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomeregiao"><span data-translate="netWordAgroApp.regiao.nomeregiao">Nomeregiao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="imagemregiao"><span data-translate="netWordAgroApp.regiao.imagemregiao">Imagemregiao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pais.nomepais"><span data-translate="netWordAgroApp.regiao.pais">Pais</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="regiao in vm.regiaos track by regiao.id"><td><a ui-sref="regiao-detail({id:regiao.id})">{{regiao.id}}</a></td><td>{{regiao.nomeregiao}}</td><td><a ng-if="regiao.imagemregiao" ng-click="vm.openFile(regiao.imagemregiaoContentType, regiao.imagemregiao)"><img data-ng-src="{{\'data:\' + regiao.imagemregiaoContentType + \';base64,\' + regiao.imagemregiao}}" style="max-height: 30px" alt="regiao image"> </a><span ng-if="regiao.imagemregiao">{{regiao.imagemregiaoContentType}}, {{vm.byteSize(regiao.imagemregiao)}}</span></td><td><a ui-sref="pais-detail({id:regiao.pais.id})">{{regiao.pais.nomepais}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="regiao-detail({id:regiao.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="regiao.edit({id:regiao.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="regiao.delete({id:regiao.id})" class="btn btn-danger btn-sm" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/safra/safra-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.safra.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.safra.delete.question" translate-values="{id: \'{{vm.safra.id}}\'}">Are you sure you want to delete this Safra?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/safra/safra-detail.html','<div><h2><span data-translate="netWordAgroApp.safra.detail.title">Safra</span> {{vm.safra.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.safra.nomesafra">Nomesafra</span></dt><dd><span>{{vm.safra.nomesafra}}</span></dd><dt><span data-translate="netWordAgroApp.safra.safra">Safra</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tiposafra.\' + vm.safra.safra}}">{{vm.safra.safra}}</span></dd><dt><span data-translate="netWordAgroApp.safra.ano">Ano</span></dt><dd><span>{{vm.safra.ano}}</span></dd><dt><span data-translate="netWordAgroApp.safra.propriedade">Propriedade</span></dt><dd><a ui-sref="propriedade-detail({id:vm.safra.propriedade.id})">{{vm.safra.propriedade.nomepropriedade}}</a></dd><dt><span data-translate="netWordAgroApp.safra.cultura">Cultura</span></dt><dd><a ui-sref="cultura-detail({id:vm.safra.cultura.id})">{{vm.safra.cultura.nomecultura}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="safra-detail.edit({id:vm.safra.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/safra/safra-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySafraLabel" data-translate="netWordAgroApp.safra.home.createOrEditLabel">Create or edit a Safra</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.safra.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.safra.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.safra.nomesafra" for="field_nomesafra">Nomesafra</label><input type="text" class="form-control" name="nomesafra" id="field_nomesafra" ng-model="vm.safra.nomesafra" required ng-maxlength="30"><div ng-show="editForm.nomesafra.$invalid"><p class="help-block" ng-show="editForm.nomesafra.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nomesafra.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">This field cannot be longer than 30 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.safra.safra" for="field_safra">Safra</label><select class="form-control" name="safra" ng-model="vm.safra.safra" id="field_safra" required><option value="verao" data-translate="netWordAgroApp.Tiposafra.verao">verao</option><option value="inverno" data-translate="netWordAgroApp.Tiposafra.inverno">inverno</option><option value="safrinha" data-translate="netWordAgroApp.Tiposafra.safrinha">safrinha</option></select><div ng-show="editForm.safra.$invalid"><p class="help-block" ng-show="editForm.safra.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.safra.ano" for="field_ano">Ano</label><input type="number" class="form-control" name="ano" id="field_ano" ng-model="vm.safra.ano" required><div ng-show="editForm.ano.$invalid"><p class="help-block" ng-show="editForm.ano.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.ano.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label data-translate="netWordAgroApp.safra.propriedade" for="field_propriedade">Propriedade</label><select class="form-control" id="field_propriedade" name="propriedade" ng-model="vm.safra.propriedade" ng-options="propriedade as propriedade.nomepropriedade for propriedade in vm.propriedades track by propriedade.id" required></select></div><div ng-show="editForm.propriedade.$invalid"><p class="help-block" ng-show="editForm.propriedade.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="netWordAgroApp.safra.cultura" for="field_cultura">Cultura</label><select class="form-control" id="field_cultura" name="cultura" ng-model="vm.safra.cultura" ng-options="cultura as cultura.nomecultura for cultura in vm.culturas track by cultura.id" required></select></div><div ng-show="editForm.cultura.$invalid"><p class="help-block" ng-show="editForm.cultura.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/safra/safras.html','<div><h2 data-translate="netWordAgroApp.safra.home.title">Safras</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="safra.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.safra.home.createLabel">Create new Safra</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.safra.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomesafra"><span data-translate="netWordAgroApp.safra.nomesafra">Nomesafra</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="safra"><span data-translate="netWordAgroApp.safra.safra">Safra</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ano"><span data-translate="netWordAgroApp.safra.ano">Ano</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="propriedade.nomepropriedade"><span data-translate="netWordAgroApp.safra.propriedade">Propriedade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cultura.nomecultura"><span data-translate="netWordAgroApp.safra.cultura">Cultura</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="safra in vm.safras track by safra.id"><td><a ui-sref="safra-detail({id:safra.id})">{{safra.id}}</a></td><td>{{safra.nomesafra}}</td><td data-translate="{{\'netWordAgroApp.Tiposafra.\' + safra.safra}}">{{safra.safra}}</td><td>{{safra.ano}}</td><td><a ui-sref="propriedade-detail({id:safra.propriedade.id})">{{safra.propriedade.nomepropriedade}}</a></td><td><a ui-sref="cultura-detail({id:safra.cultura.id})">{{safra.cultura.nomecultura}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="safra-detail({id:safra.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="safra.edit({id:safra.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="safra.delete({id:safra.id})" class="btn btn-danger btn-sm" has-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/relatoriocustosnw/relatoriocustosnw-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.relatoriocustosnw.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.relatoriocustosnw.delete.question" translate-values="{id: \'{{vm.relatoriocustosnw.id}}\'}">Are you sure you want to delete this Relatoriocustosnw?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/relatoriocustosnw/relatoriocustosnw-detail.html','<div><h2><span data-translate="netWordAgroApp.relatoriocustosnw.detail.title">Relatoriocustosnw</span> {{vm.relatoriocustosnw.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="relatoriocustosnw-detail.edit({id:vm.relatoriocustosnw.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/relatoriocustosnw/relatoriocustosnw-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRelatoriocustosnwLabel" data-translate="netWordAgroApp.relatoriocustosnw.home.createOrEditLabel">Create or edit a Relatoriocustosnw</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.relatoriocustosnw.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.relatoriocustosnw.id" readonly="readonly"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/relatoriocustosnw/relatoriocustosnws-en.html','<script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.1.3/Chart.bundle.min.js"></script><script src="bower_components/pdfmake/build/pdfmake.min.js"></script><script src="bower_components/pdfmake/build/vfs_fonts.js"></script><script src="bower_components/criacaopdf.js"></script><script type="text/javascript">function preencheSelector(){\n        $(\'#gerapdf\').attr(\'disabled\', true);\n\n        var $select = $(\'#selecsafra\');\n\n        $.ajax({\n            url:  \'/api/nomesafras/\',\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) { \n                $select.html(\'\');\n                listaOpcoes = json.map(function(item) {\n                    return item.nome;\n                });\n\n                for (i = 0; i < listaOpcoes.length; i++) {\n                    $select.append(\'<option id="\' + listaOpcoes[i] + \'">\' + listaOpcoes[i] + \'</option>\');\n                }\n                console.log("preenchido");\n            }\n        });\n    }\n\n    function dadosSafra(safra){\n        var tipoSafra = {\n                "verao":"Summer",\n                "safrinha":"Midseason",\n                "inverno": "Winter"\n        };\n\n        var urlJSON = "/api/dadossafra/" + safra;\n\n        $.ajax({\n            url:  urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) { \n                propriedade = json.map(function(item) {\n                    return item.nomepropriedade;\n                });\n\n                ano = json.map(function(item) {\n                    return item.ano;\n                });\n\n                tsafra = json.map(function(item) {\n                    return tipoSafra[item.safra];\n                });\n\n                nomeSafra = json.map(function(item) {\n                    return item.nome;\n                });\n\n                $("#titulo").html("<h3>Costs Report: <small id=\'nomeprop\'>" + propriedade + "</small></h3>");\n                $("#dadossafra").css(\'visibility\', \'visible\');\n                $("#dadossafra").html(\'Harvest name: \' + nomeSafra + \'<br>\' + \'Harvest: \' + tsafra + \'<br>\' + \'Harvest Year: \' + ano + \'<br>\');\n            }\n        });\n\n  \n    }\n\n    function limpa(){\n        $("#graficochf").html(\'\');\n        $("#graficochf").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosfert"></canvas>\');\n        $("#graficochp").html(\'\');\n        $("#graficochp").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosprod"></canvas>\');\n        $("#graficochd").html(\'\');\n        $("#graficochd").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosdef"></canvas>\');\n        $("#tabelachd").html(\'\');\n        $("#tabelachf").html(\'\');\n        $("#tabelachp").html(\'\');\n    }\n\n    function dadosFert(safra){\n        var lblfert = {\n            "fertilizantequimico":"Chemical Fertilizer",\n            "fertilizantefoliar":"Foliar Fertilizer",\n            "materialorganico":"Organic Material",\n            "corretivo":"Corrective"\n        };\n\n        var urlJSON = "/api/custonwfertsafra/" + safra;\n\n        $.ajax({\n            url:  urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) { \n            \n                listaTipo = json.map(function(item) {\n                    return lblfert[item.tipo];\n                });\n\n                listaValor = json.map(function(item) {\n                    return item.valor;\n                });\n                \n                console.log(listaTipo); console.log(listaValor);\n\n                var ctx = document.getElementById(\'grafcustosfert\').getContext(\'2d\');\n\n                var chart = new Chart(ctx, {\n                    type: \'bar\',\n\n                    data: {\n                        labels: Object.values(lblfert),\n                        datasets: [{\n                            label: "Fertilizers Costs",\n                            backgroundColor: \'rgb(204, 255, 102)\', \n                            //borderColor: \'rgb(255, 99, 132)\',\n                            data: listaValor,\n                        }]\n                    },\n\n                    // Configuration options go here\n                    options: {\n                        scales: {\n                            yAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Value ($)\'\n                            },   \n                            ticks: {\n                                suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                            }\n                            }],\n\n                            xAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Type of Cost\'\n                            }\n                            }]\n                        }     \n\n                    }\n                });\n\n                $("#tabelachf").append(\'<table class="table table-striped" id="tabchf"></table>\');\n                $("#tabchf").append(\'<tbody id="tabchfbody"></tbody>\');\n                $("#tabchf").append(\'<thead><tr><th>Type of Cost</th> <th>Value ($)</th></tr></thead>\');\n                for(i=0; i<listaTipo.length; i++){\n                    $("#tabchfbody").append(\'<tr> <td>\' + listaTipo[i] + \'</td> <td> \' + listaValor[i] + \'</td> </tr>\');\n                }\n            }\n        });\n    }\n\n    function dadosDef(safra){\n         \n        var lbldef = {\n            "inseticidaparasemente": "Seed Inseticide",\n            "inseticidaparalagarta": "Caterpillar Inseticide",\n            "inseticidaparapercevejo": "Bedbug Inseticide",\n            "fungicidaparasemente": "Seed Fungicide",\n            "fungicida": "Fungicide",\n            "herbicidaparaplantadaninha": "Weed Herbicide",\n            "herbicidaparaprecolheita": "Pre Harvest Herbicide",\n            "larvicida": "Larvicide"\n        };\n\n        var urlJSON = "/api/custonwdefsafra/" + safra;\n\n         $.ajax({\n            url:  urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) {            \n            \n                listaTipo = json.map(function(item) {\n                    return lbldef[item.tipo];\n                });\n\n                listaValor = json.map(function(item) {\n                    return item.valor;\n                });\n                \n                console.log(listaTipo); console.log(listaValor);\n\n                var ctx = document.getElementById(\'grafcustosdef\').getContext(\'2d\');        \n\n                var chart = new Chart(ctx, {\n                    type: \'bar\',\n\n                    data: {\n                        labels: Object.values(lbldef),\n                        datasets: [{\n                            label: "Defensives Costs",\n                            backgroundColor: \'rgb(255, 102, 102)\', \n                            //borderColor: \'rgb(255, 99, 132)\',\n                            data: listaValor,\n                        }]\n                    },\n\n                    // Configuration options go here\n                    options: {\n                        scales: {\n                            yAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Value ($)\'\n                            },   \n                            ticks: {\n                                suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                            }\n                            }],\n\n                            xAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Type Of Cost\'\n                            }\n                            }]\n                        }     \n\n                    }\n                });\n\n                $("#tabelachd").append(\'<table class="table table-striped" id="tabchd"></table>\');\n                $("#tabchd").append(\'<tbody id="tabchdbody"></tbody>\');\n                $("#tabchd").append(\'<thead><tr><th>Type of Cost</th> <th>Value ($)</th></tr></thead>\');\n                for(i=0; i<listaTipo.length; i++){\n                    $("#tabchdbody").append(\'<tr> <td>\' + listaTipo[i] + \'</td> <td> \' + listaValor[i] + \'</td> </tr>\');\n                }\n            }\n        });\n    }\n\n    function dadosProd(safra){\n        var lblprod = {\n            "analisedesolo": "Soil Analysis",\n            "combustivel": "Fuel",\n            "operacaodamaquina": "Machine Operation",\n            "alugueldamaquina": "Machine Rent",\n            "manutencaodamaquina": "Machine Maintenance"\n        };\n\n        \n        var urlJSON = "/api/custonwprodsafra/" + safra;\n\n        $.ajax({\n            url:  urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) {             \n            \n                listaTipo = json.map(function(item) {\n                    return lblprod[item.tipo];\n                });\n\n                listaValor = json.map(function(item) {\n                    return item.valor;\n                });\n                \n                console.log(listaTipo); console.log(listaValor);\n                \n                var ctx = document.getElementById(\'grafcustosprod\').getContext(\'2d\');\n                \n                var chart = new Chart(ctx, {\n                    type: \'bar\',\n\n                    data: {\n                        labels: Object.values(lblprod),\n                        datasets: [{\n                            label: "Production costs",\n                            backgroundColor: \'rgb(153, 204, 255)\', \n                            //borderColor: \'rgb(255, 99, 132)\',\n                            data: listaValor,\n                        }]\n                    },\n\n                    // Configuration options go here\n                    options: {\n                        scales: {\n                            yAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Value ($)\'\n                            },   \n                            ticks: {\n                                suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                            }\n                            }],\n\n                            xAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Type Of Cost\'\n                            }\n                            }]\n                        }     \n\n                    }\n                });\n\n                $("#tabelachp").append(\'<table class="table table-striped" id="tabchp"></table>\');\n                $("#tabchp").append(\'<tbody id="tabchpbody"></tbody>\');\n                $("#tabchp").append(\'<thead><tr><th>Type of Cost</th> <th>Value ($)</th></tr></thead>\');\n                for(i=0; i<listaTipo.length; i++){\n                    $("#tabchpbody").append(\'<tr> <td>\' + listaTipo[i] + \'</td> <td> \' + listaValor[i] + \'</td> </tr>\');\n                }\n            }\n        });\n    } \n\n    function montaRelatorio(){\n        $(\'#gerapdf\').attr(\'disabled\', false);\n\n        var $select = $(\'#selecsafra\');\n        var safra = $select.val();\n\n        limpa();\n        dadosSafra(safra);\n        dadosFert(safra);\n        dadosDef(safra);\n        dadosProd(safra);\n    }\n\n    function gerarpdf(){\n        var conteudo = [];\n\n        addLogo(conteudo, 100);\n\n        // Titulo do relat\xF3rio\n        conteudo.push(\' \');\n\n        var titulo = {};\n        titulo.text = \'Costs Report Netword Agro\';\n        titulo.fontSize = 15;\n        titulo.alignment = \'center\';\n        conteudo.push(titulo);\n\n        conteudo.push(\' \'); \n\n        conteudo.push("Property: " + $(\'#nomeprop\').html());\n        conteudo.push(($("#dadossafra").html()).split(\'<br>\'));\n        \n        //Tabelas e imagens\n        conteudo.push(\' \');\n        conteudo.push(\'Production Costs\');\n        \n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosprod\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chp\n        addTabelaPdf("#tabelachp", conteudo, \'en\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        conteudo.push(\'Defensive Costs\');\n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosdef\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chd\n        addTabelaPdf("#tabelachd", conteudo, \'en\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        conteudo.push(\'Fertilizers Costs\');\n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosfert\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chf\n        addTabelaPdf("#tabelachf", conteudo, \'en\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        addMomentoPdf(conteudo, \'en\');\n\n        // Gera\xE7\xE3o do documento\n        var doc = { content: conteudo };\n        pdfMake.createPdf(doc).download();\n    }\n    preencheSelector();</script><div><div class="container-fluid"><div class="well">Select the harvest:<form name="formSafra"><select id="selecsafra" name="safras"></select><button onclick="montaRelatorio()">Show Report</button> <button id="gerapdf" onclick="gerarpdf()">Generate PDF</button></form></div><div id="relatorio" class="col-xs-12"><div class="row"><div id="titulo" class="col-xs-12 no-padding-left"></div></div><div class="row"><div class="well" style="visibility: hidden" id="dadossafra"></div></div><div class="row"><div class="row"><div id="graficochp" class="col-xs-12 no-padding-left"><canvas id="grafcustosprod"></canvas></div></div><div class="row"><div id="tabelachp" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div><div class="row" style="margin-top:20px"><div class="row"><div id="graficochd" class="col-xs-12 no-padding-left"><canvas id="grafcustosdef"></canvas></div></div><div class="row"><div id="tabelachd" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div><div class="row" style="margin-top:20px"><div class="row"><div id="graficochf" class="col-xs-12 no-padding-left"><canvas id="grafcustosfert"></canvas></div></div><div class="row"><div id="tabelachf" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div></div></div></div>');
$templateCache.put('app/entities/relatoriocustosnw/relatoriocustosnws-es.html','<script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.1.3/Chart.bundle.min.js"></script><script src="bower_components/pdfmake/build/pdfmake.min.js"></script><script src="bower_components/pdfmake/build/vfs_fonts.js"></script><script src="bower_components/criacaopdf.js"></script><script type="text/javascript">function preencheSelector(){\n        $(\'#gerapdf\').attr(\'disabled\', true);\n\n        var $select = $(\'#selecsafra\');\n\n        $.ajax({\n            url:  \'/api/nomesafras/\',\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) {             \n                $select.html(\'\');\n                listaOpcoes = json.map(function(item) {\n                    return item.nome;\n                });\n\n                for (i = 0; i < listaOpcoes.length; i++) {\n                    $select.append(\'<option id="\' + listaOpcoes[i] + \'">\' + listaOpcoes[i] + \'</option>\');\n                }\n                console.log("preenchido");\n            }\n        });\n    }\n\n    function dadosSafra(safra){\n        var tipoSafra = {\n                "verao":"Verano",\n                "safrinha":"Fuera de la temporada",\n                "inverno": "Invierno"\n        };\n\n        var urlJSON = "/api/dadossafra/" + safra;\n\n $.ajax({\n            url:  urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) { \n                propriedade = json.map(function(item) {\n                    return item.nomepropriedade;\n                });\n\n                ano = json.map(function(item) {\n                    return item.ano;\n                });\n\n                tsafra = json.map(function(item) {\n                    return tipoSafra[item.safra];\n                });\n\n                nomeSafra = json.map(function(item) {\n                    return item.nome;\n                });\n\n                $("#titulo").html("<h3>Informe de costos: <small id=\'nomeprop\'>" + propriedade + "</small></h3>");\n                $("#dadossafra").css(\'visibility\', \'visible\');\n                $("#dadossafra").html(\'Nombre de la cosecha: \' + nomeSafra + \'<br>\' + \'Cosecha: \' + tsafra + \'<br>\' + \'A\xF1o de la cosecha: \' + ano + \'<br>\');\n            }\n        });\n\n  \n    }\n\n    function limpa(){\n        $("#graficochf").html(\'\');\n        $("#graficochf").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosfert"></canvas>\');\n        $("#graficochp").html(\'\');\n        $("#graficochp").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosprod"></canvas>\');\n        $("#graficochd").html(\'\');\n        $("#graficochd").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosdef"></canvas>\');\n        $("#tabelachd").html(\'\');\n        $("#tabelachf").html(\'\');\n        $("#tabelachp").html(\'\');\n    }\n\n    function dadosFert(safra){\n        var lblfert = {\n                "fertilizantequimico":"Fertilizante Qu\xEDmico",\n                "fertilizantefoliar":"Fertilizante para Hoja",\n                "materialorganico":"Material Org\xE1nico",\n                "corretivo":"Correctivo"\n        };\n\n        var urlJSON = "/api/custonwfertsafra/" + safra;\n\n        $.ajax({\n            url:  urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) { \n           \n                listaTipo = json.map(function(item) {\n                    return lblfert[item.tipo];\n                });\n\n                listaValor = json.map(function(item) {\n                    return item.valor;\n                });\n                \n                console.log(listaTipo); console.log(listaValor);\n\n                var ctx = document.getElementById(\'grafcustosfert\').getContext(\'2d\');\n\n                var chart = new Chart(ctx, {\n                    type: \'bar\',\n\n                    data: {\n                        labels: Object.values(lblfert),\n                        datasets: [{\n                            label: "Costos con fertilizantes",\n                            backgroundColor: \'rgb(204, 255, 102)\', \n                            //borderColor: \'rgb(255, 99, 132)\',\n                            data: listaValor,\n                        }]\n                    },\n\n                    // Configuration options go here\n                    options: {\n                        scales: {\n                            yAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Valor ($)\'\n                            },   \n                            ticks: {\n                                suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                            }\n                            }],\n\n                            xAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Tipo de costo\'\n                            }\n                            }]\n                        }     \n\n                    }\n                });\n\n                $("#tabelachf").append(\'<table class="table table-striped" id="tabchf"></table>\');\n                $("#tabchf").append(\'<tbody id="tabchfbody"></tbody>\');\n                $("#tabchf").append(\'<thead><tr><th>Tipo de Costo</th> <th>Valor ($)</th></tr></thead>\');\n                for(i=0; i<listaTipo.length; i++){\n                    $("#tabchfbody").append(\'<tr> <td>\' + listaTipo[i] + \'</td> <td> \' + listaValor[i] + \'</td> </tr>\');\n                }\n            }\n        });\n    }\n\n    function dadosDef(safra){\n         \n        var lbldef = {\n            "inseticidaparasemente": "Insecticida para la Semilla",\n            "inseticidaparalagarta": "Insecticida para la Oruga",\n            "inseticidaparapercevejo": "Insecticida para la Chincheta",\n            "fungicidaparasemente": "Fungicida para la Semilla",\n            "fungicida": "Fungicida",\n            "herbicidaparaplantadaninha": "Herbicida para la Planta Da\xF1ina",\n            "herbicidaparaprecolheita": "Herbicida para Pre-cosecha",\n            "larvicida": "Larvicida"\n        };\n\n        var urlJSON = "/api/custonwdefsafra/" + safra;\n\n        $.ajax({\n            url:  urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) {             \n            listaTipo = json.map(function(item) {\n                return lbldef[item.tipo];\n            });\n\n                listaValor = json.map(function(item) {\n                    return item.valor;\n                });\n                \n                console.log(listaTipo); console.log(listaValor);\n\n                var ctx = document.getElementById(\'grafcustosdef\').getContext(\'2d\');        \n\n                var chart = new Chart(ctx, {\n                    type: \'bar\',\n\n                    data: {\n                        labels: Object.values(lbldef),\n                        datasets: [{\n                            label: "Costos con defensivos",\n                            backgroundColor: \'rgb(255, 102, 102)\', \n                            //borderColor: \'rgb(255, 99, 132)\',\n                            data: listaValor,\n                        }]\n                    },\n\n                    // Configuration options go here\n                    options: {\n                        scales: {\n                            yAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Valor ($)\'\n                            },   \n                            ticks: {\n                                suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                            }\n                            }],\n\n                            xAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Tipo de costo\'\n                            }\n                            }]\n                        }     \n\n                    }\n                });\n\n                $("#tabelachd").append(\'<table class="table table-striped" id="tabchd"></table>\');\n                $("#tabchd").append(\'<tbody id="tabchdbody"></tbody>\');\n                $("#tabchd").append(\'<thead><tr><th>Tipo de Costo</th> <th>Valor ($)</th></tr></thead>\');\n                for(i=0; i<listaTipo.length; i++){\n                    $("#tabchdbody").append(\'<tr> <td>\' + listaTipo[i] + \'</td> <td> \' + listaValor[i] + \'</td> </tr>\');\n                }\n            }\n        });\n    }\n\n    function dadosProd(safra){\n        var lblprod = {\n            "analisedesolo": "An\xE1lisis de Suelo",\n            "combustivel": "Combustible de la M\xE1quina",\n            "operacaodamaquina": "Operaci\xF3n de la M\xE1quina",\n            "alugueldamaquina": "Alquiler de la M\xE1quina",\n            "manutencaodamaquina": "Mantenimiento de la M\xE1quina"\n        };\n\n        \n        var urlJSON = "/api/custonwprodsafra/" + safra;\n\n        $.ajax({\n            url:  urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) {             \n            \n                listaTipo = json.map(function(item) {\n                    return lblprod[item.tipo];\n                });\n\n                listaValor = json.map(function(item) {\n                    return item.valor;\n                });\n                \n                console.log(listaTipo); console.log(listaValor);\n                \n                var ctx = document.getElementById(\'grafcustosprod\').getContext(\'2d\');\n                \n                var chart = new Chart(ctx, {\n                    type: \'bar\',\n\n                    data: {\n                        labels: Object.values(lblprod),\n                        datasets: [{\n                            label: "Costos de producci\xF3n",\n                            backgroundColor: \'rgb(153, 204, 255)\', \n                            //borderColor: \'rgb(255, 99, 132)\',\n                            data: listaValor,\n                        }]\n                    },\n\n                    // Configuration options go here\n                    options: {\n                        scales: {\n                            yAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Valor ($)\'\n                            },   \n                            ticks: {\n                                suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                            }\n                            }],\n\n                            xAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Tipo de costo\'\n                            }\n                            }]\n                        }     \n\n                    }\n                });\n\n                $("#tabelachp").append(\'<table class="table table-striped" id="tabchp"></table>\');\n                $("#tabchp").append(\'<tbody id="tabchpbody"></tbody>\');\n                $("#tabchp").append(\'<thead><tr><th>Tipo de Costo</th> <th>Valor ($)</th></tr></thead>\');\n                for(i=0; i<listaTipo.length; i++){\n                    $("#tabchpbody").append(\'<tr> <td>\' + listaTipo[i] + \'</td> <td> \' + listaValor[i] + \'</td> </tr>\');\n                }\n            }\n        });\n    } \n\n    function montaRelatorio(){\n        $(\'#gerapdf\').attr(\'disabled\', false);\n\n        var $select = $(\'#selecsafra\');\n        var safra = $select.val();\n\n        limpa();\n        dadosSafra(safra);\n        dadosFert(safra);\n        dadosDef(safra);\n        dadosProd(safra);\n    }\n\n    function gerarpdf(){\n        var conteudo = [];\n\n        addLogo(conteudo, 100);\n\n        // Titulo do relat\xF3rio\n        conteudo.push(\' \');\n\n        var titulo = {};\n        titulo.text = \'Informe de Costos Netword Agro\';\n        titulo.fontSize = 15;\n        titulo.alignment = \'center\';\n        conteudo.push(titulo);\n\n        conteudo.push(\' \'); \n\n        conteudo.push("Propriedade: " + $(\'#nomeprop\').html());\n        conteudo.push(($("#dadossafra").html()).split(\'<br>\'));\n        \n        //Tabelas e imagens\n        conteudo.push(\' \');\n        conteudo.push(\'Costos de producci\xF3n\');\n        \n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosprod\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chp\n        addTabelaPdf("#tabelachp", conteudo, \'es\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        conteudo.push(\'Costos con defensivos\');\n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosdef\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chd\n        addTabelaPdf("#tabelachd", conteudo, \'es\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        conteudo.push(\'Costos con fertilizantes\');\n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosfert\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chf\n        addTabelaPdf("#tabelachf", conteudo, \'es\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        addMomentoPdf(conteudo, \'es\');\n\n        // Gera\xE7\xE3o do documento\n        var doc = { content: conteudo };\n        pdfMake.createPdf(doc).download();\n    }\n    preencheSelector();</script><div><div class="container-fluid"><div class="well">Seleccione la cosecha:<form name="formSafra"><select id="selecsafra" name="safras"></select><button onclick="montaRelatorio()">Mostrar informe</button> <button id="gerapdf" onclick="gerarpdf()">Generar PDF</button></form></div><div id="relatorio" class="col-xs-12"><div class="row"><div id="titulo" class="col-xs-12 no-padding-left"></div></div><div class="row"><div class="well" style="visibility: hidden" id="dadossafra"></div></div><div class="row"><div class="row"><div id="graficochp" class="col-xs-12 no-padding-left"><canvas id="grafcustosprod"></canvas></div></div><div class="row"><div id="tabelachp" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div><div class="row" style="margin-top:20px"><div class="row"><div id="graficochd" class="col-xs-12 no-padding-left"><canvas id="grafcustosdef"></canvas></div></div><div class="row"><div id="tabelachd" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div><div class="row" style="margin-top:20px"><div class="row"><div id="graficochf" class="col-xs-12 no-padding-left"><canvas id="grafcustosfert"></canvas></div></div><div class="row"><div id="tabelachf" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div></div></div></div>');
$templateCache.put('app/entities/relatoriocustosnw/relatoriocustosnws.html','<script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.1.3/Chart.bundle.min.js"></script><script src="bower_components/pdfmake/build/pdfmake.min.js"></script><script src="bower_components/pdfmake/build/vfs_fonts.js"></script><script src="bower_components/criacaopdf.js"></script><script type="text/javascript">function linguagem(){   \n        $.ajax({\n            url:  \'/api/account/\',\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) { \n            var linguagem = json.langKey;\n\n            if(linguagem==="en"){\n                window.location.assign("/#/relatoriocustosnw-en");\n            }\n            else if(linguagem==="es"){\n                window.location.assign("/#/relatoriocustosnw-es");\n            }\n        }\n        });\n    }\n\n    function preencheSelector(){\n        $(\'#gerapdf\').attr(\'disabled\', true);\n\n        var $select = $(\'#selecsafra\');\n\n        $.ajax({\n            url:  \'/api/nomesafras/\',\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) {             \n                $select.html(\'\');\n                listaOpcoes = json.map(function(item) {\n                    return item.nome;\n                });\n\n                for (i = 0; i < listaOpcoes.length; i++) {\n                    $select.append(\'<option id="\' + listaOpcoes[i] + \'">\' + listaOpcoes[i] + \'</option>\');\n                }\n                console.log("preenchido");\n            }\n        });\n    }\n\n    function dadosSafra(safra){\n        var tipoSafra = {\n                "verao":"Ver\xE3o",\n                "safrinha":"Safrinha",\n                "inverno": "Inverno"\n        };\n\n        var urlJSON = "/api/dadossafra/" + safra;\n\n        $.ajax({\n            url:  urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) {             \n            \n                propriedade = json.map(function(item) {\n                    return item.nomepropriedade;\n                });\n\n                ano = json.map(function(item) {\n                    return item.ano;\n                });\n\n                tsafra = json.map(function(item) {\n                    return tipoSafra[item.safra];\n                });\n\n                nomeSafra = json.map(function(item) {\n                    return item.nome;\n                });\n\n                $("#titulo").html("<h3>Relat\xF3rio de custos: <small id=\'nomeprop\'>" + propriedade + "</small></h3>");\n                $("#dadossafra").css(\'visibility\', \'visible\');\n                $("#dadossafra").html(\'Nome da safra: \' + nomeSafra + \'<br>\' + \'Safra: \' + tsafra + \'<br>\' + \'Ano da safra: \' + ano + \'<br>\');\n            }\n        });\n\n  \n    }\n\n    function limpa(){\n        $("#graficochf").html(\'\');\n        $("#graficochf").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosfert"></canvas>\');\n        $("#graficochp").html(\'\');\n        $("#graficochp").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosprod"></canvas>\');\n        $("#graficochd").html(\'\');\n        $("#graficochd").append(\'<canvas style="background-color:rgb(246,246,246); padding: 10px; margin-bottom: 20px;" id="grafcustosdef"></canvas>\');\n        $("#tabelachd").html(\'\');\n        $("#tabelachf").html(\'\');\n        $("#tabelachp").html(\'\');\n    }\n\n    function dadosFert(safra){\n        var lblfert = {\n                "fertilizantequimico":"Fertilizante Qu\xEDmico",\n                "fertilizantefoliar":"Fertilizante Foliar",\n                "materialorganico":"Material Org\xE2nico",\n                "corretivo":"Corretivo"\n        };\n\n        var urlJSON = "/api/custonwfertsafra/" + safra;\n\n        $.ajax({\n            url:  urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) { \n\n                listaTipo = json.map(function(item) {\n                    return lblfert[item.tipo];\n                });\n\n                listaValor = json.map(function(item) {\n                    return item.valor;\n                });\n                \n                console.log(listaTipo); console.log(listaValor);\n\n                var ctx = document.getElementById(\'grafcustosfert\').getContext(\'2d\');\n\n                var chart = new Chart(ctx, {\n                    type: \'bar\',\n\n                    data: {\n                        labels: Object.values(lblfert),\n                        datasets: [{\n                            label: "Custos de fertilizantes",\n                            backgroundColor: \'rgb(204, 255, 102)\', \n                            //borderColor: \'rgb(255, 99, 132)\',\n                            data: listaValor,\n                        }]\n                    },\n\n                    // Configuration options go here\n                    options: {\n                        scales: {\n                            yAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Valor (R$)\'\n                            },   \n                            ticks: {\n                                suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                            }\n                            }],\n\n                            xAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Tipo de custo\'\n                            }\n                            }]\n                        }     \n\n                    }\n                });\n\n                $("#tabelachf").append(\'<table class="table table-striped" id="tabchf"></table>\');\n                $("#tabchf").append(\'<tbody id="tabchfbody"></tbody>\');\n                $("#tabchf").append(\'<thead><tr><th>Tipo de Gasto</th> <th>Valor (R$)</th></tr></thead>\');\n                for(i=0; i<listaTipo.length; i++){\n                    $("#tabchfbody").append(\'<tr> <td>\' + listaTipo[i] + \'</td> <td> \' + listaValor[i] + \'</td> </tr>\');\n                }\n            }\n        });\n    }\n\n    function dadosDef(safra){\n         \n        var lbldef = {\n            "inseticidaparasemente": "Inseticida para Semente",\n            "inseticidaparalagarta": "Inseticida para Lagarta",\n            "inseticidaparapercevejo": "Inseticida para Percevejo",\n            "fungicidaparasemente": "Fungicida para Semente",\n            "fungicida": "Fungicida",\n            "herbicidaparaplantadaninha": "Herbicida para Planta Daninha",\n            "herbicidaparaprecolheita": "Herbicida para Pr\xE9-Colheita",\n            "larvicida": "Larvicida"\n        };\n\n        var urlJSON = "/api/custonwdefsafra/" + safra;\n\n         $.ajax({\n            url:  urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) { \n                listaTipo = json.map(function(item) {\n                    return lbldef[item.tipo];\n                });\n\n                listaValor = json.map(function(item) {\n                    return item.valor;\n                });\n                \n                console.log(listaTipo); console.log(listaValor);\n\n                var ctx = document.getElementById(\'grafcustosdef\').getContext(\'2d\');        \n\n                var chart = new Chart(ctx, {\n                    type: \'bar\',\n\n                    data: {\n                        labels: Object.values(lbldef),\n                        datasets: [{\n                            label: "Custos de defensivos",\n                            backgroundColor: \'rgb(255, 102, 102)\', \n                            //borderColor: \'rgb(255, 99, 132)\',\n                            data: listaValor,\n                        }]\n                    },\n\n                    // Configuration options go here\n                    options: {\n                        scales: {\n                            yAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Valor (R$)\'\n                            },   \n                            ticks: {\n                                suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                            }\n                            }],\n\n                            xAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Tipo de custo\'\n                            }\n                            }]\n                        }     \n\n                    }\n                });\n\n                $("#tabelachd").append(\'<table class="table table-striped" id="tabchd"></table>\');\n                $("#tabchd").append(\'<tbody id="tabchdbody"></tbody>\');\n                $("#tabchd").append(\'<thead><tr><th>Tipo de Gasto</th> <th>Valor (R$)</th></tr></thead>\');\n                for(i=0; i<listaTipo.length; i++){\n                    $("#tabchdbody").append(\'<tr> <td>\' + listaTipo[i] + \'</td> <td> \' + listaValor[i] + \'</td> </tr>\');\n                }\n            }\n        });\n    }\n\n    function dadosProd(safra){\n        var lblprod = {\n            "analisedesolo": "An\xE1lise de Solo",\n            "combustivel": "Combust\xEDvel da M\xE1quina",\n            "operacaodamaquina": "Opera\xE7\xE3o da M\xE1quina",\n            "alugueldamaquina": "Aluguel da M\xE1quina",\n            "manutencaodamaquina": "Manuten\xE7\xE3o da M\xE1quina"\n        };\n\n        \n        var urlJSON = "/api/custonwprodsafra/" + safra;\n\n        $.ajax({\n            url:  urlJSON,\n            type: \'GET\',\n            beforeSend: function(xhr) {\n                xhr.setRequestHeader(\'Authorization\', \'Bearer \' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));\n            },\n            success: function(json) { \n                listaTipo = json.map(function(item) {\n                    return lblprod[item.tipo];\n                });\n\n                listaValor = json.map(function(item) {\n                    return item.valor;\n                });\n                \n                console.log(listaTipo); console.log(listaValor);\n                \n                var ctx = document.getElementById(\'grafcustosprod\').getContext(\'2d\');\n                \n                var chart = new Chart(ctx, {\n                    type: \'bar\',\n\n                    data: {\n                        labels: Object.values(lblprod),\n                        datasets: [{\n                            label: "Custos de produ\xE7\xE3o",\n                            backgroundColor: \'rgb(153, 204, 255)\', \n                            //borderColor: \'rgb(255, 99, 132)\',\n                            data: listaValor,\n                        }]\n                    },\n\n                    // Configuration options go here\n                    options: {\n                        scales: {\n                            yAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Valor (R$)\'\n                            },   \n                            ticks: {\n                                suggestedMin: 0  // minimum will be 0, unless there is a lower value.\n                            }\n                            }],\n\n                            xAxes: [{\n                            scaleLabel: {\n                                display: true,\n                                labelString: \'Tipo de custo\'\n                            }\n                            }]\n                        }     \n\n                    }\n                });\n\n                $("#tabelachp").append(\'<table class="table table-striped" id="tabchp"></table>\');\n                $("#tabchp").append(\'<tbody id="tabchpbody"></tbody>\');\n                $("#tabchp").append(\'<thead><tr><th>Tipo de Gasto</th> <th>Valor (R$)</th></tr></thead>\');\n                for(i=0; i<listaTipo.length; i++){\n                    $("#tabchpbody").append(\'<tr> <td>\' + listaTipo[i] + \'</td> <td> \' + listaValor[i] + \'</td> </tr>\');\n                }\n            }\n        });\n    } \n\n    function montaRelatorio(){\n        $(\'#gerapdf\').attr(\'disabled\', false);\n\n        var $select = $(\'#selecsafra\');\n        var safra = $select.val();\n\n        limpa();\n        dadosSafra(safra);\n        dadosFert(safra);\n        dadosDef(safra);\n        dadosProd(safra);\n    }\n\n    function gerarpdf(){\n        var conteudo = [];\n\n        addLogo(conteudo, 100);\n\n        // Titulo do relat\xF3rio\n        conteudo.push(\' \');\n\n        var titulo = {};\n        titulo.text = \'Relat\xF3rio dos Custos Netword Agro\';\n        titulo.fontSize = 15;\n        titulo.alignment = \'center\';\n        conteudo.push(titulo);\n\n        conteudo.push(\' \'); \n\n        conteudo.push("Propriedade: " + $(\'#nomeprop\').html());\n        conteudo.push(($("#dadossafra").html()).split(\'<br>\'));\n        \n        //Tabelas e imagens\n        conteudo.push(\' \');\n        conteudo.push(\'Custos de produ\xE7\xE3o\');\n        \n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosprod\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chp\n        addTabelaPdf("#tabelachp", conteudo, \'pt\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        conteudo.push(\'Custos de defensivos\');\n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosdef\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chd\n        addTabelaPdf("#tabelachd", conteudo, \'pt\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        conteudo.push(\'Custos de fertilizantes\');\n        //adi\xE7\xE3o de uma imagem - 500 \xE9 o tamanho ideal\n        addImagemPdf(\'#grafcustosfert\', conteudo, 500);\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        // tabela chf\n        addTabelaPdf("#tabelachf", conteudo, \'pt\');\n        conteudo.push(\' \'); conteudo.push(\' \');\n\n        addMomentoPdf(conteudo, \'pt\');\n\n        // Gera\xE7\xE3o do documento\n        var doc = { content: conteudo };\n        pdfMake.createPdf(doc).download();\n    }\n\n    linguagem();\n    preencheSelector();</script><div><div class="container-fluid"><div class="well">Selecione a safra:<form name="formSafra"><select id="selecsafra" name="safras"></select><button onclick="montaRelatorio()">Mostrar relat\xF3rio</button> <button id="gerapdf" onclick="gerarpdf()">Gerar PDF</button></form></div><div id="relatorio" class="col-xs-12"><div class="row"><div id="titulo" class="col-xs-12 no-padding-left"></div></div><div class="row"><div class="well" style="visibility: hidden" id="dadossafra"></div></div><div class="row"><div class="row"><div id="graficochp" class="col-xs-12 no-padding-left"><canvas id="grafcustosprod"></canvas></div></div><div class="row"><div id="tabelachp" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div><div class="row" style="margin-top:20px"><div class="row"><div id="graficochd" class="col-xs-12 no-padding-left"><canvas id="grafcustosdef"></canvas></div></div><div class="row"><div id="tabelachd" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div><div class="row" style="margin-top:20px"><div class="row"><div id="graficochf" class="col-xs-12 no-padding-left"><canvas id="grafcustosfert"></canvas></div></div><div class="row"><div id="tabelachf" class="col-xs-6 col-xs-offset-3 no-padding-left"></div></div></div></div></div></div>');
$templateCache.put('app/entities/sensor/sensor-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sensor.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.sensor.delete.question" translate-values="{id: \'{{vm.sensor.id}}\'}">Are you sure you want to delete this Sensor?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/sensor/sensor-detail.html','<div><h2><span data-translate="netWordAgroApp.sensor.detail.title">Sensor</span> {{vm.sensor.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.sensor.descricao">Descricao</span></dt><dd><span>{{vm.sensor.descricao}}</span></dd><dt><span data-translate="netWordAgroApp.sensor.status">Status</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipostatussensor.\' + vm.sensor.status}}">{{vm.sensor.status}}</span></dd><dt><span data-translate="netWordAgroApp.sensor.unidade">Unidade</span></dt><dd><a ui-sref="unidade-detail({id:vm.sensor.unidade.id})">{{vm.sensor.unidade.nome}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="sensor-detail.edit({id:vm.sensor.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/sensor/sensor-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySensorLabel" data-translate="netWordAgroApp.sensor.home.createOrEditLabel">Create or edit a Sensor</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.sensor.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sensor.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.sensor.descricao" for="field_descricao">Descricao</label><input type="text" class="form-control" name="descricao" id="field_descricao" ng-model="vm.sensor.descricao" required><div ng-show="editForm.descricao.$invalid"><p class="help-block" ng-show="editForm.descricao.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.sensor.status" for="field_status">Status</label><select class="form-control" name="status" ng-model="vm.sensor.status" id="field_status"><option value="funcionando" data-translate="netWordAgroApp.Tipostatussensor.funcionando">funcionando</option><option value="manutencao" data-translate="netWordAgroApp.Tipostatussensor.manutencao">manutencao</option><option value="problema" data-translate="netWordAgroApp.Tipostatussensor.problema">problema</option><option value="transporte" data-translate="netWordAgroApp.Tipostatussensor.transporte">transporte</option></select></div><div class="form-group"><label data-translate="netWordAgroApp.sensor.unidade" for="field_unidade">Unidade</label><select class="form-control" id="field_unidade" name="unidade" ng-model="vm.sensor.unidade" ng-options="unidade as unidade.nome for unidade in vm.unidades track by unidade.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/sensor/sensors.html','<div><h2 data-translate="netWordAgroApp.sensor.home.title">Sensors</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="sensor.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.sensor.home.createLabel">Create new Sensor</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.sensor.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.sensor.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span data-translate="netWordAgroApp.sensor.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="unidade.nome"><span data-translate="netWordAgroApp.sensor.unidade">Unidade</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="sensor in vm.sensors track by sensor.id"><td><a ui-sref="sensor-detail({id:sensor.id})">{{sensor.id}}</a></td><td>{{sensor.descricao}}</td><td data-translate="{{\'netWordAgroApp.Tipostatussensor.\' + sensor.status}}">{{sensor.status}}</td><td><a ui-sref="unidade-detail({id:sensor.unidade.id})">{{sensor.unidade.nome}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="sensor-detail({id:sensor.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="sensor.edit({id:sensor.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="sensor.delete({id:sensor.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/servico/servico-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.servico.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.servico.delete.question" translate-values="{id: \'{{vm.servico.id}}\'}">Are you sure you want to delete this Servico?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/servico/servico-detail.html','<script type="text/javascript">function Voltar(){\n        history.go(-1);\n    }</script><div><h2><span data-translate="netWordAgroApp.servico.detail.title">Servico</span> {{vm.servico.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.servico.nome">Nome</span></dt><dd><span>{{vm.servico.nome}}</span></dd><dt><span data-translate="netWordAgroApp.servico.descricao">Descricao</span></dt><dd><span>{{vm.servico.descricao}}</span></dd><dt><span data-translate="netWordAgroApp.servico.valor">Valor</span></dt><dd><span>{{vm.servico.valor}}</span></dd><dt><span data-translate="netWordAgroApp.servico.nomeresponsavel">Nomeresponsavel</span></dt><dd><span>{{vm.servico.nomeresponsavel}}</span></dd><dt><span data-translate="netWordAgroApp.servico.tiporesponsavel">Tiporesponsavel</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tiposervico.\' + vm.servico.tiporesponsavel}}">{{vm.servico.tiporesponsavel}}</span></dd><dt><span data-translate="netWordAgroApp.servico.datacontratacao">Datacontratacao</span></dt><dd><span>{{vm.servico.datacontratacao | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.servico.datarealizacao">Datarealizacao</span></dt><dd><span>{{vm.servico.datarealizacao | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.servico.fluxo">Fluxo</span></dt><dd><span data-translate="{{\'netWordAgroApp.Tipofluxo.\' + vm.servico.fluxo}}">{{vm.servico.fluxo}}</span></dd><dt><span data-translate="netWordAgroApp.servico.atividade">Atividade</span></dt><dd><a ui-sref="atividade-detail({id:vm.servico.atividade.id})">{{vm.servico.atividade.nome}}</a></dd></dl><button type="submit" onclick="Voltar()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="servico-detail.edit({id:vm.servico.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div><div><h2 data-translate="netWordAgroApp.alocacaoinsumos.home.title">Alocacaoinsumos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="alocacaoinsumos.new({idservico:vm.servico.id})"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.alocacaoinsumos.home.createLabel">Create new Alocacaoinsumos</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.alocacaoinsumos.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quantidade"><span data-translate="netWordAgroApp.alocacaoinsumos.quantidade">Quantidade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="medida"><span data-translate="netWordAgroApp.alocacaoinsumos.medida">Medida</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="servico.nome"><span data-translate="netWordAgroApp.alocacaoinsumos.servico">Servico</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="insumo.nome"><span data-translate="netWordAgroApp.alocacaoinsumos.insumo">Insumo</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="alocacaoinsumos in vm.alocacaoinsumos track by alocacaoinsumos.id"><td><a ui-sref="alocacaoinsumos-detail({id:alocacaoinsumos.id})">{{alocacaoinsumos.id}}</a></td><td>{{alocacaoinsumos.quantidade}}</td><td data-translate="{{\'netWordAgroApp.Tipomedidaalocacao.\' + alocacaoinsumos.medida}}">{{alocacaoinsumos.medida}}</td><td><a ui-sref="servico-detail({id:alocacaoinsumos.servico.id})">{{alocacaoinsumos.servico.nome}}</a></td><td><a ui-sref="insumo-detail({id:alocacaoinsumos.insumo.id})">{{alocacaoinsumos.insumo.nome}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="alocacaoinsumos-detail({id:alocacaoinsumos.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="alocacaoinsumos.edit({id:alocacaoinsumos.id, idservico:vm.servico.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="alocacaoinsumos.delete({id:alocacaoinsumos.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/servico/servico-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myServicoLabel" data-translate="netWordAgroApp.servico.home.createOrEditLabel">Create or edit a Servico</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.servico.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.servico.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.servico.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.servico.nome" required><div ng-show="editForm.nome.$invalid"><p class="help-block" ng-show="editForm.nome.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.servico.descricao" for="field_descricao">Descricao</label><input type="text" class="form-control" name="descricao" id="field_descricao" ng-model="vm.servico.descricao" required><div ng-show="editForm.descricao.$invalid"><p class="help-block" ng-show="editForm.descricao.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.servico.valor" for="field_valor">Valor</label><input type="number" class="form-control" name="valor" id="field_valor" ng-model="vm.servico.valor" required min="0"><div ng-show="editForm.valor.$invalid"><p class="help-block" ng-show="editForm.valor.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.valor.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.servico.nomeresponsavel" for="field_nomeresponsavel">Nomeresponsavel</label><input type="text" class="form-control" name="nomeresponsavel" id="field_nomeresponsavel" ng-model="vm.servico.nomeresponsavel"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.servico.tiporesponsavel" for="field_tiporesponsavel">Tiporesponsavel</label><select class="form-control" name="tiporesponsavel" ng-model="vm.servico.tiporesponsavel" id="field_tiporesponsavel" required><option value="terceirizado" data-translate="netWordAgroApp.Tiposervico.terceirizado">terceirizado</option><option value="naoterceirizado" data-translate="netWordAgroApp.Tiposervico.naoterceirizado">naoterceirizado</option></select><div ng-show="editForm.tiporesponsavel.$invalid"><p class="help-block" ng-show="editForm.tiporesponsavel.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.servico.datacontratacao" for="field_datacontratacao">Datacontratacao</label><div class="input-group"><input id="field_datacontratacao" type="text" class="form-control" name="datacontratacao" uib-datepicker-popup="{{dateformat}}" ng-model="vm.servico.datacontratacao" is-open="vm.datePickerOpenStatus.datacontratacao"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datacontratacao\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.servico.datarealizacao" for="field_datarealizacao">Datarealizacao</label><div class="input-group"><input id="field_datarealizacao" type="text" class="form-control" name="datarealizacao" uib-datepicker-popup="{{dateformat}}" ng-model="vm.servico.datarealizacao" is-open="vm.datePickerOpenStatus.datarealizacao" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datarealizacao\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.datarealizacao.$invalid"><p class="help-block" ng-show="editForm.datarealizacao.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.servico.fluxo" for="field_fluxo">Fluxo</label><select class="form-control" name="fluxo" ng-model="vm.servico.fluxo" id="field_fluxo" required><option value="receita" data-translate="netWordAgroApp.Tipofluxo.receita">receita</option><option value="despesa" data-translate="netWordAgroApp.Tipofluxo.despesa">despesa</option></select><div ng-show="editForm.fluxo.$invalid"><p class="help-block" ng-show="editForm.fluxo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><!--\n        <div class="form-group">\n            <label data-translate="netWordAgroApp.servico.atividade" for="field_atividade">Atividade</label>\n            <select class="form-control" id="field_atividade" name="atividade" ng-model="vm.servico.atividade" ng-options="atividade as atividade.nome for atividade in vm.atividades track by atividade.id">\n                <option value=""></option>\n            </select>\n        </div>\n    --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/servico/servicos.html','<div><h2 data-translate="netWordAgroApp.servico.home.title">Servicos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="servico.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.servico.home.createLabel">Create new Servico</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.servico.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.servico.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="netWordAgroApp.servico.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="valor"><span data-translate="netWordAgroApp.servico.valor">Valor</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomeresponsavel"><span data-translate="netWordAgroApp.servico.nomeresponsavel">Nomeresponsavel</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tiporesponsavel"><span data-translate="netWordAgroApp.servico.tiporesponsavel">Tiporesponsavel</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datacontratacao"><span data-translate="netWordAgroApp.servico.datacontratacao">Datacontratacao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datarealizacao"><span data-translate="netWordAgroApp.servico.datarealizacao">Datarealizacao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fluxo"><span data-translate="netWordAgroApp.servico.fluxo">Fluxo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="atividade.nome"><span data-translate="netWordAgroApp.servico.atividade">Atividade</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="servico in vm.servicos track by servico.id"><td><a ui-sref="servico-detail({id:servico.id})">{{servico.id}}</a></td><td>{{servico.nome}}</td><td>{{servico.descricao}}</td><td>{{servico.valor}}</td><td>{{servico.nomeresponsavel}}</td><td data-translate="{{\'netWordAgroApp.Tiposervico.\' + servico.tiporesponsavel}}">{{servico.tiporesponsavel}}</td><td>{{servico.datacontratacao | date:\'mediumDate\'}}</td><td>{{servico.datarealizacao | date:\'mediumDate\'}}</td><td data-translate="{{\'netWordAgroApp.Tipofluxo.\' + servico.fluxo}}">{{servico.fluxo}}</td><td><a ui-sref="atividade-detail({id:servico.atividade.id})">{{servico.atividade.nome}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="servico-detail({id:servico.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="servico.edit({id:servico.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="servico.delete({id:servico.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/solo/solo-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.solo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.solo.delete.question" translate-values="{id: \'{{vm.solo.id}}\'}">Are you sure you want to delete this Solo?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/solo/solo-detail.html','<div><h2><span data-translate="netWordAgroApp.solo.detail.title">Solo</span> {{vm.solo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.solo.nomesolo">Nomesolo</span></dt><dd><span>{{vm.solo.nomesolo}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="solo-detail.edit({id:vm.solo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/solo/solo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySoloLabel" data-translate="netWordAgroApp.solo.home.createOrEditLabel">Create or edit a Solo</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.solo.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.solo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.solo.nomesolo" for="field_nomesolo">Nomesolo</label><input type="text" class="form-control" name="nomesolo" id="field_nomesolo" ng-model="vm.solo.nomesolo" required ng-maxlength="35"><div ng-show="editForm.nomesolo.$invalid"><p class="help-block" ng-show="editForm.nomesolo.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nomesolo.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="35">This field cannot be longer than 35 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/solo/solos.html','<div><h2 data-translate="netWordAgroApp.solo.home.title">Solos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="solo.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.solo.home.createLabel">Create new Solo</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.solo.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomesolo"><span data-translate="netWordAgroApp.solo.nomesolo">Nomesolo</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="solo in vm.solos track by solo.id"><td><a ui-sref="solo-detail({id:solo.id})">{{solo.id}}</a></td><td>{{solo.nomesolo}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="solo-detail({id:solo.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="solo.edit({id:solo.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="solo.delete({id:solo.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/tecnico/tecnico-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tecnico.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.tecnico.delete.question" translate-values="{id: \'{{vm.tecnico.id}}\'}">Are you sure you want to delete this Tecnico?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tecnico/tecnico-detail.html','<div><h2><span data-translate="netWordAgroApp.tecnico.detail.title">Tecnico</span> {{vm.tecnico.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.tecnico.nome">Nome</span></dt><dd><span>{{vm.tecnico.nome}}</span></dd><dt><span data-translate="netWordAgroApp.tecnico.sobrenome">Sobrenome</span></dt><dd><span>{{vm.tecnico.sobrenome}}</span></dd><dt><span data-translate="netWordAgroApp.tecnico.cpf">Cpf</span></dt><dd><span>{{vm.tecnico.cpf}}</span></dd><dt><span data-translate="netWordAgroApp.tecnico.email">Email</span></dt><dd><span>{{vm.tecnico.email}}</span></dd><dt><span data-translate="netWordAgroApp.tecnico.foto">Foto</span></dt><dd><div ng-if="vm.tecnico.foto"><a ng-click="vm.openFile(vm.tecnico.fotoContentType, vm.tecnico.foto)"><img data-ng-src="{{\'data:\' + vm.tecnico.fotoContentType + \';base64,\' + vm.tecnico.foto}}" style="max-width: 100%" alt="tecnico image"> </a>{{vm.tecnico.fotoContentType}}, {{vm.byteSize(vm.tecnico.foto)}}</div></dd><dt><span data-translate="netWordAgroApp.tecnico.login">Login</span></dt><dd><span>{{vm.tecnico.login}}</span></dd><dt><span data-translate="netWordAgroApp.tecnico.unidade">Unidade</span></dt><dd><a ui-sref="unidade-detail({id:vm.tecnico.unidade.id})">{{vm.tecnico.unidade.nome}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="tecnico-detail.edit({id:vm.tecnico.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/tecnico/tecnico-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTecnicoLabel" data-translate="netWordAgroApp.tecnico.home.createOrEditLabel">Create or edit a Tecnico</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.tecnico.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.tecnico.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.tecnico.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.tecnico.nome"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.tecnico.sobrenome" for="field_sobrenome">Sobrenome</label><input type="text" class="form-control" name="sobrenome" id="field_sobrenome" ng-model="vm.tecnico.sobrenome"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.tecnico.cpf" for="field_cpf">Cpf</label><input type="text" class="form-control" name="cpf" id="field_cpf" ng-model="vm.tecnico.cpf"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.tecnico.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.tecnico.email"></div><div class="form-group" ngf-drop ngf-change="vm.setFoto($file, vm.tecnico)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="netWordAgroApp.tecnico.foto" for="field_foto">Foto</label><div><img data-ng-src="{{\'data:\' + vm.tecnico.fotoContentType + \';base64,\' + vm.tecnico.foto}}" style="max-height: 100px" ng-if="vm.tecnico.foto" alt="tecnico image"><div ng-if="vm.tecnico.foto" class="help-block clearfix"><span class="pull-left">{{vm.tecnico.fotoContentType}}, {{vm.byteSize(vm.tecnico.foto)}}</span> <button type="button" ng-click="vm.tecnico.foto=null;vm.tecnico.fotoContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setFoto($file, vm.tecnico)" accept="image/*" data-translate="entity.action.addimage">Add image</button></div><input type="hidden" class="form-control" name="foto" id="field_foto" ng-model="vm.tecnico.foto"> <input type="hidden" class="form-control" name="fotoContentType" id="field_fotoContentType" ng-model="vm.tecnico.fotoContentType"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.tecnico.login" for="field_login">Login</label><input type="text" class="form-control" name="login" id="field_login" ng-model="vm.tecnico.login"></div><div class="form-group"><label data-translate="netWordAgroApp.tecnico.unidade" for="field_unidade">Unidade</label><select class="form-control" id="field_unidade" name="unidade" ng-model="vm.tecnico.unidade" ng-options="unidade as unidade.nome for unidade in vm.unidades track by unidade.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/tecnico/tecnicos.html','<div><h2 data-translate="netWordAgroApp.tecnico.home.title">Tecnicos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="tecnico.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.tecnico.home.createLabel">Create new Tecnico</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.tecnico.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.tecnico.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sobrenome"><span data-translate="netWordAgroApp.tecnico.sobrenome">Sobrenome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cpf"><span data-translate="netWordAgroApp.tecnico.cpf">Cpf</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="netWordAgroApp.tecnico.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="foto"><span data-translate="netWordAgroApp.tecnico.foto">Foto</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="netWordAgroApp.tecnico.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="unidade.nome"><span data-translate="netWordAgroApp.tecnico.unidade">Unidade</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="tecnico in vm.tecnicos track by tecnico.id"><td><a ui-sref="tecnico-detail({id:tecnico.id})">{{tecnico.id}}</a></td><td>{{tecnico.nome}}</td><td>{{tecnico.sobrenome}}</td><td>{{tecnico.cpf}}</td><td>{{tecnico.email}}</td><td><a ng-if="tecnico.foto" ng-click="vm.openFile(tecnico.fotoContentType, tecnico.foto)"><img data-ng-src="{{\'data:\' + tecnico.fotoContentType + \';base64,\' + tecnico.foto}}" style="max-height: 30px" alt="tecnico image"> </a><span ng-if="tecnico.foto">{{tecnico.fotoContentType}}, {{vm.byteSize(tecnico.foto)}}</span></td><td>{{tecnico.login}}</td><td><a ui-sref="unidade-detail({id:tecnico.unidade.id})">{{tecnico.unidade.nome}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="tecnico-detail({id:tecnico.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="tecnico.edit({id:tecnico.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="tecnico.delete({id:tecnico.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/tarefa/tarefa-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tarefa.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.tarefa.delete.question" translate-values="{id: \'{{vm.tarefa.id}}\'}">Are you sure you want to delete this Tarefa?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tarefa/tarefa-detail.html','<div><h2><span data-translate="netWordAgroApp.tarefa.detail.title">Tarefa</span> {{vm.tarefa.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.tarefa.latitude">Latitude</span></dt><dd><span>{{vm.tarefa.latitude}}</span></dd><dt><span data-translate="netWordAgroApp.tarefa.longitude">Longitude</span></dt><dd><span>{{vm.tarefa.longitude}}</span></dd><dt><span data-translate="netWordAgroApp.tarefa.tipo">Tipo</span></dt><dd><span>{{vm.tarefa.tipo}}</span></dd><dt><span data-translate="netWordAgroApp.tarefa.datahora">Datahora</span></dt><dd><span>{{vm.tarefa.datahora}}</span></dd><dt><span data-translate="netWordAgroApp.tarefa.atividade">Atividade</span></dt><dd><a ui-sref="atividade-detail({id:vm.tarefa.atividade.id})">{{vm.tarefa.atividade.nome}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="tarefa-detail.edit({id:vm.tarefa.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/tarefa/tarefa-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTarefaLabel" data-translate="netWordAgroApp.tarefa.home.createOrEditLabel">Create or edit a Tarefa</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.tarefa.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.tarefa.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.tarefa.latitude" for="field_latitude">Latitude</label><input type="text" class="form-control" name="latitude" id="field_latitude" ng-model="vm.tarefa.latitude"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.tarefa.longitude" for="field_longitude">Longitude</label><input type="text" class="form-control" name="longitude" id="field_longitude" ng-model="vm.tarefa.longitude"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.tarefa.tipo" for="field_tipo">Tipo</label><input type="text" class="form-control" name="tipo" id="field_tipo" ng-model="vm.tarefa.tipo"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.tarefa.datahora" for="field_datahora">Datahora</label><input type="text" class="form-control" name="datahora" id="field_datahora" ng-model="vm.tarefa.datahora"></div><div class="form-group"><label data-translate="netWordAgroApp.tarefa.atividade" for="field_atividade">Atividade</label><select class="form-control" id="field_atividade" name="atividade" ng-model="vm.tarefa.atividade" ng-options="atividade as atividade.nome for atividade in vm.atividades track by atividade.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/tarefa/tarefas.html','<div><h2 data-translate="netWordAgroApp.tarefa.home.title">Tarefas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="tarefa.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.tarefa.home.createLabel">Create new Tarefa</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.tarefa.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="latitude"><span data-translate="netWordAgroApp.tarefa.latitude">Latitude</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="longitude"><span data-translate="netWordAgroApp.tarefa.longitude">Longitude</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipo"><span data-translate="netWordAgroApp.tarefa.tipo">Tipo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="datahora"><span data-translate="netWordAgroApp.tarefa.datahora">Datahora</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="atividade.nome"><span data-translate="netWordAgroApp.tarefa.atividade">Atividade</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="tarefa in vm.tarefas track by tarefa.id"><td><a ui-sref="tarefa-detail({id:tarefa.id})">{{tarefa.id}}</a></td><td>{{tarefa.latitude}}</td><td>{{tarefa.longitude}}</td><td>{{tarefa.tipo}}</td><td>{{tarefa.datahora}}</td><td><a ui-sref="atividade-detail({id:tarefa.atividade.id})">{{tarefa.atividade.nome}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="tarefa-detail({id:tarefa.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="tarefa.edit({id:tarefa.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="tarefa.delete({id:tarefa.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/unidade/unidade-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.unidade.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.unidade.delete.question" translate-values="{id: \'{{vm.unidade.id}}\'}">Are you sure you want to delete this Unidade?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/unidade/unidade-detail.html','<div><h2><span data-translate="netWordAgroApp.unidade.detail.title">Unidade</span> {{vm.unidade.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.unidade.nome">Nome</span></dt><dd><span>{{vm.unidade.nome}}</span></dd><dt><span data-translate="netWordAgroApp.unidade.cnpj">Cnpj</span></dt><dd><span>{{vm.unidade.cnpj}}</span></dd><dt><span data-translate="netWordAgroApp.unidade.email">Email</span></dt><dd><span>{{vm.unidade.email}}</span></dd><dt><span data-translate="netWordAgroApp.unidade.endereco">Endereco</span></dt><dd><span>{{vm.unidade.endereco}}</span></dd><dt><span data-translate="netWordAgroApp.unidade.telefone">Telefone</span></dt><dd><span>{{vm.unidade.telefone}}</span></dd><dt><span data-translate="netWordAgroApp.unidade.responsavel">Responsavel</span></dt><dd><span>{{vm.unidade.responsavel}}</span></dd><dt><span data-translate="netWordAgroApp.unidade.cpf">Cpf</span></dt><dd><span>{{vm.unidade.cpf}}</span></dd><dt><span data-translate="netWordAgroApp.unidade.login">Login</span></dt><dd><span>{{vm.unidade.login}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="unidade-detail.edit({id:vm.unidade.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/unidade/unidade-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUnidadeLabel" data-translate="netWordAgroApp.unidade.home.createOrEditLabel">Create or edit a Unidade</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.unidade.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.unidade.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.unidade.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.unidade.nome" required><div ng-show="editForm.nome.$invalid"><p class="help-block" ng-show="editForm.nome.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.unidade.cnpj" for="field_cnpj">Cnpj</label><input type="text" class="form-control" name="cnpj" id="field_cnpj" ng-model="vm.unidade.cnpj"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.unidade.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.unidade.email"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.unidade.endereco" for="field_endereco">Endereco</label><input type="text" class="form-control" name="endereco" id="field_endereco" ng-model="vm.unidade.endereco"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.unidade.telefone" for="field_telefone">Telefone</label><input type="text" class="form-control" name="telefone" id="field_telefone" ng-model="vm.unidade.telefone"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.unidade.responsavel" for="field_responsavel">Responsavel</label><input type="text" class="form-control" name="responsavel" id="field_responsavel" ng-model="vm.unidade.responsavel"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.unidade.cpf" for="field_cpf">Cpf</label><input type="text" class="form-control" name="cpf" id="field_cpf" ng-model="vm.unidade.cpf"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.unidade.login" for="field_login">Login</label><input type="text" class="form-control" name="login" id="field_login" ng-model="vm.unidade.login"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/unidade/unidades.html','<div><h2 data-translate="netWordAgroApp.unidade.home.title">Unidades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="unidade.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.unidade.home.createLabel">Create new Unidade</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.unidade.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="netWordAgroApp.unidade.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cnpj"><span data-translate="netWordAgroApp.unidade.cnpj">Cnpj</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="netWordAgroApp.unidade.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="endereco"><span data-translate="netWordAgroApp.unidade.endereco">Endereco</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="telefone"><span data-translate="netWordAgroApp.unidade.telefone">Telefone</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="responsavel"><span data-translate="netWordAgroApp.unidade.responsavel">Responsavel</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="cpf"><span data-translate="netWordAgroApp.unidade.cpf">Cpf</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="netWordAgroApp.unidade.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="unidade in vm.unidades track by unidade.id"><td><a ui-sref="unidade-detail({id:unidade.id})">{{unidade.id}}</a></td><td>{{unidade.nome}}</td><td>{{unidade.cnpj}}</td><td>{{unidade.email}}</td><td>{{unidade.endereco}}</td><td>{{unidade.telefone}}</td><td>{{unidade.responsavel}}</td><td>{{unidade.cpf}}</td><td>{{unidade.login}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="unidade-detail({id:unidade.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="unidade.edit({id:unidade.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="unidade.delete({id:unidade.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/uploadnw/uploadnw-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.uploadnw.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.uploadnw.delete.question" translate-values="{id: \'{{vm.uploadnw.id}}\'}">Are you sure you want to delete this Uploadnw?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/uploadnw/uploadnw-detail.html','<div><h2><span data-translate="netWordAgroApp.uploadnw.detail.title">Uploadnw</span> {{vm.uploadnw.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.uploadnw.data">Data</span></dt><dd><span>{{vm.uploadnw.data}}</span></dd><dt><span data-translate="netWordAgroApp.uploadnw.inicio">Inicio</span></dt><dd><span>{{vm.uploadnw.inicio}}</span></dd><dt><span data-translate="netWordAgroApp.uploadnw.fim">Fim</span></dt><dd><span>{{vm.uploadnw.fim}}</span></dd><dt><span data-translate="netWordAgroApp.uploadnw.propriedade">Propriedade</span></dt><dd><span>{{vm.uploadnw.propriedade}}</span></dd><dt><span data-translate="netWordAgroApp.uploadnw.usuario">Usuario</span></dt><dd><span>{{vm.uploadnw.usuario}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="uploadnw-detail.edit({id:vm.uploadnw.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/uploadnw/uploadnw-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUploadnwLabel" data-translate="netWordAgroApp.uploadnw.home.createOrEditLabel">Create or edit a Uploadnw</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.uploadnw.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.uploadnw.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.uploadnw.data" for="field_data">Data</label><input type="text" class="form-control" name="data" id="field_data" ng-model="vm.uploadnw.data"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.uploadnw.inicio" for="field_inicio">Inicio</label><input type="text" class="form-control" name="inicio" id="field_inicio" ng-model="vm.uploadnw.inicio"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.uploadnw.fim" for="field_fim">Fim</label><input type="text" class="form-control" name="fim" id="field_fim" ng-model="vm.uploadnw.fim"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.uploadnw.propriedade" for="field_propriedade">Propriedade</label><input type="text" class="form-control" name="propriedade" id="field_propriedade" ng-model="vm.uploadnw.propriedade"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.uploadnw.usuario" for="field_usuario">Usuario</label><input type="text" class="form-control" name="usuario" id="field_usuario" ng-model="vm.uploadnw.usuario"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/uploadnw/uploadnws.html','<div><h2>Uploads</h2><jhi-alert></jhi-alert><br><div class="container-fluid well" style="padding-left: 30px"><div class="row"><h3><span data-translate="netWordAgroApp.uploadnw.fazerupload">Fazer um upload</span></h3></div><div class="row"><div class="col-xs-6 no-padding-left"><span data-translate="netWordAgroApp.uploadnw.selecionepropriedade">Selecione a propriedade associada:</span><select class="form-control" id="field_propriedade" name="propriedade" ng-model="vm.propriedadeSelecionada" ng-options="propriedade as propriedade.nomepropriedade for propriedade in vm.propriedades track by propriedade.id" required ng-change="vm.changePropriedade()"><option value></option></select></div></div><br><div class="row"><div class="col-xs-6 no-padding-left"><span data-translate="netWordAgroApp.uploadnw.selecionesafra">Selecione a safra associada:</span><select class="form-control" id="field_safra" name="safras" ng-model="vm.safraSelecionada" ng-options="safra as safra.nomesafra for safra in vm.safras track by safra.id" required><option value></option></select></div></div><br><div class="row"><!--<input type="file" ng-model="vm.selectedFile" ng-click="vm.selectedFile = null;" ng-change="vm.setFile(vm.selectedFile)">--><div class="form-group col-xs-6 no-padding-left" ngf-drop ngf-change="vm.setFile($file, selectedFile)"><div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setFile($file, selectedFile)"><span data-translate="netWordAgroApp.uploadnw.escolherarquivo">Selecione o arquivo:</span></button> <span ng-show="vm.fileData!=null;">{{vm.fileData.name}}</span></div></div></div><br><div class="row"><span data-translate="netWordAgroApp.uploadnw.marcarprocessos">Marque os processamentos necess\xE1rios</span><br><br><b><span data-translate="netWordAgroApp.uploadnw.processamentoscomuns">Processamentos comuns</span></b><br></div><div class="row col-xs-10 well"><div class="col-xs-6 no-padding-left"><div class="form-group"><input type="checkbox" name="plantadaninha" id="field_plantadaninha" ng-model="vm.procPlantaDaninha"><label class="control-label" for="field_plantadaninha"><span data-translate="netWordAgroApp.uploadnw.plantadaninha">Planta Daninha</span></label><br><input type="checkbox" name="lagarta" id="field_lagarta" ng-model="vm.procLagarta"><label class="control-label" for="field_lagarta"><span data-translate="netWordAgroApp.uploadnw.lagarta">Lagarta</span></label><br><input type="checkbox" name="amargoso" id="field_amargoso" ng-model="vm.procAmargoso"><label class="control-label" for="field_amargoso"><span data-translate="netWordAgroApp.uploadnw.amargoso">Amargoso</span></label><br><input type="checkbox" name="manchaalvo" id="field_manchaalvo" ng-model="vm.procManchaAlvo"><label class="control-label" for="field_manchaalvo"><span data-translate="netWordAgroApp.uploadnw.manchaalvo">Mancha-Alvo</span></label><br><input type="checkbox" name="ferrugem" id="field_ferrugem" ng-model="vm.procFerrugem"><label class="control-label" for="field_ferrugem"><span data-translate="netWordAgroApp.uploadnw.ferrugem">Ferrugem</span></label><br><input type="checkbox" name="buva" id="field_buva" ng-model="vm.procBuva"><label class="control-label" for="field_buva"><span data-translate="netWordAgroApp.uploadnw.buva">Buva</span></label></div></div><div class="col-xs-6 no-padding-left"><div class="form-group"><input type="checkbox" name="percevejo" id="field_percevejo" ng-model="vm.procPercevejo"><label class="control-label" for="field_percevejo"><span data-translate="netWordAgroApp.uploadnw.percevejo">Percevejo</span></label><br><input type="checkbox" name="falhadeplantio" id="field_falhadeplantio" ng-model="vm.procFalhaDePlantio"><label class="control-label" for="field_falhadeplantio"><span data-translate="netWordAgroApp.uploadnw.falhaplantio">Falha de Plantio</span></label><br><input type="checkbox" name="milho" id="field_milho" ng-model="vm.procMilho"><label class="control-label" for="field_milho"><span data-translate="netWordAgroApp.uploadnw.milho">Milho</span></label><br><input type="checkbox" name="folhalarga" id="field_folhalarga" ng-model="vm.procFolhaLarga"><label class="control-label" for="field_folhalarga"><span data-translate="netWordAgroApp.uploadnw.folhalarga">>Folha Larga</span></label><br><input type="checkbox" name="folhaestreita" id="field_folhaestreita" ng-model="vm.procFolhaEstreita"><label class="control-label" for="field_folhaestreita"><span data-translate="netWordAgroApp.uploadnw.folhaestreita">>Folha Estreita</span></label></div></div></div><div class="row col-xs-12"><b><span data-translate="netWordAgroApp.uploadnw.processamentocana">Processamentos da cana</span></b><br></div><div class="row col-xs-6 well"><div class="col-xs-6 no-padding-left"><div class="form-group"><input type="checkbox" name="bicudo" id="field_bicudo" ng-model="vm.procBicudo"><label class="control-label" for="field_bicudo"><span data-translate="netWordAgroApp.uploadnw.bicudo">Bicudo</span></label><br><input type="checkbox" name="cigarrinha" id="field_cigarrinha" ng-model="vm.procCigarrinha"><label class="control-label" for="field_cigarrinha"><span data-translate="netWordAgroApp.uploadnw.cigarrinha">Cigarrinha</span></label><br><input type="checkbox" name="folhalargacana" id="field_folhalargacana" ng-model="vm.procFolhaLargaCana"><label class="control-label" for="field_folhalargacana"><span data-translate="netWordAgroApp.uploadnw.folhalarga">Folha Larga</span></label><br><input type="checkbox" name="folhaestreitacana" id="field_folhaestreitacana" ng-model="vm.procFolhaEstreitaCana"><label class="control-label" for="field_folhaestreitacana"><span data-translate="netWordAgroApp.uploadnw.folhaestreita">Folha Estreita</span></label><br><input type="checkbox" name="brocadacana" id="field_brocadacana" ng-model="vm.procBrocaDaCana"><label class="control-label" for="field_brocadacana"><span data-translate="netWordAgroApp.uploadnw.broca">Broca da Cana</span></label><br><input type="checkbox" name="plantadaninhacana" id="field_plantadaninhacana" ng-model="vm.procPlantaDaninhaCana"><label class="control-label" for="field_plantadaninhacana"><span data-translate="netWordAgroApp.uploadnw.plantadaninha">Planta Daninha</span></label></div></div></div><div class="row col-xs-12"><div class="col-xs-6 no-padding-left"><button class="btn btn-primary" ng-click="vm.enviar()" ng-disabled="vm.propriedadeSelecionada==null || vm.fileData == null || vm.safraSelecionada == null"><span data-translate="netWordAgroApp.uploadnw.enviararquivo">Enviar arquivo</span></button></div></div></div><br><div class="container-fluid"><div class="row"><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.uploadnw.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive" has-any-authority="ROLE_ADMIN"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="data"><span data-translate="netWordAgroApp.uploadnw.data">Data</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="inicio"><span data-translate="netWordAgroApp.uploadnw.inicio">Inicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fim"><span data-translate="netWordAgroApp.uploadnw.fim">Fim</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="propriedade"><span data-translate="netWordAgroApp.uploadnw.propriedade">Propriedade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="usuario"><span data-translate="netWordAgroApp.uploadnw.usuario">Usuario</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="uploadnw in vm.uploadnws track by uploadnw.id"><td><a ui-sref="uploadnw-detail({id:uploadnw.id})">{{uploadnw.id}}</a></td><td>{{uploadnw.data}}</td><td>{{uploadnw.inicio}}</td><td>{{uploadnw.fim}}</td><td>{{uploadnw.propriedade}}</td><td>{{uploadnw.usuario}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="uploadnw-detail({id:uploadnw.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="uploadnw.edit({id:uploadnw.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="uploadnw.delete({id:uploadnw.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/unidadegestor/unidadegestor-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.unidadegestor.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.unidadegestor.delete.question" translate-values="{id: \'{{vm.unidadegestor.id}}\'}">Are you sure you want to delete this Unidadegestor?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/unidadegestor/unidadegestor-detail.html','<div><h2><span data-translate="netWordAgroApp.unidadegestor.detail.title">Unidadegestor</span> {{vm.unidadegestor.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.unidadegestor.unidade">Unidade</span></dt><dd><a ui-sref="unidade-detail({id:vm.unidadegestor.unidade.id})">{{vm.unidadegestor.unidade.nome}}</a></dd><dt><span data-translate="netWordAgroApp.unidadegestor.gestor">Gestor</span></dt><dd><a ui-sref="gestor-detail({id:vm.unidadegestor.gestor.id})">{{vm.unidadegestor.gestor.nome}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="unidadegestor-detail.edit({id:vm.unidadegestor.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/unidadegestor/unidadegestor-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUnidadegestorLabel" data-translate="netWordAgroApp.unidadegestor.home.createOrEditLabel">Create or edit a Unidadegestor</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.unidadegestor.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.unidadegestor.id" readonly="readonly"></div><div class="form-group"><label data-translate="netWordAgroApp.unidadegestor.unidade" for="field_unidade">Unidade</label><select class="form-control" id="field_unidade" name="unidade" ng-model="vm.unidadegestor.unidade" ng-options="unidade as unidade.nome for unidade in vm.unidades track by unidade.id"><option value=""></option></select></div><div class="form-group"><label data-translate="netWordAgroApp.unidadegestor.gestor" for="field_gestor">Gestor</label><select class="form-control" id="field_gestor" name="gestor" ng-model="vm.unidadegestor.gestor" ng-options="gestor as gestor.nome for gestor in vm.gestors track by gestor.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/unidadegestor/unidadegestors.html','<div><h2 data-translate="netWordAgroApp.unidadegestor.home.title">Unidadegestors</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="unidadegestor.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.unidadegestor.home.createLabel">Create new Unidadegestor</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.unidadegestor.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="unidade.nome"><span data-translate="netWordAgroApp.unidadegestor.unidade">Unidade</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="gestor.nome"><span data-translate="netWordAgroApp.unidadegestor.gestor">Gestor</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="unidadegestor in vm.unidadegestors track by unidadegestor.id"><td><a ui-sref="unidadegestor-detail({id:unidadegestor.id})">{{unidadegestor.id}}</a></td><td><a ui-sref="unidade-detail({id:unidadegestor.unidade.id})">{{unidadegestor.unidade.nome}}</a></td><td><a ui-sref="gestor-detail({id:unidadegestor.gestor.id})">{{unidadegestor.gestor.nome}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="unidadegestor-detail({id:unidadegestor.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="unidadegestor.edit({id:unidadegestor.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="unidadegestor.delete({id:unidadegestor.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/versao/versao-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.versao.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="netWordAgroApp.versao.delete.question" translate-values="{id: \'{{vm.versao.id}}\'}">Are you sure you want to delete this Versao?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/versao/versao-detail.html','<div><h2><span data-translate="netWordAgroApp.versao.detail.title">Versao</span> {{vm.versao.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="netWordAgroApp.versao.dataversao">Dataversao</span></dt><dd><span>{{vm.versao.dataversao | date:\'mediumDate\'}}</span></dd><dt><span data-translate="netWordAgroApp.versao.versaoandroid">Versaoandroid</span></dt><dd><span>{{vm.versao.versaoandroid}}</span></dd><dt><span data-translate="netWordAgroApp.versao.versaoios">Versaoios</span></dt><dd><span>{{vm.versao.versaoios}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="versao-detail.edit({id:vm.versao.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/versao/versao-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myVersaoLabel" data-translate="netWordAgroApp.versao.home.createOrEditLabel">Create or edit a Versao</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.versao.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.versao.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.versao.dataversao" for="field_dataversao">Dataversao</label><div class="input-group"><input id="field_dataversao" type="text" class="form-control" name="dataversao" uib-datepicker-popup="{{dateformat}}" ng-model="vm.versao.dataversao" is-open="vm.datePickerOpenStatus.dataversao"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataversao\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.versao.versaoandroid" for="field_versaoandroid">Versaoandroid</label><input type="text" class="form-control" name="versaoandroid" id="field_versaoandroid" ng-model="vm.versao.versaoandroid"></div><div class="form-group"><label class="control-label" data-translate="netWordAgroApp.versao.versaoios" for="field_versaoios">Versaoios</label><input type="text" class="form-control" name="versaoios" id="field_versaoios" ng-model="vm.versao.versaoios"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/versao/versaos.html','<div><h2 data-translate="netWordAgroApp.versao.home.title">Versaos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="versao.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="netWordAgroApp.versao.home.createLabel">Create new Versao</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'netWordAgroApp.versao.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dataversao"><span data-translate="netWordAgroApp.versao.dataversao">Dataversao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="versaoandroid"><span data-translate="netWordAgroApp.versao.versaoandroid">Versaoandroid</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="versaoios"><span data-translate="netWordAgroApp.versao.versaoios">Versaoios</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="versao in vm.versaos track by versao.id"><td><a ui-sref="versao-detail({id:versao.id})">{{versao.id}}</a></td><td>{{versao.dataversao | date:\'mediumDate\'}}</td><td>{{versao.versaoandroid}}</td><td>{{versao.versaoios}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="versao-detail({id:versao.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="versao.edit({id:versao.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="versao.delete({id:versao.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>Email address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the email address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success === \'OK\'"><p data-translate="reset.request.messages.success">Check your emails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div>');}]);})();